import {
  PRODUCT_HERO_MEDIA_KIND,
  validateCheckoutConfigs,
  validateCmsConfig
} from "./chunk-QINU3K7Q.mjs";
import {
  setLegacyRuntimeConfig
} from "./chunk-RR2AD6GR.mjs";

// src/organisms/PromoBar.tsx
import React6 from "react";
import classNames6 from "classnames";

// src/molecules/TimerBadge.tsx
import React4, { useEffect, useState, useRef } from "react";
import classNames4 from "classnames";

// src/atoms/Icon.tsx
import React from "react";
import classNames from "classnames";
var Icon = ({ src, alt = "", className = "", classes = {} }) => {
  const iconClass = classNames(className, classes.icon);
  return /* @__PURE__ */ React.createElement("img", { src, alt, className: iconClass });
};

// src/atoms/Badge.tsx
import React2 from "react";
import classNames2 from "classnames";
var Badge = ({ children, className = "", classes = {} }) => {
  const badgeClass = classNames2(
    "rounded-sm px-2 py-1 flex gap-2 items-center",
    className,
    classes.base
  );
  return /* @__PURE__ */ React2.createElement("span", { className: badgeClass }, children);
};

// src/atoms/Text.tsx
import React3 from "react";
import classNames3 from "classnames";
var textVariants = {
  heroTitle: "font-black lg:text-[40px] block lg:leading-12 text-[32px] leading-10",
  heroSubtitle: "text-lg block leading-6.5",
  base: ""
};
var Text = ({
  children,
  className = "",
  variant = "base",
  as: Component = "span"
}) => {
  const variantClass = textVariants[variant] || "";
  return /* @__PURE__ */ React3.createElement(Component, { className: classNames3(variantClass, className) }, children);
};

// src/helpers/helpers.ts
function readCookie(name) {
  const match = document.cookie.split("; ").find((row) => row.startsWith(name + "="));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match.split("=")[1]));
  } catch (e) {
    return null;
  }
}
function writeCookie(name, value, expiresSec = 86400) {
  const expires = new Date(Date.now() + expiresSec * 1e3).toUTCString();
  document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + "; expires=" + expires + "; path=/";
}

// src/molecules/TimerBadge.tsx
function formatTime(seconds) {
  const h = Math.floor(seconds / 3600).toString().padStart(2, "0");
  const m = Math.floor(seconds % 3600 / 60).toString().padStart(2, "0");
  const s = Math.floor(seconds % 60).toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
}
var COOKIE_KEY = "time_left";
var COOLDOWN_MS = 24 * 60 * 60 * 1e3;
var DEFAULT_CONTAINER_CLASS = "bg-(--promo-bar-badge-bg-color) text-(--promo-bar-text-color)";
var DEFAULT_ICON_CLASS = "size-4 w-full h-auto";
var DEFAULT_TEXT_CLASS = "font-bold text-xl";
var TimerBadge = ({
  time,
  iconSrc,
  className,
  iconClassName,
  textClassName,
  classes = {}
}) => {
  const [remaining, setRemaining] = useState(() => {
    const cookie = readCookie(COOKIE_KEY);
    const now = Date.now();
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      const timeRemaining = Math.max(0, Math.floor((cookie.endAt - now) / 1e3));
      return timeRemaining;
    }
    return time * 60;
  });
  const intervalRef = useRef(void 0);
  useEffect(() => {
    const now = Date.now();
    let cookie = readCookie(COOKIE_KEY);
    let endAt, cooldownExpires;
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      endAt = cookie.endAt;
      cooldownExpires = cookie.cooldownExpires;
    } else {
      endAt = now + time * 60 * 1e3;
      cooldownExpires = now + COOLDOWN_MS;
      writeCookie(COOKIE_KEY, { endAt, cooldownExpires }, COOLDOWN_MS / 1e3);
      setRemaining(time * 60);
    }
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = window.setInterval(() => {
      setRemaining((prev) => {
        const next = Math.max(prev - 1, 0);
        return next;
      });
    }, 1e3);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [time]);
  useEffect(() => {
    const now = Date.now();
    const cookie = readCookie(COOKIE_KEY);
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      const timeRemaining = Math.max(0, Math.floor((cookie.endAt - now) / 1e3));
      if (timeRemaining <= 0) {
        setRemaining(0);
      }
    }
  }, []);
  if (remaining <= 0) return null;
  return /* @__PURE__ */ React4.createElement(Badge, { className: classNames4(DEFAULT_CONTAINER_CLASS, className, classes.container) }, iconSrc && /* @__PURE__ */ React4.createElement(
    Icon,
    {
      src: iconSrc,
      className: classNames4(DEFAULT_ICON_CLASS, iconClassName, classes.icon)
    }
  ), /* @__PURE__ */ React4.createElement(Text, { className: classNames4(DEFAULT_TEXT_CLASS, textClassName, classes.text) }, formatTime(remaining)));
};

// src/molecules/Container.tsx
import React5 from "react";
import classNames5 from "classnames";
var DEFAULT_BASE_CLASS = "";
var Container = ({
  children,
  style,
  id,
  className,
  baseClassName,
  classes = {}
}) => {
  const baseClass = classNames5(
    DEFAULT_BASE_CLASS,
    className,
    baseClassName,
    classes.container,
    classes.base
  );
  return /* @__PURE__ */ React5.createElement("div", { id, style, className: baseClass }, children);
};

// src/organisms/PromoBar.tsx
var DEFAULT_BASE_CLASS2 = "w-full p-3 flex items-center justify-center gap-4 [background:var(--promo-bar-bg-color)]";
var DEFAULT_OFFER_TEXT_CLASS = "text-(--promo-bar-text-color) font-bold text-sm md:text-xl";
var PromoBar = ({
  time,
  offer,
  timerIconSrc,
  className,
  timerBadgeClassName,
  offerTextClassName,
  baseClassName,
  classes = {},
  children
}) => {
  let content;
  if (children) {
    content = children;
  } else {
    content = /* @__PURE__ */ React6.createElement(React6.Fragment, null, time && /* @__PURE__ */ React6.createElement(
      TimerBadge,
      {
        time: time || 15,
        iconSrc: timerIconSrc,
        className: classNames6(timerBadgeClassName, classes.timerBadge)
      }
    ), /* @__PURE__ */ React6.createElement(
      Text,
      {
        className: classNames6(DEFAULT_OFFER_TEXT_CLASS, offerTextClassName, classes.offerText)
      },
      offer
    ));
  }
  return /* @__PURE__ */ React6.createElement(
    Container,
    {
      className: classNames6(
        DEFAULT_BASE_CLASS2,
        className,
        baseClassName,
        classes.container,
        classes.base
      )
    },
    content
  );
};

// src/organisms/Header.tsx
import React60 from "react";

// src/atoms/FlagIcon.tsx
import React7 from "react";

// src/helpers/cn.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/atoms/FlagIcon.tsx
var DEFAULT_FLAG_ICON_CLASS = "h-4 w-4 shrink-0";
var FlagIcon = ({ className, classes = {} }) => /* @__PURE__ */ React7.createElement(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 24 25",
    fill: "none",
    className: cn(DEFAULT_FLAG_ICON_CLASS, classes.root, className),
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React7.createElement("g", { clipPath: "url(#flag-icon-clip)" }, /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M12 24.084C18.6274 24.084 24 18.7114 24 12.084C24 5.45657 18.6274 0.0839844 12 0.0839844C5.37258 0.0839844 0 5.45657 0 12.084C0 18.7114 5.37258 24.084 12 24.084Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M11.4795 12.0838H24.0012C24.0012 11.0007 23.8568 9.95148 23.5878 8.95337H11.4795V12.0838Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M11.4795 5.82308H22.2399C21.5054 4.62439 20.5661 3.56488 19.471 2.69263H11.4795V5.82308Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M12.0001 24.0843C14.8243 24.0843 17.4201 23.1081 19.4699 21.4756H4.53027C6.58012 23.1081 9.17591 24.0843 12.0001 24.0843Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M1.76098 18.3448H22.2384C22.8281 17.3825 23.2855 16.3306 23.5863 15.2144H0.413086C0.713883 16.3306 1.17124 17.3825 1.76098 18.3448V18.3448Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M5.55862 1.95795H6.65217L5.63498 2.69694L6.02353 3.89267L5.00639 3.15369L3.98925 3.89267L4.32487 2.85969C3.42928 3.6057 2.64431 4.47973 1.99744 5.45361H2.34783L1.70034 5.924C1.59947 6.09228 1.50272 6.26323 1.41 6.43672L1.71919 7.38833L1.14234 6.96922C0.998953 7.27302 0.867797 7.58366 0.749906 7.90077L1.09055 8.94927H2.34783L1.33064 9.68825L1.71919 10.884L0.702047 10.145L0.0927656 10.5877C0.0317812 11.0779 0 11.5772 0 12.084H12C12 5.45661 12 4.6753 12 0.0839844C9.62944 0.0839844 7.41961 0.771641 5.55862 1.95795V1.95795ZM6.02353 10.884L5.00639 10.145L3.98925 10.884L4.3778 9.68825L3.36061 8.94927H4.61789L5.00639 7.75353L5.39489 8.94927H6.65217L5.63498 9.68825L6.02353 10.884ZM5.63498 6.19259L6.02353 7.38833L5.00639 6.64934L3.98925 7.38833L4.3778 6.19259L3.36061 5.45361H4.61789L5.00639 4.25787L5.39489 5.45361H6.65217L5.63498 6.19259ZM10.3279 10.884L9.31073 10.145L8.29359 10.884L8.68214 9.68825L7.66495 8.94927H8.92223L9.31073 7.75353L9.69923 8.94927H10.9565L9.93933 9.68825L10.3279 10.884ZM9.93933 6.19259L10.3279 7.38833L9.31073 6.64934L8.29359 7.38833L8.68214 6.19259L7.66495 5.45361H8.92223L9.31073 4.25787L9.69923 5.45361H10.9565L9.93933 6.19259ZM9.93933 2.69694L10.3279 3.89267L9.31073 3.15369L8.29359 3.89267L8.68214 2.69694L7.66495 1.95795H8.92223L9.31073 0.762219L9.69923 1.95795H10.9565L9.93933 2.69694Z",
      fill: "#0052B4"
    }
  )),
  /* @__PURE__ */ React7.createElement("defs", null, /* @__PURE__ */ React7.createElement("clipPath", { id: "flag-icon-clip" }, /* @__PURE__ */ React7.createElement("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.0839844)" })))
);

// src/atoms/Image.tsx
import React8 from "react";
import classNames7 from "classnames";
var Image = ({
  src,
  alt = "",
  loading = "eager",
  srcSet,
  sizes,
  sources = [],
  decoding,
  fetchPriority,
  width,
  height,
  className = "",
  classes = {},
  onError
}) => {
  const imageClass = classNames7(className, classes.image);
  const image = /* @__PURE__ */ React8.createElement(
    "img",
    {
      loading,
      src,
      srcSet,
      sizes,
      alt,
      decoding,
      fetchPriority,
      width,
      height,
      className: imageClass,
      onError
    }
  );
  if (!sources.length) {
    return image;
  }
  return /* @__PURE__ */ React8.createElement("picture", { className: classes.picture }, sources.map((source, index) => {
    var _a, _b;
    return /* @__PURE__ */ React8.createElement(
      "source",
      {
        key: `${(_a = source.media) != null ? _a : "default"}-${(_b = source.type) != null ? _b : "image"}-${index}`,
        media: source.media,
        srcSet: source.srcSet,
        sizes: source.sizes,
        type: source.type
      }
    );
  }), image);
};

// src/atoms/icons/IconArrowCircleRight.tsx
import React9 from "react";
var IconArrowCircleRight = ({ className }) => /* @__PURE__ */ React9.createElement(
  "svg",
  {
    className: cn("size-6 shrink-0", className),
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React9.createElement("path", { d: "M11.9998 0C5.38305 0 0 5.38316 0 12.0001C0 18.6168 5.38305 24 11.9998 24C18.6165 24 23.9996 18.6168 23.9996 12.0001C23.9996 5.38316 18.6165 0 11.9998 0ZM11.9998 22.3573C6.28884 22.3573 1.64271 17.711 1.64271 12.0001C1.64271 6.28906 6.28884 1.64271 11.9998 1.64271C17.7107 1.64271 22.3568 6.28906 22.3568 12.0001C22.3568 17.7112 17.7107 22.3573 11.9998 22.3573Z" }),
  /* @__PURE__ */ React9.createElement("path", { d: "M13.6113 6.86049C13.2905 6.53983 12.7704 6.53983 12.4498 6.86049C12.129 7.18136 12.129 7.70134 12.4498 8.0221L15.6061 11.1783L6.46637 11.1792C6.01266 11.1792 5.64502 11.5469 5.64502 12.0006C5.64502 12.4542 6.01277 12.8219 6.46637 12.8219L15.6064 12.821L12.4495 15.9778C12.1287 16.2985 12.1287 16.8186 12.4495 17.1393C12.6098 17.2997 12.8201 17.3799 13.0302 17.3799C13.2404 17.3799 13.4506 17.2997 13.611 17.1394L18.1699 12.5806C18.324 12.4265 18.4105 12.2177 18.4105 11.9998C18.4105 11.7819 18.324 11.573 18.1699 11.4189L13.6113 6.86049Z" })
);

// src/atoms/icons/IconArrowUp.tsx
import React10 from "react";
var IconArrowUp = ({ className }) => /* @__PURE__ */ React10.createElement(
  "svg",
  {
    className: cn("size-4", className),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React10.createElement(
    "path",
    {
      d: "M8 12.5V3.5M8 3.5L4 7.5M8 3.5L12 7.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/atoms/icons/IconCircleCheckmark.tsx
import React11 from "react";
var IconCircleCheckmark = ({
  className,
  classes = {}
}) => /* @__PURE__ */ React11.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React11.createElement(
    "path",
    {
      className: classes.circle,
      d: "M10 20C11.3132 20 12.6136 19.7413 13.8268 19.2388C15.0401 18.7362 16.1425 17.9997 17.0711 17.0711C17.9997 16.1425 18.7362 15.0401 19.2388 13.8268C19.7413 12.6136 20 11.3132 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React11.createElement(
    "path",
    {
      className: classes.check,
      d: "M9.74222 14.0444L15.2978 7.37778L13.5911 5.95556L8.81333 11.6878L6.34111 9.21445L4.77 10.7856L8.10333 14.1189L8.96333 14.9789L9.74222 14.0444Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconMinus.tsx
import React12 from "react";
var IconMinus = ({ className }) => /* @__PURE__ */ React12.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "2",
    viewBox: "0 0 14 2",
    fill: "none",
    "aria-hidden": "true",
    className: cn(className)
  },
  /* @__PURE__ */ React12.createElement("path", { d: "M14 2H0V0H14V2Z", fill: "currentColor" })
);

// src/atoms/icons/IconPlus.tsx
import React13 from "react";
var IconPlus = ({ className }) => /* @__PURE__ */ React13.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-hidden": "true",
    className: cn(className)
  },
  /* @__PURE__ */ React13.createElement("path", { d: "M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z", fill: "currentColor" })
);

// src/atoms/icons/IconCheckmark.tsx
import React14 from "react";
var IconCheckmark = ({ className, color }) => /* @__PURE__ */ React14.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: color ? { color } : void 0
  },
  /* @__PURE__ */ React14.createElement(
    "path",
    {
      d: "M3 10.5L8 15.5L17.5 5",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/atoms/icons/IconCheckCircle.tsx
import React15 from "react";
var IconCheckCircle = ({ className }) => /* @__PURE__ */ React15.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    width: "20",
    height: "22",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React15.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 22C11.3132 22 12.6136 21.7413 13.8268 21.2388C15.0401 20.7362 16.1425 19.9997 17.0711 19.0711C17.9997 18.1425 18.7362 17.0401 19.2388 15.8268C19.7413 14.6136 20 13.3132 20 12C20 10.6868 19.7413 9.38642 19.2388 8.17317C18.7362 6.95991 17.9997 5.85752 17.0711 4.92893C16.1425 4.00035 15.0401 3.26375 13.8268 2.7612C12.6136 2.25866 11.3132 2 10 2C7.34784 2 4.8043 3.05357 2.92893 4.92893C1.05357 6.8043 0 9.34784 0 12C0 14.6522 1.05357 17.1957 2.92893 19.0711C4.8043 20.9464 7.34784 22 10 22ZM9.74222 16.0444L15.2978 9.37778L13.5911 7.95556L8.81333 13.6878L6.34111 11.2144L4.77 12.7856L8.10333 16.1189L8.96333 16.9789L9.74222 16.0444Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconInfo.tsx
import React16 from "react";
var IconInfo = ({ className }) => /* @__PURE__ */ React16.createElement(
  "svg",
  {
    className: cn("size-4 shrink-0", className),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React16.createElement(
    "path",
    {
      d: "M7.19996 12.0001H8.79995V7.20008H7.19996V12.0001ZM7.99996 5.60009C8.22662 5.60009 8.41676 5.52329 8.57036 5.36969C8.72395 5.21609 8.80049 5.02623 8.79995 4.8001C8.79995 4.57343 8.72315 4.38357 8.56955 4.2305C8.41596 4.07743 8.22609 4.00063 7.99996 4.0001C7.77329 4.0001 7.58343 4.0769 7.43036 4.2305C7.2773 4.3841 7.2005 4.57396 7.19996 4.8001C7.19996 5.02676 7.27676 5.21689 7.43036 5.37049C7.58396 5.52409 7.77383 5.60063 7.99996 5.60009ZM7.99996 16C6.8933 16 5.8533 15.7899 4.87997 15.3696C3.90665 14.9494 3.05998 14.3795 2.33999 13.6601C1.61999 12.9401 1.05013 12.0934 0.630397 11.1201C0.210666 10.1467 0.00053333 9.10674 0 8.00008C0 6.89342 0.210132 5.85343 0.630397 4.8801C1.05066 3.90677 1.62052 3.06011 2.33999 2.34011C3.05998 1.62011 3.90665 1.05025 4.87997 0.630519C5.8533 0.210788 6.8933 0.000655401 7.99996 0.00012207C9.10662 0.00012207 10.1466 0.210254 11.1199 0.630519C12.0933 1.05078 12.9399 1.62065 13.6599 2.34011C14.3799 3.06011 14.9501 3.90677 15.3703 4.8801C15.7906 5.85343 16.0004 6.89342 15.9999 8.00008C15.9999 9.10674 15.7898 10.1467 15.3695 11.1201C14.9493 12.0934 14.3794 12.9401 13.6599 13.6601C12.9399 14.38 12.0933 14.9502 11.1199 15.3704C10.1466 15.7907 9.10662 16.0006 7.99996 16ZM7.99996 14.4C9.78662 14.4 11.2999 13.78 12.5399 12.5401C13.7799 11.3001 14.3999 9.78674 14.3999 8.00008C14.3999 6.21342 13.7799 4.7001 12.5399 3.4601C11.2999 2.22011 9.78662 1.60011 7.99996 1.60011C6.2133 1.60011 4.69998 2.22011 3.45998 3.4601C2.21999 4.7001 1.59999 6.21342 1.59999 8.00008C1.59999 9.78674 2.21999 11.3001 3.45998 12.5401C4.69998 13.78 6.2133 14.4 7.99996 14.4Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconXMark.tsx
import React17 from "react";
var IconXMark = ({ className }) => /* @__PURE__ */ React17.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React17.createElement(
    "path",
    {
      d: "M4.5 4.5L15.5 15.5M15.5 4.5L4.5 15.5",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round"
    }
  )
);

// src/atoms/icons/IconCircleXmark.tsx
import React18 from "react";
var IconCircleXmark = ({ className, classes = {} }) => /* @__PURE__ */ React18.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React18.createElement(
    "path",
    {
      className: classes.circle,
      d: "M10 20C11.3132 20 12.6136 19.7413 13.8268 19.2388C15.0401 18.7362 16.1425 17.9997 17.0711 17.0711C17.9997 16.1425 18.7362 15.0401 19.2388 13.8268C19.7413 12.6136 20 11.3132 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React18.createElement(
    "path",
    {
      className: classes.x,
      d: "M6.4 6.4L13.6 13.6M13.6 6.4L6.4 13.6",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round"
    }
  )
);

// src/atoms/icons/IconThumbsUp.tsx
import React19 from "react";
var IconThumbsUp = ({ className }) => /* @__PURE__ */ React19.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React19.createElement(
    "path",
    {
      d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconBurgerMenu.tsx
import React20 from "react";
var IconBurgerMenu = ({ className }) => /* @__PURE__ */ React20.createElement(
  "svg",
  {
    "aria-hidden": "true",
    className: cn("size-6 text-current", className),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React20.createElement(
    "path",
    {
      d: "M4 7H20M4 12H20M4 17H20",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }
  )
);

// src/atoms/icons/IconChevron.tsx
import React21 from "react";
var IconChevron = ({ isOpen = false, className }) => /* @__PURE__ */ React21.createElement(
  "svg",
  {
    className: cn("size-4 transition-transform duration-200", isOpen && "rotate-180", className),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React21.createElement(
    "path",
    {
      d: "M4 6L8 10L12 6",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/atoms/icons/IconChevronRight.tsx
import React22 from "react";
var IconChevronRight = ({ className }) => /* @__PURE__ */ React22.createElement(
  "svg",
  {
    className: cn("h-[16.67px] w-[8.33px] shrink-0", className),
    viewBox: "0 0 8.33 16.67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React22.createElement(
    "path",
    {
      d: "M1.36 1.36L6.97 8.34L1.36 15.31",
      stroke: "currentColor",
      strokeWidth: "2.71",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/atoms/icons/IconAmexCard.tsx
import React23 from "react";
var IconAmexCard = () => /* @__PURE__ */ React23.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "41", height: "28", viewBox: "0 0 41 28", fill: "none" }, /* @__PURE__ */ React23.createElement("rect", { width: "40.6", height: "28", rx: "2.80105", fill: "#F5F5F5" }), /* @__PURE__ */ React23.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74966 9.91602L4.05957 18.3706H8.47712L9.02477 17.0225H10.2766L10.8242 18.3706H15.6867V17.3417L16.12 18.3706H18.6352L19.0685 17.32V18.3706H29.1812L30.4108 17.0576L31.5622 18.3706L36.7563 18.3814L33.0545 14.1669L36.7563 9.91602H31.6428L30.4458 11.2047L29.3306 9.91602H18.3294L17.3847 12.0982L16.4179 9.91602H12.0096V10.9098L11.5192 9.91602H7.74966ZM22.8508 11.1166H28.658L30.4341 13.1029L32.2675 11.1166H34.0437L31.345 14.1657L34.0437 17.1797H32.187L30.4108 15.1703L28.5681 17.1797H22.8508V11.1166ZM24.2849 13.4801V12.3727V12.3716H27.9084L29.4895 14.1427L27.8383 15.9236H24.2849V14.7145H27.4529V13.4801H24.2849ZM8.60443 11.1166H10.7578L13.2054 16.8496V11.1166H15.5643L17.4548 15.2272L19.1971 11.1166H21.5442V17.1833H20.116L20.1044 12.4294L18.0223 17.1833H16.7447L14.651 12.4294V17.1833H11.7129L11.1559 15.8232H8.14669L7.59085 17.1821H6.01668L8.60443 11.1166ZM8.66052 14.5659L9.65195 12.143L10.6422 14.5659H8.66052Z",
    fill: "#1F72CD"
  }
));

// src/atoms/icons/IconApplePayCard.tsx
import React24 from "react";

// src/atoms/icons/IconChat.tsx
import React25 from "react";
var IconChat = ({ alt = "" }) => /* @__PURE__ */ React25.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    className: "size-[20px] object-contain",
    role: alt ? "img" : "presentation",
    "aria-hidden": alt ? void 0 : true,
    "aria-label": alt || void 0
  },
  /* @__PURE__ */ React25.createElement(
    "path",
    {
      d: "M16.8746 6.25H16.2496V9.375C16.2496 10.2038 15.9204 10.9987 15.3343 11.5847C14.7483 12.1708 13.9534 12.5 13.1246 12.5H7.02461L5.08086 14.45C5.05908 14.4744 5.03381 14.4955 5.00586 14.5125C5.04057 14.9845 5.25248 15.4259 5.59908 15.7482C5.94569 16.0704 6.40134 16.2497 6.87461 16.25H13.4934L15.8059 18.5687C15.8643 18.6267 15.9335 18.6725 16.0097 18.7036C16.0858 18.7347 16.1674 18.7505 16.2496 18.75C16.3316 18.7521 16.4129 18.735 16.4871 18.7C16.6012 18.6531 16.699 18.5735 16.7679 18.4712C16.8369 18.3688 16.874 18.2484 16.8746 18.125V16.25C17.3719 16.25 17.8488 16.0525 18.2004 15.7008C18.5521 15.3492 18.7496 14.8723 18.7496 14.375V8.125C18.7496 7.62772 18.5521 7.15081 18.2004 6.79917C17.8488 6.44754 17.3719 6.25 16.8746 6.25Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React25.createElement(
    "path",
    {
      d: "M13.125 11.25C13.6223 11.25 14.0992 11.0525 14.4508 10.7008C14.8025 10.3492 15 9.87228 15 9.375V3.125C15 2.62772 14.8025 2.15081 14.4508 1.79917C14.0992 1.44754 13.6223 1.25 13.125 1.25H3.125C2.62772 1.25 2.15081 1.44754 1.79917 1.79917C1.44754 2.15081 1.25 2.62772 1.25 3.125V9.375C1.25 9.87228 1.44754 10.3492 1.79917 10.7008C2.15081 11.0525 2.62772 11.25 3.125 11.25V13.125C3.12562 13.2484 3.16274 13.3688 3.2317 13.4712C3.30066 13.5735 3.39836 13.6531 3.5125 13.7C3.58667 13.735 3.66801 13.7521 3.75 13.75C3.83225 13.7505 3.91379 13.7347 3.98994 13.7036C4.06609 13.6725 4.13535 13.6267 4.19375 13.5687L6.50625 11.25H13.125ZM11.25 5.625C11.3736 5.625 11.4945 5.66166 11.5972 5.73033C11.7 5.79901 11.7801 5.89662 11.8274 6.01082C11.8747 6.12503 11.8871 6.25069 11.863 6.37193C11.8389 6.49317 11.7794 6.60453 11.6919 6.69194C11.6045 6.77935 11.4932 6.83888 11.3719 6.86299C11.2507 6.88711 11.125 6.87473 11.0108 6.82743C10.8966 6.78012 10.799 6.70001 10.7303 6.59723C10.6617 6.49445 10.625 6.37361 10.625 6.25C10.625 6.08424 10.6908 5.92527 10.8081 5.80806C10.9253 5.69085 11.0842 5.625 11.25 5.625ZM8.125 5.625C8.24861 5.625 8.36945 5.66166 8.47223 5.73033C8.57501 5.79901 8.65512 5.89662 8.70243 6.01082C8.74973 6.12503 8.76211 6.25069 8.73799 6.37193C8.71388 6.49317 8.65435 6.60453 8.56694 6.69194C8.47953 6.77935 8.36817 6.83888 8.24693 6.86299C8.12569 6.88711 8.00003 6.87473 7.88582 6.82743C7.77162 6.78012 7.67401 6.70001 7.60533 6.59723C7.53666 6.49445 7.5 6.37361 7.5 6.25C7.5 6.08424 7.56585 5.92527 7.68306 5.80806C7.80027 5.69085 7.95924 5.625 8.125 5.625ZM5 6.875C4.87639 6.875 4.75555 6.83834 4.65277 6.76967C4.54999 6.70099 4.46988 6.60338 4.42258 6.48918C4.37527 6.37497 4.36289 6.24931 4.38701 6.12807C4.41112 6.00683 4.47065 5.89547 4.55806 5.80806C4.64547 5.72065 4.75683 5.66112 4.87807 5.63701C4.99931 5.61289 5.12497 5.62527 5.23918 5.67257C5.35338 5.71988 5.45099 5.79999 5.51967 5.90277C5.58834 6.00555 5.625 6.12639 5.625 6.25C5.625 6.41576 5.55915 6.57473 5.44194 6.69194C5.32473 6.80915 5.16576 6.875 5 6.875Z",
      fill: "white"
    }
  )
);

// src/atoms/icons/IconDinersCard.tsx
import React26 from "react";
var IconDinersCard = () => /* @__PURE__ */ React26.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "28",
    viewBox: "0 0 42 28",
    fill: "none",
    className: "h-[28px] w-[42px]",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React26.createElement("g", { clipPath: "url(#icon-diners-card)" }, /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      fill: "#F5F5F5"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      stroke: "#AFAFAF"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M34.2268 14.0913C34.2268 7.8275 28.9987 3.49811 23.2701 3.5H18.3404C12.5437 3.49792 7.77246 7.82882 7.77246 14.0913C7.77246 19.8205 12.5438 24.5276 18.3404 24.4999H23.2701C28.9982 24.5274 34.2268 19.819 34.2268 14.0913Z",
      fill: "#0079BE"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M18.372 4.38672C13.0752 4.38836 8.78314 8.69053 8.78125 14.0002C8.78257 19.3089 13.0748 23.6105 18.372 23.6123C23.6701 23.6108 27.9634 19.309 27.964 14.0002C27.9633 8.6904 23.6702 4.38861 18.372 4.38672Z",
      fill: "white"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M12.3096 13.9753C12.3146 11.3808 13.9318 9.16825 16.2122 8.28906V19.6604C13.9318 18.7817 12.3145 16.5703 12.3096 13.9754V13.9753ZM20.5633 19.6632V8.28938C22.8447 9.16648 24.4644 11.3803 24.4685 13.976C24.4643 16.5726 22.8447 18.7848 20.5633 19.6635V19.6632Z",
      fill: "#0079BE"
    }
  )),
  /* @__PURE__ */ React26.createElement("defs", null, /* @__PURE__ */ React26.createElement("clipPath", { id: "icon-diners-card" }, /* @__PURE__ */ React26.createElement("rect", { width: "42", height: "28", fill: "white" })))
);

// src/atoms/icons/IconDiscoverCard.tsx
import React27 from "react";
var IconDiscoverCard = () => /* @__PURE__ */ React27.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "28",
    viewBox: "0 0 42 28",
    fill: "none",
    className: "h-[28px] w-[42px]",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React27.createElement("g", { clipPath: "url(#icon-discover-card)" }, /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      fill: "#F5F5F5"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      stroke: "#AFAFAF"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M25.0092 13.9842C25.0124 13.2319 24.7304 12.4786 24.1627 11.9109C23.5939 11.342 22.8386 11.0602 22.0848 11.0647C22.0812 11.0647 22.0777 11.0645 22.074 11.0645C20.4371 11.0645 19.1387 12.3625 19.1387 13.9999C19.1387 15.6211 20.4531 16.9352 22.074 16.9352C23.7114 16.9352 25.0096 15.6368 25.0096 13.9999C25.0096 13.9945 25.0092 13.9895 25.0092 13.9842Z",
      fill: "#F26E21"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M18.5926 15.2415C18.1539 15.6807 17.749 15.8523 17.3128 15.8616C16.2503 15.8521 15.469 15.0652 15.469 13.9433C15.469 13.3785 15.6829 12.9157 16.0216 12.5203C16.3392 12.2187 16.7485 12.0239 17.2191 12.0239C17.727 12.0239 18.1224 12.1932 18.5737 12.6448V11.3465C18.1225 11.1208 17.727 11.0078 17.2191 11.0078C16.5015 11.0591 15.8249 11.349 15.3059 11.8043C15.1563 11.9389 15.013 12.0875 14.8914 12.2575C14.5123 12.7489 14.2832 13.3505 14.2832 14C14.2832 15.6368 15.582 16.8787 17.219 16.8787C17.2269 16.8787 17.2348 16.878 17.2426 16.8779C17.2536 16.878 17.2644 16.8787 17.2753 16.8787C17.7269 16.8787 18.1224 16.766 18.6304 16.5402L18.5926 15.2415C18.5736 15.2606 18.6115 15.2783 18.5926 15.2963V15.2415Z",
      fill: "#2B2B2B"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M28.7147 11.8173L27.4363 14.9604L25.9685 11.2344H24.7832L27.0976 16.936H27.7185L30.1459 11.2344H28.9606L28.7147 11.8173Z",
      fill: "#2B2B2B"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M30.5977 13.7183V16.7669H33.6462H33.7024V15.8633H32.7428H31.7267V14.8475V14.3396H33.6462V13.3796H31.7267V12.1942H33.7024V11.2344H30.5977V13.7183Z",
      fill: "#2B2B2B"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M5.08191 11.2344H3.50098V16.7669H5.08183C5.92846 16.7669 6.54933 16.5409 7.05739 16.1457C7.67825 15.6377 8.07358 14.8475 8.07358 14.0009C8.07366 12.3634 6.88798 11.2344 5.08191 11.2344ZM6.38016 15.412C6.04143 15.6942 5.58981 15.8633 4.91235 15.8633H4.57361V12.1941H4.85583C5.53329 12.1941 5.98491 12.307 6.32372 12.6456C6.71881 12.9841 6.94474 13.4925 6.94474 14.0007C7.00118 14.5087 6.77541 15.073 6.38016 15.412Z",
      fill: "#2B2B2B"
    }
  ), /* @__PURE__ */ React27.createElement("path", { d: "M9.65459 11.2344H8.58203V16.7667H9.65459V11.2344Z", fill: "#2B2B2B" }), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M12.3637 13.3771C11.6864 13.1513 11.5168 12.9819 11.5168 12.6997C11.5168 12.361 11.8556 12.0788 12.3072 12.0788C12.6459 12.0788 12.9281 12.1917 13.2104 12.5305L13.7751 11.7966C13.3233 11.4013 12.759 11.1758 12.138 11.1758C11.1781 11.1758 10.3878 11.8532 10.3878 12.7562C10.3878 13.5467 10.7268 13.8853 11.7428 14.2805C12.1944 14.4496 12.3638 14.5063 12.4769 14.6192C12.7023 14.7319 12.8154 14.9579 12.8154 15.1834C12.8154 15.6351 12.4769 15.9739 11.9685 15.9739C11.46 15.9739 11.0088 15.6917 10.7829 15.24L10.1055 15.9175C10.6138 16.6513 11.2347 16.99 12.0251 16.99C13.154 16.99 13.9439 16.2561 13.9439 15.1834C13.9441 14.224 13.6057 13.8288 12.3637 13.3771Z",
      fill: "#2B2B2B"
    }
  ), /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "M36.7512 14.4521C37.5977 14.283 38.0495 13.7182 38.0495 12.8717C38.0495 11.8557 37.3155 11.2344 36.0737 11.2344H34.4365V16.7669H35.5091V14.565H35.6786L37.2024 16.7669H38.501L36.7512 14.4521ZM35.8477 13.7746H35.5092V12.0812H35.8477C36.5251 12.0812 36.9205 12.3634 36.9205 12.9283C36.9205 13.4925 36.5252 13.7746 35.8477 13.7746Z",
      fill: "#2B2B2B"
    }
  )),
  /* @__PURE__ */ React27.createElement("defs", null, /* @__PURE__ */ React27.createElement("clipPath", { id: "icon-discover-card" }, /* @__PURE__ */ React27.createElement("rect", { width: "42", height: "28", fill: "white" })))
);

// src/atoms/icons/IconEmail.tsx
import React28 from "react";
var IconEmail = ({ alt = "" }) => /* @__PURE__ */ React28.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    className: "size-[20px] object-contain",
    role: alt ? "img" : "presentation",
    "aria-hidden": alt ? void 0 : true,
    "aria-label": alt || void 0
  },
  /* @__PURE__ */ React28.createElement(
    "path",
    {
      d: "M17.6828 3.9375C17.4314 3.81572 17.1559 3.75166 16.8766 3.75H3.12656C2.8472 3.75166 2.57174 3.81572 2.32031 3.9375L10.0016 11.025L17.6828 3.9375Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React28.createElement(
    "path",
    {
      d: "M18.5625 4.81836L10.4375 12.3184C10.3219 12.4255 10.1701 12.4851 10.0125 12.4851C9.85488 12.4851 9.70307 12.4255 9.5875 12.3184L1.4625 4.81836C1.33205 5.06775 1.25942 5.34332 1.25 5.62461V14.3746C1.25 14.8719 1.44754 15.3488 1.79917 15.7004C2.15081 16.0521 2.62772 16.2496 3.125 16.2496H16.875C17.3723 16.2496 17.8492 16.0521 18.2008 15.7004C18.5525 15.3488 18.75 14.8719 18.75 14.3746V5.62461C18.7483 5.34525 18.6843 5.06979 18.5625 4.81836Z",
      fill: "white"
    }
  )
);

// src/atoms/icons/IconHighlyRated.tsx
import React29 from "react";

// src/atoms/icons/IconKlarnaCard.tsx
import React30 from "react";

// src/atoms/icons/IconMasterCard.tsx
import React31 from "react";
var IconMasterCard = () => /* @__PURE__ */ React31.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "28",
    viewBox: "0 0 42 28",
    fill: "none",
    className: "h-[28px] w-[42px]",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React31.createElement("g", { clipPath: "url(#icon-master-card)" }, /* @__PURE__ */ React31.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      fill: "#F5F5F5"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      stroke: "#AFAFAF"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      d: "M25.3826 5.71111L16.3447 5.74219L16.6186 22.2883L25.6565 22.2572L25.3826 5.71111Z",
      fill: "#FF5F00"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      d: "M16.9389 14.0477C16.883 10.6823 18.3906 7.69209 20.7519 5.75248C18.9695 4.35384 16.735 3.51279 14.3128 3.52109C8.57431 3.54074 4.00994 8.26812 4.10671 14.0916C4.20349 19.9151 8.92445 24.6107 14.6629 24.5911C17.0852 24.5828 19.2915 23.7265 21.0271 22.3158C18.6021 20.4219 16.9948 17.413 16.9389 14.0477Z",
      fill: "#EB001B"
    }
  ), /* @__PURE__ */ React31.createElement(
    "path",
    {
      d: "M37.8944 13.9072C37.9912 19.7307 33.4268 24.4581 27.6884 24.4777C25.2661 24.486 23.0316 23.645 21.2492 22.2464C23.6394 20.3066 25.1181 17.3165 25.0622 13.9511C25.0063 10.5858 23.3995 7.60623 20.974 5.68301C22.7096 4.27232 24.916 3.41606 27.3382 3.40776C33.0767 3.38811 37.7981 8.11295 37.8944 13.9072Z",
      fill: "#F79E1B"
    }
  )),
  /* @__PURE__ */ React31.createElement("defs", null, /* @__PURE__ */ React31.createElement("clipPath", { id: "icon-master-card" }, /* @__PURE__ */ React31.createElement("rect", { width: "42", height: "28", fill: "white" })))
);

// src/atoms/icons/IconPayPalCard.tsx
import React32 from "react";
var IconPayPalCard = () => /* @__PURE__ */ React32.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "28",
    viewBox: "0 0 42 28",
    fill: "none",
    className: "h-[28px] w-[42px]",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React32.createElement("g", { clipPath: "url(#icon-paypal-card)" }, /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M0 3.5C0 1.567 1.567 0 3.5 0H38.5C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5Z",
      fill: "#F5F5F5"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M9.42447 10.0777C8.98577 9.77616 8.41332 9.625 7.70709 9.625H4.97297C4.75647 9.625 4.63686 9.73328 4.61414 9.94962L3.50349 16.9215C3.49194 16.99 3.50908 17.0526 3.55473 17.1095C3.60011 17.1666 3.6572 17.1949 3.72558 17.1949H5.02426C5.25205 17.1949 5.37725 17.0869 5.40023 16.8703L5.70777 14.9907C5.719 14.8996 5.75906 14.8255 5.82743 14.7685C5.89575 14.7116 5.9812 14.6743 6.08373 14.6573C6.18626 14.6404 6.28294 14.6318 6.37424 14.6318C6.46528 14.6318 6.57345 14.6376 6.69897 14.6489C6.82417 14.6603 6.90398 14.6659 6.93819 14.6659C7.91785 14.6659 8.6868 14.3898 9.2451 13.8371C9.80315 13.2847 10.0825 12.5187 10.0825 11.5387C10.0825 10.8666 9.86295 10.3796 9.42447 10.0776V10.0777ZM8.01479 12.1712C7.95765 12.57 7.80973 12.8319 7.5705 12.9572C7.33123 13.0827 6.98948 13.1452 6.54525 13.1452L5.9813 13.1622L6.27187 11.3338C6.29454 11.2086 6.36855 11.1459 6.49396 11.1459H6.81873C7.27419 11.1459 7.60477 11.2115 7.80983 11.3423C8.01479 11.4734 8.08316 11.7498 8.01479 12.1712Z",
      fill: "#003087"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M38.2775 9.625H37.0132C36.8875 9.625 36.8135 9.68768 36.791 9.81309L35.6802 16.9218L35.6631 16.956C35.6631 17.0132 35.6859 17.0671 35.7316 17.1183C35.7768 17.1695 35.8341 17.1952 35.9024 17.1952H37.0304C37.2464 17.1952 37.3661 17.0872 37.3892 16.8706L38.4999 9.88146V9.86448C38.4998 9.70491 38.4256 9.62521 38.2775 9.62521V9.625Z",
      fill: "#009CDE"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M23.0013 12.3759C23.0013 12.3191 22.9784 12.2649 22.9331 12.2138C22.8874 12.1625 22.8361 12.1367 22.7793 12.1367H21.4635C21.3379 12.1367 21.2354 12.194 21.1558 12.3076L19.3445 14.9734L18.5926 12.4102C18.5354 12.2281 18.4102 12.1367 18.2167 12.1367H16.9349C16.8778 12.1367 16.8265 12.1624 16.7813 12.2138C16.7356 12.2649 16.7129 12.3192 16.7129 12.3759C16.7129 12.3989 16.824 12.7348 17.0461 13.3842C17.2682 14.0337 17.5074 14.7343 17.7637 15.4863C18.0201 16.238 18.1539 16.637 18.1653 16.6822C17.2311 17.9583 16.7642 18.6418 16.7642 18.7328C16.7642 18.881 16.8381 18.955 16.9863 18.955H18.3021C18.4274 18.955 18.5298 18.8981 18.6097 18.7842L22.9673 12.4955C22.9899 12.4729 23.0013 12.4332 23.0013 12.3759V12.3759Z",
      fill: "#003087"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M35.2527 12.1372H33.954C33.7943 12.1372 33.6979 12.3252 33.6637 12.7012C33.3671 12.2457 32.8263 12.0176 32.0401 12.0176C31.2199 12.0176 30.5221 12.3252 29.9469 12.9404C29.3715 13.5556 29.084 14.2792 29.084 15.1107C29.084 15.783 29.2805 16.3184 29.6734 16.717C30.0665 17.116 30.5933 17.3151 31.2542 17.3151C31.5845 17.3151 31.9206 17.2466 32.2624 17.11C32.6041 16.9733 32.8716 16.7911 33.0656 16.5632C33.0656 16.5746 33.054 16.6257 33.0315 16.7168C33.0084 16.8081 32.9972 16.8767 32.9972 16.9219C32.9972 17.1044 33.071 17.1953 33.2194 17.1953H34.3985C34.6147 17.1953 34.7402 17.0872 34.7742 16.8706L35.475 12.4106C35.4862 12.3421 35.4692 12.2796 35.4237 12.2226C35.3779 12.1658 35.3211 12.1372 35.2527 12.1372ZM33.0228 15.5037C32.7323 15.7886 32.3819 15.9309 31.9718 15.9309C31.6413 15.9309 31.3738 15.8399 31.1687 15.6575C30.9635 15.4756 30.861 15.225 30.861 14.9056C30.861 14.4844 31.0034 14.1281 31.2883 13.8376C31.5727 13.5471 31.9262 13.4019 32.3477 13.4019C32.6665 13.4019 32.9314 13.4959 33.1423 13.6838C33.3529 13.8718 33.4586 14.131 33.4586 14.4615C33.4585 14.8715 33.3132 15.2191 33.0228 15.5037Z",
      fill: "#009CDE"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M15.8408 12.1372H14.5421C14.3824 12.1372 14.2857 12.3252 14.2515 12.7012C13.9439 12.2457 13.4028 12.0176 12.6281 12.0176C11.8079 12.0176 11.11 12.3252 10.5348 12.9404C9.95941 13.5556 9.67188 14.2792 9.67188 15.1107C9.67188 15.783 9.86842 16.3184 10.2615 16.717C10.6545 17.116 11.1813 17.3151 11.8421 17.3151C12.1609 17.3151 12.4915 17.2466 12.8332 17.11C13.1749 16.9733 13.4484 16.7911 13.6534 16.5632C13.6077 16.6998 13.585 16.8195 13.585 16.9219C13.585 17.1044 13.6591 17.1953 13.8072 17.1953H14.9863C15.2025 17.1953 15.328 17.0872 15.3622 16.8706L16.0628 12.4106C16.074 12.3421 16.057 12.2796 16.0116 12.2226C15.966 12.1658 15.9091 12.1372 15.8408 12.1372ZM13.6108 15.5122C13.3202 15.7916 12.9641 15.9309 12.5428 15.9309C12.2123 15.9309 11.9474 15.8399 11.7482 15.6575C11.5487 15.4756 11.4491 15.225 11.4491 14.9056C11.4491 14.4844 11.5914 14.1281 11.8764 13.8376C12.161 13.5471 12.5141 13.4019 12.9358 13.4019C13.2546 13.4019 13.5195 13.4959 13.7305 13.6838C13.9411 13.8718 14.0466 14.131 14.0466 14.4615C14.0465 14.883 13.9013 15.2334 13.6108 15.5122Z",
      fill: "#003087"
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M28.8367 10.0777C28.398 9.77616 27.8257 9.625 27.1193 9.625H24.4023C24.1744 9.625 24.049 9.73328 24.0264 9.94962L22.9156 16.9215C22.9041 16.99 22.9212 17.0526 22.9669 17.1095C23.0121 17.1666 23.0693 17.1949 23.1377 17.1949H24.5388C24.6755 17.1949 24.7666 17.121 24.8123 16.9728L25.1199 14.9907C25.1313 14.8996 25.1711 14.8255 25.2396 14.7685C25.308 14.7116 25.3933 14.6743 25.4959 14.6573C25.5984 14.6404 25.695 14.6318 25.7864 14.6318C25.8775 14.6318 25.9856 14.6376 26.111 14.6489C26.2363 14.6603 26.3163 14.6659 26.3502 14.6659C27.3301 14.6659 28.0989 14.3898 28.6572 13.8371C29.2154 13.2847 29.4945 12.5187 29.4945 11.5387C29.4946 10.8666 29.2751 10.3796 28.8367 10.0776V10.0777ZM27.0852 12.8888C26.8345 13.0596 26.4585 13.145 25.9574 13.145L25.4105 13.1622L25.701 11.3336C25.7236 11.2085 25.7976 11.1457 25.9231 11.1457H26.2306C26.4812 11.1457 26.6805 11.1572 26.8289 11.1799C26.9767 11.2028 27.1193 11.2738 27.256 11.3934C27.3928 11.5131 27.4611 11.6869 27.4611 11.9146C27.4611 12.3933 27.3356 12.7178 27.0852 12.8888Z",
      fill: "#009CDE"
    }
  )),
  /* @__PURE__ */ React32.createElement("defs", null, /* @__PURE__ */ React32.createElement("clipPath", { id: "icon-paypal-card" }, /* @__PURE__ */ React32.createElement("rect", { width: "42", height: "28", fill: "white" })))
);

// src/atoms/icons/IconPhone.tsx
import React33 from "react";
var IconPhone = ({ alt = "" }) => /* @__PURE__ */ React33.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    className: "size-[20px] object-contain",
    role: alt ? "img" : "presentation",
    "aria-hidden": alt ? void 0 : true,
    "aria-label": alt || void 0
  },
  /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M16.875 3.125H9.375V16.875H16.875C17.3723 16.875 17.8492 16.6775 18.2008 16.3258C18.5525 15.9742 18.75 15.4973 18.75 15V5C18.75 4.50272 18.5525 4.02581 18.2008 3.67417C17.8492 3.32254 17.3723 3.125 16.875 3.125ZM11.25 14.375C11.1264 14.375 11.0055 14.3383 10.9028 14.2697C10.8 14.201 10.7199 14.1034 10.6726 13.9892C10.6253 13.875 10.6129 13.7493 10.637 13.6281C10.6611 13.5068 10.7206 13.3955 10.8081 13.3081C10.8955 13.2206 11.0068 13.1611 11.1281 13.137C11.2493 13.1129 11.375 13.1253 11.4892 13.1726C11.6034 13.2199 11.701 13.3 11.7697 13.4028C11.8383 13.5055 11.875 13.6264 11.875 13.75C11.875 13.9158 11.8092 14.0747 11.6919 14.1919C11.5747 14.3092 11.4158 14.375 11.25 14.375ZM11.25 11.875C11.1264 11.875 11.0055 11.8383 10.9028 11.7697C10.8 11.701 10.7199 11.6034 10.6726 11.4892C10.6253 11.375 10.6129 11.2493 10.637 11.1281C10.6611 11.0068 10.7206 10.8955 10.8081 10.8081C10.8955 10.7207 11.0068 10.6611 11.1281 10.637C11.2493 10.6129 11.375 10.6253 11.4892 10.6726C11.6034 10.7199 11.701 10.8 11.7697 10.9028C11.8383 11.0055 11.875 11.1264 11.875 11.25C11.875 11.4158 11.8092 11.5747 11.6919 11.6919C11.5747 11.8092 11.4158 11.875 11.25 11.875ZM11.25 9.375C11.1264 9.375 11.0055 9.33834 10.9028 9.26967C10.8 9.20099 10.7199 9.10338 10.6726 8.98918C10.6253 8.87497 10.6129 8.74931 10.637 8.62807C10.6611 8.50683 10.7206 8.39547 10.8081 8.30806C10.8955 8.22065 11.0068 8.16112 11.1281 8.13701C11.2493 8.11289 11.375 8.12527 11.4892 8.17257C11.6034 8.21988 11.701 8.29999 11.7697 8.40277C11.8383 8.50555 11.875 8.62639 11.875 8.75C11.875 8.91576 11.8092 9.07473 11.6919 9.19194C11.5747 9.30915 11.4158 9.375 11.25 9.375ZM13.75 14.375C13.6264 14.375 13.5055 14.3383 13.4028 14.2697C13.3 14.201 13.2199 14.1034 13.1726 13.9892C13.1253 13.875 13.1129 13.7493 13.137 13.6281C13.1611 13.5068 13.2206 13.3955 13.3081 13.3081C13.3955 13.2206 13.5068 13.1611 13.6281 13.137C13.7493 13.1129 13.875 13.1253 13.9892 13.1726C14.1034 13.2199 14.201 13.3 14.2697 13.4028C14.3383 13.5055 14.375 13.6264 14.375 13.75C14.375 13.9158 14.3092 14.0747 14.1919 14.1919C14.0747 14.3092 13.9158 14.375 13.75 14.375ZM13.75 11.875C13.6264 11.875 13.5055 11.8383 13.4028 11.7697C13.3 11.701 13.2199 11.6034 13.1726 11.4892C13.1253 11.375 13.1129 11.2493 13.137 11.1281C13.1611 11.0068 13.2206 10.8955 13.3081 10.8081C13.3955 10.7207 13.5068 10.6611 13.6281 10.637C13.7493 10.6129 13.875 10.6253 13.9892 10.6726C14.1034 10.7199 14.201 10.8 14.2697 10.9028C14.3383 11.0055 14.375 11.1264 14.375 11.25C14.375 11.4158 14.3092 11.5747 14.1919 11.6919C14.0747 11.8092 13.9158 11.875 13.75 11.875ZM13.75 9.375C13.6264 9.375 13.5055 9.33834 13.4028 9.26967C13.3 9.20099 13.2199 9.10338 13.1726 8.98918C13.1253 8.87497 13.1129 8.74931 13.137 8.62807C13.1611 8.50683 13.2206 8.39547 13.3081 8.30806C13.3955 8.22065 13.5068 8.16112 13.6281 8.13701C13.7493 8.11289 13.875 8.12527 13.9892 8.17257C14.1034 8.21988 14.201 8.29999 14.2697 8.40277C14.3383 8.50555 14.375 8.62639 14.375 8.75C14.375 8.91576 14.3092 9.07473 14.1919 9.19194C14.0747 9.30915 13.9158 9.375 13.75 9.375ZM16.25 14.375C16.1264 14.375 16.0055 14.3383 15.9028 14.2697C15.8 14.201 15.7199 14.1034 15.6726 13.9892C15.6253 13.875 15.6129 13.7493 15.637 13.6281C15.6611 13.5068 15.7207 13.3955 15.8081 13.3081C15.8955 13.2206 16.0068 13.1611 16.1281 13.137C16.2493 13.1129 16.375 13.1253 16.4892 13.1726C16.6034 13.2199 16.701 13.3 16.7697 13.4028C16.8383 13.5055 16.875 13.6264 16.875 13.75C16.875 13.9158 16.8092 14.0747 16.6919 14.1919C16.5747 14.3092 16.4158 14.375 16.25 14.375ZM16.25 11.875C16.1264 11.875 16.0055 11.8383 15.9028 11.7697C15.8 11.701 15.7199 11.6034 15.6726 11.4892C15.6253 11.375 15.6129 11.2493 15.637 11.1281C15.6611 11.0068 15.7207 10.8955 15.8081 10.8081C15.8955 10.7207 16.0068 10.6611 16.1281 10.637C16.2493 10.6129 16.375 10.6253 16.4892 10.6726C16.6034 10.7199 16.701 10.8 16.7697 10.9028C16.8383 11.0055 16.875 11.1264 16.875 11.25C16.875 11.4158 16.8092 11.5747 16.6919 11.6919C16.5747 11.8092 16.4158 11.875 16.25 11.875ZM16.25 9.375C16.1264 9.375 16.0055 9.33834 15.9028 9.26967C15.8 9.20099 15.7199 9.10338 15.6726 8.98918C15.6253 8.87497 15.6129 8.74931 15.637 8.62807C15.6611 8.50683 15.7207 8.39547 15.8081 8.30806C15.8955 8.22065 16.0068 8.16112 16.1281 8.13701C16.2493 8.11289 16.375 8.12527 16.4892 8.17257C16.6034 8.21988 16.701 8.29999 16.7697 8.40277C16.8383 8.50555 16.875 8.62639 16.875 8.75C16.875 8.91576 16.8092 9.07473 16.6919 9.19194C16.5747 9.30915 16.4158 9.375 16.25 9.375ZM16.25 6.875H11.25C11.0842 6.875 10.9253 6.80915 10.8081 6.69194C10.6908 6.57473 10.625 6.41576 10.625 6.25C10.625 6.08424 10.6908 5.92527 10.8081 5.80806C10.9253 5.69085 11.0842 5.625 11.25 5.625H16.25C16.4158 5.625 16.5747 5.69085 16.6919 5.80806C16.8092 5.92527 16.875 6.08424 16.875 6.25C16.875 6.41576 16.8092 6.57473 16.6919 6.69194C16.5747 6.80915 16.4158 6.875 16.25 6.875Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M1.25 5.00039V15.0004C1.25237 15.3862 1.37368 15.7618 1.59738 16.0761C1.82108 16.3904 2.13628 16.6281 2.5 16.7566V3.24414C2.13628 3.37273 1.82108 3.61037 1.59738 3.92467C1.37368 4.23897 1.25237 4.61462 1.25 5.00039Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M6.25 1.25H5.625C4.58947 1.25 3.75 2.08947 3.75 3.125V16.875C3.75 17.9105 4.58947 18.75 5.625 18.75H6.25C7.28553 18.75 8.125 17.9105 8.125 16.875V3.125C8.125 2.08947 7.28553 1.25 6.25 1.25Z",
      fill: "white"
    }
  )
);

// src/atoms/icons/IconPremium.tsx
import React34 from "react";

// src/atoms/icons/IconSupport.tsx
import React35 from "react";

// src/atoms/icons/IconVisaCard.tsx
import React36 from "react";
var IconVisaCard = () => /* @__PURE__ */ React36.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "28",
    viewBox: "0 0 42 28",
    fill: "none",
    className: "h-[28px] w-[42px]",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React36.createElement("g", { clipPath: "url(#icon-visa-card)" }, /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      fill: "#F5F5F5"
    }
  ), /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M38.5 0C40.433 0 42 1.567 42 3.5V24.5C42 26.433 40.433 28 38.5 28H3.5C1.567 28 0 26.433 0 24.5V3.5C0 1.567 1.567 0 3.5 0H38.5Z",
      stroke: "#AFAFAF"
    }
  ), /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M36.1457 8.78125H33.9454C33.2802 8.78125 32.7685 8.98593 32.4615 9.65113L28.2656 19.2198H31.2335C31.2335 19.2198 31.7452 17.9406 31.8475 17.6336C32.1545 17.6336 35.0712 17.6336 35.4805 17.6336C35.5829 17.9918 35.8387 19.1687 35.8387 19.1687H38.4995L36.1457 8.78125ZM32.6662 15.4845C32.9221 14.8704 33.7919 12.5678 33.7919 12.5678C33.7919 12.619 34.0478 11.9538 34.1501 11.5956L34.3548 12.5166C34.3548 12.5166 34.9177 15.0239 35.02 15.5356H32.6662V15.4845Z",
      fill: "#3362AB"
    }
  ), /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M28.4709 15.7907C28.4709 17.9398 26.5265 19.3726 23.5075 19.3726C22.2282 19.3726 21.0002 19.1167 20.335 18.8097L20.7443 16.4559L21.1025 16.6094C22.0236 17.0188 22.6376 17.1723 23.7633 17.1723C24.582 17.1723 25.4519 16.8653 25.4519 16.1489C25.4519 15.6884 25.0937 15.3813 23.968 14.8696C22.8934 14.3579 21.4607 13.5392 21.4607 12.0553C21.4607 10.0085 23.4563 8.62695 26.2706 8.62695C27.3452 8.62695 28.2662 8.83163 28.8291 9.08748L28.4198 11.3389L28.2151 11.1343C27.7034 10.9296 27.0382 10.7249 26.066 10.7249C24.9914 10.7761 24.4797 11.2366 24.4797 11.646C24.4797 12.1065 25.0937 12.4647 26.066 12.9252C27.7034 13.6927 28.4709 14.5626 28.4709 15.7907Z",
      fill: "#3362AB"
    }
  ), /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M3.5 8.88241L3.55117 8.67773H7.95175C8.56579 8.67773 9.02632 8.88241 9.17982 9.54762L10.152 14.1529C9.17982 11.6967 6.92836 9.70113 3.5 8.88241Z",
      fill: "#F9B50B"
    }
  ), /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M16.3437 8.77969L11.8919 19.1671H8.87293L6.31445 10.4683C8.15656 11.6452 9.69165 13.4873 10.2545 14.7665L10.5615 15.8411L13.3247 8.72852H16.3437V8.77969Z",
      fill: "#3362AB"
    }
  ), /* @__PURE__ */ React36.createElement("path", { d: "M17.5204 8.72852H20.3348L18.5438 19.1671H15.7295L17.5204 8.72852Z", fill: "#3362AB" })),
  /* @__PURE__ */ React36.createElement("defs", null, /* @__PURE__ */ React36.createElement("clipPath", { id: "icon-visa-card" }, /* @__PURE__ */ React36.createElement("rect", { width: "42", height: "28", fill: "white" })))
);

// src/atoms/icons/IconWorld.tsx
import React37 from "react";

// src/atoms/icons/IconWuffyLogo.tsx
import React38 from "react";

// src/atoms/icons/IconVerifiedBadge.tsx
import React39 from "react";
var IconVerifiedBadge = ({ className }) => /* @__PURE__ */ React39.createElement(
  "svg",
  {
    className: cn("size-[70px] shrink-0", className),
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React39.createElement("circle", { cx: "35", cy: "35", r: "34.8", stroke: "currentColor", strokeOpacity: "0.2", strokeWidth: "0.4" }),
  /* @__PURE__ */ React39.createElement("circle", { cx: "35", cy: "35", r: "24.5", stroke: "currentColor", strokeOpacity: "0.4" }),
  /* @__PURE__ */ React39.createElement("circle", { cx: "35", cy: "35", r: "29.7", stroke: "currentColor", strokeOpacity: "0.3", strokeWidth: "0.6" }),
  /* @__PURE__ */ React39.createElement("g", { clipPath: "url(#icon-verified-badge)" }, /* @__PURE__ */ React39.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 55C37.6264 55 40.2272 54.4827 42.6537 53.4776C45.0802 52.4725 47.285 50.9993 49.1421 49.1421C50.9993 47.285 52.4725 45.0802 53.4776 42.6537C54.4827 40.2272 55 37.6264 55 35C55 32.3736 54.4827 29.7728 53.4776 27.3463C52.4725 24.9198 50.9993 22.715 49.1421 20.8579C47.285 19.0007 45.0802 17.5275 42.6537 16.5224C40.2272 15.5173 37.6264 15 35 15C29.6957 15 24.6086 17.1071 20.8579 20.8579C17.1071 24.6086 15 29.6957 15 35C15 40.3043 17.1071 45.3914 20.8579 49.1421C24.6086 52.8929 29.6957 55 35 55ZM34.4844 43.0889L45.5956 29.7556L42.1822 26.9111L32.6267 38.3756L27.6822 33.4289L24.54 36.5711L31.2067 43.2378L32.9267 44.9578L34.4844 43.0889Z",
      fill: "currentColor"
    }
  )),
  /* @__PURE__ */ React39.createElement("defs", null, /* @__PURE__ */ React39.createElement("clipPath", { id: "icon-verified-badge" }, /* @__PURE__ */ React39.createElement("rect", { width: "40", height: "40", fill: "white", transform: "translate(15 15)" })))
);

// src/atoms/icons/IconAiPowered.tsx
import React40 from "react";

// src/atoms/icons/IconAllergyFriendly.tsx
import React41 from "react";

// src/atoms/icons/IconColorOptions.tsx
import React42 from "react";

// src/atoms/icons/IconHandSculpted.tsx
import React43 from "react";

// src/atoms/icons/IconPuppyBehavior.tsx
import React44 from "react";

// src/atoms/icons/IconTouchResponsive.tsx
import React45 from "react";

// src/atoms/icons/IconSoftDurable.tsx
import React46 from "react";

// src/atoms/icons/IconReadyToPlay.tsx
import React47 from "react";

// src/atoms/icons/IconCart.tsx
import React48 from "react";
var IconCart = ({ className, color }) => /* @__PURE__ */ React48.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: color ? { color } : void 0
  },
  /* @__PURE__ */ React48.createElement(
    "path",
    {
      d: "M6.875 17.5C7.56536 17.5 8.125 16.9404 8.125 16.25C8.125 15.5596 7.56536 15 6.875 15C6.18464 15 5.625 15.5596 5.625 16.25C5.625 16.9404 6.18464 17.5 6.875 17.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React48.createElement(
    "path",
    {
      d: "M15.625 17.5C16.3154 17.5 16.875 16.9404 16.875 16.25C16.875 15.5596 16.3154 15 15.625 15C14.9346 15 14.375 15.5596 14.375 16.25C14.375 16.9404 14.9346 17.5 15.625 17.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React48.createElement(
    "path",
    {
      d: "M18.9233 4.15685C18.8232 4.03626 18.6971 3.93914 18.5541 3.87253C18.411 3.80592 18.2548 3.7715 18.0966 3.77177H4.53884L4.26577 2.24633C4.23665 2.08384 4.15032 1.93665 4.02193 1.83061C3.89353 1.72457 3.7313 1.66647 3.56372 1.6665H0.712744C0.523712 1.6665 0.342423 1.74044 0.208758 1.87204C0.0750924 2.00365 0 2.18214 0 2.36826C0 2.55438 0.0750924 2.73287 0.208758 2.86447C0.342423 2.99608 0.523712 3.07001 0.712744 3.07001H2.96591L4.9999 14.42C5.02902 14.5825 5.11535 14.7297 5.24374 14.8357C5.37213 14.9418 5.53437 14.9999 5.70195 14.9998H17.1059C17.2949 14.9998 17.4762 14.9259 17.6098 14.7943C17.7435 14.6627 17.8186 14.4842 17.8186 14.2981C17.8186 14.112 17.7435 13.9335 17.6098 13.8019C17.4762 13.6703 17.2949 13.5963 17.1059 13.5963H6.29976L6.04852 12.1928H16.8136C17.0608 12.1925 17.3003 12.1081 17.4915 11.954C17.6828 11.7998 17.8141 11.5853 17.8631 11.3468L19.1461 5.03098C19.177 4.87813 19.173 4.72043 19.1345 4.56926C19.096 4.41809 19.0239 4.27724 18.9233 4.15685Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconBonus.tsx
import React49 from "react";
var IconBonus = ({ className, color }) => /* @__PURE__ */ React49.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: color ? { color } : void 0
  },
  /* @__PURE__ */ React49.createElement(
    "path",
    {
      d: "M15.5416 2.37471L16.0499 5.59137L18.9749 7.08304L17.4999 9.99971L18.9833 12.9164L16.0333 14.408L15.5249 17.6247L12.2833 17.1164L9.97493 19.4164L7.65827 17.083L4.4416 17.6164L3.92493 14.3747L1.0166 12.8914L2.49993 9.97471L1.02493 7.08304L3.94993 5.57471L4.45827 2.38304L7.68327 2.91637L9.99993 0.574707L12.3083 2.88304L15.5416 2.37471ZM7.9166 5.83304C7.58508 5.83304 7.26714 5.96474 7.03272 6.19916C6.7983 6.43358 6.6666 6.75152 6.6666 7.08304C6.6666 7.41456 6.7983 7.7325 7.03272 7.96692C7.26714 8.20134 7.58508 8.33304 7.9166 8.33304C8.24812 8.33304 8.56606 8.20134 8.80048 7.96692C9.03491 7.7325 9.1666 7.41456 9.1666 7.08304C9.1666 6.75152 9.03491 6.43358 8.80048 6.19916C8.56606 5.96474 8.24812 5.83304 7.9166 5.83304ZM12.0833 11.6664C11.7517 11.6664 11.4338 11.7981 11.1994 12.0325C10.965 12.2669 10.8333 12.5849 10.8333 12.9164C10.8333 13.2479 10.965 13.5658 11.1994 13.8003C11.4338 14.0347 11.7517 14.1664 12.0833 14.1664C12.4148 14.1664 12.7327 14.0347 12.9672 13.8003C13.2016 13.5658 13.3333 13.2479 13.3333 12.9164C13.3333 12.5849 13.2016 12.2669 12.9672 12.0325C12.7327 11.7981 12.4148 11.6664 12.0833 11.6664ZM7.00827 14.1664L14.1666 7.00804L12.9916 5.83304L5.83327 12.9914L7.00827 14.1664Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconSummary.tsx
import React50 from "react";
var IconSummary = ({ className, color }) => /* @__PURE__ */ React50.createElement(
  "svg",
  {
    className: cn("size-5 shrink-0", className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: color ? { color } : void 0
  },
  /* @__PURE__ */ React50.createElement(
    "path",
    {
      d: "M7.75238 7.08712L8.23954 8.84938C8.69831 10.5095 8.92722 11.34 9.60167 11.7174C10.2761 12.0958 11.1322 11.8726 12.8443 11.428L14.6605 10.955C16.3726 10.5104 17.2287 10.2881 17.6184 9.6345C18.0081 8.97992 17.7792 8.1494 17.3195 6.4893L16.8333 4.72798C16.3745 3.06693 16.1446 2.23641 15.4711 1.85899C14.7958 1.48062 13.9397 1.70385 12.2276 2.14939L10.4114 2.62046C8.69926 3.06504 7.84319 3.28828 7.45442 3.94286C7.06469 4.5965 7.29361 5.42702 7.75238 7.08712Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React50.createElement(
    "path",
    {
      d: "M0.859214 3.79226C0.884136 3.70242 0.926521 3.61838 0.983947 3.54493C1.04137 3.47148 1.11271 3.41007 1.19389 3.36421C1.27506 3.31836 1.36448 3.28895 1.45703 3.27767C1.54957 3.26639 1.64344 3.27347 1.73325 3.29849L3.34416 3.74497C3.7711 3.86092 4.16071 4.0855 4.47502 4.39683C4.78933 4.70816 5.01762 5.09561 5.13764 5.52142L7.17233 12.8864L7.32178 13.4029C7.92055 13.6271 8.43514 14.0461 8.76148 14.6023L9.05472 14.5115L17.4451 12.3311C17.5353 12.3077 17.6292 12.3022 17.7215 12.315C17.8138 12.3278 17.9027 12.3587 17.9831 12.4059C18.0634 12.453 18.1337 12.5156 18.1899 12.5899C18.2461 12.6642 18.2871 12.7489 18.3106 12.8391C18.3341 12.9293 18.3396 13.0232 18.3268 13.1155C18.3139 13.2078 18.2831 13.2967 18.2359 13.3771C18.1887 13.4574 18.1262 13.5277 18.0518 13.5839C17.9775 13.6401 17.8928 13.6811 17.8026 13.7046L9.44255 15.8765L9.13229 15.973C9.12566 17.1743 8.29609 18.2725 7.04179 18.5988C5.53682 18.9905 3.99023 18.124 3.58727 16.6654C3.1843 15.2058 4.07726 13.7056 5.58128 13.3149C5.65539 13.2958 5.73017 13.2794 5.80546 13.2657L3.76983 5.89884C3.71503 5.70957 3.61218 5.53771 3.47129 5.39997C3.33039 5.26222 3.15625 5.16328 2.96579 5.11278L1.35393 4.66535C1.26411 4.64053 1.18006 4.59825 1.10658 4.54093C1.03311 4.48361 0.97164 4.41238 0.925699 4.3313C0.879757 4.25022 0.850239 4.16088 0.838832 4.06839C0.827424 3.97591 0.83435 3.88208 0.859214 3.79226Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconBox.tsx
import React51 from "react";
var IconBox = ({ className }) => /* @__PURE__ */ React51.createElement(
  "svg",
  {
    className: cn("size-4 shrink-0", className),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React51.createElement(
    "path",
    {
      d: "M21 8L12 3L3 8M21 8V16L12 21M21 8L12 13M3 8V16L12 21M3 8L12 13M12 13V21",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/atoms/icons/IconClock.tsx
import React52 from "react";
var IconClock = ({ className, color }) => /* @__PURE__ */ React52.createElement(
  "svg",
  {
    className: cn("size-4 shrink-0", className),
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: color ? { color } : void 0
  },
  /* @__PURE__ */ React52.createElement(
    "path",
    {
      d: "M8.49967 0.083313C7.46004 0.083313 6.43059 0.288084 5.4701 0.685933C4.5096 1.08378 3.63688 1.66692 2.90175 2.40205C1.41708 3.88671 0.583008 5.90035 0.583008 7.99998C0.583008 10.0996 1.41708 12.1132 2.90175 13.5979C3.63688 14.333 4.5096 14.9162 5.4701 15.314C6.43059 15.7119 7.46004 15.9166 8.49967 15.9166C10.5993 15.9166 12.6129 15.0826 14.0976 13.5979C15.5823 12.1132 16.4163 10.0996 16.4163 7.99998C16.4163 6.96035 16.2116 5.9309 15.8137 4.9704C15.4159 4.00991 14.8327 3.13718 14.0976 2.40205C13.3625 1.66692 12.4897 1.08378 11.5293 0.685933C10.5688 0.288084 9.53931 0.083313 8.49967 0.083313ZM11.8247 11.325L7.70801 8.79165V4.04165H8.89551V8.15831L12.458 10.2958L11.8247 11.325Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconDoubleChevron.tsx
import React53 from "react";
var IconDoubleChevron = () => /* @__PURE__ */ React53.createElement(
  "svg",
  {
    width: "15",
    height: "16",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React53.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.535421 15.1812C0.78087 15.4271 1.1031 15.55 1.42517 15.55C1.74732 15.55 2.06948 15.4281 2.31532 15.1803L8.60888 8.88668C9.10057 8.39501 9.10057 7.59848 8.60888 7.10679L2.31532 0.813223C1.82363 0.321536 1.02711 0.321536 0.535421 0.813223C0.0437348 1.30491 0.0437348 2.10144 0.535421 2.59313L5.94081 7.99773L0.535421 13.4013C0.0437348 13.893 0.0437348 14.6896 0.535421 15.1812ZM6.19963 15.1812C6.44508 15.4271 6.7673 15.55 7.08939 15.55C7.41152 15.55 7.73368 15.4281 7.97952 15.1803L14.2731 8.88668C14.7648 8.39501 14.7648 7.59848 14.2731 7.10679L7.97952 0.813223C7.48784 0.321536 6.69132 0.321536 6.19963 0.813223C5.70795 1.30491 5.70795 2.10144 6.19963 2.59313L11.605 7.99773L6.19963 13.4013C5.70795 13.893 5.70795 14.6896 6.19963 15.1812Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconStarFull.tsx
import React54 from "react";
var STAR_PATH = "m10 1.7 2.5 5.1 5.6.8-4 4 1 5.5-5-2.6-5 2.6 1-5.5-4-4 5.5-.8L10 1.7Z";
var IconStarFull = ({ className }) => /* @__PURE__ */ React54.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 20 20", className: cn("h-4 w-4", className) }, /* @__PURE__ */ React54.createElement("path", { d: STAR_PATH, className: "fill-[#ffc400]" }));

// src/atoms/icons/IconStarHalf.tsx
import React55 from "react";
var STAR_PATH2 = "m10 1.7 2.5 5.1 5.6.8-4 4 1 5.5-5-2.6-5 2.6 1-5.5-4-4 5.5-.8L10 1.7Z";
var IconStarHalf = ({ className }) => {
  const id = React55.useId();
  return /* @__PURE__ */ React55.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 20 20", className: cn("h-4 w-4", className) }, /* @__PURE__ */ React55.createElement("defs", null, /* @__PURE__ */ React55.createElement("clipPath", { id: `${id}-l` }, /* @__PURE__ */ React55.createElement("rect", { width: "10", height: "20" })), /* @__PURE__ */ React55.createElement("clipPath", { id: `${id}-r` }, /* @__PURE__ */ React55.createElement("rect", { x: "10", width: "10", height: "20" }))), /* @__PURE__ */ React55.createElement("path", { d: STAR_PATH2, clipPath: `url(#${id}-l)`, className: "fill-[#ffc400]" }), /* @__PURE__ */ React55.createElement("path", { d: STAR_PATH2, clipPath: `url(#${id}-r)`, className: "fill-gray-200" }));
};

// src/atoms/icons/IconStarEmpty.tsx
import React56 from "react";
var STAR_PATH3 = "m10 1.7 2.5 5.1 5.6.8-4 4 1 5.5-5-2.6-5 2.6 1-5.5-4-4 5.5-.8L10 1.7Z";
var IconStarEmpty = ({ className }) => /* @__PURE__ */ React56.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 20 20", className: cn("h-4 w-4", className) }, /* @__PURE__ */ React56.createElement("path", { d: STAR_PATH3, className: "fill-gray-200" }));

// src/atoms/icons/IconTrustpilotStar.tsx
import React57 from "react";
var STAR_PATH4 = "M5.194 17.306L6.966 11.945C6.994 11.858 6.966 11.762 6.891 11.708L2.348 8.36C2.184 8.238 2.271 7.978 2.475 7.978L8.279 8.001H8.283L10.127 2.497C10.193 2.303 10.467 2.305 10.53 2.499L12.234 7.856C12.262 7.943 12.341 8.004 12.433 8.004L18.091 8.051C18.295 8.051 18.379 8.313 18.213 8.432L13.5 11.837L13.416 11.898L13.366 11.933L10.24 14.168L5.517 17.543C5.351 17.662 5.131 17.498 5.194 17.304V17.306Z";
var SHADOW_PATH = "M15.259 17.37L13.496 11.84L10.241 14.175L14.933 17.606C15.097 17.728 15.322 17.566 15.259 17.372V17.37Z";
var GREEN = "#00B890";
var GREY = "#DCDCE7";
var IconTrustpilotStar = ({
  fill = "full",
  className
}) => {
  const shadowId = React57.useId();
  return /* @__PURE__ */ React57.createElement(
    "svg",
    {
      viewBox: "0 0 20 20",
      className: cn("size-5 shrink-0", className),
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    },
    fill === "full" && /* @__PURE__ */ React57.createElement("defs", null, /* @__PURE__ */ React57.createElement(
      "linearGradient",
      {
        id: shadowId,
        x1: "16",
        y1: "16",
        x2: "11",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React57.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ React57.createElement("stop", { offset: "0.34", stopColor: "#FCFCFC" }),
      /* @__PURE__ */ React57.createElement("stop", { offset: "0.52", stopColor: "#F4F4F4" }),
      /* @__PURE__ */ React57.createElement("stop", { offset: "0.66", stopColor: "#E7E7E7" }),
      /* @__PURE__ */ React57.createElement("stop", { offset: "0.78", stopColor: "#D4D4D4" }),
      /* @__PURE__ */ React57.createElement("stop", { offset: "0.89", stopColor: "#BBBBBB" }),
      /* @__PURE__ */ React57.createElement("stop", { offset: "1", stopColor: "#999999" })
    )),
    /* @__PURE__ */ React57.createElement("rect", { x: "0", y: "0", width: "20", height: "20", fill: fill === "empty" ? GREY : GREEN }),
    fill === "half" && /* @__PURE__ */ React57.createElement("rect", { x: "10", y: "0", width: "10", height: "20", fill: GREY }),
    fill === "full" && /* @__PURE__ */ React57.createElement("path", { d: SHADOW_PATH, fill: `url(#${shadowId})` }),
    /* @__PURE__ */ React57.createElement("path", { d: STAR_PATH4, fill: "white" })
  );
};

// src/atoms/icons/IconReviewPlus.tsx
import React58 from "react";
var IconReviewPlus = ({ className }) => /* @__PURE__ */ React58.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    className: cn(className)
  },
  /* @__PURE__ */ React58.createElement(
    "path",
    {
      d: "M8 0.75C4.00594 0.75 0.75 4.00594 0.75 8C0.75 11.9941 4.00594 15.25 8 15.25C11.9941 15.25 15.25 11.9941 15.25 8C15.25 4.00594 11.9941 0.75 8 0.75ZM8 14.25C4.55781 14.25 1.75 11.4422 1.75 8C1.75 4.55781 4.55781 1.75 8 1.75C11.4422 1.75 14.25 4.55781 14.25 8C14.25 11.4422 11.4422 14.25 8 14.25ZM11.5 7.5H8.5V4.5C8.5 4.22375 8.27625 4 8 4C7.72375 4 7.5 4.22375 7.5 4.5V7.5H4.5C4.22375 7.5 4 7.72375 4 8C4 8.27625 4.22375 8.5 4.5 8.5H7.5V11.5C7.5 11.7763 7.72375 12 8 12C8.27625 12 8.5 11.7763 8.5 11.5V8.5H11.5C11.7763 8.5 12 8.27625 12 8C12 7.72375 11.7763 7.5 11.5 7.5Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/icons/IconReviewSingleStar.tsx
import React59 from "react";
var IconReviewSingleStar = ({ className }) => /* @__PURE__ */ React59.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    "aria-hidden": "true",
    className: cn(className)
  },
  /* @__PURE__ */ React59.createElement(
    "path",
    {
      d: "M11.6815 4.28914L7.99255 3.7248L6.33906 0.197544C6.21556 -0.0658481 5.78406 -0.0658481 5.66056 0.197544L4.00756 3.7248L0.318574 4.28914C0.0155746 4.33571 -0.105425 4.70476 0.107074 4.92258L2.78707 7.67368L2.15357 11.563C2.10307 11.8719 2.43257 12.1038 2.70507 11.952L6.00006 10.1283L9.29505 11.9525C9.56505 12.1028 9.89755 11.8754 9.84655 11.5635L9.21305 7.67418L11.893 4.92308C12.1055 4.70476 11.984 4.33571 11.6815 4.28914Z",
      fill: "currentColor"
    }
  )
);

// src/organisms/Header.tsx
var DEFAULT_HEADER_CLASS = "relative box-border h-12 w-full border-b border-[#F0F0F0] bg-white md:h-[60px] md:shadow-[0_1px_0_0_rgba(0,0,0,0.08)]";
var DEFAULT_CONTAINER_CLASS2 = "mx-auto flex h-full w-full max-w-[1100px] items-center justify-between px-4 lg:px-0 py-3";
var DEFAULT_LOGO_CLASS = "flex h-9 w-full max-w-30 md:max-w-40 lg:max-w-50 shrink-0 items-center";
var DEFAULT_LOGO_IMAGE_CLASS = "h-full object-contain";
var DEFAULT_NAV_CLASS = "hidden items-center gap-6 md:flex";
var DEFAULT_LINK_CLASS = "text-[14px] font-medium leading-5 text-black";
var DEFAULT_ACTIONS_CLASS = "flex items-center gap-3 md:gap-8";
var DEFAULT_DESKTOP_ACTIONS_CLASS = "hidden items-center gap-8 md:flex";
var DEFAULT_MOBILE_ACTIONS_CLASS = "flex items-center gap-3 md:hidden";
var DEFAULT_CTA_CLASS = "font-outfit box-border flex h-9 items-center justify-center rounded-[10px] border border-[#D39208] bg-gradient-to-r from-[#FFCD5A] to-[#FFE65B] px-4 py-2 text-center text-[14px] leading-5 font-bold text-black";
var DEFAULT_FLAG_CLASS = "size-5";
var DEFAULT_MENU_BUTTON_CLASS = "flex size-6 items-center justify-center text-black md:hidden";
var DEFAULT_MENU_ICON_CLASS = "size-6";
var DEFAULT_MOBILE_MENU_CLASS = "absolute top-full left-0 z-20 grid w-full origin-top overflow-hidden border-b border-[#F0F0F0] bg-white shadow-[0_8px_20px_rgba(0,0,0,0.08)] transition-[grid-template-rows,opacity,transform] duration-200 ease-out md:hidden";
var DEFAULT_MOBILE_MENU_OPEN_CLASS = "grid-rows-[1fr] translate-y-0 opacity-100";
var DEFAULT_MOBILE_MENU_CLOSED_CLASS = "pointer-events-none grid-rows-[0fr] -translate-y-2 opacity-0";
var DEFAULT_MOBILE_MENU_CONTENT_CLASS = "flex min-h-0 flex-col overflow-hidden px-4 py-4";
var DEFAULT_MOBILE_MENU_LINK_CLASS = "border-b border-[#F0F0F0] py-3 text-center text-[16px] font-medium leading-6 text-black last:border-b-0";
var DEFAULT_MOBILE_MENU_CTA_CLASS = "mt-4 w-full";
var Header = ({
  logo,
  logoImage,
  logoImageAlt = "",
  links = [],
  cta = false,
  ctaText,
  ctaHref,
  flagImage,
  flagImageAlt = "",
  showFlag = false,
  showMobileMenuButton = true,
  menuIcon,
  menuOpenIcon,
  mobileMenuOpen,
  defaultMobileMenuOpen = false,
  onMobileMenuClick,
  onMobileMenuOpenChange,
  className,
  classes = {}
}) => {
  const [uncontrolledMobileMenuOpen, setUncontrolledMobileMenuOpen] = React60.useState(defaultMobileMenuOpen);
  const isMobileMenuOpen = mobileMenuOpen != null ? mobileMenuOpen : uncontrolledMobileMenuOpen;
  const mobileMenuId = React60.useId();
  const hasCta = Boolean(cta && ctaText && ctaHref);
  const hasMobileMenuContent = links.length > 0 || hasCta;
  const setMobileMenuOpen = (nextOpen) => {
    if (mobileMenuOpen === void 0) {
      setUncontrolledMobileMenuOpen(nextOpen);
    }
    onMobileMenuOpenChange == null ? void 0 : onMobileMenuOpenChange(nextOpen);
  };
  const handleMobileMenuToggle = () => {
    const nextOpen = !isMobileMenuOpen;
    setMobileMenuOpen(nextOpen);
    onMobileMenuClick == null ? void 0 : onMobileMenuClick();
  };
  const handleMobileMenuClose = () => {
    if (isMobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  };
  const renderedLogo = logo ? logo : logoImage ? /* @__PURE__ */ React60.createElement(Image, { src: logoImage, alt: logoImageAlt, className: DEFAULT_LOGO_IMAGE_CLASS }) : null;
  const renderFlag = () => {
    if (flagImage) {
      return /* @__PURE__ */ React60.createElement(
        Image,
        {
          src: flagImage,
          alt: flagImageAlt,
          className: cn(DEFAULT_FLAG_CLASS, classes.flag)
        }
      );
    }
    if (showFlag) {
      return /* @__PURE__ */ React60.createElement(FlagIcon, { className: cn(DEFAULT_FLAG_CLASS, classes.flag) });
    }
    return null;
  };
  return /* @__PURE__ */ React60.createElement("header", { className: cn(DEFAULT_HEADER_CLASS, className) }, /* @__PURE__ */ React60.createElement("nav", { className: cn(DEFAULT_CONTAINER_CLASS2, classes.container), "aria-label": "Product" }, /* @__PURE__ */ React60.createElement("div", { className: cn(DEFAULT_LOGO_CLASS, classes.logo) }, renderedLogo), /* @__PURE__ */ React60.createElement("div", { className: cn(DEFAULT_ACTIONS_CLASS, classes.actions) }, links.length > 0 && /* @__PURE__ */ React60.createElement("div", { className: cn(DEFAULT_NAV_CLASS, classes.nav) }, links.map((link) => {
    var _a;
    return /* @__PURE__ */ React60.createElement(
      "a",
      {
        key: `${link.label}-${(_a = link.href) != null ? _a : ""}`,
        href: link.href,
        className: cn(DEFAULT_LINK_CLASS, classes.link)
      },
      /* @__PURE__ */ React60.createElement(Text, { as: "span" }, link.label)
    );
  })), /* @__PURE__ */ React60.createElement("div", { className: DEFAULT_DESKTOP_ACTIONS_CLASS }, hasCta && /* @__PURE__ */ React60.createElement(
    "a",
    {
      href: ctaHref,
      className: cn(DEFAULT_CTA_CLASS, classes.cta),
      onClick: handleMobileMenuClose
    },
    ctaText
  ), renderFlag()), /* @__PURE__ */ React60.createElement("div", { className: DEFAULT_MOBILE_ACTIONS_CLASS }, renderFlag(), showMobileMenuButton && hasMobileMenuContent && /* @__PURE__ */ React60.createElement(
    "button",
    {
      className: cn(DEFAULT_MENU_BUTTON_CLASS, classes.menuButton),
      onClick: handleMobileMenuToggle,
      "aria-label": isMobileMenuOpen ? "Close menu" : "Open menu",
      "aria-expanded": isMobileMenuOpen,
      "aria-controls": mobileMenuId,
      type: "button"
    },
    menuOpenIcon && isMobileMenuOpen ? React60.isValidElement(menuOpenIcon) ? React60.cloneElement(menuOpenIcon, {
      className: cn(
        DEFAULT_MENU_ICON_CLASS,
        menuOpenIcon.props.className,
        classes.menuIcon
      )
    }) : menuOpenIcon : menuIcon && React60.isValidElement(menuIcon) ? React60.cloneElement(menuIcon, {
      className: cn(
        DEFAULT_MENU_ICON_CLASS,
        menuIcon.props.className,
        classes.menuIcon
      )
    }) : /* @__PURE__ */ React60.createElement(IconBurgerMenu, { className: cn(DEFAULT_MENU_ICON_CLASS, classes.menuIcon) })
  )))), showMobileMenuButton && hasMobileMenuContent && /* @__PURE__ */ React60.createElement(
    "div",
    {
      id: mobileMenuId,
      className: cn(
        DEFAULT_MOBILE_MENU_CLASS,
        isMobileMenuOpen ? DEFAULT_MOBILE_MENU_OPEN_CLASS : DEFAULT_MOBILE_MENU_CLOSED_CLASS,
        classes.mobileMenu
      ),
      "aria-hidden": !isMobileMenuOpen,
      inert: !isMobileMenuOpen ? true : void 0
    },
    /* @__PURE__ */ React60.createElement("div", { className: cn(DEFAULT_MOBILE_MENU_CONTENT_CLASS, classes.mobileMenuContent) }, links.map((link) => {
      var _a;
      return /* @__PURE__ */ React60.createElement(
        "a",
        {
          key: `${link.label}-${(_a = link.href) != null ? _a : ""}-mobile`,
          href: link.href,
          className: cn(DEFAULT_MOBILE_MENU_LINK_CLASS, classes.mobileMenuLink),
          onClick: handleMobileMenuClose
        },
        /* @__PURE__ */ React60.createElement(Text, { as: "span" }, link.label)
      );
    }), hasCta && /* @__PURE__ */ React60.createElement(
      "a",
      {
        href: ctaHref,
        className: cn(
          DEFAULT_CTA_CLASS,
          DEFAULT_MOBILE_MENU_CTA_CLASS,
          classes.mobileMenuCta
        ),
        onClick: handleMobileMenuClose
      },
      ctaText
    ))
  ));
};

// src/organisms/PageHeader.tsx
import React62 from "react";

// src/atoms/BrandLogo.tsx
import React61 from "react";
var DEFAULT_LOGO_CLASS2 = "block h-[26px] max-w-full w-auto";
var BrandLogo = ({ image, imageAlt, className, classes = {} }) => {
  return /* @__PURE__ */ React61.createElement("img", { className: cn(DEFAULT_LOGO_CLASS2, classes.root, className), src: image, alt: imageAlt });
};

// src/organisms/PageHeader.tsx
var DEFAULT_ROOT_CLASS = "w-full border-b";
var DEFAULT_INNER_CLASS = "mx-auto flex";
var DEFAULT_INNER_DEFAULT_CLASS = "items-center justify-between px-4 py-3";
var DEFAULT_INNER_STACKED_CLASS = "flex-col md:flex-row md:items-center md:justify-between";
var DEFAULT_LOGO_WRAPPER_CLASS = "flex items-center";
var DEFAULT_LOGO_WRAPPER_STACKED_CLASS = "w-full justify-center px-4 py-3 md:w-auto md:justify-start";
var DEFAULT_RIGHT_CLASS = "flex items-center";
var DEFAULT_RIGHT_STACKED_CLASS = "w-full justify-center px-4 py-2 md:w-auto md:bg-transparent md:justify-start md:px-4 md:py-0";
var THEMED_ROOT_CLASS = "border-[var(--theme-color-border-light,#e5e7eb)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_INNER_CLASS = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var THEMED_RIGHT_STACKED_CLASS = "bg-[var(--theme-color-bg-raised,#f9fafb)]";
var PageHeader = ({
  logo,
  logoImage,
  logoAlt,
  right,
  stackOnMobile = false,
  className,
  classes = {}
}) => {
  const logoContent = logo != null ? logo : logoImage && /* @__PURE__ */ React62.createElement(BrandLogo, { image: logoImage, imageAlt: logoAlt, classes: { root: classes.logo } });
  const innerClass = cn(
    DEFAULT_INNER_CLASS,
    THEMED_INNER_CLASS,
    stackOnMobile ? DEFAULT_INNER_STACKED_CLASS : DEFAULT_INNER_DEFAULT_CLASS
  );
  const logoWrapperClass = cn(
    DEFAULT_LOGO_WRAPPER_CLASS,
    stackOnMobile && DEFAULT_LOGO_WRAPPER_STACKED_CLASS
  );
  const rightClass = cn(
    DEFAULT_RIGHT_CLASS,
    stackOnMobile && DEFAULT_RIGHT_STACKED_CLASS,
    stackOnMobile && THEMED_RIGHT_STACKED_CLASS
  );
  return /* @__PURE__ */ React62.createElement("header", { className: cn(DEFAULT_ROOT_CLASS, THEMED_ROOT_CLASS, classes.root, className) }, /* @__PURE__ */ React62.createElement("div", { className: cn(innerClass, classes.inner) }, /* @__PURE__ */ React62.createElement("div", { className: cn(logoWrapperClass, classes.logoWrapper) }, logoContent), right && /* @__PURE__ */ React62.createElement("div", { className: cn(rightClass, classes.right) }, right)));
};

// src/organisms/PillBreadcrumbPageHeader.tsx
import React64 from "react";

// src/molecules/PillStepBreadcrumb.tsx
import React63 from "react";
var DEFAULT_ROOT_CLASS2 = "flex h-[26px] w-full max-w-full items-stretch overflow-hidden rounded-full border md:inline-flex md:w-auto";
var DEFAULT_STEP_CLASS = 'relative flex min-w-0 flex-1 items-center justify-center whitespace-nowrap bg-[var(--step-breadcrumb-step-bg)] text-xs font-light leading-none after:absolute after:right-[-10px] after:top-1/2 after:z-10 after:-translate-y-1/2 after:border-y-[13px] after:border-l-[10px] after:border-y-transparent after:[border-left-color:var(--step-breadcrumb-step-bg)] after:content-[""] last:after:hidden md:flex-none';
var DEFAULT_LABEL_CLASS = "whitespace-nowrap";
var THEMED_ROOT_CLASS2 = "border-[var(--theme-color-border-light,#d1d5db)] bg-[var(--theme-color-border-light,#d1d5db)]";
var THEMED_ACTIVE_STEP_CLASS = "[--step-breadcrumb-step-bg:var(--theme-color-button-primary,#111827)] font-bold text-[var(--theme-color-text-inverse,#ffffff)]";
var THEMED_INACTIVE_STEP_CLASS = "[--step-breadcrumb-step-bg:var(--theme-color-bg-section,#f3f4f6)] text-[var(--theme-color-text-light,#828282)]";
function getStepPadding(index, total) {
  if (total <= 1) return "px-4";
  if (index === 0) return "pl-4 pr-5 md:pr-1";
  if (index === total - 1) return "py-1 pr-4 pl-5";
  return "py-1 pr-2 pl-5";
}
var PillStepBreadcrumb = ({
  steps,
  activeIndex,
  className,
  classes = {}
}) => /* @__PURE__ */ React63.createElement("nav", { className: cn(DEFAULT_ROOT_CLASS2, THEMED_ROOT_CLASS2, classes.root, className) }, steps.map((step, index) => {
  const isActive = index === activeIndex;
  return /* @__PURE__ */ React63.createElement(
    "span",
    {
      key: `${step.label}-${index}`,
      "aria-current": isActive ? "step" : void 0,
      style: { zIndex: steps.length - index },
      className: cn(
        DEFAULT_STEP_CLASS,
        getStepPadding(index, steps.length),
        isActive ? THEMED_ACTIVE_STEP_CLASS : THEMED_INACTIVE_STEP_CLASS,
        classes.step,
        isActive ? classes.activeStep : classes.inactiveStep
      )
    },
    /* @__PURE__ */ React63.createElement("span", { className: cn(DEFAULT_LABEL_CLASS, classes.label) }, step.label)
  );
}));

// src/organisms/PillBreadcrumbPageHeader.tsx
var PillBreadcrumbPageHeader = ({
  steps,
  activeIndex,
  breadcrumbClasses,
  classes = {},
  ...pageHeaderProps
}) => /* @__PURE__ */ React64.createElement(
  PageHeader,
  {
    stackOnMobile: true,
    ...pageHeaderProps,
    classes,
    right: /* @__PURE__ */ React64.createElement(PillStepBreadcrumb, { steps, activeIndex, classes: breadcrumbClasses })
  }
);

// src/organisms/InlineBreadcrumbPageHeader.tsx
import React66 from "react";

// src/molecules/InlineStepBreadcrumb.tsx
import React65 from "react";
var DEFAULT_ROOT_CLASS3 = "flex items-center gap-1 font-light flex-nowrap";
var DEFAULT_ACTIVE_STEP_CLASS = "flex items-center gap-1 whitespace-nowrap";
var DEFAULT_INACTIVE_STEP_CLASS = "flex items-center gap-1 whitespace-nowrap";
var DEFAULT_ICON_CLASS2 = "shrink-0";
var DEFAULT_LABEL_CLASS2 = "text-xs md:text-base";
var DEFAULT_SEPARATOR_CLASS = "shrink-0 select-none text-xs leading-none md:text-base";
var THEMED_ACTIVE_STEP_CLASS2 = "text-[var(--theme-color-accent,#0D40FF)]";
var THEMED_INACTIVE_STEP_CLASS2 = "text-[var(--theme-color-text-light,#828282)]";
var THEMED_SEPARATOR_CLASS = "text-[var(--theme-color-text-light,#828282)]";
var InlineStepBreadcrumb = ({
  steps,
  activeIndex,
  className,
  classes = {}
}) => /* @__PURE__ */ React65.createElement("nav", { className: cn(DEFAULT_ROOT_CLASS3, classes.root, className) }, steps.map((step, index) => {
  const isActive = index === activeIndex;
  const isLast = index === steps.length - 1;
  return /* @__PURE__ */ React65.createElement(React65.Fragment, { key: `${step.label}-${index}` }, /* @__PURE__ */ React65.createElement(
    "span",
    {
      "aria-current": isActive ? "step" : void 0,
      className: cn(
        isActive ? DEFAULT_ACTIVE_STEP_CLASS : DEFAULT_INACTIVE_STEP_CLASS,
        isActive ? THEMED_ACTIVE_STEP_CLASS2 : THEMED_INACTIVE_STEP_CLASS2,
        classes.step,
        isActive ? classes.activeStep : classes.inactiveStep
      )
    },
    step.icon && /* @__PURE__ */ React65.createElement("span", { className: cn(DEFAULT_ICON_CLASS2, classes.icon), "aria-hidden": "true" }, step.icon),
    /* @__PURE__ */ React65.createElement("span", { className: cn(DEFAULT_LABEL_CLASS2, classes.label) }, step.label)
  ), !isLast && /* @__PURE__ */ React65.createElement(
    "span",
    {
      "aria-hidden": "true",
      className: cn(DEFAULT_SEPARATOR_CLASS, THEMED_SEPARATOR_CLASS, classes.separator)
    },
    ">"
  ));
}));

// src/organisms/InlineBreadcrumbPageHeader.tsx
var InlineBreadcrumbPageHeader = ({
  steps,
  activeIndex,
  breadcrumbClasses,
  ...pageHeaderProps
}) => /* @__PURE__ */ React66.createElement(
  PageHeader,
  {
    stackOnMobile: true,
    ...pageHeaderProps,
    right: /* @__PURE__ */ React66.createElement(InlineStepBreadcrumb, { steps, activeIndex, classes: breadcrumbClasses })
  }
);

// src/molecules/Ribbon.tsx
import React67 from "react";
var DEFAULT_ROOT_CLASS4 = "w-full text-sm font-light leading-5";
var DEFAULT_SIMPLE_CONTENT_CLASS = "flex items-center justify-center gap-2 px-4 py-2 text-center";
var DEFAULT_SPLIT_CONTENT_CLASS = "flex flex-col items-center text-center md:flex-row md:justify-center md:gap-4 md:px-4 md:py-2";
var DEFAULT_MESSAGE_CLASS = "flex w-full items-center justify-center gap-2 px-4 py-2 md:w-auto md:p-0";
var DEFAULT_TIMER_CLASS = "flex w-full items-center justify-center gap-1.5 border-t border-current/20 px-4 py-1.5 text-xs md:w-auto md:border-none md:p-0 md:text-sm";
var THEMED_ROOT_CLASS3 = "bg-[var(--theme-color-button-primary,#000000)] text-[var(--theme-color-text-inverse,#ffffff)]";
var THEMED_MESSAGE_CLASS = "text-[var(--theme-color-text-inverse,currentColor)]";
var THEMED_TIMER_CLASS = "text-[var(--theme-color-warning,currentColor)]";
var THEMED_ICON_CLASS = "text-[var(--theme-color-text-inverse,currentColor)]";
var Ribbon = ({
  message,
  icon,
  iconImage,
  iconAlt,
  timerIcon,
  timerText,
  className,
  classes = {}
}) => {
  const iconEl = icon != null ? icon : iconImage && /* @__PURE__ */ React67.createElement(
    "img",
    {
      src: iconImage,
      alt: iconAlt != null ? iconAlt : "",
      className: cn("size-4 shrink-0", THEMED_ICON_CLASS, classes.icon)
    }
  );
  const messageElement = /* @__PURE__ */ React67.createElement("span", { className: cn(DEFAULT_MESSAGE_CLASS, THEMED_MESSAGE_CLASS, classes.message) }, iconEl, /* @__PURE__ */ React67.createElement("span", null, message));
  return /* @__PURE__ */ React67.createElement("div", { className: cn(DEFAULT_ROOT_CLASS4, THEMED_ROOT_CLASS3, classes.root, className) }, timerText ? /* @__PURE__ */ React67.createElement("div", { className: DEFAULT_SPLIT_CONTENT_CLASS }, messageElement, /* @__PURE__ */ React67.createElement("span", { className: cn(DEFAULT_TIMER_CLASS, THEMED_TIMER_CLASS, classes.timer) }, timerIcon, /* @__PURE__ */ React67.createElement("span", null, timerText))) : /* @__PURE__ */ React67.createElement("div", { className: DEFAULT_SIMPLE_CONTENT_CLASS }, messageElement));
};

// src/molecules/CountdownText.tsx
import React68 from "react";

// src/hooks/useCountdown.ts
import { useEffect as useEffect2, useState as useState2 } from "react";
var getRemainingSeconds = (endAt) => Math.max(0, Math.floor((endAt - Date.now()) / 1e3));
var useCountdown = ({ endAt, onEnd, showHours = false }) => {
  const [remainingSeconds, setRemainingSeconds] = useState2(() => getRemainingSeconds(endAt));
  useEffect2(() => {
    const update = () => {
      const next = getRemainingSeconds(endAt);
      setRemainingSeconds(next);
      if (next <= 0) onEnd();
    };
    update();
    const interval = window.setInterval(update, 1e3);
    return () => window.clearInterval(interval);
  }, [endAt, onEnd]);
  const hours = String(Math.floor(remainingSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor(remainingSeconds % 3600 / 60)).padStart(2, "0");
  const seconds = String(remainingSeconds % 60).padStart(2, "0");
  return {
    formattedTime: showHours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`,
    hasTimeRemaining: remainingSeconds > 0,
    remainingSeconds
  };
};

// src/molecules/CountdownText.tsx
var CountdownText = ({ endAt, onEnd, className, classes = {} }) => {
  const { formattedTime, hasTimeRemaining } = useCountdown({ endAt, onEnd });
  if (!hasTimeRemaining) return null;
  return /* @__PURE__ */ React68.createElement("span", { className: cn(classes.root, className) }, formattedTime);
};

// src/context/ThemeContext.tsx
import React69, { createContext } from "react";
var ThemeContext = createContext({});
var ThemeProvider = ({ variables, children }) => {
  var _a;
  const useThemeEffect = (_a = React69.useInsertionEffect) != null ? _a : React69.useLayoutEffect;
  useThemeEffect(() => {
    if (!variables) return;
    for (const [key, value] of Object.entries(variables)) {
      document.documentElement.style.setProperty(`--${key}`, value);
    }
  }, [variables]);
  return /* @__PURE__ */ React69.createElement(ThemeContext.Provider, { value: {} }, children);
};

// src/checkout/theme.ts
var velvetTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#2C0D4C",
  themeColorButtonEnd: "#2C0D4C",
  themeColorButtonHover: "#1C0038",
  themeColorButtonBorder: "#1C0038",
  themeColorButtonText: "#FFFFFF",
  themeColorAccent: "#B11CFF",
  themeColorAccentSecondary: "#B3C1E5",
  themeColorHeadingPrimary: "#1C2B54",
  themeColorHeadingGradientStart: "#1C2B54",
  themeColorHeadingGradientEnd: "#1C2B54",
  themeColorTextPrimary: "#000000",
  themeColorTextSecondary: "#666666",
  themeColorTextLight: "#BDBDBD",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FFFFFF",
  themeColorBgRaised: "#FAFAFA",
  themeColorBgSection: "#F6F6F9",
  themeColorBgTint: "#F1EEFB",
  themeColorBgDark: "#1A0A2E",
  themeColorBorderLight: "#F1F1F1",
  themeColorBorder: "#BDBDBD",
  themeColorSuccess: "#53A179",
  themeColorError: "#E34400",
  themeColorWarning: "#FFC438"
};
var amberTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#E14903",
  themeColorButtonEnd: "#E14903",
  themeColorButtonHover: "#BD2E00",
  themeColorButtonBorder: "#C63100",
  themeColorButtonText: "#FFFFFF",
  themeColorAccent: "#B88E4B",
  themeColorAccentSecondary: "#FFD261",
  themeColorHeadingPrimary: "#603424",
  themeColorHeadingGradientStart: "#603424",
  themeColorHeadingGradientEnd: "#45050C",
  themeColorTextPrimary: "#221F1F",
  themeColorTextSecondary: "#4F4948",
  themeColorTextLight: "#BDBDBD",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FFFFFF",
  themeColorBgRaised: "#F9F9F9",
  themeColorBgSection: "#F6F2F2",
  themeColorBgTint: "#FBF0E5",
  themeColorBgDark: "#2A1209",
  themeColorBorderLight: "#EDD7CF",
  themeColorBorder: "#BDBDBD",
  themeColorSuccess: "#53A179",
  themeColorError: "#E34400",
  themeColorWarning: "#FFD261"
};
var cobaltTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#0D40FF",
  themeColorButtonEnd: "#0D40FF",
  themeColorButtonHover: "#0D35FF",
  themeColorButtonBorder: "#0025AD",
  themeColorButtonText: "#FFFFFF",
  themeColorAccent: "#202CA3",
  themeColorAccentSecondary: "#C4A3FF",
  themeColorHeadingPrimary: "#202CA3",
  themeColorHeadingGradientStart: "#202CA3",
  themeColorHeadingGradientEnd: "#24164A",
  themeColorTextPrimary: "#333333",
  themeColorTextSecondary: "#666666",
  themeColorTextLight: "#BDBDBD",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FFFFFF",
  themeColorBgRaised: "#FAFAFA",
  themeColorBgSection: "#F4F6FF",
  themeColorBgTint: "#EDF4FE",
  themeColorBgDark: "#080C2B",
  themeColorBorderLight: "#E0E0E0",
  themeColorBorder: "#BDBDBD",
  themeColorSuccess: "#08AE30",
  themeColorError: "#EF243D",
  themeColorWarning: "#FFC438"
};
var emberTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#1C1C1C",
  themeColorButtonEnd: "#1C1C1C",
  themeColorButtonHover: "#0A0A0A",
  themeColorButtonBorder: "#0A0A0A",
  themeColorButtonText: "#FFFFFF",
  themeColorAccent: "#D4782A",
  themeColorAccentSecondary: "#F0C080",
  themeColorHeadingPrimary: "#1C1C1C",
  themeColorHeadingGradientStart: "#1C1C1C",
  themeColorHeadingGradientEnd: "#3D1A00",
  themeColorTextPrimary: "#1C1C1C",
  themeColorTextSecondary: "#5C4E42",
  themeColorTextLight: "#A89B8E",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FAFAF8",
  themeColorBgRaised: "#F5F1EB",
  themeColorBgSection: "#EDE6DB",
  themeColorBgTint: "#FDF0E0",
  themeColorBgDark: "#120C08",
  themeColorBorderLight: "#E8DDD0",
  themeColorBorder: "#C8B8A8",
  themeColorSuccess: "#2D9B6A",
  themeColorError: "#C4371A",
  themeColorWarning: "#F0A030"
};
var sageTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#2C5F3E",
  themeColorButtonEnd: "#2C5F3E",
  themeColorButtonHover: "#1F4A2E",
  themeColorButtonBorder: "#1A3F28",
  themeColorButtonText: "#FFFFFF",
  themeColorAccent: "#5A9E74",
  themeColorAccentSecondary: "#A8D4B4",
  themeColorHeadingPrimary: "#1E3D2A",
  themeColorHeadingGradientStart: "#1E3D2A",
  themeColorHeadingGradientEnd: "#1E3D2A",
  themeColorTextPrimary: "#1E2D24",
  themeColorTextSecondary: "#4A5E50",
  themeColorTextLight: "#9AB0A0",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FFFFFF",
  themeColorBgRaised: "#F6FAF7",
  themeColorBgSection: "#EBF4EE",
  themeColorBgTint: "#DFF0E6",
  themeColorBgDark: "#0C1A10",
  themeColorBorderLight: "#C8DDD2",
  themeColorBorder: "#A0BCA8",
  themeColorSuccess: "#2D9B6A",
  themeColorError: "#C0392B",
  themeColorWarning: "#E8A020"
};
var oceanTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#0077B6",
  themeColorButtonEnd: "#0096C7",
  themeColorButtonHover: "#005F94",
  themeColorButtonBorder: "#004E7A",
  themeColorButtonText: "#FFFFFF",
  themeColorAccent: "#00B4D8",
  themeColorAccentSecondary: "#90E0EF",
  themeColorHeadingPrimary: "#03045E",
  themeColorHeadingGradientStart: "#0077B6",
  themeColorHeadingGradientEnd: "#03045E",
  themeColorTextPrimary: "#03045E",
  themeColorTextSecondary: "#4A6080",
  themeColorTextLight: "#90A8C0",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FFFFFF",
  themeColorBgRaised: "#F0F8FF",
  themeColorBgSection: "#E8F4FD",
  themeColorBgTint: "#D2EEF7",
  themeColorBgDark: "#02091A",
  themeColorBorderLight: "#D0E8F4",
  themeColorBorder: "#90C8E8",
  themeColorSuccess: "#059669",
  themeColorError: "#DC2626",
  themeColorWarning: "#F59E0B"
};
var noirTheme = {
  themeFontCheckout: "Roboto, sans-serif",
  themeColorButtonPrimary: "#B8860B",
  themeColorButtonEnd: "#DAA520",
  themeColorButtonHover: "#A07800",
  themeColorButtonBorder: "#8B6914",
  themeColorButtonText: "#1A1A1A",
  themeColorAccent: "#B8860B",
  themeColorAccentSecondary: "#D4AF6A",
  themeColorHeadingPrimary: "#1A1A1A",
  themeColorHeadingGradientStart: "#2C2C2C",
  themeColorHeadingGradientEnd: "#1A1A1A",
  themeColorTextPrimary: "#1A1A1A",
  themeColorTextSecondary: "#5A5A5A",
  themeColorTextLight: "#9A9A9A",
  themeColorTextInverse: "#FFFFFF",
  themeColorBgPage: "#FFFFFF",
  themeColorBgRaised: "#F8F7F5",
  themeColorBgSection: "#F0EDEA",
  themeColorBgTint: "#FBF6EC",
  themeColorBgDark: "#0A0A08",
  themeColorBorderLight: "#E8E2D8",
  themeColorBorder: "#C8C0B0",
  themeColorSuccess: "#2E7D52",
  themeColorError: "#C0392B",
  themeColorWarning: "#C89A00"
};
function toKebabCase(str) {
  return str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").toLowerCase();
}
function convertThemeKeysToKebab(obj) {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      acc[toKebabCase(key)] = value;
      return acc;
    },
    {}
  );
}
var checkoutThemeRegistry = {
  velvet: velvetTheme,
  amber: amberTheme,
  cobalt: cobaltTheme,
  ember: emberTheme,
  sage: sageTheme,
  ocean: oceanTheme,
  noir: noirTheme
};
function getThemeVariables(theme) {
  return checkoutThemeRegistry[theme != null ? theme : "velvet"];
}
function getCheckoutThemeVariables(theme) {
  const selectedTheme = theme && theme in checkoutThemeRegistry ? checkoutThemeRegistry[theme] : void 0;
  return convertThemeKeysToKebab(selectedTheme != null ? selectedTheme : velvetTheme);
}

// src/atoms/BadgeCheckIcon.tsx
import React70 from "react";
var DEFAULT_VERIFIED_ICON_CLASS = "h-2 w-2";
var BadgeCheckIcon = ({ className, classes = {} }) => /* @__PURE__ */ React70.createElement(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 10 10",
    className: cn(DEFAULT_VERIFIED_ICON_CLASS, classes.root, className)
  },
  /* @__PURE__ */ React70.createElement(
    "path",
    {
      d: "m2.1 5.2 1.8 1.7 4-4.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  )
);

// src/atoms/BarSurface.tsx
import React71 from "react";
var DEFAULT_ROOT_CLASS5 = "min-h-[46px] rounded border border-neutral-300 px-4 py-3 text-current";
var BarSurface = ({ children, className }) => {
  return /* @__PURE__ */ React71.createElement("div", { className: cn(DEFAULT_ROOT_CLASS5, className) }, children);
};

// src/atoms/Button.tsx
import React72 from "react";
import classNames8 from "classnames";
var Button = ({
  children,
  className,
  icon,
  iconPosition = "end",
  iconClassName,
  contentClassName,
  classes = {},
  style,
  onClick,
  type = "button"
}) => {
  const buttonClass = classNames8(className, classes.button);
  const contentClass = classNames8(contentClassName, classes.content);
  const iconCls = classNames8(classes.icon, iconClassName);
  const iconNode = typeof icon === "string" ? /* @__PURE__ */ React72.createElement(Icon, { src: icon, className: iconCls }) : icon ? /* @__PURE__ */ React72.createElement("span", { className: iconCls }, icon) : null;
  const buttonContent = /* @__PURE__ */ React72.createElement(React72.Fragment, null, iconPosition === "start" && iconNode, children, iconPosition === "end" && iconNode);
  return /* @__PURE__ */ React72.createElement("button", { className: buttonClass, style, onClick, type }, contentClass ? /* @__PURE__ */ React72.createElement("span", { className: contentClass }, buttonContent) : buttonContent);
};

// src/atoms/CheckboxCheckedIcon.tsx
import React73 from "react";
var DEFAULT_ICON_CLASS3 = "block size-[16px] shrink-0";
var CheckboxCheckedIcon = ({ className }) => {
  return /* @__PURE__ */ React73.createElement(
    "svg",
    {
      className: cn(DEFAULT_ICON_CLASS3, className),
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React73.createElement("g", { clipPath: "url(#subscription-checked-icon-clip)" }, /* @__PURE__ */ React73.createElement("rect", { width: "16", height: "16", rx: "4", fill: "#333333" }), /* @__PURE__ */ React73.createElement("rect", { x: "0.4", y: "0.4", width: "15.2", height: "15.2", stroke: "#333333", strokeWidth: "0.8" }), /* @__PURE__ */ React73.createElement(
      "path",
      {
        d: "M12.8985 3.34494C12.454 3.05628 11.8295 3.14549 11.5044 3.54035L6.45957 9.69L4.78045 7.79944C4.43828 7.41547 3.81109 7.35011 3.37947 7.65304C2.94653 7.95596 2.87367 8.51487 3.21454 8.89755L6.52295 12.625L13.1166 4.584C13.4418 4.18781 13.3443 3.6336 12.8985 3.34494Z",
        fill: "white"
      }
    )),
    /* @__PURE__ */ React73.createElement("defs", null, /* @__PURE__ */ React73.createElement("clipPath", { id: "subscription-checked-icon-clip" }, /* @__PURE__ */ React73.createElement("rect", { width: "16", height: "16", rx: "4", fill: "white" })))
  );
};

// src/atoms/CheckboxUncheckedIcon.tsx
import React74 from "react";
var DEFAULT_ICON_CLASS4 = "block size-[16px] shrink-0";
var CheckboxUncheckedIcon = ({ className }) => {
  return /* @__PURE__ */ React74.createElement(
    "svg",
    {
      className: cn(DEFAULT_ICON_CLASS4, className),
      width: "16",
      height: "16",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 21",
      fill: "none",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React74.createElement("g", { clipPath: "url(#subscription-unchecked-icon-clip)" }, /* @__PURE__ */ React74.createElement("rect", { x: "0.5", y: "1", width: "19", height: "19", stroke: "#bdbdbd" })),
    /* @__PURE__ */ React74.createElement("defs", null, /* @__PURE__ */ React74.createElement("clipPath", { id: "subscription-unchecked-icon-clip" }, /* @__PURE__ */ React74.createElement("rect", { y: "0.5", width: "20", height: "20", rx: "2", fill: "white" })))
  );
};

// src/atoms/ChevronIcon.tsx
import React75 from "react";
var DEFAULT_CHEVRON_ICON_CLASS = "h-5 w-5";
var ChevronIcon = ({ direction, className, classes = {} }) => /* @__PURE__ */ React75.createElement(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    className: cn(
      DEFAULT_CHEVRON_ICON_CLASS,
      direction === "next" && "rotate-180",
      classes.root,
      className
    )
  },
  /* @__PURE__ */ React75.createElement(
    "path",
    {
      d: "M11.7 4.2 6 10l5.7 5.8",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }
  )
);

// src/atoms/CircleCheckIcon.tsx
import React76 from "react";
var DEFAULT_CHECK_ICON_CLASS = "h-full w-full text-current";
var CircleCheckIcon = ({ className, classes = {} }) => /* @__PURE__ */ React76.createElement(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    className: cn(DEFAULT_CHECK_ICON_CLASS, classes.root, className)
  },
  /* @__PURE__ */ React76.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }),
  /* @__PURE__ */ React76.createElement("path", { d: "m8.6 12.7 5.5-5.5 1.2 1.2-6.7 6.7-3.8-3.8L6 10.1l2.6 2.6Z", fill: "#ffffff" })
);

// src/atoms/ClockIcon.tsx
import React77 from "react";
var DEFAULT_ICON_CLASS5 = "block h-5 w-[19px] shrink-0";
var ClockIcon = ({ className, classes = {} }) => /* @__PURE__ */ React77.createElement(
  "svg",
  {
    className: cn(DEFAULT_ICON_CLASS5, classes.root, className),
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React77.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.5 2.083a7.917 7.917 0 1 0 0 15.834 7.917 7.917 0 0 0 0-15.834Zm3.325 11.242-4.117-2.533v-4.75h1.188v4.116l3.562 2.138-.633 1.029Z"
    }
  )
);

// src/atoms/CloseIcon.tsx
import React78 from "react";
var DEFAULT_ICON_CLASS6 = "h-[14px] w-[14px] shrink-0";
var CloseIcon = ({ className }) => /* @__PURE__ */ React78.createElement(
  "svg",
  {
    className: cn(DEFAULT_ICON_CLASS6, className),
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React78.createElement(
    "path",
    {
      d: "M7 8.238L10.094 11.332C10.436 11.674 10.99 11.674 11.332 11.332C11.674 10.99 11.674 10.436 11.332 10.094L8.237 7L11.332 3.907C11.674 3.565 11.674 3.01 11.332 2.67C10.99 2.327 10.436 2.327 10.094 2.67L7 5.763L3.907 2.67C3.565 2.327 3.01 2.327 2.67 2.67C2.327 3.01 2.327 3.565 2.67 3.907L5.763 7L2.67 10.094C2.327 10.436 2.327 10.99 2.67 11.332C3.01 11.674 3.565 11.674 3.907 11.332L7 8.238Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/DateText.tsx
import React79 from "react";
import classNames9 from "classnames";
var DEFAULT_TEXT_CLASS2 = "text-[#999] text-[12px]";
var DateText = ({ date, className, classes = {} }) => {
  const textCls = classNames9(DEFAULT_TEXT_CLASS2, className, classes.text);
  return /* @__PURE__ */ React79.createElement("span", { className: textCls }, date);
};

// src/atoms/Divider.tsx
import React80 from "react";
var VARIANT_CLASSES = {
  primary: "block h-[7px] w-[100px] rounded-full bg-[#0090CD]",
  horizontal: "block w-full border-t border-gray-200",
  vertical: "block self-stretch w-px bg-gray-200 shrink-0"
};
var Divider = ({
  variant = "primary",
  className,
  classes = {}
}) => {
  const dividerClass = cn(VARIANT_CLASSES[variant], classes.base, className);
  return /* @__PURE__ */ React80.createElement("span", { "aria-hidden": "true", className: dividerClass });
};

// src/atoms/DoubleTagIcon.tsx
import React81 from "react";
var DEFAULT_ICON_CLASS7 = "block h-[20px] w-[19px] shrink-0 text-current";
var DoubleTagIcon = ({ className, classes = {} }) => {
  return /* @__PURE__ */ React81.createElement(
    "svg",
    {
      className: cn(DEFAULT_ICON_CLASS7, classes.root, className),
      width: "19",
      height: "20",
      viewBox: "0 0 19 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React81.createElement("g", { clipPath: "url(#double-tag-icon-clip)" }, /* @__PURE__ */ React81.createElement(
      "path",
      {
        d: "M8.87458 17.1265L16.625 9.3761V11.6165L8.87458 19.3669L1.71792 12.2103L2.84208 11.094L8.87458 17.1265Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React81.createElement(
      "path",
      {
        d: "M16.625 7.65667L8.87458 15.4071L1.71792 8.25042L9.46833 0.5H16.625V7.65667ZM13.2604 2.875C12.998 2.875 12.7463 2.97926 12.5607 3.16484C12.3751 3.35043 12.2708 3.60213 12.2708 3.86458C12.2708 4.12704 12.3751 4.37874 12.5607 4.56432C12.7463 4.74991 12.998 4.85417 13.2604 4.85417C13.5229 4.85417 13.7746 4.74991 13.9602 4.56432C14.1457 4.37874 14.25 4.12704 14.25 3.86458C14.25 3.60213 14.1457 3.35043 13.9602 3.16484C13.7746 2.97926 13.5229 2.875 13.2604 2.875Z",
        fill: "currentColor"
      }
    )),
    /* @__PURE__ */ React81.createElement("defs", null, /* @__PURE__ */ React81.createElement("clipPath", { id: "double-tag-icon-clip" }, /* @__PURE__ */ React81.createElement("rect", { width: "19", height: "19", fill: "white", transform: "matrix(-1 0 0 1 19 0.5)" })))
  );
};

// src/atoms/HalfStarIcon.tsx
import React82 from "react";
var DEFAULT_HALF_STAR_ICON_CLASS = "h-4 w-4 fill-current";
var HalfStarIcon = ({ className, classes = {} }) => {
  const clipPathId = React82.useId();
  return /* @__PURE__ */ React82.createElement(
    "svg",
    {
      "aria-hidden": "true",
      viewBox: "0 0 20 20",
      className: cn(DEFAULT_HALF_STAR_ICON_CLASS, classes.root, className)
    },
    /* @__PURE__ */ React82.createElement("defs", null, /* @__PURE__ */ React82.createElement("clipPath", { id: clipPathId }, /* @__PURE__ */ React82.createElement("rect", { width: "10", height: "20" }))),
    /* @__PURE__ */ React82.createElement(
      "path",
      {
        clipPath: `url(#${clipPathId})`,
        d: "m10 1.7 2.5 5.1 5.6.8-4 4 1 5.5-5-2.6-5 2.6 1-5.5-4-4 5.5-.8L10 1.7Z"
      }
    )
  );
};

// src/atoms/Heading.tsx
import React83 from "react";
import classNames10 from "classnames";
var Heading = ({ children, className }) => {
  return /* @__PURE__ */ React83.createElement("h2", { className: classNames10(className) }, children);
};

// src/atoms/Logo.tsx
import React84 from "react";
import classNames11 from "classnames";
var Logo = ({ src, alt = "", className = "", classes = {} }) => {
  const logoClass = classNames11(className, classes.logo);
  return /* @__PURE__ */ React84.createElement("img", { src, alt, className: logoClass });
};

// src/atoms/Link.tsx
import React85 from "react";
import classNames12 from "classnames";
var Link = ({ className = "", label, href, classes = {} }) => {
  const linkClass = classNames12(className, classes.link);
  return /* @__PURE__ */ React85.createElement("a", { className: linkClass, href }, label);
};

// src/atoms/RichText.tsx
import React86 from "react";

// src/helpers/sanitizeHtml.ts
import DOMPurify from "isomorphic-dompurify";
var ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "a", "span"];
var ALLOWED_ATTR = ["href", "target", "rel"];
var ALLOWED_HEADING_TAGS = ["br", "strong", "b", "em", "i", "u", "a", "span"];
var ALLOWED_HEADING_ATTR = ["href", "target", "rel", "style"];
var HEX_COLOR_PATTERN = /^#(?:[\da-fA-F]{3}|[\da-fA-F]{4}|[\da-fA-F]{6}|[\da-fA-F]{8})$/;
var RGB_COLOR_PATTERN = /^rgba?\(\s*(?:\d{1,3}\s*,\s*){2}\d{1,3}(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)$/i;
var HSL_COLOR_PATTERN = /^hsla?\(\s*-?\d{1,3}(?:\.\d+)?(?:deg|rad|turn)?\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)$/i;
var ALLOWED_NAMED_COLORS = /* @__PURE__ */ new Set([
  "aliceblue",
  "antiquewhite",
  "aqua",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkgrey",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkslategrey",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dimgrey",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "fuchsia",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "green",
  "greenyellow",
  "grey",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightgrey",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightslategrey",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "linen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "navy",
  "oldlace",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "slategrey",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "white",
  "whitesmoke",
  "yellow",
  "yellowgreen"
]);
function isAllowedColorValue(value) {
  const normalizedValue = value.trim().toLowerCase();
  return HEX_COLOR_PATTERN.test(normalizedValue) || RGB_COLOR_PATTERN.test(normalizedValue) || HSL_COLOR_PATTERN.test(normalizedValue) || ALLOWED_NAMED_COLORS.has(normalizedValue);
}
function getSafeColorStyle(styleValue) {
  const declarations = styleValue.split(";").map((declaration) => declaration.trim()).filter(Boolean);
  for (let i = declarations.length - 1; i >= 0; i -= 1) {
    const [rawProperty, ...rawValueParts] = declarations[i].split(":");
    const property = rawProperty == null ? void 0 : rawProperty.trim().toLowerCase();
    const value = rawValueParts.join(":").trim();
    if (property !== "color" || !value || !isAllowedColorValue(value)) {
      continue;
    }
    return `color: ${value};`;
  }
  return "";
}
var linkHookRegistered = false;
if (!linkHookRegistered) {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node && node.nodeType === 1 && node.nodeName === "A" && typeof node.getAttribute === "function" && typeof node.setAttribute === "function" && typeof node.removeAttribute === "function") {
      const target = node.getAttribute("target");
      if (target === "_blank") {
        node.setAttribute("rel", "noopener noreferrer");
      } else {
        node.removeAttribute("rel");
      }
    }
    if (node && node.nodeType === 1 && typeof node.getAttribute === "function" && typeof node.setAttribute === "function" && typeof node.removeAttribute === "function") {
      const style = node.getAttribute("style");
      if (!style) {
        return;
      }
      const safeColorStyle = getSafeColorStyle(style);
      if (safeColorStyle) {
        node.setAttribute("style", safeColorStyle);
      } else {
        node.removeAttribute("style");
      }
    }
  });
  linkHookRegistered = true;
}
function sanitizeHtml(html) {
  if (!(html == null ? void 0 : html.trim())) {
    return "";
  }
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR
  });
}
function sanitizeHeadingHtml(html) {
  if (!(html == null ? void 0 : html.trim())) {
    return "";
  }
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ALLOWED_HEADING_TAGS,
    ALLOWED_ATTR: ALLOWED_HEADING_ATTR
  });
}

// src/atoms/RichText.tsx
var RichText = ({
  html,
  className = "",
  as: Component = "div"
}) => {
  const safeHtml = sanitizeHtml(html);
  if (!safeHtml) {
    return null;
  }
  return /* @__PURE__ */ React86.createElement(Component, { className: cn(className), dangerouslySetInnerHTML: { __html: safeHtml } });
};

// src/atoms/MoneyBackBadgeIcon.tsx
import React87 from "react";
var DEFAULT_ICON_CLASS8 = "block size-16 flex-none";
var MoneyBackBadgeIcon = ({ className, classes = {} }) => {
  return /* @__PURE__ */ React87.createElement(
    "svg",
    {
      className: cn(DEFAULT_ICON_CLASS8, classes.root, className),
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none"
    },
    /* @__PURE__ */ React87.createElement("g", null, /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M63.8035 32.6928L62.6145 31.413C62.3662 31.1457 62.3512 30.7365 62.5794 30.4517L63.6729 29.0869C63.9269 28.7698 63.876 28.3067 63.5592 28.0525L62.1967 26.9595C61.912 26.7312 61.8377 26.3287 62.0221 26.0136L62.9054 24.504C63.1106 24.1532 62.9929 23.7025 62.6423 23.4971L61.1354 22.6143C60.8205 22.4298 60.6885 22.0423 60.8249 21.7039L61.4792 20.0816C61.6311 19.7047 61.449 19.2759 61.0723 19.1238L59.4529 18.4699C59.1146 18.3333 58.9276 17.9692 59.0133 17.6143L59.4246 15.9141C59.52 15.5191 59.2776 15.1214 58.8828 15.0257L57.1855 14.6147C56.8309 14.5287 56.5929 14.1957 56.6261 13.8324L56.7856 12.0903C56.8227 11.6857 56.5248 11.3275 56.1203 11.2903L54.3814 11.1309C54.018 11.0976 53.7341 10.8028 53.7141 10.4384L53.6183 8.69175C53.596 8.28599 53.2493 7.97495 52.8437 7.99726L51.1002 8.09289C50.7359 8.11282 50.4121 7.86267 50.3393 7.50501L49.9904 5.7909C49.9094 5.39264 49.521 5.13554 49.123 5.21673L47.4118 5.56544C47.0543 5.63822 46.6975 5.43799 46.5734 5.09458L45.9787 3.4496C45.8407 3.06743 45.419 2.86958 45.037 3.00782L43.395 3.6021C43.0519 3.72626 42.6697 3.57998 42.4971 3.25851L41.6695 1.71758C41.4771 1.35954 41.0313 1.22533 40.6735 1.41769L39.1353 2.24494C38.814 2.41774 38.4147 2.32869 38.1969 2.03575L37.1539 0.631954C36.9116 0.305737 36.451 0.237897 36.1249 0.480366L34.7235 1.52283C34.4307 1.74062 34.0226 1.71081 33.7648 1.45262L32.5287 0.215589C32.2414 -0.0718629 31.7758 -0.0718629 31.4886 0.215589L30.2537 1.45115C29.9957 1.70935 29.5878 1.73915 29.295 1.52137L27.8921 0.477623C27.5661 0.235154 27.1055 0.302994 26.8632 0.629211L25.8213 2.03154C25.6037 2.32448 25.2043 2.41353 24.8829 2.24073L23.343 1.41257C22.9852 1.22021 22.5394 1.35442 22.347 1.71246L21.5203 3.25157C21.3477 3.57303 20.9655 3.71931 20.6225 3.59515L18.9786 3.00014C18.5966 2.8619 18.1751 3.05975 18.0369 3.44192L17.443 5.08507C17.3188 5.4283 16.962 5.62871 16.6046 5.55593L14.8915 5.20686C14.4937 5.12567 14.1053 5.38277 14.0241 5.78103L13.6755 7.4933C13.6028 7.85097 13.2789 8.1013 12.9147 8.08119L11.1691 7.98537C10.7635 7.96306 10.4169 8.2741 10.3945 8.67986L10.2989 10.4247C10.279 10.7891 9.995 11.0839 9.63166 11.1172L7.89068 11.2766C7.4862 11.3137 7.18833 11.6718 7.22545 12.0766L7.38471 13.8167C7.41799 14.1802 7.17991 14.5132 6.82536 14.5989L5.12625 15.0104C4.73146 15.106 4.48899 15.5037 4.58444 15.8987L4.99514 17.5971C5.0809 17.9518 4.89384 18.3159 4.55555 18.4527L2.93434 19.1073C2.55765 19.2594 2.37553 19.6882 2.52766 20.0651L3.1812 21.6854C3.31779 22.0239 3.18558 22.4113 2.87089 22.5958L1.36231 23.4798C1.01178 23.6851 0.894018 24.1359 1.09918 24.4866L1.98147 25.9944C2.16579 26.3095 2.09155 26.712 1.80684 26.9403L0.442909 28.0346C0.126018 28.2887 0.0751835 28.7519 0.329172 29.069L1.42156 30.4324C1.64977 30.7171 1.63477 31.1263 1.38645 31.3936L0.196235 32.6749C-0.0802451 32.9726 -0.0632394 33.4382 0.234269 33.715L1.51335 34.9047C1.78051 35.1532 1.82531 35.5602 1.6185 35.8608L0.627412 37.3019C0.397195 37.6368 0.481675 38.095 0.816303 38.3254L2.25484 39.3159C2.55527 39.5229 2.65877 39.919 2.49804 40.2467L1.7273 41.8167C1.54828 42.1815 1.69859 42.6224 2.06302 42.8016L3.63029 43.5719C3.95779 43.7328 4.11779 44.1097 4.00625 44.4573L3.47212 46.123C3.34796 46.5099 3.56099 46.9243 3.94773 47.0486L5.61045 47.5825C5.95788 47.6941 6.17091 48.0435 6.1113 48.4037L5.82513 50.1296C5.75875 50.5306 6.02956 50.9094 6.4302 50.976L8.1529 51.262C8.51276 51.3218 8.77443 51.6365 8.76785 52.0015L8.73585 53.7505C8.72835 54.1568 9.05164 54.4923 9.45777 54.4997L11.2037 54.5317C11.5685 54.5382 11.8731 54.8116 11.9196 55.1737L12.1425 56.9086C12.1942 57.3116 12.5629 57.5965 12.9657 57.5446L14.6977 57.3219C15.0596 57.2752 15.4008 57.5013 15.4995 57.8527L15.9726 59.5368C16.0825 59.9281 16.4886 60.1562 16.8796 60.0461L18.5606 59.5732C18.9118 59.4745 19.2823 59.6482 19.431 59.9815L20.1439 61.5788C20.3096 61.9498 20.7444 62.1164 21.1153 61.9505L22.7096 61.2379C23.0428 61.0891 23.4345 61.207 23.6301 61.5152L24.568 62.9915C24.786 63.3346 25.2403 63.4359 25.5832 63.2177L27.0569 62.2804C27.3648 62.0846 27.7694 62.1442 28.0079 62.4205L29.1506 63.7444C29.4161 64.0519 29.8804 64.0859 30.1879 63.8202L31.5096 62.6781C31.7857 62.4395 32.1948 62.4395 32.4709 62.6781L33.794 63.8215C34.1014 64.0872 34.5659 64.0532 34.8314 63.7456L35.9728 62.4232C36.2112 62.1469 36.6161 62.0873 36.9238 62.2832L38.3991 63.2216C38.742 63.4395 39.1964 63.3382 39.4143 62.9954L40.3511 61.5206C40.5468 61.2125 40.9386 61.0946 41.2716 61.2434L42.8678 61.9569C43.2386 62.1226 43.6734 61.9562 43.8391 61.5852L44.5513 59.9898C44.7002 59.6564 45.0707 59.4827 45.4217 59.5814L47.1048 60.0547C47.4957 60.1646 47.9018 59.9366 48.0117 59.5454L48.4842 57.8633C48.583 57.5119 48.9242 57.286 49.2861 57.3325L51.0199 57.5556C51.4227 57.6073 51.7914 57.3226 51.8431 56.9196L52.0659 55.1865C52.1123 54.8244 52.4171 54.5512 52.7819 54.5445L54.5299 54.5125C54.936 54.505 55.2591 54.1696 55.2518 53.7633L55.22 52.0163C55.2134 51.6513 55.475 51.3366 55.8349 51.2768L57.5594 50.9906C57.9601 50.9241 58.2311 50.5452 58.1645 50.1442L57.8787 48.4204C57.8191 48.0603 58.0321 47.7107 58.3796 47.5994L60.0441 47.0649C60.4308 46.9407 60.6437 46.5264 60.5197 46.1392L59.9861 44.4754C59.8746 44.1278 60.0348 43.7511 60.3621 43.59L61.9312 42.8187C62.2958 42.6395 62.4461 42.1985 62.2669 41.8339L61.4969 40.2655C61.336 39.9378 61.4395 39.5418 61.7401 39.3348L63.1803 38.3431C63.5149 38.1127 63.5994 37.6545 63.3692 37.3197L62.3792 35.8802C62.1724 35.5796 62.2172 35.1726 62.4843 34.9241L63.7649 33.7331C64.0624 33.4565 64.0799 32.9905 63.8035 32.6928Z",
        fill: "#A31547"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M54.2036 29.1001L54.934 31.3476H57.297L55.3852 32.7366L56.1154 34.9839L54.2036 33.5949L52.2919 34.9839L53.0222 32.7366L51.1104 31.3476H53.4735L54.2036 29.1001Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M9.7975 29.0996L10.5278 31.3471H12.8909L10.9791 32.7361L11.7093 34.9834L9.7975 33.5944L7.88572 34.9834L8.61587 32.7361L6.7041 31.3471H9.06735L9.7975 29.0996Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M14.468 45.3065L15.6772 46.9014L13.7055 48.3972C13.5782 48.3392 13.4442 48.2598 13.3027 48.1593C13.1611 48.0587 13.02 47.949 12.8795 47.8299C12.7387 47.7109 12.6071 47.588 12.4846 47.4615C12.3619 47.3348 12.2604 47.2187 12.1805 47.1131C12.0832 46.985 11.9927 46.84 11.9084 46.6781C11.8243 46.5161 11.7583 46.3435 11.7111 46.1597C11.6637 45.976 11.642 45.783 11.646 45.581C11.6498 45.3789 11.6902 45.1717 11.7665 44.9595C11.8427 44.7472 11.9641 44.5334 12.1302 44.3182C12.2964 44.1031 12.5169 43.8912 12.7918 43.6826C13.2098 43.3655 13.5974 43.1664 13.9544 43.0857C14.3113 43.0049 14.6399 43.008 14.9403 43.095C15.2406 43.1821 15.5145 43.332 15.7621 43.5451C16.0097 43.7581 16.2364 44.0004 16.4421 44.2719C16.5392 44.4001 16.6307 44.5402 16.7162 44.6921C16.8016 44.8441 16.8768 44.986 16.9413 45.1182C17.0059 45.2504 17.075 45.4042 17.1491 45.5799L16.4767 46.0899C16.416 45.916 16.3558 45.7642 16.296 45.6344C16.2361 45.5046 16.1646 45.3614 16.0815 45.2047C15.9983 45.048 15.9038 44.8998 15.7981 44.7605C15.6495 44.5645 15.4918 44.4034 15.3251 44.2774C15.1583 44.1514 14.9778 44.0717 14.7833 44.038C14.5887 44.0044 14.3784 44.0245 14.1524 44.098C13.9262 44.1715 13.6814 44.3083 13.4179 44.5083C13.1805 44.6883 12.9969 44.8708 12.8671 45.0555C12.7371 45.2401 12.6522 45.4217 12.6127 45.6004C12.5731 45.7788 12.5762 45.9533 12.6221 46.1233C12.668 46.2934 12.7466 46.4519 12.8581 46.5991C12.9753 46.7536 13.079 46.8769 13.1695 46.9687C13.2599 47.0605 13.3387 47.1312 13.4062 47.1812C13.4793 47.2384 13.5481 47.2784 13.6126 47.3008L14.477 46.645L13.8295 45.7911L14.4678 45.3067L14.468 45.3065Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M16.4882 51.4712C16.2428 51.2781 16.0513 51.066 15.914 50.8348C15.7767 50.6037 15.6918 50.3669 15.6595 50.125C15.6269 49.8829 15.6443 49.6426 15.7118 49.4036C15.7789 49.1648 15.8944 48.9414 16.0579 48.7331L18.0031 46.2568L18.7843 46.8709L16.769 49.4364C16.6873 49.5406 16.6202 49.6487 16.5681 49.7611C16.516 49.8734 16.4927 49.9891 16.4986 50.108C16.5044 50.2268 16.5434 50.3477 16.6154 50.4706C16.6873 50.5933 16.8071 50.7206 16.9746 50.8522C17.1419 50.9839 17.2951 51.0682 17.4345 51.1055C17.5736 51.1428 17.7022 51.1477 17.8201 51.1201C17.9379 51.0925 18.0461 51.0393 18.1443 50.9601C18.2425 50.8809 18.3325 50.7893 18.4144 50.6853L20.4079 48.1476L21.1891 48.7616L19.2438 51.2379C19.0802 51.4461 18.8913 51.6118 18.6772 51.7352C18.4628 51.8587 18.2345 51.9329 17.9916 51.9587C17.7488 51.9843 17.4999 51.9587 17.2448 51.8812C16.9898 51.8038 16.7374 51.6672 16.4884 51.4714L16.4882 51.4712Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M23.1908 53.9001L21.4655 53.1521L20.6097 54.0567L19.6201 53.6275L23.2635 49.8032L24.4027 50.2973L24.1056 55.5725L23.116 55.1434L23.1904 53.9L23.1908 53.9001ZM23.2465 52.9502C23.2624 52.6995 23.2758 52.481 23.2866 52.295C23.2976 52.1091 23.3089 51.913 23.321 51.7069C23.3328 51.5009 23.3431 51.3222 23.3519 51.1714L22.7327 51.8152C22.6566 51.8957 22.5809 51.975 22.506 52.0531C22.4308 52.1314 22.3648 52.2007 22.3078 52.261C22.2507 52.3213 22.1882 52.3883 22.1203 52.4618L23.2465 52.9502Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M29.2306 56.6384L28.1354 56.4342L27.9242 54.699C27.9085 54.6288 27.8867 54.5646 27.859 54.5065C27.8295 54.4577 27.7939 54.4103 27.752 54.3638C27.7101 54.3176 27.6496 54.287 27.5706 54.2722L26.9986 54.1656L26.6287 56.1533L25.6592 55.9724L26.5663 51.0977L27.9544 51.3566C28.2055 51.4034 28.4399 51.4689 28.6577 51.5526C28.8755 51.6365 29.059 51.7477 29.209 51.8863C29.3587 52.0249 29.4655 52.1952 29.529 52.397C29.5924 52.5989 29.5974 52.8439 29.5438 53.1323C29.516 53.2811 29.4701 53.4048 29.4061 53.5035C29.3419 53.6022 29.269 53.6836 29.1874 53.7478C29.1057 53.812 29.0208 53.861 28.9327 53.8952C28.8446 53.9292 28.7641 53.9539 28.6915 53.9692C28.6189 53.9846 28.5363 53.9956 28.4435 54.0023C28.5597 54.0239 28.6524 54.0691 28.7217 54.1371C28.7908 54.2053 28.8436 54.2766 28.8804 54.3507C28.9171 54.4249 28.944 54.5189 28.9614 54.6328L29.2306 56.6386V56.6384ZM27.5468 53.4307C27.6584 53.4516 27.7681 53.4636 27.8756 53.4667C27.9833 53.47 28.082 53.456 28.1722 53.4247C28.2622 53.3934 28.3408 53.3395 28.4079 53.263C28.475 53.1866 28.5213 53.0809 28.5463 52.9462C28.5714 52.8114 28.5699 52.6969 28.5417 52.6026C28.5134 52.5084 28.4644 52.4294 28.3945 52.3658C28.3245 52.3021 28.2376 52.2524 28.1338 52.216C28.0297 52.1798 27.9151 52.15 27.7896 52.1266L27.3921 52.0524L27.1495 53.3565L27.547 53.4305L27.5468 53.4307Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M33.8405 55.442L31.9628 55.5345L31.5956 56.7245L30.5186 56.7776L32.0944 51.7349L33.3346 51.6738L35.401 56.5369L34.324 56.5899L33.8409 55.4418L33.8405 55.442ZM33.4704 54.5652C33.3737 54.3331 33.289 54.1314 33.2166 53.9597C33.1442 53.7882 33.0678 53.6072 32.9873 53.417C32.9069 53.2268 32.8372 53.0621 32.7781 52.9229L32.5077 53.7745C32.4749 53.8804 32.4422 53.985 32.4095 54.0883C32.3766 54.1918 32.348 54.283 32.3235 54.3624C32.299 54.4417 32.2725 54.5295 32.2442 54.6255L33.4701 54.5652H33.4704Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M40.9893 54.9791L39.7424 55.3655L36.8984 52.3472L38.0009 55.9051L37.0996 56.1843L35.6318 51.4474L36.8787 51.061L39.7206 54.0725L38.6204 50.5214L39.5217 50.2422L40.9895 54.9791H40.9893Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M43.3127 48.0952L43.7007 48.7641L42.4736 49.4763L44.5739 53.0969L43.7208 53.5919L41.6205 49.9713L40.3872 50.687L39.9991 50.0181L43.3127 48.0952Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M47.2944 50.1546L48.7386 48.8746L49.2606 49.4641L47.0731 51.403L43.7852 47.6908L45.9727 45.752L46.3728 46.4497L45.0507 47.6215L45.8551 48.5296L47.1772 47.3578L47.6992 47.9473L46.3772 49.1191L47.2944 50.1546Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M50.5656 46.7282L51.7262 45.1862L52.355 45.6599L50.597 47.9956L46.6367 45.0119L48.3949 42.6763L48.9255 43.2804L47.863 44.6919L48.8317 45.4219L49.8943 44.0104L50.5232 44.4842L49.4606 45.8956L50.5654 46.728L50.5656 46.7282Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M13.1289 16.1262L17.1884 18.8434L16.6714 19.616L13.3902 17.4195L15.9137 20.7486L15.424 21.4806L11.385 20.4169L14.6662 22.6134L14.1493 23.386L10.0898 20.6687L10.9138 19.4372L14.6583 20.4383L12.305 17.3575L13.1289 16.126V16.1262Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M16.4876 12.9375C16.6794 12.7821 16.9067 12.6444 17.1691 12.5244C17.4316 12.4047 17.7136 12.3438 18.0153 12.3423C18.3169 12.3408 18.6316 12.4186 18.9596 12.5756C19.2875 12.7327 19.6115 13.0085 19.9309 13.4032C20.2535 13.8015 20.4568 14.1767 20.5408 14.5284C20.6247 14.8802 20.6333 15.2016 20.5664 15.4928C20.4994 15.784 20.3795 16.0446 20.2063 16.275C20.0332 16.5054 19.8507 16.6983 19.6588 16.8538C19.467 17.0094 19.2407 17.1478 18.9795 17.2696C18.7184 17.3914 18.4377 17.4555 18.1373 17.4619C17.8369 17.4685 17.5234 17.3943 17.1969 17.239C16.8703 17.084 16.5459 16.8071 16.2231 16.4089C15.9035 16.0143 15.7009 15.6401 15.6155 15.2865C15.5299 14.933 15.5202 14.6081 15.5859 14.3117C15.6517 14.0154 15.7704 13.7512 15.9421 13.519C16.1138 13.2869 16.2956 13.0931 16.4874 12.9375H16.4876ZM19.1796 16.2615C19.3315 16.1382 19.4508 15.9967 19.5371 15.8367C19.6234 15.6767 19.6689 15.5035 19.6735 15.3167C19.678 15.13 19.6371 14.9294 19.5502 14.7149C19.4634 14.5004 19.3248 14.2755 19.134 14.04C18.9494 13.8117 18.761 13.6331 18.5692 13.5036C18.3774 13.3742 18.189 13.2915 18.004 13.2555C17.8189 13.2197 17.6386 13.2264 17.4629 13.2758C17.2872 13.3253 17.1233 13.4117 16.9714 13.5349C16.8194 13.6581 16.7009 13.8006 16.6161 13.9624C16.5313 14.1242 16.487 14.3009 16.4835 14.4927C16.4801 14.6845 16.5208 14.8868 16.6062 15.0994C16.6916 15.3123 16.8282 15.5344 17.0158 15.7661C17.2065 16.0015 17.3969 16.183 17.5873 16.3107C17.7776 16.4385 17.9654 16.5186 18.1506 16.5511C18.3361 16.5839 18.5158 16.5745 18.6901 16.5233C18.8643 16.472 19.0274 16.3847 19.1796 16.2615Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M25.8037 13.293L24.6309 13.8194L21.4918 11.2056L22.9927 14.5545L22.1447 14.935L20.1465 10.4762L21.3193 9.94978L24.4555 12.5571L22.9575 9.21451L23.8055 8.83398L25.8037 13.2928V13.293Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M27.6218 12.0889L29.4851 11.7157L29.6373 12.4765L26.8149 13.0417L25.8574 8.24978L28.6798 7.68457L28.6743 8.47707L26.9686 8.81865L27.2029 9.99095L28.9086 9.64937L29.0605 10.4102L27.3548 10.7518L27.622 12.0887L27.6218 12.0889Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M31.843 10.5L30.1797 7.5918L31.1856 7.60825L32.3606 9.62736L33.5953 7.64775L34.6081 7.66439L32.7929 10.5155L32.7614 12.403L31.8115 12.3874L31.843 10.5Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M40.823 12.7728C40.7326 13.0277 40.6024 13.2239 40.4326 13.3614C40.2627 13.4991 40.0709 13.5905 39.8571 13.6357C39.6433 13.6811 39.4137 13.6875 39.1685 13.6547C38.9231 13.6222 38.6819 13.5637 38.4449 13.4796L37.1084 13.0054L38.7422 8.39941L40.1709 8.90629C40.3947 8.98565 40.5986 9.08275 40.7829 9.19759C40.9671 9.31242 41.1157 9.44682 41.2291 9.60079C41.3425 9.75475 41.4145 9.93121 41.4452 10.13C41.4759 10.3289 41.4507 10.5498 41.3693 10.793L41.367 10.7996C41.2905 11.0148 41.1823 11.167 41.0422 11.2556C40.902 11.3443 40.7639 11.3994 40.628 11.4202C40.4655 11.4467 40.2969 11.4412 40.1224 11.4039C40.3121 11.4961 40.4697 11.6087 40.5953 11.7424C40.7036 11.855 40.7895 11.9957 40.8533 12.1641C40.9169 12.3327 40.9084 12.5311 40.8273 12.7595L40.8226 12.7726L40.823 12.7728ZM38.9216 12.8253C39.0182 12.8595 39.1156 12.8805 39.2144 12.8884C39.3127 12.8962 39.4065 12.886 39.4956 12.8584C39.5845 12.8306 39.6635 12.782 39.7326 12.7125C39.8017 12.643 39.8573 12.549 39.8993 12.4303C39.9414 12.3116 39.9568 12.2021 39.9454 12.1017C39.9341 12.0013 39.9015 11.9117 39.848 11.8335C39.7942 11.755 39.7233 11.6866 39.6355 11.6283C39.5475 11.57 39.4508 11.5221 39.3455 11.4846L38.7662 11.279L38.2964 12.6035L38.9218 12.8253H38.9216ZM39.0092 10.5937L39.5951 10.8016C39.6741 10.8296 39.7565 10.8477 39.8427 10.8561C39.9286 10.8643 40.0105 10.8563 40.0884 10.832C40.1661 10.8076 40.2365 10.7658 40.2996 10.7065C40.3625 10.6473 40.4121 10.5672 40.4479 10.4661C40.4854 10.3606 40.4982 10.2651 40.4867 10.1793C40.475 10.0936 40.4463 10.0179 40.4006 9.95224C40.3547 9.88659 40.2925 9.82863 40.2139 9.77852C40.1352 9.72842 40.0498 9.68691 39.9577 9.65436L39.4113 9.46053L39.0092 10.5939V10.5937Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M44.0558 15.0534L42.4983 14.0528L41.5223 14.7971L40.6289 14.2233L44.7796 11.0811L45.8082 11.7417L44.6785 16.8246L43.785 16.2508L44.0557 15.0534H44.0558ZM44.2614 14.1384C44.3168 13.8971 44.3645 13.6868 44.4049 13.5076C44.4451 13.3286 44.4876 13.1397 44.532 12.9411C44.5764 12.7425 44.6148 12.5706 44.6474 12.4252L43.943 12.9533C43.8562 13.0195 43.77 13.0846 43.6846 13.1488C43.5991 13.213 43.5239 13.2699 43.4588 13.3196C43.3937 13.3691 43.3222 13.4244 43.2445 13.4853L44.2614 14.1384Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M50.0727 15.3134C50.1961 15.4403 50.3029 15.5685 50.3934 15.6981C50.4837 15.8278 50.5594 15.9475 50.6207 16.0571C50.6915 16.1832 50.7524 16.3027 50.8036 16.4155L50.2577 16.947C50.1778 16.7647 50.0824 16.5864 49.971 16.4118C49.8598 16.2374 49.7342 16.0832 49.5945 15.9497C49.4546 15.8161 49.3028 15.7087 49.1394 15.6274C48.9757 15.5462 48.8 15.5059 48.6124 15.5069C48.4246 15.5078 48.2255 15.557 48.015 15.6548C47.8043 15.7526 47.5856 15.9121 47.3587 16.1331C47.1283 16.3575 46.9614 16.5736 46.8582 16.7816C46.7549 16.9895 46.6993 17.188 46.6918 17.3775C46.6841 17.5669 46.7189 17.7445 46.7957 17.9103C46.8723 18.076 46.9775 18.2291 47.1106 18.3693C47.2437 18.5094 47.3977 18.6359 47.5723 18.7485C47.7469 18.8614 47.9276 18.9566 48.1143 19.0349L47.5633 19.5714C47.4454 19.5237 47.3243 19.4628 47.2002 19.3887C47.089 19.3278 46.9698 19.2505 46.8427 19.1567C46.7154 19.0627 46.5902 18.9523 46.4667 18.8255C46.3563 18.712 46.2502 18.5812 46.1484 18.4333C46.0467 18.2852 45.9615 18.1245 45.8931 17.9506C45.8245 17.7767 45.7803 17.5907 45.76 17.3927C45.7395 17.1946 45.754 16.9873 45.8031 16.7704C45.8521 16.5535 45.9443 16.3306 46.0791 16.1017C46.214 15.8728 46.4033 15.6396 46.647 15.4023C46.8875 15.1682 47.1237 14.9868 47.3561 14.8579C47.5884 14.7292 47.8137 14.643 48.0316 14.5999C48.2496 14.5565 48.4571 14.5478 48.6546 14.5734C48.8517 14.599 49.0373 14.6476 49.2109 14.7191C49.3844 14.7906 49.5437 14.8791 49.689 14.9848C49.8342 15.0905 49.9619 15.2 50.0725 15.3136L50.0727 15.3134Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M49.8913 23.5896L49.3184 22.6623L50.3207 20.3746L50.0672 19.9644L48.3195 21.0457L47.8311 20.2552L51.9865 17.6846L52.4749 18.4751L50.7271 19.5563L50.9842 19.9723L53.4371 20.0323L54.0173 20.9714L51.0455 20.8297L49.8913 23.5896Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M32.0009 49.3352C41.5456 49.3352 49.2831 41.5927 49.2831 32.0419C49.2831 22.491 41.5456 14.7485 32.0009 14.7485C22.4563 14.7485 14.7188 22.491 14.7188 32.0419C14.7188 41.5927 22.4563 49.3352 32.0009 49.3352Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M32.0006 4.89961C33.8416 4.89961 35.6811 5.08521 37.468 5.45111C39.209 5.8075 40.9215 6.33961 42.558 7.03209C44.165 7.71214 45.7151 8.55401 47.1649 9.53431C48.6015 10.5055 49.9522 11.6207 51.1799 12.8491C52.4076 14.0776 53.5221 15.4294 54.4928 16.8669C55.4723 18.3179 56.3138 19.8688 56.9935 21.4771C57.6856 23.1146 58.2174 24.8283 58.5736 26.5706C58.9393 28.3587 59.1247 30.1995 59.1247 32.042C59.1247 33.8845 58.9393 35.7251 58.5736 37.5135C58.2174 39.2557 57.6856 40.9695 56.9935 42.6069C56.3138 44.215 55.4725 45.7662 54.4928 47.2171C53.5223 48.6546 52.4076 50.0063 51.1799 51.2349C49.9522 52.4633 48.6013 53.5787 47.1649 54.5497C45.7149 55.53 44.165 56.3719 42.558 57.0519C40.9216 57.7446 39.2092 58.2765 37.468 58.6329C35.6811 58.9988 33.8416 59.1844 32.0006 59.1844C30.1596 59.1844 28.32 58.9988 26.5332 58.6329C24.7922 58.2763 23.0797 57.7444 21.4432 57.0519C19.8362 56.3719 18.2861 55.53 16.8363 54.5497C15.3997 53.5786 14.049 52.4633 12.8213 51.2349C11.5936 50.0064 10.479 48.6546 9.50843 47.2171C8.52887 45.7662 7.68736 44.2152 7.00768 42.6069C6.31557 40.9693 5.78382 39.2557 5.42761 37.5135C5.0619 35.7253 4.87648 33.8845 4.87648 32.042C4.87648 30.1995 5.0619 28.3589 5.42761 26.5706C5.78382 24.8283 6.31557 23.1146 7.00768 21.4771C7.68736 19.869 8.52869 18.3179 9.50843 16.8669C10.4789 15.4294 11.5936 14.0778 12.8213 12.8491C14.049 11.6207 15.3997 10.5053 16.8363 9.53431C18.2863 8.55401 19.8362 7.71214 21.4432 7.03209C23.0795 6.33943 24.792 5.8075 26.5332 5.45111C28.32 5.08521 30.1596 4.89961 32.0006 4.89961ZM32.0006 3.83301C16.4312 3.83301 3.80969 16.4626 3.80969 32.042C3.80969 47.6214 16.4312 60.251 32.0006 60.251C47.57 60.251 60.1915 47.6214 60.1915 32.042C60.1915 16.4626 47.57 3.83301 32.0006 3.83301Z",
        fill: "white"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M21.5163 37.3292H19.6813V28.6281H17.8213V27.132L21.5163 26.7544V37.3294V37.3292Z",
        fill: "#A31547"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M29.2444 33.2109C29.2444 34.6103 28.9668 35.672 28.4119 36.3958C27.8567 37.1197 27.1057 37.4816 26.1591 37.4816C25.2124 37.4816 24.4477 37.1197 23.8905 36.3958C23.3334 35.672 23.0547 34.6103 23.0547 33.2109V30.8795C23.0547 29.485 23.3323 28.4236 23.8874 27.6947C24.4424 26.966 25.1954 26.6016 26.1464 26.6016C27.0975 26.6016 27.8463 26.966 28.4056 27.6947C28.965 28.4236 29.2446 29.485 29.2446 30.8795V33.2109H29.2444ZM27.4158 30.6593C27.4158 29.8226 27.3068 29.2093 27.0891 28.8198C26.8711 28.4305 26.5569 28.2358 26.1464 28.2358C25.7359 28.2358 25.4176 28.4292 25.2038 28.8161C24.9902 29.2031 24.8833 29.8175 24.8833 30.6592V33.4092C24.8833 34.2607 24.9911 34.8799 25.2069 35.2668C25.4227 35.6537 25.7399 35.8474 26.1589 35.8474C26.5778 35.8474 26.8815 35.6539 27.0953 35.2668C27.3089 34.8799 27.4158 34.2607 27.4158 33.4092V30.6592V30.6593Z",
        fill: "#A31547"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M36.6282 33.2109C36.6282 34.6103 36.3506 35.672 35.7956 36.3958C35.2405 37.1197 34.4895 37.4816 33.5428 37.4816C32.5962 37.4816 31.8315 37.1197 31.2743 36.3958C30.7172 35.672 30.4385 34.6103 30.4385 33.2109V30.8795C30.4385 29.485 30.7161 28.4236 31.2712 27.6947C31.8262 26.966 32.5792 26.6016 33.5302 26.6016C34.4813 26.6016 35.2301 26.966 35.7894 27.6947C36.3488 28.4236 36.6284 29.485 36.6284 30.8795V33.2109H36.6282ZM34.7994 30.6593C34.7994 29.8226 34.6905 29.2093 34.4727 28.8198C34.2549 28.4305 33.9406 28.2358 33.53 28.2358C33.1195 28.2358 32.8012 28.4292 32.5874 28.8161C32.3738 29.2031 32.2669 29.8175 32.2669 30.6592V33.4092C32.2669 34.2607 32.3748 34.8799 32.5905 35.2668C32.8063 35.6537 33.1236 35.8474 33.5425 35.8474C33.9614 35.8474 34.2651 35.6539 34.4789 35.2668C34.6925 34.8799 34.7993 34.2607 34.7993 33.4092V30.6592L34.7994 30.6593Z",
        fill: "#A31547"
      }
    ), /* @__PURE__ */ React87.createElement(
      "path",
      {
        d: "M37.8223 28.7878C37.8223 28.1632 37.9971 27.6428 38.3471 27.2262C38.6969 26.8098 39.1838 26.6016 39.8081 26.6016C40.4324 26.6016 40.9308 26.8086 41.2786 27.2225C41.6262 27.6365 41.8001 28.1584 41.8001 28.7878V29.347C41.8001 29.9716 41.6262 30.4898 41.2786 30.9013C40.9308 31.3129 40.445 31.5186 39.8207 31.5186C39.1964 31.5186 38.7022 31.3129 38.3502 30.9013C37.9982 30.4898 37.8223 29.9716 37.8223 29.347V28.7878ZM39.0414 29.347C39.0414 29.6278 39.1083 29.8639 39.2425 30.0552C39.3766 30.2465 39.5693 30.3421 39.8207 30.3421C40.0721 30.3421 40.2512 30.2465 40.3832 30.0552C40.5152 29.8639 40.5812 29.6278 40.5812 29.347V28.7878C40.5812 28.5071 40.5141 28.2685 40.3801 28.0725C40.2459 27.8764 40.0553 27.7782 39.8083 27.7782C39.5612 27.7782 39.3716 27.8763 39.2396 28.0725C39.1076 28.2685 39.0416 28.5071 39.0416 28.7878V29.347H39.0414ZM40.1222 36.5373L39.2299 35.9926L43.6978 27.7272L44.5902 28.272L40.1222 36.5373ZM42.196 34.736C42.196 34.1163 42.3719 33.5982 42.7239 33.1817C43.0758 32.7653 43.5638 32.557 44.1881 32.557C44.8123 32.557 45.3055 32.764 45.6553 33.178C46.0051 33.592 46.1801 34.1113 46.1801 34.736V35.2951C46.1801 35.9247 46.0062 36.4451 45.6586 36.8567C45.3108 37.2684 44.825 37.4741 44.2007 37.4741C43.5764 37.4741 43.0811 37.2671 42.727 36.8531C42.373 36.4391 42.196 35.9198 42.196 35.2951V34.736ZM43.4151 35.2951C43.4151 35.5711 43.4874 35.8071 43.632 36.0033C43.7765 36.1996 43.9661 36.2976 44.2007 36.2976C44.473 36.2976 44.6677 36.2069 44.7851 36.0253C44.9023 35.8437 44.961 35.6003 44.961 35.2953V34.7361C44.961 34.4602 44.8939 34.2241 44.7599 34.0279C44.6257 33.8319 44.4351 33.7337 44.1881 33.7337C43.941 33.7337 43.745 33.8317 43.613 34.0279C43.481 34.2241 43.4151 34.46 43.4151 34.7361V35.2953V35.2951Z",
        fill: "#A31547"
      }
    ))
  );
};

// src/atoms/QuestionMarkCircleIcon.tsx
import React88 from "react";
var DEFAULT_ICON_CLASS9 = "h-[14px] w-[14px] shrink-0";
var QuestionMarkCircleIcon = ({ className }) => /* @__PURE__ */ React88.createElement(
  "svg",
  {
    className: cn(DEFAULT_ICON_CLASS9, className),
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React88.createElement(
    "path",
    {
      d: "M7 1.167C3.779 1.167 1.167 3.779 1.167 7C1.167 10.221 3.779 12.833 7 12.833C10.221 12.833 12.833 10.221 12.833 7C12.833 3.779 10.221 1.167 7 1.167ZM7 11.667C4.427 11.667 2.333 9.573 2.333 7C2.333 4.427 4.427 2.333 7 2.333C9.573 2.333 11.667 4.427 11.667 7C11.667 9.573 9.573 11.667 7 11.667ZM7 9.333C6.678 9.333 6.417 9.594 6.417 9.917C6.417 10.239 6.678 10.5 7 10.5C7.322 10.5 7.583 10.239 7.583 9.917C7.583 9.594 7.322 9.333 7 9.333ZM7 3.792C5.834 3.792 4.885 4.741 4.885 5.906C4.885 6.228 5.146 6.49 5.469 6.49C5.791 6.49 6.052 6.228 6.052 5.906C6.052 5.384 6.477 4.958 7 4.958C7.523 4.958 7.948 5.384 7.948 5.906C7.948 6.302 7.705 6.489 7.246 6.674C6.794 6.855 6.417 7.241 6.417 7.875V8.167C6.417 8.489 6.678 8.75 7 8.75C7.322 8.75 7.583 8.489 7.583 8.167V7.975C7.583 7.78 7.621 7.711 7.681 7.666C7.749 7.615 7.877 7.555 8.039 7.489C8.532 7.291 9.115 6.888 9.115 5.906C9.115 4.741 8.166 3.792 7 3.792Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/ScoreBar.tsx
import React89 from "react";
var DEFAULT_CONTAINER_CLASS3 = "relative block h-3 overflow-hidden rounded-[100px] bg-[#E5EEF7]";
var DEFAULT_FILL_CLASS = "absolute inset-y-0 left-0 block w-[var(--score-bar-width)] rounded-r-[100px] bg-[#3E82AB]";
var ScoreBar = ({ percent = 0, className, classes = {} }) => {
  const clampedPercent = Math.max(0, Math.min(100, percent));
  const containerClass = cn(DEFAULT_CONTAINER_CLASS3, className, classes.container);
  const fillClass = cn(DEFAULT_FILL_CLASS, classes.fill);
  return /* @__PURE__ */ React89.createElement(
    "span",
    {
      "aria-hidden": "true",
      className: containerClass,
      style: { "--score-bar-width": `${clampedPercent}%` }
    },
    /* @__PURE__ */ React89.createElement("span", { className: fillClass })
  );
};

// src/atoms/SelectableRadio.tsx
import React90 from "react";
var DEFAULT_WRAPPER_CLASS = "flex w-[18px] shrink-0 justify-center lg:w-[22px]";
var DEFAULT_INDICATOR_CLASS = "flex size-[16px] items-center justify-center rounded-full border border-current/30 bg-white before:block before:size-[7px] before:scale-0 before:rounded-full before:bg-current before:opacity-70 before:transition-transform before:duration-100 before:ease-out lg:size-[20px] lg:before:size-[10px]";
var DEFAULT_INDICATOR_ACTIVE_CLASS = "border-2 border-current before:scale-100";
var SelectableRadio = ({
  isActive = false,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React90.createElement("div", { className: cn(DEFAULT_WRAPPER_CLASS, classes.wrapper) }, /* @__PURE__ */ React90.createElement(
    "span",
    {
      className: cn(
        DEFAULT_INDICATOR_CLASS,
        isActive && DEFAULT_INDICATOR_ACTIVE_CLASS,
        isActive && classes.active,
        classes.indicator,
        className
      )
    }
  ));
};

// src/atoms/ShoppingBagIcon.tsx
import React91 from "react";
var DEFAULT_ICON_CLASS10 = "block size-6";
var ShoppingBagIcon = ({ className, classes = {} }) => {
  const rootClassName = cn(DEFAULT_ICON_CLASS10, classes.root, className);
  return /* @__PURE__ */ React91.createElement(
    "svg",
    {
      className: rootClassName,
      width: "24",
      height: "24",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React91.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.44794 4.95874H4.17192C3.29018 4.95874 2.55828 5.64022 2.49537 6.52003L1.67223 18.046C1.63909 18.5114 1.80045 18.9695 2.11837 19.311C2.43678 19.6524 2.88197 19.8465 3.34877 19.8465H16.6536C17.1204 19.8465 17.5656 19.6524 17.884 19.311C18.2019 18.9695 18.3633 18.5114 18.3301 18.046L17.507 6.52003C17.4441 5.64022 16.7122 4.95874 15.8304 4.95874H14.5635V4.71861C14.5635 2.19875 12.521 0.15625 10.0012 0.15625C7.57352 0.15625 5.3298 2.08973 5.43881 4.71861C5.44218 4.79834 5.44506 4.87854 5.44794 4.95874ZM14.5635 6.39949V10.0014C14.5635 10.399 14.2408 10.7217 13.8432 10.7217C13.4455 10.7217 13.1228 10.399 13.1228 10.0014V6.39949H6.87956V10.0014C6.87956 10.399 6.55683 10.7217 6.15919 10.7217C5.76154 10.7217 5.43881 10.399 5.43881 10.0014C5.43881 10.0014 5.50125 8.31808 5.4806 6.39949H4.17192C4.04609 6.39949 3.9414 6.49697 3.93276 6.62232L3.10912 18.1483C3.10432 18.215 3.12738 18.2804 3.173 18.3294C3.21863 18.3779 3.28202 18.4057 3.34877 18.4057H16.6536C16.7203 18.4057 16.7837 18.3779 16.8294 18.3294C16.875 18.2804 16.898 18.215 16.8932 18.1483L16.0696 6.62232C16.061 6.49697 15.9563 6.39949 15.8304 6.39949H14.5635ZM13.1228 4.95874V4.71861C13.1228 2.99452 11.7253 1.597 10.0012 1.597C8.27709 1.597 6.87956 2.99452 6.87956 4.71861V4.95874H13.1228Z",
        fill: "currentColor"
      }
    )
  );
};

// src/atoms/StarIcon.tsx
import React92 from "react";
var DEFAULT_STAR_ICON_CLASS = "h-4 w-4 fill-current";
var StarIcon = ({ className, classes = {} }) => /* @__PURE__ */ React92.createElement(
  "svg",
  {
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    className: cn(DEFAULT_STAR_ICON_CLASS, classes.root, className)
  },
  /* @__PURE__ */ React92.createElement("path", { d: "m10 1.7 2.5 5.1 5.6.8-4 4 1 5.5-5-2.6-5 2.6 1-5.5-4-4 5.5-.8L10 1.7Z" })
);

// src/atoms/TruckIcon.tsx
import React93 from "react";
var DEFAULT_ICON_CLASS11 = "block h-5 w-[19px] shrink-0";
var TruckIcon = ({ className, classes = {} }) => /* @__PURE__ */ React93.createElement(
  "svg",
  {
    className: cn(DEFAULT_ICON_CLASS11, classes.root, className),
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React93.createElement(
    "path",
    {
      d: "M17.7591 9.7625L16.4469 6.79375C16.4009 6.68847 16.3254 6.59877 16.2295 6.53554C16.1336 6.4723 16.0214 6.43825 15.9066 6.4375H12.73L12.92 4.72156C12.9293 4.63826 12.921 4.55393 12.8954 4.47411C12.8698 4.39428 12.8276 4.32078 12.7716 4.25844C12.716 4.19693 12.6483 4.14772 12.5726 4.11398C12.4969 4.08023 12.415 4.0627 12.3322 4.0625H4.15625C3.99878 4.0625 3.84775 4.12506 3.73641 4.23641C3.62506 4.34776 3.5625 4.49878 3.5625 4.65625C3.5625 4.81372 3.62506 4.96474 3.73641 5.07609C3.84775 5.18744 3.99878 5.25 4.15625 5.25H7.125C7.28247 5.25 7.43349 5.31256 7.54484 5.42391C7.65619 5.53526 7.71875 5.68628 7.71875 5.84375C7.71875 6.00122 7.65619 6.15224 7.54484 6.26359C7.43349 6.37494 7.28247 6.4375 7.125 6.4375H2.96875C2.81128 6.4375 2.66026 6.50006 2.54891 6.61141C2.43756 6.72276 2.375 6.87378 2.375 7.03125C2.375 7.18872 2.43756 7.33974 2.54891 7.45109C2.66026 7.56244 2.81128 7.625 2.96875 7.625H8.90625C9.06372 7.625 9.21474 7.68756 9.32609 7.79891C9.43744 7.91026 9.5 8.06128 9.5 8.21875C9.5 8.37622 9.43744 8.52725 9.32609 8.63859C9.21474 8.74994 9.06372 8.8125 8.90625 8.8125H4.75C4.59253 8.8125 4.4415 8.87506 4.33016 8.98641C4.21881 9.09775 4.15625 9.24878 4.15625 9.40625C4.15625 9.56372 4.21881 9.71475 4.33016 9.82609C4.4415 9.93744 4.59253 10 4.75 10H7.125C7.28247 10 7.43349 10.0626 7.54484 10.1739C7.65619 10.2853 7.71875 10.4363 7.71875 10.5938C7.71875 10.7512 7.65619 10.9022 7.54484 11.0136C7.43349 11.1249 7.28247 11.1875 7.125 11.1875H2.375C2.21753 11.1875 2.06651 11.2501 1.95516 11.3614C1.84381 11.4728 1.78125 11.6238 1.78125 11.7812C1.78125 11.9387 1.84381 12.0897 1.95516 12.2011C2.06651 12.3124 2.21753 12.375 2.375 12.375H3.5625C3.71997 12.375 3.87099 12.4376 3.98234 12.5489C4.09369 12.6603 4.15625 12.8113 4.15625 12.9688C4.15625 13.1262 4.09369 13.2772 3.98234 13.3886C3.87099 13.4999 3.71997 13.5625 3.5625 13.5625H2.96875C2.81128 13.5625 2.66026 13.6251 2.54891 13.7364C2.43756 13.8478 2.375 13.9988 2.375 14.1562C2.375 14.3137 2.43756 14.4647 2.54891 14.5761C2.66026 14.6874 2.81128 14.75 2.96875 14.75H4.66094C4.72505 15.0004 4.84708 15.2323 5.01719 15.4269C5.16134 15.588 5.33798 15.7169 5.53549 15.8049C5.73299 15.8929 5.9469 15.9381 6.16312 15.9375C6.52902 15.927 6.88368 15.8088 7.18262 15.5975C7.48155 15.3863 7.71143 15.0914 7.84344 14.75H12.3797C12.4438 15.0004 12.5658 15.2323 12.7359 15.4269C12.8801 15.588 13.0567 15.7169 13.2542 15.8049C13.4517 15.8929 13.6656 15.9381 13.8819 15.9375C14.2478 15.927 14.6024 15.8088 14.9014 15.5975C15.2003 15.3863 15.4302 15.0914 15.5622 14.75H16.7497C16.8965 14.7509 17.0384 14.6974 17.148 14.5998C17.2577 14.5022 17.3273 14.3675 17.3434 14.2216L17.8006 10.0653C17.8169 9.96248 17.8024 9.85714 17.7591 9.7625ZM6.16312 14.75C6.11389 14.7521 6.06481 14.7431 6.01957 14.7235C5.97432 14.704 5.93409 14.6745 5.90187 14.6372C5.85527 14.5795 5.82117 14.5128 5.80174 14.4412C5.78232 14.3697 5.778 14.2949 5.78906 14.2216C5.80423 14.0549 5.8762 13.8984 5.99294 13.7784C6.10967 13.6585 6.26408 13.5822 6.43031 13.5625C6.47955 13.5604 6.52863 13.5694 6.57387 13.589C6.61912 13.6085 6.65935 13.638 6.69156 13.6753C6.73817 13.733 6.77227 13.7997 6.79169 13.8713C6.81111 13.9428 6.81543 14.0176 6.80437 14.0909C6.78921 14.2576 6.71723 14.4141 6.6005 14.5341C6.48376 14.654 6.32936 14.7303 6.16312 14.75ZM13.8819 14.75C13.8326 14.7521 13.7836 14.7431 13.7383 14.7235C13.6931 14.704 13.6528 14.6745 13.6206 14.6372C13.574 14.5795 13.5399 14.5128 13.5205 14.4412C13.5011 14.3697 13.4968 14.2949 13.5078 14.2216C13.523 14.0549 13.595 13.8984 13.7117 13.7784C13.8284 13.6585 13.9828 13.5822 14.1491 13.5625C14.1983 13.5604 14.2474 13.5694 14.2926 13.589C14.3379 13.6085 14.3781 13.638 14.4103 13.6753C14.4569 13.733 14.491 13.7997 14.5104 13.8713C14.5299 13.9428 14.5342 14.0176 14.5231 14.0909C14.508 14.2576 14.436 14.4141 14.3192 14.5341C14.2025 14.654 14.0481 14.7303 13.8819 14.75ZM16.5537 10.5938H13.9294C13.8465 10.5936 13.7646 10.576 13.689 10.5423C13.6133 10.5085 13.5455 10.4593 13.49 10.3978C13.434 10.3355 13.3918 10.262 13.3662 10.1821C13.3406 10.1023 13.3322 10.018 13.3416 9.93469L13.5375 8.15344C13.555 8.00862 13.6252 7.8753 13.7347 7.77894C13.8442 7.68257 13.9854 7.62988 14.1312 7.63094H15.5147L16.625 10.095L16.5537 10.5938Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React93.createElement(
    "path",
    {
      d: "M2.375 10C2.53247 10 2.68349 9.93744 2.79484 9.82609C2.90619 9.71474 2.96875 9.56372 2.96875 9.40625C2.96875 9.24878 2.90619 9.09776 2.79484 8.98641C2.68349 8.87506 2.53247 8.8125 2.375 8.8125H1.78125C1.62378 8.8125 1.47276 8.87506 1.36141 8.98641C1.25006 9.09776 1.1875 9.24878 1.1875 9.40625C1.1875 9.56372 1.25006 9.71474 1.36141 9.82609C1.47276 9.93744 1.62378 10 1.78125 10H2.375Z",
      fill: "currentColor"
    }
  )
);

// src/atoms/VerifiedIcon.tsx
import React94 from "react";
var VERIFIED_ICON_PATH = "M11.1702 4.82418C11.0161 4.72076 10.877 4.59671 10.7567 4.45546C10.7657 4.25879 10.8052 4.06473 10.8739 3.88026C11.0031 3.44302 11.1639 2.89885 10.8539 2.47304C10.5417 2.04385 9.97123 2.02944 9.51296 2.01773C9.32017 2.02542 9.12733 2.00469 8.94058 1.95619C8.83791 1.79514 8.75951 1.61985 8.70792 1.43594C8.55501 1.00047 8.36452 0.458462 7.85439 0.292681C7.35939 0.131802 6.91516 0.437459 6.52346 0.706246C6.36605 0.83193 6.18932 0.931276 6.00014 1.00045C5.81085 0.931355 5.63403 0.831989 5.4766 0.706246C5.08488 0.437222 4.64053 0.132531 4.14565 0.292681C3.63565 0.458462 3.44523 1.00019 3.29214 1.43576C3.24065 1.61875 3.16311 1.79339 3.06192 1.9543C2.87458 2.00428 2.68077 2.0256 2.48706 2.01755C2.02881 2.02924 1.45838 2.04367 1.14613 2.47284C0.836126 2.89889 0.996965 3.44306 1.12613 3.88034C1.19404 4.06384 1.23392 4.25651 1.24442 4.45189C1.12466 4.59514 0.985017 4.72052 0.829748 4.8242C0.46 5.10618 0 5.45722 0 6.00045C0 6.54367 0.46 6.89472 0.829827 7.17672C0.983856 7.28014 1.12298 7.40419 1.24327 7.54544C1.23434 7.74211 1.19481 7.93615 1.12609 8.12063C0.996946 8.55788 0.836086 9.10209 1.14609 9.52786C1.45834 9.95705 2.02877 9.97146 2.48704 9.98319C2.67983 9.9755 2.87267 9.99622 3.05942 10.0447C3.16209 10.2058 3.24049 10.3811 3.29208 10.565C3.44517 11.0005 3.63559 11.5425 4.14571 11.7083C4.23608 11.7379 4.3306 11.753 4.42572 11.753C4.80964 11.753 5.16021 11.512 5.47664 11.2947C5.63405 11.169 5.81078 11.0696 5.99998 11.0005C6.18926 11.0695 6.36609 11.1689 6.52356 11.2947C6.91526 11.5637 7.35949 11.8681 7.85449 11.7082C8.36449 11.5424 8.55491 11.0007 8.70799 10.5651C8.75949 10.3822 8.83702 10.2075 8.93822 10.0466C9.12556 9.99662 9.31937 9.9753 9.51308 9.98335C9.97133 9.97166 10.5418 9.95723 10.854 9.52806C11.164 9.10203 11.0032 8.55782 10.874 8.12056C10.8061 7.93706 10.7662 7.74439 10.7557 7.54901C10.8755 7.40576 11.0151 7.28038 11.1704 7.1767C11.54 6.89472 12 6.54367 12 6.00045C12 5.45722 11.54 5.10618 11.1702 4.82418ZM8.22853 5.10397L5.72852 7.60396C5.53333 7.79921 5.21682 7.79927 5.02158 7.60408C5.02154 7.60404 5.0215 7.604 5.02146 7.60396L3.77145 6.35396C3.57373 6.16119 3.56971 5.84463 3.76248 5.6469C3.95524 5.44917 4.27181 5.44516 4.46953 5.63793C4.47257 5.64088 4.47556 5.64387 4.47851 5.6469L5.37499 6.5434L7.52147 4.3969C7.71424 4.19917 8.0308 4.19517 8.22853 4.38794C8.42625 4.58071 8.43025 4.89727 8.23748 5.095C8.23453 5.09805 8.23154 5.10102 8.22853 5.10397Z";
var VerifiedIcon = ({
  className,
  color = "#00B67A",
  size = 12,
  title = ""
}) => /* @__PURE__ */ React94.createElement("span", { "aria-hidden": !title }, /* @__PURE__ */ React94.createElement(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    role: title ? "img" : void 0,
    "aria-label": title || void 0
  },
  /* @__PURE__ */ React94.createElement("path", { d: VERIFIED_ICON_PATH, fill: color })
));

// src/molecules/AccordionItem.tsx
import React95, { useEffect as useEffect3, useRef as useRef2, useState as useState3 } from "react";
var DEFAULT_BUTTON_CLASS = "w-full flex items-center justify-between gap-4 p-4 text-left cursor-pointer";
var DEFAULT_LABEL_CLASS3 = "flex-1 min-w-0 font-bold text-base leading-6";
var DEFAULT_ICON_WRAPPER_CLASS = "shrink-0 size-6 flex items-center justify-center";
var DEFAULT_PANEL_CLASS = "overflow-hidden transition-[max-height] duration-300 ease-in-out";
var DEFAULT_CONTENT_CLASS = "px-4 pt-2 pb-4 text-base leading-6 transition-opacity duration-200";
var AccordionItem = ({
  id,
  label,
  content,
  isOpen,
  onToggle,
  openIcon = /* @__PURE__ */ React95.createElement(IconMinus, null),
  closedIcon = /* @__PURE__ */ React95.createElement(IconPlus, null),
  className,
  classes = {}
}) => {
  const contentRef = useRef2(null);
  const [maxHeight, setMaxHeight] = useState3("0px");
  useEffect3(() => {
    if (!contentRef.current) return;
    setMaxHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
  }, [isOpen, content]);
  return /* @__PURE__ */ React95.createElement("div", { className: cn(className, classes.root) }, /* @__PURE__ */ React95.createElement(
    "button",
    {
      type: "button",
      onClick: onToggle,
      "aria-expanded": isOpen,
      "aria-controls": `accordion-panel-${id}`,
      className: cn(DEFAULT_BUTTON_CLASS, classes.button)
    },
    /* @__PURE__ */ React95.createElement("span", { className: cn(DEFAULT_LABEL_CLASS3, classes.label) }, label),
    /* @__PURE__ */ React95.createElement("span", { "aria-hidden": true, className: cn(DEFAULT_ICON_WRAPPER_CLASS, classes.iconWrapper) }, isOpen ? openIcon : closedIcon)
  ), /* @__PURE__ */ React95.createElement(
    "div",
    {
      id: `accordion-panel-${id}`,
      className: cn(DEFAULT_PANEL_CLASS, classes.panel),
      style: { maxHeight },
      inert: !isOpen
    },
    /* @__PURE__ */ React95.createElement(
      "div",
      {
        ref: contentRef,
        className: cn(
          DEFAULT_CONTENT_CLASS,
          isOpen ? "opacity-100" : "opacity-0",
          classes.content
        )
      },
      content
    )
  ));
};

// src/molecules/CtaButton.tsx
import React96 from "react";
import { twMerge as twMerge2 } from "tailwind-merge";
var DEFAULT_BUTTON_CLASS2 = "inline-flex md:whitespace-nowrap p-3 xs:py-4 xs:px-6 border rounded-[10px] text-lg font-bold font-poppins cursor-pointer [background:var(--cta-bg)] border-(--button-border-color) text-(--button-text-color) hover:[background:var(--button-hover-color)] text-center items-center justify-center";
var DEFAULT_WITH_ICON_BUTTON_CLASS = "relative";
var DEFAULT_WITH_ICON_CONTENT_CLASS = "relative flex w-full items-center justify-center gap-4 text-center";
var DEFAULT_LABEL_CLASS4 = "min-w-0 flex-1";
var DEFAULT_ICON_CLASS12 = "flex size-[24px] shrink-0 items-center justify-center";
var CTAButton = ({
  buttonText,
  className,
  icon,
  href,
  buttonClassName,
  iconClassName,
  classes = {},
  style
}) => {
  const resolvedIcon = typeof icon === "string" && icon.trim() === "" ? void 0 : icon;
  let link;
  if (typeof window !== "undefined" && window.cta_link && window.affiliate && window.entry_url) {
    const separator = window.cta_link.indexOf("?") !== -1 ? "&" : "?";
    link = window.cta_link + `${separator}aff=` + window.btoa(window.affiliate) + "&entryUrl=" + window.btoa(window.entry_url);
  }
  const handleClick = () => {
    if (link) {
      window.location.href = link;
    } else if (href) {
      window.location.href = href;
    }
  };
  const buttonClasses = twMerge2(
    DEFAULT_BUTTON_CLASS2,
    resolvedIcon && DEFAULT_WITH_ICON_BUTTON_CLASS,
    className,
    buttonClassName,
    classes.button
  );
  const contentClassName = resolvedIcon ? twMerge2(DEFAULT_WITH_ICON_CONTENT_CLASS, classes.content) : classes.content;
  const resolvedIconClassName = resolvedIcon ? twMerge2(DEFAULT_ICON_CLASS12, iconClassName, classes.icon) : twMerge2(iconClassName, classes.icon);
  const buttonContent = resolvedIcon ? /* @__PURE__ */ React96.createElement("span", { className: DEFAULT_LABEL_CLASS4 }, buttonText) : buttonText;
  return /* @__PURE__ */ React96.createElement(
    Button,
    {
      children: buttonContent,
      className: buttonClasses,
      icon: resolvedIcon,
      contentClassName,
      iconClassName: resolvedIconClassName,
      style,
      onClick: handleClick
    }
  );
};

// src/molecules/BarNotice.tsx
import React97 from "react";
var DEFAULT_ROOT_CLASS6 = "flex items-center gap-2";
var DEFAULT_CONTENT_CLASS2 = "text-sm font-normal leading-5 max-md:text-xs";
var COMPACT_ROOT_CLASS = "min-h-0 px-[6px] py-2 [&_img]:max-h-[14px] [&_svg]:max-h-[14px]";
var COMPACT_CONTENT_CLASS = "text-[12px] leading-[12px]";
var BarNotice = ({
  icon,
  children,
  centered,
  compact,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React97.createElement(
    BarSurface,
    {
      className: cn(
        DEFAULT_ROOT_CLASS6,
        centered && "justify-center",
        compact && COMPACT_ROOT_CLASS,
        classes.root,
        className
      )
    },
    icon,
    /* @__PURE__ */ React97.createElement(
      "span",
      {
        className: cn(DEFAULT_CONTENT_CLASS2, compact && COMPACT_CONTENT_CLASS, classes.content)
      },
      children
    )
  );
};

// src/organisms/Hero.tsx
import React98 from "react";
import classNames13 from "classnames";
var DEFAULT_BASE_CLASS3 = "flex max-w-body mx-auto py-6 px-4 lg:py-15 md:py-10 md:px-4 lg:gap-16 md:gap-4 lg:items-center flex-col md:flex-row";
var DEFAULT_LEFT_CLASS = "flex-1";
var DEFAULT_RIGHT_CLASS2 = "flex-1";
var Hero = ({
  left,
  right,
  className,
  leftClassName,
  rightClassName,
  baseClassName,
  classes = {},
  children
}) => {
  const containerClass = classNames13(
    DEFAULT_BASE_CLASS3,
    className,
    baseClassName,
    classes.container,
    classes.base
  );
  const leftCls = classNames13(DEFAULT_LEFT_CLASS, leftClassName, classes.left);
  const rightCls = classNames13(DEFAULT_RIGHT_CLASS2, rightClassName, classes.right);
  return /* @__PURE__ */ React98.createElement(Container, { className: containerClass }, left && /* @__PURE__ */ React98.createElement("div", { className: leftCls }, left), right && /* @__PURE__ */ React98.createElement("div", { className: rightCls }, right), children);
};

// src/molecules/FeatureCard.tsx
import React99 from "react";
var DEFAULT_ROOT_CLASS7 = "flex items-start";
var DEFAULT_ICON_CLASS13 = "mr-4 size-8 flex-none self-start object-contain";
var DEFAULT_CONTENT_CLASS3 = "min-w-0";
var DEFAULT_TITLE_CLASS = "mb-2 text-xs font-bold not-italic leading-4 text-neutral-900";
var DEFAULT_DESCRIPTION_CLASS = "text-xs font-normal not-italic leading-4 text-neutral-600";
var FeatureCard = ({
  icon,
  iconAlt,
  title,
  description,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React99.createElement("article", { className: cn(DEFAULT_ROOT_CLASS7, classes.root, className) }, icon && /* @__PURE__ */ React99.createElement("img", { className: cn(DEFAULT_ICON_CLASS13, classes.icon), src: icon, alt: iconAlt != null ? iconAlt : title }), /* @__PURE__ */ React99.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS3, classes.content) }, /* @__PURE__ */ React99.createElement("h3", { className: cn(DEFAULT_TITLE_CLASS, classes.title) }, title), /* @__PURE__ */ React99.createElement("p", { className: cn(DEFAULT_DESCRIPTION_CLASS, classes.description) }, description)));
};

// src/molecules/HeadingDescriptionBlock.tsx
import React100 from "react";
var DEFAULT_ROOT_CLASS8 = "grid gap-3";
var DEFAULT_HEADING_CLASS = "text-[24px] font-black leading-[1.25] text-current md:text-[24px] lg:text-[32px]";
var DEFAULT_DESCRIPTION_CLASS2 = "text-[16px] font-bold leading-[1.55] text-current md:text-[16px]";
var HeadingDescriptionBlock = ({
  heading,
  description,
  className,
  classes = {}
}) => /* @__PURE__ */ React100.createElement("div", { className: cn(DEFAULT_ROOT_CLASS8, classes.root, className) }, heading ? /* @__PURE__ */ React100.createElement("div", { className: cn(DEFAULT_HEADING_CLASS, classes.heading) }, heading) : null, description ? /* @__PURE__ */ React100.createElement("p", { className: cn(DEFAULT_DESCRIPTION_CLASS2, classes.description) }, description) : null);

// src/molecules/IconLabelRow.tsx
import React101 from "react";
var DEFAULT_ROOT_CLASS9 = "flex items-center gap-2 text-[13px] font-bold uppercase leading-5 text-current";
var DEFAULT_ICON_CLASS14 = "h-4 w-4 shrink-0 object-contain";
var IconLabelRow = ({ label, icon, className, classes = {} }) => /* @__PURE__ */ React101.createElement("div", { className: cn(DEFAULT_ROOT_CLASS9, classes.root, className) }, icon ? /* @__PURE__ */ React101.createElement("span", { className: cn(DEFAULT_ICON_CLASS14, classes.icon), "aria-hidden": "true" }, icon) : null, /* @__PURE__ */ React101.createElement("span", { className: classes.label }, label));

// src/molecules/IconLabelStack.tsx
import React102 from "react";
var DEFAULT_ROOT_CLASS10 = "grid justify-items-center gap-2 text-[12px] font-bold uppercase leading-4 text-current";
var DEFAULT_ICON_CLASS15 = "h-7 w-7 object-contain";
var IconLabelStack = ({ icon, label, className, classes = {} }) => /* @__PURE__ */ React102.createElement("div", { className: cn(DEFAULT_ROOT_CLASS10, classes.root, className) }, /* @__PURE__ */ React102.createElement("span", { className: cn(DEFAULT_ICON_CLASS15, classes.icon), "aria-hidden": "true" }, icon), /* @__PURE__ */ React102.createElement("span", { className: classes.label }, label));

// src/molecules/IconTextRow.tsx
import React103 from "react";
var DEFAULT_ROOT_CLASS11 = "flex items-start gap-3 text-base font-normal leading-6 text-current";
var DEFAULT_ICON_CLASS16 = "mt-0.5 h-5 w-5 shrink-0";
var IconTextRow = ({ text, icon, className, classes = {} }) => /* @__PURE__ */ React103.createElement("div", { className: cn(DEFAULT_ROOT_CLASS11, classes.root, className) }, icon ? /* @__PURE__ */ React103.createElement("span", { className: cn(DEFAULT_ICON_CLASS16, classes.icon), "aria-hidden": "true" }, icon) : null, /* @__PURE__ */ React103.createElement("span", { className: classes.text }, text));

// src/molecules/ImageCard.tsx
import React104 from "react";
var DEFAULT_ROOT_CLASS12 = "flex items-start gap-4 rounded border border-neutral-200 px-4 py-4";
var DEFAULT_CONTENT_CLASS4 = "min-w-0";
var DEFAULT_TITLE_CLASS2 = "mb-1 text-sm font-bold leading-5 text-neutral-900";
var DEFAULT_DESCRIPTION_CLASS3 = "text-xs font-normal leading-4 text-neutral-600";
var ImageCard = ({
  image,
  title,
  description,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React104.createElement("article", { className: cn(DEFAULT_ROOT_CLASS12, classes.root, className) }, image, /* @__PURE__ */ React104.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS4, classes.content) }, /* @__PURE__ */ React104.createElement("h3", { className: cn(DEFAULT_TITLE_CLASS2, classes.title) }, title), /* @__PURE__ */ React104.createElement("p", { className: cn(DEFAULT_DESCRIPTION_CLASS3, classes.description) }, description)));
};

// src/molecules/RatingBanner.tsx
import React105 from "react";
import classNames14 from "classnames";
var DEFAULT_WRAPPER_CLASS2 = "flex gap-2 flex-wrap xs:flex-nowrap";
var DEFAULT_CONTAINER_CLASS4 = "flex w-full items-center gap-2 text-sm leading-[14px] flex-nowrap";
var DEFAULT_ICON_CLASS17 = "unset max-w-[80px]";
var DEFAULT_RATING_TEXT_CLASS = "font-bold";
var DEFAULT_TEXT_CLASS3 = "";
var RatingBanner = ({
  stars,
  rating,
  reviewers,
  reviewLabel,
  containerClass,
  wrapperClass,
  ratingTextClass,
  iconClass,
  textClass,
  classes = {}
}) => {
  const computedContainerClass = classNames14(
    DEFAULT_CONTAINER_CLASS4,
    containerClass,
    classes.container
  );
  const computedWrapperlass = classNames14(DEFAULT_WRAPPER_CLASS2, wrapperClass, classes.wrapper);
  const computedIconClass = classNames14(DEFAULT_ICON_CLASS17, iconClass, classes.icon);
  const computedRatingTextClass = classNames14(
    DEFAULT_RATING_TEXT_CLASS,
    ratingTextClass,
    classes.ratingText
  );
  const computedTextClass = classNames14(DEFAULT_TEXT_CLASS3, textClass, classes.text);
  return /* @__PURE__ */ React105.createElement("div", { className: computedWrapperlass }, stars && /* @__PURE__ */ React105.createElement(Icon, { src: stars, className: computedIconClass }), /* @__PURE__ */ React105.createElement("div", { className: computedContainerClass }, rating && /* @__PURE__ */ React105.createElement("span", { className: computedRatingTextClass }, rating), rating && reviewLabel && /* @__PURE__ */ React105.createElement("span", { className: computedRatingTextClass }, " | "), reviewers && /* @__PURE__ */ React105.createElement(Icon, { src: reviewers, className: computedIconClass }), reviewLabel && /* @__PURE__ */ React105.createElement("span", { className: computedTextClass }, reviewLabel)));
};

// src/organisms/StickyCtaFloater.tsx
import React107 from "react";

// src/molecules/StockAndShippingLevel.tsx
import React106 from "react";

// src/helpers/shippingDate.ts
var DEFAULT_SHIP_BY_DATE_OPTIONS = {
  day: "numeric",
  month: "short"
};
function formatShipByDate(daysFromNow, locale) {
  if (typeof daysFromNow !== "number" || !Number.isFinite(daysFromNow) || daysFromNow < 0) {
    return void 0;
  }
  const date = /* @__PURE__ */ new Date();
  date.setDate(date.getDate() + Math.floor(daysFromNow));
  try {
    return new Intl.DateTimeFormat(locale || void 0, DEFAULT_SHIP_BY_DATE_OPTIONS).format(date);
  } catch (e) {
    return new Intl.DateTimeFormat(void 0, DEFAULT_SHIP_BY_DATE_OPTIONS).format(date);
  }
}
function resolveShipByText(shipByText, daysFromNow, locale) {
  if (!shipByText) return void 0;
  if (!shipByText.includes("{date}")) return shipByText;
  const formattedDate = formatShipByDate(daysFromNow, locale);
  if (!formattedDate) return void 0;
  return shipByText.split("{date}").join(formattedDate);
}

// src/molecules/StockAndShippingLevel.tsx
var DEFAULT_ROOT_CLASS13 = "flex items-center gap-2";
var DEFAULT_SHIP_BY_CLASS = "flex items-center gap-1";
var DEFAULT_SHIP_DOT_CLASS = "flex size-3 shrink-0 items-center justify-center rounded-full bg-(--stock-ship-dot) [animation:stock-ship-dot-pulse_2400ms_ease-in-out_infinite] motion-reduce:animate-none";
var DEFAULT_SHIP_DOT_INNER_CLASS = "size-1.5 rounded-full bg-(--stock-ship-dot-inner)";
var DEFAULT_DIVIDER_CLASS = "w-px h-4 bg-(--stock-ship-divider) shrink-0";
var DEFAULT_STOCK_STATUS_CLASS = "flex items-center gap-1";
var DEFAULT_STOCK_LABEL_CLASS = "text-xs font-bold text-(--stock-ship-text) whitespace-nowrap leading-[18px]";
var DEFAULT_STOCK_TRACK_CLASS = "flex items-center rounded-full overflow-hidden h-[10px] w-[70px] shrink-0";
var DEFAULT_STOCK_LOW_CLASS = "text-xs font-bold uppercase text-(--stock-low-color) whitespace-nowrap leading-[18px]";
var DEFAULT_SHIP_TEXT_CLASS = "text-xs font-medium text-(--stock-ship-text) whitespace-nowrap leading-[18px]";
function buildStockAndShippingVars(colors) {
  var _a, _b, _c, _d, _e, _f, _g;
  return {
    "--stock-ship-dot": (_a = colors == null ? void 0 : colors.shipDotColor) != null ? _a : "#C0F1D2",
    "--stock-ship-dot-inner": (_b = colors == null ? void 0 : colors.shipDotInnerColor) != null ? _b : "#007F3E",
    "--stock-ship-text": (_c = colors == null ? void 0 : colors.textColor) != null ? _c : "#333333",
    "--stock-ship-divider": (_d = colors == null ? void 0 : colors.dividerColor) != null ? _d : "#E0E0E0",
    "--stock-fill-color": (_e = colors == null ? void 0 : colors.fillColor) != null ? _e : "#EC0B43",
    "--stock-track-color": (_f = colors == null ? void 0 : colors.trackColor) != null ? _f : "#E0E0E0",
    "--stock-low-color": (_g = colors == null ? void 0 : colors.lowTextColor) != null ? _g : "#EC0B43"
  };
}
var StockAndShippingLevel = ({
  shipByText,
  daysFromNow,
  shipByLocale,
  showShipBy = true,
  stockLevelLabel,
  stockLevel = 30,
  stockLevelLowLabel,
  showStockLevel = true,
  colors,
  className,
  classes = {}
}) => {
  const resolvedShipByText = resolveShipByText(shipByText, daysFromNow, shipByLocale);
  const hasShipBy = showShipBy && !!resolvedShipByText;
  const hasStockLevel = showStockLevel && !!stockLevelLabel;
  const clamped = Math.max(0, Math.min(100, stockLevel));
  if (!hasShipBy && !hasStockLevel) return null;
  return /* @__PURE__ */ React106.createElement(
    "div",
    {
      className: cn(DEFAULT_ROOT_CLASS13, classes.root, className),
      style: buildStockAndShippingVars(colors)
    },
    hasShipBy && /* @__PURE__ */ React106.createElement("div", { className: cn(DEFAULT_SHIP_BY_CLASS, classes.shipBy) }, /* @__PURE__ */ React106.createElement("span", { "aria-hidden": "true", className: DEFAULT_SHIP_DOT_CLASS }, /* @__PURE__ */ React106.createElement("span", { className: DEFAULT_SHIP_DOT_INNER_CLASS })), /* @__PURE__ */ React106.createElement(Text, { as: "span", className: DEFAULT_SHIP_TEXT_CLASS }, resolvedShipByText)),
    hasShipBy && hasStockLevel && /* @__PURE__ */ React106.createElement("div", { "aria-hidden": "true", className: cn(DEFAULT_DIVIDER_CLASS, classes.divider) }),
    hasStockLevel && /* @__PURE__ */ React106.createElement(
      "div",
      {
        className: cn(DEFAULT_STOCK_STATUS_CLASS, classes.stockStatus),
        style: { "--stock-fill-pct": `${clamped}%` }
      },
      /* @__PURE__ */ React106.createElement(Text, { as: "span", className: DEFAULT_STOCK_LABEL_CLASS }, stockLevelLabel),
      /* @__PURE__ */ React106.createElement("div", { "aria-hidden": "true", className: DEFAULT_STOCK_TRACK_CLASS }, /* @__PURE__ */ React106.createElement("div", { className: "h-full rounded-l-full bg-(--stock-fill-color) shrink-0 w-[var(--stock-fill-pct)]" }), /* @__PURE__ */ React106.createElement("div", { className: "flex-1 h-full bg-(--stock-track-color)" })),
      stockLevelLowLabel && /* @__PURE__ */ React106.createElement(Text, { as: "span", className: DEFAULT_STOCK_LOW_CLASS }, stockLevelLowLabel)
    )
  );
};

// src/helpers/color.ts
function lightenHex(hex, amount) {
  const clean = hex.replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(clean)) return hex;
  const num = parseInt(clean, 16);
  const r = Math.min(255, Math.round((num >> 16 & 255) + (255 - (num >> 16 & 255)) * amount));
  const g = Math.min(255, Math.round((num >> 8 & 255) + (255 - (num >> 8 & 255)) * amount));
  const b = Math.min(255, Math.round((num & 255) + (255 - (num & 255)) * amount));
  return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
}
function lightenGradient(gradient, amount) {
  return gradient.replace(/#[0-9a-fA-F]{6}/g, (hex) => lightenHex(hex, amount));
}

// src/organisms/StickyCtaFloater.tsx
var STOCK_STYLES = {
  "in-stock": { lowLabel: "IN STOCK", fillColor: "#16A34A", lowTextColor: "#16A34A", value: 85 },
  low: { lowLabel: "LOW", fillColor: "#EC0B43", lowTextColor: "#EC0B43", value: 20 },
  "out-of-stock": {
    lowLabel: "OUT OF STOCK",
    fillColor: "#991B1B",
    lowTextColor: "#991B1B",
    value: 0
  }
};
function buildFloaterVars(backgroundColor = "#FFFFFF") {
  return {
    "--sticky-cta-floater-bg": backgroundColor
  };
}
function buildCtaButtonVars(ctaButton) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    "--cta-bg": (_b = (_a = ctaButton == null ? void 0 : ctaButton.backgroundGradient) != null ? _a : ctaButton == null ? void 0 : ctaButton.backgroundColor) != null ? _b : "#16A34A",
    "--button-hover-color": (_e = (_c = ctaButton == null ? void 0 : ctaButton.backgroundHoverGradient) != null ? _c : ctaButton == null ? void 0 : ctaButton.backgroundHoverColor) != null ? _e : (ctaButton == null ? void 0 : ctaButton.backgroundGradient) ? lightenGradient(ctaButton.backgroundGradient, 0.1) : lightenHex((_d = ctaButton == null ? void 0 : ctaButton.backgroundColor) != null ? _d : "#16A34A", 0.2),
    "--button-text-color": (_f = ctaButton == null ? void 0 : ctaButton.textColor) != null ? _f : "#fff",
    "--button-border-color": (_g = ctaButton == null ? void 0 : ctaButton.borderColor) != null ? _g : "transparent",
    "--button-icon-color": (_h = ctaButton == null ? void 0 : ctaButton.iconColor) != null ? _h : "#9B6A00"
  };
}
var DEFAULT_ROOT_CLASS14 = "fixed inset-x-0 bottom-0 z-50 [background:var(--sticky-cta-floater-bg)] p-[10px] pb-[calc(10px+env(safe-area-inset-bottom))] shadow-[0_-4px_16.4px_0_rgba(0,0,0,0.1)]";
var DEFAULT_CONTAINER_CLASS5 = "mx-auto flex w-full max-w-[500px] flex-col items-center gap-2";
var DEFAULT_CTA_WRAPPER_CLASS = "w-full md:w-[500px]";
var DEFAULT_CTA_BUTTON_CLASS = "w-full h-14 text-[20px] font-outfit font-bold leading-7 rounded-[10px] px-6 py-2.5 lg:py-3";
var DEFAULT_CTA_ICON_CLASS = "text-(--button-icon-color)";
var DEFAULT_SHIPPING_CLASS = "flex-wrap justify-center";
var StickyCtaFloater = React107.forwardRef(
  ({
    ctaButton,
    shippingInfo,
    backgroundColor,
    ariaLabel = "Product offer",
    className,
    classes = {}
  }, ref) => {
    var _a, _b, _c, _d, _e, _f;
    const hasCta = !!(ctaButton == null ? void 0 : ctaButton.text);
    const stock = (shippingInfo == null ? void 0 : shippingInfo.stockLevel) ? STOCK_STYLES[shippingInfo.stockLevel] : void 0;
    const hasStockLevelData = !!((shippingInfo == null ? void 0 : shippingInfo.stockLevel) || (shippingInfo == null ? void 0 : shippingInfo.stockLevelLabel) || (shippingInfo == null ? void 0 : shippingInfo.stockLevelValue) !== void 0 || (shippingInfo == null ? void 0 : shippingInfo.stockLowLabel));
    const hasShipBy = (shippingInfo == null ? void 0 : shippingInfo.showShipBy) !== false && !!(shippingInfo == null ? void 0 : shippingInfo.shipBy);
    const hasStockLevel = ((_a = shippingInfo == null ? void 0 : shippingInfo.showStockLevel) != null ? _a : hasStockLevelData) && !!(hasStockLevelData ? (_b = shippingInfo == null ? void 0 : shippingInfo.stockLevelLabel) != null ? _b : "Stock levels:" : void 0);
    if (!hasCta && !hasShipBy && !hasStockLevel) return null;
    return /* @__PURE__ */ React107.createElement(
      "aside",
      {
        ref,
        "aria-label": ariaLabel,
        className: cn(DEFAULT_ROOT_CLASS14, className, classes.root),
        style: buildFloaterVars(backgroundColor)
      },
      /* @__PURE__ */ React107.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS5, classes.container) }, hasCta && /* @__PURE__ */ React107.createElement("div", { className: cn(DEFAULT_CTA_WRAPPER_CLASS, classes.ctaWrapper) }, /* @__PURE__ */ React107.createElement(
        CTAButton,
        {
          buttonText: ctaButton.text,
          icon: /* @__PURE__ */ React107.createElement(IconArrowCircleRight, { className: DEFAULT_CTA_ICON_CLASS }),
          href: ctaButton.url,
          className: cn(DEFAULT_CTA_BUTTON_CLASS, classes.ctaButton),
          style: buildCtaButtonVars(ctaButton)
        }
      )), shippingInfo && /* @__PURE__ */ React107.createElement(
        StockAndShippingLevel,
        {
          shipByText: shippingInfo.shipBy,
          daysFromNow: shippingInfo.daysFromNow,
          shipByLocale: shippingInfo.shipByLocale,
          showShipBy: shippingInfo.showShipBy,
          stockLevelLabel: hasStockLevelData ? (_c = shippingInfo.stockLevelLabel) != null ? _c : "Stock levels:" : void 0,
          stockLevel: (_d = shippingInfo.stockLevelValue) != null ? _d : stock == null ? void 0 : stock.value,
          stockLevelLowLabel: (_e = shippingInfo.stockLowLabel) != null ? _e : stock == null ? void 0 : stock.lowLabel,
          showStockLevel: (_f = shippingInfo.showStockLevel) != null ? _f : hasStockLevelData,
          colors: {
            textColor: shippingInfo.textColor || void 0,
            fillColor: stock == null ? void 0 : stock.fillColor,
            lowTextColor: shippingInfo.statusTextColor || (stock == null ? void 0 : stock.lowTextColor)
          },
          className: cn(DEFAULT_SHIPPING_CLASS, classes.shipping),
          classes: {
            shipBy: classes.shipByWrapper,
            stockStatus: classes.stockLevelWrapper
          }
        }
      ))
    );
  }
);
StickyCtaFloater.displayName = "StickyCtaFloater";

// src/molecules/CheckmarkList.tsx
import React108 from "react";
import classNames15 from "classnames";
var DEFAULT_CONTAINER_CLASS6 = "flex flex-col gap-2";
var DEFAULT_ITEM_CLASS = "flex items-center gap-3";
var DEFAULT_ICON_CLASS18 = "size-5";
var DEFAULT_TEXT_CLASS4 = "text-lg font-medium";
var CheckmarkList = ({
  listItems,
  checkmarkListClass,
  icon,
  itemClassName,
  iconClassName,
  textClassName,
  classes = {}
}) => {
  const baseClass = classNames15(DEFAULT_CONTAINER_CLASS6, checkmarkListClass, classes.container);
  const itemClass = classNames15(DEFAULT_ITEM_CLASS, itemClassName, classes.item);
  const iconCls = classNames15(DEFAULT_ICON_CLASS18, iconClassName, classes.icon);
  const textCls = classNames15(DEFAULT_TEXT_CLASS4, textClassName, classes.text);
  return /* @__PURE__ */ React108.createElement("div", { className: baseClass }, listItems && listItems.map((item, idx) => /* @__PURE__ */ React108.createElement("div", { key: idx, className: itemClass }, /* @__PURE__ */ React108.createElement(Icon, { src: icon, className: iconCls }), /* @__PURE__ */ React108.createElement(Text, { className: textCls }, item.tr_label))));
};

// src/molecules/Video.tsx
import React109 from "react";
var DEFAULT_BASE_CLASS4 = "rounded-[10px] w-full h-auto aspect-square";
var Video = ({
  src,
  poster,
  autoPlay = true,
  loop = true,
  muted = true,
  controls = false,
  ariaLabel,
  className,
  classes = {}
}) => {
  const baseClass = cn(DEFAULT_BASE_CLASS4, className, classes.video);
  return /* @__PURE__ */ React109.createElement(
    "video",
    {
      className: baseClass,
      "aria-label": ariaLabel,
      autoPlay,
      loop,
      muted,
      playsInline: true,
      poster,
      controls
    },
    /* @__PURE__ */ React109.createElement("source", { src, type: "video/mp4" })
  );
};

// src/molecules/StockLevel.tsx
import React110 from "react";
import classNames16 from "classnames";
var DEFAULT_CONTAINER_CLASS7 = "flex items-center border border-dashed rounded-sm gap-2 py-3 px-4 justify-center bg-[#E0E0E0] bg-[rgba(255,255,255,0.70)]";
var DEFAULT_LABEL_CLASS5 = "font-bold text-sm lg:text-base";
var DEFAULT_BARWRAPPER_CLASS = "h-[12px] w-[96px] rounded-full bg-[#E0E0E0]";
var DEFAULT_BARFILL_CLASS = "h-full rounded-l-full";
var DEFAULT_LOWLABEL_CLASS = "font-bold text-sm lg:text-base";
var StockLevel = ({
  label,
  level = 30,
  lowLabel,
  className,
  labelClassName,
  barWrapperClassName,
  barFillClassName,
  lowLabelClassName,
  classes = {}
}) => {
  const containerClass = classNames16(DEFAULT_CONTAINER_CLASS7, className, classes.container);
  const labelClass = classNames16(DEFAULT_LABEL_CLASS5, labelClassName, classes.label);
  const barWrapperClass = classNames16(
    DEFAULT_BARWRAPPER_CLASS,
    barWrapperClassName,
    classes.barWrapper
  );
  const barFillClass = classNames16(DEFAULT_BARFILL_CLASS, barFillClassName, classes.barFill);
  const lowLabelClass = classNames16(DEFAULT_LOWLABEL_CLASS, lowLabelClassName, classes.lowLabel);
  return /* @__PURE__ */ React110.createElement(Container, { className: containerClass }, /* @__PURE__ */ React110.createElement(Text, { className: labelClass }, label), /* @__PURE__ */ React110.createElement("div", { className: barWrapperClass }, /* @__PURE__ */ React110.createElement(
    "div",
    {
      className: barFillClass,
      style: {
        width: `${Math.max(0, Math.min(100, level))}%`,
        background: "linear-gradient(270deg, #EC0B43 0%, #A60029 100%)"
      }
    }
  )), lowLabel && /* @__PURE__ */ React110.createElement(Text, { className: lowLabelClass }, lowLabel));
};

// src/molecules/SslText.tsx
import React111 from "react";
import classNames17 from "classnames";
var DEFAULT_CONTAINER_CLASS8 = "flex gap-2 items-center text-(--ssl-text-color) justify-center";
var DEFAULT_ICON_CLASS19 = "";
var DEFAULT_LABEL_CLASS6 = "lg:text-sm text-xs";
var SSLText = ({
  label,
  icon,
  className,
  iconClassName,
  labelClassName,
  classes = {}
}) => {
  const containerClass = classNames17(DEFAULT_CONTAINER_CLASS8, className, classes.container);
  const iconClass = classNames17(DEFAULT_ICON_CLASS19, iconClassName, classes.icon);
  const labelClass = classNames17(DEFAULT_LABEL_CLASS6, labelClassName, classes.label);
  return /* @__PURE__ */ React111.createElement(Container, { className: containerClass }, /* @__PURE__ */ React111.createElement(Icon, { src: icon, className: iconClass }), /* @__PURE__ */ React111.createElement(Text, { className: labelClass }, label));
};

// src/molecules/GuaranteeCard.tsx
import React112 from "react";
import classNames18 from "classnames";
var DEFAULT_CONTAINER_CLASS9 = "border flex flex-1 gap-4 py-3 px-4 rounded-sm border-(--card-border-color) bg-(--card-bg-color) items-center";
var DEFAULT_ICON_CLASS20 = "block size-[80px]";
var DEFAULT_CONTENT_CLASS5 = "flex gap-2 flex-col h-full items-start";
var DEFAULT_TITLE_CLASS3 = "text-lg/6 font-bold";
var DEFAULT_DESCRIPTION_CLASS4 = "block text-sm/4.5";
var Card = ({
  title,
  description,
  icon,
  className,
  iconClassName,
  titleClassName,
  descriptionClassName,
  classes = {}
}) => {
  const baseClass = classNames18(DEFAULT_CONTAINER_CLASS9, className, classes.container);
  const iconCls = classNames18(DEFAULT_ICON_CLASS20, iconClassName, classes.icon);
  const contentCls = classNames18(DEFAULT_CONTENT_CLASS5, classes.content);
  const titleCls = classNames18(DEFAULT_TITLE_CLASS3, titleClassName, classes.title);
  const descCls = classNames18(DEFAULT_DESCRIPTION_CLASS4, descriptionClassName, classes.description);
  return /* @__PURE__ */ React112.createElement(Container, { className: baseClass }, icon && /* @__PURE__ */ React112.createElement(Icon, { className: iconCls, src: icon }), (title || description) && /* @__PURE__ */ React112.createElement("div", { className: contentCls }, title && /* @__PURE__ */ React112.createElement(Text, { className: titleCls }, title), description && /* @__PURE__ */ React112.createElement(Text, { className: descCls }, description)));
};

// src/molecules/Marquee.tsx
import React113 from "react";
import classNames19 from "classnames";
var DEFAULT_CONTAINER_CLASS10 = "relative w-full overflow-hidden bg-(--marquee-bg-color) py-6";
var DEFAULT_INNER_CLASS2 = "flex w-max whitespace-nowrap will-change-transform [animation:marquee_30s_linear_infinite] lg:animate-none lg:mx-auto md:block";
var DEFAULT_ITEM_CLASS2 = "inline-flex items-center gap-6 px-4";
var Marquee = ({
  children,
  className,
  innerClassName,
  itemClassName,
  classes = {}
}) => {
  const marqueeClass = classNames19(DEFAULT_CONTAINER_CLASS10, className, classes.container);
  const innerClass = classNames19(DEFAULT_INNER_CLASS2, innerClassName, classes.inner);
  const itemClass = classNames19(DEFAULT_ITEM_CLASS2, itemClassName, classes.item);
  return /* @__PURE__ */ React113.createElement(Container, { className: marqueeClass, "aria-live": "off" }, /* @__PURE__ */ React113.createElement("div", { className: innerClass }, /* @__PURE__ */ React113.createElement("div", { className: itemClass }, children), /* @__PURE__ */ React113.createElement("div", { className: classNames19(itemClass, "block md:hidden"), "aria-hidden": true }, children)), /* @__PURE__ */ React113.createElement("style", null, `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `));
};

// src/molecules/StatsCard.tsx
import React115 from "react";
import classNames21 from "classnames";

// src/atoms/ProgressCircle.tsx
import React114, { useEffect as useEffect4, useRef as useRef3, useState as useState4 } from "react";
import classNames20 from "classnames";
var ProgressCircle = ({
  percentage,
  fillColor = "#FFFFFF",
  gradientStart = "#4D1FC9",
  gradientMid = "#260F63",
  gradientFade = "rgba(38, 15, 99, 0)",
  trailColor = "#D1D1D1",
  textColor = "#000000",
  className,
  maskClassName,
  textClassName,
  classes = {},
  duration = 6e3,
  startOnVisible = true
}) => {
  const percent = Math.max(0, Math.min(percentage, 100));
  const fadeDeg = 2;
  const strokePx = 7;
  const outerSizePx = 120;
  const innerPercent = (outerSizePx - 2 * strokePx) / outerSizePx * 100;
  const offsetPercent = strokePx / outerSizePx * 100;
  const containerRef = useRef3(null);
  const rafRef = useRef3(null);
  const startTimeRef = useRef3(null);
  const fromPercentRef = useRef3(0);
  const targetPercentRef = useRef3(percent);
  const hasAnimatedToTargetRef = useRef3(false);
  const [isVisible, setIsVisible] = useState4(!startOnVisible);
  const [currentPercent, setCurrentPercent] = useState4(startOnVisible ? 0 : percent);
  const prefersReducedMotion = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
  useEffect4(() => {
    if (!startOnVisible) {
      setIsVisible(true);
      return;
    }
    const el = containerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(el);
          }
        }
      },
      {
        threshold: 0.3
      }
    );
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [startOnVisible]);
  useEffect4(() => {
    targetPercentRef.current = percent;
    if (prefersReducedMotion) {
      setCurrentPercent(percent);
      hasAnimatedToTargetRef.current = true;
      return;
    }
    if (!isVisible) {
      setCurrentPercent((prev) => startOnVisible ? 0 : prev);
      hasAnimatedToTargetRef.current = false;
      return;
    }
    if (hasAnimatedToTargetRef.current && Math.round(currentPercent) === Math.round(percent)) {
      return;
    }
    fromPercentRef.current = currentPercent;
    startTimeRef.current = null;
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
    const animate = (timestamp) => {
      if (startTimeRef.current === null) startTimeRef.current = timestamp;
      const elapsed = timestamp - startTimeRef.current;
      const clampedElapsed = Math.min(elapsed, duration);
      const t = duration === 0 ? 1 : clampedElapsed / duration;
      const eased = easeOutCubic(t);
      const newPercent = fromPercentRef.current + (targetPercentRef.current - fromPercentRef.current) * eased;
      setCurrentPercent(newPercent);
      if (clampedElapsed < duration) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        setCurrentPercent(targetPercentRef.current);
        hasAnimatedToTargetRef.current = true;
        startTimeRef.current = null;
        rafRef.current = null;
      }
    };
    if (rafRef.current !== null) {
      cancelAnimationFrame(rafRef.current);
    }
    rafRef.current = requestAnimationFrame(animate);
    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, [percent, isVisible, duration, prefersReducedMotion, startOnVisible, currentPercent]);
  useEffect4(() => {
    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);
  const arcDeg = currentPercent * 3.6;
  const styleCircle = {
    width: "100%",
    height: "100%",
    maxWidth: `${outerSizePx}px`,
    maxHeight: `${outerSizePx}px`,
    aspectRatio: "1",
    borderRadius: "50%",
    background: `
      conic-gradient(
        from 0deg at 50% 50%,
        ${gradientStart} 0deg,
        ${gradientMid} ${Math.max(0, arcDeg - fadeDeg)}deg,
        ${gradientFade} ${arcDeg}deg,
        ${trailColor} ${arcDeg}deg 360deg
      )
    `,
    position: "relative",
    display: "inline-block",
    boxSizing: "border-box",
    transition: prefersReducedMotion ? void 0 : "box-shadow 200ms ease"
  };
  const styleMask = {
    position: "absolute",
    top: `${offsetPercent}%`,
    left: `${offsetPercent}%`,
    width: `${innerPercent}%`,
    height: `${innerPercent}%`,
    background: fillColor,
    borderRadius: "50%",
    zIndex: 2
  };
  const styleText = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
    fontSize: "2em",
    color: textColor,
    zIndex: 3,
    pointerEvents: "none",
    userSelect: "none"
  };
  const containerClass = classNames20(className, classes.container);
  const maskClass = classNames20(maskClassName, classes.mask);
  const textClass = classNames20(textClassName, classes.text);
  return /* @__PURE__ */ React114.createElement("div", { ref: containerRef, style: styleCircle, className: containerClass, "aria-hidden": false }, /* @__PURE__ */ React114.createElement("div", { style: styleMask, className: maskClass }), /* @__PURE__ */ React114.createElement("div", { style: styleText, className: textClass, "aria-live": "polite" }, Math.round(currentPercent), "%"));
};
var ProgressCircle_default = ProgressCircle;

// src/molecules/StatsCard.tsx
var DEFAULT_BASE_CLASS5 = "flex lg:flex-col items-center text-center gap-4 md:p-6 p-4 rounded-[10px] bg-(--benefits-card-bg) md:flex-row";
var DEFAULT_TITLE_CLASS4 = "text-(--benefits-card-text) lg:text-xl text-lg font-semibold";
var StatsCard = ({
  title,
  percentage,
  className,
  titleClassName
}) => {
  const baseClass = classNames21(DEFAULT_BASE_CLASS5, className);
  const titleClass = classNames21(DEFAULT_TITLE_CLASS4, titleClassName);
  return /* @__PURE__ */ React115.createElement(Container, { className: baseClass }, /* @__PURE__ */ React115.createElement(ProgressCircle_default, { percentage: percentage || 80, fillColor: "var(--benefits-card-bg)" }), /* @__PURE__ */ React115.createElement(Text, { className: titleClass }, title));
};

// src/organisms/Floater.tsx
import React116 from "react";
import classNames22 from "classnames";
var DEFAULT_WRAPPER_CLASS3 = "floater-bg";
var DEFAULT_BASE_CLASS6 = "flex md:justify-between max-w-body mx-auto px-4 py-2 gap-4 md:gap-0 flex-col-reverse md:flex-row items-center md:items-left";
var DEFAULT_FLOATER_IMAGE_CLASS = "rounded-[10px] max-h-[40px] lg:max-h-[56px]";
var DEFAULT_FLOATER_INFO_CLASS = "flex flex-col gap-2";
var DEFAULT_RATINGBANNER_CLASS = "";
var DEFAULT_LABELTEXT_CLASS = "text-(--floater-text-color) text-sm lg:text-xl hidden xs:block";
var DEFAULT_FLOATER_WRAPPER_CLASS = "flex gap-2 items-center";
var Floater = ({
  floater,
  children,
  className,
  baseClassName,
  wrapperClassName,
  classes = {}
}) => {
  const wrapperClass = classNames22(
    DEFAULT_WRAPPER_CLASS3,
    wrapperClassName,
    baseClassName,
    classes.wrapper
  );
  const baseClass = classNames22(
    DEFAULT_BASE_CLASS6,
    className,
    baseClassName,
    classes.base,
    classes.floater
  );
  const floaterImageClass = classNames22(DEFAULT_FLOATER_IMAGE_CLASS, classes.floaterImage);
  const floaterInfoClass = classNames22(DEFAULT_FLOATER_INFO_CLASS, classes.floaterInfo);
  const ratingBannerClass = classNames22(DEFAULT_RATINGBANNER_CLASS, classes.ratingBanner);
  const labelTextClass = classNames22(DEFAULT_LABELTEXT_CLASS, classes.labelText);
  const floaterWrapperClass = classNames22(DEFAULT_FLOATER_WRAPPER_CLASS, classes.floaterWrapper);
  return /* @__PURE__ */ React116.createElement(Container, { className: wrapperClass }, /* @__PURE__ */ React116.createElement("div", { className: baseClass }, /* @__PURE__ */ React116.createElement("div", { className: floaterWrapperClass }, /* @__PURE__ */ React116.createElement("img", { src: floater == null ? void 0 : floater.image, className: floaterImageClass }), /* @__PURE__ */ React116.createElement("div", { className: floaterInfoClass }, /* @__PURE__ */ React116.createElement(
    RatingBanner,
    {
      stars: floater == null ? void 0 : floater.stars_image,
      reviewLabel: floater == null ? void 0 : floater.tr_rating_label,
      rating: floater == null ? void 0 : floater.rating_count,
      containerClass: ratingBannerClass,
      classes: {
        ratingText: "text-(--floater-text-color) lg:text-base",
        text: "text-(--floater-text-color) lg:text-base font-semibold xs:font-normal"
      }
    }
  ), /* @__PURE__ */ React116.createElement(Text, { className: labelTextClass }, floater == null ? void 0 : floater.tr_label))), children));
};

// src/molecules/ZigzagCard.tsx
import React117 from "react";
import classNames23 from "classnames";
var DEFAULT_CONTAINER_CLASS11 = "grid grid-cols-1 md:grid-cols-2 gap-0";
var DEFAULT_VIDEO_WRAPPER_CLASS = "w-full";
var DEFAULT_VIDEO_CLASS = "w-full h-auto";
var DEFAULT_TITLE_WRAPPER_CLASS = "gap-6 bg-(--zigzag-card-bg-color) flex flex-col justify-center max-w-[550px] md:p-8 p-6";
var DEFAULT_TITLE_CLASS5 = "lg:text-[32px] block font-black text-[28px]";
var DEFAULT_DESCRIPTION_CLASS5 = "text-(--zigzag-card-text) block text-lg";
var ZigzagCard = ({
  tr_title,
  tr_description,
  src,
  poster,
  reverse = false,
  className,
  classes = {}
}) => {
  const containerClass = classNames23(DEFAULT_CONTAINER_CLASS11, className, classes.container);
  const videoWrapperClass = classNames23(
    DEFAULT_VIDEO_WRAPPER_CLASS,
    reverse ? "order-1 md:order-1" : "order-1 md:order-2",
    classes.videoWrapper
  );
  const titleWrapperClass = classNames23(
    DEFAULT_TITLE_WRAPPER_CLASS,
    reverse ? "order-2 md:order-2" : "order-2 md:order-1",
    classes.titleWrapper
  );
  const videoClass = classNames23(DEFAULT_VIDEO_CLASS, classes.video);
  const titleClass = classNames23(DEFAULT_TITLE_CLASS5, classes.title);
  const descriptionClass = classNames23(DEFAULT_DESCRIPTION_CLASS5, classes.description);
  return /* @__PURE__ */ React117.createElement(Container, { className: containerClass }, /* @__PURE__ */ React117.createElement("div", { className: videoWrapperClass }, /* @__PURE__ */ React117.createElement(Video, { src, className: videoClass, poster })), /* @__PURE__ */ React117.createElement("div", { className: titleWrapperClass }, /* @__PURE__ */ React117.createElement(Text, { variant: "base", className: titleClass }, tr_title), /* @__PURE__ */ React117.createElement(Text, { className: descriptionClass }, tr_description)));
};

// src/molecules/RecommendedCard.tsx
import React118 from "react";
import classNames24 from "classnames";
var DEFAULT_CLASSES = {
  root: "p-6 border border-(--happy-users-border-color) rounded-[10px] flex gap-4 flex-col flex-1 justify-between",
  header: "flex items-center gap-4",
  image: "rounded-full size-[40px]",
  name: "text-(--happy-users-name-color) font-bold",
  description: "text-(--happy-users-description-color) text-lg",
  recommended: "flex gap-1",
  checkmarkIcon: "size-[20px]",
  recommendedLabel: "text-(--happy-users-recommended-label-color) font-semibold",
  contentClassName: "flex flex-col gap-4"
};
var RecommendedCard = ({
  name,
  description,
  checkmarkIcon,
  image,
  recommendedLabel,
  classes = {}
}) => {
  const rootClass = classNames24(DEFAULT_CLASSES.root, classes.root);
  const headerClass = classNames24(DEFAULT_CLASSES.header, classes.header);
  const imageClass = classNames24(DEFAULT_CLASSES.image, classes.image);
  const nameClass = classNames24(DEFAULT_CLASSES.name, classes.name);
  const descriptionClass = classNames24(DEFAULT_CLASSES.description, classes.description);
  const recommendedClass = classNames24(DEFAULT_CLASSES.recommended, classes.recommended);
  const checkmarkIconClass = classNames24(DEFAULT_CLASSES.checkmarkIcon, classes.checkmarkIcon);
  const contentClass = classNames24(DEFAULT_CLASSES.contentClassName, classes.contentClassName);
  const recommendedLabelClass = classNames24(
    DEFAULT_CLASSES.recommendedLabel,
    classes.recommendedLabel
  );
  return /* @__PURE__ */ React118.createElement(Container, { className: rootClass }, /* @__PURE__ */ React118.createElement("div", { className: contentClass }, /* @__PURE__ */ React118.createElement("div", { className: headerClass }, /* @__PURE__ */ React118.createElement(Icon, { className: imageClass, src: image }), /* @__PURE__ */ React118.createElement(Text, { className: nameClass }, name)), /* @__PURE__ */ React118.createElement(Text, { className: descriptionClass }, description)), /* @__PURE__ */ React118.createElement("div", { className: recommendedClass }, /* @__PURE__ */ React118.createElement(Icon, { src: checkmarkIcon, className: checkmarkIconClass }), /* @__PURE__ */ React118.createElement(Text, { className: recommendedLabelClass }, recommendedLabel)));
};

// src/molecules/ProvenResultsBanner.tsx
import React119 from "react";
import classNames25 from "classnames";
var DEFAULT_CLASSES2 = {
  root: "flex md:flex-row flex-col",
  leftContainer: "justify-center rounded-tr-[10px] rounded-tl-[10px] md:rounded-tr-none md:rounded-l-[10px] border-t border-b border-l border-(--happy-users-proven-border-color) bg-(--happy-users-proven-bg-color) py-2 px-4 md:p-6 flex items-center md:flex-col gap-4",
  icon: "size-[40px] md:size-[70px]",
  provenTitle: "whitespace-nowrap font-black text-white text-xl",
  rightContainer: "flex flex-col gap-4 rounded-br-[10px] rounded-bl-[10px] md:rounded-bl-none md:rounded-r-[10px] md:border-t border-b border-r border-l md:border-l-none border-(--happy-users-proven-border-color) bg-(--happy-users-proven-secondary-bg-color) p-6",
  title: "block text-[20px] lg:text-[32px] font-black",
  description: "text-(--happy-users-proven-description-color)"
};
var DEFAULT_VAR_STYLE = {
  "--happy-users-proven-border-color": "var(--theme-color-border, #cccccc)",
  "--happy-users-proven-bg-color": "var(--theme-color-bg-raised, #ffffff)",
  "--happy-users-proven-secondary-bg-color": "var(--theme-color-bg-section, #f5f5f5)",
  "--happy-users-proven-description-color": "var(--theme-color-text-secondary, #666666)"
};
var ProvenResultsBanner = ({
  checkmarkIcon,
  provenTitle,
  title,
  description,
  classes = {}
}) => {
  const rootClass = classNames25(DEFAULT_CLASSES2.root, classes.root);
  const leftContainerClass = classNames25(DEFAULT_CLASSES2.leftContainer, classes.leftContainer);
  const iconClass = classNames25(DEFAULT_CLASSES2.icon, classes.icon);
  const provenTitleClass = classNames25(DEFAULT_CLASSES2.provenTitle, classes.provenTitle);
  const rightContainerClass = classNames25(DEFAULT_CLASSES2.rightContainer, classes.rightContainer);
  const titleClass = classNames25(DEFAULT_CLASSES2.title, classes.title);
  const descriptionClass = classNames25(DEFAULT_CLASSES2.description, classes.description);
  return /* @__PURE__ */ React119.createElement(Container, { className: rootClass, style: DEFAULT_VAR_STYLE }, /* @__PURE__ */ React119.createElement("div", { className: leftContainerClass }, checkmarkIcon && /* @__PURE__ */ React119.createElement(Icon, { className: iconClass, src: checkmarkIcon }), /* @__PURE__ */ React119.createElement(Text, { className: provenTitleClass }, provenTitle)), /* @__PURE__ */ React119.createElement("div", { className: rightContainerClass }, /* @__PURE__ */ React119.createElement(Text, { className: titleClass }, title), /* @__PURE__ */ React119.createElement(Text, { className: descriptionClass }, description)));
};

// src/molecules/ComparisonCard.tsx
import React120 from "react";
import classNames26 from "classnames";
var DEFAULT_CLASSES3 = {
  root: "bg-(--comparison-card-bg) rounded-[10px] w-full overflow-hidden flex flex-col",
  image: "w-full h-auto max-h-[300px] rounded-t-[10px] object-cover",
  content: "p-6 flex flex-col gap-6",
  label: "font-black text-[28px]",
  section: "flex flex-col gap-4",
  item: "text-lg flex gap-2 items-center",
  icon: "",
  text: "text-lg font-medium text-(--comparison-proscons-text-color)"
};
function renderIcon(icon, iconClass) {
  if (!icon) return null;
  if (typeof icon === "string") {
    return /* @__PURE__ */ React120.createElement(Icon, { className: iconClass, src: icon });
  }
  return /* @__PURE__ */ React120.createElement("span", { className: iconClass }, icon);
}
function toNonEmptyStrings(arr) {
  return (arr != null ? arr : []).filter((v) => typeof v === "string" && v.trim().length > 0);
}
var ComparisonCard = ({
  label,
  image,
  imageAlt,
  pros,
  cons,
  prosIcon,
  consIcon,
  classes = {}
}) => {
  const rootClass = classNames26(DEFAULT_CLASSES3.root, classes.root);
  const imageClass = classNames26(DEFAULT_CLASSES3.image, classes.image);
  const contentClass = classNames26(DEFAULT_CLASSES3.content, classes.content);
  const labelClass = classNames26(DEFAULT_CLASSES3.label, classes.label);
  const sectionClass = classNames26(DEFAULT_CLASSES3.section, classes.section);
  const itemClass = classNames26(DEFAULT_CLASSES3.item, classes.item);
  const iconClass = classNames26(DEFAULT_CLASSES3.icon, classes.icon);
  const textClass = classNames26(DEFAULT_CLASSES3.text, classes.text);
  const prosList = toNonEmptyStrings(pros);
  const consList = toNonEmptyStrings(cons);
  return /* @__PURE__ */ React120.createElement(Container, { className: rootClass }, image && /* @__PURE__ */ React120.createElement(Image, { src: image, alt: imageAlt || label, className: imageClass }), /* @__PURE__ */ React120.createElement("div", { className: contentClass }, /* @__PURE__ */ React120.createElement(Text, { className: labelClass }, label), prosList.length > 0 && /* @__PURE__ */ React120.createElement("div", { className: sectionClass }, prosList.map((item, idx) => /* @__PURE__ */ React120.createElement("div", { key: idx, className: itemClass }, renderIcon(prosIcon, iconClass), /* @__PURE__ */ React120.createElement(Text, { className: textClass }, item)))), consList.length > 0 && /* @__PURE__ */ React120.createElement("div", { className: sectionClass }, consList.map((item, idx) => /* @__PURE__ */ React120.createElement("div", { key: idx, className: itemClass }, renderIcon(consIcon, iconClass), /* @__PURE__ */ React120.createElement(Text, { className: textClass }, item))))));
};

// src/molecules/PercentageProgress.tsx
import React121, { useEffect as useEffect5, useRef as useRef4, useState as useState5 } from "react";
import classNames27 from "classnames";
var DEFAULT_BASE_CLASS7 = "flex flex-col w-full gap-4 lg:flex-row lg:items-center";
var DEFAULT_PERCENT_TEXT = "text-(--statistics-percentage-color) text-[40px] font-black leading-[40px] lg:leading-[56px] lg:text-[56px]";
var DEFAULT_TITLE_TEXT = "font-semibold text-(--statistics-statistics-title-color) text-lg leading-[26px]";
var DEFAULT_BAR_CONTAINER = "w-full h-6 rounded-[5px] overflow-hidden flex bg-(--statistics-empty-bar-color)";
var DEFAULT_FILLED_BAR = "h-full";
var DEFAULT_EMPTY_BAR = "";
var PercentageProgress = ({
  percentage,
  title,
  className,
  baseClassName,
  classes = {},
  duration = 6e3,
  startOnVisible = true,
  visibilityThreshold = 0.3
}) => {
  const target = Math.max(0, Math.min(100, percentage));
  const rootRef = useRef4(null);
  const rafRef = useRef4(null);
  const startTimeRef = useRef4(null);
  const fromPercentRef = useRef4(0);
  const targetPercentRef = useRef4(target);
  const hasAnimatedToTargetRef = useRef4(false);
  const [isVisible, setIsVisible] = useState5(!startOnVisible);
  const [currentPercent, setCurrentPercent] = useState5(startOnVisible ? 0 : target);
  const [reducedMotion, setReducedMotion] = useState5(false);
  useEffect5(() => {
    var _a;
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(mq.matches);
    update();
    (_a = mq.addEventListener) == null ? void 0 : _a.call(mq, "change", update);
    return () => {
      var _a2;
      return (_a2 = mq.removeEventListener) == null ? void 0 : _a2.call(mq, "change", update);
    };
  }, []);
  useEffect5(() => {
    if (!startOnVisible) {
      setIsVisible(true);
      return;
    }
    const el = rootRef.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(el);
          }
        }
      },
      { threshold: visibilityThreshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [startOnVisible, visibilityThreshold]);
  useEffect5(() => {
    targetPercentRef.current = target;
    if (reducedMotion) {
      setCurrentPercent(target);
      hasAnimatedToTargetRef.current = true;
      return;
    }
    if (!isVisible) {
      if (startOnVisible) setCurrentPercent(0);
      hasAnimatedToTargetRef.current = false;
      return;
    }
    if (hasAnimatedToTargetRef.current && Math.round(currentPercent) === Math.round(target)) {
      return;
    }
    fromPercentRef.current = currentPercent;
    startTimeRef.current = null;
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
    const animate = (ts) => {
      if (startTimeRef.current === null) startTimeRef.current = ts;
      const elapsed = ts - startTimeRef.current;
      const clamped = Math.min(elapsed, duration);
      const t = duration === 0 ? 1 : clamped / duration;
      const eased = easeOutCubic(t);
      const next = fromPercentRef.current + (targetPercentRef.current - fromPercentRef.current) * eased;
      setCurrentPercent(next);
      if (clamped < duration) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        setCurrentPercent(targetPercentRef.current);
        hasAnimatedToTargetRef.current = true;
        startTimeRef.current = null;
        rafRef.current = null;
      }
    };
    if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(animate);
    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, [target, isVisible, duration, reducedMotion, startOnVisible]);
  useEffect5(() => {
    return () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    };
  }, []);
  const baseClass = classNames27(
    DEFAULT_BASE_CLASS7,
    className,
    baseClassName,
    classes.container,
    classes.base
  );
  const percentTextClass = classNames27(DEFAULT_PERCENT_TEXT, classes.percentText);
  const titleTextClass = classNames27(DEFAULT_TITLE_TEXT, classes.titleText);
  const barContainerClass = classNames27(DEFAULT_BAR_CONTAINER, classes.barContainer);
  const filledBarClass = classNames27(DEFAULT_FILLED_BAR, classes.filledBar);
  const emptyBarClass = classNames27(DEFAULT_EMPTY_BAR, classes.emptyBar);
  const displayPercent = Math.round(Math.max(0, Math.min(100, currentPercent)));
  return /* @__PURE__ */ React121.createElement("div", { ref: rootRef, style: { width: "100%" } }, /* @__PURE__ */ React121.createElement(Container, { className: baseClass, "aria-label": `${title} progress` }, /* @__PURE__ */ React121.createElement(Text, { className: classNames27("hidden lg:block", percentTextClass) }, displayPercent, "%"), /* @__PURE__ */ React121.createElement(Container, { className: "flex flex-col flex-1 w-full gap-4 lg:gap-2" }, /* @__PURE__ */ React121.createElement(Container, { className: "flex flex-row items-center gap-4" }, /* @__PURE__ */ React121.createElement(Text, { className: classNames27("lg:hidden", percentTextClass) }, displayPercent, "%"), /* @__PURE__ */ React121.createElement(Text, { className: titleTextClass }, title)), /* @__PURE__ */ React121.createElement(
    Container,
    {
      className: barContainerClass,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": displayPercent,
      "aria-label": title
    },
    /* @__PURE__ */ React121.createElement(
      Container,
      {
        className: filledBarClass,
        style: {
          width: `${Math.max(0, Math.min(100, currentPercent))}%`,
          background: "var(--statistics-progress-bar-gradient)",
          transition: reducedMotion ? void 0 : "box-shadow 200ms ease",
          willChange: "width"
        }
      }
    ),
    /* @__PURE__ */ React121.createElement("div", { className: emptyBarClass, "aria-hidden": true })
  ))));
};

// src/organisms/Statistics.tsx
import React122 from "react";
import classNames28 from "classnames";
var DEFAULT_LIST_CLASS = "w-full flex flex-col gap-[20px]";
var DEFAULT_DIVIDER_CLASS2 = "border-t border-(--statistics-divider-color)";
var Statistics = ({
  statisticsData = [],
  className,
  classes = {}
}) => {
  const listClass = classNames28(DEFAULT_LIST_CLASS, classes.list);
  return /* @__PURE__ */ React122.createElement(Container, { className }, /* @__PURE__ */ React122.createElement("div", { className: "flex flex-col" }, /* @__PURE__ */ React122.createElement("div", { className: listClass }, statisticsData.map((stat, idx) => /* @__PURE__ */ React122.createElement(React122.Fragment, { key: idx }, /* @__PURE__ */ React122.createElement(
    PercentageProgress,
    {
      percentage: stat.percentage,
      title: stat.tr_title,
      className: classes.statProgress
    }
  ), idx < statisticsData.length - 1 && /* @__PURE__ */ React122.createElement("hr", { className: classNames28(DEFAULT_DIVIDER_CLASS2, classes.divider) }))))));
};

// src/organisms/ExpertCard.tsx
import React123 from "react";
import classNames29 from "classnames";
var DEFAULT_CONTAINER_CLASS12 = "flex md:px-8 md:pt-6 px-4 pt-6 gap-16 rounded-[10px] bg-(--statistics-card-background-color) md:flex-row flex-col-reverse md:items-end";
var DEFAULT_IMAGE_DESKTOP_CLASS = "max-h-[408px] hidden md:block";
var DEFAULT_CONTENT_CLASS6 = "";
var DEFAULT_MEETLABEL_CLASS = "block text-lg lg:text-xl font-semibold text-(--statistics-meet-label-color)";
var DEFAULT_OUREXPERTS_LABEL_CLASS = "block text-[32px] lg:text-[40px] mt-2 leading-[40px] font-black text-(--statistics-expert-primary-color)";
var DEFAULT_DESCRIPTION_CLASS6 = "block text-base lg:text-lg py-6 text-(--statistics-expert-secondary-color)";
var DEFAULT_NAME_CLASS = "block text-xl font-semibold text-(--statistics-expert-secondary-color)";
var DEFAULT_OCCUPATION_CLASS = "block mb-6 text-(--statistics-expert-secondary-color)";
var DEFAULT_SIGNATURE_ROW_CLASS = "grid grid-cols-2";
var DEFAULT_SIGNATURE_IMAGE_CLASS = "max-w-[143px] w-full h-auto flex-1 md:mb-6";
var DEFAULT_IMAGE_MOBILE_CLASS = "max-h-[408px] block md:hidden flex-1";
var ExpertCard = ({
  image,
  meetLabel,
  ourExpertsLabel,
  name,
  occupation,
  description,
  signatureImage,
  className,
  classes = {}
}) => {
  const containerCls = classNames29(DEFAULT_CONTAINER_CLASS12, className, classes.container);
  const imageDesktopCls = classNames29(DEFAULT_IMAGE_DESKTOP_CLASS, classes.imageDesktop);
  const contentCls = classNames29(DEFAULT_CONTENT_CLASS6, classes.content);
  const meetLabelCls = classNames29(DEFAULT_MEETLABEL_CLASS, classes.meetLabel);
  const ourExpertsLabelCls = classNames29(DEFAULT_OUREXPERTS_LABEL_CLASS, classes.ourExpertsLabel);
  const descriptionCls = classNames29(DEFAULT_DESCRIPTION_CLASS6, classes.description);
  const nameCls = classNames29(DEFAULT_NAME_CLASS, classes.name);
  const occupationCls = classNames29(DEFAULT_OCCUPATION_CLASS, classes.occupation);
  const signatureRowCls = classNames29(DEFAULT_SIGNATURE_ROW_CLASS, classes.signatureRow);
  const signatureImageCls = classNames29(DEFAULT_SIGNATURE_IMAGE_CLASS, classes.signatureImage);
  const imageMobileCls = classNames29(DEFAULT_IMAGE_MOBILE_CLASS, classes.imageMobile);
  return /* @__PURE__ */ React123.createElement(Container, { className: containerCls }, /* @__PURE__ */ React123.createElement(Image, { className: imageDesktopCls, src: image, alt: `${name} - ${occupation}` }), /* @__PURE__ */ React123.createElement("div", { className: contentCls }, /* @__PURE__ */ React123.createElement(Text, { className: meetLabelCls }, meetLabel), /* @__PURE__ */ React123.createElement(Text, { className: ourExpertsLabelCls }, ourExpertsLabel), /* @__PURE__ */ React123.createElement(Text, { className: descriptionCls }, description), /* @__PURE__ */ React123.createElement(Text, { className: nameCls }, name), /* @__PURE__ */ React123.createElement(Text, { className: occupationCls }, occupation), /* @__PURE__ */ React123.createElement("div", { className: signatureRowCls }, /* @__PURE__ */ React123.createElement(Image, { className: signatureImageCls, src: signatureImage, alt: `${name} signature` }), /* @__PURE__ */ React123.createElement(Image, { className: imageMobileCls, src: image, alt: `${name} - ${occupation}` }))));
};

// src/organisms/Steps.tsx
import React125 from "react";
import classNames31 from "classnames";

// src/molecules/StepCard.tsx
import React124 from "react";
import classNames30 from "classnames";
var DEFAULT_CONTAINER_CLASS13 = "flex border border-(--steps-card-border-color) rounded-[10px] overflow-hidden bg-(--steps-card-background-color) flex-col md:flex-row max-w-[900px]";
var DEFAULT_IMAGE_CLASS = "md:max-w-[240px] object-contain";
var DEFAULT_CONTENT_CLASS7 = "p-6 flex flex-col gap-4 justify-center";
var DEFAULT_STEP_LABEL_CLASS = "block font-black lg:text-[20px] text-lg text-(--steps-label-color)";
var DEFAULT_TITLE_CLASS6 = "block font-black lg:text-[32px] text-[20px] text-(--steps-card-title-color) leading-[32px]";
var DEFAULT_DESCRIPTION_CLASS7 = "block text-lg text-(--steps-card-description-color)";
var StepCard = ({
  index,
  step,
  title,
  description,
  image,
  className,
  classes = {}
}) => {
  const containerCls = classNames30(DEFAULT_CONTAINER_CLASS13, className, classes.container);
  const imageCls = classNames30(DEFAULT_IMAGE_CLASS, classes.image);
  const contentCls = classNames30(DEFAULT_CONTENT_CLASS7, classes.content);
  const stepLabelCls = classNames30(DEFAULT_STEP_LABEL_CLASS, classes.stepLabel);
  const titleCls = classNames30(DEFAULT_TITLE_CLASS6, classes.title);
  const descriptionCls = classNames30(DEFAULT_DESCRIPTION_CLASS7, classes.description);
  return /* @__PURE__ */ React124.createElement(Container, { className: containerCls }, /* @__PURE__ */ React124.createElement(Image, { className: imageCls, src: image, alt: (title == null ? void 0 : title.toString()) || "Step Image" }), /* @__PURE__ */ React124.createElement(Container, { className: contentCls }, /* @__PURE__ */ React124.createElement(Text, { className: stepLabelCls }, step, " ", index + 1), /* @__PURE__ */ React124.createElement(Text, { className: titleCls }, title), /* @__PURE__ */ React124.createElement(Text, { className: descriptionCls }, description)));
};

// src/organisms/Steps.tsx
var DEFAULT_CONTAINER_CLASS14 = "flex gap-8 justify-center";
var DEFAULT_INDICATOR_IMAGE_CLASS = "hidden md:block";
var DEFAULT_STEP_CONTAINER_CLASS = "flex flex-col gap-4";
var DEFAULT_STEP_CARD_CLASS = "";
var Steps = ({
  steps,
  stepLabel,
  indicatorImage,
  className,
  classes = {}
}) => {
  const containerCls = classNames31(DEFAULT_CONTAINER_CLASS14, className, classes.container);
  const indicatorImageCls = classNames31(DEFAULT_INDICATOR_IMAGE_CLASS, classes.indicatorImage);
  const stepsContainerCls = classNames31(DEFAULT_STEP_CONTAINER_CLASS, classes.stepsContainer);
  const stepCardCls = classNames31(DEFAULT_STEP_CARD_CLASS, classes.stepCard);
  return /* @__PURE__ */ React125.createElement(Container, { className: containerCls }, /* @__PURE__ */ React125.createElement(Image, { className: indicatorImageCls, src: indicatorImage }), /* @__PURE__ */ React125.createElement("div", { className: stepsContainerCls }, steps.map((stepItem, index) => /* @__PURE__ */ React125.createElement(
    StepCard,
    {
      key: index,
      index,
      title: stepItem.tr_title,
      step: stepLabel,
      description: stepItem.tr_description,
      image: stepItem.image,
      className: stepCardCls
    }
  ))));
};

// src/organisms/ReviewStatistics.tsx
import React127 from "react";
import classNames32 from "classnames";

// src/atoms/Stars.tsx
import React126 from "react";
var TRUSTPILOT_STAR_PATH = "M12,2.5 L14.23,8.93 L21.04,9.06 L15.61,13.17 L17.58,19.69 L12,15.8 L6.42,19.69 L8.39,13.17 L2.96,9.06 L9.77,8.93 Z";
var TrustpilotStars = ({
  score,
  className
}) => {
  const filledCount = score >= 4.5 ? 5 : score >= 3.5 ? 4 : score >= 2.5 ? 3 : score >= 1.5 ? 2 : 1;
  const W = 20;
  const GAP = 4;
  const total = 5 * W + 4 * GAP;
  return /* @__PURE__ */ React126.createElement(
    "svg",
    {
      width: total,
      height: W,
      viewBox: `0 0 ${total} ${W}`,
      fill: "none",
      className,
      "aria-hidden": "true"
    },
    Array.from({ length: 5 }, (_, i) => /* @__PURE__ */ React126.createElement("g", { key: i, transform: `translate(${i * (W + GAP)}, 0)` }, /* @__PURE__ */ React126.createElement("rect", { width: W, height: W, rx: 2, fill: i < filledCount ? "#00B67A" : "#DCDCE6" }), /* @__PURE__ */ React126.createElement("g", { transform: `scale(${W / 24})` }, /* @__PURE__ */ React126.createElement("path", { d: TRUSTPILOT_STAR_PATH, fill: "white" }))))
  );
};
var BASE_STAR_PATH = "M15.5754 5.71885L10.6567 4.96639L8.45208 0.263392C8.28741 -0.0877974 7.71208 -0.0877974 7.54741 0.263392L5.34342 4.96639L0.424765 5.71885C0.0207661 5.78094 -0.140567 6.27301 0.142766 6.56344L3.71609 10.2316L2.87143 15.4173C2.80409 15.8292 3.24342 16.1384 3.60676 15.9361L8.00008 13.5044L12.3934 15.9367C12.7534 16.137 13.1967 15.8339 13.1287 15.418L12.2841 10.2322L15.8574 6.56411C16.1407 6.27301 15.9787 5.78094 15.5754 5.71885Z";
var HALF_STAR_LEFT_PATH = "M87.999 13.5039L83.6064 15.9355C83.2432 16.1375 82.8038 15.8278 82.8711 15.416L83.7158 10.2305L80.1426 6.56348C79.8593 6.27307 80.0209 5.78087 80.4248 5.71875L85.3428 4.96582L87.5469 0.263672C87.6292 0.0881849 87.8141 9.70826e-05 87.999 0V13.5039Z";
var HALF_STAR_RIGHT_PATH = "M87.9995 0C88.1844 8.09536e-05 88.3694 0.0881688 88.4517 0.263672L90.6558 4.96582L95.5747 5.71875C95.9778 5.78104 96.1392 6.27247 95.856 6.56348L92.2837 10.2314L93.1274 15.417C93.1954 15.8328 92.753 16.1356 92.3931 15.9355L87.9995 13.5039V0Z";
var FILLED_COLOR = "#FFCB13";
var EMPTY_COLOR = "#E1E6F5";
var HALF_EMPTY_COLOR = "#F0F0F0";
var VARIANT_FILLED = {
  five: 5,
  fourHalf: 4,
  four: 4,
  three: 3,
  two: 2,
  one: 1
};
var StarRating = ({ variant, size = 16, gap = 4, emptyColor = EMPTY_COLOR, className }) => {
  var _a;
  const filledCount = (_a = VARIANT_FILLED[variant]) != null ? _a : 5;
  const hasHalf = variant === "fourHalf";
  const scale = size / 16;
  const totalWidth = 5 * size + 4 * gap;
  return /* @__PURE__ */ React126.createElement(
    "svg",
    {
      width: totalWidth,
      height: size,
      viewBox: `0 0 ${totalWidth} ${size}`,
      fill: "none",
      className,
      "aria-hidden": "true"
    },
    Array.from({ length: 5 }, (_, i) => {
      const x = i * (size + gap);
      if (hasHalf && i === 4) {
        return /* @__PURE__ */ React126.createElement("g", { key: i, transform: `translate(${x}, 0)` }, /* @__PURE__ */ React126.createElement("g", { transform: `scale(${scale})` }, /* @__PURE__ */ React126.createElement("g", { transform: "translate(-80, 0)" }, /* @__PURE__ */ React126.createElement("path", { d: HALF_STAR_LEFT_PATH, fill: FILLED_COLOR }), /* @__PURE__ */ React126.createElement("path", { d: HALF_STAR_RIGHT_PATH, fill: HALF_EMPTY_COLOR }))));
      }
      return /* @__PURE__ */ React126.createElement("g", { key: i, transform: `translate(${x}, 0)` }, /* @__PURE__ */ React126.createElement("g", { transform: `scale(${scale})` }, /* @__PURE__ */ React126.createElement("path", { d: BASE_STAR_PATH, fill: i < filledCount ? FILLED_COLOR : emptyColor })));
    })
  );
};
var STAR_SVG = {
  five: /* @__PURE__ */ React126.createElement(StarRating, { variant: "five" }),
  fourHalf: /* @__PURE__ */ React126.createElement(StarRating, { variant: "fourHalf" }),
  four: /* @__PURE__ */ React126.createElement(StarRating, { variant: "four" }),
  three: /* @__PURE__ */ React126.createElement(StarRating, { variant: "three" }),
  two: /* @__PURE__ */ React126.createElement(StarRating, { variant: "two" }),
  one: /* @__PURE__ */ React126.createElement(StarRating, { variant: "one" })
};

// src/organisms/ReviewStatistics.tsx
var DEFAULT_CONTAINER_CLASS15 = "flex justify-center md:flex-row flex-col items-center gap-6 md:gap-0";
var DEFAULT_RATINGBOX_CLASS = "text-center md:border-r border-(--reviews-divider-color) flex flex-col justify-center";
var DEFAULT_RATINGVALUE_CLASS = "md:mr-6 w-fit text-7xl font-black text-(--reviews-global-rating-text-color)";
var DEFAULT_RATINGLABEL_CLASS = "w-fit text-(--reviews-reviews-count-color)";
var DEFAULT_STARSBOX_CLASS = "flex-1 md:pl-6 flex flex-col justify-center max-w-fit gap-2";
var DEFAULT_STARROW_CLASS = "flex items-center gap-2";
var DEFAULT_STARICON_CLASS = "";
var DEFAULT_BARCONTAINER_CLASS = "flex-1 h-3 bg-(--reviews-empty-bar-color) rounded-lg w-[168px]";
var DEFAULT_BAREMPTY_CLASS = "h-full";
var DEFAULT_BARFILLED_CLASS = "bg-(--reviews-filled-bar-color) h-full rounded-lg";
var DEFAULT_COUNTTEXT_CLASS = "min-w-[30px] text-right text-xs text-(--reviews-star-rating-count-color)";
var StarRow = ({ svg, count, maxCount, classes = {} }) => {
  const starRowCls = classNames32(DEFAULT_STARROW_CLASS, classes.starRow);
  const starIconCls = classNames32(DEFAULT_STARICON_CLASS, classes.starIcon);
  const barContainerCls = classNames32(DEFAULT_BARCONTAINER_CLASS, classes.barContainer);
  const barEmptyCls = classNames32(DEFAULT_BAREMPTY_CLASS, classes.barEmpty);
  const barFilledCls = classNames32(DEFAULT_BARFILLED_CLASS, classes.barFilled);
  const countTextCls = classNames32(DEFAULT_COUNTTEXT_CLASS, classes.countText);
  const percentage = maxCount > 0 ? Math.max(0, Math.min(100, Number(count) / Number(maxCount) * 100)) : 0;
  return /* @__PURE__ */ React127.createElement(Container, { className: starRowCls }, /* @__PURE__ */ React127.createElement(Container, { className: starIconCls }, svg), /* @__PURE__ */ React127.createElement(Container, { className: barContainerCls }, /* @__PURE__ */ React127.createElement(Container, { className: barEmptyCls }, count >= 10 && /* @__PURE__ */ React127.createElement(
    Container,
    {
      className: barFilledCls,
      style: {
        width: maxCount > 0 ? `${count / maxCount * 100}%` : "0%"
      }
    }
  ))), /* @__PURE__ */ React127.createElement(Text, { className: countTextCls }, Number(count).toLocaleString("en-US")));
};
var ReviewStatistics = ({
  globalRating,
  oneStarCount,
  twoStarCount,
  threeStarCount,
  fourStarCount,
  fiveStarCount,
  reviewLabel,
  className,
  classes = {}
}) => {
  const starCounts = [fiveStarCount, fourStarCount, threeStarCount, twoStarCount, oneStarCount];
  const totalReviews = starCounts.reduce((a, b) => Number(a) + Number(b), 0);
  const maxCount = Math.max(...starCounts);
  const containerCls = classNames32(DEFAULT_CONTAINER_CLASS15, className, classes.container);
  const ratingBoxCls = classNames32(DEFAULT_RATINGBOX_CLASS, classes.ratingBox);
  const ratingValueCls = classNames32(DEFAULT_RATINGVALUE_CLASS, classes.ratingValue);
  const ratingLabelCls = classNames32(DEFAULT_RATINGLABEL_CLASS, classes.ratingLabel);
  const starsBoxCls = classNames32(DEFAULT_STARSBOX_CLASS, classes.starsBox);
  return /* @__PURE__ */ React127.createElement(Container, { className: containerCls }, /* @__PURE__ */ React127.createElement("div", { className: ratingBoxCls }, /* @__PURE__ */ React127.createElement(Text, { className: ratingValueCls }, globalRating), /* @__PURE__ */ React127.createElement(Text, { className: ratingLabelCls }, totalReviews, " ", reviewLabel)), /* @__PURE__ */ React127.createElement("div", { className: starsBoxCls }, /* @__PURE__ */ React127.createElement(
    StarRow,
    {
      svg: STAR_SVG.five,
      count: fiveStarCount,
      maxCount,
      starIndex: 5,
      classes
    }
  ), /* @__PURE__ */ React127.createElement(
    StarRow,
    {
      svg: STAR_SVG.four,
      count: fourStarCount,
      maxCount,
      starIndex: 4,
      classes
    }
  ), /* @__PURE__ */ React127.createElement(
    StarRow,
    {
      svg: STAR_SVG.three,
      count: threeStarCount,
      maxCount,
      starIndex: 3,
      classes
    }
  ), /* @__PURE__ */ React127.createElement(
    StarRow,
    {
      svg: STAR_SVG.two,
      count: twoStarCount,
      maxCount,
      starIndex: 2,
      classes
    }
  ), /* @__PURE__ */ React127.createElement(
    StarRow,
    {
      svg: STAR_SVG.one,
      count: oneStarCount,
      maxCount,
      starIndex: 1,
      classes
    }
  )));
};

// src/organisms/ReviewsList.tsx
import React129 from "react";
import classNames34 from "classnames";

// src/molecules/ReviewCard.tsx
import React128 from "react";
import classNames33 from "classnames";
var DEFAULT_CONTAINER_CLASS16 = "flex gap-6 py-6 flex-col md:flex-row";
var DEFAULT_HEADER_CLASS2 = "flex gap-2 items-center";
var DEFAULT_AVATAR_CLASS = "rounded-full size-[60px]";
var DEFAULT_AUTHORINFO_CLASS = "min-w-[142px]";
var DEFAULT_AUTHORNAME_CLASS = "text-(--reviews-name-color) font-medium";
var DEFAULT_VERIFIED_CLASS = "flex gap-1 items-center";
var DEFAULT_VERIFIEDICON_CLASS = "";
var DEFAULT_VERIFIEDLABEL_CLASS = "whitespace-nowrap text-xs text-(--reviews-verified-customer-color)";
var DEFAULT_REVIEWSECTION_CLASS = "flex gap-4 flex-1 items-start";
var DEFAULT_QUOTEICON_CLASS = "";
var DEFAULT_REVIEWCONTENT_CLASS = "flex flex-col gap-2";
var DEFAULT_REVIEWTITLE_CLASS = "font-bold md:text-xl text-(--reviews-review-title-color) text-lg";
var DEFAULT_STARS_CLASS = "";
var DEFAULT_REVIEWTEXT_CLASS = "md:text-lg text-(--reviews-review-color) text-base";
var ReviewCard = ({
  authorImage,
  name,
  title,
  review,
  starRating,
  verifiedLabel,
  verifiedIcon,
  quoteIcon,
  index,
  total,
  className,
  classes = {}
}) => {
  let borderClass = "border-t border-(--reviews-divider-color)";
  if (total && index === total - 1) {
    borderClass = "border-t border-b border-(--reviews-divider-color)";
  }
  const containerCls = classNames33(
    DEFAULT_CONTAINER_CLASS16,
    borderClass,
    className,
    classes.container
  );
  const headerCls = classNames33(DEFAULT_HEADER_CLASS2, classes.header);
  const avatarCls = classNames33(DEFAULT_AVATAR_CLASS, classes.avatar);
  const authorInfoCls = classNames33(DEFAULT_AUTHORINFO_CLASS, classes.authorInfo);
  const authorNameCls = classNames33(DEFAULT_AUTHORNAME_CLASS, classes.authorName);
  const verifiedCls = classNames33(DEFAULT_VERIFIED_CLASS, classes.verified);
  const verifiedIconCls = classNames33(DEFAULT_VERIFIEDICON_CLASS, classes.verifiedIcon);
  const verifiedLabelCls = classNames33(DEFAULT_VERIFIEDLABEL_CLASS, classes.verifiedLabel);
  const reviewSectionCls = classNames33(DEFAULT_REVIEWSECTION_CLASS, classes.reviewSection);
  const quoteIconCls = classNames33(DEFAULT_QUOTEICON_CLASS, classes.quoteIcon);
  const reviewContentCls = classNames33(DEFAULT_REVIEWCONTENT_CLASS, classes.reviewContent);
  const reviewTitleCls = classNames33(DEFAULT_REVIEWTITLE_CLASS, classes.reviewTitle);
  const starsCls = classNames33(DEFAULT_STARS_CLASS, classes.stars);
  const reviewTextCls = classNames33(DEFAULT_REVIEWTEXT_CLASS, classes.reviewText);
  return /* @__PURE__ */ React128.createElement(Container, { className: containerCls }, /* @__PURE__ */ React128.createElement("div", { className: headerCls }, /* @__PURE__ */ React128.createElement(Image, { className: avatarCls, src: authorImage, alt: name || "Author Image" }), /* @__PURE__ */ React128.createElement("div", { className: authorInfoCls }, /* @__PURE__ */ React128.createElement(Text, { className: authorNameCls }, name), /* @__PURE__ */ React128.createElement("div", { className: verifiedCls }, /* @__PURE__ */ React128.createElement(Icon, { src: verifiedIcon, className: verifiedIconCls }), /* @__PURE__ */ React128.createElement(Text, { className: verifiedLabelCls }, verifiedLabel)))), /* @__PURE__ */ React128.createElement("div", { className: reviewSectionCls }, /* @__PURE__ */ React128.createElement(Icon, { src: quoteIcon, className: quoteIconCls }), /* @__PURE__ */ React128.createElement("div", { className: reviewContentCls }, /* @__PURE__ */ React128.createElement(Text, { className: reviewTitleCls }, title), /* @__PURE__ */ React128.createElement("div", { className: starsCls }, starRating && STAR_SVG[starRating]), /* @__PURE__ */ React128.createElement(Text, { className: reviewTextCls }, review))));
};

// src/organisms/ReviewsList.tsx
var DEFAULT_CONTAINER_CLASS17 = "flex justify-center flex-col px-4";
var DEFAULT_ITEM_CLASS3 = "";
var DEFAULT_CARD_CLASS = "";
var ReviewsList = ({
  reviews,
  verifiedLabel,
  verifiedIcon,
  quoteIcon,
  containerClassName,
  itemClassName,
  cardClassName,
  cardInternalClasses,
  classes = {}
}) => {
  const baseClass = classNames34(DEFAULT_CONTAINER_CLASS17, containerClassName, classes.container);
  const itemClass = classNames34(DEFAULT_ITEM_CLASS3, itemClassName, classes.item);
  const cardCls = classNames34(DEFAULT_CARD_CLASS, cardClassName, classes.card);
  return /* @__PURE__ */ React129.createElement(Container, { className: baseClass }, reviews.map((item, index) => /* @__PURE__ */ React129.createElement("div", { key: index, className: itemClass }, /* @__PURE__ */ React129.createElement(
    ReviewCard,
    {
      index,
      authorImage: item == null ? void 0 : item.author_image,
      name: item == null ? void 0 : item.name,
      title: item == null ? void 0 : item.tr_title,
      review: item == null ? void 0 : item.tr_review,
      starRating: item == null ? void 0 : item.star_rating,
      total: reviews.length,
      verifiedLabel,
      verifiedIcon,
      quoteIcon,
      className: cardCls,
      classes: cardInternalClasses
    }
  ))));
};

// src/organisms/MoneyBack.tsx
import React130 from "react";
import classNames35 from "classnames";
var DEFAULT_WRAPPER_CLASS4 = "lg:py-16 md:py-10 px-4 py-6 bg-(--moneyback-section-background-color)";
var DEFAULT_CONTAINER_CLASS18 = "gap-8 flex max-w-[900px] mx-auto md:flex-row flex-col items-center";
var DEFAULT_IMAGE_CLASS2 = "max-w-[160px] md:max-w-none";
var DEFAULT_CONTENT_CLASS8 = "flex flex-col gap-4";
var DEFAULT_TITLE_CLASS7 = "block text-(--moneyback-title-color) font-black text-[32px] text-center md:text-left";
var DEFAULT_SUBTITLE_CLASS = "block font-bold text-xl text-(--moneyback-subtitle-color) text-center md:text-left";
var DEFAULT_DESCRIPTION_CLASS8 = "block font-bold text-lg text-(--moneyback-description-color) text-center md:text-left";
var DEFAULT_DIVIDER_CLASS3 = "border-t border-(--moneyback-divider-color) my-2";
var DEFAULT_PROTECTED_LABEL_CLASS = "block text-(--moneyback-protected-label-color) text-center md:text-left";
var DEFAULT_CARDS_IMAGE_CLASS = "w-full max-w-[359px] h-auto mx-auto md:mx-0";
var MoneyBack = ({
  title,
  subtitle,
  description,
  checkoutLabel,
  image,
  cardsImage,
  className,
  classes = {}
}) => {
  const wrapperCls = classNames35(DEFAULT_WRAPPER_CLASS4, className, classes.wrapper);
  const containerCls = classNames35(DEFAULT_CONTAINER_CLASS18, classes.container);
  const imageCls = classNames35(DEFAULT_IMAGE_CLASS2, classes.image);
  const contentCls = classNames35(DEFAULT_CONTENT_CLASS8, classes.content);
  const titleCls = classNames35(DEFAULT_TITLE_CLASS7, classes.title);
  const subtitleCls = classNames35(DEFAULT_SUBTITLE_CLASS, classes.subtitle);
  const descriptionCls = classNames35(DEFAULT_DESCRIPTION_CLASS8, classes.description);
  const dividerCls = classNames35(DEFAULT_DIVIDER_CLASS3, classes.divider);
  const protectedLabelCls = classNames35(DEFAULT_PROTECTED_LABEL_CLASS, classes.protectedLabel);
  const cardsImageCls = classNames35(DEFAULT_CARDS_IMAGE_CLASS, classes.cardsImage);
  return /* @__PURE__ */ React130.createElement(Container, { className: wrapperCls }, /* @__PURE__ */ React130.createElement("div", { className: containerCls }, /* @__PURE__ */ React130.createElement(Image, { src: image, alt: "Money Back Icon", className: imageCls }), /* @__PURE__ */ React130.createElement("div", { className: contentCls }, /* @__PURE__ */ React130.createElement(Text, { className: titleCls }, title), /* @__PURE__ */ React130.createElement(Text, { className: subtitleCls }, subtitle), /* @__PURE__ */ React130.createElement(Text, { className: descriptionCls }, description), /* @__PURE__ */ React130.createElement("hr", { className: dividerCls }), /* @__PURE__ */ React130.createElement("div", { className: "flex flex-col gap-2" }, /* @__PURE__ */ React130.createElement(Text, { className: protectedLabelCls }, checkoutLabel), /* @__PURE__ */ React130.createElement(Icon, { src: cardsImage, alt: "Cards Image", className: cardsImageCls })))));
};

// src/sections/Quiz.tsx
import React162, { useCallback as useCallback2, useState as useState9 } from "react";
import classNames63 from "classnames";

// src/interfaces/quizSteps.ts
var STEP_TYPES = {
  SINGLE_SELECT: "singleSelect",
  MULTISELECT: "multiselect",
  INFO: "info",
  FORM: "form",
  LOADING: "loading",
  CUSTOM: "custom"
};
var FORM_TYPES = {
  AGE: "age",
  HEIGHT: "height",
  WEIGHT: "weight",
  EMAIL: "email"
};
var FORM_UNITS = {
  IMPERIAL: "imperial",
  METRIC: "metric"
};

// src/templates/quiz/QuizEngine.tsx
import React137, { useEffect as useEffect6 } from "react";
import classNames41 from "classnames";

// src/store/useQuizStore.ts
import { create } from "zustand";
var DEFAULT_FIXED_BUTTON_TYPES = /* @__PURE__ */ new Set([
  STEP_TYPES.MULTISELECT,
  STEP_TYPES.INFO,
  STEP_TYPES.LOADING,
  STEP_TYPES.CUSTOM
]);
function prepareSteps(steps = []) {
  if (!Array.isArray(steps)) return [];
  return steps.map((step) => {
    var _a;
    return {
      ...step,
      showFixedButton: (_a = step == null ? void 0 : step.showFixedButton) != null ? _a : DEFAULT_FIXED_BUTTON_TYPES.has(step == null ? void 0 : step.type)
    };
  });
}
function getStepCanContinue(step) {
  return (step == null ? void 0 : step.type) === STEP_TYPES.INFO || (step == null ? void 0 : step.type) === STEP_TYPES.CUSTOM;
}
function getSelectedValues(quizData, field) {
  return Array.isArray(quizData[field]) ? quizData[field] : [];
}
function getStepByField(steps, field) {
  return steps.find(
    (step) => "field" in step && "options" in step && step.field === field
  );
}
function getNonExclusiveSelection(selectedValues, options = []) {
  return selectedValues.filter((selectedValue) => {
    const selectedOption = options.find((option) => option.value === selectedValue);
    return !(selectedOption == null ? void 0 : selectedOption.exclusive);
  });
}
function getNextSelection(selectedValues, value, isExclusive, options = []) {
  if (isExclusive) {
    return selectedValues.includes(value) ? [] : [value];
  }
  const nonExclusiveSelection = getNonExclusiveSelection(selectedValues, options);
  if (selectedValues.includes(value)) {
    return nonExclusiveSelection.filter((selectedValue) => selectedValue !== value);
  }
  return [...nonExclusiveSelection, value];
}
var useQuizStore = create((set, get) => ({
  currentStep: 1,
  steps: [],
  quizData: {},
  canContinue: false,
  onComplete: null,
  setConfig: ({ steps = [], onComplete = null, initialData = {} } = {}) => {
    const preparedSteps = prepareSteps(steps);
    set({
      currentStep: 1,
      steps: preparedSteps,
      quizData: initialData,
      canContinue: getStepCanContinue(preparedSteps[0]),
      onComplete
    });
  },
  goToNext: () => {
    const { currentStep, steps, onComplete } = get();
    if (currentStep < steps.length) {
      const nextStep = currentStep + 1;
      set({
        currentStep: nextStep,
        canContinue: getStepCanContinue(steps[nextStep - 1])
      });
      return;
    }
    if (typeof onComplete === "function") {
      onComplete(get().quizData);
    }
  },
  goToPrevious: () => {
    const { currentStep, steps } = get();
    if (currentStep > 1) {
      const previousStep = currentStep - 1;
      set({
        currentStep: previousStep,
        canContinue: getStepCanContinue(steps[previousStep - 1])
      });
    }
  },
  updateFormField: (field, value) => {
    set((state) => ({
      quizData: {
        ...state.quizData,
        [field]: value
      }
    }));
  },
  toggleSelection: (field, value, isExclusive = false) => {
    const { quizData, steps, currentStep } = get();
    const selectedValues = getSelectedValues(quizData, field);
    const step = getStepByField(steps, field);
    const newSelection = getNextSelection(selectedValues, value, isExclusive, step == null ? void 0 : step.options);
    const currentStepData = steps[currentStep - 1];
    const currentStepField = currentStepData && "field" in currentStepData ? currentStepData.field : void 0;
    set((state) => ({
      quizData: {
        ...state.quizData,
        [field]: newSelection
      },
      canContinue: currentStepField === field ? newSelection.length > 0 : state.canContinue
    }));
  },
  setSingleSelection: (field, value) => {
    set((state) => ({
      quizData: {
        ...state.quizData,
        [field]: [value]
      }
    }));
  },
  getCurrentStepData: () => {
    const { currentStep, steps } = get();
    return steps[currentStep - 1];
  },
  setCanContinue: (canContinue) => {
    set({ canContinue });
  }
}));
var useQuizStore_default = useQuizStore;

// src/atoms/quiz/QuizButton.tsx
import React132 from "react";
import classNames37 from "classnames";

// src/atoms/quiz/NextCircleIcon.tsx
import React131 from "react";
import classNames36 from "classnames";
var DEFAULT_ICON_CLASS21 = "w-[18px] h-[18px] ml-1.5 shrink-0";
var NextCircleIcon = ({ className, classes = {} }) => /* @__PURE__ */ React131.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: classNames36(DEFAULT_ICON_CLASS21, className, classes.icon)
  },
  /* @__PURE__ */ React131.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#FFFFFF", fillOpacity: "0.22" }),
  /* @__PURE__ */ React131.createElement(
    "path",
    {
      d: "M10 8L14 12L10 16",
      stroke: "#FFFFFF",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
var NextCircleIcon_default = NextCircleIcon;

// src/atoms/quiz/QuizButton.tsx
var DEFAULT_BUTTON_CLASS3 = `
    bg-green text-white border-none py-4 px-8 rounded-[88px] text-base font-medium cursor-pointer
    transition-all duration-200 w-full min-h-[52px] md:min-h-[58px] flex items-center justify-center
    disabled:opacity-0 disabled:translate-y-5 disabled:pointer-events-none
    enabled:opacity-100 enabled:translate-y-0
    hover:enabled:-translate-y-0.5 active:enabled:translate-y-0
  `;
var DEFAULT_FIXED_WRAPPER_CLASS = "fixed bottom-2 md:bottom-[15px] left-1/2 -translate-x-1/2 w-[calc(100%-1rem)] md:w-[calc(100%-1.4rem)] max-w-[520px] md:max-w-[560px] p-4 pt-8 z-50 flex justify-center items-end bg-gradient-to-b from-[#E7F1ED]/0 to-[#E7F1ED] to-[80.67%] rounded-b-[18px] md:rounded-b-[22px]";
var QuizButton = ({
  children,
  onClick,
  disabled,
  fixed,
  type = "button",
  className,
  classes = {}
}) => {
  const transitionClasses = disabled ? "transition-all duration-600 ease-[cubic-bezier(0.25,1.6,0.5,1)]" : "transition-all duration-400 ease-[cubic-bezier(0.25,1.6,0.5,1)]";
  const buttonClass = classNames37(
    DEFAULT_BUTTON_CLASS3,
    transitionClasses,
    className,
    classes.button
  );
  if (fixed) {
    return /* @__PURE__ */ React132.createElement("div", { className: classNames37(DEFAULT_FIXED_WRAPPER_CLASS, classes.fixedWrapper) }, /* @__PURE__ */ React132.createElement("button", { type, onClick, disabled, className: buttonClass }, children, /* @__PURE__ */ React132.createElement(NextCircleIcon_default, null)));
  }
  return /* @__PURE__ */ React132.createElement("button", { type, onClick, disabled, className: buttonClass }, children, /* @__PURE__ */ React132.createElement(NextCircleIcon_default, null));
};
var QuizButton_default = QuizButton;

// src/organisms/quiz/QuizNavigation.tsx
import React136 from "react";
import classNames40 from "classnames";

// src/atoms/quiz/BackIcon.tsx
import React133 from "react";
import classNames38 from "classnames";
var DEFAULT_ICON_CLASS22 = "w-5 h-5 md:w-6 md:h-6";
var BackIcon = ({ className, classes = {} }) => /* @__PURE__ */ React133.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: classNames38(DEFAULT_ICON_CLASS22, className, classes.icon),
    fill: "none"
  },
  /* @__PURE__ */ React133.createElement(
    "path",
    {
      d: "M14.5 6.5L9 12L14.5 17.5",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
var BackIcon_default = BackIcon;

// src/atoms/quiz/QuizLogo.tsx
import React135 from "react";
import classNames39 from "classnames";

// src/context/QuizTranslationsContext.tsx
import React134, { createContext as createContext2, useContext } from "react";
var QuizTranslationsContext = createContext2(null);
var QuizTranslationsProvider = ({
  children,
  value
}) => {
  return /* @__PURE__ */ React134.createElement(QuizTranslationsContext.Provider, { value }, children);
};
var useQuizTranslations = () => {
  const translations = useContext(QuizTranslationsContext);
  if (!translations) {
    throw new Error("Quiz translations are required.");
  }
  return translations;
};

// src/atoms/quiz/QuizLogo.tsx
var DEFAULT_LOGO_CLASS3 = "h-[25px] md:h-6 w-auto";
var QuizLogo = ({ className, classes = {} }) => {
  const translations = useQuizTranslations();
  const quizLabel = translations.accessibilityLabels.quizLogo;
  return /* @__PURE__ */ React135.createElement(
    "svg",
    {
      viewBox: "0 0 92 24",
      "aria-label": quizLabel,
      className: classNames39(DEFAULT_LOGO_CLASS3, className, classes.logo)
    },
    /* @__PURE__ */ React135.createElement(
      "text",
      {
        x: "0",
        y: "17",
        fill: "#1C8B55",
        fontSize: "18",
        fontWeight: "700",
        fontFamily: "Arial, sans-serif",
        letterSpacing: "0.5"
      },
      "QUIZ"
    )
  );
};
var QuizLogo_default = QuizLogo;

// src/organisms/quiz/QuizNavigation.tsx
var DEFAULT_NAV_CLASS2 = "sticky top-0 z-50 bg-transparent backdrop-blur-[30px] rounded-t-[18px] md:rounded-t-[22px] shrink-0";
var DEFAULT_ROW_CLASS = "grid grid-cols-[1fr_auto_1fr] items-center px-4 md:px-6 py-3 md:py-4 gap-4";
var DEFAULT_BACK_BUTTON_CLASS = "justify-self-start bg-white border-none text-green cursor-pointer p-1.5 md:p-2 rounded-xl md:rounded-[14px] transition-all hover:scale-[1.02] hover:shadow-sm";
var DEFAULT_LOGO_WRAPPER_CLASS2 = "text-center flex items-center justify-center";
var DEFAULT_STEP_TEXT_CLASS = "justify-self-end text-xs md:text-sm text-gray";
var DEFAULT_PROGRESS_TRACK_CLASS = "h-[3px] bg-light-gray relative mx-4 md:mx-6";
var DEFAULT_PROGRESS_FILL_CLASS = "h-full bg-green rounded-full transition-all duration-400 ease-[cubic-bezier(0.25,1.2,0.5,1)]";
var QuizNavigation = ({ logo, className, classes = {} }) => {
  const { currentStep, goToPrevious, steps, getCurrentStepData } = useQuizStore_default();
  const translations = useQuizTranslations();
  const currentStepData = getCurrentStepData();
  const displayStep = currentStep;
  const displayTotal = steps.length || 1;
  const progressPercentage = displayStep / displayTotal * 100;
  const showBackButton = currentStep > 1 && (currentStepData == null ? void 0 : currentStepData.hideBackButton) !== true;
  const goBackLabel = translations.accessibilityLabels.goBack;
  return /* @__PURE__ */ React136.createElement("nav", { className: classNames40(DEFAULT_NAV_CLASS2, className, classes.root) }, /* @__PURE__ */ React136.createElement("div", { className: classNames40(DEFAULT_ROW_CLASS, classes.row) }, /* @__PURE__ */ React136.createElement(
    "button",
    {
      onClick: goToPrevious,
      className: classNames40(
        DEFAULT_BACK_BUTTON_CLASS,
        showBackButton ? "visible" : "invisible",
        classes.backButton
      ),
      "aria-label": goBackLabel
    },
    /* @__PURE__ */ React136.createElement(BackIcon_default, null)
  ), /* @__PURE__ */ React136.createElement("div", { className: classNames40(DEFAULT_LOGO_WRAPPER_CLASS2, classes.logoWrapper) }, logo || /* @__PURE__ */ React136.createElement(QuizLogo_default, null)), /* @__PURE__ */ React136.createElement("div", { className: classNames40(DEFAULT_STEP_TEXT_CLASS, classes.stepText) }, displayStep, " of ", displayTotal)), /* @__PURE__ */ React136.createElement("div", { className: classNames40(DEFAULT_PROGRESS_TRACK_CLASS, classes.progressTrack) }, /* @__PURE__ */ React136.createElement(
    "div",
    {
      className: classNames40(DEFAULT_PROGRESS_FILL_CLASS, classes.progressFill),
      style: { width: `${progressPercentage}%` }
    }
  )));
};
var QuizNavigation_default = QuizNavigation;

// src/templates/quiz/QuizEngine.tsx
var DEFAULT_CONTAINER_CLASS19 = "absolute inset-0 overflow-y-auto overflow-x-hidden hide-scrollbar flex flex-col bg-gradient-to-b from-[#DFF3E4] to-[#E7F1ED] m-2 md:m-[15px] rounded-[18px] md:rounded-[22px] w-[calc(100%-16px)] md:w-[calc(100%-30px)] h-[calc(100%-16px)] md:h-[calc(100%-30px)]";
var DEFAULT_MAIN_CLASS = "flex-1 px-4 py-5 md:py-8 max-w-[520px] mx-auto w-full";
function QuizEngine({
  steps,
  logo,
  renderStep,
  onComplete,
  initialData,
  className,
  classes = {},
  containerClassName = DEFAULT_CONTAINER_CLASS19,
  mainClassName = DEFAULT_MAIN_CLASS
}) {
  const currentStep = useQuizStore_default((state) => state.currentStep);
  const currentStepData = useQuizStore_default((state) => state.getCurrentStepData());
  const canContinue = useQuizStore_default((state) => state.canContinue);
  const goToNext = useQuizStore_default((state) => state.goToNext);
  const setConfig = useQuizStore_default((state) => state.setConfig);
  const translations = useQuizTranslations();
  useEffect6(() => {
    setConfig({
      steps,
      onComplete,
      initialData
    });
  }, [initialData, onComplete, setConfig, steps]);
  const needsFixedButton = (currentStepData == null ? void 0 : currentStepData.showFixedButton) === true;
  const continueButtonLabel = translations.continueButtonLabel;
  return /* @__PURE__ */ React137.createElement("div", { className: classNames41(containerClassName, className, classes.root, classes.container) }, /* @__PURE__ */ React137.createElement(QuizNavigation_default, { logo, className: classes.navigation, classes: classes.navigationClasses }), /* @__PURE__ */ React137.createElement("main", { className: classNames41(mainClassName, classes.main) }, typeof renderStep === "function" ? renderStep({
    step: currentStepData,
    stepNumber: currentStep
  }) : null), needsFixedButton ? /* @__PURE__ */ React137.createElement(
    QuizButton_default,
    {
      onClick: goToNext,
      disabled: !canContinue,
      fixed: true,
      className: classes.continueButton
    },
    continueButtonLabel
  ) : null);
}
var QuizEngine_default = QuizEngine;

// src/templates/quiz/StepRenderer.tsx
import React138 from "react";
function getStepComponentProps(stepType, componentProps, stepClasses) {
  const stepComponentProps = componentProps[stepType] || {};
  const classes = stepClasses[stepType];
  if (!classes) {
    return stepComponentProps;
  }
  return {
    ...stepComponentProps,
    classes: {
      ...stepComponentProps.classes || {},
      ...classes
    }
  };
}
var StepRenderer = ({
  step,
  stepNumber,
  componentMap = {},
  componentProps = {},
  stepClasses = {}
}) => {
  if (!step) return null;
  const StepComponent = componentMap[step.type];
  if (!StepComponent) {
    throw new Error(`StepRenderer: missing component for step type "${step.type}".`);
  }
  return /* @__PURE__ */ React138.createElement(
    StepComponent,
    {
      key: stepNumber,
      step,
      stepNumber,
      ...getStepComponentProps(step.type, componentProps, stepClasses)
    }
  );
};
var StepRenderer_default = StepRenderer;

// src/organisms/quiz/SingleSelectStep.tsx
import React144 from "react";
import classNames47 from "classnames";

// src/templates/quiz/StepLayout.tsx
import React140 from "react";
import classNames43 from "classnames";

// src/molecules/quiz/QuizStepHeader.tsx
import React139 from "react";
import classNames42 from "classnames";
var DEFAULT_TITLE_CLASS8 = "font-title text-[1.6rem] md:text-[2.1rem] font-normal leading-[1.25] md:leading-[1.2] text-center text-main";
var DEFAULT_SUBTITLE_CLASS2 = "text-[0.9rem] md:text-base leading-[1.4] md:leading-[1.55] text-center text-gray mb-2 md:mb-4";
var QuizStepHeader = ({ title, subtitle, className, classes = {} }) => {
  return /* @__PURE__ */ React139.createElement(React139.Fragment, null, title && /* @__PURE__ */ React139.createElement("h2", { className: classNames42(DEFAULT_TITLE_CLASS8, className, classes.root, classes.title) }, title), subtitle && /* @__PURE__ */ React139.createElement(
    "p",
    {
      className: classNames42(DEFAULT_SUBTITLE_CLASS2, className, classes.root, classes.subtitle)
    },
    subtitle
  ));
};
var QuizStepHeader_default = QuizStepHeader;

// src/templates/quiz/StepLayout.tsx
var DEFAULT_BASE_CLASS8 = "flex flex-col gap-2 animate-fade-in";
var DEFAULT_PADDING_CLASS = "pb-16 md:pb-[65px]";
var StepLayout = ({
  title,
  subtitle,
  children,
  noPadding = false,
  className,
  classes = {}
}) => {
  const wrapperClass = noPadding ? DEFAULT_BASE_CLASS8 : `${DEFAULT_BASE_CLASS8} ${DEFAULT_PADDING_CLASS}`;
  return /* @__PURE__ */ React140.createElement("div", { className: classNames43(wrapperClass, className, classes.root) }, /* @__PURE__ */ React140.createElement(
    QuizStepHeader_default,
    {
      title,
      subtitle,
      className: classes.header,
      classes: { title: classes.title, subtitle: classes.subtitle }
    }
  ), children);
};
var StepLayout_default = StepLayout;

// src/molecules/quiz/OptionCard.tsx
import React143 from "react";
import classNames46 from "classnames";

// src/atoms/quiz/CheckIcon.tsx
import React141 from "react";
import classNames44 from "classnames";
var DEFAULT_ICON_CLASS23 = "w-4 h-4 transition-opacity duration-200";
var CheckIcon = ({ checked, className, classes = {} }) => /* @__PURE__ */ React141.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: classNames44(
      DEFAULT_ICON_CLASS23,
      checked ? "opacity-100 text-white" : "opacity-0 text-transparent",
      className,
      classes.icon
    ),
    fill: "none"
  },
  /* @__PURE__ */ React141.createElement(
    "path",
    {
      d: "M6.5 12.5L10.2 16L17.5 8.5",
      stroke: "currentColor",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
var CheckIcon_default = CheckIcon;

// src/atoms/quiz/NextIcon.tsx
import React142 from "react";
import classNames45 from "classnames";
var DEFAULT_ICON_CLASS24 = "w-5 h-5 md:w-[22px] md:h-[22px] shrink-0 transition-opacity duration-200";
var NextIcon = ({ checked, className, classes = {} }) => /* @__PURE__ */ React142.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: classNames45(
      DEFAULT_ICON_CLASS24,
      checked ? "opacity-100" : "opacity-30",
      className,
      classes.icon
    ),
    fill: "none"
  },
  /* @__PURE__ */ React142.createElement(
    "path",
    {
      d: "M9 6L15 12L9 18",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
var NextIcon_default = NextIcon;

// src/molecules/quiz/OptionCard.tsx
var DEFAULT_LABEL_CLASS7 = "block cursor-pointer transition-all duration-200 select-none outline-none [-webkit-tap-highlight-color:transparent]";
var DEFAULT_CARD_CLASS2 = `
  flex items-center justify-between
  px-3.5 md:px-5 py-3 md:py-[1.4rem]
  bg-white border rounded-[14px] md:rounded-2xl
  font-medium min-h-[54px] md:min-h-[60px] w-full
  transition-all duration-200
  shadow-[0_1px_4px_rgba(0,0,0,0)]
  hover:text-green hover:scale-[1.01] hover:shadow-[0_10px_14px_rgba(0,0,0,0.01)]
  active:scale-[0.99] active:transition-transform active:duration-300 active:ease-[cubic-bezier(0.34,1.56,0.64,1)]
`;
var DEFAULT_TEXT_CLASS5 = "text-[0.95rem] md:text-base flex-grow leading-[1.4]";
var DEFAULT_CHECKBOX_CLASS = "w-5 h-5 md:w-[22px] md:h-[22px] shrink-0 border-2 rounded-md flex items-center justify-center transition-all duration-200";
function OptionCard({ type, label, checked, onChange, className, classes = {} }) {
  const isRadio = type === "radio";
  return /* @__PURE__ */ React143.createElement("label", { className: classNames46(DEFAULT_LABEL_CLASS7, className, classes.root) }, /* @__PURE__ */ React143.createElement("input", { type, checked, onChange, className: "hidden" }), /* @__PURE__ */ React143.createElement(
    "div",
    {
      className: classNames46(
        DEFAULT_CARD_CLASS2,
        checked ? "border-green bg-secondary text-green scale-[0.999]" : "border-transparent",
        classes.card
      )
    },
    /* @__PURE__ */ React143.createElement("span", { className: classNames46(DEFAULT_TEXT_CLASS5, classes.label) }, label),
    isRadio ? /* @__PURE__ */ React143.createElement(NextIcon_default, { checked }) : /* @__PURE__ */ React143.createElement(
      "div",
      {
        className: classNames46(
          DEFAULT_CHECKBOX_CLASS,
          checked ? "bg-[#1C8B55] border-[#1C8B55]" : "bg-white border-light-gray",
          classes.checkbox
        )
      },
      /* @__PURE__ */ React143.createElement(CheckIcon_default, { checked })
    )
  ));
}
var OptionCard_default = OptionCard;

// src/organisms/quiz/SingleSelectStep.tsx
var DEFAULT_OPTIONS_CLASS = "flex flex-col gap-2 md:gap-2.5";
var SingleSelectStep = ({ step, className, classes = {} }) => {
  var _a;
  const { quizData, setSingleSelection, goToNext } = useQuizStore_default();
  const selectedValues = Array.isArray(quizData[step.field]) ? quizData[step.field] : [];
  const selected = (_a = selectedValues[0]) != null ? _a : null;
  const handleSelect = (value) => {
    setSingleSelection(step.field, value);
    setTimeout(() => {
      goToNext();
    }, 300);
  };
  return /* @__PURE__ */ React144.createElement(
    StepLayout_default,
    {
      title: step.title,
      subtitle: step.subtitle,
      className,
      classes: classes.layout
    },
    /* @__PURE__ */ React144.createElement("div", { className: classNames47(DEFAULT_OPTIONS_CLASS, classes.options) }, step.options.map((option) => /* @__PURE__ */ React144.createElement(
      OptionCard_default,
      {
        key: option.value,
        type: "radio",
        label: option.label,
        checked: selected === option.value,
        onChange: () => handleSelect(option.value),
        className: classes.option,
        classes: classes.optionClasses
      }
    )))
  );
};
var SingleSelectStep_default = SingleSelectStep;

// src/organisms/quiz/MultiSelectStep.tsx
import React145, { useEffect as useEffect7 } from "react";
import classNames48 from "classnames";
var DEFAULT_OPTIONS_CLASS2 = "flex flex-col gap-2 md:gap-2.5";
var MultiSelectStep = ({ step, className, classes = {} }) => {
  const { quizData, toggleSelection, setCanContinue } = useQuizStore_default();
  const selected = Array.isArray(quizData[step.field]) ? quizData[step.field] : [];
  useEffect7(() => {
    setCanContinue(selected.length > 0);
  }, [selected.length, setCanContinue]);
  const handleToggle = (value, isExclusive) => {
    toggleSelection(step.field, value, isExclusive);
  };
  return /* @__PURE__ */ React145.createElement(
    StepLayout_default,
    {
      title: step.title,
      subtitle: step.subtitle,
      className,
      classes: classes.layout
    },
    /* @__PURE__ */ React145.createElement("div", { className: classNames48(DEFAULT_OPTIONS_CLASS2, classes.options) }, step.options.map((option) => /* @__PURE__ */ React145.createElement(
      OptionCard_default,
      {
        key: option.value,
        type: "checkbox",
        label: option.label,
        checked: selected.includes(option.value),
        onChange: () => handleToggle(option.value, option.exclusive),
        className: classes.option,
        classes: classes.optionClasses
      }
    )))
  );
};
var MultiSelectStep_default = MultiSelectStep;

// src/organisms/quiz/FormStep.tsx
import React154 from "react";
import classNames55 from "classnames";

// src/organisms/quizForm/useFormStepController.ts
import {
  useCallback,
  useEffect as useEffect8,
  useMemo,
  useState as useState7
} from "react";

// src/organisms/quizForm/fields/AgeFormFields.tsx
import React148 from "react";

// src/molecules/quiz/QuizTextField.tsx
import React146, { useState as useState6 } from "react";
import classNames49 from "classnames";
var QuizTextField = ({
  id,
  type = "text",
  label,
  value,
  onChange,
  onBlur,
  error,
  min,
  max,
  maxLength,
  inputMode = "text",
  pattern,
  className,
  classes = {}
}) => {
  const [isFocused, setIsFocused] = useState6(false);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur == null ? void 0 : onBlur(e);
  };
  const handleChange = (event) => {
    let newValue = event.target.value;
    if (type === "number") {
      newValue = newValue.replace(/[^0-9]/g, "");
    }
    if (maxLength && newValue.length > maxLength) {
      newValue = newValue.slice(0, maxLength);
    }
    onChange({
      ...event,
      target: { ...event.target, value: newValue },
      currentTarget: { ...event.currentTarget, value: newValue }
    });
  };
  const handleKeyPress = (e) => {
    if (type === "number") {
      if (!/[0-9]/.test(e.key) && !["Backspace", "Tab", "Enter", "Delete"].includes(e.key)) {
        e.preventDefault();
      }
    }
  };
  const hasValue = value !== "" && value !== void 0;
  return /* @__PURE__ */ React146.createElement("div", { className: classNames49("relative mb-0.5", className, classes.root) }, /* @__PURE__ */ React146.createElement(
    "input",
    {
      id,
      type: type === "number" ? "text" : type,
      value,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyPress: handleKeyPress,
      placeholder: label,
      inputMode,
      pattern,
      min,
      max,
      className: classNames49(
        `
            w-full h-[calc(3.75rem+2px)] md:h-[calc(4.2rem+2px)]
            pt-[1.15rem] md:pt-[2.03rem] pb-[0.15rem] md:pb-[0.73rem] px-3.5 md:px-[0.85rem]
            border-2 rounded-xl md:rounded-[14px]
            text-base bg-white
            transition-[border-color] duration-200
            placeholder:text-transparent
            focus:outline-none focus:border-green
          `,
        error ? "border-red shadow-[0_0_0_0.2rem_rgba(220,53,69,0.25)] animate-shake" : "border-light-gray",
        classes.input
      )
    }
  ), /* @__PURE__ */ React146.createElement(
    "label",
    {
      htmlFor: id,
      className: classNames49(
        `
            absolute top-0 left-0 h-full
            px-4 md:px-[0.95rem] py-[1.1rem] md:py-[1.3rem]
            pointer-events-none
            transition-all duration-100 ease-in-out
            text-base
            origin-top-left
          `,
        isFocused || hasValue ? "scale-75 -translate-y-[0.3rem] md:-translate-y-[0.5rem] translate-x-[0.1rem] md:translate-x-[0.15rem] font-medium" : "",
        isFocused ? "text-green" : error ? "text-red" : "text-gray",
        classes.label
      )
    },
    label
  ));
};
var QuizTextField_default = QuizTextField;

// src/atoms/quiz/QuizErrorMessage.tsx
import React147 from "react";
import classNames50 from "classnames";
var DEFAULT_ERROR_CLASS = "text-red text-sm md:text-[0.875rem] mt-1 md:mt-1.5 font-medium leading-[1.4] text-center animate-fade-in-error";
var QuizErrorMessage = ({ message, show, className, classes = {} }) => {
  if (!show) return null;
  return /* @__PURE__ */ React147.createElement("div", { className: classNames50(DEFAULT_ERROR_CLASS, className, classes.root) }, message);
};
var QuizErrorMessage_default = QuizErrorMessage;

// src/helpers/quiz/quizFormValidation.ts
var validateAge = (age) => {
  const numAge = parseInt(age);
  return age !== "" && !isNaN(numAge) && numAge >= 18 && numAge <= 80;
};
var validateHeightMetric = (cm) => {
  const numCm = parseInt(cm);
  return cm !== "" && !isNaN(numCm) && numCm >= 100 && numCm <= 245;
};
var validateHeightImperial = (feet, inches) => {
  const numFeet = parseInt(feet);
  const numInches = parseInt(inches);
  if (feet === "" || inches === "" || isNaN(numFeet) || isNaN(numInches)) {
    return false;
  }
  if (numInches < 0 || numInches > 11) return false;
  const totalInches = numFeet * 12 + numInches;
  return totalInches >= 39 && totalInches <= 96;
};
var validateWeightMetric = (currentKg, goalKg) => {
  const numCurrent = parseFloat(currentKg);
  const numGoal = parseFloat(goalKg);
  return currentKg !== "" && goalKg !== "" && !isNaN(numCurrent) && !isNaN(numGoal) && numCurrent >= 30 && numCurrent <= 300 && numGoal >= 30 && numGoal <= 300 && numGoal < numCurrent;
};
var validateWeightImperial = (currentLb, goalLb) => {
  const numCurrent = parseFloat(currentLb);
  const numGoal = parseFloat(goalLb);
  return currentLb !== "" && goalLb !== "" && !isNaN(numCurrent) && !isNaN(numGoal) && numCurrent >= 60 && numCurrent <= 661 && numGoal >= 60 && numGoal <= 661 && numGoal < numCurrent;
};
var validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email !== "" && emailRegex.test(email);
};
var getAgeError = (messages) => messages == null ? void 0 : messages.ageInvalid;
var getHeightError = (messages) => messages == null ? void 0 : messages.heightInvalid;
var getWeightError = (current, goal, unit = FORM_UNITS.METRIC, messages) => {
  const numCurrent = parseFloat(current);
  const numGoal = parseFloat(goal);
  const isImperial = unit === FORM_UNITS.IMPERIAL;
  const min = isImperial ? 60 : 30;
  const max = isImperial ? 661 : 300;
  const isRangeError = current === "" || goal === "" || isNaN(numCurrent) || isNaN(numGoal) || numCurrent < min || numCurrent > max || numGoal < min || numGoal > max;
  if (isRangeError) {
    return messages == null ? void 0 : messages.weightRangeInvalid;
  }
  if (numGoal >= numCurrent) {
    return messages == null ? void 0 : messages.weightGoalInvalid;
  }
  return messages == null ? void 0 : messages.weightInvalid;
};
var getEmailError = (messages) => messages == null ? void 0 : messages.emailInvalid;

// src/organisms/quizForm/constants.ts
var FORM_FIELD_IDS = {
  age: "age",
  heightUnit: "heightUnit",
  heightCm: "heightCm",
  heightFt: "heightFt",
  heightIn: "heightIn",
  weightUnit: "weightUnit",
  currentWeightKg: "currentWeightKg",
  goalWeightKg: "goalWeightKg",
  currentWeightLb: "currentWeightLb",
  goalWeightLb: "goalWeightLb",
  email: "email"
};

// src/organisms/quizForm/fields/AgeFormFields.tsx
var AgeFormFields = ({ formContext }) => {
  const { getFieldValue, onFieldChange, onBlur, label, error, showError } = formContext;
  const translations = useQuizTranslations();
  const ageLabel = label != null ? label : translations.formLabels.age;
  return /* @__PURE__ */ React148.createElement(React148.Fragment, null, /* @__PURE__ */ React148.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.age,
      type: "number",
      label: ageLabel,
      value: getFieldValue(FORM_FIELD_IDS.age),
      onChange: onFieldChange(FORM_FIELD_IDS.age),
      onBlur,
      error: showError,
      maxLength: 2,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  ), /* @__PURE__ */ React148.createElement(QuizErrorMessage_default, { message: error, show: showError }));
};
var ageFormDefinition = {
  Component: AgeFormFields,
  isValid: ({ getFieldValue }) => validateAge(getFieldValue(FORM_FIELD_IDS.age)),
  getError: ({ validationMessages }) => getAgeError(validationMessages),
  getSetup: () => ({
    focusFieldId: FORM_FIELD_IDS.age
  })
};

// src/organisms/quizForm/fields/HeightFormFields.tsx
import React151 from "react";
import classNames53 from "classnames";

// src/molecules/quiz/QuizUnitToggle.tsx
import React150 from "react";
import classNames52 from "classnames";

// src/atoms/quiz/QuizSegmentedButton.tsx
import React149 from "react";
import classNames51 from "classnames";
var DEFAULT_BUTTON_CLASS4 = `
  flex-1 py-3 px-4 border-none rounded-xl cursor-pointer
  transition-all duration-200
  min-h-[40px] md:min-h-[48px] text-[0.9rem] md:text-[0.95rem] font-medium
  select-none outline-none [-webkit-tap-highlight-color:transparent]
`;
var QuizSegmentedButton = ({
  children,
  isActive,
  onClick,
  className
}) => {
  return /* @__PURE__ */ React149.createElement(
    "button",
    {
      type: "button",
      onClick,
      className: classNames51(
        DEFAULT_BUTTON_CLASS4,
        isActive ? "bg-white text-main" : "bg-transparent text-gray hover:text-main",
        className
      )
    },
    children
  );
};
var QuizSegmentedButton_default = QuizSegmentedButton;

// src/molecules/quiz/QuizUnitToggle.tsx
var DEFAULT_ROOT_CLASS15 = "flex bg-overlay rounded-2xl p-1 gap-1 mb-2.5";
var DEFAULT_BUTTON_CLASS5 = `
  flex-1 py-3 px-4 border-none rounded-xl cursor-pointer
  transition-all duration-200
  min-h-[40px] md:min-h-[48px] text-[0.9rem] md:text-[0.95rem] font-medium
  select-none outline-none [-webkit-tap-highlight-color:transparent]
`;
var QuizUnitToggle = ({ value, onChange, className, classes = {} }) => {
  const translations = useQuizTranslations();
  const unitToggleLabels = translations.unitToggleLabels;
  return /* @__PURE__ */ React150.createElement("div", { className: classNames52(DEFAULT_ROOT_CLASS15, className, classes.root) }, /* @__PURE__ */ React150.createElement(
    QuizSegmentedButton_default,
    {
      isActive: value === FORM_UNITS.IMPERIAL,
      onClick: () => onChange(FORM_UNITS.IMPERIAL),
      className: classNames52(DEFAULT_BUTTON_CLASS5, classes.button, classes.imperial)
    },
    unitToggleLabels.imperial
  ), /* @__PURE__ */ React150.createElement(
    QuizSegmentedButton_default,
    {
      isActive: value === FORM_UNITS.METRIC,
      onClick: () => onChange(FORM_UNITS.METRIC),
      className: classNames52(DEFAULT_BUTTON_CLASS5, classes.button, classes.metric)
    },
    unitToggleLabels.metric
  ));
};
var QuizUnitToggle_default = QuizUnitToggle;

// src/organisms/quizForm/fields/HeightFormFields.tsx
var DEFAULT_IMPERIAL_GROUP_CLASS = "grid grid-cols-2 gap-2 md:gap-2 step-input-group";
var HeightFormFields = ({ formContext }) => {
  const {
    preferredUnit,
    onUnitChange,
    getFieldValue,
    onFieldChange,
    onBlur,
    label,
    error,
    showError,
    classes = {}
  } = formContext;
  const translations = useQuizTranslations();
  const { formLabels } = translations;
  const metricLabel = label != null ? label : formLabels.heightCm;
  const feetLabel = formLabels.heightFeet;
  const inchesLabel = formLabels.heightInches;
  return /* @__PURE__ */ React151.createElement(React151.Fragment, null, /* @__PURE__ */ React151.createElement("div", { className: "unit-toggle-container" }, /* @__PURE__ */ React151.createElement(QuizUnitToggle_default, { value: preferredUnit, onChange: onUnitChange })), preferredUnit === FORM_UNITS.METRIC ? /* @__PURE__ */ React151.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.heightCm,
      type: "number",
      label: metricLabel,
      value: getFieldValue(FORM_FIELD_IDS.heightCm),
      onChange: onFieldChange(FORM_FIELD_IDS.heightCm),
      onBlur,
      error: showError,
      maxLength: 3,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  ) : /* @__PURE__ */ React151.createElement("div", { className: classNames53(DEFAULT_IMPERIAL_GROUP_CLASS, classes.imperialGroup) }, /* @__PURE__ */ React151.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.heightFt,
      type: "number",
      label: feetLabel,
      value: getFieldValue(FORM_FIELD_IDS.heightFt),
      onChange: onFieldChange(FORM_FIELD_IDS.heightFt),
      onBlur,
      error: showError,
      maxLength: 1,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  ), /* @__PURE__ */ React151.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.heightIn,
      type: "number",
      label: inchesLabel,
      value: getFieldValue(FORM_FIELD_IDS.heightIn),
      onChange: onFieldChange(FORM_FIELD_IDS.heightIn),
      onBlur,
      error: showError,
      maxLength: 2,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  )), /* @__PURE__ */ React151.createElement(QuizErrorMessage_default, { message: error, show: showError }));
};
var heightFormDefinition = {
  Component: HeightFormFields,
  isValid: ({ getFieldValue, preferredUnit }) => preferredUnit === FORM_UNITS.METRIC ? validateHeightMetric(getFieldValue(FORM_FIELD_IDS.heightCm)) : validateHeightImperial(
    getFieldValue(FORM_FIELD_IDS.heightFt),
    getFieldValue(FORM_FIELD_IDS.heightIn)
  ),
  getError: ({ validationMessages }) => getHeightError(validationMessages),
  getSetup: ({ getFieldValue, stepPreferredUnit }) => {
    const storedUnit = getFieldValue(FORM_FIELD_IDS.heightUnit);
    const preferredUnit = storedUnit === FORM_UNITS.METRIC || storedUnit === FORM_UNITS.IMPERIAL ? storedUnit : stepPreferredUnit || FORM_UNITS.IMPERIAL;
    return {
      preferredUnit,
      unitField: FORM_FIELD_IDS.heightUnit,
      initialValues: storedUnit ? void 0 : { [FORM_FIELD_IDS.heightUnit]: preferredUnit },
      focusFieldId: preferredUnit === FORM_UNITS.METRIC ? FORM_FIELD_IDS.heightCm : FORM_FIELD_IDS.heightFt
    };
  }
};

// src/organisms/quizForm/fields/WeightFormFields.tsx
import React152 from "react";
import classNames54 from "classnames";
var DEFAULT_GROUP_CLASS = "flex flex-col gap-2.5 md:gap-4 step-input-group";
var DEFAULT_DISCLAIMER_CLASS = "text-[0.75rem] md:text-[0.8rem] text-gray leading-normal mt-1 text-center";
var WeightFormFields = ({ formContext }) => {
  const {
    preferredUnit,
    onUnitChange,
    getFieldValue,
    onFieldChange,
    onBlur,
    label,
    error,
    showError,
    classes = {}
  } = formContext;
  const translations = useQuizTranslations();
  const { formLabels } = translations;
  const unit = preferredUnit || FORM_UNITS.METRIC;
  const currentWeightKgLabel = label != null ? label : formLabels.currentWeightKg;
  const goalWeightKgLabel = formLabels.goalWeightKg;
  const currentWeightLbLabel = label != null ? label : formLabels.currentWeightLb;
  const goalWeightLbLabel = formLabels.goalWeightLb;
  const weightDisclaimer = formLabels.weightDisclaimer;
  const weightRange = unit === FORM_UNITS.METRIC ? formLabels.weightDisclaimerMetricRange : formLabels.weightDisclaimerImperialRange;
  return /* @__PURE__ */ React152.createElement(React152.Fragment, null, /* @__PURE__ */ React152.createElement("div", { className: "unit-toggle-container" }, /* @__PURE__ */ React152.createElement(QuizUnitToggle_default, { value: preferredUnit, onChange: onUnitChange })), unit === FORM_UNITS.METRIC ? /* @__PURE__ */ React152.createElement("div", { className: classNames54(DEFAULT_GROUP_CLASS, classes.group) }, /* @__PURE__ */ React152.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.currentWeightKg,
      type: "number",
      label: currentWeightKgLabel,
      value: getFieldValue(FORM_FIELD_IDS.currentWeightKg),
      onChange: onFieldChange(FORM_FIELD_IDS.currentWeightKg),
      onBlur,
      error: showError,
      maxLength: 3,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  ), /* @__PURE__ */ React152.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.goalWeightKg,
      type: "number",
      label: goalWeightKgLabel,
      value: getFieldValue(FORM_FIELD_IDS.goalWeightKg),
      onChange: onFieldChange(FORM_FIELD_IDS.goalWeightKg),
      onBlur,
      error: showError,
      maxLength: 3,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  )) : /* @__PURE__ */ React152.createElement("div", { className: classNames54(DEFAULT_GROUP_CLASS, classes.group) }, /* @__PURE__ */ React152.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.currentWeightLb,
      type: "number",
      label: currentWeightLbLabel,
      value: getFieldValue(FORM_FIELD_IDS.currentWeightLb),
      onChange: onFieldChange(FORM_FIELD_IDS.currentWeightLb),
      onBlur,
      error: showError,
      maxLength: 3,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  ), /* @__PURE__ */ React152.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.goalWeightLb,
      type: "number",
      label: goalWeightLbLabel,
      value: getFieldValue(FORM_FIELD_IDS.goalWeightLb),
      onChange: onFieldChange(FORM_FIELD_IDS.goalWeightLb),
      onBlur,
      error: showError,
      maxLength: 3,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }
  )), /* @__PURE__ */ React152.createElement(QuizErrorMessage_default, { message: error, show: showError }), /* @__PURE__ */ React152.createElement("p", { className: classNames54(DEFAULT_DISCLAIMER_CLASS, classes.disclaimer) }, weightDisclaimer.replace("{range}", weightRange)));
};
var weightFormDefinition = {
  Component: WeightFormFields,
  isValid: ({ getFieldValue, preferredUnit }) => preferredUnit === FORM_UNITS.METRIC ? validateWeightMetric(
    getFieldValue(FORM_FIELD_IDS.currentWeightKg),
    getFieldValue(FORM_FIELD_IDS.goalWeightKg)
  ) : validateWeightImperial(
    getFieldValue(FORM_FIELD_IDS.currentWeightLb),
    getFieldValue(FORM_FIELD_IDS.goalWeightLb)
  ),
  getError: ({ getFieldValue, preferredUnit, validationMessages }) => preferredUnit === FORM_UNITS.METRIC ? getWeightError(
    getFieldValue(FORM_FIELD_IDS.currentWeightKg),
    getFieldValue(FORM_FIELD_IDS.goalWeightKg),
    FORM_UNITS.METRIC,
    validationMessages
  ) : getWeightError(
    getFieldValue(FORM_FIELD_IDS.currentWeightLb),
    getFieldValue(FORM_FIELD_IDS.goalWeightLb),
    FORM_UNITS.IMPERIAL,
    validationMessages
  ),
  getSetup: ({ getFieldValue, stepPreferredUnit }) => {
    const storedUnit = getFieldValue(FORM_FIELD_IDS.weightUnit);
    const preferredUnit = storedUnit === FORM_UNITS.METRIC || storedUnit === FORM_UNITS.IMPERIAL ? storedUnit : stepPreferredUnit || FORM_UNITS.IMPERIAL;
    return {
      preferredUnit,
      unitField: FORM_FIELD_IDS.weightUnit,
      initialValues: storedUnit ? void 0 : { [FORM_FIELD_IDS.weightUnit]: preferredUnit },
      focusFieldId: preferredUnit === FORM_UNITS.METRIC ? FORM_FIELD_IDS.currentWeightKg : FORM_FIELD_IDS.currentWeightLb
    };
  }
};

// src/organisms/quizForm/fields/EmailFormFields.tsx
import React153 from "react";
var EmailFormFields = ({ formContext }) => {
  const { getFieldValue, onFieldChange, onBlur, label, error, showError } = formContext;
  const translations = useQuizTranslations();
  const emailLabel = label != null ? label : translations.formLabels.email;
  return /* @__PURE__ */ React153.createElement(React153.Fragment, null, /* @__PURE__ */ React153.createElement(
    QuizTextField_default,
    {
      id: FORM_FIELD_IDS.email,
      type: "email",
      label: emailLabel,
      value: getFieldValue(FORM_FIELD_IDS.email),
      onChange: onFieldChange(FORM_FIELD_IDS.email),
      onBlur,
      error: showError,
      inputMode: "email"
    }
  ), /* @__PURE__ */ React153.createElement(QuizErrorMessage_default, { message: error, show: showError }));
};
var emailFormDefinition = {
  Component: EmailFormFields,
  isValid: ({ getFieldValue }) => validateEmail(getFieldValue(FORM_FIELD_IDS.email)),
  getError: ({ validationMessages }) => getEmailError(validationMessages),
  getSetup: () => ({
    focusFieldId: FORM_FIELD_IDS.email
  })
};

// src/organisms/quizForm/registry.ts
var FORM_DEFINITIONS = {
  [FORM_TYPES.AGE]: ageFormDefinition,
  [FORM_TYPES.HEIGHT]: heightFormDefinition,
  [FORM_TYPES.WEIGHT]: weightFormDefinition,
  [FORM_TYPES.EMAIL]: emailFormDefinition
};

// src/organisms/quizForm/useFormStepController.ts
function useFormStepController({ step, classes }) {
  var _a, _b;
  const { quizData, updateFormField, goToNext } = useQuizStore_default();
  const translations = useQuizTranslations();
  const continueButtonLabel = translations.continueButtonLabel;
  const validationMessages = translations.validationMessages;
  const [error, setError] = useState7("");
  const [showError, setShowError] = useState7(false);
  const formDefinition = FORM_DEFINITIONS[step.formType];
  const FormFieldsComponent = formDefinition == null ? void 0 : formDefinition.Component;
  const getFieldValue = useCallback(
    (field) => typeof quizData[field] === "string" ? quizData[field] : "",
    [quizData]
  );
  const formSetup = useMemo(
    () => {
      var _a2, _b2;
      return (_b2 = (_a2 = formDefinition == null ? void 0 : formDefinition.getSetup) == null ? void 0 : _a2.call(formDefinition, {
        getFieldValue,
        stepPreferredUnit: step.preferredUnit
      })) != null ? _b2 : {};
    },
    [formDefinition, getFieldValue, step.preferredUnit]
  );
  const preferredUnit = (_b = (_a = formSetup.preferredUnit) != null ? _a : step.preferredUnit) != null ? _b : FORM_UNITS.IMPERIAL;
  const onFieldChange = useCallback(
    (field) => (event) => {
      updateFormField(field, event.target.value);
      setShowError(false);
    },
    [updateFormField]
  );
  const handleUnitChange = useCallback(
    (unit) => {
      if (!formSetup.unitField) {
        return;
      }
      updateFormField(formSetup.unitField, unit);
      setShowError(false);
    },
    [formSetup.unitField, updateFormField]
  );
  const isValid = useMemo(
    () => {
      var _a2;
      return (_a2 = formDefinition == null ? void 0 : formDefinition.isValid({
        preferredUnit,
        getFieldValue,
        validationMessages
      })) != null ? _a2 : false;
    },
    [formDefinition, getFieldValue, preferredUnit, validationMessages]
  );
  const getValidationError = useCallback(
    () => (formDefinition == null ? void 0 : formDefinition.getError({
      preferredUnit,
      getFieldValue,
      validationMessages
    })) || validationMessages.inputInvalid,
    [formDefinition, getFieldValue, preferredUnit, validationMessages]
  );
  const showValidationError = useCallback(() => {
    setError(getValidationError());
    setShowError(true);
  }, [getValidationError]);
  const handleBlur = useCallback(
    (event) => {
      if (event.relatedTarget && (event.relatedTarget.closest(".unit-toggle-container") || event.relatedTarget.closest(".step-input-group"))) {
        return;
      }
      if (!isValid) {
        showValidationError();
      }
    },
    [isValid, showValidationError]
  );
  const handleSubmit = useCallback(() => {
    if (!isValid) {
      showValidationError();
      return;
    }
    setShowError(false);
    goToNext();
  }, [goToNext, isValid, showValidationError]);
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleSubmit();
      }
    },
    [handleSubmit]
  );
  useEffect8(() => {
    if (!formSetup.initialValues) {
      return;
    }
    Object.entries(formSetup.initialValues).forEach(([field, value]) => {
      if (!getFieldValue(field)) {
        updateFormField(field, value);
      }
    });
  }, [formSetup.initialValues, getFieldValue, updateFormField]);
  useEffect8(() => {
    const targetId = formSetup.focusFieldId;
    if (!targetId) {
      return void 0;
    }
    const timer = setTimeout(() => {
      const input = document.getElementById(targetId);
      if (input) {
        input.focus();
        input.click();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [formSetup.focusFieldId]);
  return {
    continueButtonLabel,
    error,
    showError,
    isValid,
    FormFieldsComponent,
    formContext: {
      preferredUnit,
      getFieldValue,
      onFieldChange,
      onUnitChange: handleUnitChange,
      onBlur: handleBlur,
      label: step.label,
      error,
      showError,
      classes
    },
    handleKeyDown,
    handleSubmit
  };
}

// src/organisms/quiz/FormStep.tsx
var FormStep = ({ step, className, classes = {} }) => {
  const { title, subtitle } = step;
  const {
    continueButtonLabel,
    isValid,
    FormFieldsComponent,
    formContext,
    handleKeyDown,
    handleSubmit
  } = useFormStepController({ step, classes });
  return /* @__PURE__ */ React154.createElement(
    StepLayout_default,
    {
      title,
      subtitle,
      noPadding: true,
      className,
      classes: classes.layout
    },
    /* @__PURE__ */ React154.createElement("div", { onKeyDown: handleKeyDown, className: classNames55(classes.formContent) }, FormFieldsComponent ? /* @__PURE__ */ React154.createElement(FormFieldsComponent, { formContext }) : null),
    /* @__PURE__ */ React154.createElement("div", { className: classNames55("pt-4 md:pt-6", classes.actions) }, /* @__PURE__ */ React154.createElement(QuizButton_default, { onClick: handleSubmit, disabled: !isValid, className: classes.button }, continueButtonLabel))
  );
};
var FormStep_default = FormStep;

// src/organisms/quiz/InfoStep.tsx
import React156 from "react";
import classNames57 from "classnames";

// src/molecules/quiz/InfoFeatureItem.tsx
import React155 from "react";
import classNames56 from "classnames";
var DEFAULT_ITEM_CLASS4 = "flex items-center gap-2 md:gap-4 rounded-[14px] md:rounded-[18px] p-2.5 md:p-4 bg-white";
var DEFAULT_ITEM_IMAGE_CLASS = "w-[54px] md:w-[66px] h-[54px] md:h-[66px] shrink-0";
var DEFAULT_ITEM_TITLE_CLASS = "text-[0.9rem] md:text-base font-semibold text-green";
var DEFAULT_ITEM_TEXT_CLASS = "text-[0.9rem] md:text-[0.9rem] text-gray leading-[1.4]";
var DEFAULT_ITEM_CONTENT_CLASS = "flex flex-col gap-0 md:gap-0.5";
var InfoFeatureItem = ({ item, className, classes = {} }) => {
  return /* @__PURE__ */ React155.createElement("li", { className: classNames56(DEFAULT_ITEM_CLASS4, className, classes.root) }, /* @__PURE__ */ React155.createElement(
    "img",
    {
      src: item.image,
      alt: item.imageAlt || item.title,
      className: classNames56(DEFAULT_ITEM_IMAGE_CLASS, classes.image)
    }
  ), /* @__PURE__ */ React155.createElement("div", { className: classNames56(DEFAULT_ITEM_CONTENT_CLASS, classes.content) }, /* @__PURE__ */ React155.createElement("span", { className: classNames56(DEFAULT_ITEM_TITLE_CLASS, classes.title) }, item.title), /* @__PURE__ */ React155.createElement("span", { className: classNames56(DEFAULT_ITEM_TEXT_CLASS, classes.text) }, item.text)));
};
var InfoFeatureItem_default = InfoFeatureItem;

// src/organisms/quiz/InfoStep.tsx
var DEFAULT_LIST_CLASS2 = "list-none flex flex-col gap-2.5 md:gap-2.5 mt-2.5 md:mt-3";
var DEFAULT_HERO_IMAGE_CLASS = "max-w-full h-auto mx-auto block pb-4 md:pb-4";
var DEFAULT_INTRO_TEXT_CLASS = "text-[0.95rem] md:text-base leading-[1.3] md:leading-[1.6] text-center";
var InfoStep = ({ step, className, classes = {} }) => {
  const content = step.content;
  return /* @__PURE__ */ React156.createElement(
    StepLayout_default,
    {
      title: step.title,
      subtitle: step.subtitle,
      className,
      classes: classes.layout
    },
    content.image && /* @__PURE__ */ React156.createElement(
      "img",
      {
        src: content.image,
        alt: content.imageAlt || "",
        className: classNames57(DEFAULT_HERO_IMAGE_CLASS, classes.image)
      }
    ),
    content.description && /* @__PURE__ */ React156.createElement("p", { className: classNames57(DEFAULT_INTRO_TEXT_CLASS, classes.description) }, content.description),
    content.items.length > 0 && /* @__PURE__ */ React156.createElement("ul", { className: classNames57(DEFAULT_LIST_CLASS2, classes.list) }, content.items.map((item) => /* @__PURE__ */ React156.createElement(
      InfoFeatureItem_default,
      {
        key: `${item.title}-${item.image}`,
        item,
        className: classes.item,
        classes: classes.itemClasses
      }
    )))
  );
};
var InfoStep_default = InfoStep;

// src/organisms/quiz/LoadingStep.tsx
import React160 from "react";
import classNames61 from "classnames";

// src/molecules/quiz/LoadingItem.tsx
import React159 from "react";
import classNames60 from "classnames";

// src/atoms/quiz/LoadingItemCompleteIndicator.tsx
import React158 from "react";
import classNames59 from "classnames";

// src/atoms/quiz/CompleteIcon.tsx
import React157 from "react";
import classNames58 from "classnames";
var DEFAULT_ICON_CLASS25 = "w-5 h-5 md:w-6 md:h-6";
var CompleteIcon = ({ className, classes = {} }) => /* @__PURE__ */ React157.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: classNames58(DEFAULT_ICON_CLASS25, className, classes.icon),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React157.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#1C8B55" }),
  /* @__PURE__ */ React157.createElement(
    "path",
    {
      d: "M17.196 8.354a.75.75 0 0 1 0 1.06l-6.01 6.01a.75.75 0 0 1-1.06 0l-3.322-3.322a.75.75 0 1 1 1.06-1.06l2.792 2.791 5.48-5.48a.75.75 0 0 1 1.06 0Z",
      fill: "#FFF"
    }
  )
);
var CompleteIcon_default = CompleteIcon;

// src/atoms/quiz/LoadingItemCompleteIndicator.tsx
var DEFAULT_WRAPPER_CLASS5 = "flex items-center justify-center w-5 h-5 md:w-6 md:h-6 relative";
var DEFAULT_ICON_CLASS26 = "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center transition-all duration-400 ease-[cubic-bezier(0.25,1.6,0.5,1)]";
var LoadingItemCompleteIndicator = ({
  isCompleted,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React158.createElement("div", { className: classNames59(DEFAULT_WRAPPER_CLASS5, className, classes.root) }, /* @__PURE__ */ React158.createElement(
    "div",
    {
      className: classNames59(
        DEFAULT_ICON_CLASS26,
        isCompleted ? "opacity-100 scale-100 rotate-0" : "opacity-0 scale-[0.4] rotate-[-18deg]",
        classes.icon
      )
    },
    /* @__PURE__ */ React158.createElement(CompleteIcon_default, null)
  ));
};
var LoadingItemCompleteIndicator_default = LoadingItemCompleteIndicator;

// src/molecules/quiz/LoadingItem.tsx
var DEFAULT_ITEM_CLASS5 = "relative overflow-hidden bg-white rounded-[14px] md:rounded-xl font-medium transition-opacity duration-300";
var DEFAULT_PROGRESS_CLASS = "absolute top-0 left-0 h-full bg-[#FFFEEF] z-[5] transition-[width] duration-[1500ms] ease-out";
var DEFAULT_ITEM_CONTENT_CLASS2 = "relative z-10 flex items-center justify-between px-3.5 md:px-5 py-3 md:py-[1.4rem] min-h-[54px] md:min-h-[60px] bg-transparent";
var DEFAULT_ITEM_TEXT_CLASS2 = "text-[0.95rem] md:text-base";
var LoadingItem = ({
  text,
  isActive,
  isCompleted,
  isRevealed,
  isInitiallyVisible = false,
  itemDurationMs,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React159.createElement(
    "div",
    {
      className: classNames60(
        DEFAULT_ITEM_CLASS5,
        isInitiallyVisible ? "opacity-60" : isRevealed ? "opacity-60 animate-fade-in" : "opacity-0 translate-y-[25px]",
        (isActive || isCompleted) && "opacity-100",
        className,
        classes.root
      )
    },
    /* @__PURE__ */ React159.createElement(
      "div",
      {
        className: classNames60(
          DEFAULT_PROGRESS_CLASS,
          isActive || isCompleted ? "w-full" : "w-0",
          classes.progress
        ),
        style: {
          transitionDuration: isCompleted ? "0ms" : `${itemDurationMs - 300}ms`
        }
      }
    ),
    /* @__PURE__ */ React159.createElement("div", { className: classNames60(DEFAULT_ITEM_CONTENT_CLASS2, classes.content) }, /* @__PURE__ */ React159.createElement("span", { className: classNames60(DEFAULT_ITEM_TEXT_CLASS2, classes.text) }, text), /* @__PURE__ */ React159.createElement(
      LoadingItemCompleteIndicator_default,
      {
        isCompleted,
        className: classes.indicator,
        classes: { icon: classes.indicatorIcon }
      }
    ))
  );
};
var LoadingItem_default = LoadingItem;

// src/helpers/quiz/useLoadingStepProgress.ts
import { useEffect as useEffect9, useState as useState8 } from "react";
var ITEM_DURATION_MS = 1800;
var SWITCH_DELAY_MS = 200;
function getInitialState() {
  return {
    activeStep: 0,
    completedSteps: [],
    revealedSteps: [0]
  };
}
function useLoadingStepProgress({
  items,
  isManualAdvance,
  onComplete,
  onCanContinueChange
}) {
  const [state, setState] = useState8(getInitialState);
  useEffect9(() => {
    if (!isManualAdvance) {
      return;
    }
    onCanContinueChange(false);
  }, [isManualAdvance, onCanContinueChange, items.length]);
  useEffect9(() => {
    const timers = [];
    const itemCount = items.length;
    setState(getInitialState());
    items.forEach((_, index) => {
      timers.push(
        setTimeout(
          () => {
            setState((previousState) => ({
              ...previousState,
              completedSteps: previousState.completedSteps.includes(index) ? previousState.completedSteps : [...previousState.completedSteps, index],
              revealedSteps: index + 1 < itemCount && !previousState.revealedSteps.includes(index + 1) ? [...previousState.revealedSteps, index + 1] : previousState.revealedSteps
            }));
            if (index + 1 < itemCount) {
              timers.push(
                setTimeout(() => {
                  setState((previousState) => ({
                    ...previousState,
                    activeStep: index + 1
                  }));
                }, SWITCH_DELAY_MS)
              );
            }
          },
          ITEM_DURATION_MS * (index + 1)
        )
      );
    });
    if (!isManualAdvance) {
      timers.push(
        setTimeout(
          () => {
            onComplete();
          },
          ITEM_DURATION_MS * itemCount + SWITCH_DELAY_MS
        )
      );
    }
    return () => timers.forEach(clearTimeout);
  }, [isManualAdvance, items, onComplete]);
  useEffect9(() => {
    if (!isManualAdvance) {
      return;
    }
    const allItemsRevealed = state.revealedSteps.length >= items.length;
    const allItemsCompleted = state.completedSteps.length >= items.length;
    onCanContinueChange(items.length > 0 && allItemsRevealed && allItemsCompleted);
  }, [
    isManualAdvance,
    items.length,
    onCanContinueChange,
    state.completedSteps.length,
    state.revealedSteps.length
  ]);
  return {
    activeStep: state.activeStep,
    completedSteps: state.completedSteps,
    revealedSteps: state.revealedSteps,
    itemDurationMs: ITEM_DURATION_MS
  };
}

// src/organisms/quiz/LoadingStep.tsx
var DEFAULT_LIST_CLASS3 = "flex flex-col gap-2 md:gap-2.5";
function getItemState(index, activeStep, completedSteps, revealedSteps) {
  const isCompleted = completedSteps.includes(index);
  return {
    isCompleted,
    isActive: activeStep === index && !isCompleted,
    isRevealed: revealedSteps.includes(index)
  };
}
var LoadingStep = ({ step, className, classes = {} }) => {
  const { goToNext, setCanContinue } = useQuizStore_default();
  const isManualAdvance = (step == null ? void 0 : step.showFixedButton) === true;
  const loadingItems = Array.isArray(step == null ? void 0 : step.items) ? step.items : [];
  const { activeStep, completedSteps, revealedSteps, itemDurationMs } = useLoadingStepProgress({
    items: loadingItems,
    isManualAdvance,
    onComplete: goToNext,
    onCanContinueChange: setCanContinue
  });
  return /* @__PURE__ */ React160.createElement(
    StepLayout_default,
    {
      title: step.title,
      subtitle: step.subtitle,
      noPadding: true,
      className,
      classes: classes.layout
    },
    /* @__PURE__ */ React160.createElement("div", { className: classNames61(DEFAULT_LIST_CLASS3, classes.list) }, loadingItems.map((loadingItem, index) => {
      const { isRevealed, isActive, isCompleted } = getItemState(
        index,
        activeStep,
        completedSteps,
        revealedSteps
      );
      return /* @__PURE__ */ React160.createElement(
        LoadingItem_default,
        {
          key: index,
          text: loadingItem.text,
          isActive,
          isCompleted,
          isRevealed,
          isInitiallyVisible: index === 0,
          itemDurationMs,
          className: classes.item,
          classes: {
            progress: classes.progress,
            content: classes.itemContent,
            text: classes.itemText,
            indicator: classes.iconWrapper,
            indicatorIcon: classes.icon
          }
        }
      );
    }))
  );
};
var LoadingStep_default = LoadingStep;

// src/organisms/quiz/CustomStep.tsx
import React161 from "react";
import classNames62 from "classnames";
var DEFAULT_WRAPPER_CLASS6 = "animate-fade-in pb-16 md:pb-[65px]";
var CustomStep = ({
  step,
  customStepComponents = {},
  className,
  classes = {}
}) => {
  const CustomStepComponent = customStepComponents[step.content];
  if (!CustomStepComponent) {
    throw new Error(`CustomStep: missing content mapping for "${step.content}".`);
  }
  return /* @__PURE__ */ React161.createElement("div", { className: classNames62(DEFAULT_WRAPPER_CLASS6, className, classes.root) }, /* @__PURE__ */ React161.createElement(CustomStepComponent, null));
};
var CustomStep_default = CustomStep;

// src/sections/Quiz.tsx
var STEP_COMPONENT_MAP = {
  [STEP_TYPES.SINGLE_SELECT]: SingleSelectStep_default,
  [STEP_TYPES.MULTISELECT]: MultiSelectStep_default,
  [STEP_TYPES.FORM]: FormStep_default,
  [STEP_TYPES.INFO]: InfoStep_default,
  [STEP_TYPES.LOADING]: LoadingStep_default,
  [STEP_TYPES.CUSTOM]: CustomStep_default
};
var DEFAULT_WRAPPER_CLASS7 = "w-full overflow-hidden";
var QUIZ_PHASE = {
  PRIMARY: "primary",
  CUSTOM: "custom"
};
var Quiz = ({
  primarySteps,
  customSteps = [],
  adapters: externalAdapters,
  translations,
  customStepComponents = {},
  logo,
  className,
  classes = {}
}) => {
  var _a;
  const [phase, setPhase] = useState9(
    QUIZ_PHASE.PRIMARY
  );
  const [customSeedData, setCustomSeedData] = useState9({});
  const hasCustomSteps = customSteps.length > 0;
  const activeSteps = phase === QUIZ_PHASE.CUSTOM ? customSteps : primarySteps;
  const wrapperClassName = classNames63(DEFAULT_WRAPPER_CLASS7, className, classes.wrapper);
  const handlePrimaryComplete = useCallback2(
    (quizData) => {
      var _a2, _b;
      (_a2 = externalAdapters == null ? void 0 : externalAdapters.onPrimaryComplete) == null ? void 0 : _a2.call(externalAdapters, quizData || {});
      if (hasCustomSteps) {
        setCustomSeedData(quizData || {});
        setPhase(QUIZ_PHASE.CUSTOM);
        return;
      }
      (_b = externalAdapters == null ? void 0 : externalAdapters.onComplete) == null ? void 0 : _b.call(externalAdapters, quizData || {});
    },
    [externalAdapters, hasCustomSteps]
  );
  const handleCustomComplete = useCallback2(
    (quizData) => {
      var _a2, _b;
      (_a2 = externalAdapters == null ? void 0 : externalAdapters.onCustomComplete) == null ? void 0 : _a2.call(externalAdapters, quizData || {});
      (_b = externalAdapters == null ? void 0 : externalAdapters.onComplete) == null ? void 0 : _b.call(externalAdapters, quizData || {});
    },
    [externalAdapters]
  );
  return /* @__PURE__ */ React162.createElement("section", { className: wrapperClassName }, /* @__PURE__ */ React162.createElement(QuizTranslationsProvider, { value: translations }, /* @__PURE__ */ React162.createElement(
    QuizEngine_default,
    {
      key: phase,
      steps: activeSteps,
      logo,
      className: (_a = classes.engine) == null ? void 0 : _a.root,
      classes: classes.engine,
      initialData: phase === QUIZ_PHASE.CUSTOM ? customSeedData : void 0,
      onComplete: phase === QUIZ_PHASE.CUSTOM ? handleCustomComplete : handlePrimaryComplete,
      renderStep: ({ step, stepNumber }) => /* @__PURE__ */ React162.createElement(
        StepRenderer_default,
        {
          step,
          stepNumber,
          componentMap: STEP_COMPONENT_MAP,
          stepClasses: classes.steps,
          componentProps: {
            [STEP_TYPES.CUSTOM]: {
              customStepComponents
            }
          }
        }
      )
    }
  )));
};

// src/molecules/FaqItem.tsx
import React163, { useEffect as useEffect10, useRef as useRef5, useState as useState10 } from "react";
var DEFAULT_ROOT_CLASS16 = "";
var DEFAULT_CARD_CLASS3 = "border border-(--faq-card-border-color) rounded-md [background:var(--faq-card-background-color)]";
var DEFAULT_BUTTON_CLASS6 = "w-full flex items-center justify-between gap-4 px-6 py-4 cursor-pointer";
var DEFAULT_QUESTION_CLASS = "font-bold text-lg text-(--faq-question-color) text-left";
var DEFAULT_ICONWRAPPER_CLASS = "transition-transform duration-200";
var DEFAULT_CONTENT_CLASS9 = "overflow-hidden transition-[max-height] duration-300 ease-in-out";
var DEFAULT_CONTENTINNER_CLASS = "text-sm text-(--faq-answer-color) transition-opacity duration-200 px-6 pt-1 pb-4";
var FaqItem = ({
  id,
  question,
  answer,
  isOpen,
  onToggle,
  className,
  classes = {}
}) => {
  const contentRef = useRef5(null);
  const [maxHeight, setMaxHeight] = useState10("0px");
  useEffect10(() => {
    if (!contentRef.current) return;
    const height = contentRef.current.scrollHeight;
    setMaxHeight(isOpen ? `${height}px` : "0px");
  }, [isOpen, answer]);
  const openedIcon = /* @__PURE__ */ React163.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      "aria-hidden": true
    },
    /* @__PURE__ */ React163.createElement("path", { d: "M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z", fill: "currentColor" })
  );
  const closedIcon = /* @__PURE__ */ React163.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "2",
      viewBox: "0 0 14 2",
      fill: "none",
      "aria-hidden": true
    },
    /* @__PURE__ */ React163.createElement("path", { d: "M14 2H0V0H14V2Z", fill: "currentColor" })
  );
  const rootCls = cn(DEFAULT_ROOT_CLASS16, className, classes.root);
  const cardCls = cn(DEFAULT_CARD_CLASS3, classes.card);
  const buttonCls = cn(DEFAULT_BUTTON_CLASS6, classes.button);
  const questionCls = cn(DEFAULT_QUESTION_CLASS, classes.question);
  const iconWrapperCls = cn(
    DEFAULT_ICONWRAPPER_CLASS,
    { "rotate-180": isOpen },
    classes.iconWrapper
  );
  const contentCls = cn(DEFAULT_CONTENT_CLASS9, classes.content);
  const contentInnerCls = cn(
    DEFAULT_CONTENTINNER_CLASS,
    { "opacity-100": isOpen, "opacity-0": !isOpen },
    classes.contentInner
  );
  return /* @__PURE__ */ React163.createElement(Container, { className: rootCls }, /* @__PURE__ */ React163.createElement("div", { className: cardCls }, /* @__PURE__ */ React163.createElement(
    "button",
    {
      type: "button",
      onClick: () => onToggle(id),
      "aria-expanded": isOpen,
      "aria-controls": `faq-content-${id}`,
      className: buttonCls
    },
    /* @__PURE__ */ React163.createElement("span", { className: questionCls }, question),
    /* @__PURE__ */ React163.createElement("span", { className: iconWrapperCls }, isOpen ? closedIcon : openedIcon)
  ), /* @__PURE__ */ React163.createElement("div", { id: `faq-content-${id}`, className: contentCls, style: { maxHeight } }, /* @__PURE__ */ React163.createElement("div", { ref: contentRef, className: contentInnerCls }, answer))));
};

// src/organisms/FaqAccordion.tsx
import React164, { useState as useState11 } from "react";
var DEFAULT_CONTAINER_CLASS20 = "flex flex-col gap-4";
var FaqAccordion = ({ items, className, classes = {} }) => {
  const [openId, setOpenId] = useState11(null);
  const handleToggle = (id) => {
    setOpenId((current) => current === id ? null : id);
  };
  const containerCls = cn(DEFAULT_CONTAINER_CLASS20, className, classes.container);
  return /* @__PURE__ */ React164.createElement(Container, { className: containerCls }, items.map((item) => /* @__PURE__ */ React164.createElement(
    FaqItem,
    {
      key: item.id,
      id: item.id,
      question: item.question,
      answer: item.answer,
      isOpen: openId === item.id,
      onToggle: handleToggle,
      className: classes.item,
      classes: classes.itemClasses
    }
  )));
};

// src/organisms/Footer.tsx
import React167, { useState as useState12 } from "react";
import classNames66 from "classnames";

// src/molecules/FooterSection.tsx
import React165 from "react";
import parse from "html-react-parser";
import classNames64 from "classnames";
var DEFAULT_SECTION_CLASS = "flex gap-4 flex-col";
var DEFAULT_SECTION_TITLE_CLASS = "text-(--footer-text-color) text-xl font-bold mb-2";
var DEFAULT_SECTION_LINK_CLASS = "flex items-center gap-2 text-(--footer-text-color) text-sm";
var DEFAULT_SECTION_LINK_ICON_CLASS = "h-4 w-4";
var FooterSection = ({
  title,
  links,
  showIcon,
  className,
  classes = {}
}) => {
  if (!title && (!links || links.length === 0)) return null;
  const rootCls = classNames64(DEFAULT_SECTION_CLASS, className, classes.root);
  const titleCls = classNames64(DEFAULT_SECTION_TITLE_CLASS, classes.title);
  const linkCls = classNames64(DEFAULT_SECTION_LINK_CLASS, classes.link);
  const linkIconCls = classNames64(DEFAULT_SECTION_LINK_ICON_CLASS, classes.linkIcon);
  return /* @__PURE__ */ React165.createElement("div", { className: rootCls }, title ? /* @__PURE__ */ React165.createElement(Text, { className: titleCls }, title) : null, links == null ? void 0 : links.map((link, index) => {
    const href = (link.page_or_url === "url" ? link.footer_url : link.footer_page) || void 0;
    const label = (link == null ? void 0 : link.tr_footer_label) || "";
    const newTab = (link == null ? void 0 : link.footer_newTab) || false;
    const icon = showIcon ? link == null ? void 0 : link.footer_needHelpIcon : null;
    if (!label) return null;
    return /* @__PURE__ */ React165.createElement("div", { key: index }, /* @__PURE__ */ React165.createElement(
      "a",
      {
        href,
        target: newTab ? "_blank" : "_self",
        rel: newTab ? "noopener noreferrer" : void 0,
        className: linkCls
      },
      icon && /* @__PURE__ */ React165.createElement(Image, { src: icon, className: linkIconCls }),
      parse(label)
    ));
  }));
};

// src/molecules/AccordionSection.tsx
import React166 from "react";
import classNames65 from "classnames";
var DEFAULT_ACCORDION_BUTTON_CLASS = "relative w-full flex items-center justify-center";
var DEFAULT_ACCORDION_LABEL_CLASS = "text-(--footer-text-color) text-base font-bold tracking-wide";
var DEFAULT_ACCORDION_ICONWRAPPER_CLASS = "absolute right-0 top-1/2 -translate-y-1/2 transition-transform";
var DEFAULT_ACCORDION_CONTENT_CLASS = "";
var AccordionSection = ({
  label,
  isOpen,
  onToggle,
  children,
  className,
  classes = {}
}) => {
  if (!label) return null;
  const rootCls = classNames65("w-full", className, classes.root);
  const buttonCls = classNames65(DEFAULT_ACCORDION_BUTTON_CLASS, classes.button);
  const labelCls = classNames65(DEFAULT_ACCORDION_LABEL_CLASS, classes.label);
  const iconWrapperCls = classNames65(
    DEFAULT_ACCORDION_ICONWRAPPER_CLASS,
    { "rotate-90": isOpen },
    classes.iconWrapper
  );
  const contentCls = classNames65(DEFAULT_ACCORDION_CONTENT_CLASS, classes.content);
  return /* @__PURE__ */ React166.createElement("div", { className: rootCls }, /* @__PURE__ */ React166.createElement("button", { type: "button", onClick: onToggle, className: buttonCls }, /* @__PURE__ */ React166.createElement("span", { className: labelCls }, label), /* @__PURE__ */ React166.createElement("span", { className: iconWrapperCls }, /* @__PURE__ */ React166.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "7",
      height: "14",
      viewBox: "0 0 7 14",
      fill: "none"
    },
    /* @__PURE__ */ React166.createElement(
      "path",
      {
        d: "M0.188287 1.12543C0.128142 1.06183 0.081122 0.98693 0.0499121 0.905129C0.0187021 0.823329 0.00391205 0.736129 0.00638805 0.648629C0.00886505 0.561029 0.0285581 0.474929 0.0643441 0.394929C0.100129 0.315029 0.151307 0.242929 0.214954 0.182829C0.278601 0.122629 0.353472 0.0756292 0.435292 0.0444288C0.517111 0.0132284 0.604276 -0.0015707 0.69181 0.000928879C0.77935 0.00342846 0.86554 0.0230293 0.94546 0.0588293C1.02538 0.0946293 1.09748 0.145829 1.15762 0.209429L6.82429 6.20947C6.94131 6.33325 7.00652 6.49713 7.00652 6.66747C7.00652 6.83781 6.94131 7.00169 6.82429 7.12547L1.15762 13.1261C1.09787 13.1912 1.0258 13.2437 0.94558 13.2806C0.86536 13.3176 0.7786 13.3382 0.69034 13.3414C0.602075 13.3445 0.514068 13.3301 0.431431 13.2989C0.348793 13.2678 0.273171 13.2205 0.208957 13.1598C0.144743 13.0992 0.0932181 13.0264 0.0573731 12.9457C0.0215291 12.865 0.00208105 12.7779 0.000158055 12.6896C-0.00176495 12.6013 0.0138761 12.5135 0.0461711 12.4313C0.0784681 12.3491 0.126775 12.2742 0.188288 12.2108L5.42295 6.66747L0.188287 1.12543Z",
        fill: "white"
      }
    )
  ))), isOpen && /* @__PURE__ */ React166.createElement("div", { className: contentCls }, children));
};

// src/organisms/Footer.tsx
var Footer = ({ footer, generalSettings, className, classes = {} }) => {
  const {
    tr_footer_description,
    tr_footer_infoLabel,
    footer_infoLinks,
    tr_footer_orderLabel,
    footer_orderLinks,
    tr_footer_needHelpLabel,
    footer_needHelp
  } = footer || {};
  const [isInfoOpen, setIsInfoOpen] = useState12(false);
  const [isOrderOpen, setIsOrderOpen] = useState12(false);
  const DEFAULT_FOOTER_WRAPPER_CLASS = "bg-(--footer-background-color)";
  const DEFAULT_DESKTOP_CONTAINER_CLASS = "hidden lg:flex max-w-body mx-auto py-10 justify-between px-4";
  const DEFAULT_TABLET_CONTAINER_CLASS = "hidden md:flex lg:hidden max-w-body mx-auto py-10 px-6 flex-col gap-6";
  const DEFAULT_MOBILE_CONTAINER_CLASS = "flex md:hidden max-w-body mx-auto py-6 px-4 flex-col gap-6";
  const DEFAULT_SECTION_CLASS49 = "flex gap-4 flex-col md:max-w-[454px]";
  const DEFAULT_SECTION_TITLE_CLASS3 = "text-(--footer-text-color) text-xl font-bold mb-2";
  const DEFAULT_SECTION_LINK_CLASS2 = "flex items-center gap-2 text-(--footer-text-color) text-sm";
  const DEFAULT_SECTION_LINK_ICON_CLASS2 = "h-4 w-4";
  const DEFAULT_SECTION_LINK_TEXT_CLASS = "";
  const wrapperCls = classNames66(DEFAULT_FOOTER_WRAPPER_CLASS, className, classes.wrapper);
  const desktopContainerCls = classNames66(DEFAULT_DESKTOP_CONTAINER_CLASS, classes.desktopContainer);
  const tabletContainerCls = classNames66(DEFAULT_TABLET_CONTAINER_CLASS, classes.tabletContainer);
  const mobileContainerCls = classNames66(DEFAULT_MOBILE_CONTAINER_CLASS, classes.mobileContainer);
  const logoImageCls = classNames66("max-h-[30px] w-fit", classes.logoImage);
  const logoImageMobileCls = classNames66("max-h-[52px] w-full", classes.logoImage);
  const descriptionCls = classNames66("text-(--footer-text-color) text-sm", classes.description);
  const dividerCls = classNames66("h-px w-full bg-(--footer-divider-color)", classes.divider);
  const sectionClasses = {
    root: classNames66(DEFAULT_SECTION_CLASS49, classes.section),
    title: classNames66(DEFAULT_SECTION_TITLE_CLASS3, classes.sectionTitle),
    link: classNames66(DEFAULT_SECTION_LINK_CLASS2, classes.sectionLink),
    linkIcon: classNames66(DEFAULT_SECTION_LINK_ICON_CLASS2, classes.sectionLinkIcon),
    linkText: classNames66(DEFAULT_SECTION_LINK_TEXT_CLASS, classes.sectionLinkText)
  };
  return /* @__PURE__ */ React167.createElement("footer", { id: "footer", className: wrapperCls }, /* @__PURE__ */ React167.createElement(Container, { className: desktopContainerCls }, /* @__PURE__ */ React167.createElement("div", { className: DEFAULT_SECTION_CLASS49 }, /* @__PURE__ */ React167.createElement(Image, { className: logoImageCls, src: generalSettings == null ? void 0 : generalSettings.logo_white }), tr_footer_description && /* @__PURE__ */ React167.createElement(Text, { className: descriptionCls }, tr_footer_description)), /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_infoLabel,
      links: footer_infoLinks != null ? footer_infoLinks : void 0,
      classes: {
        root: sectionClasses.root,
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  ), /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_orderLabel,
      links: footer_orderLinks != null ? footer_orderLinks : void 0,
      classes: {
        root: sectionClasses.root,
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  ), /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_needHelpLabel,
      links: footer_needHelp != null ? footer_needHelp : void 0,
      showIcon: true,
      classes: {
        root: sectionClasses.root,
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  )), /* @__PURE__ */ React167.createElement(Container, { className: tabletContainerCls }, /* @__PURE__ */ React167.createElement("div", { className: "flex flex-col items-center text-center gap-4 mx-auto" }, /* @__PURE__ */ React167.createElement(Image, { className: logoImageCls, src: generalSettings == null ? void 0 : generalSettings.logo_white }), tr_footer_description && /* @__PURE__ */ React167.createElement(Text, { className: descriptionCls }, tr_footer_description)), /* @__PURE__ */ React167.createElement("div", { className: dividerCls }), /* @__PURE__ */ React167.createElement("div", { className: "flex flex-wrap justify-center gap-12" }, /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_infoLabel,
      links: footer_infoLinks != null ? footer_infoLinks : void 0,
      classes: {
        root: sectionClasses.root,
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  ), /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_orderLabel,
      links: footer_orderLinks != null ? footer_orderLinks : void 0,
      classes: {
        root: sectionClasses.root,
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  ), /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_needHelpLabel,
      links: footer_needHelp != null ? footer_needHelp : void 0,
      showIcon: true,
      classes: {
        root: sectionClasses.root,
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  ))), /* @__PURE__ */ React167.createElement(Container, { className: mobileContainerCls }, /* @__PURE__ */ React167.createElement("div", { className: "flex flex-col items-center text-center gap-4" }, /* @__PURE__ */ React167.createElement(Image, { className: logoImageMobileCls, src: generalSettings == null ? void 0 : generalSettings.logo_white }), tr_footer_description && /* @__PURE__ */ React167.createElement(Text, { className: descriptionCls }, tr_footer_description)), /* @__PURE__ */ React167.createElement("div", { className: dividerCls }), /* @__PURE__ */ React167.createElement(
    FooterSection,
    {
      title: tr_footer_needHelpLabel,
      links: footer_needHelp != null ? footer_needHelp : void 0,
      showIcon: true,
      className: "gap-3 items-center",
      classes: {
        root: classNames66(sectionClasses.root, "gap-3 items-center"),
        title: sectionClasses.title,
        link: sectionClasses.link,
        linkIcon: sectionClasses.linkIcon,
        linkText: sectionClasses.linkText
      }
    }
  ), /* @__PURE__ */ React167.createElement("div", { className: dividerCls }), /* @__PURE__ */ React167.createElement(
    AccordionSection,
    {
      label: tr_footer_infoLabel,
      isOpen: isInfoOpen,
      onToggle: () => setIsInfoOpen((prev) => !prev),
      classes: classes.accordion
    },
    /* @__PURE__ */ React167.createElement(
      FooterSection,
      {
        links: footer_infoLinks != null ? footer_infoLinks : void 0,
        showIcon: false,
        className: "items-center mt-4",
        classes: {
          root: classNames66(sectionClasses.root, "items-center mt-4"),
          title: sectionClasses.title,
          link: sectionClasses.link,
          linkIcon: sectionClasses.linkIcon,
          linkText: sectionClasses.linkText
        }
      }
    )
  ), /* @__PURE__ */ React167.createElement("div", { className: dividerCls }), /* @__PURE__ */ React167.createElement(
    AccordionSection,
    {
      label: tr_footer_orderLabel,
      isOpen: isOrderOpen,
      onToggle: () => setIsOrderOpen((prev) => !prev),
      classes: classes.accordion
    },
    /* @__PURE__ */ React167.createElement(
      FooterSection,
      {
        links: footer_orderLinks != null ? footer_orderLinks : void 0,
        showIcon: false,
        className: "items-center mt-4",
        classes: {
          root: classNames66(sectionClasses.root, "items-center mt-4"),
          title: sectionClasses.title,
          link: sectionClasses.link,
          linkIcon: sectionClasses.linkIcon,
          linkText: sectionClasses.linkText
        }
      }
    )
  )));
};

// src/sections/FooterSection.tsx
import React176 from "react";

// src/organisms/footer/BenefitsBar.tsx
import React169 from "react";

// src/molecules/footer/BenefitItem.tsx
import React168 from "react";
var DEFAULT_BENEFIT_ITEM_CLASS = "flex flex-col items-center gap-4 lg:flex-row";
var DEFAULT_BENEFIT_ICON_CLASS = "size-16 shrink-0 flex items-center justify-center";
var DEFAULT_BENEFIT_TEXT_WRAPPER_CLASS = "flex flex-col gap-1 items-center lg:items-start";
var DEFAULT_BENEFIT_TITLE_CLASS = "text-(--footer-heading) font-bold text-lg uppercase leading-6 text-center lg:text-left";
var DEFAULT_BENEFIT_SUBTITLE_CLASS = "text-(--footer-text) text-sm leading-5 text-center lg:text-left";
var BenefitItem = ({ benefit, className, classes = {} }) => /* @__PURE__ */ React168.createElement("div", { className: cn(DEFAULT_BENEFIT_ITEM_CLASS, className, classes.root) }, /* @__PURE__ */ React168.createElement("div", { className: cn(DEFAULT_BENEFIT_ICON_CLASS, classes.iconWrapper) }, benefit.icon), /* @__PURE__ */ React168.createElement("div", { className: cn(DEFAULT_BENEFIT_TEXT_WRAPPER_CLASS, classes.textWrapper) }, /* @__PURE__ */ React168.createElement("span", { className: cn(DEFAULT_BENEFIT_TITLE_CLASS, classes.title) }, benefit.title), /* @__PURE__ */ React168.createElement("span", { className: cn(DEFAULT_BENEFIT_SUBTITLE_CLASS, classes.subtitle) }, benefit.subtitle)));

// src/organisms/footer/BenefitsBar.tsx
var DEFAULT_BENEFITS_BAR_CLASS = "flex flex-col gap-6 lg:gap-10 w-full";
var DEFAULT_BENEFITS_MOBILE_WRAPPER_CLASS = "md:hidden flex flex-col w-full gap-0";
var DEFAULT_BENEFITS_MOBILE_ROW_CLASS = "flex w-full";
var DEFAULT_BENEFITS_DESKTOP_ROW_CLASS = "hidden md:flex flex-row items-center w-full md:gap-6 lg:gap-10";
var DEFAULT_BENEFITS_DESKTOP_ITEM_CLASS = "flex-1 flex justify-center";
var BenefitsBar = ({ benefits, className, classes = {} }) => /* @__PURE__ */ React169.createElement("div", { className: cn(DEFAULT_BENEFITS_BAR_CLASS, className, classes.root) }, /* @__PURE__ */ React169.createElement("div", { className: cn(DEFAULT_BENEFITS_MOBILE_WRAPPER_CLASS, classes.mobileWrapper) }, /* @__PURE__ */ React169.createElement("div", { className: DEFAULT_BENEFITS_MOBILE_ROW_CLASS }, benefits.slice(0, 2).map((b, i) => /* @__PURE__ */ React169.createElement(React169.Fragment, { key: i }, i > 0 && /* @__PURE__ */ React169.createElement(
  Divider,
  {
    variant: "vertical",
    className: cn("bg-(--footer-divider)", classes.divider)
  }
), /* @__PURE__ */ React169.createElement(
  BenefitItem,
  {
    benefit: b,
    className: cn("flex-1", classes.item),
    classes: classes.benefitItem
  }
)))), benefits.length > 2 && /* @__PURE__ */ React169.createElement(React169.Fragment, null, /* @__PURE__ */ React169.createElement(
  Divider,
  {
    variant: "horizontal",
    className: cn("border-(--footer-divider) my-6", classes.divider)
  }
), /* @__PURE__ */ React169.createElement("div", { className: DEFAULT_BENEFITS_MOBILE_ROW_CLASS }, benefits.slice(2, 4).map((b, i) => /* @__PURE__ */ React169.createElement(React169.Fragment, { key: i + 2 }, i > 0 && /* @__PURE__ */ React169.createElement(
  Divider,
  {
    variant: "vertical",
    className: cn("bg-(--footer-divider)", classes.divider)
  }
), /* @__PURE__ */ React169.createElement(
  BenefitItem,
  {
    benefit: b,
    className: cn("flex-1", classes.item),
    classes: classes.benefitItem
  }
)))))), /* @__PURE__ */ React169.createElement("div", { className: cn(DEFAULT_BENEFITS_DESKTOP_ROW_CLASS, classes.desktopRow) }, benefits.map((b, i) => /* @__PURE__ */ React169.createElement(React169.Fragment, { key: i }, /* @__PURE__ */ React169.createElement("div", { className: DEFAULT_BENEFITS_DESKTOP_ITEM_CLASS }, /* @__PURE__ */ React169.createElement(BenefitItem, { benefit: b, className: classes.item, classes: classes.benefitItem })), i < benefits.length - 1 && /* @__PURE__ */ React169.createElement(Divider, { variant: "vertical", className: cn("bg-(--footer-divider)", classes.divider) })))), /* @__PURE__ */ React169.createElement(Divider, { variant: "horizontal", className: cn("border-(--footer-divider)", classes.divider) }));

// src/organisms/footer/FooterColumns.tsx
import React174 from "react";

// src/molecules/footer/NavColumn.tsx
import React171 from "react";

// src/atoms/footer/FooterLink.tsx
import React170 from "react";
var FooterLink2 = ({ href, className, children }) => href ? /* @__PURE__ */ React170.createElement(
  "a",
  {
    href,
    className: cn(
      className,
      "transition-colors hover:[color:var(--footer-text-hover,currentColor)] hover:[text-decoration-line:var(--footer-link-hover-decoration,underline)]"
    )
  },
  children
) : /* @__PURE__ */ React170.createElement("span", { className }, children);

// src/molecules/footer/NavColumn.tsx
var DEFAULT_NAV_COLUMN_CLASS = "flex flex-col gap-4";
var DEFAULT_NAV_COLUMN_HEADING_CLASS = "text-(--footer-heading) font-bold text-xl leading-6 uppercase";
var DEFAULT_NAV_COLUMN_LIST_CLASS = "flex flex-col gap-2";
var DEFAULT_NAV_COLUMN_LINK_CLASS = "text-(--footer-text) text-sm leading-6";
var NavColumn = ({ column, className, classes = {} }) => /* @__PURE__ */ React171.createElement("div", { className: cn(DEFAULT_NAV_COLUMN_CLASS, className, classes.root) }, /* @__PURE__ */ React171.createElement("span", { className: cn(DEFAULT_NAV_COLUMN_HEADING_CLASS, classes.heading) }, column.title), /* @__PURE__ */ React171.createElement("ul", { className: cn(DEFAULT_NAV_COLUMN_LIST_CLASS, classes.list) }, column.links.map((link, i) => /* @__PURE__ */ React171.createElement("li", { key: i }, /* @__PURE__ */ React171.createElement(FooterLink2, { href: link.href, className: cn(DEFAULT_NAV_COLUMN_LINK_CLASS, classes.link) }, link.label)))));

// src/molecules/footer/ContactColumn.tsx
import React172 from "react";
var DEFAULT_CONTACT_COLUMN_CLASS = "flex flex-col gap-4";
var DEFAULT_CONTACT_COLUMN_HEADING_CLASS = "text-(--footer-heading) font-bold text-xl leading-6 uppercase";
var DEFAULT_CONTACT_COLUMN_LIST_CLASS = "flex flex-col gap-2 items-start";
var DEFAULT_CONTACT_COLUMN_ITEM_CLASS = "flex items-center gap-2";
var DEFAULT_CONTACT_COLUMN_ICON_CLASS = "size-5 shrink-0 flex items-center justify-center";
var DEFAULT_CONTACT_COLUMN_LINK_CLASS = "text-(--footer-text) text-sm leading-6";
var ContactColumn = ({ column, centered = false, className, classes = {} }) => /* @__PURE__ */ React172.createElement(
  "div",
  {
    className: cn(
      DEFAULT_CONTACT_COLUMN_CLASS,
      centered ? "items-center" : "items-start",
      className,
      classes.root
    )
  },
  /* @__PURE__ */ React172.createElement("span", { className: cn(DEFAULT_CONTACT_COLUMN_HEADING_CLASS, classes.heading) }, column.title),
  /* @__PURE__ */ React172.createElement("ul", { className: cn(DEFAULT_CONTACT_COLUMN_LIST_CLASS, classes.list) }, column.items.map((item, i) => /* @__PURE__ */ React172.createElement("li", { key: i, className: cn(DEFAULT_CONTACT_COLUMN_ITEM_CLASS, classes.item) }, /* @__PURE__ */ React172.createElement("div", { className: cn(DEFAULT_CONTACT_COLUMN_ICON_CLASS, classes.iconWrapper) }, item.icon), /* @__PURE__ */ React172.createElement(
    FooterLink2,
    {
      href: item.href,
      className: cn(DEFAULT_CONTACT_COLUMN_LINK_CLASS, classes.link)
    },
    item.label
  ))))
);

// src/organisms/footer/MobileAccordionColumn.tsx
import React173, { useState as useState13 } from "react";
var DEFAULT_ACCORDION_ROOT_CLASS = "flex flex-col w-full";
var DEFAULT_ACCORDION_BUTTON_CLASS2 = "flex items-center w-full py-4";
var DEFAULT_ACCORDION_TITLE_CLASS = "flex-1 text-(--footer-heading) font-bold text-xl uppercase text-center";
var DEFAULT_ACCORDION_LIST_CLASS = "flex flex-col gap-2 pb-4 items-center";
var DEFAULT_ACCORDION_LINK_CLASS = "text-(--footer-text) text-sm leading-6 block text-center";
var MobileAccordionColumn = ({ column, className, classes = {} }) => {
  var _a;
  const [isOpen, setIsOpen] = useState13((_a = column.defaultOpen) != null ? _a : false);
  return /* @__PURE__ */ React173.createElement("div", { className: cn(DEFAULT_ACCORDION_ROOT_CLASS, className, classes.root) }, /* @__PURE__ */ React173.createElement(
    "button",
    {
      type: "button",
      className: cn(DEFAULT_ACCORDION_BUTTON_CLASS2, classes.button),
      onClick: () => setIsOpen((prev) => !prev),
      "aria-expanded": isOpen
    },
    /* @__PURE__ */ React173.createElement("span", { className: cn(DEFAULT_ACCORDION_TITLE_CLASS, classes.title) }, column.title),
    /* @__PURE__ */ React173.createElement(IconChevron, { isOpen, className: "size-5 shrink-0 text-(--footer-heading)" })
  ), isOpen && /* @__PURE__ */ React173.createElement("ul", { className: cn(DEFAULT_ACCORDION_LIST_CLASS, classes.list) }, column.links.map((link, i) => /* @__PURE__ */ React173.createElement("li", { key: i }, /* @__PURE__ */ React173.createElement(
    FooterLink2,
    {
      href: link.href,
      className: cn(DEFAULT_ACCORDION_LINK_CLASS, classes.link)
    },
    link.label
  )))));
};

// src/organisms/footer/FooterColumns.tsx
var DEFAULT_CONTENT_DESKTOP_CLASS = "hidden lg:flex items-start justify-between w-full gap-6";
var DEFAULT_PRODUCT_INFO_DESKTOP_CLASS = "flex flex-col gap-4 items-start w-[454px] shrink-0";
var DEFAULT_CONTENT_TABLET_CLASS = "hidden md:flex lg:hidden flex-col gap-6 w-full items-center md:pt-4";
var DEFAULT_PRODUCT_INFO_TABLET_CLASS = "flex flex-col gap-4 items-center w-full";
var DEFAULT_TABLET_COLUMNS_CLASS = "flex items-start justify-between w-full";
var DEFAULT_CONTENT_MOBILE_CLASS = "md:hidden flex flex-col w-full gap-6";
var DEFAULT_PRODUCT_INFO_MOBILE_CLASS = "flex flex-col gap-4 items-center w-full";
var DEFAULT_MOBILE_COLUMNS_CLASS = "flex flex-col w-full";
var DEFAULT_DESCRIPTION_CLASS9 = "text-sm text-(--footer-description) leading-5";
var ProductInfoBlock = ({
  logoEl,
  description,
  wrapperClass,
  descriptionVariantClass,
  productInfoClass,
  descriptionClass
}) => /* @__PURE__ */ React174.createElement("div", { className: cn(wrapperClass, productInfoClass) }, logoEl, description && /* @__PURE__ */ React174.createElement(
  RichText,
  {
    html: description,
    className: cn(DEFAULT_DESCRIPTION_CLASS9, descriptionVariantClass, descriptionClass)
  }
));
var FooterColumns = ({
  logoEl,
  description,
  columns = [],
  classes = {}
}) => {
  const hasColumns = columns.length > 0;
  const mobileColumns = [
    ...columns.filter((c) => c.type === "contact"),
    ...columns.filter((c) => c.type === "nav")
  ];
  const desktopTabletColumns = /* @__PURE__ */ React174.createElement(React174.Fragment, null, columns.map(
    (col, i) => col.type === "contact" ? /* @__PURE__ */ React174.createElement(ContactColumn, { key: i, column: col, classes: classes.contactColumn }) : /* @__PURE__ */ React174.createElement(NavColumn, { key: i, column: col, classes: classes.navColumn })
  ));
  return /* @__PURE__ */ React174.createElement(React174.Fragment, null, /* @__PURE__ */ React174.createElement("div", { className: cn(DEFAULT_CONTENT_DESKTOP_CLASS, classes.contentArea) }, (logoEl || description) && /* @__PURE__ */ React174.createElement(
    ProductInfoBlock,
    {
      logoEl,
      description,
      wrapperClass: DEFAULT_PRODUCT_INFO_DESKTOP_CLASS,
      descriptionVariantClass: "text-left",
      productInfoClass: classes.productInfo,
      descriptionClass: classes.description
    }
  ), hasColumns && desktopTabletColumns), /* @__PURE__ */ React174.createElement("div", { className: cn(DEFAULT_CONTENT_TABLET_CLASS, classes.contentArea) }, (logoEl || description) && /* @__PURE__ */ React174.createElement(
    ProductInfoBlock,
    {
      logoEl,
      description,
      wrapperClass: DEFAULT_PRODUCT_INFO_TABLET_CLASS,
      descriptionVariantClass: "text-center w-full",
      productInfoClass: classes.productInfo,
      descriptionClass: classes.description
    }
  ), hasColumns && /* @__PURE__ */ React174.createElement(React174.Fragment, null, /* @__PURE__ */ React174.createElement(
    Divider,
    {
      variant: "horizontal",
      className: cn("border-(--footer-divider)", classes.divider)
    }
  ), /* @__PURE__ */ React174.createElement("div", { className: DEFAULT_TABLET_COLUMNS_CLASS }, desktopTabletColumns))), /* @__PURE__ */ React174.createElement("div", { className: cn(DEFAULT_CONTENT_MOBILE_CLASS, classes.contentArea) }, (logoEl || description) && /* @__PURE__ */ React174.createElement(
    ProductInfoBlock,
    {
      logoEl,
      description,
      wrapperClass: DEFAULT_PRODUCT_INFO_MOBILE_CLASS,
      descriptionVariantClass: "text-center",
      productInfoClass: classes.productInfo,
      descriptionClass: classes.description
    }
  ), hasColumns && /* @__PURE__ */ React174.createElement(React174.Fragment, null, /* @__PURE__ */ React174.createElement(
    Divider,
    {
      variant: "horizontal",
      className: cn("border-(--footer-divider)", classes.divider)
    }
  ), /* @__PURE__ */ React174.createElement("div", { className: DEFAULT_MOBILE_COLUMNS_CLASS }, mobileColumns.map((col, i) => {
    const isLast = i === mobileColumns.length - 1;
    if (col.type === "contact") {
      return /* @__PURE__ */ React174.createElement(React174.Fragment, { key: i }, /* @__PURE__ */ React174.createElement(
        ContactColumn,
        {
          column: col,
          centered: true,
          className: "pb-4",
          classes: classes.contactColumn
        }
      ), /* @__PURE__ */ React174.createElement(
        Divider,
        {
          variant: "horizontal",
          className: cn("border-(--footer-divider)", classes.divider)
        }
      ));
    }
    return /* @__PURE__ */ React174.createElement(React174.Fragment, { key: i }, /* @__PURE__ */ React174.createElement(MobileAccordionColumn, { column: col, classes: classes.mobileAccordion }), /* @__PURE__ */ React174.createElement(
      Divider,
      {
        variant: "horizontal",
        className: cn(
          "border-(--footer-divider)",
          isLast && "md:hidden",
          classes.divider
        )
      }
    ));
  })))));
};

// src/organisms/footer/FooterCopyright.tsx
import React175 from "react";
var DEFAULT_COPYRIGHT_BAR_CLASS = "[background:var(--footer-copyright-bg)] w-full py-3 px-4 lg:px-4";
var DEFAULT_COPYRIGHT_CONTAINER_CLASS = "max-w-[1100px] mx-auto w-full flex flex-col-reverse items-center gap-2 md:gap-4 lg:flex-row lg:justify-between lg:gap-0";
var DEFAULT_COPYRIGHT_TEXT_CLASS = "text-sm leading-5 text-(--footer-copyright-text)";
var DEFAULT_PAYMENT_ICONS_CLASS = "flex items-center gap-[3.5px] flex-wrap justify-center";
var FooterCopyright = ({
  copyrightText,
  paymentIcons = [],
  copyrightTabletRow = false,
  className,
  classes = {}
}) => {
  if (!copyrightText && paymentIcons.length === 0) return null;
  return /* @__PURE__ */ React175.createElement("div", { className: cn(DEFAULT_COPYRIGHT_BAR_CLASS, className, classes.copyrightBar) }, /* @__PURE__ */ React175.createElement(
    "div",
    {
      className: cn(
        DEFAULT_COPYRIGHT_CONTAINER_CLASS,
        copyrightTabletRow && "md:flex-row md:justify-between md:gap-0",
        classes.copyrightContainer
      )
    },
    copyrightText && /* @__PURE__ */ React175.createElement("p", { className: cn(DEFAULT_COPYRIGHT_TEXT_CLASS, classes.copyrightText) }, copyrightText),
    paymentIcons.length > 0 && /* @__PURE__ */ React175.createElement("div", { className: cn(DEFAULT_PAYMENT_ICONS_CLASS, classes.paymentIconsWrapper) }, paymentIcons.map(
      (pi, i) => pi.label ? /* @__PURE__ */ React175.createElement("span", { key: i, role: "img", "aria-label": pi.label }, pi.icon) : /* @__PURE__ */ React175.createElement(React175.Fragment, { key: i }, pi.icon)
    ))
  ));
};

// src/sections/FooterSection.tsx
var DEFAULT_SECTION_CLASS2 = "w-full";
var DEFAULT_MAIN_FOOTER_CLASS = "[background:var(--footer-bg)] w-full py-6 lg:py-10 px-4 md:px-6 lg:px-6";
var DEFAULT_INNER_CONTAINER_CLASS = "max-w-[1100px] mx-auto w-full flex flex-col gap-6 lg:gap-10";
var DEFAULT_LOGO_CLASS4 = "h-[26px] md:h-[42px] w-auto";
var DEFAULT_DISCLAIMER_CLASS2 = "text-xs leading-4 text-(--footer-disclaimer) w-full";
function buildFooterVars(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    "--footer-bg": (_a = colors == null ? void 0 : colors.footerBackground) != null ? _a : "var(--theme-color-bg-dark, #000000)",
    "--footer-copyright-bg": (_b = colors == null ? void 0 : colors.copyrightBackground) != null ? _b : "var(--theme-color-bg-dark, #ffffff)",
    "--footer-text": (_c = colors == null ? void 0 : colors.linkColor) != null ? _c : "var(--theme-color-text-inverse, #ffffff)",
    ...(colors == null ? void 0 : colors.linkHoverColor) && {
      "--footer-text-hover": colors.linkHoverColor,
      "--footer-link-hover-decoration": "none"
    },
    "--footer-heading": (_d = colors == null ? void 0 : colors.headingColor) != null ? _d : "var(--theme-color-text-inverse, #ffffff)",
    "--footer-description": (_e = colors == null ? void 0 : colors.descriptionColor) != null ? _e : "var(--theme-color-text-inverse, #ffffff)",
    "--footer-disclaimer": (_f = colors == null ? void 0 : colors.disclaimerColor) != null ? _f : "var(--theme-color-text-light, #757575)",
    "--footer-copyright-text": (_g = colors == null ? void 0 : colors.copyrightColor) != null ? _g : "var(--theme-color-text-primary, #333333)",
    "--footer-divider": (_h = colors == null ? void 0 : colors.dividerColor) != null ? _h : "var(--theme-color-border-light, rgba(255,255,255,0.2))"
  };
}
var FooterSection2 = ({
  logo,
  logoAlt = "",
  logoNode,
  description,
  benefits = [],
  columns = [],
  disclaimer,
  copyrightText,
  paymentIcons = [],
  colors,
  className,
  classes = {},
  showBenefits = true,
  showLogo = true,
  showDescription = true,
  showColumns = true,
  showDisclaimer = true,
  showCopyrightBar = true,
  copyrightTabletRow = false
}) => {
  const logoEl = showLogo ? logoNode != null ? logoNode : logo ? /* @__PURE__ */ React176.createElement(Logo, { src: logo, alt: logoAlt, className: cn(DEFAULT_LOGO_CLASS4, classes.logo) }) : null : null;
  const activeDescription = showDescription ? description : void 0;
  const activeColumns = showColumns ? columns : [];
  const hasBenefits = showBenefits && benefits.length > 0;
  const hasContent = !!(logoEl || activeDescription || activeColumns.length > 0);
  return /* @__PURE__ */ React176.createElement(
    "footer",
    {
      className: cn(DEFAULT_SECTION_CLASS2, classes.section, className),
      style: buildFooterVars(colors)
    },
    /* @__PURE__ */ React176.createElement("div", { className: cn(DEFAULT_MAIN_FOOTER_CLASS, classes.mainFooter) }, /* @__PURE__ */ React176.createElement("div", { className: cn(DEFAULT_INNER_CONTAINER_CLASS, classes.innerContainer) }, hasBenefits && /* @__PURE__ */ React176.createElement(
      BenefitsBar,
      {
        benefits,
        className: classes.benefitsBar,
        classes: classes.benefitsBarClasses
      }
    ), hasContent && /* @__PURE__ */ React176.createElement(
      FooterColumns,
      {
        logoEl,
        description: activeDescription,
        columns: activeColumns,
        classes: {
          contentArea: classes.contentArea,
          productInfo: classes.productInfo,
          description: classes.description,
          navColumn: classes.navColumn,
          contactColumn: classes.contactColumn,
          mobileAccordion: classes.mobileAccordion,
          divider: classes.divider
        }
      }
    ), showDisclaimer && disclaimer && /* @__PURE__ */ React176.createElement(React176.Fragment, null, /* @__PURE__ */ React176.createElement(
      Divider,
      {
        variant: "horizontal",
        className: cn("border-(--footer-divider) hidden md:block", classes.divider)
      }
    ), /* @__PURE__ */ React176.createElement("p", { className: cn(DEFAULT_DISCLAIMER_CLASS2, classes.disclaimer) }, disclaimer)))),
    showCopyrightBar && /* @__PURE__ */ React176.createElement(
      FooterCopyright,
      {
        copyrightText,
        paymentIcons,
        copyrightTabletRow,
        classes: {
          copyrightBar: classes.copyrightBar,
          copyrightContainer: classes.copyrightContainer,
          copyrightText: classes.copyrightText,
          paymentIconsWrapper: classes.paymentIconsWrapper
        }
      }
    )
  );
};

// src/molecules/Copyright.tsx
import React177 from "react";
import classNames67 from "classnames";
var DEFAULT_CONTAINER_CLASS21 = "py-3 bg-(--footer-copyright-bg) px-4";
var DEFAULT_INNER_CLASS3 = "max-w-body mx-auto flex justify-between items-center flex-col md:flex-row gap-4 md:gap-0";
var DEFAULT_COPY_CLASS = "text-(--footer-copyright-text) text-sm";
var DEFAULT_CARDS_CLASS = "";
var Copyright = ({
  paymentCards,
  copyText,
  className,
  classes = {}
}) => {
  const containerCls = classNames67(DEFAULT_CONTAINER_CLASS21, className, classes.container);
  const innerCls = classNames67(DEFAULT_INNER_CLASS3, classes.inner);
  const copyCls = classNames67(DEFAULT_COPY_CLASS, classes.copy);
  const cardsCls = classNames67(DEFAULT_CARDS_CLASS, classes.cards);
  return /* @__PURE__ */ React177.createElement(Container, { className: containerCls }, /* @__PURE__ */ React177.createElement("div", { className: innerCls }, copyText && /* @__PURE__ */ React177.createElement(Text, { className: copyCls }, copyText), paymentCards && /* @__PURE__ */ React177.createElement(Image, { className: cardsCls, src: paymentCards, alt: "Payment methods" })));
};

// src/molecules/SectionHeader.tsx
import React178 from "react";
var DEFAULT_CONTAINER_CLASS22 = "flex flex-col items-center text-center gap-3";
var DEFAULT_HEADING_CLASS2 = "font-[800] text-[32px] leading-[40px] font-outfit text-black lg:text-[36px] lg:leading-[44px]";
var DEFAULT_SUBHEADING_CLASS = "font-outfit text-[20px]/[28px] md:text-[24px]/[32px] text-[#333333]";
var DEFAULT_DIVIDER_CLASS4 = "";
var SectionHeader = ({
  heading,
  headingHtml,
  subheading,
  headingAs = "h2",
  subheadingPlacement = "before-divider",
  showDivider = true,
  className,
  classes = {}
}) => {
  const containerClass = cn(DEFAULT_CONTAINER_CLASS22, className, classes.container);
  const headingClass = cn(DEFAULT_HEADING_CLASS2, classes.heading);
  const subheadingClass = cn(DEFAULT_SUBHEADING_CLASS, classes.subheading);
  const dividerClass = cn(DEFAULT_DIVIDER_CLASS4, classes.divider);
  const safeHeadingHtml = sanitizeHeadingHtml(headingHtml);
  const HeadingTag = headingAs;
  const headingNode = safeHeadingHtml ? /* @__PURE__ */ React178.createElement(HeadingTag, { className: headingClass, dangerouslySetInnerHTML: { __html: safeHeadingHtml } }) : heading ? /* @__PURE__ */ React178.createElement(Text, { as: headingAs, className: headingClass }, heading) : null;
  const subheadingNode = subheading ? /* @__PURE__ */ React178.createElement(RichText, { html: subheading, className: subheadingClass }) : null;
  if (!headingNode && !subheadingNode && !showDivider) {
    return null;
  }
  return /* @__PURE__ */ React178.createElement("div", { className: containerClass }, headingNode, subheadingPlacement === "before-divider" && subheadingNode, showDivider && /* @__PURE__ */ React178.createElement(Divider, { className: dividerClass }), subheadingPlacement === "after-divider" && subheadingNode);
};

// src/organisms/ArticleHeader.tsx
import React179 from "react";
import classNames68 from "classnames";
var DEFAULT_ROOT_CLASS17 = "bg-(--header-bg-color) border-t-4 border-(--header-border-color) font-work-sans";
var DEFAULT_CONTAINER_CLASS23 = "max-w-body mx-auto p-4 flex justify-between";
var DEFAULT_BRAND_CLASS = "flex gap-4 items-center";
var DEFAULT_LOGO_CLASS5 = "h-auto w-[170px]";
var DEFAULT_DIVIDER_CLASS5 = "hidden md:block border-l w-px h-full border-(--header-advertorial-color)";
var DEFAULT_LOGOLABEL_CLASS = "hidden md:block text-(--header-advertorial-color) text-sm font-normal";
var DEFAULT_FLAG_CLASS2 = "flex items-center gap-2";
var DEFAULT_FLAGTEXT_CLASS = "text-(--header-trending-color) text-sm";
var DEFAULT_FLAGICON_CLASS = "";
var ArticleHeader = ({
  logoImgSrc,
  logoLabel,
  flagLabel,
  flagIcon,
  isCustomLogo,
  className,
  classes = {}
}) => {
  var _a;
  const rootCls = classNames68(DEFAULT_ROOT_CLASS17, className, classes.root);
  const containerCls = classNames68(DEFAULT_CONTAINER_CLASS23, classes.container);
  const brandCls = classNames68(DEFAULT_BRAND_CLASS, classes.brand);
  const logoCls = classNames68(DEFAULT_LOGO_CLASS5, classes.logo);
  const dividerCls = classNames68(DEFAULT_DIVIDER_CLASS5, classes.divider);
  const logoLabelCls = classNames68(DEFAULT_LOGOLABEL_CLASS, classes.logoLabel);
  const flagCls = classNames68(DEFAULT_FLAG_CLASS2, classes.flag);
  const flagTextCls = classNames68(DEFAULT_FLAGTEXT_CLASS, classes.flagText);
  const flagIconCls = classNames68(DEFAULT_FLAGICON_CLASS, classes.flagIcon);
  const logoSrc = isCustomLogo ? logoImgSrc : ((_a = window == null ? void 0 : window.general_settings) == null ? void 0 : _a.logo_white) || logoImgSrc;
  return /* @__PURE__ */ React179.createElement("header", { className: rootCls }, /* @__PURE__ */ React179.createElement("div", { className: containerCls }, /* @__PURE__ */ React179.createElement("div", { className: brandCls }, /* @__PURE__ */ React179.createElement(Logo, { className: logoCls, src: logoSrc || "" }), /* @__PURE__ */ React179.createElement("hr", { className: dividerCls }), logoLabel && /* @__PURE__ */ React179.createElement(Text, { className: logoLabelCls }, logoLabel)), /* @__PURE__ */ React179.createElement("div", { className: flagCls }, flagLabel && /* @__PURE__ */ React179.createElement(Text, { className: flagTextCls }, flagLabel), flagIcon && /* @__PURE__ */ React179.createElement(Icon, { src: flagIcon, className: flagIconCls }))));
};

// src/molecules/ArticleReview.tsx
import React180 from "react";
import classNames69 from "classnames";
var DEFAULT_CONTAINER_CLASS24 = "flex flex-col gap-2 font-open-sans";
var DEFAULT_STARS_CLASS2 = "max-h-[16px] w-fit";
var DEFAULT_DESCRIPTION_CLASS10 = "text-sm italic";
var DEFAULT_AUTHOR_CLASS = "text-sm font-bold";
var ArticleReview = ({
  starsImage,
  description,
  author,
  className,
  classes = {}
}) => {
  const containerCls = classNames69(DEFAULT_CONTAINER_CLASS24, className, classes.container);
  const starsCls = classNames69(DEFAULT_STARS_CLASS2, classes.stars);
  const descriptionCls = classNames69(DEFAULT_DESCRIPTION_CLASS10, classes.description);
  const authorCls = classNames69(DEFAULT_AUTHOR_CLASS, classes.author);
  return /* @__PURE__ */ React180.createElement(Container, { className: containerCls }, starsImage && /* @__PURE__ */ React180.createElement("img", { className: starsCls, src: starsImage, alt: "Star rating" }), description && /* @__PURE__ */ React180.createElement(Text, { className: descriptionCls }, description), author && /* @__PURE__ */ React180.createElement(Text, { className: authorCls }, author));
};

// src/molecules/ArticleProductCard.tsx
import React182 from "react";
import classNames70 from "classnames";

// src/atoms/Chevron.tsx
import React181 from "react";
var Chevron = ({ className }) => /* @__PURE__ */ React181.createElement("span", null, /* @__PURE__ */ React181.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "currentColor",
    className
  },
  /* @__PURE__ */ React181.createElement("g", { clipPath: "url(#clip0_4597_2123)" }, /* @__PURE__ */ React181.createElement(
    "path",
    {
      d: "M13.7235 6.81605L8.15111 12.4345C7.87479 12.7108 7.46032 12.7108 7.18401 12.4345L6.53927 11.7897C6.26295 11.5134 6.26295 11.0989 6.53927 10.8226L10.9603 6.35552L6.53927 1.88841C6.26295 1.6121 6.26295 1.19763 6.53927 0.92131L7.18401 0.276573C7.46032 0.000256993 7.87479 0.000256993 8.15111 0.276573L13.7235 5.84894C13.9998 6.12526 13.9998 6.53973 13.7235 6.81605Z",
      fill: "white"
    }
  ), /* @__PURE__ */ React181.createElement(
    "path",
    {
      d: "M7.50684 6.81605L1.88841 12.4345C1.6121 12.7108 1.19763 12.7108 0.92131 12.4345L0.276573 11.7897C0.000256985 11.5134 0.000256985 11.0529 0.276573 10.7766L4.69763 6.30947L0.276573 1.88841C0.000256985 1.6121 0.000256985 1.19763 0.276573 0.92131L0.92131 0.276573C1.19763 0.000256993 1.6121 0.000256993 1.88841 0.276573L7.46078 5.84894C7.7371 6.12526 7.7371 6.53973 7.50684 6.81605Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React181.createElement("defs", null, /* @__PURE__ */ React181.createElement("clipPath", { id: "clip0_4597_2123" }, /* @__PURE__ */ React181.createElement("rect", { width: "14", height: "12.6645", fill: "currentColor" })))
));
var Chevron_default = Chevron;

// src/molecules/ArticleProductCard.tsx
var DEFAULT_CONTAINER_CLASS25 = "border border-(--product-border-color) max-w-[250px] p-2.5 font-open-sans flex flex-col gap-4";
var DEFAULT_HEADER_CLASS3 = "pt-4 pr-5 pb-2.5 pl-5 [background:var(--product-gradient-color)]";
var DEFAULT_TITLE_CLASS9 = "text-center flex text-xl text-(--product-title-color) font-bold mb-[5px]";
var DEFAULT_RATING_CLASS = "flex gap-2 items-center";
var DEFAULT_STARS_CLASS3 = "max-h-[14px]";
var DEFAULT_RATINGTEXT_CLASS = "text-(--product-title-color) text-sm font-semibold";
var DEFAULT_PRODUCTIMAGE_CLASS = "";
var DEFAULT_SUBTITLE_CLASS3 = "text-center text-(--product-subtitle-color) font-bold";
var DEFAULT_BUTTON_CLASS7 = "transition-all duration-200 ease-in-out cursor-pointer hover:bg-(--product-button-hover-color) bg-(--product-button-bg-color) p-4 rounded-[5px] text-xl font-bold text-(--product-button-text-color) flex items-center whitespace-nowrap";
var DEFAULT_CHEVRON_CLASS = "ml-2";
var ArticleProductCard = ({
  title,
  starsImage,
  ratingCount,
  productImage,
  subtitle,
  buttonText,
  className,
  classes = {},
  linkHref
}) => {
  const containerCls = classNames70(DEFAULT_CONTAINER_CLASS25, className, classes.container);
  const headerCls = classNames70(DEFAULT_HEADER_CLASS3, classes.header);
  const titleCls = classNames70(DEFAULT_TITLE_CLASS9, classes.title);
  const ratingCls = classNames70(DEFAULT_RATING_CLASS, classes.rating);
  const starsCls = classNames70(DEFAULT_STARS_CLASS3, classes.stars);
  const ratingTextCls = classNames70(DEFAULT_RATINGTEXT_CLASS, classes.ratingText);
  const productImageCls = classNames70(DEFAULT_PRODUCTIMAGE_CLASS, classes.productImage);
  const subtitleCls = classNames70(DEFAULT_SUBTITLE_CLASS3, classes.subtitle);
  const buttonCls = classNames70(DEFAULT_BUTTON_CLASS7, classes.button);
  const chevronCls = classNames70(DEFAULT_CHEVRON_CLASS, classes.chevron);
  return /* @__PURE__ */ React182.createElement(Container, { className: containerCls }, /* @__PURE__ */ React182.createElement("div", { className: headerCls }, title && /* @__PURE__ */ React182.createElement(Text, { className: titleCls }, title), /* @__PURE__ */ React182.createElement("div", { className: ratingCls }, starsImage && /* @__PURE__ */ React182.createElement("img", { className: starsCls, src: starsImage, alt: `${title || "Product"} rating` }), ratingCount && /* @__PURE__ */ React182.createElement(Text, { className: ratingTextCls }, ratingCount))), productImage && /* @__PURE__ */ React182.createElement(
    "img",
    {
      loading: "lazy",
      className: productImageCls,
      src: productImage,
      alt: title || "Product image"
    }
  ), subtitle && /* @__PURE__ */ React182.createElement(Text, { className: subtitleCls }, subtitle), buttonText && linkHref && /* @__PURE__ */ React182.createElement("a", { href: linkHref, className: buttonCls }, buttonText, /* @__PURE__ */ React182.createElement(Chevron_default, { className: chevronCls })));
};

// src/organisms/ArticleFooter.tsx
import React183 from "react";
import classNames71 from "classnames";
import parse2 from "html-react-parser";
var DEFAULT_ROOT_CLASS18 = "bg-(--footer-bg-color) py-10 font-inter";
var DEFAULT_CONTAINER_CLASS26 = "max-w-[1520px] flex gap-4 md:gap-8 justify-center flex-col mx-auto text-center";
var DEFAULT_LINKS_ROW_CLASS = "flex gap-2 md:gap-6 justify-center flex-col md:flex-row";
var DEFAULT_LINK_CLASS2 = "text-(--footer-text-color) text-sm font-medium";
var DEFAULT_TEXTS_CLASS = "flex flex-col gap-4 items-center px-4";
var DEFAULT_TEXT_ITEM_CLASS = "text-xs text-(--footer-disclosure-color) text-center";
var DEFAULT_LOGO_CLASS6 = "max-h-[30px] max-w-[150px] mx-auto";
var ArticleFooter = ({
  footer,
  className,
  classes = {}
}) => {
  var _a, _b;
  const year = (/* @__PURE__ */ new Date()).getFullYear();
  const rootCls = classNames71(DEFAULT_ROOT_CLASS18, className, classes.root);
  const containerCls = classNames71(DEFAULT_CONTAINER_CLASS26, classes.container);
  const linksRowCls = classNames71(DEFAULT_LINKS_ROW_CLASS, classes.linksRow);
  const linkCls = classNames71(DEFAULT_LINK_CLASS2, classes.link);
  const textsCls = classNames71(DEFAULT_TEXTS_CLASS, classes.texts);
  const textItemCls = classNames71(DEFAULT_TEXT_ITEM_CLASS, classes.textItem);
  const logoCls = classNames71(DEFAULT_LOGO_CLASS6, classes.logo);
  const renderedLinks = (_a = footer == null ? void 0 : footer.links) == null ? void 0 : _a.map((link, index) => {
    const href = (link.page_or_url === "url" ? link.footer_url : link.footer_page) || void 0;
    const label = (link == null ? void 0 : link.tr_footer_label) || "";
    const newTab = (link == null ? void 0 : link.footer_newTab) || false;
    if (!label) return null;
    return /* @__PURE__ */ React183.createElement(
      "a",
      {
        className: linkCls,
        key: index,
        href,
        target: newTab ? "_blank" : "_self",
        rel: newTab ? "noopener noreferrer" : void 0
      },
      parse2(label)
    );
  });
  const renderedDisclosure = (_b = footer == null ? void 0 : footer.texts) == null ? void 0 : _b.map((item, index) => {
    const raw = (item == null ? void 0 : item.tr_row) || "";
    const replaced = raw.replace(/###get_year###/g, String(year));
    return /* @__PURE__ */ React183.createElement(Text, { className: textItemCls, key: index }, parse2(replaced));
  });
  return /* @__PURE__ */ React183.createElement("footer", { className: rootCls }, /* @__PURE__ */ React183.createElement("div", { className: containerCls }, /* @__PURE__ */ React183.createElement("div", { className: linksRowCls }, renderedLinks), /* @__PURE__ */ React183.createElement("div", { className: textsCls }, renderedDisclosure), (footer == null ? void 0 : footer.footer_icon) && /* @__PURE__ */ React183.createElement("img", { className: logoCls, src: footer.footer_icon, loading: "lazy", alt: "Footer Image" })));
};

// src/molecules/LikeButton.tsx
import React185 from "react";

// src/atoms/Like.tsx
import React184 from "react";
var LIKE_UP_PATH = "M0.358891 5.27344C0.162836 5.27344 0.00390625 5.43239 0.00390625 5.62842V10.8423C0.00390625 11.0383 0.162859 11.1973 0.358891 11.1973H2.49763V5.27344H0.358891Z";
var LIKE_UP_BODY_PATH = "M11.9942 7.23252C11.9942 6.78189 11.7521 6.38673 11.3911 6.17031C11.5294 5.9706 11.6105 5.72833 11.6105 5.46754C11.6105 4.7852 11.0554 4.23006 10.373 4.23006H7.76074C7.8408 3.86724 7.9503 3.32281 8.02654 2.75288C8.22496 1.26973 8.08935 0.44719 7.59981 0.164322C7.29461 -0.0119984 6.96555 -0.0477641 6.67323 0.0635174C6.44741 0.149533 6.14244 0.36101 5.96865 0.880035L5.28207 2.67772C4.934 3.53734 3.86809 4.4398 3.20703 4.93881V11.3531C4.43221 11.7824 5.71068 12 7.01498 12H9.86137C10.5437 12 11.0989 11.4449 11.0989 10.7625C11.0989 10.5236 11.0308 10.3002 10.913 10.1109C11.3255 9.90998 11.6105 9.48637 11.6105 8.99753C11.6105 8.73672 11.5294 8.49449 11.391 8.29476C11.7521 8.07834 11.9942 7.68316 11.9942 7.23252Z";
var LIKE_DOWN_PATH = "M11.6411 6.72656C11.8372 6.72656 11.9961 6.56761 11.9961 6.37158V1.15772C11.9961 0.961664 11.8371 0.802734 11.6411 0.802734H9.50237V6.72656H11.6411Z";
var LIKE_DOWN_BODY_PATH = "M0.0057869 4.76748C0.0057869 5.21811 0.247921 5.61327 0.608906 5.82969C0.470601 6.0294 0.389483 6.27167 0.389483 6.53246C0.389483 7.2148 0.944624 7.76994 1.62696 7.76994H4.23926C4.1592 8.13276 4.0497 8.67719 3.97346 9.24712C3.77504 10.7303 3.91065 11.5528 4.40019 11.8357C4.70539 12.012 5.03445 12.0478 5.32677 11.9365C5.55259 11.8505 5.85756 11.639 6.03135 11.12L6.71793 9.32228C7.066 8.46266 8.13191 7.5602 8.79297 7.06119V0.646852C7.56779 0.217569 6.28932 -2.57492e-05 4.98502 -2.57492e-05H2.13863C1.45629 -2.57492e-05 0.901149 0.555117 0.901149 1.23745C0.901149 1.4764 0.969235 1.69976 1.08701 1.88911C0.674484 2.09002 0.389529 2.51363 0.389529 3.00247C0.389529 3.26328 0.470647 3.50551 0.608952 3.70524C0.24792 3.92166 0.0057869 4.31684 0.0057869 4.76748Z";
var Like = ({
  className,
  color = "#808080",
  size = 12,
  title = "",
  variant = "up"
}) => /* @__PURE__ */ React184.createElement("span", { "aria-hidden": !title }, /* @__PURE__ */ React184.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 12 12",
    fill: "none",
    className,
    role: title ? "img" : void 0,
    "aria-label": title || void 0
  },
  /* @__PURE__ */ React184.createElement("path", { d: variant === "up" ? LIKE_UP_PATH : LIKE_DOWN_PATH, fill: color }),
  /* @__PURE__ */ React184.createElement("path", { d: variant === "up" ? LIKE_UP_BODY_PATH : LIKE_DOWN_BODY_PATH, fill: color })
));
var Like_default = Like;

// src/molecules/LikeButton.tsx
var LikeButton = ({
  likeLabel = "Like",
  likeCount = "112.5K"
}) => {
  return /* @__PURE__ */ React185.createElement(Container, { className: "flex items-center gap-1 py-1 px-4 border border-[#808080] rounded-[50px] w-fit mb-4 md:mb-6 mx-auto md:mx-0" }, /* @__PURE__ */ React185.createElement(Like_default, { size: 16 }), /* @__PURE__ */ React185.createElement(Text, { className: "font-work-sans text-sm text-[#808080] font-medium" }, likeLabel), /* @__PURE__ */ React185.createElement("hr", { className: "w-px h-[15px] bg-[#808080]" }), /* @__PURE__ */ React185.createElement(Text, { className: "font-work-sans text-sm text-[#808080] font-medium" }, likeCount));
};

// src/organisms/ArticleBanner.tsx
import React186 from "react";
import classNames72 from "classnames";
var DEFAULT_CONTAINER_CLASS27 = "max-w-[590px] mx-auto bg-(--banner-bg-color) p-6 flex flex-col gap-4";
var DEFAULT_TITLE_CLASS10 = "text-center font-bold text-lg md:text-2xl";
var DEFAULT_IMAGE_CLASS3 = "max-h-[160px] max-w-[160px] md:max-h-[254px] md:max-w-[254px] mx-auto";
var DEFAULT_BUTTON_CLASS8 = "transition-all duration-200 ease-in-out p-4 bg-(--banner-button-bg-color) cursor-pointer hover:bg-(--banner-button-hover-color) text-(--banner-button-color) font-bold uppercase text-lg md:text-[22px] rounded-[5px] text-center";
var DEFAULT_SUBTITLE_CLASS4 = "text-center font-extrabold test-base md:text-lg";
var ArticleBanner = ({
  title,
  imageSrc,
  buttonLabel,
  subtitle,
  linkHref,
  className,
  classes = {}
}) => {
  const containerCls = classNames72(DEFAULT_CONTAINER_CLASS27, className, classes.container);
  const titleCls = classNames72(DEFAULT_TITLE_CLASS10, classes.title);
  const imageCls = classNames72(DEFAULT_IMAGE_CLASS3, classes.image);
  const buttonCls = classNames72(DEFAULT_BUTTON_CLASS8, classes.button);
  const subtitleCls = classNames72(DEFAULT_SUBTITLE_CLASS4, classes.subtitle);
  return /* @__PURE__ */ React186.createElement(Container, { className: containerCls }, title && /* @__PURE__ */ React186.createElement(Text, { className: titleCls }, title), imageSrc && /* @__PURE__ */ React186.createElement(Image, { loading: "lazy", src: imageSrc, alt: title || "Banner Image", className: imageCls }), buttonLabel && linkHref && /* @__PURE__ */ React186.createElement(Link, { className: buttonCls, href: linkHref, label: buttonLabel }), subtitle && /* @__PURE__ */ React186.createElement(Text, { className: subtitleCls }, subtitle));
};

// src/organisms/ArticleStatistics.tsx
import React187 from "react";
import classNames73 from "classnames";
var DEFAULT_CONTAINER_CLASS28 = "font-open-sans";
var DEFAULT_HEADER_CLASS4 = "flex p-4 gap-4 bg-(--statistics-primary-color) flex-col-reverse md:flex-row items-start";
var DEFAULT_HEADERLEFT_CLASS = "flex-1 flex gap-1 flex-col";
var DEFAULT_TITLE_CLASS11 = "text-2xl font-bold text-(--statistics-text-color)";
var DEFAULT_AVERAGELABEL_CLASS = "text-base text-(--statistics-text-color)";
var DEFAULT_RATINGROW_CLASS = "flex items-center gap-2";
var DEFAULT_RATINGVALUE_CLASS2 = "text-2xl font-bold text-(--statistics-text-color)";
var DEFAULT_STARS_CLASS4 = "max-h-[20px] w-auto";
var DEFAULT_RATINGTEXT_CLASS2 = "text-(--statistics-text-color)";
var DEFAULT_BRANDLOGO_CLASS = "max-h-[32px] w-auto";
var DEFAULT_STATS_CLASS = "flex flex-col gap-4 p-4 bg-(--statistics-secondary-color)";
var DEFAULT_STATROW_CLASS = "flex items-center gap-[20px]";
var DEFAULT_STATBAR_CLASS = "relative h-[20px] flex-1 rounded-full bg-(--statistics-empty-color) overflow-hidden max-w-[548px]";
var DEFAULT_STATFILL_CLASS = "absolute inset-y-0 rounded-full bg-(--statistics-filled-color)";
var DEFAULT_STATVALUEWRAPPER_CLASS = "absolute inset-y-0 right-2 flex items-center";
var DEFAULT_STATVALUE_CLASS = "text-sm font-bold text-(--statistics-number-color)";
var DEFAULT_STATLABEL_CLASS = "text-(--statistics-text-color)";
var ArticleStatistics = ({
  customerRatingsLabel,
  averageLabel,
  rating,
  excellentLabel,
  starsImage,
  statistics = [],
  brandLogo,
  className,
  classes = {}
}) => {
  const containerCls = classNames73(DEFAULT_CONTAINER_CLASS28, className, classes.container);
  const headerCls = classNames73(DEFAULT_HEADER_CLASS4, classes.header);
  const headerLeftCls = classNames73(DEFAULT_HEADERLEFT_CLASS, classes.headerLeft);
  const titleCls = classNames73(DEFAULT_TITLE_CLASS11, classes.title);
  const averageLabelCls = classNames73(DEFAULT_AVERAGELABEL_CLASS, classes.averageLabel);
  const ratingRowCls = classNames73(DEFAULT_RATINGROW_CLASS, classes.ratingRow);
  const ratingValueCls = classNames73(DEFAULT_RATINGVALUE_CLASS2, classes.ratingValue);
  const starsCls = classNames73(DEFAULT_STARS_CLASS4, classes.stars);
  const ratingTextCls = classNames73(DEFAULT_RATINGTEXT_CLASS2, classes.ratingText);
  const brandLogoCls = classNames73(DEFAULT_BRANDLOGO_CLASS, classes.brandLogo);
  const statsCls = classNames73(DEFAULT_STATS_CLASS, classes.stats);
  const statRowCls = classNames73(DEFAULT_STATROW_CLASS, classes.statRow);
  const statBarCls = classNames73(DEFAULT_STATBAR_CLASS, classes.statBar);
  const statFillCls = classNames73(DEFAULT_STATFILL_CLASS, classes.statFill);
  const statValueWrapperCls = classNames73(DEFAULT_STATVALUEWRAPPER_CLASS, classes.statValueWrapper);
  const statValueCls = classNames73(DEFAULT_STATVALUE_CLASS, classes.statValue);
  const statLabelCls = classNames73(DEFAULT_STATLABEL_CLASS, classes.statLabel);
  const ratings = statistics.map((stat) => {
    const clamped = Math.max(0, Math.min(10, stat.rating));
    const pct = clamped / 10 * 100;
    return /* @__PURE__ */ React187.createElement("div", { key: stat.tr_label, className: statRowCls }, /* @__PURE__ */ React187.createElement("div", { className: statBarCls }, /* @__PURE__ */ React187.createElement("div", { className: statFillCls, style: { width: `${pct}%` } }, /* @__PURE__ */ React187.createElement("div", { className: statValueWrapperCls }, /* @__PURE__ */ React187.createElement("span", { className: statValueCls }, clamped)))), /* @__PURE__ */ React187.createElement("div", { className: statLabelCls }, stat.tr_label));
  });
  return /* @__PURE__ */ React187.createElement(Container, { className: containerCls }, /* @__PURE__ */ React187.createElement("div", { className: headerCls }, /* @__PURE__ */ React187.createElement("div", { className: headerLeftCls }, customerRatingsLabel && /* @__PURE__ */ React187.createElement("div", { className: titleCls }, customerRatingsLabel), averageLabel && /* @__PURE__ */ React187.createElement("div", { className: averageLabelCls }, averageLabel), /* @__PURE__ */ React187.createElement("div", { className: ratingRowCls }, rating && /* @__PURE__ */ React187.createElement("div", { className: ratingValueCls }, rating), starsImage && /* @__PURE__ */ React187.createElement("img", { loading: "lazy", src: starsImage, alt: "stars", className: starsCls }), excellentLabel && /* @__PURE__ */ React187.createElement("div", { className: ratingTextCls }, excellentLabel))), brandLogo && /* @__PURE__ */ React187.createElement("img", { loading: "lazy", src: brandLogo, alt: "brand logo", className: brandLogoCls })), /* @__PURE__ */ React187.createElement("div", { className: statsCls }, ratings));
};

// src/organisms/CommentsThread.tsx
import React196, { useEffect as useEffect11, useMemo as useMemo2, useState as useState14 } from "react";
import classNames81 from "classnames";

// src/organisms/CommentList.tsx
import React193 from "react";
import classNames78 from "classnames";

// src/organisms/CommentItem.tsx
import React192 from "react";
import classNames77 from "classnames";

// src/atoms/Avatar.tsx
import React188 from "react";
var DEFAULT_ROOT_CLASS19 = "inline-flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#0C2F6C] text-[14px] font-normal leading-none text-white";
var DEFAULT_IMAGE_CLASS4 = "h-full w-full object-cover";
var DEFAULT_FALLBACK_CLASS = "";
function getInitials(name, initials) {
  if (initials) {
    return initials;
  }
  if (!name) {
    return "";
  }
  return name.split(" ").filter(Boolean).slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
}
var Avatar = ({
  src,
  alt,
  name,
  initials,
  size,
  className,
  classes = {},
  loading = "eager"
}) => {
  const rootCls = cn(DEFAULT_ROOT_CLASS19, className, classes.root);
  const imageCls = cn(DEFAULT_IMAGE_CLASS4, classes.image);
  const fallbackCls = cn(DEFAULT_FALLBACK_CLASS, classes.fallback);
  const avatarInitials = getInitials(name || alt, initials);
  const sizeStyle = size ? { width: size, height: size } : void 0;
  return /* @__PURE__ */ React188.createElement("span", { className: rootCls, style: sizeStyle, "aria-label": !src ? alt || name : void 0 }, src ? /* @__PURE__ */ React188.createElement("img", { loading, src, alt: alt || name || "", className: imageCls }) : /* @__PURE__ */ React188.createElement("span", { className: fallbackCls }, avatarInitials));
};

// src/molecules/CommentActions.tsx
import React191 from "react";
import classNames76 from "classnames";

// src/atoms/TextButton.tsx
import React189 from "react";
import classNames74 from "classnames";
var DEFAULT_BUTTON_CLASS9 = "cursor-pointer";
var TextButton = ({
  children,
  className,
  classes = {},
  ...rest
}) => {
  const buttonCls = classNames74(DEFAULT_BUTTON_CLASS9, className, classes.button);
  return /* @__PURE__ */ React189.createElement("button", { className: buttonCls, ...rest }, children);
};

// src/atoms/LikeCount.tsx
import React190 from "react";
import classNames75 from "classnames";
var DEFAULT_TEXT_CLASS6 = "text-[#3b5998] text-[13px] flex items-center gap-1";
var LikeCount = ({ likes, className, classes = {} }) => {
  const likeIcon = /* @__PURE__ */ React190.createElement(
    "svg",
    {
      width: "20",
      height: "17",
      viewBox: "0 0 20 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    },
    /* @__PURE__ */ React190.createElement("rect", { width: "20", height: "16.4706", fill: "url(#pattern0_4597_1559)" }),
    /* @__PURE__ */ React190.createElement("defs", null, /* @__PURE__ */ React190.createElement(
      "pattern",
      {
        id: "pattern0_4597_1559",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      },
      /* @__PURE__ */ React190.createElement("use", { xlinkHref: "#image0_4597_1559", transform: "scale(0.0588235 0.0714286)" })
    ), /* @__PURE__ */ React190.createElement(
      "image",
      {
        id: "image0_4597_1559",
        width: "17",
        height: "14",
        preserveAspectRatio: "none",
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAATVJREFUOE9j/P///38GCgEjIUP+/fvHcPLySwZLfUmcVuE1BGSAbdQsBjUFIYZbD94xHF2RgdUgvIYs3nKVYd+RqwzzO8IYXDI3M8ws1WFQVlLEMAivIc1T9zEIiggx5IQbMCRWrGJIi7TF6i2chhy/+JyhtGM7w96FsQzsbKxgQ2rSTElziXXEDIaWHGMGRxtThg1b9zF0L76F4g0PWzWG2mwnsBjcJSBNyMDZSoWhKc8FZ4yA1MMCGsUQA5c0sKYLe2bhjAmQ/P4jpxmmr7nNsGpCFKZL1GUhNt98vAevISDv7b/CzDCx3J58Q0CB7GSjzRDro43fkMPL0xmYGBkxwuT+o2cMseU7GPYuiGFgZ2fDbwiugJ2y8gLD+zfv4DGDN3ZAUbjjMGq0gjSAxF1sNFESHQDnTavX2+tMFAAAAABJRU5ErkJggg=="
      }
    ))
  );
  const textCls = classNames75(DEFAULT_TEXT_CLASS6, className, classes.text);
  return /* @__PURE__ */ React190.createElement("span", { className: textCls }, likeIcon, " ", likes);
};

// src/molecules/CommentActions.tsx
var DEFAULT_ROOT_CLASS20 = "flex items-center gap-2 text-[13px] text-[#3658A6]";
var CommentActions = ({
  liked = false,
  likes,
  date,
  onLike,
  onReply,
  className,
  likeLabel,
  replyLabel,
  unlikeLabel,
  classes = {}
}) => {
  const rootCls = classNames76(DEFAULT_ROOT_CLASS20, className, classes.root);
  return /* @__PURE__ */ React191.createElement("div", { className: rootCls }, /* @__PURE__ */ React191.createElement(TextButton, { className: classes.likeButton, onClick: onLike }, liked ? unlikeLabel || "Unlike" : likeLabel || "Like"), /* @__PURE__ */ React191.createElement(TextButton, { className: classes.replyButton, onClick: onReply }, replyLabel || "Reply"), /* @__PURE__ */ React191.createElement(LikeCount, { className: classes.likeCount, likes: likes != null ? likes : 0 }), /* @__PURE__ */ React191.createElement(DateText, { className: classes.dateText, date: date || "" }));
};

// src/organisms/CommentItem.tsx
var DEFAULT_ROOT_CLASS21 = "flex gap-[10px]";
var DEFAULT_AVATAR_CLASS2 = "";
var DEFAULT_BODY_CLASS = "flex-1 flex flex-col gap-0.5";
var DEFAULT_HEADER_CLASS5 = "flex gap-[5px] items-center";
var DEFAULT_NAME_CLASS2 = "font-bold text-[#3658A6] text-sm";
var DEFAULT_LOCATION_CLASS = "text-[#999] text-xs";
var DEFAULT_FLAG_CLASS3 = "";
var DEFAULT_COMMENTTEXT_CLASS = "text-sm";
var DEFAULT_ACTIONS_CLASS2 = "";
var DEFAULT_CHILDREN_CLASS = "";
var CommentItem = ({
  comment,
  isReply = false,
  onLike,
  onReply,
  children,
  className,
  classes = {},
  likeLabel,
  replyLabel,
  unlikeLabel
}) => {
  const rootCls = classNames77(DEFAULT_ROOT_CLASS21, className, classes.root);
  const avatarCls = classNames77(DEFAULT_AVATAR_CLASS2, classes.avatar);
  const bodyCls = classNames77(DEFAULT_BODY_CLASS, classes.body);
  const headerCls = classNames77(DEFAULT_HEADER_CLASS5, classes.header);
  const nameCls = classNames77(DEFAULT_NAME_CLASS2, classes.name);
  const locationCls = classNames77(DEFAULT_LOCATION_CLASS, classes.location);
  const flagCls = classNames77(DEFAULT_FLAG_CLASS3, classes.flag);
  const commentTextCls = classNames77(DEFAULT_COMMENTTEXT_CLASS, classes.commentText);
  const actionsCls = classNames77(DEFAULT_ACTIONS_CLASS2, classes.actions);
  const childrenCls = classNames77(DEFAULT_CHILDREN_CLASS, classes.children);
  return /* @__PURE__ */ React192.createElement("div", { className: rootCls }, /* @__PURE__ */ React192.createElement(
    Avatar,
    {
      loading: "lazy",
      className: avatarCls,
      src: comment.author_image,
      alt: comment.name,
      size: 40
    }
  ), /* @__PURE__ */ React192.createElement("div", { className: bodyCls }, /* @__PURE__ */ React192.createElement("div", { className: headerCls }, /* @__PURE__ */ React192.createElement("span", { className: nameCls }, comment.name), " ", /* @__PURE__ */ React192.createElement("span", { className: locationCls }, comment.location), " ", comment.flag && /* @__PURE__ */ React192.createElement(
    "img",
    {
      loading: "lazy",
      className: flagCls,
      src: comment.flag,
      alt: `${comment.location} flag`
    }
  )), /* @__PURE__ */ React192.createElement("div", { className: commentTextCls }, comment.tr_comment), /* @__PURE__ */ React192.createElement("div", { className: actionsCls }, /* @__PURE__ */ React192.createElement(
    CommentActions,
    {
      likeLabel,
      replyLabel,
      unlikeLabel,
      liked: comment.liked,
      likes: comment.likes,
      date: comment.tr_date,
      onLike,
      onReply
    }
  )), children && /* @__PURE__ */ React192.createElement("div", { className: childrenCls }, children)));
};

// src/organisms/CommentList.tsx
var DEFAULT_ROOT_CLASS22 = "space-y-4";
var DEFAULT_COMMENTWRAPPER_CLASS = "";
var DEFAULT_REPLIESWRAPPER_CLASS = "mt-2 space-y-3";
var DEFAULT_REPLYBOXWRAPPER_CLASS = "";
var CommentList = ({
  comments = [],
  onLike,
  onReplyToggle,
  renderReplyBox,
  className,
  likeLabel,
  replyLabel,
  unlikeLabel,
  classes = {}
}) => {
  const rootCls = classNames78(DEFAULT_ROOT_CLASS22, className, classes.root);
  const commentWrapperCls = classNames78(DEFAULT_COMMENTWRAPPER_CLASS, classes.commentWrapper);
  const repliesWrapperCls = classNames78(DEFAULT_REPLIESWRAPPER_CLASS, classes.repliesWrapper);
  const replyBoxWrapperCls = classNames78(DEFAULT_REPLYBOXWRAPPER_CLASS, classes.replyBoxWrapper);
  return /* @__PURE__ */ React193.createElement("div", { className: rootCls }, comments.map((c) => {
    var _a;
    return /* @__PURE__ */ React193.createElement("div", { key: c.id, className: commentWrapperCls }, /* @__PURE__ */ React193.createElement(
      CommentItem,
      {
        likeLabel,
        replyLabel,
        unlikeLabel,
        comment: c,
        onLike: () => onLike == null ? void 0 : onLike(c.id),
        onReply: () => onReplyToggle == null ? void 0 : onReplyToggle(c.id)
      },
      ((_a = c.replies) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ React193.createElement("div", { className: repliesWrapperCls }, c.replies.map((r) => /* @__PURE__ */ React193.createElement(
        CommentItem,
        {
          likeLabel,
          replyLabel,
          unlikeLabel,
          key: r.id,
          comment: r,
          isReply: true,
          onLike: () => onLike == null ? void 0 : onLike(r.id, c.id),
          onReply: () => onReplyToggle == null ? void 0 : onReplyToggle(r.id)
        }
      ))),
      renderReplyBox && /* @__PURE__ */ React193.createElement("div", { className: replyBoxWrapperCls }, renderReplyBox(c.id))
    ));
  }));
};

// src/molecules/ReplyBox.tsx
import React194 from "react";
import classNames79 from "classnames";
var DEFAULT_ROOT_CLASS23 = "flex gap-2 mt-2 p-3 border border-neutral-200";
var DEFAULT_AVATAR_CLASS3 = "";
var DEFAULT_BODY_CLASS2 = "flex-1";
var DEFAULT_TEXTAREA_CLASS = "w-full p-2 border border-neutral-300 focus:outline-none focus:ring-1 focus:ring-blue-500 text-[14px]";
var DEFAULT_ACTIONS_CLASS3 = "flex justify-end gap-2 mt-2";
var DEFAULT_CANCEL_BUTTON_CLASS = "px-3 py-1 border border-neutral-400 bg-neutral-100 text-sm";
var DEFAULT_SUBMIT_BUTTON_CLASS = "px-3 py-1 border border-[#3b5998] rounded bg-[#3b5998] text-white text-sm";
var ReplyBox = ({
  value = "",
  onChange,
  onCancel,
  onSubmit,
  avatar,
  className,
  addCommentLabel,
  cancelLabel,
  replyLabel,
  classes = {}
}) => {
  const rootCls = classNames79(DEFAULT_ROOT_CLASS23, className, classes.root);
  const avatarCls = classNames79(DEFAULT_AVATAR_CLASS3, classes.avatar);
  const bodyCls = classNames79(DEFAULT_BODY_CLASS2, classes.body);
  const textareaCls = classNames79(DEFAULT_TEXTAREA_CLASS, classes.textarea);
  const actionsCls = classNames79(DEFAULT_ACTIONS_CLASS3, classes.actions);
  const cancelBtnCls = classNames79(DEFAULT_CANCEL_BUTTON_CLASS, classes.cancelButton);
  const submitBtnCls = classNames79(DEFAULT_SUBMIT_BUTTON_CLASS, classes.submitButton);
  return /* @__PURE__ */ React194.createElement("div", { className: rootCls }, /* @__PURE__ */ React194.createElement(Avatar, { loading: "lazy", className: avatarCls, src: avatar, alt: "You", size: 32 }), /* @__PURE__ */ React194.createElement("div", { className: bodyCls }, /* @__PURE__ */ React194.createElement(
    "textarea",
    {
      className: textareaCls,
      placeholder: addCommentLabel || "Add comment here",
      value,
      onChange: (e) => onChange == null ? void 0 : onChange(e.target.value)
    }
  ), /* @__PURE__ */ React194.createElement("div", { className: actionsCls }, /* @__PURE__ */ React194.createElement("button", { onClick: onCancel, className: cancelBtnCls }, cancelLabel || "Cancel"), /* @__PURE__ */ React194.createElement("button", { onClick: onSubmit, className: submitBtnCls }, replyLabel || "Reply"))));
};

// src/organisms/AddCommentBox.tsx
import React195 from "react";
import classNames80 from "classnames";
var DEFAULT_ROOT_CLASS24 = "flex gap-[10px] mb-6";
var DEFAULT_AVATAR_CLASS4 = "";
var DEFAULT_BODY_CLASS3 = "flex-1 border border-[#C5CDE0] text-sm";
var DEFAULT_TEXTAREA_CLASS2 = "w-full border-0 p-2 text-[14px]";
var DEFAULT_FOOTER_CLASS = "flex justify-end bg-neutral-50 border-t border-neutral-200 px-3 py-2";
var DEFAULT_POST_BUTTON_CLASS = "px-3 py-1 border border-[#3b5998] rounded bg-[#3b5998] text-white text-sm";
var AddCommentBox = ({
  value = "",
  showPost = false,
  onChange,
  onSubmit,
  onFocus,
  onBlur,
  avatar,
  className,
  addCommentLabel,
  postLabel,
  classes = {}
}) => {
  const rootCls = classNames80(DEFAULT_ROOT_CLASS24, className, classes.root);
  const avatarCls = classNames80(DEFAULT_AVATAR_CLASS4, classes.avatar);
  const bodyCls = classNames80(DEFAULT_BODY_CLASS3, classes.body);
  const textareaCls = classNames80(DEFAULT_TEXTAREA_CLASS2, classes.textarea);
  const footerCls = classNames80(DEFAULT_FOOTER_CLASS, classes.footer);
  const postButtonCls = classNames80(DEFAULT_POST_BUTTON_CLASS, classes.postButton);
  return /* @__PURE__ */ React195.createElement("div", { className: rootCls }, /* @__PURE__ */ React195.createElement(Avatar, { loading: "lazy", className: avatarCls, src: avatar, alt: "You", size: 40 }), /* @__PURE__ */ React195.createElement("div", { className: bodyCls }, /* @__PURE__ */ React195.createElement(
    "textarea",
    {
      className: textareaCls,
      placeholder: addCommentLabel || "Add comment here",
      value,
      onChange: (e) => onChange == null ? void 0 : onChange(e.target.value),
      onFocus,
      onBlur
    }
  ), showPost && /* @__PURE__ */ React195.createElement("div", { className: footerCls }, /* @__PURE__ */ React195.createElement("button", { onClick: onSubmit, className: postButtonCls }, postLabel || "Post"))));
};

// src/organisms/CommentsThread.tsx
var normalize = (list) => (list || []).map((c) => {
  var _a;
  return { ...c, replies: (_a = c.replies) != null ? _a : [] };
});
var DEFAULT_ROOT_CLASS25 = "md:mb-10";
var DEFAULT_HEADER_CLASS6 = "font-bold mb-6 text-base";
var DEFAULT_COUNT_CLASS = "";
var DEFAULT_ADD_BOX_CLASS = "";
var DEFAULT_LIST_CLASS4 = "";
var DEFAULT_REPLYBOXWRAPPER_CLASS2 = "";
var CommentsThread = ({
  commentsList = [],
  guestAvatar,
  className,
  classes = {},
  commentsSettings
}) => {
  const [comments, setComments] = useState14(() => normalize(commentsList));
  useEffect11(() => {
    setComments(normalize(commentsList));
  }, [commentsList]);
  const [replyOpen, setReplyOpen] = useState14({});
  const [replyDrafts, setReplyDrafts] = useState14({});
  const [newComment, setNewComment] = useState14("");
  const [showPost, setShowPost] = useState14(false);
  const totalCount = useMemo2(
    () => comments.reduce((acc, c) => {
      var _a, _b;
      return acc + 1 + ((_b = (_a = c.replies) == null ? void 0 : _a.length) != null ? _b : 0);
    }, 0),
    [comments]
  );
  const toNum = (v) => typeof v === "number" ? v : Number(v != null ? v : 0);
  const toggleLike = (commentId, parentId) => {
    setComments(
      (prev) => prev.map((c) => {
        if (parentId) {
          if (c.id !== parentId) return c;
          return {
            ...c,
            replies: c.replies.map(
              (r) => r.id === commentId ? {
                ...r,
                liked: !r.liked,
                likes: r.liked ? toNum(r.likes) - 1 : toNum(r.likes) + 1
              } : r
            )
          };
        }
        if (c.id !== commentId) return c;
        return {
          ...c,
          liked: !c.liked,
          likes: c.liked ? toNum(c.likes) - 1 : toNum(c.likes) + 1
        };
      })
    );
  };
  const toggleReplyOpen = (id) => {
    setReplyOpen((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const handleReplyChange = (id, text) => {
    setReplyDrafts((prev) => ({ ...prev, [id]: text }));
  };
  const submitReply = (parentId) => {
    const text = (replyDrafts[parentId] || "").trim();
    if (!text) return;
    const newReply = {
      id: `${parentId}-${Date.now()}`,
      name: (commentsSettings == null ? void 0 : commentsSettings.tr_guest_label) || "Guest",
      location: "",
      author_image: guestAvatar,
      tr_date: (commentsSettings == null ? void 0 : commentsSettings.tr_just_now_label) || "Just now",
      tr_comment: text,
      likes: 0,
      liked: false,
      replies: []
    };
    setComments(
      (prev) => prev.map((c) => c.id === parentId ? { ...c, replies: [...c.replies, newReply] } : c)
    );
    setReplyDrafts((prev) => ({ ...prev, [parentId]: "" }));
    setReplyOpen((prev) => ({ ...prev, [parentId]: false }));
  };
  const cancelReply = (parentId) => {
    setReplyDrafts((prev) => ({ ...prev, [parentId]: "" }));
    setReplyOpen((prev) => ({ ...prev, [parentId]: false }));
  };
  const submitNewComment = () => {
    const text = newComment.trim();
    if (!text) return;
    const fresh = {
      id: `c-${Date.now()}`,
      name: (commentsSettings == null ? void 0 : commentsSettings.tr_guest_label) || "Guest",
      location: "",
      author_image: guestAvatar,
      tr_date: (commentsSettings == null ? void 0 : commentsSettings.tr_just_now_label) || "Just now",
      tr_comment: text,
      likes: 0,
      liked: false,
      replies: []
    };
    setComments((prev) => [fresh, ...prev]);
    setNewComment("");
    setShowPost(false);
  };
  const handleAddFocus = () => setShowPost(true);
  const handleAddBlur = () => {
    if (!newComment.trim()) setShowPost(false);
  };
  const rootCls = classNames81(DEFAULT_ROOT_CLASS25, className, classes.root);
  const headerCls = classNames81(DEFAULT_HEADER_CLASS6, classes.header);
  const countCls = classNames81(DEFAULT_COUNT_CLASS, classes.count);
  const addBoxCls = classNames81(DEFAULT_ADD_BOX_CLASS, classes.addBox);
  const listCls = classNames81(DEFAULT_LIST_CLASS4, classes.list);
  const replyBoxWrapperCls = classNames81(DEFAULT_REPLYBOXWRAPPER_CLASS2, classes.replyBoxWrapper);
  return /* @__PURE__ */ React196.createElement("div", { className: rootCls }, /* @__PURE__ */ React196.createElement("div", { className: headerCls }, /* @__PURE__ */ React196.createElement("span", { className: countCls }, totalCount, " ", commentsSettings == null ? void 0 : commentsSettings.tr_comments_label)), /* @__PURE__ */ React196.createElement("div", { className: addBoxCls }, /* @__PURE__ */ React196.createElement(
    AddCommentBox,
    {
      value: newComment,
      avatar: guestAvatar,
      postLabel: commentsSettings == null ? void 0 : commentsSettings.tr_post_label,
      addCommentLabel: commentsSettings == null ? void 0 : commentsSettings.tr_add_comment_label,
      showPost: showPost || !!newComment.trim(),
      onChange: setNewComment,
      onSubmit: submitNewComment,
      onFocus: handleAddFocus,
      onBlur: handleAddBlur
    }
  )), /* @__PURE__ */ React196.createElement("div", { className: listCls }, /* @__PURE__ */ React196.createElement(
    CommentList,
    {
      likeLabel: commentsSettings == null ? void 0 : commentsSettings.tr_like_label,
      replyLabel: commentsSettings == null ? void 0 : commentsSettings.tr_reply_label,
      unlikeLabel: commentsSettings == null ? void 0 : commentsSettings.tr_unlike_label,
      comments,
      onLike: toggleLike,
      onReplyToggle: toggleReplyOpen,
      renderReplyBox: (id) => replyOpen[id] ? /* @__PURE__ */ React196.createElement("div", { className: replyBoxWrapperCls }, /* @__PURE__ */ React196.createElement(
        ReplyBox,
        {
          cancelLabel: commentsSettings == null ? void 0 : commentsSettings.tr_cancel_label,
          replyLabel: commentsSettings == null ? void 0 : commentsSettings.tr_reply_label,
          addCommentLabel: commentsSettings == null ? void 0 : commentsSettings.tr_add_comment_label,
          avatar: guestAvatar,
          value: replyDrafts[id] || "",
          onChange: (v) => handleReplyChange(id, v),
          onCancel: () => cancelReply(id),
          onSubmit: () => submitReply(id)
        }
      )) : null
    }
  )));
};

// src/providers/LinkEnhancer.tsx
import React197, { useEffect as useEffect12, useRef as useRef6 } from "react";
var PARAMS_CONFIG = [
  { key: "aff", cookieKey: "affiliate_tag", encode: true },
  { key: "affOverwrite", cookieKey: "affiliate_overwrite", encode: true },
  { key: "affSource", cookieKey: "affiliate_source", encode: true },
  { key: "entryUrl", cookieKey: "entrypoint_url", encode: true },
  { key: "postId", cookieKey: "cc_param_postId", encode: true },
  { key: "core_gclid", cookieKey: "cc_param_core_gclid", encode: false },
  { key: "core_gbraid", cookieKey: "cc_param_core_gbraid", encode: false },
  { key: "core_gclid", cookieKey: "cc_param_core_wbraid", encode: false },
  { key: "tracking_id", cookieKey: "cc_param_tracking_id", encode: false },
  { key: "newsbreak_cid", cookieKey: "cc_param_newsbreak_cid", encode: false },
  { key: "dclid", cookieKey: "cc_param_dclid", encode: false },
  { key: "utm_id", cookieKey: "cc_param_utm_id", encode: false },
  { key: "fbclid", cookieKey: "cc_param_fbclid", encode: false },
  { key: "epik", cookieKey: "cc_param_epik", encode: false },
  { key: "adclid", cookieKey: "cc_param_adclid", encode: false },
  { key: "msclkid", cookieKey: "cc_param_msclkid", encode: false },
  { key: "transaction_id", cookieKey: "cc_param_transaction_id", encode: false },
  { key: "campaignid", cookieKey: "cc_param_campaignid", encode: false },
  { key: "pi_clickid", cookieKey: "cc_param_pi_clickid", encode: false },
  { key: "pi_companyid", cookieKey: "cc_param_pi_companyid", encode: false },
  { key: "_raclid", cookieKey: "cc_param__raclid", encode: false },
  { key: "caid", cookieKey: "cc_param_caid", encode: false },
  { key: "performclickID", cookieKey: "cc_param_performclickID", encode: false },
  { key: "msclkid", cookieKey: "cc_param_msclkid", encode: false },
  { key: "cid", cookieKey: "cc_param_cid", encode: false },
  { key: "oid", cookieKey: "cc_param_oid", encode: false },
  { key: "affid2", cookieKey: "cc_param_affid2", encode: false },
  { key: "sub1", cookieKey: "ef_sub1", encode: false },
  { key: "sub2", cookieKey: "ef_sub2", encode: false },
  { key: "sub3", cookieKey: "ef_sub3", encode: false },
  { key: "sub4", cookieKey: "ef_sub4", encode: false },
  { key: "sub5", cookieKey: "ef_sub5", encode: false },
  { key: "uid", cookieKey: "ef_uid", encode: false },
  { key: "_ef_transaction_id", cookieKey: "ef_transaction_id", encode: false },
  { key: "transaction_id", cookieKey: "ef_transaction_id", encode: false },
  { key: "obclid", cookieKey: "cc_param_obclid", encode: false },
  { key: "rc_uuid", cookieKey: "cc_param_rc_uuid", encode: false },
  { key: "aleid", cookieKey: "_aleid", encode: false },
  { key: "axwrt", cookieKey: "_axwrt", encode: false }
];
var getCookie = (name) => {
  var _a;
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return ((_a = parts.pop()) == null ? void 0 : _a.split(";").shift()) || null;
  }
  return null;
};
var isBase64encoded = (str) => {
  if (!str) return false;
  const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
  if (!base64Regex.test(str)) return false;
  try {
    return btoa(atob(str)) === str;
  } catch (e) {
    return false;
  }
};
function LinkEnhancer({ children }) {
  const containerRef = useRef6(null);
  useEffect12(() => {
    if (typeof window === "undefined") return;
    const container = containerRef.current;
    if (!container) return;
    const currentParams = new URLSearchParams(window.location.search);
    const enhanceLinks = () => {
      const links = Array.from(container.querySelectorAll("a[href]")).filter(
        (link) => {
          var _a;
          const href = (_a = link.getAttribute("href")) != null ? _a : "";
          return !(href.includes("/legal/") || href.startsWith("tel:") || href.startsWith("mailto:") || href.startsWith("#") || href.startsWith("javascript:") || href.includes("trackingmore"));
        }
      );
      const appendParamsToUrl = (url) => {
        PARAMS_CONFIG.forEach(({ key, cookieKey, encode }) => {
          if (url.searchParams.has(key)) return;
          const value = currentParams.get(key) || getCookie(cookieKey);
          if (value) {
            const finalValue = encode && !isBase64encoded(value) ? btoa(String(value)) : value;
            url.searchParams.set(key, finalValue);
          }
        });
      };
      links.forEach((link) => {
        try {
          const url = new URL(link.href);
          appendParamsToUrl(url);
          const nextHref = url.toString();
          if (link.getAttribute("href") !== nextHref) {
            link.setAttribute("href", nextHref);
          }
        } catch (error) {
          console.error("Failed to enhance link", link, error);
        }
      });
    };
    enhanceLinks();
    const observer = new MutationObserver((mutations) => {
      const shouldEnhance = mutations.some(
        (m) => m.type === "childList" || m.type === "attributes" && m.attributeName === "href"
      );
      if (shouldEnhance) enhanceLinks();
    });
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["href"]
    });
    return () => observer.disconnect();
  }, []);
  return /* @__PURE__ */ React197.createElement("section", { ref: containerRef }, children);
}

// src/providers/top5LinkEnhancer.tsx
import React198, { useEffect as useEffect13, useRef as useRef7 } from "react";
function Top5LinkEnhancer({
  children,
  exceptions = ["trackingmore", "/legal/", "#", "javascript"],
  excludedParams = ["aff", "affiliate"]
}) {
  const containerRef = useRef7(null);
  useEffect13(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;
    const getAnchorTags = () => {
      const container = containerRef.current;
      if (!container) return [];
      const anchorTags = container.getElementsByTagName("a");
      return Array.from(anchorTags).filter((anchorTag) => {
        return !exceptions.some((slug) => anchorTag.href.includes(slug));
      });
    };
    const getCurrentUrlParams = () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.toString()) {
        return null;
      }
      const urlParamPairs = Object.fromEntries(urlParams.entries());
      return Object.entries(urlParamPairs).map(([key, value]) => {
        if (excludedParams.includes(key)) {
          return;
        }
        return `${key}=${value}`;
      }).filter(Boolean).join("&");
    };
    const addTrackingParams = () => {
      const urlParams = getCurrentUrlParams();
      if (!urlParams) {
        return;
      }
      const anchorTags = getAnchorTags();
      anchorTags.forEach((a) => {
        const separator = a.href.includes("?") ? "&" : "?";
        a.href = `${a.href}${separator}${urlParams}`;
      });
    };
    addTrackingParams();
  }, []);
  return /* @__PURE__ */ React198.createElement("div", { ref: containerRef }, children);
}

// src/organisms/reviews/ReviewsFooter.tsx
import React199 from "react";
import classNames82 from "classnames";
var ReviewsFooter = ({
  footer,
  classes = {},
  className,
  generalSettings = {}
}) => {
  var _a;
  const DEFAULT_WRAPPER_CLASS12 = "max-w-[400px] md:max-w-[972px] m-auto p-7 md:p-3 bg-white";
  const DEFAULT_GRID_CLASS9 = "grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-0";
  const DEFAULT_COLUMN_CLASS2 = "flex flex-col gap-2";
  const DEFAULT_COLUMN_TITLE_CLASS = "font-bold mb-2 text-[16]";
  const DEFAULT_LINK_CLASS7 = "hover:underline text-[15px]";
  const DEFAULT_LOGO_WRAPPER_CLASS3 = "max-w-[160px] md:max-w-full";
  const DEFAULT_LOGO_IMAGE_CLASS2 = "";
  const DEFAULT_BRAND_NAME_CLASS = "mt-13 md:mt-8 text-[11px]";
  const wrapperCls = classNames82(DEFAULT_WRAPPER_CLASS12, className, classes.wrapper);
  const gridCls = classNames82(DEFAULT_GRID_CLASS9, classes.grid);
  const columnCls = classNames82(DEFAULT_COLUMN_CLASS2, classes.column);
  const columnTitleCls = classNames82(DEFAULT_COLUMN_TITLE_CLASS, classes.columnTitle);
  const linkCls = classNames82(DEFAULT_LINK_CLASS7, classes.link);
  const logoWrapperCls = classNames82(DEFAULT_LOGO_WRAPPER_CLASS3, classes.logoWrapper);
  const logoImageCls = classNames82(DEFAULT_LOGO_IMAGE_CLASS2, classes.logoImage);
  const brandNameCls = classNames82(DEFAULT_BRAND_NAME_CLASS, classes.brandName);
  const resolveHref = (link) => {
    if (!link) return "#";
    return link.link_type === "page" ? link.page : link.url;
  };
  return /* @__PURE__ */ React199.createElement("div", { className: wrapperCls }, /* @__PURE__ */ React199.createElement("div", { className: gridCls }, (_a = footer == null ? void 0 : footer.footer_columns) == null ? void 0 : _a.map((column, index) => {
    var _a2;
    return /* @__PURE__ */ React199.createElement("div", { key: index, className: columnCls }, column.tr_title && /* @__PURE__ */ React199.createElement("h4", { className: columnTitleCls }, column.tr_title), (_a2 = column == null ? void 0 : column.link) == null ? void 0 : _a2.map((item, i) => /* @__PURE__ */ React199.createElement(
      "a",
      {
        key: i,
        href: resolveHref(item),
        target: item.targetBlank ? "_blank" : "_self",
        className: linkCls
      },
      item.tr_label
    )));
  }), /* @__PURE__ */ React199.createElement("div", { className: logoWrapperCls }, /* @__PURE__ */ React199.createElement(Image, { className: logoImageCls, src: generalSettings == null ? void 0 : generalSettings.logo }))), /* @__PURE__ */ React199.createElement("div", { className: brandNameCls }, "\xA9 ", (/* @__PURE__ */ new Date()).getFullYear(), " ", generalSettings == null ? void 0 : generalSettings.brand_name, ".", generalSettings == null ? void 0 : generalSettings.domain_second_part));
};

// src/organisms/reviews/ProductCard.tsx
import React200 from "react";
import parse3 from "html-react-parser";
import classNames83 from "classnames";
var ProductCard = ({ item, index, assets, labels }) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { prizes, icons } = assets;
  const prize = (_a = prizes[index]) != null ? _a : null;
  const proLabel = (_b = labels == null ? void 0 : labels.tr_product_pro_label) != null ? _b : "Pros";
  const consLabel = (_c = labels == null ? void 0 : labels.tr_product_cons_label) != null ? _c : "Cons";
  const clamp2 = (n, min = 0, max = 100) => Math.max(min, Math.min(max, n));
  const toPercent = (value) => {
    if (value == null) return 0;
    const num = typeof value === "string" ? parseFloat(value.replace("%", "").trim()) : Number(value);
    if (!Number.isFinite(num)) return 0;
    if (num >= 0 && num <= 1) return clamp2(Math.round(num * 100));
    if (num > 1 && num <= 5) return clamp2(Math.round(num / 5 * 100));
    return clamp2(Math.round(num));
  };
  const ratingToKey = (rating) => {
    const value = Number(rating);
    switch (value) {
      case 5:
        return "five";
      case 4.5:
        return "fourHalf";
      case 4:
        return "four";
      case 3:
        return "three";
      case 2:
        return "two";
      case 1:
        return "one";
      default:
        return "one";
    }
  };
  const featuresList = (_d = item.feature_rating) != null ? _d : [];
  const prosList = (_e = item.pros) != null ? _e : [];
  const consList = (_f = item.cons) != null ? _f : [];
  const isMain = Boolean(item.main_product);
  const starRating = ratingToKey(item == null ? void 0 : item.stars_rating);
  return /* @__PURE__ */ React200.createElement("article", { className: "relative w-full overflow-visible rounded-xl border border-gray-200 bg-white p-6 md:p-14 shadow-[0_0_7px_0_rgba(155,155,155,0.25)]" }, prize && /* @__PURE__ */ React200.createElement("img", { src: prize, alt: "", className: "absolute left-6 -top-5 w-[70px]" }), isMain && /* @__PURE__ */ React200.createElement("div", { className: "mb-6 flex justify-center" }, /* @__PURE__ */ React200.createElement(
    "a",
    {
      href: item.cta_link,
      target: item.new_tab ? "_blank" : void 0,
      rel: item.new_tab ? "noopener noreferrer" : void 0
    },
    /* @__PURE__ */ React200.createElement("h3", { className: "text-[32px] font-bold underline underline-offset-4 text-center mt-10 md:mt-0" }, item.brand_name)
  )), /* @__PURE__ */ React200.createElement("div", { className: "grid gap-6 md:grid-cols-2" }, /* @__PURE__ */ React200.createElement("div", { className: "min-w-0" }, !isMain && /* @__PURE__ */ React200.createElement(
    "a",
    {
      href: item.cta_link,
      target: item.new_tab ? "_blank" : void 0,
      rel: item.new_tab ? "noopener noreferrer" : void 0
    },
    /* @__PURE__ */ React200.createElement("h3", { className: "text-[32px] font-bold underline underline-offset-4 mt-10 md:mt-0" }, item.brand_name)
  ), /* @__PURE__ */ React200.createElement(
    "a",
    {
      href: item.cta_link,
      target: item.new_tab ? "_blank" : void 0,
      rel: item.new_tab ? "noopener noreferrer" : void 0
    },
    /* @__PURE__ */ React200.createElement("div", { className: "mt-4 w-full overflow-hidden h-64 lg:h-100" }, item.product_image ? /* @__PURE__ */ React200.createElement(
      Image,
      {
        src: item.product_image.url,
        alt: item.brand_name || "Product image",
        loading: "lazy",
        className: "h-full w-full object-contain p-3"
      }
    ) : /* @__PURE__ */ React200.createElement("div", { className: "flex h-56 items-center justify-center text-sm text-gray-500" }, "No image"))
  )), /* @__PURE__ */ React200.createElement("div", { className: "min-w-0" }, /* @__PURE__ */ React200.createElement("div", { className: "flex items-center justify-center gap-4" }, /* @__PURE__ */ React200.createElement("p", { className: "text-[28px] font-semibold" }, item.price), /* @__PURE__ */ React200.createElement("span", { className: "h-8 w-px bg-gray-300" }), /* @__PURE__ */ React200.createElement("p", { className: "text-[28px] font-semibold" }, item.rating)), /* @__PURE__ */ React200.createElement("div", { className: "mt-6 max-w-82.5 space-y-7.5 mx-auto md:mx-0 md:ml-auto" }, featuresList.map((f, i) => {
    const pct = toPercent(f.feature_rating);
    return /* @__PURE__ */ React200.createElement("div", { key: `${f.tr_feature}-${i}` }, /* @__PURE__ */ React200.createElement("p", { className: "text-[15px] font-semibold uppercase" }, f.tr_feature), /* @__PURE__ */ React200.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React200.createElement("div", { className: "relative h-8 w-full overflow-hidden rounded-sm border border-gray-300 bg-gray-100" }, /* @__PURE__ */ React200.createElement("div", { className: "h-full bg-[rgb(77,199,28)]", style: { width: `${pct}%` } }), /* @__PURE__ */ React200.createElement(
      "span",
      {
        className: "absolute top-1/2 -translate-y-1/2 text-sm font-semibold text-white",
        style: { left: `calc(${pct}% - 50px)` }
      },
      pct,
      "%"
    ))));
  })))), /* @__PURE__ */ React200.createElement("div", { className: "mt-12 text-center" }, /* @__PURE__ */ React200.createElement("p", { className: "text-[35px] font-bold uppercase" }, item == null ? void 0 : item.tr_overall_rating), /* @__PURE__ */ React200.createElement("div", { className: "flex items-center justify-center gap-10" }, /* @__PURE__ */ React200.createElement("p", { className: "text-[50px] font-bold" }, item == null ? void 0 : item.overtall), /* @__PURE__ */ React200.createElement("div", { className: "h-5 scale-[1.25]" }, STAR_SVG[starRating]))), isMain && (item == null ? void 0 : item.tr_over_ratings) && /* @__PURE__ */ React200.createElement("p", { className: "text-center text-[17px] text-[#484848]" }, item.tr_over_ratings), /* @__PURE__ */ React200.createElement(
    "a",
    {
      href: item == null ? void 0 : item.cta_link,
      target: item.new_tab ? "_blank" : void 0,
      rel: item.new_tab ? "noopener noreferrer" : void 0,
      className: classNames83(
        "mx-auto mt-6 flex w-full items-center justify-center rounded-lg text-[20px] font-semibold text-white",
        {
          "h-[60px] max-w-[336px] uppercase bg-[linear-gradient(to_right,rgb(241,89,0),rgb(255,60,30))]": isMain,
          "h-[56px] max-w-[283px] bg-[#FF9C00]": !isMain
        }
      )
    },
    item == null ? void 0 : item.tr_cta_label
  ), isMain && /* @__PURE__ */ React200.createElement("div", { className: "mt-8" }, /* @__PURE__ */ React200.createElement("p", { className: "text-[26px] font-bold" }, item.tr_review_heading), /* @__PURE__ */ React200.createElement("div", { className: "mt-3 text-[16px]" }, parse3((_g = item.tr_review) != null ? _g : ""))), /* @__PURE__ */ React200.createElement("div", { className: "mt-10 grid md:grid-cols-2" }, /* @__PURE__ */ React200.createElement("div", null, /* @__PURE__ */ React200.createElement("div", { className: "flex h-16 items-center justify-center bg-[rgb(77,199,28)]" }, /* @__PURE__ */ React200.createElement("p", { className: "text-[30px] font-semibold text-white" }, proLabel)), /* @__PURE__ */ React200.createElement("ul", { className: "mt-4 ml-[10px] space-y-2 text-[16px]" }, prosList.map((pro, i) => /* @__PURE__ */ React200.createElement("li", { key: `pro-${i}`, className: "flex items-center gap-[18px]" }, /* @__PURE__ */ React200.createElement("img", { src: icons.check, alt: "", className: "h-[27px] w-[27px] flex-shrink-0" }), /* @__PURE__ */ React200.createElement("span", null, pro == null ? void 0 : pro.tr_pro))))), /* @__PURE__ */ React200.createElement("div", { className: "mt-8 md:mt-0" }, /* @__PURE__ */ React200.createElement("div", { className: "flex h-16 items-center justify-center bg-[rgb(204,75,75)]" }, /* @__PURE__ */ React200.createElement("p", { className: "text-[30px] font-semibold text-white" }, consLabel)), /* @__PURE__ */ React200.createElement("ul", { className: "mt-4 ml-[10px] space-y-2 text-[16px]" }, consList.map((con, i) => /* @__PURE__ */ React200.createElement("li", { key: `con-${i}`, className: "flex items-center gap-[18px]" }, /* @__PURE__ */ React200.createElement("img", { src: icons.cross, alt: "", className: "h-[27px] w-[27px] flex-shrink-0" }), /* @__PURE__ */ React200.createElement("span", null, con == null ? void 0 : con.tr_con)))))), isMain && /* @__PURE__ */ React200.createElement(
    "a",
    {
      href: item == null ? void 0 : item.cta_link,
      target: item.new_tab ? "_blank" : void 0,
      rel: item.new_tab ? "noopener noreferrer" : void 0,
      className: "bg-gradient-to-r from-[#f15900] to-[#ff3c1e] mx-auto mt-10 flex h-[60px] w-full max-w-[336px] items-center justify-center rounded-lg text-[20px] uppercase font-semibold text-white"
    },
    item == null ? void 0 : item.tr_cta_label
  ));
};

// src/molecules/BannerTimerBadge.tsx
import React201 from "react";
import classNames84 from "classnames";

// src/hooks/usePersistentCookieCountdown.ts
import { useEffect as useEffect14, useState as useState15 } from "react";
var DEFAULT_COOKIE_KEY = "time_left";
var DEFAULT_COOLDOWN_MS = 24 * 60 * 60 * 1e3;
var canUseCookies = () => typeof document !== "undefined";
var isStoredCountdown = (value) => {
  if (!value || typeof value !== "object") return false;
  const timer = value;
  return typeof timer.endAt === "number" && typeof timer.cooldownExpires === "number";
};
var getRemainingSeconds2 = (endAt) => Math.max(0, Math.floor((endAt - Date.now()) / 1e3));
var resolveCountdown = (durationMinutes, cookieKey, cooldownMs) => {
  const now = Date.now();
  const stored = canUseCookies() ? readCookie(cookieKey) : null;
  if (isStoredCountdown(stored) && stored.cooldownExpires > now) {
    return stored;
  }
  const countdown = {
    endAt: now + durationMinutes * 60 * 1e3,
    cooldownExpires: now + cooldownMs
  };
  if (canUseCookies()) {
    writeCookie(cookieKey, countdown, cooldownMs / 1e3);
  }
  return countdown;
};
var usePersistentCookieCountdown = ({
  durationMinutes,
  cookieKey = DEFAULT_COOKIE_KEY,
  cooldownMs = DEFAULT_COOLDOWN_MS
}) => {
  const [endAt, setEndAt] = useState15(
    () => resolveCountdown(durationMinutes, cookieKey, cooldownMs).endAt
  );
  const [remainingSeconds, setRemainingSeconds] = useState15(() => getRemainingSeconds2(endAt));
  useEffect14(() => {
    const countdown = resolveCountdown(durationMinutes, cookieKey, cooldownMs);
    setEndAt(countdown.endAt);
    setRemainingSeconds(getRemainingSeconds2(countdown.endAt));
  }, [durationMinutes, cookieKey, cooldownMs]);
  useEffect14(() => {
    const updateRemainingSeconds = () => {
      setRemainingSeconds(getRemainingSeconds2(endAt));
    };
    updateRemainingSeconds();
    const interval = window.setInterval(updateRemainingSeconds, 1e3);
    return () => window.clearInterval(interval);
  }, [endAt]);
  return {
    remainingSeconds,
    hasTimeRemaining: remainingSeconds > 0
  };
};

// src/molecules/BannerTimerBadge.tsx
function formatTime2(totalSeconds) {
  const h = Math.floor(totalSeconds / 3600).toString().padStart(2, "0");
  const m = Math.floor(totalSeconds % 3600 / 60).toString().padStart(2, "0");
  const s = (totalSeconds % 60).toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
}
var DEFAULT_CONTAINER_CLASS29 = "inline-flex items-center rounded px-2 py-1.5 [background:var(--banner-timer-badge-bg-color)] text-(--banner-timer-badge-text-color)";
var DEFAULT_TEXT_CLASS7 = "font-bold tabular-nums text-[16px]/[16px]";
var BannerTimerBadge = ({
  time,
  cookieKey,
  backgroundColor,
  textColor,
  className,
  classes = {}
}) => {
  const { remainingSeconds, hasTimeRemaining } = usePersistentCookieCountdown({
    durationMinutes: time,
    cookieKey
  });
  if (!hasTimeRemaining) return null;
  return /* @__PURE__ */ React201.createElement(
    "span",
    {
      className: classNames84(DEFAULT_CONTAINER_CLASS29, className, classes.container),
      style: {
        ...backgroundColor && { background: backgroundColor },
        ...textColor && { color: textColor }
      }
    },
    /* @__PURE__ */ React201.createElement(Text, { className: classNames84(DEFAULT_TEXT_CLASS7, classes.text) }, formatTime2(remainingSeconds))
  );
};

// src/sections/BannerTimerAndText.tsx
import React202 from "react";
import classNames85 from "classnames";
var DEFAULT_CONTAINER_CLASS30 = "w-full flex items-center justify-center gap-3 px-4 py-2 font-[Roboto,sans-serif] [background:var(--banner-timer-and-text-bg-color)]";
var DEFAULT_TEXT_CLASS8 = "font-bold text-[14px]/[16px] md:text-[18px]/[26px] text-(--banner-timer-and-text-text-color)";
var BannerTimerAndText = ({
  block,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React202.createElement(
    "section",
    {
      className: classNames85(DEFAULT_CONTAINER_CLASS30, className, classes.container),
      style: {
        "--banner-timer-and-text-bg-color": block.backgroundColor || "var(--theme-color-bg-section, #F3F4F6)",
        "--banner-timer-and-text-text-color": block.textColor || "var(--theme-color-text-primary, #333333)"
      }
    },
    block.time && /* @__PURE__ */ React202.createElement(
      BannerTimerBadge,
      {
        time: block.time,
        cookieKey: block.timerCookieKey,
        backgroundColor: block.timerBackgroundColor,
        textColor: block.timerTextColor,
        className: classes.timer
      }
    ),
    block.text && /* @__PURE__ */ React202.createElement(Text, { className: classNames85(DEFAULT_TEXT_CLASS8, classes.text) }, block.text)
  );
};

// src/molecules/LogoItem.tsx
import React203 from "react";
import classNames86 from "classnames";
var DEFAULT_CONTAINER_CLASS31 = "inline-flex items-center justify-center";
var DEFAULT_IMAGE_CLASS5 = "h-6 w-auto object-contain";
var LogoItem = ({ image, className, classes = {} }) => {
  var _a;
  if (!(image == null ? void 0 : image.url)) return null;
  return /* @__PURE__ */ React203.createElement("div", { className: classNames86(DEFAULT_CONTAINER_CLASS31, className, classes.container) }, /* @__PURE__ */ React203.createElement(
    Image,
    {
      src: image.url,
      alt: (_a = image.alt) != null ? _a : "",
      className: classNames86(DEFAULT_IMAGE_CLASS5, classes.image)
    }
  ));
};

// src/sections/BannerLogos.tsx
import React204, { useEffect as useEffect16, useRef as useRef8, useState as useState16 } from "react";

// src/helpers/useInfiniteTrackScroll.ts
import { useEffect as useEffect15 } from "react";
function useInfiniteTrackScroll({
  containerRef,
  trackRef,
  speed = 0.5,
  cycleSize = 0,
  initialOffset = 0,
  axis = "x"
}) {
  useEffect15(() => {
    const container = containerRef.current;
    const track = trackRef.current;
    if (!container || !track || cycleSize === 0) return;
    let rafId = 0;
    let pos = initialOffset;
    let isDragging = false;
    let startPointer = 0;
    let startPos = 0;
    const getPointerPosition = (event) => axis === "y" ? event.clientY : event.clientX;
    const applyTransform = (value) => {
      track.style.transform = axis === "y" ? `translateY(${value}px)` : `translateX(${value}px)`;
    };
    const normalizePosition = (value) => {
      let next = value;
      while (next <= -2 * cycleSize) next += cycleSize;
      while (next > 0) next -= cycleSize;
      return next;
    };
    const clampDragPosition = (value) => Math.min(0, Math.max(-2 * cycleSize, value));
    pos = normalizePosition(pos);
    applyTransform(pos);
    const tick = () => {
      if (!isDragging) {
        pos = normalizePosition(pos - speed);
        applyTransform(pos);
      }
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    const onPointerDown = (event) => {
      isDragging = true;
      startPointer = getPointerPosition(event);
      startPos = pos;
      container.setPointerCapture(event.pointerId);
      container.style.cursor = "grabbing";
    };
    const onPointerMove = (event) => {
      if (!isDragging) return;
      pos = clampDragPosition(startPos + (getPointerPosition(event) - startPointer));
      applyTransform(pos);
    };
    const onPointerUp = () => {
      isDragging = false;
      container.style.cursor = "";
    };
    container.addEventListener("pointerdown", onPointerDown);
    container.addEventListener("pointermove", onPointerMove);
    container.addEventListener("pointerup", onPointerUp);
    container.addEventListener("pointercancel", onPointerUp);
    return () => {
      cancelAnimationFrame(rafId);
      container.removeEventListener("pointerdown", onPointerDown);
      container.removeEventListener("pointermove", onPointerMove);
      container.removeEventListener("pointerup", onPointerUp);
      container.removeEventListener("pointercancel", onPointerUp);
    };
  }, [axis, containerRef, trackRef, speed, cycleSize, initialOffset]);
}

// src/sections/BannerLogos.tsx
var DEFAULT_SECTION_CLASS3 = "w-full p-4 md:px-4 md:py-6 [background:var(--banner-logos-bg-color)]";
var DEFAULT_VIEWPORT_CLASS = "mx-auto w-full max-w-[1100px] overflow-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden";
var DEFAULT_MOTION_VIEWPORT_CLASS = "cursor-grab select-none";
var DEFAULT_TRACK_CLASS = "flex w-max items-center will-change-transform";
var DEFAULT_STATIC_TRACK_CLASS = "mx-auto";
var DEFAULT_GROUP_CLASS2 = "flex h-10 flex-none items-center justify-center gap-12 px-6";
var DEFAULT_LOGO_ITEM_CLASS = "shrink-0";
var MOTION_SPEED_MAP = {
  slow: 0.25,
  medium: 0.5,
  fast: 1
};
var MIN_MOTION_COPIES = 3;
var BannerLogos = ({ block, className, classes = {} }) => {
  var _a, _b, _c;
  const viewportRef = useRef8(null);
  const trackRef = useRef8(null);
  const firstGroupRef = useRef8(null);
  const [cycleWidth, setCycleWidth] = useState16(0);
  const [viewportWidth, setViewportWidth] = useState16(0);
  const logos = (_b = (_a = block.logos) == null ? void 0 : _a.filter((logo) => {
    var _a2;
    return (_a2 = logo.image) == null ? void 0 : _a2.url;
  })) != null ? _b : [];
  const motionSpeed = MOTION_SPEED_MAP[(_c = block.speed) != null ? _c : "medium"];
  useEffect16(() => {
    const group = firstGroupRef.current;
    const viewport = viewportRef.current;
    if (!group || !viewport) return;
    const updateSizes = () => {
      setCycleWidth(group.offsetWidth);
      setViewportWidth(viewport.offsetWidth);
    };
    updateSizes();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateSizes);
      return () => {
        window.removeEventListener("resize", updateSizes);
      };
    }
    const observer = new ResizeObserver(updateSizes);
    observer.observe(group);
    observer.observe(viewport);
    return () => {
      observer.disconnect();
    };
  }, [logos.length]);
  const hasMeasured = cycleWidth > 0 && viewportWidth > 0;
  const shouldAnimate = hasMeasured && cycleWidth > viewportWidth;
  const copyCount = shouldAnimate ? Math.max(MIN_MOTION_COPIES, Math.ceil(viewportWidth / cycleWidth) + 2) : 1;
  const copies = Array.from({ length: copyCount }, (_, index) => index);
  useInfiniteTrackScroll({
    containerRef: viewportRef,
    trackRef,
    speed: motionSpeed,
    cycleSize: shouldAnimate ? cycleWidth : 0,
    initialOffset: shouldAnimate ? -cycleWidth : 0
  });
  if (!logos.length) return null;
  return /* @__PURE__ */ React204.createElement(
    "section",
    {
      "aria-label": "Partner logos",
      className: cn(DEFAULT_SECTION_CLASS3, className, classes.section),
      style: {
        "--banner-logos-bg-color": block.backgroundColor || "var(--theme-color-bg-section, #F3F4F6)"
      }
    },
    /* @__PURE__ */ React204.createElement(
      "div",
      {
        ref: viewportRef,
        className: cn(
          DEFAULT_VIEWPORT_CLASS,
          shouldAnimate && DEFAULT_MOTION_VIEWPORT_CLASS,
          classes.scrollWrapper,
          classes.viewport
        )
      },
      /* @__PURE__ */ React204.createElement(
        "div",
        {
          ref: trackRef,
          className: cn(
            DEFAULT_TRACK_CLASS,
            !shouldAnimate && DEFAULT_STATIC_TRACK_CLASS,
            classes.track
          )
        },
        copies.map((copyIndex) => /* @__PURE__ */ React204.createElement(
          "div",
          {
            key: copyIndex,
            ref: copyIndex === 0 ? firstGroupRef : void 0,
            className: cn(DEFAULT_GROUP_CLASS2, classes.container, classes.group),
            "aria-hidden": copyIndex > 0 || void 0
          },
          logos.map((logo, index) => {
            var _a2;
            return /* @__PURE__ */ React204.createElement(
              LogoItem,
              {
                key: `${copyIndex}-${(_a2 = logo.image) == null ? void 0 : _a2.url}-${index}`,
                image: logo.image,
                className: cn(DEFAULT_LOGO_ITEM_CLASS, classes.logoItem)
              }
            );
          })
        ))
      )
    )
  );
};

// src/molecules/MarqueeText.tsx
import React205 from "react";
import classNames87 from "classnames";
var SPEED_MAP = {
  slow: "40s",
  medium: "25s",
  fast: "15s"
};
var DEFAULT_CONTAINER_CLASS32 = "relative w-full overflow-hidden py-3";
var DEFAULT_TRACK_CLASS2 = "inline-block whitespace-nowrap will-change-transform";
var DEFAULT_TEXT_CLASS9 = "text-sm font-medium";
var MarqueeText = ({
  items,
  separator = "\u2022",
  speed = "medium",
  className,
  classes = {}
}) => {
  const joined = items.join(` ${separator} `);
  const repeated = `${joined} ${separator} ${joined} ${separator} ${joined} ${separator} `;
  const duration = SPEED_MAP[speed];
  return /* @__PURE__ */ React205.createElement(
    Container,
    {
      className: classNames87(DEFAULT_CONTAINER_CLASS32, className, classes.container),
      "aria-live": "off"
    },
    /* @__PURE__ */ React205.createElement(
      "div",
      {
        className: classNames87(DEFAULT_TRACK_CLASS2, classes.track),
        style: { animation: `marquee-text ${duration} linear infinite` }
      },
      /* @__PURE__ */ React205.createElement("span", { className: classNames87(DEFAULT_TEXT_CLASS9, classes.text) }, repeated)
    ),
    /* @__PURE__ */ React205.createElement("style", null, `
        @keyframes marquee-text {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `)
  );
};

// src/sections/BannerTextMotion.tsx
import React206 from "react";
import classNames88 from "classnames";
var DEFAULT_CONTAINER_CLASS33 = "w-full font-[Roboto,sans-serif]";
var BannerTextMotion = ({
  block,
  className,
  classes = {}
}) => {
  var _a, _b;
  const items = (_b = (_a = block.items) == null ? void 0 : _a.map((item) => item.text)) != null ? _b : [];
  if (!items.length) return null;
  return /* @__PURE__ */ React206.createElement(
    "section",
    {
      className: classNames88(DEFAULT_CONTAINER_CLASS33, className, classes.container),
      style: {
        ...block.backgroundColor && { background: block.backgroundColor },
        ...block.textColor && { color: block.textColor }
      }
    },
    /* @__PURE__ */ React206.createElement(
      MarqueeText,
      {
        items,
        separator: block.separator,
        speed: block.speed,
        classes: {
          track: classes.track,
          text: classes.text
        }
      }
    )
  );
};

// src/molecules/MarqueeImages.tsx
import React207 from "react";
import classNames89 from "classnames";
var SPEED_MAP2 = {
  slow: "45s",
  medium: "30s",
  fast: "18s"
};
var REPEAT_COUNT = 3;
var DEFAULT_CONTAINER_CLASS34 = "relative w-full overflow-hidden";
var DEFAULT_TRACK_CLASS3 = "flex w-max will-change-transform";
var DEFAULT_GROUP_CLASS3 = "flex flex-none gap-2 pr-2 md:gap-4 md:pr-4";
var DEFAULT_ITEM_CLASS6 = "size-[150px] flex-none overflow-hidden md:size-[250px]";
var DEFAULT_IMAGE_CLASS6 = "size-full object-cover";
var DEFAULT_BORDER_RADIUS_CLASS = "rounded-[10px]";
var MarqueeImages = ({
  items,
  speed = "medium",
  borderRadiusClass = DEFAULT_BORDER_RADIUS_CLASS,
  className,
  classes = {}
}) => {
  if (!items.length) return null;
  const duration = SPEED_MAP2[speed];
  const groups = Array.from({ length: REPEAT_COUNT }, (_, index) => index);
  const itemClass = classNames89(DEFAULT_ITEM_CLASS6, borderRadiusClass, classes.item);
  const imageClass = classNames89(DEFAULT_IMAGE_CLASS6, borderRadiusClass, classes.image);
  return /* @__PURE__ */ React207.createElement(
    "div",
    {
      className: classNames89(DEFAULT_CONTAINER_CLASS34, className, classes.container),
      "aria-live": "off"
    },
    /* @__PURE__ */ React207.createElement(
      "div",
      {
        className: classNames89(DEFAULT_TRACK_CLASS3, classes.track),
        style: { animation: `marquee-images ${duration} linear infinite` }
      },
      groups.map((groupIndex) => /* @__PURE__ */ React207.createElement("div", { key: groupIndex, className: DEFAULT_GROUP_CLASS3, "aria-hidden": groupIndex > 0 }, items.map((item, itemIndex) => /* @__PURE__ */ React207.createElement("div", { key: `${groupIndex}-${item.src}-${itemIndex}`, className: itemClass }, item.assetType === "video" ? /* @__PURE__ */ React207.createElement(
        Video,
        {
          src: item.src,
          ariaLabel: groupIndex === 0 ? item.alt : "",
          className: classNames89(imageClass, "aspect-auto")
        }
      ) : /* @__PURE__ */ React207.createElement(
        Image,
        {
          src: item.src,
          alt: groupIndex === 0 ? item.alt || "" : "",
          className: imageClass
        }
      )))))
    ),
    /* @__PURE__ */ React207.createElement("style", null, `
        @keyframes marquee-images {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `)
  );
};

// src/sections/SocialProofImagesMotion.tsx
import React208 from "react";

// src/sections/sectionSpacing.ts
var SECTION_SPACING_CLASSES = {
  default: "py-8 md:py-10 lg:py-14",
  none: "py-0",
  "no-top": "pt-0 pb-8 md:pb-10 lg:pb-14",
  "no-bottom": "pt-8 md:pt-10 lg:pt-14 pb-0"
};
function getSectionSpacingClass(sectionSpacing = "default") {
  return SECTION_SPACING_CLASSES[sectionSpacing];
}

// src/sections/SocialProofImagesMotion.tsx
var DEFAULT_CONTAINER_CLASS35 = "w-full";
var SocialProofImagesMotion = ({
  block,
  sectionSpacing,
  className,
  classes = {}
}) => {
  var _a, _b;
  const items = (_b = (_a = block.items) == null ? void 0 : _a.map((item) => {
    var _a2, _b2;
    const assetType = item.assetType === "video" ? "video" : "image";
    const src = assetType === "video" ? item.videoUrl : (_a2 = item.image) == null ? void 0 : _a2.url;
    if (!src) return null;
    return {
      assetType,
      src,
      alt: (_b2 = item.image) == null ? void 0 : _b2.alt
    };
  }).filter((item) => item !== null)) != null ? _b : [];
  if (!items.length) return null;
  return /* @__PURE__ */ React208.createElement(
    "section",
    {
      className: cn(
        DEFAULT_CONTAINER_CLASS35,
        getSectionSpacingClass(sectionSpacing),
        classes.container,
        className
      )
    },
    /* @__PURE__ */ React208.createElement(
      MarqueeImages,
      {
        items,
        speed: block.speed,
        borderRadiusClass: block.borderRadiusClass,
        classes: {
          track: classes.track,
          item: classes.item,
          image: classes.image
        }
      }
    )
  );
};

// src/molecules/GalleryCarousel.tsx
import React209, { useState as useState17 } from "react";
var DEFAULT_CONTAINER_CLASS36 = "flex flex-col gap-3";
var DEFAULT_FILL_CONTAINER_CLASS = "relative w-full flex flex-col sm:block sm:h-full";
var DEFAULT_MAIN_WRAPPER_CLASS = "relative w-full aspect-square rounded-lg overflow-hidden bg-white";
var DEFAULT_FILL_MAIN_WRAPPER_CLASS = "relative w-full overflow-hidden sm:h-full";
var DEFAULT_MAIN_PICTURE_CLASS = "block h-full w-full";
var DEFAULT_MAIN_ASSET_CLASS = "w-full h-[390px] sm:h-[520px] md:h-full object-cover";
var DEFAULT_MAIN_VIDEO_CLASS = "aspect-auto rounded-none";
var DEFAULT_NAV_CLASS3 = "absolute top-1/2 z-10 flex size-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-[8.67273px] border-none bg-white/50 p-0";
var DEFAULT_NAV_ICON_CLASS = "text-[#666666]";
var DEFAULT_THUMB_STRIP_CLASS = "flex flex-row gap-2 justify-center bg-white px-[10px] py-4";
var DEFAULT_THUMB_CLASS = "size-15 rounded overflow-hidden outline outline-2 cursor-pointer p-0 bg-transparent";
var DEFAULT_INACTIVE_THUMB_CLASS = "outline-transparent";
var DEFAULT_ACTIVE_THUMB_CLASS = "outline-(--gallery-active-dot)";
var DEFAULT_THUMB_PICTURE_CLASS = "block h-full w-full";
var DEFAULT_THUMB_ASSET_CLASS = "w-full h-full object-cover";
var DEFAULT_THUMB_FALLBACK_CLASS = "flex h-full w-full items-center justify-center bg-[#E5E7EB]";
var DEFAULT_DOT_BASE_CLASS = "w-[60px] h-1 rounded-[10px] border-none cursor-pointer p-0 transition-colors duration-200";
var DEFAULT_DOT_INACTIVE_CLASS = "bg-[#F5F5F5]";
var DEFAULT_ACTIVE_DOT_CLASS = "bg-(--gallery-active-dot)";
var MAX_VISIBLE_CONTROLS = 5;
var getAssetType = (asset) => {
  var _a;
  return (_a = asset.assetType) != null ? _a : "image";
};
var getVisibleControlIndexes = (total, activeIndex) => {
  if (total <= MAX_VISIBLE_CONTROLS) {
    return Array.from({ length: total }, (_, i) => i);
  }
  const maxStart = total - MAX_VISIBLE_CONTROLS;
  const start = Math.min(Math.max(activeIndex - Math.floor(MAX_VISIBLE_CONTROLS / 2), 0), maxStart);
  return Array.from({ length: MAX_VISIBLE_CONTROLS }, (_, i) => start + i);
};
var GalleryCarousel = ({
  images,
  fill = false,
  showDots = true,
  activeDotColor = "#0090CD",
  className,
  classes = {}
}) => {
  const [current, setCurrent] = useState17(0);
  if (!images.length) return null;
  const prev = () => setCurrent((c) => (c - 1 + images.length) % images.length);
  const next = () => setCurrent((c) => (c + 1) % images.length);
  const activeIndex = current >= images.length ? 0 : current;
  const activeAsset = images[activeIndex];
  const renderMainAsset = (asset) => {
    var _a, _b;
    const sharedClassName = cn(DEFAULT_MAIN_ASSET_CLASS, classes.mainAsset);
    if (getAssetType(asset) === "video") {
      return /* @__PURE__ */ React209.createElement(
        Video,
        {
          key: asset.url,
          src: asset.url,
          poster: (_a = asset.poster) != null ? _a : asset.thumbnailUrl,
          ariaLabel: asset.alt,
          className: cn(
            sharedClassName,
            classes.mainImage,
            DEFAULT_MAIN_VIDEO_CLASS,
            classes.mainVideo
          )
        }
      );
    }
    return /* @__PURE__ */ React209.createElement(
      Image,
      {
        key: asset.url,
        src: asset.url,
        alt: (_b = asset.alt) != null ? _b : "",
        sources: asset.sources,
        srcSet: asset.srcSet,
        sizes: asset.sizes,
        className: cn(sharedClassName, classes.mainImage),
        classes: { picture: cn(DEFAULT_MAIN_PICTURE_CLASS, classes.mainPicture) }
      }
    );
  };
  const renderThumbnailAsset = (asset) => {
    var _a, _b, _c;
    const sharedClassName = cn(DEFAULT_THUMB_ASSET_CLASS, classes.thumbnailAsset);
    const assetType = getAssetType(asset);
    const thumbnailUrl = (_a = asset.thumbnailUrl) != null ? _a : assetType === "video" ? asset.poster : asset.url;
    const thumbnailAlt = (_c = (_b = asset.thumbnailAlt) != null ? _b : asset.alt) != null ? _c : "";
    if (!thumbnailUrl) {
      return /* @__PURE__ */ React209.createElement(
        "span",
        {
          "aria-hidden": "true",
          className: cn(DEFAULT_THUMB_FALLBACK_CLASS, classes.thumbnailVideo)
        }
      );
    }
    return /* @__PURE__ */ React209.createElement(
      Image,
      {
        src: thumbnailUrl,
        alt: thumbnailAlt,
        className: cn(sharedClassName, classes.thumbnailImage),
        classes: { picture: cn(DEFAULT_THUMB_PICTURE_CLASS, classes.thumbnailPicture) }
      }
    );
  };
  const containerCls = cn(
    fill ? DEFAULT_FILL_CONTAINER_CLASS : DEFAULT_CONTAINER_CLASS36,
    className,
    classes.container
  );
  const mainWrapperCls = cn(
    fill ? DEFAULT_FILL_MAIN_WRAPPER_CLASS : DEFAULT_MAIN_WRAPPER_CLASS,
    classes.mainWrapper
  );
  const containerStyle = {
    "--gallery-active-dot": activeDotColor
  };
  const visibleControlIndexes = getVisibleControlIndexes(images.length, activeIndex);
  return /* @__PURE__ */ React209.createElement("div", { className: containerCls, style: containerStyle }, /* @__PURE__ */ React209.createElement("div", { className: mainWrapperCls }, renderMainAsset(activeAsset), images.length > 1 && /* @__PURE__ */ React209.createElement(React209.Fragment, null, /* @__PURE__ */ React209.createElement(
    "button",
    {
      type: "button",
      onClick: prev,
      className: cn(DEFAULT_NAV_CLASS3, "left-3", classes.navButton),
      "aria-label": "Previous media"
    },
    /* @__PURE__ */ React209.createElement(IconChevronRight, { className: cn(DEFAULT_NAV_ICON_CLASS, "rotate-180") })
  ), /* @__PURE__ */ React209.createElement(
    "button",
    {
      type: "button",
      onClick: next,
      className: cn(DEFAULT_NAV_CLASS3, "right-3", classes.navButton),
      "aria-label": "Next media"
    },
    /* @__PURE__ */ React209.createElement(IconChevronRight, { className: DEFAULT_NAV_ICON_CLASS })
  )), fill && showDots && images.length > 1 && /* @__PURE__ */ React209.createElement("div", { className: "absolute bottom-4 left-0 right-0 z-10 flex justify-center gap-2" }, visibleControlIndexes.map((i) => /* @__PURE__ */ React209.createElement(
    "button",
    {
      key: i,
      type: "button",
      onClick: () => setCurrent(i),
      className: cn(
        DEFAULT_DOT_BASE_CLASS,
        i === activeIndex ? DEFAULT_ACTIVE_DOT_CLASS : DEFAULT_DOT_INACTIVE_CLASS,
        i === activeIndex ? classes.activeDot : classes.dot
      ),
      "aria-label": `View media ${i + 1}`
    }
  )))), images.length > 1 && /* @__PURE__ */ React209.createElement("div", { className: cn(DEFAULT_THUMB_STRIP_CLASS, "sm:hidden", classes.thumbnailStrip) }, visibleControlIndexes.map((i) => /* @__PURE__ */ React209.createElement(
    "button",
    {
      key: i,
      type: "button",
      onClick: () => setCurrent(i),
      className: cn(
        DEFAULT_THUMB_CLASS,
        classes.thumbnail,
        i === activeIndex ? cn(DEFAULT_ACTIVE_THUMB_CLASS, classes.activeThumbnail) : DEFAULT_INACTIVE_THUMB_CLASS
      ),
      "aria-label": `View media ${i + 1}`
    },
    renderThumbnailAsset(images[i])
  ))));
};

// src/molecules/HeroReviewCard.tsx
import React210 from "react";
import classNames90 from "classnames";
function getStarVariant(rating) {
  if (rating >= 5) return "five";
  if (rating >= 4.5) return "fourHalf";
  if (rating >= 4) return "four";
  if (rating >= 3) return "three";
  if (rating >= 2) return "two";
  return "one";
}
var DEFAULT_CONTAINER_CLASS37 = "bg-white rounded-xl p-4 border border-[#DFDFDF] flex items-start gap-2";
var DEFAULT_AVATAR_CLASS5 = "size-10 shrink-0 rounded-full object-cover";
var DEFAULT_CONTENT_CLASS10 = "flex flex-1 flex-col gap-1";
var DEFAULT_HEADER_CLASS7 = "flex items-center justify-between";
var DEFAULT_VERIFIED_CLASS2 = "flex items-center gap-1";
var DEFAULT_VERIFIED_ICON_CLASS2 = "";
var DEFAULT_VERIFIED_LABEL_CLASS = "text-xs text-[#00B67A]";
var DEFAULT_RATING_ICON_CLASS = "max-h-3";
var DEFAULT_TITLE_CLASS12 = "text-xs text-[#666] font-bold";
var DEFAULT_TEXT_CLASS10 = "text-xs text-[#666]";
var HeroReviewCard = ({
  rating = 5,
  ratingIcon,
  authorImage,
  authorImageAlt = "",
  isVerified = false,
  verifiedLabel = "Verified customer",
  title,
  text,
  className,
  classes = {}
}) => {
  const textNode = typeof text === "string" ? /* @__PURE__ */ React210.createElement(RichText, { html: text, className: classNames90(DEFAULT_TEXT_CLASS10, classes.text) }) : text && /* @__PURE__ */ React210.createElement("div", { className: classNames90(DEFAULT_TEXT_CLASS10, classes.text) }, text);
  return /* @__PURE__ */ React210.createElement("article", { className: classNames90(DEFAULT_CONTAINER_CLASS37, className, classes.container) }, authorImage && /* @__PURE__ */ React210.createElement(
    Image,
    {
      src: authorImage,
      alt: authorImageAlt,
      className: classNames90(DEFAULT_AVATAR_CLASS5, classes.avatar)
    }
  ), /* @__PURE__ */ React210.createElement("div", { className: classNames90(DEFAULT_CONTENT_CLASS10, classes.content) }, /* @__PURE__ */ React210.createElement("div", { className: classNames90(DEFAULT_HEADER_CLASS7, classes.header) }, ratingIcon ? /* @__PURE__ */ React210.createElement(
    Image,
    {
      src: ratingIcon,
      alt: "",
      className: classNames90(DEFAULT_RATING_ICON_CLASS, classes.stars)
    }
  ) : /* @__PURE__ */ React210.createElement("div", { className: classes.stars }, STAR_SVG[getStarVariant(rating)]), isVerified && /* @__PURE__ */ React210.createElement("div", { className: classNames90(DEFAULT_VERIFIED_CLASS2, classes.verified) }, /* @__PURE__ */ React210.createElement(
    VerifiedIcon,
    {
      className: classNames90(DEFAULT_VERIFIED_ICON_CLASS2, classes.verifiedIcon)
    }
  ), /* @__PURE__ */ React210.createElement(Text, { className: classNames90(DEFAULT_VERIFIED_LABEL_CLASS, classes.verifiedLabel) }, verifiedLabel))), title && /* @__PURE__ */ React210.createElement(Text, { className: classNames90(DEFAULT_TITLE_CLASS12, classes.title) }, title), textNode));
};

// src/molecules/RatingCard.tsx
import React213 from "react";

// src/molecules/StarRating.tsx
import React211 from "react";
var TOTAL_STARS = 5;
var DEFAULT_STAR_RATING_CLASS = "flex items-center gap-1";
var StarRating2 = ({ rating, className, classes = {} }) => {
  const normalized = typeof rating === "number" ? Math.max(0, Math.min(rating, 10)) : 0;
  const starsValue = normalized / 2;
  const fullCount = Math.floor(starsValue);
  const hasHalf = starsValue - fullCount >= 0.5;
  const emptyCount = TOTAL_STARS - fullCount - (hasHalf ? 1 : 0);
  return /* @__PURE__ */ React211.createElement("div", { className: cn(DEFAULT_STAR_RATING_CLASS, classes.root, className), "aria-hidden": "true" }, Array.from({ length: fullCount }).map((_, i) => /* @__PURE__ */ React211.createElement(IconStarFull, { key: i, className: classes.star })), hasHalf && /* @__PURE__ */ React211.createElement(IconStarHalf, { className: classes.star }), Array.from({ length: emptyCount }).map((_, i) => /* @__PURE__ */ React211.createElement(IconStarEmpty, { key: i, className: classes.star })));
};

// src/molecules/TrustpilotStars.tsx
import React212 from "react";
var TOTAL_STARS2 = 5;
var DEFAULT_ROOT_CLASS26 = "flex items-center gap-0.5";
var TrustpilotStars2 = ({
  rating,
  className,
  classes = {}
}) => {
  const normalized = typeof rating === "number" ? Math.max(0, Math.min(rating, 10)) : 0;
  const fullCount = Math.floor(normalized / 2);
  const hasHalf = normalized % 2 === 1;
  const emptyCount = TOTAL_STARS2 - fullCount - (hasHalf ? 1 : 0);
  const stars = [
    ...Array(fullCount).fill("full"),
    ...hasHalf ? ["half"] : [],
    ...Array(emptyCount).fill("empty")
  ];
  return /* @__PURE__ */ React212.createElement("div", { className: cn(DEFAULT_ROOT_CLASS26, classes.root, className), "aria-hidden": "true" }, stars.map((fill, i) => /* @__PURE__ */ React212.createElement(IconTrustpilotStar, { key: i, fill, className: classes.star })));
};

// src/molecules/RatingCard.tsx
var DEFAULT_ROOT_CLASS27 = "rounded-md border border-neutral-300 bg-white p-4";
var DEFAULT_HEADER_CLASS8 = "flex items-center gap-2";
var DEFAULT_STARS_CLASS5 = "text-base leading-4 tracking-[0] text-amber-400";
var DEFAULT_NAME_CLASS3 = "text-sm font-medium leading-5 text-neutral-800";
var DEFAULT_LABEL_CLASS8 = "ml-auto text-xs font-medium not-italic leading-5 text-neutral-500";
var DEFAULT_TITLE_CLASS13 = "my-2 text-sm font-bold leading-5 text-neutral-900";
var DEFAULT_DESCRIPTION_CLASS11 = "text-sm font-normal leading-5 text-neutral-600";
var RatingCard = ({
  title,
  description,
  name,
  label,
  rating,
  isTrustpilot = false,
  className,
  classes = {}
}) => {
  const isRated = typeof rating === "number" ? Math.min(Math.max(rating, 0), 10) : void 0;
  return /* @__PURE__ */ React213.createElement("article", { className: cn(DEFAULT_ROOT_CLASS27, classes.root, className) }, /* @__PURE__ */ React213.createElement("header", { className: DEFAULT_HEADER_CLASS8 }, !!isRated && (isTrustpilot ? /* @__PURE__ */ React213.createElement(
    TrustpilotStars2,
    {
      rating: isRated,
      classes: { star: cn(DEFAULT_STARS_CLASS5, classes.stars) }
    }
  ) : /* @__PURE__ */ React213.createElement(StarRating2, { rating: isRated, className: cn(DEFAULT_STARS_CLASS5, classes.stars) })), /* @__PURE__ */ React213.createElement("strong", { className: cn(DEFAULT_NAME_CLASS3, classes.name) }, name), /* @__PURE__ */ React213.createElement("em", { className: cn(DEFAULT_LABEL_CLASS8, classes.label) }, label)), /* @__PURE__ */ React213.createElement("h3", { className: cn(DEFAULT_TITLE_CLASS13, classes.title) }, title), /* @__PURE__ */ React213.createElement("p", { className: cn(DEFAULT_DESCRIPTION_CLASS11, classes.description) }, description));
};

// src/molecules/RatingSummaryRow.tsx
import React214 from "react";
var DEFAULT_ROOT_CLASS28 = "flex flex-wrap items-center gap-2 text-sm font-normal leading-5 text-current";
var DEFAULT_RATING_CLASS2 = "font-semibold text-current";
var DEFAULT_DIVIDER_CLASS6 = "text-current";
var RatingSummaryRow = ({
  ratingValue,
  reviewsLabel,
  starRating = 9,
  isTrustpilot = false,
  className,
  classes = {}
}) => /* @__PURE__ */ React214.createElement("div", { className: cn(DEFAULT_ROOT_CLASS28, classes.root, className) }, isTrustpilot ? /* @__PURE__ */ React214.createElement(TrustpilotStars2, { rating: starRating, classes: { star: classes.stars } }) : /* @__PURE__ */ React214.createElement(StarRating2, { rating: starRating, className: classes.stars }), /* @__PURE__ */ React214.createElement("span", { className: cn(DEFAULT_RATING_CLASS2, classes.rating) }, ratingValue), reviewsLabel ? /* @__PURE__ */ React214.createElement(React214.Fragment, null, /* @__PURE__ */ React214.createElement("span", { "aria-hidden": "true", className: cn(DEFAULT_DIVIDER_CLASS6, classes.divider) }, "|"), /* @__PURE__ */ React214.createElement("span", { className: classes.reviewsLabel }, reviewsLabel)) : null);

// src/sections/HeroGalleryReview.tsx
import React215 from "react";
var STOCK_STYLES2 = {
  "in-stock": { lowLabel: "IN STOCK", fillColor: "#16A34A", lowTextColor: "#16A34A", value: 85 },
  low: { lowLabel: "LOW", fillColor: "#EC0B43", lowTextColor: "#EC0B43", value: 20 },
  "out-of-stock": {
    lowLabel: "OUT OF STOCK",
    fillColor: "#991B1B",
    lowTextColor: "#991B1B",
    value: 0
  }
};
var DEFAULT_OUTER_CLASS = "w-full [background:var(--hero-gallery-review-bg-color)]";
var DEFAULT_CONTENT_COLUMN_CLASS = "flex-1 flex flex-col justify-center gap-4 p-4 md:px-4 md:py-10 md:overflow-y-auto lg:max-w-[550px]";
var DEFAULT_INTRO_CLASS = "flex flex-col items-center gap-3 px-4 py-6 lg:items-start lg:p-0";
var DEFAULT_RATING_ROW_CLASS = "flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap";
var DEFAULT_RATING_META_CLASS = "flex items-center gap-2 flex-wrap justify-center sm:justify-start";
var DEFAULT_CUSTOMER_AVATARS_IMAGE_CLASS = "h-5 w-auto shrink-0";
var DEFAULT_TITLE_CLASS14 = "text-[32px]/[40px] md:text-[36px]/[44px] font-outfit text-center lg:text-left font-extrabold text-(--hero-primary-text-color)";
var DEFAULT_FEATURES_LIST_CLASS = "flex flex-col gap-2 list-none p-0 m-0";
var DEFAULT_FEATURE_ITEM_CLASS = "flex items-center gap-2";
var DEFAULT_FEATURE_ICON_CLASS = "size-5";
var DEFAULT_FEATURE_ICON_CIRCLE_CLASS = "text-(--feature-icon-bg-color)";
var DEFAULT_FEATURE_ICON_CHECK_CLASS = "text-(--feature-icon-color)";
var DEFAULT_FEATURE_TEXT_CLASS = "flex-1 text-[16px] font-bold leading-6 sm:text-[18px] sm:leading-[26px]";
var DEFAULT_CTA_WRAPPER_CLASS2 = "hidden lg:flex flex-col items-center gap-2 w-full md:w-[400px]";
var DEFAULT_CTA_BUTTON_CLASS2 = "transition-colors duration-200 w-full h-14 text-[20px] font-bold leading-7 rounded-[10px] font-outfit px-6 py-2.5 lg:py-3";
var DEFAULT_CTA_ICON_CLASS2 = "size-6 shrink-0";
var DEFAULT_CTA_FALLBACK_ICON_CLASS = "text-(--button-icon-color)";
var DEFAULT_SHIPPING_CLASS2 = "flex-wrap justify-center";
var DEFAULT_GALLERY_LAYOUT = "boxed";
var DEFAULT_DESKTOP_CONTENT_LAYOUT_CLASS = "lg:pl-10 lg:pr-0";
var HERO_GALLERY_LAYOUT_CLASSES = {
  "full-width": {
    outer: "flex flex-col lg:flex-row lg:min-h-[649px] lg:max-h-[649px]",
    inner: "flex flex-col lg:contents",
    gallery: "lg:w-1/2 shrink-0 overflow-hidden",
    galleryFrame: "h-full w-full overflow-hidden",
    content: DEFAULT_DESKTOP_CONTENT_LAYOUT_CLASS
  },
  boxed: {
    outer: "",
    inner: "w-full flex flex-col lg:flex-row lg:items-center lg:gap-0 lg:py-10 lg:max-w-[1300px] lg:mx-auto",
    gallery: "lg:aspect-square lg:w-[min(649px,50%)] lg:max-w-[649px]",
    galleryFrame: "h-full w-full overflow-hidden lg:rounded-2xl",
    content: DEFAULT_DESKTOP_CONTENT_LAYOUT_CLASS
  }
};
var HeroGalleryReview = ({
  block,
  cleanVersion = false,
  className,
  headingLevel: Heading2 = "h2",
  classes = {}
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  const galleryAssets = ((_a = block.galleryImages) != null ? _a : []).reduce((assets, item) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2;
    const assetType = item.assetType === "video" ? "video" : "image";
    const url = assetType === "video" ? item.videoUrl : (_a2 = item.image) == null ? void 0 : _a2.url;
    const videoThumbnailUrl = (_b2 = item.videoThumbnail) == null ? void 0 : _b2.url;
    const videoThumbnailAlt = (_c2 = item.videoThumbnail) == null ? void 0 : _c2.alt;
    if (!url) return assets;
    assets.push({
      assetType,
      url,
      alt: (_e2 = (_d2 = item.image) == null ? void 0 : _d2.alt) != null ? _e2 : videoThumbnailAlt,
      sources: assetType === "image" ? (_f2 = item.image) == null ? void 0 : _f2.sources : void 0,
      srcSet: assetType === "image" ? (_g2 = item.image) == null ? void 0 : _g2.srcSet : void 0,
      sizes: assetType === "image" ? (_h2 = item.image) == null ? void 0 : _h2.sizes : void 0,
      poster: assetType === "video" ? videoThumbnailUrl : void 0,
      thumbnailUrl: assetType === "video" ? videoThumbnailUrl : void 0,
      thumbnailAlt: videoThumbnailAlt != null ? videoThumbnailAlt : (_i2 = item.image) == null ? void 0 : _i2.alt
    });
    return assets;
  }, []);
  const hasGallery = galleryAssets.length > 0;
  const galleryLayout = (_b = block.galleryLayout) != null ? _b : DEFAULT_GALLERY_LAYOUT;
  const layoutClasses = HERO_GALLERY_LAYOUT_CLASSES[galleryLayout];
  const stock = block.stockStatus ? STOCK_STYLES2[block.stockStatus] : void 0;
  const hasCta = !!(block.cta && block.ctaLabel);
  const hasShipBy = !cleanVersion && !!(block.showShipBy && block.shipByText);
  const hasStockLevelData = !!(block.stockStatus || block.stockLevelLabel || block.stockLevel !== void 0 || block.stockLevelLowLabel);
  const hasStockLevel = !cleanVersion && !!(block.showStockLevel && hasStockLevelData);
  const hasShipping = hasShipBy || hasStockLevel;
  const featuredReview = !cleanVersion && block.showFeaturedReview !== false ? block.featuredReview : void 0;
  const ctaStyle = hasCta ? {
    "--cta-bg": (_d = (_c = block.ctaBackgroundGradient) != null ? _c : block.ctaBackgroundColor) != null ? _d : "#16A34A",
    "--button-hover-color": (_g = (_e = block.ctaBackgroundHoverGradient) != null ? _e : block.ctaBackgroundHoverColor) != null ? _g : block.ctaBackgroundGradient ? lightenGradient(block.ctaBackgroundGradient, 0.1) : lightenHex((_f = block.ctaBackgroundColor) != null ? _f : "#16A34A", 0.2),
    "--button-text-color": (_h = block.ctaTextColor) != null ? _h : "#fff",
    "--button-border-color": (_i = block.ctaBorderColor) != null ? _i : "transparent",
    "--button-icon-color": (_j = block.ctaIconColor) != null ? _j : "#9B6A00"
  } : void 0;
  const bgStyle = {
    "--hero-gallery-review-bg-color": (_k = block.backgroundColor) != null ? _k : "var(--theme-color-bg-page, transparent)",
    "--feature-icon-bg-color": (_l = block.featureIconBackgroundColor) != null ? _l : "var(--theme-color-bg-tint, #4646DA)",
    "--feature-icon-color": (_m = block.featureIconColor) != null ? _m : "var(--theme-color-accent, #FFFFFF)",
    ...block.backgroundImage && {
      backgroundImage: block.backgroundGradient ? `${block.backgroundGradient}, url(${block.backgroundImage})` : `url(${block.backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    }
  };
  const galleryOrderClass = block.reverse ? "lg:order-2" : "lg:order-1";
  const contentOrderClass = block.reverse ? "lg:order-1" : "lg:order-2";
  const renderIntro = (className2) => {
    var _a2, _b2, _c2, _d2, _e2;
    if (!block.rating && !block.title) return null;
    return /* @__PURE__ */ React215.createElement(Container, { className: cn(DEFAULT_INTRO_CLASS, className2) }, block.rating && /* @__PURE__ */ React215.createElement("div", { className: cn(DEFAULT_RATING_ROW_CLASS, classes.ratingRow) }, /* @__PURE__ */ React215.createElement(React215.Fragment, null, block.rating.showTrustpilot && !cleanVersion ? /* @__PURE__ */ React215.createElement(TrustpilotStars, { score: (_a2 = block.rating.score) != null ? _a2 : 4.8 }) : /* @__PURE__ */ React215.createElement(
      StarRating,
      {
        variant: getStarVariant(cleanVersion ? 4.5 : (_b2 = block.rating.score) != null ? _b2 : 4.8),
        size: 20,
        gap: 1.25,
        emptyColor: "#E0E0E0"
      }
    )), /* @__PURE__ */ React215.createElement("div", { className: DEFAULT_RATING_META_CLASS }, /* @__PURE__ */ React215.createElement(Text, { className: "text-sm font-semibold text-(--hero-primary-text-color)" }, (_c2 = block.rating.score) != null ? _c2 : 4.8, "/", (_d2 = block.rating.maxScore) != null ? _d2 : 5), block.rating.reviewCount && /* @__PURE__ */ React215.createElement(Text, { className: "text-sm text-[#333]" }, block.rating.reviewCount), block.rating.customerAvatarsImage && /* @__PURE__ */ React215.createElement(
      Image,
      {
        src: block.rating.customerAvatarsImage,
        alt: (_e2 = block.rating.customerAvatarsImageAlt) != null ? _e2 : "",
        className: cn(DEFAULT_CUSTOMER_AVATARS_IMAGE_CLASS, classes.customerAvatarsImage)
      }
    ))), block.title && /* @__PURE__ */ React215.createElement(Heading2, { className: cn(DEFAULT_TITLE_CLASS14, classes.title) }, block.title));
  };
  return /* @__PURE__ */ React215.createElement(React215.Fragment, null, /* @__PURE__ */ React215.createElement(
    "section",
    {
      className: cn(DEFAULT_OUTER_CLASS, layoutClasses.outer, classes.outer, className),
      style: bgStyle
    },
    /* @__PURE__ */ React215.createElement(Container, { className: cn(layoutClasses.inner, classes.inner) }, renderIntro("lg:hidden"), hasGallery && /* @__PURE__ */ React215.createElement("div", { className: cn(layoutClasses.gallery, galleryOrderClass, classes.gallery) }, /* @__PURE__ */ React215.createElement("div", { className: cn(layoutClasses.galleryFrame, classes.galleryFrame) }, /* @__PURE__ */ React215.createElement(
      GalleryCarousel,
      {
        images: galleryAssets,
        fill: true,
        showDots: (_n = block.showGalleryDots) != null ? _n : true,
        activeDotColor: (_o = block.featureIconBackgroundColor) != null ? _o : "#4646DA",
        className: cn("h-full w-full", classes.carousel)
      }
    ))), /* @__PURE__ */ React215.createElement(
      "div",
      {
        className: cn(
          DEFAULT_CONTENT_COLUMN_CLASS,
          layoutClasses.content,
          hasGallery && contentOrderClass,
          hasGallery && block.reverse && "lg:max-w-none",
          classes.content
        )
      },
      renderIntro("hidden lg:flex"),
      !!((_p = block.features) == null ? void 0 : _p.length) && /* @__PURE__ */ React215.createElement("ul", { className: cn(DEFAULT_FEATURES_LIST_CLASS, classes.featuresList) }, block.features.map((feature, i) => /* @__PURE__ */ React215.createElement("li", { key: i, className: DEFAULT_FEATURE_ITEM_CLASS }, /* @__PURE__ */ React215.createElement(
        IconCircleCheckmark,
        {
          className: DEFAULT_FEATURE_ICON_CLASS,
          classes: {
            circle: DEFAULT_FEATURE_ICON_CIRCLE_CLASS,
            check: DEFAULT_FEATURE_ICON_CHECK_CLASS
          }
        }
      ), /* @__PURE__ */ React215.createElement(RichText, { html: feature.text, className: DEFAULT_FEATURE_TEXT_CLASS })))),
      (hasCta || hasShipping) && /* @__PURE__ */ React215.createElement(
        "div",
        {
          "data-sticky-cta-trigger": "hero-gallery-review",
          className: cn(
            DEFAULT_CTA_WRAPPER_CLASS2,
            block.showCtaOnMobile && "flex",
            classes.ctaWrapper
          )
        },
        hasCta && /* @__PURE__ */ React215.createElement(
          CTAButton,
          {
            buttonText: block.ctaLabel,
            icon: block.ctaIcon || /* @__PURE__ */ React215.createElement(
              IconArrowCircleRight,
              {
                className: cn(DEFAULT_CTA_ICON_CLASS2, DEFAULT_CTA_FALLBACK_ICON_CLASS)
              }
            ),
            iconClassName: block.ctaIcon ? DEFAULT_CTA_ICON_CLASS2 : void 0,
            href: block.ctaHref,
            className: cn(DEFAULT_CTA_BUTTON_CLASS2, classes.ctaButton),
            style: ctaStyle
          }
        ),
        hasShipping && /* @__PURE__ */ React215.createElement(
          StockAndShippingLevel,
          {
            shipByText: block.shipByText,
            daysFromNow: block.daysFromNow,
            shipByLocale: block.shipByLocale,
            showShipBy: hasShipBy,
            stockLevelLabel: hasStockLevelData ? (_q = block.stockLevelLabel) != null ? _q : "Stock levels:" : void 0,
            stockLevel: (_r = block.stockLevel) != null ? _r : stock == null ? void 0 : stock.value,
            stockLevelLowLabel: (_s = block.stockLevelLowLabel) != null ? _s : stock == null ? void 0 : stock.lowLabel,
            showStockLevel: hasStockLevel,
            colors: {
              fillColor: stock == null ? void 0 : stock.fillColor,
              lowTextColor: stock == null ? void 0 : stock.lowTextColor
            },
            className: cn(DEFAULT_SHIPPING_CLASS2, classes.shipping),
            classes: {
              shipBy: classes.shipByWrapper,
              stockStatus: classes.stockLevelWrapper
            }
          }
        )
      ),
      featuredReview && /* @__PURE__ */ React215.createElement(
        HeroReviewCard,
        {
          rating: featuredReview.rating,
          ratingIcon: featuredReview.ratingIcon,
          authorImage: featuredReview.authorImage,
          authorImageAlt: featuredReview.authorImageAlt,
          isVerified: featuredReview.isVerified,
          verifiedLabel: featuredReview.verifiedLabel,
          title: featuredReview.title,
          text: featuredReview.text,
          className: cn("max-w-[510px]", classes.reviewCard)
        }
      )
    ))
  ));
};

// src/sections/StickyCtaFloaterSection.tsx
import React216, { useEffect as useEffect17, useRef as useRef9, useState as useState18 } from "react";
var DESKTOP_QUERY = "(min-width: 1024px)";
var HERO_CTA_TRIGGER_SELECTOR = '[data-sticky-cta-trigger="hero-gallery-review"]';
function useReservedBodyBottomSpace(floaterRef, enabled) {
  useEffect17(() => {
    if (!enabled || typeof document === "undefined") return void 0;
    const floater = floaterRef.current;
    if (!floater) return void 0;
    const previousPaddingBottom = document.body.style.paddingBottom;
    const basePaddingBottom = previousPaddingBottom || "0px";
    const applyPadding = () => {
      const floaterHeight = floater.getBoundingClientRect().height;
      document.body.style.paddingBottom = floaterHeight > 0 ? `calc(${basePaddingBottom} + ${Math.ceil(floaterHeight)}px)` : previousPaddingBottom;
    };
    applyPadding();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", applyPadding);
      return () => {
        window.removeEventListener("resize", applyPadding);
        document.body.style.paddingBottom = previousPaddingBottom;
      };
    }
    const resizeObserver = new ResizeObserver(applyPadding);
    resizeObserver.observe(floater);
    window.addEventListener("resize", applyPadding);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", applyPadding);
      document.body.style.paddingBottom = previousPaddingBottom;
    };
  }, [enabled, floaterRef]);
}
function isElementOutsideViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.bottom <= 0 || rect.top >= window.innerHeight;
}
function useStickyFloaterVisibility(enabled) {
  const [visible, setVisible] = useState18(true);
  useEffect17(() => {
    var _a;
    if (!enabled || typeof window === "undefined") {
      setVisible(false);
      return void 0;
    }
    const mediaQuery = window.matchMedia(DESKTOP_QUERY);
    let cleanupTriggerObserver;
    const setupTriggerObserver = () => {
      cleanupTriggerObserver == null ? void 0 : cleanupTriggerObserver();
      cleanupTriggerObserver = void 0;
      if (!mediaQuery.matches) {
        setVisible(true);
        return;
      }
      const trigger = document.querySelector(HERO_CTA_TRIGGER_SELECTOR);
      if (!trigger) {
        setVisible(true);
        return;
      }
      if (typeof IntersectionObserver === "undefined") {
        const updateFromRect = () => setVisible(isElementOutsideViewport(trigger));
        updateFromRect();
        window.addEventListener("scroll", updateFromRect, { passive: true });
        window.addEventListener("resize", updateFromRect);
        cleanupTriggerObserver = () => {
          window.removeEventListener("scroll", updateFromRect);
          window.removeEventListener("resize", updateFromRect);
        };
        return;
      }
      const observer = new IntersectionObserver(([entry]) => {
        setVisible(!entry.isIntersecting);
      });
      observer.observe(trigger);
      cleanupTriggerObserver = () => observer.disconnect();
    };
    setupTriggerObserver();
    (_a = mediaQuery.addEventListener) == null ? void 0 : _a.call(mediaQuery, "change", setupTriggerObserver);
    return () => {
      var _a2;
      cleanupTriggerObserver == null ? void 0 : cleanupTriggerObserver();
      (_a2 = mediaQuery.removeEventListener) == null ? void 0 : _a2.call(mediaQuery, "change", setupTriggerObserver);
    };
  }, [enabled]);
  return visible;
}
var StickyCtaFloaterSection = ({
  cta = true,
  ctaLabel,
  ctaHref,
  ctaBackgroundColor,
  ctaBackgroundGradient,
  ctaBackgroundHoverColor,
  ctaBackgroundHoverGradient,
  ctaTextColor,
  ctaBorderColor,
  ctaIconColor,
  cleanVersion = false,
  showShipBy = true,
  shipByText,
  daysFromNow,
  shipByLocale,
  shipTextColor,
  shipStatusTextColor,
  showStockLevel = true,
  stockLevelLabel,
  stockLevel,
  stockLevelLowLabel,
  stockStatus,
  backgroundColor,
  ariaLabel,
  reserveBottomSpace = true,
  className,
  classes = {}
}) => {
  const floaterRef = useRef9(null);
  const hasCta = !!(cta && ctaLabel);
  const hasShipBy = !cleanVersion && !!(showShipBy && shipByText);
  const hasStockLevelData = !!(stockStatus || stockLevelLabel || stockLevel !== void 0 || stockLevelLowLabel);
  const hasStockLevel = !cleanVersion && !!(showStockLevel && hasStockLevelData);
  const hasFloaterContent = hasCta || hasShipBy || hasStockLevel;
  const isFloaterVisible = useStickyFloaterVisibility(hasFloaterContent);
  useReservedBodyBottomSpace(
    floaterRef,
    reserveBottomSpace && hasFloaterContent && isFloaterVisible
  );
  if (!hasFloaterContent || !isFloaterVisible) return null;
  return /* @__PURE__ */ React216.createElement(
    StickyCtaFloater,
    {
      ref: floaterRef,
      ctaButton: hasCta ? {
        text: ctaLabel,
        url: ctaHref,
        backgroundColor: ctaBackgroundColor,
        backgroundGradient: ctaBackgroundGradient,
        backgroundHoverColor: ctaBackgroundHoverColor,
        backgroundHoverGradient: ctaBackgroundHoverGradient,
        textColor: ctaTextColor,
        borderColor: ctaBorderColor,
        iconColor: ctaIconColor
      } : void 0,
      shippingInfo: hasShipBy || hasStockLevel ? {
        shipBy: shipByText,
        daysFromNow,
        shipByLocale,
        showShipBy: hasShipBy,
        stockLevelLabel: hasStockLevelData ? stockLevelLabel != null ? stockLevelLabel : "Stock levels:" : void 0,
        stockLevel: stockStatus,
        stockLevelValue: stockLevel,
        stockLowLabel: stockLevelLowLabel,
        showStockLevel: hasStockLevel,
        textColor: shipTextColor,
        statusTextColor: shipStatusTextColor
      } : void 0,
      backgroundColor,
      ariaLabel,
      className,
      classes
    }
  );
};

// src/sections/interfaces/StickyCtaFloaterSection.ts
var defaultStickyCtaFloaterSectionBlock = {
  cta: true,
  ctaLabel: "Order Now & Save 70% OFF",
  ctaHref: "#",
  ctaBackgroundGradient: "linear-gradient(to bottom, #FFCD5A, #FFE65B)",
  ctaTextColor: "#000000",
  ctaBorderColor: "#D39208",
  ctaIconColor: "#9B6A00",
  showShipBy: true,
  shipByText: "Ship by {date}",
  daysFromNow: 2,
  shipByLocale: "en-GB",
  showStockLevel: true,
  stockStatus: "low",
  backgroundColor: "#E7F4FD",
  reserveBottomSpace: true
};

// src/sections/ProductBenefitsSection.tsx
import React217 from "react";
var DEFAULT_SECTION_CLASS4 = "w-full [background:var(--product-benefits-bg)] px-4 py-8 md:py-6 lg:py-8";
var DEFAULT_INNER_CLASS4 = "mx-auto flex max-w-body flex-col items-center gap-8";
var DEFAULT_GRID_CLASS = "flex w-full flex-wrap justify-center gap-x-6 gap-y-8 lg:gap-x-14";
var DEFAULT_ITEM_CLASS7 = "flex max-w-[130px] flex-none flex-col items-center gap-2 text-center lg:w-[130px] lg:max-w-[130px]";
var DEFAULT_TWO_COLUMN_ITEM_CLASS = "w-[calc((100%-1.5rem)/2)]";
var DEFAULT_THREE_COLUMN_ITEM_CLASS = "w-[calc((100%-3rem)/3)] md:max-w-none";
var DEFAULT_ICON_CLASS27 = "size-10 md:size-15 object-contain";
var DEFAULT_TEXT_CLASS11 = "whitespace-normal text-center text-[12px] leading-[18px] font-medium text-(--product-benefits-text) md:text-[14px] md:leading-[20px]";
var DEFAULT_SUBHEADING_CLASS2 = "text-(--product-benefits-text)";
var DEFAULT_DIVIDER_CLASS7 = "bg-(--product-benefits-accent)";
function buildVars({
  sectionBgColor,
  textColor,
  accentColor
}) {
  return {
    "--product-benefits-bg": sectionBgColor != null ? sectionBgColor : "var(--theme-color-bg-page, #FFFFFF)",
    "--product-benefits-text": textColor != null ? textColor : "var(--theme-color-text-primary, #333333)",
    "--product-benefits-accent": accentColor != null ? accentColor : "var(--theme-color-accent, #0075A7)"
  };
}
var ProductBenefitsSection = ({
  heading,
  headingHtml,
  headingAs = "h2",
  showDivider = true,
  showSubheading = true,
  subheadingPlacement,
  subheading,
  benefits = [],
  sectionBgColor,
  textColor,
  accentColor,
  className,
  classes = {}
}) => {
  const sectionClass = cn(DEFAULT_SECTION_CLASS4, className, classes.section);
  const innerClass = cn(DEFAULT_INNER_CLASS4, classes.inner);
  const gridClass = cn(DEFAULT_GRID_CLASS, classes.grid);
  const itemWidthClass = benefits.length > 0 && benefits.length <= 4 ? DEFAULT_TWO_COLUMN_ITEM_CLASS : DEFAULT_THREE_COLUMN_ITEM_CLASS;
  const itemClass = cn(DEFAULT_ITEM_CLASS7, itemWidthClass, classes.item);
  const iconClass = cn(DEFAULT_ICON_CLASS27, classes.icon);
  const textClass = cn(DEFAULT_TEXT_CLASS11, classes.text);
  return /* @__PURE__ */ React217.createElement("section", { className: sectionClass, style: buildVars({ sectionBgColor, textColor, accentColor }) }, /* @__PURE__ */ React217.createElement("div", { className: innerClass }, /* @__PURE__ */ React217.createElement(
    SectionHeader,
    {
      heading,
      headingHtml,
      headingAs,
      subheading: showSubheading ? subheading : void 0,
      subheadingPlacement,
      showDivider,
      className: classes.header,
      classes: {
        heading: classes.heading,
        subheading: cn(DEFAULT_SUBHEADING_CLASS2, classes.subheading),
        divider: cn(DEFAULT_DIVIDER_CLASS7, classes.divider)
      }
    }
  ), benefits.length > 0 && /* @__PURE__ */ React217.createElement("ul", { className: gridClass }, benefits.map((benefit, index) => /* @__PURE__ */ React217.createElement("li", { key: `${benefit.text}-${index}`, className: itemClass }, /* @__PURE__ */ React217.createElement(Icon, { src: benefit.icon, alt: benefit.iconAlt || "", className: iconClass }), /* @__PURE__ */ React217.createElement(Text, { as: "span", className: textClass }, benefit.text))))));
};

// src/sections/ReviewsSmallImagesVertical.tsx
import React236, { useState as useState22 } from "react";

// src/organisms/reviews/ReviewsScoreSummary.tsx
import React222 from "react";

// src/helpers/ratings.ts
function getStarVariant2(rating) {
  if (rating >= 5) return "five";
  if (rating >= 4.5) return "fourHalf";
  if (rating >= 4) return "four";
  if (rating >= 3) return "three";
  if (rating >= 2) return "two";
  return "one";
}

// src/molecules/reviews/RatingBreakdown.tsx
import React219 from "react";

// src/molecules/reviews/RatingBreakdownRow.tsx
import React218 from "react";
var DEFAULT_ROW_CLASS2 = "flex min-w-0 items-center";
var DEFAULT_LABEL_CLASS9 = "mr-2 inline-flex min-w-[22px] shrink-0 items-center whitespace-nowrap";
var DEFAULT_LABEL_NUMBER_CLASS = "relative top-px text-[12px] font-normal leading-3 text-[#333333]";
var DEFAULT_LABEL_ICON_CLASS = "ml-0.5 h-3 w-3 text-[#FFCB13]";
var DEFAULT_BAR_CLASS = "mr-2 h-3 min-w-0 flex-1";
var DEFAULT_COUNT_CLASS2 = "min-w-[40px] shrink-0 whitespace-nowrap text-right text-[12px] font-normal leading-4 text-[#333333]";
var RatingBreakdownRow = ({
  rating,
  count,
  percent = 0,
  ratingIcon,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React218.createElement("div", { className: cn(DEFAULT_ROW_CLASS2, className, classes.row) }, /* @__PURE__ */ React218.createElement("div", { className: cn(DEFAULT_LABEL_CLASS9, classes.label) }, /* @__PURE__ */ React218.createElement(Text, { as: "span", className: cn(DEFAULT_LABEL_NUMBER_CLASS, classes.labelNumber) }, rating), ratingIcon ? /* @__PURE__ */ React218.createElement(
    Icon,
    {
      src: ratingIcon,
      alt: "",
      className: cn(DEFAULT_LABEL_ICON_CLASS, classes.labelIcon)
    }
  ) : /* @__PURE__ */ React218.createElement(IconReviewSingleStar, { className: cn(DEFAULT_LABEL_ICON_CLASS, classes.labelIcon) })), /* @__PURE__ */ React218.createElement(
    ScoreBar,
    {
      percent,
      className: cn(DEFAULT_BAR_CLASS, classes.bar),
      classes: { fill: classes.barFill }
    }
  ), /* @__PURE__ */ React218.createElement(Text, { as: "span", className: cn(DEFAULT_COUNT_CLASS2, classes.count) }, count.toLocaleString("en-US")));
};

// src/molecules/reviews/RatingBreakdown.tsx
var DEFAULT_CONTAINER_CLASS38 = "flex min-w-0 w-full flex-col gap-2";
var RatingBreakdown = ({
  items = [],
  totalReviews = 0,
  ratingIcon,
  className,
  classes = {}
}) => {
  if (items.length === 0) {
    return null;
  }
  const containerClass = cn(DEFAULT_CONTAINER_CLASS38, className, classes.container);
  const maxCount = Math.max(...items.map((item) => item.count), 0);
  const baseCount = totalReviews > 0 ? totalReviews : maxCount;
  const orderedItems = [...items].sort((left, right) => right.rating - left.rating);
  return /* @__PURE__ */ React219.createElement("div", { className: containerClass }, orderedItems.map((item, index) => {
    var _a, _b;
    return /* @__PURE__ */ React219.createElement(
      RatingBreakdownRow,
      {
        key: `${(_a = item.rating) != null ? _a : "rating"}-${index}`,
        rating: item.rating,
        count: item.count,
        percent: (_b = item.percent) != null ? _b : baseCount > 0 ? item.count / baseCount * 100 : 0,
        ratingIcon,
        classes: {
          row: classes.row,
          label: classes.label,
          labelNumber: classes.labelNumber,
          labelIcon: classes.labelIcon,
          bar: classes.track,
          barFill: classes.fill,
          count: classes.count
        }
      }
    );
  }));
};

// src/molecules/reviews/RecommendationCriteria.tsx
import React221 from "react";

// src/molecules/reviews/RecommendationCriteriaRow.tsx
import React220 from "react";
var DEFAULT_ROW_CLASS3 = "flex min-w-0 items-center";
var DEFAULT_LABEL_CLASS10 = "mr-4 min-w-[100px] shrink-0 whitespace-nowrap text-[12px] font-normal leading-3 text-[#666666]";
var DEFAULT_BAR_CLASS2 = "h-3 min-w-0 flex-1";
var RecommendationCriteriaRow = ({
  label,
  percent = 0,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React220.createElement("div", { className: cn(DEFAULT_ROW_CLASS3, className, classes.row) }, /* @__PURE__ */ React220.createElement(Text, { as: "span", className: cn(DEFAULT_LABEL_CLASS10, classes.label) }, label), /* @__PURE__ */ React220.createElement(
    ScoreBar,
    {
      percent,
      className: cn(DEFAULT_BAR_CLASS2, classes.bar),
      classes: { fill: classes.barFill }
    }
  ));
};

// src/molecules/reviews/RecommendationCriteria.tsx
var DEFAULT_CONTAINER_CLASS39 = "mt-3 flex min-w-0 flex-col gap-3";
var RecommendationCriteria = ({
  items = [],
  className,
  classes = {}
}) => {
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React221.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS39, className, classes.container) }, items.map((item, index) => {
    var _a;
    return /* @__PURE__ */ React221.createElement(
      RecommendationCriteriaRow,
      {
        key: `${(_a = item.label) != null ? _a : "criteria"}-${index}`,
        label: item.label,
        percent: item.percent,
        classes: {
          row: classes.row,
          label: classes.label,
          bar: classes.track,
          barFill: classes.fill
        }
      }
    );
  }));
};

// src/organisms/reviews/ReviewsScoreSummary.tsx
var DEFAULT_SECTION_CLASS5 = "mt-8 w-full border-[#F0F0F0] py-6 md:mt-10";
var DEFAULT_GRID_CLASS2 = "flex flex-col items-center gap-y-6 md:flex-row md:flex-wrap md:items-center md:gap-x-4 lg:flex-nowrap lg:gap-x-6";
var DEFAULT_SUMMARY_CLASS = "flex w-[98px] shrink-0 flex-col items-center justify-center gap-2 text-center";
var DEFAULT_AVERAGE_RATING_CLASS = "text-center text-[56px]/[46px] font-outfit font-semibold text-[#111111]";
var DEFAULT_STARS_CLASS6 = "mt-2 flex justify-center";
var DEFAULT_RATING_LABEL_CLASS = "whitespace-nowrap text-[16px] font-normal leading-4 text-[#666666]";
var DEFAULT_DIVIDER_CLASS8 = "hidden h-[92px] w-0 border-l border-[#F0F0F0] bg-transparent md:block lg:h-[98px]";
var DEFAULT_BREAKDOWN_CLASS = "min-w-0 w-full shrink-0 md:w-[184px] lg:w-[311px]";
var DEFAULT_RECOMMENDATION_CLASS = "flex min-w-0 w-full shrink-0 flex-col md:w-[374px] lg:w-[443px]";
var DEFAULT_RECOMMENDATION_TEXT_CLASS = "border-b border-[#F0F0F0] pb-3 text-[12px] font-normal leading-4 text-[#333333] lg:whitespace-nowrap lg:text-[16px] lg:leading-4";
var DEFAULT_WRITE_REVIEW_BUTTON_CLASS = "w-full border-t border-[#F0F0F0] pt-4 text-[14px] font-normal leading-5 text-[#333333] transition-opacity hover:opacity-70 md:pt-6 lg:w-[104px] lg:shrink-0 lg:border-t-0 lg:pt-0";
var DEFAULT_WRITE_REVIEW_BUTTON_CONTENT_CLASS = "inline-flex items-center cursor-pointer justify-center gap-2 whitespace-nowrap";
var DEFAULT_WRITE_REVIEW_ICON_CLASS = "h-4 w-4";
var DEFAULT_DESKTOP_BUTTON_DIVIDER_CLASS = "hidden h-[98px] w-0 border-l border-[#F0F0F0] bg-transparent lg:block";
var ReviewsScoreSummary = ({
  averageRating = 0,
  totalReviews = 0,
  reviewLabel = "reviews",
  ratingBreakdown = [],
  recommendationText,
  recommendationCriteria = [],
  writeReviewText = "Write Review",
  onWriteReview,
  writeReviewIcon,
  ratingStarIcon,
  className,
  classes = {}
}) => {
  const showBreakdown = ratingBreakdown.length > 0;
  const showRecommendation = Boolean(recommendationText || recommendationCriteria.length > 0);
  return /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_SECTION_CLASS5, className, classes.section) }, /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_GRID_CLASS2, classes.grid) }, /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_SUMMARY_CLASS, classes.summary) }, /* @__PURE__ */ React222.createElement(Text, { className: cn(DEFAULT_AVERAGE_RATING_CLASS, classes.averageRating) }, averageRating.toFixed(1)), /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_STARS_CLASS6, classes.stars) }, STAR_SVG[getStarVariant2(averageRating)]), /* @__PURE__ */ React222.createElement(Text, { className: cn(DEFAULT_RATING_LABEL_CLASS, classes.ratingLabel) }, totalReviews.toLocaleString("en-US"), " ", reviewLabel)), showBreakdown && /* @__PURE__ */ React222.createElement(React222.Fragment, null, /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS8, classes.divider) }), /* @__PURE__ */ React222.createElement(
    RatingBreakdown,
    {
      items: ratingBreakdown,
      totalReviews,
      ratingIcon: ratingStarIcon,
      className: DEFAULT_BREAKDOWN_CLASS,
      classes: classes.ratingBreakdown
    }
  )), showRecommendation && /* @__PURE__ */ React222.createElement(React222.Fragment, null, /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS8, classes.divider) }), /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_RECOMMENDATION_CLASS, classes.recommendation) }, recommendationText && /* @__PURE__ */ React222.createElement(
    RichText,
    {
      html: recommendationText,
      className: cn(DEFAULT_RECOMMENDATION_TEXT_CLASS, classes.recommendationText)
    }
  ), /* @__PURE__ */ React222.createElement(
    RecommendationCriteria,
    {
      items: recommendationCriteria,
      classes: classes.recommendationCriteria
    }
  ))), writeReviewText && /* @__PURE__ */ React222.createElement(React222.Fragment, null, /* @__PURE__ */ React222.createElement("div", { className: cn(DEFAULT_DESKTOP_BUTTON_DIVIDER_CLASS, classes.divider) }), /* @__PURE__ */ React222.createElement(
    Button,
    {
      type: "button",
      onClick: onWriteReview,
      icon: writeReviewIcon ? /* @__PURE__ */ React222.createElement(Icon, { src: writeReviewIcon, alt: "" }) : /* @__PURE__ */ React222.createElement(IconReviewPlus, null),
      contentClassName: DEFAULT_WRITE_REVIEW_BUTTON_CONTENT_CLASS,
      iconClassName: cn(DEFAULT_WRITE_REVIEW_ICON_CLASS, classes.writeReviewIcon),
      className: cn(DEFAULT_WRITE_REVIEW_BUTTON_CLASS, classes.writeReviewButton)
    },
    /* @__PURE__ */ React222.createElement("span", null, writeReviewText)
  ))));
};

// src/organisms/reviews/ReviewsVerticalList.tsx
import React229, { useState as useState20 } from "react";

// src/organisms/reviews/ReviewsVerticalCard.tsx
import React228 from "react";

// src/molecules/reviews/ReviewHelpful.tsx
import React223, { useState as useState19 } from "react";
var DEFAULT_CONTAINER_CLASS40 = "mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] font-normal leading-4 text-[#333333]";
var DEFAULT_LABEL_CLASS11 = "";
var DEFAULT_ACTION_CLASS = "inline-flex appearance-none items-center border-0 bg-transparent p-0 text-[#333333] transition-opacity hover:opacity-75";
var DEFAULT_ACTION_ICON_CLASS = "h-3 w-3 shrink-0 cursor-pointer";
var DEFAULT_COUNT_CLASS3 = "ml-0.5 text-[12px] font-normal leading-4";
var INACTIVE_ICON_COLOR = "#F0F0F0";
var ACTIVE_ICON_COLOR = "#53A179";
var ReviewHelpful = ({
  helpfulLabel,
  helpfulYesCount,
  helpfulNoCount,
  className,
  classes = {}
}) => {
  const [vote, setVote] = useState19(null);
  const yesCount = (helpfulYesCount != null ? helpfulYesCount : 0) + (vote === "yes" ? 1 : 0);
  const noCount = (helpfulNoCount != null ? helpfulNoCount : 0) + (vote === "no" ? 1 : 0);
  if (!helpfulLabel && helpfulYesCount === void 0 && helpfulNoCount === void 0) {
    return null;
  }
  return /* @__PURE__ */ React223.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS40, className, classes.container) }, helpfulLabel && /* @__PURE__ */ React223.createElement(Text, { as: "span", className: cn(DEFAULT_LABEL_CLASS11, classes.label) }, helpfulLabel), /* @__PURE__ */ React223.createElement(
    "button",
    {
      type: "button",
      "aria-label": "Mark review as helpful",
      "aria-pressed": vote === "yes",
      onClick: () => setVote((currentVote) => currentVote === "yes" ? null : "yes"),
      className: cn(DEFAULT_ACTION_CLASS, classes.action, classes.positive)
    },
    /* @__PURE__ */ React223.createElement(
      Like_default,
      {
        color: vote === "yes" ? ACTIVE_ICON_COLOR : INACTIVE_ICON_COLOR,
        title: "",
        className: cn(DEFAULT_ACTION_ICON_CLASS, classes.actionIcon)
      }
    ),
    /* @__PURE__ */ React223.createElement(Text, { as: "span", className: DEFAULT_COUNT_CLASS3 }, yesCount)
  ), /* @__PURE__ */ React223.createElement(
    "button",
    {
      type: "button",
      "aria-label": "Mark review as not helpful",
      "aria-pressed": vote === "no",
      onClick: () => setVote((currentVote) => currentVote === "no" ? null : "no"),
      className: cn(DEFAULT_ACTION_CLASS, classes.action, classes.negative)
    },
    /* @__PURE__ */ React223.createElement(
      Like_default,
      {
        color: vote === "no" ? ACTIVE_ICON_COLOR : INACTIVE_ICON_COLOR,
        variant: "down",
        title: "",
        className: cn(DEFAULT_ACTION_ICON_CLASS, classes.actionIcon)
      }
    ),
    /* @__PURE__ */ React223.createElement(Text, { as: "span", className: DEFAULT_COUNT_CLASS3 }, noCount)
  ));
};

// src/molecules/reviews/ReviewIdentity.tsx
import React224 from "react";
var DEFAULT_CONTAINER_CLASS41 = "flex items-center";
var DEFAULT_AVATAR_CLASS6 = "h-12 w-12 text-[18px] leading-6 md:h-[60px] md:w-[60px]";
var DEFAULT_CONTENT_CLASS11 = "ml-2 flex min-w-0 flex-col";
var DEFAULT_NAME_CLASS4 = "text-[18px] font-bold leading-6 text-[#333333]";
var DEFAULT_VERIFIED_CLASS3 = "mt-1 inline-flex items-center gap-1 text-[12px] font-normal leading-4 text-[#53A179]";
var DEFAULT_VERIFIED_ICON_CLASS3 = "h-3 w-3";
var ReviewIdentity = ({
  name,
  avatar,
  avatarAlt,
  initials,
  verified = false,
  verifiedLabel,
  verifiedIcon,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React224.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS41, className, classes.container) }, /* @__PURE__ */ React224.createElement(
    Avatar,
    {
      src: avatar,
      alt: avatarAlt || name,
      name,
      initials,
      className: cn(DEFAULT_AVATAR_CLASS6, classes.avatar),
      classes: { fallback: classes.fallback }
    }
  ), /* @__PURE__ */ React224.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS11, classes.content) }, /* @__PURE__ */ React224.createElement(Text, { className: cn(DEFAULT_NAME_CLASS4, classes.name) }, name), !verified && verifiedLabel && /* @__PURE__ */ React224.createElement("div", { className: cn(DEFAULT_VERIFIED_CLASS3, classes.verified) }, verifiedIcon ? /* @__PURE__ */ React224.createElement(
    Icon,
    {
      src: verifiedIcon,
      alt: "",
      className: cn(DEFAULT_VERIFIED_ICON_CLASS3, classes.verifiedIcon)
    }
  ) : /* @__PURE__ */ React224.createElement(VerifiedIcon, { className: cn(DEFAULT_VERIFIED_ICON_CLASS3, classes.verifiedIcon) }), /* @__PURE__ */ React224.createElement(Text, { as: "span" }, verifiedLabel))));
};

// src/molecules/reviews/ReviewImageList.tsx
import React225 from "react";
var DEFAULT_CONTAINER_CLASS42 = "mt-2 flex flex-wrap";
var DEFAULT_IMAGE_CLASS7 = "h-[100px] w-[100px] object-cover";
var ReviewImageList = ({
  images = [],
  reviewerName = "Reviewer",
  className,
  classes = {}
}) => {
  if (images.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React225.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS42, className, classes.container) }, images.map((image, index) => {
    var _a, _b;
    return /* @__PURE__ */ React225.createElement(
      Image,
      {
        key: (_b = image.id) != null ? _b : `${image.src}-${(_a = image.alt) != null ? _a : ""}`,
        src: image.src,
        alt: image.alt || `${reviewerName} review image ${index + 1}`,
        className: cn(DEFAULT_IMAGE_CLASS7, index < images.length - 1 && "mr-2", classes.image)
      }
    );
  }));
};

// src/molecules/reviews/ReviewRatingDate.tsx
import React226 from "react";
var DEFAULT_ROW_CONTAINER_CLASS = "flex items-center justify-between";
var DEFAULT_COLUMN_CONTAINER_CLASS = "flex flex-col items-center justify-between";
var DEFAULT_STARS_CLASS7 = "";
var DEFAULT_DATE_CLASS = "text-[14px] font-normal leading-5 text-[#333333]";
var ReviewRatingDate = ({
  rating = 5,
  dateLabel,
  position = "row",
  showStars = true,
  showDate = true,
  className,
  classes = {}
}) => {
  const containerClass = cn(
    position === "column" ? DEFAULT_COLUMN_CONTAINER_CLASS : DEFAULT_ROW_CONTAINER_CLASS,
    className,
    classes.container
  );
  return /* @__PURE__ */ React226.createElement("div", { className: containerClass }, showStars && /* @__PURE__ */ React226.createElement("div", { className: cn(DEFAULT_STARS_CLASS7, classes.stars) }, STAR_SVG[getStarVariant2(rating)]), showDate && dateLabel && /* @__PURE__ */ React226.createElement(DateText, { date: dateLabel, className: cn(DEFAULT_DATE_CLASS, classes.date) }));
};

// src/molecules/reviews/ReviewRecommendation.tsx
import React227 from "react";
var DEFAULT_CONTAINER_CLASS43 = "mt-4 inline-flex items-center";
var DEFAULT_ICON_CLASS28 = "mr-2 h-[14px] w-[14px]";
var DEFAULT_TEXT_CLASS12 = "text-[16px] font-normal leading-5 text-[#333333]";
var DEFAULT_ICON_COLOR = "#53A179";
var ReviewRecommendation = ({
  label,
  className,
  classes = {}
}) => {
  if (!label) {
    return null;
  }
  return /* @__PURE__ */ React227.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS43, className, classes.container) }, /* @__PURE__ */ React227.createElement(
    Like_default,
    {
      color: DEFAULT_ICON_COLOR,
      size: 14,
      title: "",
      className: cn(DEFAULT_ICON_CLASS28, classes.icon)
    }
  ), /* @__PURE__ */ React227.createElement(Text, { as: "span", className: cn(DEFAULT_TEXT_CLASS12, classes.text) }, label));
};

// src/organisms/reviews/ReviewsVerticalCard.tsx
var DEFAULT_CARD_CLASS4 = "w-full border-b border-[#F0F0F0]";
var DEFAULT_WRAPPER_CLASS8 = "flex flex-col py-4 md:grid md:grid-cols-[210px_minmax(0,1fr)_auto] md:gap-x-6 md:py-6";
var DEFAULT_SIDE_CLASS = "md:col-start-1 md:row-span-4 md:w-[210px]";
var DEFAULT_SIDE_TOP_CLASS = "flex items-center";
var DEFAULT_MOBILE_RATING_DATE_CLASS = "ml-auto md:hidden";
var DEFAULT_CONTENT_CLASS12 = "md:col-start-2 md:min-w-0";
var DEFAULT_DESKTOP_STARS_CLASS = "hidden h-4 md:col-start-2 md:flex md:items-center";
var DEFAULT_DESKTOP_DATE_CLASS = "hidden h-4 md:col-start-3 md:flex md:items-center md:justify-end";
var DEFAULT_REVIEW_CLASS = "mt-4 flex flex-col gap-2";
var DEFAULT_TITLE_CLASS15 = "text-[18px] font-bold leading-6 text-[#333333]";
var DEFAULT_DESCRIPTION_CLASS12 = "text-[14px] font-normal leading-5 text-[#666666] md:text-[16px] md:leading-6";
var ReviewsVerticalCard = ({
  review,
  verifiedLabel,
  recommendLabel,
  helpfulLabel,
  cleanVersion = false,
  className,
  classes = {}
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const displayedVerifiedLabel = review.verified === false ? void 0 : (_a = review.verifiedLabel) != null ? _a : verifiedLabel;
  const displayedRecommendLabel = (_b = review.recommendLabel) != null ? _b : recommendLabel;
  const displayedHelpfulLabel = (_c = review.helpfulLabel) != null ? _c : helpfulLabel;
  return /* @__PURE__ */ React228.createElement("article", { className: cn(DEFAULT_CARD_CLASS4, className, classes.card) }, /* @__PURE__ */ React228.createElement("div", { className: cn(DEFAULT_WRAPPER_CLASS8, classes.wrapper) }, /* @__PURE__ */ React228.createElement("div", { className: cn(DEFAULT_SIDE_CLASS, classes.side) }, /* @__PURE__ */ React228.createElement("div", { className: cn(DEFAULT_SIDE_TOP_CLASS, classes.sideTop) }, /* @__PURE__ */ React228.createElement(
    ReviewIdentity,
    {
      name: review.name,
      avatar: review.avatar,
      avatarAlt: review.avatarAlt,
      initials: review.initials,
      verified: cleanVersion,
      verifiedLabel: displayedVerifiedLabel,
      className: (_d = classes.identity) == null ? void 0 : _d.container,
      classes: classes.identity
    }
  ), /* @__PURE__ */ React228.createElement(
    ReviewRatingDate,
    {
      rating: review.rating,
      dateLabel: review.dateLabel,
      position: "column",
      className: DEFAULT_MOBILE_RATING_DATE_CLASS,
      classes: {
        ...classes.mobileRatingDate,
        date: cn("self-end", (_e = classes.mobileRatingDate) == null ? void 0 : _e.date)
      }
    }
  )), /* @__PURE__ */ React228.createElement(
    ReviewRecommendation,
    {
      label: review.recommendsProduct !== false ? displayedRecommendLabel : void 0,
      className: (_f = classes.recommend) == null ? void 0 : _f.container,
      classes: classes.recommend
    }
  )), /* @__PURE__ */ React228.createElement(
    ReviewRatingDate,
    {
      rating: review.rating,
      showDate: false,
      className: DEFAULT_DESKTOP_STARS_CLASS,
      classes: classes.desktopRatingDate
    }
  ), /* @__PURE__ */ React228.createElement(
    ReviewRatingDate,
    {
      dateLabel: review.dateLabel,
      showStars: false,
      className: DEFAULT_DESKTOP_DATE_CLASS,
      classes: classes.desktopRatingDate
    }
  ), /* @__PURE__ */ React228.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS12, classes.content) }, /* @__PURE__ */ React228.createElement("div", { className: cn(DEFAULT_REVIEW_CLASS, classes.review) }, review.title && /* @__PURE__ */ React228.createElement(Text, { as: "h3", className: cn(DEFAULT_TITLE_CLASS15, classes.title) }, review.title), review.description && /* @__PURE__ */ React228.createElement(
    RichText,
    {
      html: review.description,
      className: cn(DEFAULT_DESCRIPTION_CLASS12, classes.description)
    }
  )), /* @__PURE__ */ React228.createElement(
    ReviewImageList,
    {
      images: review.images,
      reviewerName: review.name,
      className: (_g = classes.images) == null ? void 0 : _g.container,
      classes: classes.images
    }
  ), /* @__PURE__ */ React228.createElement(
    ReviewHelpful,
    {
      helpfulLabel: displayedHelpfulLabel,
      helpfulYesCount: review.helpfulYesCount,
      helpfulNoCount: review.helpfulNoCount,
      className: (_h = classes.helpful) == null ? void 0 : _h.container,
      classes: classes.helpful
    }
  ))));
};

// src/organisms/reviews/ReviewsVerticalList.tsx
var DEFAULT_CONTAINER_CLASS44 = "mb-8 w-full border-t border-[#F0F0F0]";
var DEFAULT_LOAD_MORE_BUTTON_CLASS = "mx-auto inline-flex min-h-[48px] cursor-pointer items-center justify-center rounded-[12px] bg-black px-8 py-3 text-[18px] font-medium leading-6 text-white transition-colors hover:bg-[#222222]";
var ReviewsVerticalList = ({
  reviews = [],
  initialVisibleCount = 5,
  loadMoreText = "Load More",
  readLessText = "Read Less",
  verifiedLabel,
  recommendLabel,
  helpfulLabel,
  cleanVersion = false,
  className,
  classes = {}
}) => {
  const [isExpanded, setIsExpanded] = useState20(false);
  const visibleReviews = isExpanded ? reviews : reviews.slice(0, initialVisibleCount);
  const showToggleButton = reviews.length > initialVisibleCount;
  return /* @__PURE__ */ React229.createElement(React229.Fragment, null, /* @__PURE__ */ React229.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS44, className, classes.container) }, visibleReviews.map((review) => {
    var _a, _b, _c;
    return /* @__PURE__ */ React229.createElement(
      ReviewsVerticalCard,
      {
        key: (_c = review.id) != null ? _c : `${review.name}-${(_a = review.title) != null ? _a : ""}-${(_b = review.dateLabel) != null ? _b : ""}`,
        review,
        verifiedLabel,
        recommendLabel,
        helpfulLabel,
        cleanVersion,
        classes: classes.card
      }
    );
  })), showToggleButton && /* @__PURE__ */ React229.createElement(
    Button,
    {
      type: "button",
      onClick: () => setIsExpanded((current) => !current),
      className: cn(DEFAULT_LOAD_MORE_BUTTON_CLASS, classes.loadMoreButton)
    },
    isExpanded ? readLessText : loadMoreText
  ));
};

// src/organisms/reviewsModal/ReviewModalForm.tsx
import React234 from "react";
import { Formik, Field as Field2, useField, useFormikContext, Form as FormikForm } from "formik";
import * as Yup from "yup";

// src/atoms/reviewsModal/ReviewModalIcons.tsx
import React230 from "react";
var CloseIcon2 = ({ className }) => /* @__PURE__ */ React230.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    className: cn("w-6 h-6", className),
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  },
  /* @__PURE__ */ React230.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" })
);
var CameraIcon = ({ className }) => /* @__PURE__ */ React230.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    className: cn("w-6 h-6", className),
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  },
  /* @__PURE__ */ React230.createElement(
    "path",
    {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
    }
  ),
  /* @__PURE__ */ React230.createElement(
    "path",
    {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
    }
  )
);
var StarIcon2 = ({
  filled,
  selected,
  label,
  onClick
}) => /* @__PURE__ */ React230.createElement(
  "button",
  {
    type: "button",
    role: "radio",
    "aria-checked": selected,
    "aria-label": label,
    onClick,
    className: cn(
      "w-8 h-8 cursor-pointer border-0 bg-transparent p-0 transition-colors",
      filled ? "text-[#FFC72C]" : "text-[#E5E5E5]"
    )
  },
  /* @__PURE__ */ React230.createElement("svg", { "aria-hidden": "true", fill: "currentColor", viewBox: "0 0 24 24" }, /* @__PURE__ */ React230.createElement("path", { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" }))
);

// src/molecules/reviewsModal/ReviewModalErrorBadge.tsx
import React231 from "react";
var DEFAULT_ERROR_BADGE_CLASS = "md:col-span-2 w-full flex p-2 justify-center items-center bg-[#E34400] rounded mt-4 md:mt-0";
var DEFAULT_ERROR_TEXT_CLASS = "text-[14px] leading-[20px] font-bold text-white";
var ReviewModalErrorBadge = ({
  text,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React231.createElement("div", { className: cn(DEFAULT_ERROR_BADGE_CLASS, className) }, /* @__PURE__ */ React231.createElement("p", { className: cn(DEFAULT_ERROR_TEXT_CLASS, classes.text) }, text));
};

// src/molecules/reviewsModal/ReviewModalInput.tsx
import React232 from "react";
import { Field } from "formik";
var DEFAULT_INPUT_WRAPPER_CLASS = "flex flex-col w-full";
var DEFAULT_INPUT_LABEL_CLASS = "text-base leading-6 font-medium text-[#002D4A] mb-1";
var DEFAULT_INPUT_CLASS = "text-sm leading-5 font-normal text-[#333] p-2 rounded placeholder-[#888] focus:outline-none transition-colors border";
var DEFAULT_TEXTAREA_CLASS3 = "h-[100px] resize-none";
var DEFAULT_ERROR_CLASS2 = "text-xs leading-4 font-normal text-[#E34400] mt-1";
var ReviewModalInput = ({
  input,
  label,
  placeholder,
  values,
  errors,
  isTyped,
  isTextArea = false,
  className,
  classes = {}
}) => {
  var _a;
  return /* @__PURE__ */ React232.createElement("div", { className: cn(DEFAULT_INPUT_WRAPPER_CLASS, className) }, /* @__PURE__ */ React232.createElement("label", { className: cn(DEFAULT_INPUT_LABEL_CLASS, classes.label), htmlFor: input }, label), /* @__PURE__ */ React232.createElement(
    Field,
    {
      id: input,
      name: input,
      placeholder,
      as: isTextArea ? "textarea" : "input",
      className: cn(
        DEFAULT_INPUT_CLASS,
        isTextArea && DEFAULT_TEXTAREA_CLASS3,
        isTyped ? "border-[#E34400]" : "border-[#E5E5E5]",
        ((_a = values[input]) == null ? void 0 : _a.length) ? "bg-white" : "bg-[#F3F3F3]",
        classes.input
      )
    }
  ), isTyped && /* @__PURE__ */ React232.createElement("div", { className: cn(DEFAULT_ERROR_CLASS2, classes.error) }, errors[input]));
};

// src/molecules/reviewsModal/ReviewModalInputImage.tsx
import React233, { useEffect as useEffect18, useRef as useRef10 } from "react";
import { FieldArray } from "formik";
var DEFAULT_IMAGE_INPUT_WRAPPER_CLASS = "flex flex-col w-full";
var DEFAULT_IMAGE_LABEL_CLASS = "text-base leading-6 font-medium text-[#002D4A] mb-1";
var DEFAULT_GALLERY_WRAPPER_CLASS = "flex";
var DEFAULT_IMAGES_BOX_CLASS = "flex gap-2";
var DEFAULT_IMAGE_WRAPPER_CLASS = "relative w-[50px] h-[50px] rounded shrink-0 bg-[#F3F3F3] border border-[#E5E5E5]";
var DEFAULT_IMAGE_CLASS8 = "w-full h-full object-cover rounded";
var DEFAULT_CLOSE_BUTTON_CLASS = "absolute -top-2 -right-2 flex items-center justify-center bg-white rounded-full text-[#E34400] shadow cursor-pointer w-5 h-5 border border-[#E5E5E5] p-0";
var DEFAULT_UPLOAD_BUTTON_CLASS = "flex items-center justify-center border border-[#E5E5E5] bg-[#F3F3F3] rounded cursor-pointer text-[#333] hover:bg-[#E5E5E5] transition-colors";
var DEFAULT_MAX_SIZE_TEXT_CLASS = "text-[11px] leading-[12px] font-normal text-[#888] mt-1";
var ReviewModalInputImage = ({
  input,
  label,
  uploadText,
  maxSizeText,
  values,
  maxImages = 4,
  className,
  classes = {}
}) => {
  const inputId = React233.useId();
  const inputRef = useRef10(null);
  const objectUrlsRef = useRef10([]);
  const hasImages = values.images.length > 0;
  useEffect18(() => {
    return () => {
      objectUrlsRef.current.forEach((url) => URL.revokeObjectURL(url));
      objectUrlsRef.current = [];
    };
  }, []);
  const handleImageUpload = (event, arrayHelpers) => {
    const files = event.target.files;
    if (!files) {
      return;
    }
    const availableSlots = Math.max(maxImages - values.images.length, 0);
    const fileArray = Array.from(files).slice(0, availableSlots).map((file, index) => {
      const url = URL.createObjectURL(file);
      objectUrlsRef.current.push(url);
      return {
        id: `${file.name}-${file.lastModified}-${index}-${url}`,
        url
      };
    });
    fileArray.forEach((file) => arrayHelpers.push(file));
    event.target.value = "";
  };
  const handleImageRemove = (index, arrayHelpers) => {
    const image = values.images[index];
    if ((image == null ? void 0 : image.url) && objectUrlsRef.current.includes(image.url)) {
      URL.revokeObjectURL(image.url);
      objectUrlsRef.current = objectUrlsRef.current.filter((url) => url !== image.url);
    }
    arrayHelpers.remove(index);
  };
  return /* @__PURE__ */ React233.createElement("div", { className: cn(DEFAULT_IMAGE_INPUT_WRAPPER_CLASS, className) }, /* @__PURE__ */ React233.createElement("label", { className: cn(DEFAULT_IMAGE_LABEL_CLASS, classes.label), htmlFor: inputId }, label), /* @__PURE__ */ React233.createElement(FieldArray, { name: input }, (arrayHelpers) => /* @__PURE__ */ React233.createElement("div", { className: cn(DEFAULT_GALLERY_WRAPPER_CLASS, classes.galleryWrapper) }, /* @__PURE__ */ React233.createElement(
    "input",
    {
      ref: inputRef,
      id: inputId,
      type: "file",
      accept: "image/*",
      className: "hidden",
      multiple: true,
      onChange: (event) => handleImageUpload(event, arrayHelpers)
    }
  ), /* @__PURE__ */ React233.createElement("div", { className: cn(DEFAULT_IMAGES_BOX_CLASS, classes.imagesBox) }, values.images.map((image, index) => /* @__PURE__ */ React233.createElement(
    "div",
    {
      key: image.id,
      className: cn(DEFAULT_IMAGE_WRAPPER_CLASS, classes.imageWrapper)
    },
    /* @__PURE__ */ React233.createElement(
      "img",
      {
        src: image.url,
        className: cn(DEFAULT_IMAGE_CLASS8, classes.image),
        alt: "uploaded preview"
      }
    ),
    /* @__PURE__ */ React233.createElement(
      "button",
      {
        type: "button",
        className: cn(DEFAULT_CLOSE_BUTTON_CLASS, classes.closeButton),
        onClick: () => handleImageRemove(index, arrayHelpers)
      },
      /* @__PURE__ */ React233.createElement(CloseIcon2, { className: "w-3 h-3" })
    )
  ))), /* @__PURE__ */ React233.createElement(
    "button",
    {
      className: cn(
        DEFAULT_UPLOAD_BUTTON_CLASS,
        hasImages ? "w-[50px] p-0 ml-2" : "w-full py-3 px-6",
        classes.uploadButton
      ),
      type: "button",
      disabled: values.images.length >= maxImages,
      onClick: () => {
        var _a;
        return (_a = inputRef.current) == null ? void 0 : _a.click();
      }
    },
    /* @__PURE__ */ React233.createElement(CameraIcon, { className: !hasImages ? "mr-2" : "" }),
    !hasImages && /* @__PURE__ */ React233.createElement("span", { className: "text-sm font-normal" }, uploadText)
  ))), /* @__PURE__ */ React233.createElement("span", { className: cn(DEFAULT_MAX_SIZE_TEXT_CLASS, classes.maxSizeText) }, maxSizeText));
};

// src/organisms/reviewsModal/ReviewModalForm.tsx
var DEFAULT_REVIEW_MODAL_SUCCESS_MESSAGE = "Thank you! Your review has been submitted and will appear once approved.";
var initialValues = {
  rating: 0,
  name: "",
  title: "",
  review: "",
  images: [],
  picked: "yes"
};
var createReviewModalValidationSchema = (requiredErrorLabel = "Required") => Yup.object().shape({
  rating: Yup.number().min(1, requiredErrorLabel).required(requiredErrorLabel),
  name: Yup.string().required(requiredErrorLabel),
  title: Yup.string().required(requiredErrorLabel),
  review: Yup.string().required(requiredErrorLabel)
});
var reviewModalValidationSchema = createReviewModalValidationSchema();
var DEFAULT_MODAL_CONTAINER_CLASS = "w-full";
var DEFAULT_FORM_WRAPPER_CLASS = "flex flex-col md:grid md:grid-cols-2 gap-4 md:grid-rows-[auto]";
var DEFAULT_INPUT_STARS_CLASS = "md:col-span-2 mb-2 md:mb-0 flex flex-col";
var DEFAULT_MAIN_LABEL_CLASS = "text-base leading-6 font-medium text-[#002D4A] mb-2";
var DEFAULT_RADIO_WRAPPER_CLASS = "md:col-span-2 flex flex-col gap-6 mt-2 md:mt-0";
var DEFAULT_RADIO_GROUP_CLASS = "flex gap-6";
var DEFAULT_RADIO_BUTTON_LABEL_CLASS = "flex items-center text-sm font-normal text-[#333] cursor-pointer";
var DEFAULT_RADIO_GROUP_WITH_TITLE_CLASS = "flex flex-col gap-3 mt-1";
var DEFAULT_RADIO_INPUT_GROUP_CLASS = "flex flex-col md:grid md:grid-cols-[100px_auto] gap-2 md:gap-4 items-start md:items-center";
var DEFAULT_INPUT_OPTIONS_CLASS = "flex gap-4 md:gap-6";
var DEFAULT_BTN_WRAPPER_CLASS = "flex w-full justify-center mt-6 md:justify-start md:col-span-2";
var DEFAULT_SUBMIT_BTN_CLASS = "w-full md:w-auto mx-auto py-4 px-8 rounded-lg bg-[#002D4A] text-white hover:bg-[#001f33] transition-colors border-b-2 border-[#001f33] text-[18px] leading-6 font-bold text-center cursor-pointer";
var DEFAULT_SUCCESS_CONTAINER_CLASS = "relative flex min-h-[220px] w-full flex-col items-center justify-center text-center";
var DEFAULT_SUCCESS_ICON_CLASS = "mb-4 size-12 text-[#002D4A] md:mb-6";
var DEFAULT_SUCCESS_ICON_CIRCLE_CLASS = "text-[#002D4A]";
var DEFAULT_SUCCESS_ICON_CHECK_CLASS = "text-white";
var DEFAULT_SUCCESS_TEXT_CLASS = "max-w-[420px] text-base font-medium leading-6 text-[#333333]";
var DEFAULT_SUCCESS_CLOSE_BUTTON_CLASS = "absolute right-0 top-0 flex cursor-pointer border-0 bg-transparent p-0 text-[#002D4A]";
var StarRatingField = ({
  name,
  errorText,
  labelledBy
}) => {
  const [field, , helpers] = useField(name);
  const { errors, touched } = useFormikContext();
  const isError = errors.rating && touched.rating;
  const errorId = React234.useId();
  const currentRating = Number(field.value) || 0;
  const handleKeyDown = (event) => {
    if (!["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp"].includes(event.key)) {
      return;
    }
    event.preventDefault();
    const direction = event.key === "ArrowLeft" || event.key === "ArrowDown" ? -1 : 1;
    const nextRating = Math.max(1, Math.min(5, currentRating + direction));
    helpers.setValue(nextRating, false);
  };
  return /* @__PURE__ */ React234.createElement("div", { className: "flex flex-col gap-1" }, /* @__PURE__ */ React234.createElement(
    "div",
    {
      className: "flex gap-2",
      role: "radiogroup",
      "aria-labelledby": labelledBy,
      "aria-describedby": isError ? errorId : void 0,
      onKeyDown: handleKeyDown
    },
    [1, 2, 3, 4, 5].map((star) => /* @__PURE__ */ React234.createElement(
      StarIcon2,
      {
        key: star,
        filled: currentRating >= star,
        selected: currentRating === star,
        label: `${star} star${star === 1 ? "" : "s"}`,
        onClick: () => helpers.setValue(star, false)
      }
    ))
  ), isError && /* @__PURE__ */ React234.createElement("span", { id: errorId, className: "text-xs text-[#E34400]" }, errorText));
};
var ReviewModalFeatureRadioGroups = ({ title, variants, classes }) => {
  const titleId = React234.useId();
  return /* @__PURE__ */ React234.createElement("div", { className: "flex flex-col" }, /* @__PURE__ */ React234.createElement("p", { id: titleId, className: cn(DEFAULT_MAIN_LABEL_CLASS, classes.label) }, title), /* @__PURE__ */ React234.createElement(
    "div",
    {
      className: cn(DEFAULT_RADIO_GROUP_WITH_TITLE_CLASS, classes.radioGroupWithTitle),
      role: "group",
      "aria-labelledby": titleId
    },
    variants.map((variant, variantIndex) => /* @__PURE__ */ React234.createElement(
      "div",
      {
        key: `${variant.name}-${variantIndex}`,
        className: cn(DEFAULT_RADIO_INPUT_GROUP_CLASS, classes.radioInputGroup)
      },
      /* @__PURE__ */ React234.createElement("p", { className: "text-sm font-normal text-[#888]" }, variant.name, ":"),
      /* @__PURE__ */ React234.createElement("div", { className: cn(DEFAULT_INPUT_OPTIONS_CLASS, classes.inputOptions) }, variant.options.map((option, optionIndex) => /* @__PURE__ */ React234.createElement(
        "label",
        {
          key: `${option}-${optionIndex}`,
          className: cn(DEFAULT_RADIO_BUTTON_LABEL_CLASS, classes.radioButtonLabel)
        },
        /* @__PURE__ */ React234.createElement(
          Field2,
          {
            type: "radio",
            name: variant.name,
            value: option,
            className: "w-4 h-4 mr-2 accent-[#002D4A]"
          }
        ),
        /* @__PURE__ */ React234.createElement("span", { className: "text-sm text-[#002D4A]" }, option)
      )))
    ))
  ));
};
var ReviewModalForm = ({
  onSubmit,
  translations,
  radioInputs,
  maxImages = 4,
  className,
  classes = {}
}) => {
  const ratingLabelId = React234.useId();
  const recommendationLabelId = React234.useId();
  const validationSchema = React234.useMemo(
    () => createReviewModalValidationSchema(translations.requiredErrorLabel),
    [translations.requiredErrorLabel]
  );
  return /* @__PURE__ */ React234.createElement("div", { className: cn(DEFAULT_MODAL_CONTAINER_CLASS, className, classes.container) }, /* @__PURE__ */ React234.createElement(
    Formik,
    {
      initialValues,
      validationSchema,
      onSubmit: (values) => {
        onSubmit(values);
      }
    },
    ({ errors, touched, values, submitCount }) => {
      const isNameTyped = errors.name && touched.name;
      const isTitleTyped = errors.title && touched.title;
      const isReviewTyped = errors.review && touched.review;
      const shouldShowErrorBadge = submitCount > 0 && Object.keys(errors).length > 0;
      return /* @__PURE__ */ React234.createElement(FormikForm, null, /* @__PURE__ */ React234.createElement("section", { className: cn(DEFAULT_FORM_WRAPPER_CLASS, classes.formWrapper) }, /* @__PURE__ */ React234.createElement("div", { className: cn(DEFAULT_INPUT_STARS_CLASS, classes.inputStars) }, /* @__PURE__ */ React234.createElement("label", { id: ratingLabelId, className: cn(DEFAULT_MAIN_LABEL_CLASS, classes.label) }, translations.ratingLabel), /* @__PURE__ */ React234.createElement(
        StarRatingField,
        {
          name: "rating",
          errorText: translations.ratingError,
          labelledBy: ratingLabelId
        }
      )), /* @__PURE__ */ React234.createElement(
        ReviewModalInput,
        {
          className: "md:col-span-1",
          input: "name",
          label: translations.nameLabel,
          placeholder: translations.namePlaceholder,
          values,
          errors,
          isTyped: isNameTyped
        }
      ), /* @__PURE__ */ React234.createElement(
        ReviewModalInput,
        {
          className: "md:col-span-1",
          input: "title",
          label: translations.titleLabel,
          placeholder: translations.titlePlaceholder,
          values,
          errors,
          isTyped: isTitleTyped
        }
      ), /* @__PURE__ */ React234.createElement(
        ReviewModalInput,
        {
          className: "md:col-span-2",
          input: "review",
          label: translations.reviewLabel,
          placeholder: translations.reviewPlaceholder,
          values,
          errors,
          isTyped: isReviewTyped,
          isTextArea: true
        }
      ), /* @__PURE__ */ React234.createElement(
        ReviewModalInputImage,
        {
          className: "md:col-span-2",
          input: "images",
          label: translations.pictureLabel,
          uploadText: translations.uploadImage,
          maxSizeText: translations.maxPhotos,
          values,
          maxImages
        }
      ), /* @__PURE__ */ React234.createElement("div", { className: cn(DEFAULT_RADIO_WRAPPER_CLASS, classes.radioWrapper) }, /* @__PURE__ */ React234.createElement("div", { className: "flex flex-col" }, /* @__PURE__ */ React234.createElement(
        "p",
        {
          id: recommendationLabelId,
          className: cn(DEFAULT_MAIN_LABEL_CLASS, classes.label)
        },
        translations.recommendLabel
      ), /* @__PURE__ */ React234.createElement(
        "div",
        {
          className: cn(DEFAULT_RADIO_GROUP_CLASS, classes.radioGroup),
          role: "group",
          "aria-labelledby": recommendationLabelId
        },
        /* @__PURE__ */ React234.createElement(
          "label",
          {
            className: cn(DEFAULT_RADIO_BUTTON_LABEL_CLASS, classes.radioButtonLabel)
          },
          /* @__PURE__ */ React234.createElement(
            Field2,
            {
              type: "radio",
              name: "picked",
              value: "yes",
              className: "w-4 h-4 mr-2 accent-[#002D4A]"
            }
          ),
          /* @__PURE__ */ React234.createElement("span", { className: "text-sm text-[#002D4A]" }, translations.recommendYes)
        ),
        /* @__PURE__ */ React234.createElement(
          "label",
          {
            className: cn(DEFAULT_RADIO_BUTTON_LABEL_CLASS, classes.radioButtonLabel)
          },
          /* @__PURE__ */ React234.createElement(
            Field2,
            {
              type: "radio",
              name: "picked",
              value: "no",
              className: "w-4 h-4 mr-2 accent-[#002D4A]"
            }
          ),
          /* @__PURE__ */ React234.createElement("span", { className: "text-sm text-[#002D4A]" }, translations.recommendNo)
        )
      )), /* @__PURE__ */ React234.createElement(
        ReviewModalFeatureRadioGroups,
        {
          title: translations.featuresLabel,
          variants: radioInputs,
          classes
        }
      )), shouldShowErrorBadge && /* @__PURE__ */ React234.createElement(ReviewModalErrorBadge, { text: translations.errorBadge }), /* @__PURE__ */ React234.createElement("div", { className: cn(DEFAULT_BTN_WRAPPER_CLASS, classes.btnWrapper) }, /* @__PURE__ */ React234.createElement("button", { type: "submit", className: cn(DEFAULT_SUBMIT_BTN_CLASS, classes.submitBtn) }, translations.submitButton))));
    }
  ));
};
var ReviewModalSuccessMessage = ({
  text = DEFAULT_REVIEW_MODAL_SUCCESS_MESSAGE,
  onClose,
  className,
  classes = {}
}) => /* @__PURE__ */ React234.createElement("div", { className: cn(DEFAULT_SUCCESS_CONTAINER_CLASS, className, classes.container) }, /* @__PURE__ */ React234.createElement(
  IconCircleCheckmark,
  {
    className: cn(DEFAULT_SUCCESS_ICON_CLASS, classes.icon),
    classes: {
      circle: cn(DEFAULT_SUCCESS_ICON_CIRCLE_CLASS, classes.iconCircle),
      check: cn(DEFAULT_SUCCESS_ICON_CHECK_CLASS, classes.iconCheck)
    }
  }
), /* @__PURE__ */ React234.createElement(
  RichText,
  {
    html: text || DEFAULT_REVIEW_MODAL_SUCCESS_MESSAGE,
    className: cn(DEFAULT_SUCCESS_TEXT_CLASS, classes.text)
  }
), /* @__PURE__ */ React234.createElement(
  "button",
  {
    type: "button",
    "aria-label": "Close review success message",
    className: cn(DEFAULT_SUCCESS_CLOSE_BUTTON_CLASS, classes.closeButton),
    onClick: onClose
  },
  /* @__PURE__ */ React234.createElement(CloseIcon2, null)
));

// src/organisms/reviewsModal/ReviewModalWrapper.tsx
import React235, { useState as useState21, useEffect as useEffect19, useRef as useRef11 } from "react";
import ReactDOM from "react-dom";
var DEFAULT_OVERLAY_CLASS = "fixed inset-0 bg-black/75 z-[100] flex items-center justify-center p-0 md:p-4";
var DEFAULT_MODAL_CLASS = "bg-white w-full h-full md:h-auto md:max-h-[92vh] md:max-w-[700px] md:rounded-2xl flex flex-col overflow-hidden relative z-[101]";
var DEFAULT_HEADER_CLASS9 = "flex justify-between items-center p-4 md:p-10 md:pb-6 shrink-0";
var DEFAULT_TITLE_CLASS16 = "text-2xl leading-8 font-bold text-[#002D4A]";
var DEFAULT_MODAL_CLOSE_BUTTON_CLASS = "flex cursor-pointer md:absolute md:top-[30px] md:right-[30px] text-[#002D4A] bg-transparent border-none";
var DEFAULT_BODY_CLASS4 = "overflow-y-auto h-full p-4 md:p-10 md:pt-0";
var DEFAULT_BODY_WITHOUT_HEADER_CLASS = "overflow-y-auto h-full p-4 md:p-10";
var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
var ReviewModalWrapper = ({
  isOpen,
  onClose,
  showHeader,
  title,
  children,
  classes = {}
}) => {
  const [isClient, setIsClient] = useState21(false);
  const modalRef = useRef11(null);
  const titleId = React235.useId();
  useEffect19(() => {
    setIsClient(true);
  }, []);
  useEffect19(() => {
    if (!isOpen) {
      return;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const getFocusableElements = () => {
      var _a, _b;
      return Array.from((_b = (_a = modalRef.current) == null ? void 0 : _a.querySelectorAll(FOCUSABLE_SELECTOR)) != null ? _b : []).filter(
        (element) => !element.hasAttribute("disabled") && element.getAttribute("aria-hidden") !== "true"
      );
    };
    const handleKeyDown = (event) => {
      var _a;
      if (event.key === "Escape") {
        onClose();
        return;
      }
      if (event.key !== "Tab") {
        return;
      }
      const focusableElements = getFocusableElements();
      if (focusableElements.length === 0) {
        event.preventDefault();
        (_a = modalRef.current) == null ? void 0 : _a.focus();
        return;
      }
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
      if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    window.setTimeout(() => {
      const [firstElement] = getFocusableElements();
      firstElement == null ? void 0 : firstElement.focus();
    }, 0);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isClient || !isOpen) {
    return null;
  }
  return ReactDOM.createPortal(
    /* @__PURE__ */ React235.createElement("div", { className: cn(DEFAULT_OVERLAY_CLASS, classes.overlay) }, /* @__PURE__ */ React235.createElement(
      "div",
      {
        ref: modalRef,
        className: cn(DEFAULT_MODAL_CLASS, classes.content),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": showHeader && title ? titleId : void 0,
        "aria-label": !showHeader && title ? title : void 0,
        tabIndex: -1
      },
      showHeader && /* @__PURE__ */ React235.createElement("div", { className: cn(DEFAULT_HEADER_CLASS9, classes.header) }, title && /* @__PURE__ */ React235.createElement("h2", { id: titleId, className: cn(DEFAULT_TITLE_CLASS16, classes.title) }, title), /* @__PURE__ */ React235.createElement(
        "button",
        {
          type: "button",
          "aria-label": "Close review modal",
          className: cn(DEFAULT_MODAL_CLOSE_BUTTON_CLASS, classes.closeButton),
          onClick: onClose
        },
        /* @__PURE__ */ React235.createElement(CloseIcon2, null)
      )),
      /* @__PURE__ */ React235.createElement(
        "div",
        {
          className: cn(
            showHeader ? DEFAULT_BODY_CLASS4 : DEFAULT_BODY_WITHOUT_HEADER_CLASS,
            classes.body
          )
        },
        children
      )
    )),
    document.body
  );
};

// src/sections/ReviewsSmallImagesVertical.tsx
var DEFAULT_SECTION_CLASS6 = "w-full px-4 [background:var(--reviews-siv-bg)]";
var DEFAULT_INNER_CLASS5 = "mx-auto flex max-w-[1100px] flex-col items-center";
var DEFAULT_HEADER_CLASS10 = "w-full max-w-[760px]";
var DEFAULT_HEADING_CLASS3 = "font-black text-[28px] leading-[34px] text-(--reviews-siv-heading-color) md:text-[44px] md:leading-[52px]";
var DEFAULT_SUBHEADING_CLASS3 = "text-[#333333]";
var DEFAULT_SECTION_DESCRIPTION_CLASS = "mt-4 max-w-[760px] text-center text-[16px] leading-[26px] text-[#333333] md:text-[18px] md:leading-[30px]";
var DEFAULT_DIVIDER_CLASS9 = "mt-1 h-[7px] w-[138px] rounded-full bg-(--reviews-siv-accent-color)";
function buildVars2(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    "--reviews-siv-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--reviews-siv-heading-color": (_b = colors == null ? void 0 : colors.headingColor) != null ? _b : "var(--theme-color-heading-primary, #111111)",
    "--reviews-siv-primary-text-color": (_c = colors == null ? void 0 : colors.primaryTextColor) != null ? _c : "var(--theme-color-text-primary, #333333)",
    "--reviews-siv-secondary-text-color": (_d = colors == null ? void 0 : colors.secondaryTextColor) != null ? _d : "var(--theme-color-text-secondary, #666666)",
    "--reviews-siv-accent-color": (_e = colors == null ? void 0 : colors.accentColor) != null ? _e : "var(--theme-color-accent, #1996D3)",
    "--reviews-siv-divider-color": (_f = colors == null ? void 0 : colors.dividerColor) != null ? _f : "var(--theme-color-border-light, #F0F0F0)",
    "--reviews-siv-progress-active-color": (_g = colors == null ? void 0 : colors.progressBarActiveColor) != null ? _g : "var(--theme-color-accent, #3E82AB)",
    "--reviews-siv-progress-passive-color": (_h = colors == null ? void 0 : colors.progressBarPassiveColor) != null ? _h : "var(--theme-color-border-light, #E5EEF7)"
  };
}
var DEFAULT_REVIEW_MODAL_TITLE = "Write a Review";
var DEFAULT_REVIEW_SUCCESS_MODAL_TITLE = "Review submitted";
var DEFAULT_REVIEW_MODAL_TRANSLATIONS = {
  ratingLabel: "What would you rate this product?",
  ratingError: "Please select a rating",
  requiredErrorLabel: "Required",
  nameLabel: "Name",
  namePlaceholder: "Enter your name",
  titleLabel: "Review title",
  titlePlaceholder: "Enter review title",
  reviewLabel: "Review",
  reviewPlaceholder: "Write your comment here",
  pictureLabel: "Picture (optional)",
  recommendLabel: "Do you recommend this product?",
  recommendYes: "Yes",
  recommendNo: "No",
  featuresLabel: "How you rate the features of this product?",
  submitButton: "SUBMIT REVIEW",
  errorBadge: "Not all the fields have been filled out correctly!",
  uploadImage: "Select your image",
  maxPhotos: "You can upload maximum 4 photos.",
  successMessage: "Thank you! Your review has been submitted and will appear once approved."
};
var DEFAULT_REVIEW_MODAL_RADIO_INPUTS = [
  { name: "Results", options: ["Excellent", "Good", "Poor"] },
  { name: "Quality", options: ["Excellent", "Good", "Poor"] },
  { name: "Satisfaction", options: ["Excellent", "Good", "Poor"] }
];
var ReviewsSmallImagesVertical = ({
  block,
  showScoreSummary = true,
  onWriteReview,
  sectionSpacing,
  className,
  classes = {}
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
  const [isReviewModalOpen, setIsReviewModalOpen] = useState22(false);
  const [isReviewSuccessModalOpen, setIsReviewSuccessModalOpen] = useState22(false);
  const headerClasses = (_a = classes.header) != null ? _a : {};
  const {
    heading,
    headingHtml,
    subheading,
    showSubheading = true,
    subheadingPlacement = "before-divider",
    showDivider,
    sectionDescription,
    headingAs = "h2",
    colors,
    averageRating = 0,
    totalReviews = 0,
    reviewLabel = "reviews",
    ratingBreakdown = [],
    recommendationText,
    recommendationCriteria = [],
    reviewModal = {},
    writeReviewText = "Write Review",
    icons = {},
    verifiedLabel,
    recommendLabel,
    helpfulLabel,
    reviews = [],
    initialVisibleCount = 5,
    loadMoreText = "Load More",
    readLessText = "Read Less",
    cleanVersion = false
  } = block;
  const resolvedSubheading = showSubheading ? subheading : void 0;
  const resolvedShowDivider = showDivider != null ? showDivider : Boolean(heading || headingHtml || resolvedSubheading);
  const {
    enabled: isReviewModalEnabled = true,
    title: reviewModalTitle = DEFAULT_REVIEW_MODAL_TITLE,
    showHeader: showReviewModalHeader = true,
    translations: reviewModalTranslations = {},
    radioInputs: reviewModalRadioInputs = DEFAULT_REVIEW_MODAL_RADIO_INPUTS,
    maxImages: reviewModalMaxImages = 4,
    onSubmit: onReviewModalSubmit
  } = reviewModal;
  const displayedReviewModalTranslations = {
    ...DEFAULT_REVIEW_MODAL_TRANSLATIONS,
    ...reviewModalTranslations
  };
  const summaryClasses = {
    ...(_b = classes.summary) != null ? _b : {},
    divider: cn("border-(--reviews-siv-divider-color)", (_c = classes.summary) == null ? void 0 : _c.divider),
    recommendationText: cn(
      "border-(--reviews-siv-divider-color)",
      (_d = classes.summary) == null ? void 0 : _d.recommendationText
    ),
    writeReviewButton: cn(
      "border-(--reviews-siv-divider-color)",
      (_e = classes.summary) == null ? void 0 : _e.writeReviewButton
    ),
    ratingBreakdown: {
      ...(_g = (_f = classes.summary) == null ? void 0 : _f.ratingBreakdown) != null ? _g : {},
      track: cn(
        "[background:var(--reviews-siv-progress-passive-color)]",
        (_i = (_h = classes.summary) == null ? void 0 : _h.ratingBreakdown) == null ? void 0 : _i.track
      ),
      fill: cn(
        "[background:var(--reviews-siv-progress-active-color)]",
        (_k = (_j = classes.summary) == null ? void 0 : _j.ratingBreakdown) == null ? void 0 : _k.fill
      )
    },
    recommendationCriteria: {
      ...(_m = (_l = classes.summary) == null ? void 0 : _l.recommendationCriteria) != null ? _m : {},
      track: cn(
        "[background:var(--reviews-siv-progress-passive-color)]",
        (_o = (_n = classes.summary) == null ? void 0 : _n.recommendationCriteria) == null ? void 0 : _o.track
      ),
      fill: cn(
        "[background:var(--reviews-siv-progress-active-color)]",
        (_q = (_p = classes.summary) == null ? void 0 : _p.recommendationCriteria) == null ? void 0 : _q.fill
      )
    }
  };
  const reviewsListClasses = {
    ...(_r = classes.reviewsList) != null ? _r : {},
    container: cn("border-(--reviews-siv-divider-color)", (_s = classes.reviewsList) == null ? void 0 : _s.container),
    card: {
      ...(_u = (_t = classes.reviewsList) == null ? void 0 : _t.card) != null ? _u : {},
      card: cn("border-(--reviews-siv-divider-color)", (_w = (_v = classes.reviewsList) == null ? void 0 : _v.card) == null ? void 0 : _w.card)
    }
  };
  const handleWriteReview = () => {
    onWriteReview == null ? void 0 : onWriteReview();
    if (isReviewModalEnabled) {
      setIsReviewSuccessModalOpen(false);
      setIsReviewModalOpen(true);
    }
  };
  const handleReviewModalSubmit = (values) => {
    onReviewModalSubmit == null ? void 0 : onReviewModalSubmit(values);
    setIsReviewModalOpen(false);
    setIsReviewSuccessModalOpen(true);
  };
  const handleReviewSuccessModalClose = () => {
    setIsReviewSuccessModalOpen(false);
  };
  return /* @__PURE__ */ React236.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS6,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars2(colors)
    },
    /* @__PURE__ */ React236.createElement("div", { className: cn(DEFAULT_INNER_CLASS5, classes.inner) }, /* @__PURE__ */ React236.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading: resolvedSubheading,
        headingAs,
        subheadingPlacement,
        showDivider: resolvedShowDivider,
        className: cn(DEFAULT_HEADER_CLASS10, headerClasses.root),
        classes: {
          heading: cn(DEFAULT_HEADING_CLASS3, headerClasses.heading),
          subheading: cn(DEFAULT_SUBHEADING_CLASS3, headerClasses.subheading),
          divider: cn(DEFAULT_DIVIDER_CLASS9, headerClasses.divider)
        }
      }
    ), sectionDescription && /* @__PURE__ */ React236.createElement(
      RichText,
      {
        html: sectionDescription,
        className: cn(DEFAULT_SECTION_DESCRIPTION_CLASS, classes.sectionDescription)
      }
    ), showScoreSummary && /* @__PURE__ */ React236.createElement(
      ReviewsScoreSummary,
      {
        averageRating,
        totalReviews,
        reviewLabel,
        ratingBreakdown,
        recommendationText,
        recommendationCriteria,
        writeReviewText,
        onWriteReview: handleWriteReview,
        writeReviewIcon: icons.writeReview,
        ratingStarIcon: icons.ratingStar,
        classes: summaryClasses
      }
    ), /* @__PURE__ */ React236.createElement(
      ReviewsVerticalList,
      {
        reviews,
        initialVisibleCount,
        loadMoreText,
        readLessText,
        verifiedLabel,
        recommendLabel,
        helpfulLabel,
        cleanVersion,
        classes: {
          ...reviewsListClasses,
          container: cn(!showScoreSummary && "mt-8", reviewsListClasses.container)
        }
      }
    ), isReviewModalEnabled && /* @__PURE__ */ React236.createElement(React236.Fragment, null, /* @__PURE__ */ React236.createElement(
      ReviewModalWrapper,
      {
        isOpen: isReviewModalOpen,
        onClose: () => setIsReviewModalOpen(false),
        showHeader: showReviewModalHeader,
        title: reviewModalTitle,
        classes: (_x = classes.reviewModal) == null ? void 0 : _x.wrapper
      },
      /* @__PURE__ */ React236.createElement(
        ReviewModalForm,
        {
          translations: displayedReviewModalTranslations,
          radioInputs: reviewModalRadioInputs,
          maxImages: reviewModalMaxImages,
          onSubmit: handleReviewModalSubmit,
          classes: (_y = classes.reviewModal) == null ? void 0 : _y.form
        }
      )
    ), /* @__PURE__ */ React236.createElement(
      ReviewModalWrapper,
      {
        isOpen: isReviewSuccessModalOpen,
        onClose: handleReviewSuccessModalClose,
        showHeader: false,
        title: DEFAULT_REVIEW_SUCCESS_MODAL_TITLE,
        classes: (_z = classes.reviewModal) == null ? void 0 : _z.wrapper
      },
      /* @__PURE__ */ React236.createElement(
        ReviewModalSuccessMessage,
        {
          text: displayedReviewModalTranslations.successMessage,
          onClose: handleReviewSuccessModalClose,
          classes: (_A = classes.reviewModal) == null ? void 0 : _A.successMessage
        }
      )
    )))
  );
};

// src/sections/ContentImageBulletListSection.tsx
import React237 from "react";
var DEFAULT_SECTION_CLASS7 = "w-full px-6 md:px-12 lg:px-20 bg-[var(--theme-color-bg-dark,#002D4A)] text-white flex justify-center";
var DEFAULT_FLEX_CONTAINER_CLASS = "max-w-[1100px] w-full flex flex-col md:flex-row gap-y-8 md:gap-y-6 md:gap-x-12 items-start";
var DEFAULT_CONTENT_WRAPPER_CLASS = "flex flex-col w-full md:w-1/2";
var DEFAULT_RICH_TEXT_CLASS = "text-sm md:text-base leading-relaxed [&>p>strong]:font-bold [&>strong]:font-bold";
var DEFAULT_IMAGE_WRAPPER_CLASS2 = "w-full md:w-1/2 flex";
var DEFAULT_IMAGE_CLASS9 = "w-full h-auto object-cover rounded-lg";
var DEFAULT_LIST_WRAPPER_CLASS = "w-full flex flex-col gap-2 md:mt-6";
var DEFAULT_LIST_ITEM_CLASS = "flex items-start gap-3 text-sm md:text-base font-bold leading-snug";
var DEFAULT_LIST_ICON_CLASS = "w-5 h-5 flex-shrink-0 mt-0.5";
var DEFAULT_ICON_SVG = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<g clip-path="url(#clip0_491_4688)">
<path d="M19.5941 15.0238L12.5212 2.00277C11.9874 1.1041 11.0445 0.567383 9.99924 0.567383C8.95392 0.567383 8.01111 1.1041 7.47728 2.00277C7.47326 2.00965 7.46986 2.01652 7.46584 2.0234L0.416462 15.0032C-0.128812 15.9208 -0.139124 17.0228 0.388376 17.9507C0.917087 18.8792 1.86959 19.4331 2.93783 19.4331H17.0216C18.0898 19.4331 19.0815 18.8792 19.6101 17.9507C20.1376 17.0229 20.1274 15.9208 19.5941 15.0238ZM8.82619 6.52945C8.82619 5.88156 9.35138 5.35641 9.99924 5.35641C10.6471 5.35641 11.1723 5.8816 11.1723 6.52945V11.2217C11.1723 11.8695 10.6471 12.3947 9.99924 12.3947C9.35138 12.3947 8.82619 11.8695 8.82619 11.2217V6.52945ZM9.99924 17.087C9.02896 17.087 8.23963 16.2977 8.23963 15.3274C8.23963 14.3571 9.02892 13.5678 9.99924 13.5678C10.9695 13.5678 11.7588 14.3571 11.7588 15.3274C11.7588 16.2977 10.9695 17.087 9.99924 17.087Z" fill="#FFCB13"/>
</g>
<defs>
<clipPath id="clip0_491_4688">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`)}`;
var ContentImageBulletListSection = ({
  heading,
  headingHtml,
  subheading,
  showSubheading = false,
  headingAs,
  subheadingPlacement,
  showDivider = true,
  paragraph,
  bulletPoints = [],
  assetType,
  image,
  imageAlt = "",
  videoUrl,
  listIcon,
  imagePosition = "right",
  sectionSpacing,
  className,
  classes = {}
}) => {
  const resolvedAssetType = assetType === "video" ? "video" : "image";
  const mediaUrl = resolvedAssetType === "video" ? videoUrl : image;
  const listElement = bulletPoints.length > 0 ? /* @__PURE__ */ React237.createElement("div", { className: cn(DEFAULT_LIST_WRAPPER_CLASS, classes.listWrapper) }, /* @__PURE__ */ React237.createElement("ul", { className: cn("w-full flex flex-col gap-2", classes.list) }, bulletPoints.map((item, index) => /* @__PURE__ */ React237.createElement("li", { key: `${item}-${index}`, className: cn(DEFAULT_LIST_ITEM_CLASS, classes.listItem) }, /* @__PURE__ */ React237.createElement(
    Icon,
    {
      src: listIcon || DEFAULT_ICON_SVG,
      className: cn(DEFAULT_LIST_ICON_CLASS, classes.listIcon)
    }
  ), /* @__PURE__ */ React237.createElement("span", null, item))))) : null;
  const contentColumn = /* @__PURE__ */ React237.createElement(
    "div",
    {
      className: cn(
        DEFAULT_CONTENT_WRAPPER_CLASS,
        !mediaUrl && "md:w-full",
        classes.contentWrapper
      )
    },
    (heading || headingHtml || showSubheading && subheading) && /* @__PURE__ */ React237.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading: showSubheading ? subheading : void 0,
        headingAs,
        subheadingPlacement,
        showDivider,
        classes: {
          container: cn("items-start text-left gap-0 mb-0", classes.header),
          heading: cn("text-white text-3xl md:text-4xl font-bold leading-tight", classes.heading),
          subheading: cn("text-white", classes.subheading),
          divider: cn(
            "w-12 h-1 bg-[var(--theme-color-accent,#00A3E0)] my-6 rounded-full",
            classes.divider
          )
        }
      }
    ),
    paragraph && /* @__PURE__ */ React237.createElement(RichText, { html: paragraph, className: cn(DEFAULT_RICH_TEXT_CLASS, classes.richText) }),
    listElement && /* @__PURE__ */ React237.createElement("div", { className: "hidden md:flex w-full" }, listElement)
  );
  const imageColumn = mediaUrl ? /* @__PURE__ */ React237.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS2, classes.imageWrapper) }, resolvedAssetType === "video" ? /* @__PURE__ */ React237.createElement(
    Video,
    {
      src: mediaUrl,
      ariaLabel: imageAlt,
      className: cn(DEFAULT_IMAGE_CLASS9, "aspect-auto", classes.image)
    }
  ) : /* @__PURE__ */ React237.createElement(Image, { src: mediaUrl, alt: imageAlt, className: cn(DEFAULT_IMAGE_CLASS9, classes.image) })) : null;
  const left = imagePosition === "left" ? imageColumn : contentColumn;
  const right = imagePosition === "left" ? contentColumn : imageColumn;
  return /* @__PURE__ */ React237.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS7,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      )
    },
    /* @__PURE__ */ React237.createElement("div", { className: cn(DEFAULT_FLEX_CONTAINER_CLASS, classes.inner) }, left, right, listElement && /* @__PURE__ */ React237.createElement("div", { className: "flex w-full md:hidden order-last" }, listElement))
  );
};

// src/sections/InfoBannerAward.tsx
import React238 from "react";
import classNames91 from "classnames";
var DEFAULT_SECTION_CLASS8 = "w-full px-4 md:px-6";
var DEFAULT_BANNER_CLASS = "mx-auto flex w-full flex-col items-center justify-center gap-6 rounded-[20px] border border-[var(--theme-color-border,#52A4D8)] bg-[var(--theme-color-bg-raised,#FAFAFA)] p-6 md:flex-row md:gap-10 md:p-10 lg:max-w-[768px]";
var DEFAULT_CONTENT_CLASS13 = "order-1 flex w-full flex-col items-center justify-start gap-4 md:order-2 md:flex-1";
var DEFAULT_RATING_CLASS3 = "flex items-center justify-center [&_svg]:h-4 [&_svg]:w-24";
var DEFAULT_QUOTE_CLASS = "w-full text-center text-[20px] leading-6 font-black text-[var(--theme-color-text-primary,#333333)] capitalize md:max-w-[301px]";
var DEFAULT_DOMAIN_CLASS = "w-full text-center text-[18px] leading-6 font-semibold text-[var(--theme-color-text-secondary,#666666)] md:max-w-[301px]";
var DEFAULT_MEDIA_ROW_CLASS = "order-2 flex w-full items-center justify-center gap-0 md:contents";
var DEFAULT_AWARD_WRAPPER_CLASS = "flex w-1/2 shrink-0 items-center justify-center md:order-1 md:w-[142px]";
var DEFAULT_AWARD_IMAGE_CLASS = "h-auto w-full max-w-[142px] object-contain";
var DEFAULT_PRODUCT_WRAPPER_CLASS = "flex w-1/2 shrink-0 items-center justify-center md:order-3 md:w-[165px]";
var DEFAULT_PRODUCT_IMAGE_CLASS = "aspect-square w-full max-w-[165px] object-contain";
var InfoBannerAward = ({
  quote,
  domain,
  awardImage,
  awardImageAlt = "",
  productImage,
  productImageAlt = "",
  ratingLabel = "Rated 5 out of 5 stars",
  sectionSpacing,
  className,
  classes = {}
}) => {
  if (!quote || !awardImage || !productImage) return null;
  const hasDomain = typeof domain === "string" && domain.trim() !== "";
  const sectionClass = cn(
    DEFAULT_SECTION_CLASS8,
    getSectionSpacingClass(sectionSpacing),
    classes.section,
    className
  );
  const bannerClass = classNames91(DEFAULT_BANNER_CLASS, classes.banner);
  const contentClass = classNames91(DEFAULT_CONTENT_CLASS13, classes.content);
  const ratingClass = classNames91(DEFAULT_RATING_CLASS3, classes.rating);
  const quoteClass = classNames91(DEFAULT_QUOTE_CLASS, classes.quote);
  const domainClass = classNames91(DEFAULT_DOMAIN_CLASS, classes.domain);
  const mediaRowClass = classNames91(DEFAULT_MEDIA_ROW_CLASS, classes.mediaRow);
  const awardWrapperClass = classNames91(DEFAULT_AWARD_WRAPPER_CLASS, classes.awardWrapper);
  const awardImageClass = classNames91(DEFAULT_AWARD_IMAGE_CLASS, classes.awardImage);
  const productWrapperClass = classNames91(DEFAULT_PRODUCT_WRAPPER_CLASS, classes.productWrapper);
  const productImageClass = classNames91(DEFAULT_PRODUCT_IMAGE_CLASS, classes.productImage);
  return /* @__PURE__ */ React238.createElement("section", { className: sectionClass }, /* @__PURE__ */ React238.createElement("div", { className: bannerClass }, /* @__PURE__ */ React238.createElement("div", { className: contentClass }, /* @__PURE__ */ React238.createElement("div", { className: ratingClass, "aria-label": ratingLabel }, /* @__PURE__ */ React238.createElement("span", { "aria-hidden": "true" }, STAR_SVG.five)), /* @__PURE__ */ React238.createElement(RichText, { html: quote, className: quoteClass }), hasDomain && /* @__PURE__ */ React238.createElement(Text, { as: "p", className: domainClass }, domain)), /* @__PURE__ */ React238.createElement("div", { className: mediaRowClass }, /* @__PURE__ */ React238.createElement("div", { className: awardWrapperClass }, /* @__PURE__ */ React238.createElement(
    Image,
    {
      src: awardImage,
      alt: awardImageAlt,
      className: awardImageClass,
      loading: "eager"
    }
  )), /* @__PURE__ */ React238.createElement("div", { className: productWrapperClass }, /* @__PURE__ */ React238.createElement(
    Image,
    {
      src: productImage,
      alt: productImageAlt,
      className: productImageClass,
      loading: "eager"
    }
  )))));
};

// src/sections/ReviewCarouselSection.tsx
import React242 from "react";
import classNames94 from "classnames";

// src/organisms/ReviewCarousel.tsx
import React240, { useEffect as useEffect20, useMemo as useMemo3, useRef as useRef12, useState as useState23 } from "react";
import classNames93 from "classnames";

// src/molecules/ReviewCarouselCard.tsx
import React239 from "react";
import classNames92 from "classnames";

// src/assets/verified.svg
var verified_default = "./verified-BICZRTAV.svg";

// src/assets/stars-green.svg
var stars_green_default = "./stars-green-MTDFKKNM.svg";

// src/molecules/ReviewCarouselCard.tsx
var DEFAULT_REVIEW_CAROUSEL_CARD_CLASS = "flex h-full w-full max-w-[420px] flex-col overflow-hidden rounded-[10px] bg-[#FFFFFFB2]";
var DEFAULT_REVIEW_CAROUSEL_CARD_IMAGE_CLASS = "h-[250px] w-full object-cover";
var DEFAULT_REVIEW_CAROUSEL_CARD_CONTENT_CLASS = "p-4 flex flex-1 flex-col gap-2 items-start min-h-64";
var DEFAULT_REVIEW_CAROUSEL_CARD_RATING_CLASS = "max-h-5";
var DEFAULT_REVIEW_CAROUSEL_CARD_TITLE_CLASS = "text-[20px] leading-7 font-bold";
var DEFAULT_REVIEW_CAROUSEL_CARD_NAME_ROW_CLASS = "flex items-center gap-2";
var DEFAULT_REVIEW_CAROUSEL_CARD_NAME_CLASS = "text-[16px] leading-6 font-bold text-[#333]";
var DEFAULT_REVIEW_CAROUSEL_CARD_VERIFIED_ROW_CLASS = "flex flex-row items-center gap-1";
var DEFAULT_REVIEW_CAROUSEL_CARD_VERIFIED_ICON_CLASS = "";
var DEFAULT_REVIEW_CAROUSEL_CARD_VERIFIED_LABEL_CLASS = "text-[#00B67A] text-[12px] leading-3";
var DEFAULT_REVIEW_CAROUSEL_CARD_REVIEW_CLASS = "text-[16px] leading-6 text-[#333]";
function ReviewCard2({
  assetType,
  image,
  videoUrl,
  title,
  name,
  review,
  ratingIcon = stars_green_default,
  cleanVersion = false,
  verified = true,
  verifiedIcon = verified_default,
  verifiedLabel = "Verified customer",
  className,
  classes = {}
}) {
  const resolvedAssetType = assetType === "video" ? "video" : "image";
  const mediaUrl = resolvedAssetType === "video" ? videoUrl : image;
  return /* @__PURE__ */ React239.createElement("article", { className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_CLASS, className, classes.root) }, mediaUrl && (resolvedAssetType === "video" ? /* @__PURE__ */ React239.createElement(
    Video,
    {
      src: mediaUrl,
      ariaLabel: title,
      className: classNames92(
        DEFAULT_REVIEW_CAROUSEL_CARD_IMAGE_CLASS,
        "aspect-auto rounded-none",
        classes.image
      )
    }
  ) : /* @__PURE__ */ React239.createElement(
    Image,
    {
      src: mediaUrl,
      alt: title,
      className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_IMAGE_CLASS, classes.image)
    }
  )), /* @__PURE__ */ React239.createElement("div", { className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_CONTENT_CLASS, classes.content) }, cleanVersion ? /* @__PURE__ */ React239.createElement(
    StarRating,
    {
      variant: "five",
      size: 20,
      gap: 1.25,
      emptyColor: "#E0E0E0",
      className: classNames92(classes.rating)
    }
  ) : /* @__PURE__ */ React239.createElement(
    Image,
    {
      src: ratingIcon,
      alt: "",
      className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_RATING_CLASS, classes.rating)
    }
  ), /* @__PURE__ */ React239.createElement(Text, { className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_TITLE_CLASS, classes.title) }, title), /* @__PURE__ */ React239.createElement("div", { className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_NAME_ROW_CLASS, classes.nameRow) }, /* @__PURE__ */ React239.createElement(Text, { className: classNames92(DEFAULT_REVIEW_CAROUSEL_CARD_NAME_CLASS, classes.name) }, name), verified && !cleanVersion && /* @__PURE__ */ React239.createElement(
    "div",
    {
      className: classNames92(
        DEFAULT_REVIEW_CAROUSEL_CARD_VERIFIED_ROW_CLASS,
        classes.verifiedRow
      )
    },
    /* @__PURE__ */ React239.createElement(
      Image,
      {
        src: verifiedIcon,
        alt: "",
        className: classNames92(
          DEFAULT_REVIEW_CAROUSEL_CARD_VERIFIED_ICON_CLASS,
          classes.verifiedIcon
        )
      }
    ),
    /* @__PURE__ */ React239.createElement(
      Text,
      {
        className: classNames92(
          DEFAULT_REVIEW_CAROUSEL_CARD_VERIFIED_LABEL_CLASS,
          classes.verifiedLabel
        )
      },
      verifiedLabel
    )
  )), /* @__PURE__ */ React239.createElement(Text, { className: cn(DEFAULT_REVIEW_CAROUSEL_CARD_REVIEW_CLASS, classes.review) }, review)));
}

// src/organisms/ReviewCarousel.tsx
var DEFAULT_REVIEW_CAROUSEL_CLASS = "w-full [--review-carousel-chevron-bg-color:#ffffff] [--review-carousel-chevron-color:#666666]";
var DEFAULT_REVIEW_CAROUSEL_VIEWPORT_CLASS = "w-full overflow-x-hidden overflow-y-visible";
var DEFAULT_REVIEW_CAROUSEL_TRACK_CLASS = "hide-scrollbar flex items-stretch";
var DEFAULT_REVIEW_CAROUSEL_ITEM_CLASS = "flex shrink-0";
var DEFAULT_REVIEW_CAROUSEL_CONTROLS_CLASS = "mt-6 flex items-center justify-center gap-3";
var DEFAULT_REVIEW_CAROUSEL_CONTROL_BUTTON_CLASS = "inline-flex h-10 w-10 items-center justify-center cursor-pointer";
var DEFAULT_REVIEW_CAROUSEL_CHEVRON_WRAPPER_CLASS = "inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-[8.67px] bg-(--review-carousel-chevron-bg-color) text-(--review-carousel-chevron-color)";
var DEFAULT_REVIEW_CAROUSEL_PREV_CHEVRON_CLASS = "rotate-180";
function ReviewCarousel({
  reviews,
  gapPx = 24,
  peekPx = 80,
  minCardWidth = 358,
  maxCardWidth = 420,
  verified,
  verifiedLabel,
  verifiedIcon,
  cleanVersion = false,
  className,
  classes = {},
  cardClassName,
  cardClasses
}) {
  const scrollerRef = useRef12(null);
  const firstCardRef = useRef12(null);
  const looped = useMemo3(() => {
    const r = reviews != null ? reviews : [];
    if (r.length === 0) return [];
    return [...r, ...r, ...r];
  }, [reviews]);
  const [step, setStep] = useState23(maxCardWidth + gapPx);
  const [cardW, setCardW] = useState23(maxCardWidth);
  const [vw, setVw] = useState23(typeof window !== "undefined" ? window.innerWidth : 1024);
  const [ready, setReady] = useState23(false);
  const indexRef = useRef12(0);
  const animatingRef = useRef12(false);
  const queuedRef = useRef12(0);
  const cardWidthCss = `clamp(${minCardWidth}px, calc(100vw - ${peekPx * 2}px), ${maxCardWidth}px)`;
  const canPeek = vw >= cardW + peekPx * 2;
  const sidePad = canPeek ? `max(${peekPx}px, calc(50vw - ${cardW / 2}px))` : `max(0px, calc(50vw - ${cardW / 2}px))`;
  useEffect20(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  useEffect20(() => {
    const el = firstCardRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      const w = Math.round(el.getBoundingClientRect().width);
      setCardW(w);
      setStep(w + gapPx);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [gapPx]);
  const jumpToIndex = (idx) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollLeft = idx * step;
  };
  const smoothToIndex = (idx) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollTo({ left: idx * step, behavior: "smooth" });
  };
  useEffect20(() => {
    const scroller = scrollerRef.current;
    if (!scroller || reviews.length === 0) return;
    requestAnimationFrame(() => {
      const start = reviews.length;
      indexRef.current = start;
      jumpToIndex(start);
      setReady(true);
    });
  }, [reviews.length, step]);
  useEffect20(() => {
    if (!ready) return;
    jumpToIndex(indexRef.current);
  }, [step, ready]);
  const normalizeIfNeeded = () => {
    const n = reviews.length;
    if (n === 0) return;
    const oneCopy = n;
    const min = oneCopy * 0.5;
    const max = oneCopy * 2.5;
    if (indexRef.current < min) {
      indexRef.current += oneCopy;
      jumpToIndex(indexRef.current);
    } else if (indexRef.current > max) {
      indexRef.current -= oneCopy;
      jumpToIndex(indexRef.current);
    }
  };
  const runMove = (dir) => {
    if (!ready || reviews.length === 0) return;
    if (animatingRef.current) {
      queuedRef.current += dir;
      return;
    }
    animatingRef.current = true;
    indexRef.current += dir;
    smoothToIndex(indexRef.current);
    window.setTimeout(() => {
      normalizeIfNeeded();
      animatingRef.current = false;
      const q = queuedRef.current;
      if (q !== 0) {
        queuedRef.current = q > 0 ? q - 1 : q + 1;
        runMove(q > 0 ? 1 : -1);
      }
    }, 520);
  };
  const onPrev = () => runMove(-1);
  const onNext = () => runMove(1);
  const touchStartRef = useRef12(null);
  const onTouchStart = (e) => {
    const t = e.touches[0];
    touchStartRef.current = { x: t.clientX, y: t.clientY };
  };
  const onTouchMove = (e) => {
    const start = touchStartRef.current;
    if (!start) return;
    const t = e.touches[0];
    const dx = t.clientX - start.x;
    const dy = t.clientY - start.y;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
      e.preventDefault();
    }
  };
  const onWheel = (e) => {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.preventDefault();
  };
  if (reviews.length === 0) return null;
  return /* @__PURE__ */ React240.createElement("div", { className: classNames93(DEFAULT_REVIEW_CAROUSEL_CLASS, className, classes.root) }, /* @__PURE__ */ React240.createElement(
    "div",
    {
      ref: scrollerRef,
      className: classNames93(DEFAULT_REVIEW_CAROUSEL_VIEWPORT_CLASS, classes.viewport),
      style: {
        paddingLeft: sidePad,
        paddingRight: sidePad,
        touchAction: "pan-y",
        overscrollBehaviorX: "none",
        scrollbarWidth: "none"
      },
      onWheel,
      onTouchStart,
      onTouchMove,
      "aria-roledescription": "carousel",
      "aria-label": "Customer reviews"
    },
    /* @__PURE__ */ React240.createElement("style", null, `
          .hide-scrollbar::-webkit-scrollbar { display: none; }
        `),
    /* @__PURE__ */ React240.createElement(
      "ul",
      {
        className: classNames93(DEFAULT_REVIEW_CAROUSEL_TRACK_CLASS, classes.track),
        style: {
          gap: `${gapPx}px`,
          width: "max-content",
          paddingTop: 1,
          paddingBottom: 1
        }
      },
      looped.map((r, i) => {
        const isDuplicate = i < reviews.length || i >= reviews.length * 2;
        return /* @__PURE__ */ React240.createElement(
          "li",
          {
            ref: i === 0 ? firstCardRef : null,
            key: `${r.id}__${i}`,
            className: classNames93(DEFAULT_REVIEW_CAROUSEL_ITEM_CLASS, classes.item),
            style: { width: cardWidthCss },
            "aria-hidden": isDuplicate
          },
          /* @__PURE__ */ React240.createElement(
            ReviewCard2,
            {
              ...r,
              verified,
              verifiedLabel,
              verifiedIcon,
              cleanVersion,
              className: cardClassName,
              classes: cardClasses
            }
          )
        );
      })
    )
  ), /* @__PURE__ */ React240.createElement("div", { className: classNames93(DEFAULT_REVIEW_CAROUSEL_CONTROLS_CLASS, classes.controls) }, /* @__PURE__ */ React240.createElement(
    "button",
    {
      type: "button",
      onClick: onPrev,
      "aria-label": "Previous review",
      className: classNames93(
        DEFAULT_REVIEW_CAROUSEL_CONTROL_BUTTON_CLASS,
        classes.controlButton,
        classes.prevButton
      )
    },
    /* @__PURE__ */ React240.createElement("span", { className: DEFAULT_REVIEW_CAROUSEL_CHEVRON_WRAPPER_CLASS }, /* @__PURE__ */ React240.createElement(IconChevronRight, { className: DEFAULT_REVIEW_CAROUSEL_PREV_CHEVRON_CLASS }))
  ), /* @__PURE__ */ React240.createElement(
    "button",
    {
      type: "button",
      onClick: onNext,
      "aria-label": "Next review",
      className: classNames93(
        DEFAULT_REVIEW_CAROUSEL_CONTROL_BUTTON_CLASS,
        classes.controlButton,
        classes.nextButton
      )
    },
    /* @__PURE__ */ React240.createElement("span", { className: DEFAULT_REVIEW_CAROUSEL_CHEVRON_WRAPPER_CLASS }, /* @__PURE__ */ React240.createElement(IconChevronRight, null))
  )));
}

// src/organisms/ReviewCarouselMotion.tsx
import React241, { useEffect as useEffect21, useRef as useRef13, useState as useState24 } from "react";
var DEFAULT_ROOT_CLASS29 = "w-full";
var DEFAULT_VIEWPORT_CLASS2 = "w-full overflow-hidden cursor-grab select-none";
var DEFAULT_TRACK_CLASS4 = "flex w-max items-stretch will-change-transform";
var DEFAULT_GROUP_CLASS4 = "flex flex-none items-stretch";
var DEFAULT_ITEM_CLASS8 = "flex shrink-0";
var COPIES = 3;
function ReviewCarouselMotion({
  reviews,
  gapPx = 24,
  minCardWidth = 358,
  maxCardWidth = 420,
  scrollSpeed = 0.5,
  verified,
  verifiedLabel,
  verifiedIcon,
  cleanVersion = false,
  className,
  classes = {},
  cardClassName,
  cardClasses
}) {
  const viewportRef = useRef13(null);
  const trackRef = useRef13(null);
  const firstGroupRef = useRef13(null);
  const [cycleWidth, setCycleWidth] = useState24(0);
  const [viewportWidth, setViewportWidth] = useState24(0);
  useEffect21(() => {
    const group = firstGroupRef.current;
    const viewport = viewportRef.current;
    if (!group || !viewport) return;
    const updateSizes = () => {
      setCycleWidth(group.offsetWidth);
      setViewportWidth(viewport.offsetWidth);
    };
    updateSizes();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateSizes);
      return () => {
        window.removeEventListener("resize", updateSizes);
      };
    }
    const observer = new ResizeObserver(updateSizes);
    observer.observe(group);
    observer.observe(viewport);
    return () => {
      observer.disconnect();
    };
  }, [reviews.length, gapPx, minCardWidth, maxCardWidth]);
  const copyCount = cycleWidth > 0 ? Math.max(COPIES, Math.ceil(viewportWidth / cycleWidth) + 2) : COPIES;
  const copies = Array.from({ length: copyCount }, (_, index) => index);
  const cardWidthCss = `clamp(${minCardWidth}px, calc(100vw - 32px), ${maxCardWidth}px)`;
  useInfiniteTrackScroll({
    containerRef: viewportRef,
    trackRef,
    speed: scrollSpeed,
    cycleSize: cycleWidth,
    initialOffset: -cycleWidth
  });
  if (!reviews.length) return null;
  return /* @__PURE__ */ React241.createElement("div", { className: cn(DEFAULT_ROOT_CLASS29, className, classes.root) }, /* @__PURE__ */ React241.createElement("div", { ref: viewportRef, className: cn(DEFAULT_VIEWPORT_CLASS2, classes.viewport) }, /* @__PURE__ */ React241.createElement("div", { ref: trackRef, className: cn(DEFAULT_TRACK_CLASS4, classes.track) }, copies.map((copyIndex) => /* @__PURE__ */ React241.createElement(
    "div",
    {
      key: copyIndex,
      ref: copyIndex === 0 ? firstGroupRef : void 0,
      className: cn(DEFAULT_GROUP_CLASS4, classes.group),
      style: { gap: `${gapPx}px`, paddingLeft: `${gapPx}px` },
      "aria-hidden": copyIndex > 0 || void 0
    },
    reviews.map((review, reviewIndex) => /* @__PURE__ */ React241.createElement(
      "div",
      {
        key: `${copyIndex}-${review.id}-${reviewIndex}`,
        className: cn(DEFAULT_ITEM_CLASS8, classes.item),
        style: { width: cardWidthCss }
      },
      /* @__PURE__ */ React241.createElement(
        ReviewCard2,
        {
          ...review,
          verified,
          verifiedLabel,
          verifiedIcon,
          cleanVersion,
          className: cardClassName,
          classes: cardClasses
        }
      )
    ))
  )))));
}

// src/sections/ReviewCarouselSection.tsx
var DEFAULT_SECTION_CLASS9 = "w-full [background:var(--review-carousel-section-bg)]";
var DEFAULT_HEADER_CLASS11 = "";
var DEFAULT_RATING_CLASS4 = "mb-2 flex flex-wrap items-center justify-center gap-2 text-center text-[16px] leading-5 font-bold text-[#333333]";
var DEFAULT_RATING_ICON_CLASS2 = "h-5 w-auto object-contain [&_svg]:h-5 [&_svg]:w-[112px]";
var DEFAULT_RATING_TEXT_CLASS2 = "flex flex-wrap items-center justify-center gap-1.5";
var DEFAULT_RATING_LABEL_CLASS2 = "";
var DEFAULT_HAPPY_CUSTOMERS_LABEL_CLASS = "";
var DEFAULT_HEADING_CLASS4 = "text-(--review-carousel-heading)";
var DEFAULT_SUBHEADING_CLASS4 = "text-(--review-carousel-subheading)";
var DEFAULT_DIVIDER_CLASS10 = "bg-(--review-carousel-accent)";
var DEFAULT_REVIEW_TEXT_CLASS = "text-(--review-carousel-text)";
var DEFAULT_CAROUSEL_WRAPPER_CLASS = "mt-10";
var DEFAULT_CAROUSEL_CLASS = "";
function buildVars3({
  sectionBgColor,
  headingTextColor,
  subheadingTextColor,
  textColor,
  accentColor
}) {
  return {
    "--review-carousel-section-bg": sectionBgColor != null ? sectionBgColor : "var(--theme-color-bg-section, #E7F4FD)",
    "--review-carousel-heading": headingTextColor != null ? headingTextColor : "var(--theme-color-heading-primary, #000000)",
    "--review-carousel-subheading": subheadingTextColor != null ? subheadingTextColor : "var(--theme-color-text-secondary, #333333)",
    "--review-carousel-text": textColor != null ? textColor : "var(--theme-color-text-primary, #333333)",
    "--review-carousel-accent": accentColor != null ? accentColor : "var(--theme-color-accent, #0090CD)"
  };
}
var ReviewCarouselSection = ({
  displayOption = "carousel",
  heading,
  headingHtml,
  subheading,
  showSubheading = true,
  showRating = true,
  ratingLabel,
  happyCustomersLabel,
  ratingIcon,
  ratingIconAlt = "",
  headingAs = "h2",
  subheadingPlacement = "before-divider",
  showDivider = true,
  sectionBgColor,
  headingTextColor,
  subheadingTextColor,
  textColor,
  accentColor,
  reviews,
  gapPx,
  peekPx,
  minCardWidth,
  maxCardWidth,
  verified,
  verifiedLabel,
  verifiedIcon,
  sectionSpacing,
  className,
  classes = {},
  carouselClassName,
  carouselClasses,
  motionClassName,
  motionClasses,
  cardClassName,
  cardClasses,
  cleanVersion = false
}) => {
  const resolvedSubheading = showSubheading ? subheading : void 0;
  const hasRatingText = Boolean(ratingLabel || happyCustomersLabel);
  const shouldRenderRating = showRating !== false && hasRatingText;
  const reviewCardClasses = {
    ...cardClasses,
    review: classNames94(DEFAULT_REVIEW_TEXT_CLASS, cardClasses == null ? void 0 : cardClasses.review)
  };
  if (!heading && !headingHtml && !resolvedSubheading && !shouldRenderRating && !showDivider && (!reviews || reviews.length === 0)) {
    return null;
  }
  return /* @__PURE__ */ React242.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS9,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars3({
        sectionBgColor,
        headingTextColor,
        subheadingTextColor,
        textColor,
        accentColor
      })
    },
    shouldRenderRating && /* @__PURE__ */ React242.createElement("div", { className: classNames94(DEFAULT_RATING_CLASS4, classes.rating) }, ratingIcon ? /* @__PURE__ */ React242.createElement(
      Image,
      {
        src: ratingIcon,
        alt: ratingIconAlt,
        className: classNames94(DEFAULT_RATING_ICON_CLASS2, classes.ratingIcon)
      }
    ) : /* @__PURE__ */ React242.createElement(
      "span",
      {
        className: classNames94(DEFAULT_RATING_ICON_CLASS2, classes.ratingIcon),
        "aria-hidden": "true"
      },
      STAR_SVG.five
    ), /* @__PURE__ */ React242.createElement("div", { className: classNames94(DEFAULT_RATING_TEXT_CLASS2, classes.ratingText) }, ratingLabel && /* @__PURE__ */ React242.createElement("span", { className: classNames94(DEFAULT_RATING_LABEL_CLASS2, classes.ratingLabel) }, ratingLabel), happyCustomersLabel && !cleanVersion && /* @__PURE__ */ React242.createElement(
      "span",
      {
        className: classNames94(
          DEFAULT_HAPPY_CUSTOMERS_LABEL_CLASS,
          classes.happyCustomersLabel
        )
      },
      happyCustomersLabel
    ))),
    (heading || headingHtml || resolvedSubheading || showDivider) && /* @__PURE__ */ React242.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading: resolvedSubheading,
        headingAs,
        subheadingPlacement,
        showDivider,
        className: classNames94(DEFAULT_HEADER_CLASS11, classes.header),
        classes: {
          heading: classNames94(DEFAULT_HEADING_CLASS4, classes.heading),
          subheading: classNames94(DEFAULT_SUBHEADING_CLASS4, classes.subheading),
          divider: classNames94(DEFAULT_DIVIDER_CLASS10, classes.divider)
        }
      }
    ),
    (reviews == null ? void 0 : reviews.length) > 0 && /* @__PURE__ */ React242.createElement("div", { className: classNames94(DEFAULT_CAROUSEL_WRAPPER_CLASS, classes.carouselWrapper) }, /* @__PURE__ */ React242.createElement("div", { className: classNames94(DEFAULT_CAROUSEL_CLASS, classes.carousel) }, displayOption === "motion" ? /* @__PURE__ */ React242.createElement(
      ReviewCarouselMotion,
      {
        reviews,
        gapPx,
        minCardWidth,
        maxCardWidth,
        verified,
        verifiedLabel,
        verifiedIcon,
        cleanVersion,
        className: motionClassName,
        classes: motionClasses,
        cardClassName,
        cardClasses: reviewCardClasses
      }
    ) : /* @__PURE__ */ React242.createElement(
      ReviewCarousel,
      {
        reviews,
        gapPx,
        peekPx,
        minCardWidth,
        maxCardWidth,
        verified,
        verifiedLabel,
        verifiedIcon,
        cleanVersion,
        className: carouselClassName,
        classes: carouselClasses,
        cardClassName,
        cardClasses: reviewCardClasses
      }
    )))
  );
};

// src/molecules/SegmentedOption.tsx
import React243 from "react";
var DEFAULT_OPTION_CLASS = "flex min-h-[66px] items-center justify-center border-0 bg-transparent px-3 text-center text-[16px] font-black leading-[20px] text-current transition-colors focus-visible:relative focus-visible:z-10 focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-current";
var DEFAULT_OPTION_ACTIVE_CLASS = "rounded-[4px] border-2";
var SegmentedOption = ({
  isActive,
  label,
  onSelect,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React243.createElement(
    "button",
    {
      type: "button",
      className: cn(
        DEFAULT_OPTION_CLASS,
        classes.root,
        isActive && DEFAULT_OPTION_ACTIVE_CLASS,
        isActive && classes.active,
        className
      ),
      onClick: onSelect,
      "aria-pressed": isActive
    },
    label
  );
};

// src/molecules/SelectableRadioOption.tsx
import React244 from "react";
var DEFAULT_ROOT_CLASS30 = "flex h-[42px] w-full items-center gap-[12px] rounded-[4px] border px-[12px] text-left text-[12px] font-normal leading-[16px]";
var SelectableRadioOption = ({
  isSelected = false,
  label,
  onClick,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React244.createElement(
    "button",
    {
      type: "button",
      className: cn(DEFAULT_ROOT_CLASS30, classes.root, isSelected && classes.active, className),
      onClick
    },
    /* @__PURE__ */ React244.createElement(
      SelectableRadio,
      {
        isActive: isSelected,
        classes: {
          wrapper: classes.radioWrapper,
          indicator: classes.radioIndicator,
          active: classes.radioActive
        }
      }
    ),
    /* @__PURE__ */ React244.createElement("span", { className: classes.label }, label)
  );
};

// src/sections/FeaturesImageSection.tsx
import React245 from "react";
var DEFAULT_SECTION_CLASS10 = "w-full px-4 md:px-10 lg:px-20 [background:var(--features-image-section-bg)] flex justify-center";
var DEFAULT_INNER_CLASS6 = "max-w-[1100px] w-full flex flex-col lg:flex-row gap-10 items-center [background:var(--features-image-panel-bg)] rounded-2xl overflow-hidden pt-6 px-4 pb-0 md:p-10 lg:pl-0 lg:pr-10 lg:py-10";
var DEFAULT_IMAGE_WRAPPER_CLASS3 = "relative flex-shrink-0 w-[300px] h-[300px] md:w-[400px] md:h-[400px] order-last lg:order-first";
var DEFAULT_IMAGE_CLASS10 = "w-full h-full object-cover rounded-2xl";
var DEFAULT_CONTENT_WRAPPER_CLASS2 = "flex-1 flex flex-col gap-6 min-w-0 w-full";
var DEFAULT_HEADER_GROUP_CLASS = "flex flex-col gap-4";
var DEFAULT_PARAGRAPH_CLASS = "text-base md:text-lg leading-relaxed text-(--features-image-text) text-center lg:text-left";
var DEFAULT_FEATURES_LIST_CLASS2 = "flex flex-col gap-4 md:gap-6";
var DEFAULT_FEATURE_ITEM_CLASS2 = "flex gap-4 items-start";
var DEFAULT_FEATURE_ICON_CLASS2 = "flex-shrink-0 w-[54px] h-[54px] [background:var(--features-image-feature-icon-bg)] rounded-full flex items-center justify-center p-[10px]";
var DEFAULT_FEATURE_ICON_IMAGE_CLASS = "w-full h-full object-contain";
var DEFAULT_FEATURE_TEXT_CLASS2 = "flex flex-col gap-2";
var DEFAULT_FEATURE_TITLE_CLASS = "text-base md:text-lg font-bold leading-snug text-(--features-image-text)";
var DEFAULT_FEATURE_DESCRIPTION_CLASS = "text-base md:text-lg leading-relaxed text-(--features-image-text)";
function buildVars4({
  sectionBgColor,
  featuresBgColor,
  featureIconBgColor,
  headingTextColor,
  textColor
}) {
  return {
    "--features-image-section-bg": sectionBgColor != null ? sectionBgColor : "var(--theme-color-bg-page, #FFFFFF)",
    "--features-image-panel-bg": featuresBgColor != null ? featuresBgColor : "linear-gradient(180deg, #E7F4FD 0%, #CFEBFF 100%)",
    "--features-image-feature-icon-bg": featureIconBgColor != null ? featureIconBgColor : "var(--theme-color-accent, #4646DA)",
    "--features-image-heading": headingTextColor != null ? headingTextColor : "var(--theme-color-heading-primary, #000000)",
    "--features-image-text": textColor != null ? textColor : "var(--theme-color-text-primary, #333333)"
  };
}
var FeaturesImageSection = ({
  heading,
  headingHtml,
  headingAs,
  paragraph,
  features = [],
  image,
  imageAlt = "",
  sectionBgColor,
  featuresBgColor,
  featureIconBgColor,
  headingTextColor,
  textColor,
  sectionSpacing,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React245.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS10,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars4({
        sectionBgColor,
        featuresBgColor,
        featureIconBgColor,
        headingTextColor,
        textColor
      })
    },
    /* @__PURE__ */ React245.createElement("div", { className: cn(DEFAULT_INNER_CLASS6, classes.inner) }, /* @__PURE__ */ React245.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS3, classes.imageWrapper) }, /* @__PURE__ */ React245.createElement(Image, { src: image, alt: imageAlt, className: cn(DEFAULT_IMAGE_CLASS10, classes.image) })), /* @__PURE__ */ React245.createElement("div", { className: cn(DEFAULT_CONTENT_WRAPPER_CLASS2, classes.contentWrapper) }, (heading || headingHtml || paragraph) && /* @__PURE__ */ React245.createElement("div", { className: cn(DEFAULT_HEADER_GROUP_CLASS, classes.headerGroup) }, (heading || headingHtml) && /* @__PURE__ */ React245.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        showDivider: false,
        classes: {
          container: cn("items-center lg:items-start", classes.header),
          heading: cn(
            "font-extrabold text-3xl md:text-4xl leading-snug text-(--features-image-heading) text-center lg:text-left",
            classes.heading
          )
        }
      }
    ), paragraph && /* @__PURE__ */ React245.createElement(
      RichText,
      {
        html: paragraph,
        className: cn(DEFAULT_PARAGRAPH_CLASS, classes.paragraph)
      }
    )), features.length > 0 && /* @__PURE__ */ React245.createElement("ul", { className: cn(DEFAULT_FEATURES_LIST_CLASS2, classes.featuresList) }, features.map((feature, index) => /* @__PURE__ */ React245.createElement("li", { key: index, className: cn(DEFAULT_FEATURE_ITEM_CLASS2, classes.featureItem) }, /* @__PURE__ */ React245.createElement("div", { className: cn(DEFAULT_FEATURE_ICON_CLASS2, classes.featureIcon) }, /* @__PURE__ */ React245.createElement(
      Icon,
      {
        src: feature.icon,
        alt: feature.iconAlt,
        className: cn(DEFAULT_FEATURE_ICON_IMAGE_CLASS, classes.featureIconImage)
      }
    )), /* @__PURE__ */ React245.createElement("div", { className: cn(DEFAULT_FEATURE_TEXT_CLASS2, classes.featureText) }, /* @__PURE__ */ React245.createElement(
      Text,
      {
        as: "span",
        className: cn(DEFAULT_FEATURE_TITLE_CLASS, classes.featureTitle)
      },
      feature.title
    ), /* @__PURE__ */ React245.createElement(
      RichText,
      {
        html: feature.description,
        className: cn(DEFAULT_FEATURE_DESCRIPTION_CLASS, classes.featureDescription)
      }
    )))))))
  );
};

// src/sections/StatsThreeResultsWithoutImageSection.tsx
import React246, { useEffect as useEffect22, useRef as useRef14, useState as useState25 } from "react";
var DEFAULT_SECTION_CLASS11 = "w-full bg-white px-6 md:px-12 lg:px-20";
var DEFAULT_INNER_CLASS7 = "mx-auto w-full max-w-body";
var DEFAULT_LIST_CLASS5 = "flex w-full flex-col gap-8 lg:grid lg:grid-cols-3 lg:gap-8";
var DEFAULT_ITEM_CLASS9 = "relative flex w-full flex-col gap-6 pb-8 last:pb-0 lg:pr-8 lg:pb-0";
var DEFAULT_CONTENT_CLASS14 = "flex w-full flex-row items-center justify-center gap-[10px]";
var DEFAULT_PERCENTAGE_CLASS = "shrink-0 text-left text-[56px] leading-[56px] font-bold text-[var(--theme-color-accent,#0075A7)]";
var DEFAULT_TEXT_CLASS13 = "flex-1 text-left text-[18px] leading-6 font-medium text-[var(--theme-color-text-primary,#333333)]";
var DEFAULT_PROGRESS_TRACK_CLASS2 = "flex h-6 w-full overflow-hidden rounded-[5px] bg-[var(--theme-color-border-light,#E0E0E0)]";
var DEFAULT_PROGRESS_FILL_CLASS2 = "h-full rounded-l-[5px] bg-[linear-gradient(90deg,#0075A7_22%,#86CEFF_100%)]";
var DEFAULT_DIVIDER_CLASS11 = "absolute bottom-0 left-0 h-px w-full bg-[var(--theme-color-border,#B4B4B4)] lg:top-0 lg:right-0 lg:left-auto lg:h-full lg:w-px";
var clampPercentage = (percentage) => Math.max(0, Math.min(100, percentage));
var HTML_ENTITY_MAP = {
  amp: "&",
  apos: "'",
  gt: ">",
  ldquo: '"',
  lsquo: "'",
  lt: "<",
  mdash: "-",
  nbsp: " ",
  ndash: "-",
  quot: '"',
  rdquo: '"',
  rsquo: "'"
};
var decodeHtmlEntities = (text) => text.replace(/&(#\d+|#x[\da-f]+|[a-z]+);/gi, (match, entity) => {
  var _a;
  const normalized = entity.toLowerCase();
  if (normalized.startsWith("#x")) {
    const codePoint = Number.parseInt(normalized.slice(2), 16);
    return Number.isFinite(codePoint) && codePoint <= 1114111 ? String.fromCodePoint(codePoint) : match;
  }
  if (normalized.startsWith("#")) {
    const codePoint = Number.parseInt(normalized.slice(1), 10);
    return Number.isFinite(codePoint) && codePoint <= 1114111 ? String.fromCodePoint(codePoint) : match;
  }
  return (_a = HTML_ENTITY_MAP[normalized]) != null ? _a : match;
});
var getPlainText = (html) => decodeHtmlEntities(html.replace(/<[^>]*>/g, " ")).replace(/\s+/g, " ").trim();
var StatsThreeResultsWithoutImageSection = ({ items = [], sectionSpacing, className, classes = {} }) => {
  const sectionRef = useRef14(null);
  const [isVisible, setIsVisible] = useState25(false);
  const [reducedMotion, setReducedMotion] = useState25(false);
  useEffect22(() => {
    var _a;
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updateReducedMotion = () => setReducedMotion(mediaQuery.matches);
    updateReducedMotion();
    (_a = mediaQuery.addEventListener) == null ? void 0 : _a.call(mediaQuery, "change", updateReducedMotion);
    return () => {
      var _a2;
      return (_a2 = mediaQuery.removeEventListener) == null ? void 0 : _a2.call(mediaQuery, "change", updateReducedMotion);
    };
  }, []);
  useEffect22(() => {
    const section = sectionRef.current;
    if (!section) return;
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  if (!items.length) return null;
  const shouldShowProgress = isVisible || reducedMotion;
  const renderItem = (item, index) => {
    const percentage = clampPercentage(item.percentage);
    const fillWidth = shouldShowProgress ? `${percentage}%` : "0%";
    const textLabel = getPlainText(item.text) || item.text;
    return /* @__PURE__ */ React246.createElement("li", { key: `${textLabel}-${index}`, className: cn(DEFAULT_ITEM_CLASS9, classes.item) }, /* @__PURE__ */ React246.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS14, classes.content) }, /* @__PURE__ */ React246.createElement(Text, { as: "span", className: cn(DEFAULT_PERCENTAGE_CLASS, classes.percentage) }, percentage, "%"), /* @__PURE__ */ React246.createElement(RichText, { html: item.text, className: cn(DEFAULT_TEXT_CLASS13, classes.text) })), /* @__PURE__ */ React246.createElement(
      "div",
      {
        className: cn(DEFAULT_PROGRESS_TRACK_CLASS2, classes.progressTrack),
        role: "progressbar",
        "aria-label": textLabel,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": percentage
      },
      /* @__PURE__ */ React246.createElement(
        "div",
        {
          className: cn(
            DEFAULT_PROGRESS_FILL_CLASS2,
            !reducedMotion && "transition-[width] duration-1000 ease-out",
            classes.progressFill,
            item.progressClassName
          ),
          style: { width: fillWidth }
        }
      )
    ), index < items.length - 1 && /* @__PURE__ */ React246.createElement("span", { className: cn(DEFAULT_DIVIDER_CLASS11, classes.divider), "aria-hidden": "true" }));
  };
  return /* @__PURE__ */ React246.createElement(
    "section",
    {
      ref: sectionRef,
      className: cn(
        DEFAULT_SECTION_CLASS11,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      )
    },
    /* @__PURE__ */ React246.createElement("div", { className: cn(DEFAULT_INNER_CLASS7, classes.inner) }, /* @__PURE__ */ React246.createElement("ul", { className: cn(DEFAULT_LIST_CLASS5, classes.list) }, items.map(renderItem)))
  );
};

// src/sections/StatsImageResultsSection.tsx
import React247, { useEffect as useEffect23, useRef as useRef15, useState as useState26 } from "react";
var DEFAULT_SECTION_CLASS12 = "w-full [background:var(--stats-bg)]";
var DEFAULT_INNER_CLASS8 = "mx-auto w-full max-w-[1132px] px-4";
var DEFAULT_LAYOUT_CLASS = "flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-10";
var DEFAULT_IMAGE_WRAPPER_CLASS4 = "order-2 lg:order-1 lg:w-[550px] lg:shrink-0";
var DEFAULT_IMAGE_CLASS11 = "w-full h-auto rounded-[20px] object-cover lg:h-[500px]";
var DEFAULT_CONTENT_WRAPPER_CLASS3 = "order-1 lg:order-2 flex flex-1 flex-col gap-6";
var DEFAULT_HEADER_CLASS12 = "lg:items-start lg:text-left";
var DEFAULT_LIST_CLASS6 = "flex flex-col gap-4";
var DEFAULT_ITEM_CLASS10 = "relative flex flex-col gap-4 pb-4 last:pb-0";
var DEFAULT_ITEM_ROW_CLASS = "flex flex-col gap-4 md:flex-row md:items-center md:gap-6";
var DEFAULT_ITEM_HEADER_CLASS = "flex items-center gap-4 md:shrink-0";
var DEFAULT_PERCENTAGE_CLASS2 = "w-[108px] shrink-0 text-left text-[56px] leading-[56px] font-bold text-(--stats-primary-color)";
var DEFAULT_TEXT_CLASS14 = "text-left text-[18px] leading-[26px] font-medium font-outfit text-(--stats-text-color)";
var DEFAULT_SECTION_DESCRIPTION_CLASS2 = "text-base md:text-[18px]/[26px] text-center lg:text-left text-[var(--stats-text-color)]";
var DEFAULT_RIGHT_COL_CLASS = "flex flex-1 flex-col gap-2";
var DEFAULT_PROGRESS_TRACK_CLASS3 = "flex h-6 w-full overflow-hidden rounded-[5px] bg-(--stats-track-bg)";
var DEFAULT_PROGRESS_FILL_CLASS3 = "h-full rounded-l-[5px] [background:var(--stats-progress-gradient)]";
var DEFAULT_DIVIDER_CLASS12 = "absolute bottom-0 left-0 h-px w-full bg-(--stats-divider-color)";
var DEFAULT_HEADER_DIVIDER_CLASS = "bg-(--stats-primary-color)";
function buildVars5(colors) {
  var _a, _b, _c, _d, _e, _f;
  return {
    "--stats-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--stats-primary-color": (_b = colors == null ? void 0 : colors.primaryColor) != null ? _b : "var(--theme-color-accent, #0075A7)",
    "--stats-text-color": (_c = colors == null ? void 0 : colors.textColor) != null ? _c : "var(--theme-color-text-primary, #333333)",
    "--stats-track-bg": (_d = colors == null ? void 0 : colors.trackBackground) != null ? _d : "var(--theme-color-border-light, #E0E0E0)",
    "--stats-progress-gradient": (_e = colors == null ? void 0 : colors.progressGradient) != null ? _e : "linear-gradient(90deg, #0075A7 22%, #86CEFF 100%)",
    "--stats-divider-color": (_f = colors == null ? void 0 : colors.dividerColor) != null ? _f : "var(--theme-color-border, #E0E0E0)"
  };
}
var clampPercentage2 = (n) => Math.max(0, Math.min(100, n));
var HTML_ENTITY_MAP2 = {
  amp: "&",
  apos: "'",
  gt: ">",
  ldquo: '"',
  lsquo: "'",
  lt: "<",
  mdash: "-",
  nbsp: " ",
  ndash: "-",
  quot: '"',
  rdquo: '"',
  rsquo: "'"
};
var decodeHtmlEntities2 = (text) => text.replace(/&(#\d+|#x[\da-f]+|[a-z]+);/gi, (match, entity) => {
  var _a;
  const normalized = entity.toLowerCase();
  if (normalized.startsWith("#x")) {
    const codePoint = Number.parseInt(normalized.slice(2), 16);
    return Number.isFinite(codePoint) && codePoint <= 1114111 ? String.fromCodePoint(codePoint) : match;
  }
  if (normalized.startsWith("#")) {
    const codePoint = Number.parseInt(normalized.slice(1), 10);
    return Number.isFinite(codePoint) && codePoint <= 1114111 ? String.fromCodePoint(codePoint) : match;
  }
  return (_a = HTML_ENTITY_MAP2[normalized]) != null ? _a : match;
});
var getPlainText2 = (html) => decodeHtmlEntities2(html.replace(/<[^>]*>/g, " ")).replace(/\s+/g, " ").trim();
var StatsImageResultsSection = ({
  assetType,
  image,
  imageAlt = "",
  videoUrl,
  heading,
  headingHtml,
  subheading,
  sectionDescription,
  headingAs = "h2",
  items = [],
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const sectionRef = useRef15(null);
  const [isVisible, setIsVisible] = useState26(false);
  const [reducedMotion, setReducedMotion] = useState26(false);
  const resolvedAssetType = assetType === "video" ? "video" : "image";
  const mediaUrl = resolvedAssetType === "video" ? videoUrl : image;
  useEffect23(() => {
    var _a;
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(mq.matches);
    update();
    (_a = mq.addEventListener) == null ? void 0 : _a.call(mq, "change", update);
    return () => {
      var _a2;
      return (_a2 = mq.removeEventListener) == null ? void 0 : _a2.call(mq, "change", update);
    };
  }, []);
  useEffect23(() => {
    const section = sectionRef.current;
    if (!section) return;
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const shouldAnimate = isVisible || reducedMotion;
  const renderItem = (item, index) => {
    const pct = clampPercentage2(item.percentage);
    const fillWidth = shouldAnimate ? `${pct}%` : "0%";
    const ariaLabel = getPlainText2(item.text) || void 0;
    const isLast = index === items.length - 1;
    return /* @__PURE__ */ React247.createElement("li", { key: index, className: cn(DEFAULT_ITEM_CLASS10, classes.item) }, /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_ITEM_ROW_CLASS, classes.itemRow) }, /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_ITEM_HEADER_CLASS, classes.itemHeader) }, /* @__PURE__ */ React247.createElement(Text, { as: "span", className: cn(DEFAULT_PERCENTAGE_CLASS2, classes.percentage) }, pct, "%"), /* @__PURE__ */ React247.createElement(
      RichText,
      {
        html: item.text,
        className: cn(DEFAULT_TEXT_CLASS14, "flex-1 md:hidden", classes.text)
      }
    )), /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_RIGHT_COL_CLASS, classes.rightCol) }, /* @__PURE__ */ React247.createElement(
      RichText,
      {
        html: item.text,
        className: cn(DEFAULT_TEXT_CLASS14, "hidden md:block", classes.text)
      }
    ), /* @__PURE__ */ React247.createElement(
      "div",
      {
        className: cn(DEFAULT_PROGRESS_TRACK_CLASS3, classes.progressTrack),
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct
      },
      /* @__PURE__ */ React247.createElement(
        "div",
        {
          className: cn(
            DEFAULT_PROGRESS_FILL_CLASS3,
            !reducedMotion && "transition-[width] duration-1000 ease-out",
            classes.progressFill
          ),
          style: { width: fillWidth }
        }
      )
    ))), !isLast && /* @__PURE__ */ React247.createElement("span", { className: cn(DEFAULT_DIVIDER_CLASS12, classes.divider), "aria-hidden": "true" }));
  };
  if (!items.length) return null;
  return /* @__PURE__ */ React247.createElement(
    "section",
    {
      ref: sectionRef,
      className: cn(
        DEFAULT_SECTION_CLASS12,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars5(colors)
    },
    /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_INNER_CLASS8, classes.inner) }, /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_LAYOUT_CLASS, classes.layout) }, mediaUrl && /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS4, classes.imageWrapper) }, resolvedAssetType === "video" ? /* @__PURE__ */ React247.createElement(
      Video,
      {
        src: mediaUrl,
        ariaLabel: imageAlt,
        className: cn(DEFAULT_IMAGE_CLASS11, "aspect-auto rounded-[20px]", classes.image)
      }
    ) : /* @__PURE__ */ React247.createElement(
      Image,
      {
        src: mediaUrl,
        alt: imageAlt,
        className: cn(DEFAULT_IMAGE_CLASS11, classes.image)
      }
    )), /* @__PURE__ */ React247.createElement("div", { className: cn(DEFAULT_CONTENT_WRAPPER_CLASS3, classes.contentWrapper) }, (heading || headingHtml || subheading) && /* @__PURE__ */ React247.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading,
        headingAs,
        subheadingPlacement: "after-divider",
        className: cn(DEFAULT_HEADER_CLASS12, classes.header),
        classes: {
          heading: classes.heading,
          subheading: classes.subheading,
          divider: cn(DEFAULT_HEADER_DIVIDER_CLASS, classes.divider)
        }
      }
    ), sectionDescription && /* @__PURE__ */ React247.createElement(
      RichText,
      {
        html: sectionDescription,
        className: cn(DEFAULT_SECTION_DESCRIPTION_CLASS2, classes.sectionDescription)
      }
    ), items.length > 0 && /* @__PURE__ */ React247.createElement("ul", { className: cn(DEFAULT_LIST_CLASS6, classes.list) }, items.map(renderItem)))))
  );
};

// src/sections/StatsImageResultsCTASection.tsx
import React248, { useEffect as useEffect24, useRef as useRef16, useState as useState27 } from "react";
var clampPercentage3 = (n) => Math.max(0, Math.min(100, n));
var isGradient = (value) => value.includes("gradient");
var HTML_ENTITY_MAP3 = {
  amp: "&",
  apos: "'",
  gt: ">",
  ldquo: '"',
  lsquo: "'",
  lt: "<",
  mdash: "-",
  nbsp: " ",
  ndash: "-",
  quot: '"',
  rdquo: '"',
  rsquo: "'"
};
var decodeHtmlEntities3 = (text) => text.replace(/&(#\d+|#x[\da-f]+|[a-z]+);/gi, (match, entity) => {
  var _a;
  const normalized = entity.toLowerCase();
  if (normalized.startsWith("#x")) {
    const codePoint = Number.parseInt(normalized.slice(2), 16);
    return Number.isFinite(codePoint) && codePoint <= 1114111 ? String.fromCodePoint(codePoint) : match;
  }
  if (normalized.startsWith("#")) {
    const codePoint = Number.parseInt(normalized.slice(1), 10);
    return Number.isFinite(codePoint) && codePoint <= 1114111 ? String.fromCodePoint(codePoint) : match;
  }
  return (_a = HTML_ENTITY_MAP3[normalized]) != null ? _a : match;
});
var getPlainText3 = (html) => decodeHtmlEntities3(html.replace(/<[^>]*>/g, " ")).replace(/\s+/g, " ").trim();
var DEFAULT_SECTION_CLASS13 = "w-full [background:var(--stats-bg)]";
var DEFAULT_INNER_CLASS9 = "mx-auto w-full max-w-[1132px] px-4";
var DEFAULT_LAYOUT_CLASS2 = "flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-10";
var DEFAULT_IMAGE_CARD_CLASS = "lg:w-[550px] lg:shrink-0 lg:self-stretch order-1 lg:order-0";
var DEFAULT_IMAGE_CARD_INNER_CLASS = "flex h-full flex-col gap-6 items-center justify-center rounded-[20px] [background:var(--stats-card-bg)] pt-6 px-4 pb-4";
var DEFAULT_CARD_HEADER_CLASS = "flex flex-col gap-4 items-start w-full shrink-0";
var DEFAULT_CARD_ICON_ROW_CLASS = "flex items-center gap-4 w-full";
var DEFAULT_CARD_ICON_WRAPPER_CLASS = "size-12 shrink-0 flex items-center justify-center rounded-full";
var DEFAULT_CARD_TITLE_CLASS = "text-[24px] leading-8 font-bold text-[var(--stats-primary-color)]";
var DEFAULT_CARD_DESCRIPTION_CLASS = "text-[16px] leading-6 text-[var(--stats-text-color)]";
var DEFAULT_SECTION_DESCRIPTION_CLASS3 = "text-base md:text-[18px]/[26px] text-center lg:text-left text-[var(--stats-text-color)]";
var DEFAULT_IMAGE_COMPARE_CLASS = "flex items-start w-full shrink-0";
var DEFAULT_IMAGE_BEFORE_WRAPPER_CLASS = "flex-1 min-w-0 overflow-hidden rounded-bl-[10px] rounded-tl-[10px] relative";
var DEFAULT_IMAGE_AFTER_WRAPPER_CLASS = "flex-1 min-w-0 overflow-hidden rounded-br-[10px] rounded-tr-[10px] relative";
var DEFAULT_IMAGE_CLASS12 = "w-full h-[200px] lg:h-[250px] object-cover block";
var DEFAULT_BEFORE_LABEL_CLASS = "absolute bottom-0 left-0 w-full flex items-center justify-center py-1 px-2 [background:var(--stats-before-color)]";
var DEFAULT_AFTER_LABEL_CLASS = "absolute bottom-0 left-0 w-full flex items-center justify-center py-1 px-2 [background:var(--stats-after-color)]";
var DEFAULT_LABEL_TEXT_CLASS = "text-white text-[16px] font-semibold uppercase leading-[18px] shrink-0";
var DEFAULT_CARD_STATS_CLASS = "flex items-start gap-6 w-full shrink-0";
var DEFAULT_CARD_STAT_COL_CLASS = "flex-1 flex flex-col items-center";
var DEFAULT_CARD_STAT_LABEL_CLASS = "text-[24px] leading-8 font-bold text-[var(--stats-text-color)]";
var DEFAULT_BEFORE_STAT_VALUE_CLASS = "text-[32px] leading-10 font-bold text-[var(--stats-before-color)]";
var DEFAULT_AFTER_STAT_VALUE_CLASS = "text-[32px] leading-10 font-bold text-[var(--stats-primary-color)]";
var DEFAULT_CONTENT_WRAPPER_CLASS4 = "flex flex-1 flex-col gap-6 lg:gap-8 items-center lg:items-start";
var DEFAULT_HEADER_CLASS13 = "lg:items-start lg:text-left";
var DEFAULT_HEADER_HEADING_CLASS = "text-[32px] font-extrabold leading-[40px] lg:text-[36px] lg:leading-[44px] text-[var(--stats-heading-color)]";
var DEFAULT_HEADER_SUBHEADING_CLASS = "text-[var(--stats-text-color)] text-center lg:text-left max-w-none";
var DEFAULT_HEADER_DIVIDER_CLASS2 = "[background:var(--stats-divider-color)]";
var DEFAULT_LIST_CLASS7 = "flex flex-col gap-4";
var DEFAULT_ITEM_CLASS11 = "relative flex flex-col gap-2 pb-4 last:pb-0";
var DEFAULT_ITEM_ROW_CLASS2 = "flex items-center gap-2";
var DEFAULT_PERCENTAGE_CLASS3 = "shrink-0 text-left text-[32px] leading-8 font-bold text-[var(--stats-primary-color)]";
var DEFAULT_TEXT_CLASS15 = "flex-1 text-left text-[18px]/[26px] font-medium font-outfit text-[var(--stats-text-color)]";
var DEFAULT_PROGRESS_TRACK_CLASS4 = "flex h-4 w-full overflow-hidden rounded-[5px] [background:var(--stats-track-bg)]";
var DEFAULT_PROGRESS_FILL_CLASS4 = "h-full rounded-l-[5px] [background:var(--stats-progress)]";
var DEFAULT_CTA_WRAPPER_CLASS3 = "flex flex-col items-center gap-2 w-full md:w-[400px]";
var DEFAULT_CTA_BUTTON_CLASS3 = "w-full h-14 text-[20px] font-bold leading-7 rounded-[10px] px-6 py-2.5 lg:py-3";
var DEFAULT_CTA_ICON_CLASS3 = "size-6 shrink-0";
var DEFAULT_CTA_FALLBACK_ICON_CLASS2 = "text-(--button-icon-color)";
function buildVars6(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const primaryColor = (_a = colors == null ? void 0 : colors.primaryColor) != null ? _a : "var(--theme-color-accent, #0075A7)";
  const secondaryAccentColor = (_b = colors == null ? void 0 : colors.secondaryAccentColor) != null ? _b : "#ED1E79";
  return {
    "--stats-bg": (_c = colors == null ? void 0 : colors.background) != null ? _c : "var(--theme-color-bg-page, #FFFFFF)",
    "--stats-card-bg": (_d = colors == null ? void 0 : colors.cardBackground) != null ? _d : "var(--theme-color-bg-raised, #E7F4FD)",
    "--stats-heading-color": (_e = colors == null ? void 0 : colors.headingColor) != null ? _e : "var(--theme-color-heading-primary, #000000)",
    "--stats-text-color": (_f = colors == null ? void 0 : colors.textColor) != null ? _f : "var(--theme-color-text-primary, #333333)",
    "--stats-primary-color": primaryColor,
    "--stats-before-color": secondaryAccentColor,
    "--stats-after-color": primaryColor,
    "--stats-track-bg": (_g = colors == null ? void 0 : colors.trackBackground) != null ? _g : "var(--theme-color-border-light, #E0E0E0)",
    "--stats-progress": (_h = colors == null ? void 0 : colors.progressGradient) != null ? _h : "linear-gradient(90deg, #0075A7 22%, #86CEFF 100%)",
    "--stats-divider-color": (_i = colors == null ? void 0 : colors.dividerColor) != null ? _i : primaryColor
  };
}
var StatsImageResultsCTASection = ({
  heading,
  headingHtml,
  subheading,
  headingAs = "h2",
  showDivider = true,
  subheadingPlacement = "after-divider",
  cardIcon,
  cardIconAlt = "",
  cardTitle,
  cardDescription,
  sectionDescription,
  imageBeforeAssetType,
  imageBefore,
  imageBeforeVideoUrl,
  imageBeforeAlt = "",
  imageAfterAssetType,
  imageAfter,
  imageAfterVideoUrl,
  imageAfterAlt = "",
  beforeLabel = "Before",
  afterLabel = "After",
  beforeStatLabel,
  beforeStatValue,
  afterStatLabel,
  afterStatValue,
  items = [],
  cta = true,
  ctaLabel,
  ctaIcon,
  ctaText,
  ctaHref,
  ctaBackgroundColor,
  ctaBackgroundGradient,
  ctaBackgroundHoverColor,
  ctaBackgroundHoverGradient,
  ctaTextColor,
  ctaBorderColor,
  ctaIconColor,
  cleanVersion = false,
  showShipBy = false,
  shipByText,
  daysFromNow,
  shipByLocale,
  showStockLevel = false,
  stockLevelLabel,
  stockLevel = 30,
  stockLevelLowLabel,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const sectionRef = useRef16(null);
  const [isVisible, setIsVisible] = useState27(false);
  const [reducedMotion, setReducedMotion] = useState27(false);
  useEffect24(() => {
    var _a;
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(mq.matches);
    update();
    (_a = mq.addEventListener) == null ? void 0 : _a.call(mq, "change", update);
    return () => {
      var _a2;
      return (_a2 = mq.removeEventListener) == null ? void 0 : _a2.call(mq, "change", update);
    };
  }, []);
  useEffect24(() => {
    const section = sectionRef.current;
    if (!section) return;
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const shouldAnimate = isVisible || reducedMotion;
  const resolvedBeforeAssetType = imageBeforeAssetType === "video" ? "video" : "image";
  const resolvedAfterAssetType = imageAfterAssetType === "video" ? "video" : "image";
  const beforeMediaUrl = resolvedBeforeAssetType === "video" ? imageBeforeVideoUrl : imageBefore;
  const afterMediaUrl = resolvedAfterAssetType === "video" ? imageAfterVideoUrl : imageAfter;
  const hasImageCard = !!(cardTitle || cardDescription || cardIcon || beforeMediaUrl || afterMediaUrl);
  const resolvedCtaLabel = ctaLabel != null ? ctaLabel : ctaText;
  const hasCTA = cta && !!resolvedCtaLabel;
  const hasShipBy = !cleanVersion && showShipBy && !!shipByText;
  const hasStockLevel = !cleanVersion && showStockLevel && !!stockLevelLabel;
  const hasSubCta = hasShipBy || hasStockLevel;
  const resolvedCtaBackground = ctaBackgroundGradient || ctaBackgroundColor || "linear-gradient(to top, #ffcd5a 4.464%, #ffe65b 100%)";
  const resolvedCtaHoverBackground = ctaBackgroundHoverGradient || ctaBackgroundHoverColor || (isGradient(resolvedCtaBackground) ? lightenGradient(resolvedCtaBackground, 0.1) : lightenHex(resolvedCtaBackground, 0.2));
  const ctaStyle = hasCTA ? {
    "--cta-bg": resolvedCtaBackground,
    "--button-hover-color": resolvedCtaHoverBackground,
    "--button-text-color": ctaTextColor != null ? ctaTextColor : "#000000",
    "--button-border-color": ctaBorderColor != null ? ctaBorderColor : "#d39208",
    "--button-icon-color": ctaIconColor != null ? ctaIconColor : "#9B6A00"
  } : void 0;
  if (!hasImageCard && !items.length && !heading && !headingHtml && !subheading && !sectionDescription && !hasCTA && !hasSubCta)
    return null;
  const renderItem = (item, index) => {
    const pct = clampPercentage3(item.percentage);
    const fillWidth = shouldAnimate ? `${pct}%` : "0%";
    const ariaLabel = getPlainText3(item.text) || void 0;
    return /* @__PURE__ */ React248.createElement("li", { key: index, className: cn(DEFAULT_ITEM_CLASS11, classes.item) }, /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_ITEM_ROW_CLASS2, classes.itemRow) }, /* @__PURE__ */ React248.createElement(Text, { as: "span", className: cn(DEFAULT_PERCENTAGE_CLASS3, classes.percentage) }, pct, "%"), /* @__PURE__ */ React248.createElement(RichText, { html: item.text, className: cn(DEFAULT_TEXT_CLASS15, classes.text) })), /* @__PURE__ */ React248.createElement(
      "div",
      {
        className: cn(DEFAULT_PROGRESS_TRACK_CLASS4, classes.progressTrack),
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct
      },
      /* @__PURE__ */ React248.createElement(
        "div",
        {
          className: cn(
            DEFAULT_PROGRESS_FILL_CLASS4,
            !reducedMotion && "transition-[width] duration-1000 ease-out",
            classes.progressFill
          ),
          style: { width: fillWidth }
        }
      )
    ));
  };
  const renderHeader = () => /* @__PURE__ */ React248.createElement(
    SectionHeader,
    {
      heading,
      headingHtml,
      subheading,
      headingAs,
      showDivider,
      subheadingPlacement,
      className: cn(DEFAULT_HEADER_CLASS13, classes.header),
      classes: {
        heading: cn(DEFAULT_HEADER_HEADING_CLASS, classes.heading),
        subheading: cn(DEFAULT_HEADER_SUBHEADING_CLASS, classes.subheading),
        divider: cn(DEFAULT_HEADER_DIVIDER_CLASS2, classes.divider)
      }
    }
  );
  const renderCompareMedia = (mediaUrl, resolvedAssetType, alt, className2) => resolvedAssetType === "video" ? /* @__PURE__ */ React248.createElement(
    Video,
    {
      src: mediaUrl,
      ariaLabel: alt,
      className: cn(DEFAULT_IMAGE_CLASS12, "aspect-auto rounded-none", className2)
    }
  ) : /* @__PURE__ */ React248.createElement(Image, { src: mediaUrl, alt, className: cn(DEFAULT_IMAGE_CLASS12, className2) });
  return /* @__PURE__ */ React248.createElement(
    "section",
    {
      ref: sectionRef,
      className: cn(
        DEFAULT_SECTION_CLASS13,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars6(colors)
    },
    /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_INNER_CLASS9, classes.inner) }, (heading || headingHtml || subheading) && /* @__PURE__ */ React248.createElement("div", { className: "mb-6 lg:hidden" }, renderHeader()), /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_LAYOUT_CLASS2, classes.layout) }, hasImageCard && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_IMAGE_CARD_CLASS, classes.imageCard) }, /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_IMAGE_CARD_INNER_CLASS, classes.cardInner) }, (cardIcon || cardTitle || cardDescription) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CARD_HEADER_CLASS, classes.cardHeader) }, (cardIcon || cardTitle) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CARD_ICON_ROW_CLASS, classes.cardIconRow) }, cardIcon && /* @__PURE__ */ React248.createElement(
      "div",
      {
        className: cn(DEFAULT_CARD_ICON_WRAPPER_CLASS, classes.cardIconWrapper)
      },
      /* @__PURE__ */ React248.createElement(Image, { src: cardIcon, alt: cardIconAlt })
    ), cardTitle && /* @__PURE__ */ React248.createElement(Text, { className: cn(DEFAULT_CARD_TITLE_CLASS, classes.cardTitle) }, cardTitle)), cardDescription && /* @__PURE__ */ React248.createElement(Text, { className: cn(DEFAULT_CARD_DESCRIPTION_CLASS, classes.cardDescription) }, cardDescription)), (beforeMediaUrl || afterMediaUrl) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_IMAGE_COMPARE_CLASS, classes.imageCompareWrapper) }, beforeMediaUrl && /* @__PURE__ */ React248.createElement(
      "div",
      {
        className: cn(
          DEFAULT_IMAGE_BEFORE_WRAPPER_CLASS,
          classes.imageBeforeWrapper
        )
      },
      renderCompareMedia(
        beforeMediaUrl,
        resolvedBeforeAssetType,
        imageBeforeAlt,
        classes.imageBefore
      ),
      beforeLabel && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_BEFORE_LABEL_CLASS, classes.beforeLabel) }, /* @__PURE__ */ React248.createElement(
        Text,
        {
          as: "span",
          className: cn(DEFAULT_LABEL_TEXT_CLASS, classes.labelText)
        },
        beforeLabel
      ))
    ), afterMediaUrl && /* @__PURE__ */ React248.createElement(
      "div",
      {
        className: cn(DEFAULT_IMAGE_AFTER_WRAPPER_CLASS, classes.imageAfterWrapper)
      },
      renderCompareMedia(
        afterMediaUrl,
        resolvedAfterAssetType,
        imageAfterAlt,
        classes.imageAfter
      ),
      afterLabel && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_AFTER_LABEL_CLASS, classes.afterLabel) }, /* @__PURE__ */ React248.createElement(
        Text,
        {
          as: "span",
          className: cn(DEFAULT_LABEL_TEXT_CLASS, classes.labelText)
        },
        afterLabel
      ))
    )), (beforeStatLabel || beforeStatValue || afterStatLabel || afterStatValue) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CARD_STATS_CLASS, classes.cardStatsWrapper) }, (beforeStatLabel || beforeStatValue) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CARD_STAT_COL_CLASS, classes.cardStatColumn) }, beforeStatLabel && /* @__PURE__ */ React248.createElement(
      Text,
      {
        className: cn(DEFAULT_CARD_STAT_LABEL_CLASS, classes.beforeStatLabel)
      },
      beforeStatLabel
    ), beforeStatValue && /* @__PURE__ */ React248.createElement(
      Text,
      {
        className: cn(DEFAULT_BEFORE_STAT_VALUE_CLASS, classes.beforeStatValue)
      },
      beforeStatValue
    )), (afterStatLabel || afterStatValue) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CARD_STAT_COL_CLASS, classes.cardStatColumn) }, afterStatLabel && /* @__PURE__ */ React248.createElement(
      Text,
      {
        className: cn(DEFAULT_CARD_STAT_LABEL_CLASS, classes.afterStatLabel)
      },
      afterStatLabel
    ), afterStatValue && /* @__PURE__ */ React248.createElement(
      Text,
      {
        className: cn(DEFAULT_AFTER_STAT_VALUE_CLASS, classes.afterStatValue)
      },
      afterStatValue
    ))))), /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CONTENT_WRAPPER_CLASS4, classes.contentWrapper) }, (heading || headingHtml || subheading) && /* @__PURE__ */ React248.createElement("div", { className: "hidden lg:block" }, renderHeader()), sectionDescription && /* @__PURE__ */ React248.createElement(
      RichText,
      {
        html: sectionDescription,
        className: cn(DEFAULT_SECTION_DESCRIPTION_CLASS3, classes.sectionDescription)
      }
    ), items.length > 0 && /* @__PURE__ */ React248.createElement("ul", { className: cn(DEFAULT_LIST_CLASS7, classes.list) }, items.map(renderItem)), (hasCTA || hasSubCta) && /* @__PURE__ */ React248.createElement("div", { className: cn(DEFAULT_CTA_WRAPPER_CLASS3, classes.ctaWrapper) }, hasCTA && /* @__PURE__ */ React248.createElement(
      CTAButton,
      {
        buttonText: resolvedCtaLabel,
        icon: ctaIcon || /* @__PURE__ */ React248.createElement(
          IconArrowCircleRight,
          {
            className: cn(DEFAULT_CTA_ICON_CLASS3, DEFAULT_CTA_FALLBACK_ICON_CLASS2)
          }
        ),
        iconClassName: ctaIcon ? DEFAULT_CTA_ICON_CLASS3 : void 0,
        href: ctaHref,
        className: cn(DEFAULT_CTA_BUTTON_CLASS3, classes.ctaButton),
        style: ctaStyle
      }
    ), hasSubCta && /* @__PURE__ */ React248.createElement(
      StockAndShippingLevel,
      {
        showShipBy: hasShipBy,
        shipByText,
        daysFromNow,
        shipByLocale,
        showStockLevel: hasStockLevel,
        stockLevelLabel,
        stockLevel,
        stockLevelLowLabel,
        classes: {
          shipBy: classes.shipByWrapper,
          stockStatus: classes.stockLevelWrapper
        }
      }
    )))))
  );
};

// src/sections/FaqSection.tsx
import React249 from "react";
var DEFAULT_SECTION_CLASS14 = "w-full bg-white px-4";
var DEFAULT_CONTAINER_CLASS45 = "flex flex-col gap-10 items-center max-w-[1100px] mx-auto w-full";
var DEFAULT_HEADER_CLASS14 = "";
var DEFAULT_ACCORDION_CLASS = "";
var FAQ_VARS_DEFAULTS = {
  "--faq-accent-color": "var(--theme-color-accent, #0075A7)",
  "--faq-card-border-color": "var(--theme-color-border-light, #f0f0f0)",
  "--faq-card-background-color": "var(--theme-color-bg-raised, #fafafa)",
  "--faq-question-color": "var(--theme-color-text-primary, #333333)",
  "--faq-answer-color": "var(--theme-color-text-secondary, #666666)"
};
function buildFaqVars(colors) {
  return {
    ...FAQ_VARS_DEFAULTS,
    ...(colors == null ? void 0 : colors.accentColor) && { "--faq-accent-color": colors.accentColor },
    ...(colors == null ? void 0 : colors.cardBorder) && { "--faq-card-border-color": colors.cardBorder },
    ...(colors == null ? void 0 : colors.cardBackground) && { "--faq-card-background-color": colors.cardBackground },
    ...(colors == null ? void 0 : colors.questionText) && { "--faq-question-color": colors.questionText },
    ...(colors == null ? void 0 : colors.answerText) && { "--faq-answer-color": colors.answerText },
    ...(colors == null ? void 0 : colors.sectionBackground) && { background: colors.sectionBackground }
  };
}
var FaqSection = ({
  heading,
  headingHtml,
  subheading,
  headingAs = "h2",
  showSubheading = false,
  subheadingPlacement,
  showDivider = true,
  items,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  if (!items || items.length === 0) {
    return null;
  }
  const resolvedSubheading = showSubheading ? subheading : void 0;
  const hasHeader = Boolean(heading || headingHtml || resolvedSubheading || showDivider);
  return /* @__PURE__ */ React249.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS14,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildFaqVars(colors)
    },
    /* @__PURE__ */ React249.createElement(Container, { className: cn(DEFAULT_CONTAINER_CLASS45, classes.container) }, hasHeader && /* @__PURE__ */ React249.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading: resolvedSubheading,
        headingAs,
        subheadingPlacement,
        showDivider,
        className: cn(DEFAULT_HEADER_CLASS14, classes.header),
        classes: {
          heading: classes.heading,
          subheading: classes.subheading,
          divider: cn("[background:var(--faq-accent-color)]", classes.divider)
        }
      }
    ), /* @__PURE__ */ React249.createElement(
      FaqAccordion,
      {
        items,
        className: cn(DEFAULT_ACCORDION_CLASS, classes.accordion),
        classes: {
          container: classes.accordionContainer,
          item: classes.accordionItem,
          itemClasses: classes.itemClasses
        }
      }
    ))
  );
};

// src/sections/CompareTableSection.tsx
import React250 from "react";
var DEFAULT_SECTION_CLASS15 = "w-full px-4 [background:var(--compare-table-section-bg)]";
var DEFAULT_INNER_CLASS10 = "mx-auto flex w-full max-w-3xl flex-col items-center gap-10 md:gap-6";
var DEFAULT_HEADER_CLASS15 = "w-full gap-4";
var DEFAULT_HEADING_CLASS5 = "text-[32px] font-extrabold leading-10 text-(--compare-table-heading-text) md:text-[36px] md:leading-[44px]";
var DEFAULT_DESCRIPTION_CLASS13 = "text-base text-center leading-[26px] text-(--compare-table-text) md:text-lg";
var DEFAULT_HEADER_DIVIDER_CLASS3 = "bg-(--compare-table-accent)";
var DEFAULT_FEATURE_COL_CLASS = "flex-1 min-w-[100px]";
var DEFAULT_PRODUCT_COL_WIDTH = "w-[98px] md:w-40 lg:w-[200px] flex-shrink-0";
var DEFAULT_OTHERS_COL_WIDTH = "w-[98px] md:w-40 lg:w-[200px] flex-shrink-0";
var DEFAULT_PRODUCT_HEADER_CLASS = "relative flex flex-col items-center justify-end pb-3 pt-10 md:pb-3.5 md:pt-20 h-[68px] md:h-[120px]";
var DEFAULT_OTHERS_HEADER_CLASS = "flex flex-col items-center justify-center pb-3 pt-10 md:pb-3.5 md:pt-20 h-[68px] md:h-[120px]";
var DEFAULT_PRODUCT_IMAGE_CLASS2 = "absolute left-1/2 -translate-x-1/2 rounded-[10px] object-cover w-[98px] h-[74px] top-[-41px] md:w-40 md:h-[120px] md:top-[-64px] lg:w-[200px] lg:h-[150px] lg:top-[-79px]";
var DEFAULT_PRODUCT_LOGO_CLASS = "h-[18px] w-[80px] object-contain md:h-[27px] md:w-[140px]";
var DEFAULT_FEATURE_LABEL_CLASS = "break-words text-[16px] font-bold leading-[22px] text-(--compare-table-text) md:text-[18px] md:leading-[26px]";
var DEFAULT_ICON_SIZE_CLASS = "size-4 md:size-5";
var DEFAULT_CHECK_ICON_CLASS2 = "text-(--compare-table-check-icon)";
var DEFAULT_CROSS_ICON_CLASS = "text-(--compare-table-cross-icon)";
var DEFAULT_PRODUCT_COL_SURFACE_CLASS = "[background:var(--compare-table-product-col-bg)] border-(--compare-table-product-col-border)";
var DEFAULT_ROW_DIVIDER_CLASS = "border-b border-(--compare-table-row-divider)";
var DEFAULT_GUARANTEE_CLASS = "flex w-full flex-col items-center gap-6 overflow-hidden rounded-[20px] [background:var(--compare-table-money-back-bg)] p-6 md:flex-row md:items-center";
var DEFAULT_GUARANTEE_BORDER_CLASS = "border border-(--compare-table-money-back-border)";
var DEFAULT_GUARANTEE_BADGE_CLASS = "h-[141px] w-[101px] flex-shrink-0 rounded-[10px] object-cover";
var DEFAULT_GUARANTEE_TITLE_CLASS = "text-center font-outfit text-[24px] font-extrabold leading-tight text-(--compare-table-money-back-title) md:text-left md:text-[36px] md:leading-[44px]";
var DEFAULT_GUARANTEE_DESCRIPTION_CLASS = "text-center text-[16px]/[24px] md:text-[18px]/[26px] text-(--compare-table-money-back-text) md:text-left";
function buildVars7({
  sectionBgColor,
  ourProductColBgColor,
  ourProductColBorderColor,
  moneyBackBgColor,
  moneyBackBorderColor,
  headingTextColor,
  textColor,
  moneyBackTitleColor,
  moneyBackTextColor,
  accentColor,
  tableRowDividerColor,
  checkIconColor,
  crossIconColor
}) {
  return {
    "--compare-table-section-bg": sectionBgColor != null ? sectionBgColor : "var(--theme-color-bg-page, #FFFFFF)",
    "--compare-table-product-col-bg": ourProductColBgColor != null ? ourProductColBgColor : "var(--theme-color-bg-tint, #E7F4FD)",
    "--compare-table-product-col-border": ourProductColBorderColor != null ? ourProductColBorderColor : "var(--theme-color-accent, #0090CD)",
    "--compare-table-money-back-bg": moneyBackBgColor != null ? moneyBackBgColor : "var(--theme-color-bg-section, #ECFCF8)",
    "--compare-table-money-back-border": moneyBackBorderColor != null ? moneyBackBorderColor : "var(--theme-color-success, #00B67A)",
    "--compare-table-heading-text": headingTextColor != null ? headingTextColor : "var(--theme-color-heading-primary, #000000)",
    "--compare-table-text": textColor != null ? textColor : "var(--theme-color-text-primary, #333333)",
    "--compare-table-money-back-title": moneyBackTitleColor != null ? moneyBackTitleColor : "var(--theme-color-heading-primary, #000000)",
    "--compare-table-money-back-text": moneyBackTextColor != null ? moneyBackTextColor : "var(--theme-color-text-primary, #333333)",
    "--compare-table-accent": accentColor != null ? accentColor : "var(--theme-color-accent, #0090CD)",
    "--compare-table-row-divider": tableRowDividerColor != null ? tableRowDividerColor : "transparent",
    "--compare-table-check-icon": checkIconColor != null ? checkIconColor : "var(--theme-color-success, #009E7B)",
    "--compare-table-cross-icon": crossIconColor != null ? crossIconColor : "var(--theme-color-error, #EA9393)"
  };
}
var CheckSvg = ({ className }) => /* @__PURE__ */ React250.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    className,
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React250.createElement(
    "path",
    {
      d: "M7.28 14.93 1.5 9.15l2.12-2.12 3.66 3.66 9.1-9.1 2.12 2.12-11.22 11.22Z",
      fill: "currentColor"
    }
  )
);
var XSvg = ({ className }) => /* @__PURE__ */ React250.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    className,
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React250.createElement(
    "path",
    {
      d: "m10 12.12-5.03 5.03-2.12-2.12L7.88 10 2.85 4.97l2.12-2.12L10 7.88l5.03-5.03 2.12 2.12L12.12 10l5.03 5.03-2.12 2.12L10 12.12Z",
      fill: "currentColor"
    }
  )
);
var getOthersHas = (feature, colIndex) => {
  var _a;
  if (Array.isArray(feature.othersHas)) {
    return (_a = feature.othersHas[colIndex]) != null ? _a : false;
  }
  return feature.othersHas;
};
var CompareTableSection = ({
  heading,
  headingHtml,
  headingAs = "h2",
  showDivider = true,
  showSubheading = true,
  subheadingPlacement,
  subheading,
  description,
  productImage,
  productImageAlt = "",
  productLogo,
  productLogoAlt = "",
  othersLabel = "Others",
  othersColumns,
  features = [],
  moneyBackTitle,
  moneyBackDescription,
  moneyBackBadgeImage,
  moneyBackBadgeImageAlt = "",
  sectionBgColor,
  ourProductColBgColor,
  ourProductColBorderColor,
  moneyBackBgColor,
  moneyBackBorderColor,
  headingTextColor,
  textColor,
  moneyBackTitleColor,
  moneyBackTextColor,
  accentColor,
  tableRowDividerColor,
  checkIconColor,
  crossIconColor,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const resolvedOthersColumns = othersColumns && othersColumns.length > 0 ? othersColumns : [{ label: othersLabel }];
  const isScrollable = resolvedOthersColumns.length > 1;
  const hasMoneyBackBorder = moneyBackBorderColor !== "";
  const hasTableRowDivider = Boolean(
    tableRowDividerColor && tableRowDividerColor !== "transparent"
  );
  const headerSubheading = showSubheading ? subheading : void 0;
  const hasHeaderContent = Boolean(heading || headingHtml || headerSubheading);
  return /* @__PURE__ */ React250.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS15,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars7({
        sectionBgColor,
        ourProductColBgColor,
        ourProductColBorderColor,
        moneyBackBgColor,
        moneyBackBorderColor,
        headingTextColor,
        textColor,
        moneyBackTitleColor,
        moneyBackTextColor,
        accentColor,
        tableRowDividerColor,
        checkIconColor,
        crossIconColor
      })
    },
    /* @__PURE__ */ React250.createElement("div", { className: cn(DEFAULT_INNER_CLASS10, classes.inner) }, /* @__PURE__ */ React250.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading: headerSubheading,
        subheadingPlacement,
        showDivider: showDivider && hasHeaderContent,
        className: cn(DEFAULT_HEADER_CLASS15, classes.header),
        classes: {
          heading: cn(DEFAULT_HEADING_CLASS5, classes.heading),
          subheading: cn("text-(--compare-table-text)", classes.subheading),
          divider: cn(DEFAULT_HEADER_DIVIDER_CLASS3, classes.divider)
        }
      }
    ), description && /* @__PURE__ */ React250.createElement(
      RichText,
      {
        html: description,
        className: cn(DEFAULT_DESCRIPTION_CLASS13, classes.description)
      }
    ), features.length > 0 && /* @__PURE__ */ React250.createElement("div", { className: cn("w-full", isScrollable && "overflow-x-auto", classes.tableWrapper) }, /* @__PURE__ */ React250.createElement(
      "div",
      {
        className: cn(
          "mt-[41px] flex flex-col md:mt-16 lg:mt-[79px]",
          isScrollable ? "min-w-full w-max" : "w-full",
          classes.table
        )
      },
      /* @__PURE__ */ React250.createElement("div", { role: "table", "aria-label": "Feature comparison", className: "flex flex-col" }, /* @__PURE__ */ React250.createElement("div", { role: "rowgroup" }, /* @__PURE__ */ React250.createElement("div", { role: "row", className: cn("flex items-end", classes.headerRow) }, /* @__PURE__ */ React250.createElement("div", { role: "columnheader", className: DEFAULT_FEATURE_COL_CLASS }, /* @__PURE__ */ React250.createElement("span", { className: "sr-only" }, "Feature")), /* @__PURE__ */ React250.createElement(
        "div",
        {
          role: "columnheader",
          className: cn(
            DEFAULT_PRODUCT_COL_WIDTH,
            DEFAULT_PRODUCT_HEADER_CLASS,
            DEFAULT_PRODUCT_COL_SURFACE_CLASS,
            "rounded-t-[20px]",
            "border-x-4 border-t-4",
            classes.productCol,
            classes.productColHeader
          )
        },
        productImage && /* @__PURE__ */ React250.createElement(
          Image,
          {
            src: productImage,
            alt: productImageAlt,
            className: cn(DEFAULT_PRODUCT_IMAGE_CLASS2, classes.productImage)
          }
        ),
        productLogo && /* @__PURE__ */ React250.createElement(
          Image,
          {
            src: productLogo,
            alt: productLogoAlt,
            className: cn(DEFAULT_PRODUCT_LOGO_CLASS, classes.productLogo)
          }
        )
      ), resolvedOthersColumns.map((col, colIdx) => /* @__PURE__ */ React250.createElement(
        "div",
        {
          key: colIdx,
          role: "columnheader",
          className: cn(
            DEFAULT_OTHERS_COL_WIDTH,
            DEFAULT_OTHERS_HEADER_CLASS,
            "text-(--compare-table-heading-text)",
            classes.othersColHeader
          )
        },
        /* @__PURE__ */ React250.createElement(Text, { as: "span", className: "font-outfit text-base font-normal md:text-xl" }, col.label)
      )))), /* @__PURE__ */ React250.createElement("div", { role: "rowgroup" }, features.map((feature, index) => /* @__PURE__ */ React250.createElement(
        "div",
        {
          role: "row",
          key: feature.label,
          className: cn(
            "flex items-stretch",
            hasTableRowDivider && index < features.length - 1 && DEFAULT_ROW_DIVIDER_CLASS,
            classes.row
          )
        },
        /* @__PURE__ */ React250.createElement(
          "div",
          {
            role: "rowheader",
            className: cn(
              DEFAULT_FEATURE_COL_CLASS,
              "flex items-center px-3 py-3.5",
              classes.featureCell
            )
          },
          /* @__PURE__ */ React250.createElement(
            Text,
            {
              as: "span",
              className: cn(DEFAULT_FEATURE_LABEL_CLASS, classes.featureLabel)
            },
            feature.label
          )
        ),
        /* @__PURE__ */ React250.createElement(
          "div",
          {
            role: "cell",
            className: cn(
              DEFAULT_PRODUCT_COL_WIDTH,
              "flex items-center justify-center py-3.5",
              DEFAULT_PRODUCT_COL_SURFACE_CLASS,
              "border-x-4",
              classes.productCell
            )
          },
          feature.productHas ? /* @__PURE__ */ React250.createElement(React250.Fragment, null, /* @__PURE__ */ React250.createElement(
            CheckSvg,
            {
              className: cn(
                DEFAULT_ICON_SIZE_CLASS,
                DEFAULT_CHECK_ICON_CLASS2,
                classes.icon
              )
            }
          ), /* @__PURE__ */ React250.createElement("span", { className: "sr-only" }, "Yes")) : /* @__PURE__ */ React250.createElement(React250.Fragment, null, /* @__PURE__ */ React250.createElement(
            XSvg,
            {
              className: cn(
                DEFAULT_ICON_SIZE_CLASS,
                DEFAULT_CROSS_ICON_CLASS,
                classes.icon
              )
            }
          ), /* @__PURE__ */ React250.createElement("span", { className: "sr-only" }, "No"))
        ),
        resolvedOthersColumns.map((_, colIdx) => {
          const has = getOthersHas(feature, colIdx);
          return /* @__PURE__ */ React250.createElement(
            "div",
            {
              role: "cell",
              key: colIdx,
              className: cn(
                DEFAULT_OTHERS_COL_WIDTH,
                "flex items-center justify-center py-3.5",
                classes.othersCell
              )
            },
            has ? /* @__PURE__ */ React250.createElement(React250.Fragment, null, /* @__PURE__ */ React250.createElement(
              CheckSvg,
              {
                className: cn(
                  DEFAULT_ICON_SIZE_CLASS,
                  DEFAULT_CHECK_ICON_CLASS2,
                  classes.icon
                )
              }
            ), /* @__PURE__ */ React250.createElement("span", { className: "sr-only" }, "Yes")) : /* @__PURE__ */ React250.createElement(React250.Fragment, null, /* @__PURE__ */ React250.createElement(
              XSvg,
              {
                className: cn(
                  DEFAULT_ICON_SIZE_CLASS,
                  DEFAULT_CROSS_ICON_CLASS,
                  classes.icon
                )
              }
            ), /* @__PURE__ */ React250.createElement("span", { className: "sr-only" }, "No"))
          );
        })
      )))),
      /* @__PURE__ */ React250.createElement("div", { "aria-hidden": "true", className: "flex" }, /* @__PURE__ */ React250.createElement("div", { className: DEFAULT_FEATURE_COL_CLASS }), /* @__PURE__ */ React250.createElement(
        "div",
        {
          className: cn(
            DEFAULT_PRODUCT_COL_WIDTH,
            "h-4 md:h-6 rounded-b-[20px]",
            DEFAULT_PRODUCT_COL_SURFACE_CLASS,
            "border-x-4 border-b-4"
          )
        }
      ), resolvedOthersColumns.map((_, i) => /* @__PURE__ */ React250.createElement("div", { key: i, className: cn(DEFAULT_OTHERS_COL_WIDTH, "h-4 md:h-6") })))
    )), (moneyBackTitle || moneyBackDescription) && /* @__PURE__ */ React250.createElement(
      "div",
      {
        className: cn(
          DEFAULT_GUARANTEE_CLASS,
          hasMoneyBackBorder && DEFAULT_GUARANTEE_BORDER_CLASS,
          classes.guarantee
        )
      },
      moneyBackBadgeImage && /* @__PURE__ */ React250.createElement(
        Image,
        {
          src: moneyBackBadgeImage,
          alt: moneyBackBadgeImageAlt,
          className: cn(DEFAULT_GUARANTEE_BADGE_CLASS, classes.guaranteeBadge)
        }
      ),
      /* @__PURE__ */ React250.createElement("div", { className: cn("flex flex-col gap-2", classes.guaranteeContent) }, moneyBackTitle && /* @__PURE__ */ React250.createElement(Text, { as: "p", className: cn(DEFAULT_GUARANTEE_TITLE_CLASS, classes.guaranteeTitle) }, moneyBackTitle), moneyBackDescription && /* @__PURE__ */ React250.createElement(
        RichText,
        {
          html: moneyBackDescription,
          className: cn(DEFAULT_GUARANTEE_DESCRIPTION_CLASS, classes.guaranteeDescription)
        }
      ))
    ))
  );
};

// src/sections/HowToUseStepsVerticalSection.tsx
import React251 from "react";
var DEFAULT_SECTION_CLASS16 = "w-full [background:var(--how-to-bg)]";
var DEFAULT_CONTAINER_CLASS46 = "mx-auto max-w-[1100px] px-4 lg:px-0 flex flex-col gap-10 lg:gap-14";
var DEFAULT_HEADER_HEADING_CLASS2 = "text-(--how-to-title)";
var DEFAULT_HEADER_SUBHEADING_CLASS2 = "text-(--how-to-subheading)";
var DEFAULT_HEADER_DIVIDER_CLASS4 = "bg-(--how-to-divider)";
var DEFAULT_CONTENT_CLASS15 = "flex flex-col lg:flex-row gap-10";
var DEFAULT_IMAGE_COLUMN_CLASS = "order-2 lg:order-1 flex flex-col gap-6 lg:w-[550px] lg:shrink-0";
var DEFAULT_IMAGE_WRAPPER_CLASS5 = "flex w-full overflow-hidden rounded-[10px] min-h-[280px]";
var DEFAULT_IMAGE_CLASS13 = "w-full h-full object-cover rounded-[10px]";
var DEFAULT_STEP_COLUMN_CLASS = "order-1 lg:order-2 flex-1 min-w-0";
var DEFAULT_STEP_LABEL_CLASS2 = "font-bold text-(--how-to-accent) text-2xl leading-8";
var DEFAULT_STEP_DESC_CLASS = "text-(--how-to-text) text-base leading-6";
var DEFAULT_TIMELINE_CLASS = "flex w-12 shrink-0 justify-center";
var DEFAULT_TIMELINE_SEGMENT_CLASS = "absolute left-6 top-4 -bottom-4 w-1 -translate-x-1/2 overflow-hidden rounded-full";
var TIMELINE_RING_ANIMATION_CLASS = "[animation:how-to-timeline-ring-pulse_2470ms_ease-in-out_infinite]";
var HOW_TO_VARS_DEFAULTS = {
  "--how-to-bg": "var(--theme-color-bg-dark, #002a42)",
  "--how-to-accent": "var(--theme-color-accent, #95e0ff)",
  "--how-to-divider": "var(--theme-color-accent, #95e0ff)",
  "--how-to-title": "var(--theme-color-text-inverse, #FFFFFF)",
  "--how-to-subheading": "var(--theme-color-text-inverse, #FFFFFF)",
  "--how-to-text": "var(--theme-color-text-inverse, #FFFFFF)"
};
function buildHowToVars(colors) {
  return {
    ...HOW_TO_VARS_DEFAULTS,
    ...(colors == null ? void 0 : colors.bg) && { "--how-to-bg": colors.bg },
    ...(colors == null ? void 0 : colors.accent) && { "--how-to-accent": colors.accent },
    ...(colors == null ? void 0 : colors.divider) && { "--how-to-divider": colors.divider },
    ...(colors == null ? void 0 : colors.title) && { "--how-to-title": colors.title },
    ...(colors == null ? void 0 : colors.subheading) && { "--how-to-subheading": colors.subheading },
    ...(colors == null ? void 0 : colors.text) && { "--how-to-text": colors.text }
  };
}
function TimelineDotRings({ isActive }) {
  const ringColor = isActive ? "border-(--how-to-accent)" : "border-white";
  const rings = [
    "size-[28px] [--ring-opacity:0.55] [border-width:1.5px] [animation-delay:0ms]",
    "size-[36px] [--ring-opacity:0.45] [border-width:1.25px] [animation-delay:180ms]",
    "size-[44px] [--ring-opacity:0.35] border [animation-delay:360ms]",
    "size-[52px] [--ring-opacity:0.25] [border-width:0.75px] [animation-delay:540ms]",
    "size-[60px] [--ring-opacity:0.15] [border-width:0.5px] [animation-delay:720ms]"
  ];
  return /* @__PURE__ */ React251.createElement(React251.Fragment, null, rings.map((ringClass) => /* @__PURE__ */ React251.createElement(
    "span",
    {
      key: ringClass,
      className: cn(
        "absolute rounded-full opacity-0 transform-gpu will-change-[transform,opacity] motion-reduce:animate-none motion-reduce:transform-none",
        TIMELINE_RING_ANIMATION_CLASS,
        ringColor,
        ringClass
      ),
      "aria-hidden": "true"
    }
  )));
}
function StepDot({ isActive, isLast }) {
  if (isLast) {
    return /* @__PURE__ */ React251.createElement("div", { className: "relative z-10 flex size-7 shrink-0 items-center justify-center text-white" }, /* @__PURE__ */ React251.createElement(IconVerifiedBadge, { className: "absolute size-[54px]" }));
  }
  return /* @__PURE__ */ React251.createElement(
    "div",
    {
      className: cn(
        "relative z-10 flex size-4.5 shrink-0 items-center justify-center rounded-full",
        isActive ? "bg-(--how-to-accent)" : "bg-white"
      )
    },
    /* @__PURE__ */ React251.createElement(TimelineDotRings, { isActive })
  );
}
function TimelineSegment({ state }) {
  if (state === "partial") {
    return /* @__PURE__ */ React251.createElement("div", { className: DEFAULT_TIMELINE_SEGMENT_CLASS }, /* @__PURE__ */ React251.createElement("div", { className: "h-1/2 rounded-full bg-(--how-to-accent)" }), /* @__PURE__ */ React251.createElement("div", { className: "h-1/2 bg-white/30" }));
  }
  return /* @__PURE__ */ React251.createElement(
    "div",
    {
      className: cn(
        DEFAULT_TIMELINE_SEGMENT_CLASS,
        state === "active" ? "bg-(--how-to-accent)" : "bg-white/30"
      )
    }
  );
}
var HowToUseStepsVerticalSection = ({
  heading = "How it Works",
  headingHtml,
  headingAs = "h2",
  showDivider = true,
  showSubheading = false,
  subheading,
  subheadingPlacement = "before-divider",
  steps = [],
  assetType,
  image,
  imageAlt = "",
  videoUrl,
  showImage = true,
  review,
  cleanVersion = false,
  progressStep,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const resolvedProgressStep = Math.min(
    Math.max(progressStep != null ? progressStep : Math.ceil(steps.length / 2), 1),
    steps.length
  );
  const resolvedAssetType = assetType === "video" ? "video" : "image";
  const mediaUrl = resolvedAssetType === "video" ? videoUrl : image;
  const hasImage = showImage && !!mediaUrl;
  const resolvedSubheading = showSubheading ? subheading : void 0;
  const getSegmentState = (index) => {
    if (index < resolvedProgressStep - 2) return "active";
    if (index === resolvedProgressStep - 2) return "partial";
    return "inactive";
  };
  return /* @__PURE__ */ React251.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS16,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildHowToVars(colors)
    },
    /* @__PURE__ */ React251.createElement(Container, { className: cn(DEFAULT_CONTAINER_CLASS46, classes.container) }, /* @__PURE__ */ React251.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading: resolvedSubheading,
        subheadingPlacement,
        showDivider,
        className: classes.header,
        classes: {
          heading: cn(DEFAULT_HEADER_HEADING_CLASS2, classes.heading),
          subheading: cn(DEFAULT_HEADER_SUBHEADING_CLASS2, classes.subheading),
          divider: cn(DEFAULT_HEADER_DIVIDER_CLASS4, classes.divider)
        }
      }
    ), /* @__PURE__ */ React251.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS15, classes.content) }, (hasImage || review && !cleanVersion) && /* @__PURE__ */ React251.createElement("div", { className: cn(DEFAULT_IMAGE_COLUMN_CLASS, classes.imageColumn) }, hasImage && /* @__PURE__ */ React251.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS5, classes.imageWrapper) }, resolvedAssetType === "video" ? /* @__PURE__ */ React251.createElement(
      Video,
      {
        src: mediaUrl,
        ariaLabel: imageAlt,
        className: cn(DEFAULT_IMAGE_CLASS13, "aspect-auto", classes.image)
      }
    ) : /* @__PURE__ */ React251.createElement(
      Image,
      {
        src: mediaUrl,
        alt: imageAlt,
        className: cn(DEFAULT_IMAGE_CLASS13, classes.image)
      }
    )), review && !cleanVersion && /* @__PURE__ */ React251.createElement(
      HeroReviewCard,
      {
        rating: review.rating,
        ratingIcon: review.ratingIcon,
        authorImage: review.authorImage,
        authorImageAlt: review.authorImageAlt,
        isVerified: review.isVerified,
        verifiedLabel: review.verifiedLabel,
        title: review.title,
        text: review.text,
        className: classes.reviewCard
      }
    )), steps.length > 0 && /* @__PURE__ */ React251.createElement("div", { className: cn(DEFAULT_STEP_COLUMN_CLASS, classes.stepColumn) }, /* @__PURE__ */ React251.createElement("ol", { className: "flex flex-col list-none" }, steps.map((step, i) => /* @__PURE__ */ React251.createElement(
      "li",
      {
        key: i,
        className: cn(
          "relative flex gap-6",
          i < steps.length - 1 && "pb-10 lg:pb-[60px]",
          classes.step
        )
      },
      /* @__PURE__ */ React251.createElement("div", { "aria-hidden": "true", className: DEFAULT_TIMELINE_CLASS }, /* @__PURE__ */ React251.createElement("div", { className: "flex h-8 items-center" }, /* @__PURE__ */ React251.createElement(
        StepDot,
        {
          isActive: i < resolvedProgressStep - 1,
          isLast: i === steps.length - 1
        }
      )), i < steps.length - 1 && /* @__PURE__ */ React251.createElement(TimelineSegment, { state: getSegmentState(i) })),
      /* @__PURE__ */ React251.createElement("div", { className: "flex flex-1 min-w-0 flex-col gap-2" }, /* @__PURE__ */ React251.createElement(Text, { as: "p", className: cn(DEFAULT_STEP_LABEL_CLASS2, classes.stepLabel) }, step.label), step.description && /* @__PURE__ */ React251.createElement(
        RichText,
        {
          html: step.description,
          className: cn(DEFAULT_STEP_DESC_CLASS, classes.stepDescription)
        }
      ))
    )))))),
    /* @__PURE__ */ React251.createElement("style", null, `
        @keyframes how-to-timeline-ring-pulse {
          0% {
            opacity: 0;
            transform: translateZ(0) scale(0.88);
          }
          10% {
            opacity: var(--ring-opacity);
            transform: translateZ(0) scale(0.9);
          }
          50.73% {
            opacity: var(--ring-opacity);
            transform: translateZ(0) scale(1);
          }
          60.73% {
            opacity: 0;
            transform: translateZ(0) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateZ(0) scale(0.88);
          }
        }
      `)
  );
};

// src/sections/HowToUseStepsHorizontal.tsx
import React253, { useCallback as useCallback3, useRef as useRef17, useState as useState28 } from "react";

// src/molecules/HowToUseStepCard.tsx
import React252 from "react";
var DEFAULT_ROOT_CLASS31 = "flex-[0_0_263px] lg:flex-1 flex flex-col rounded-[10px] overflow-hidden self-stretch";
var DEFAULT_IMAGE_CLASS14 = "w-full h-[250px] object-cover";
var DEFAULT_BODY_CLASS5 = "[background:var(--how-to-h-card-bg)] flex flex-col gap-4 p-4 flex-1 rounded-b-[10px]";
var DEFAULT_TITLES_CLASS = "flex flex-col gap-2";
var DEFAULT_LABEL_CLASS12 = "font-semibold text-base leading-6 uppercase text-(--how-to-h-step-label)";
var DEFAULT_TITLE_CLASS17 = "font-extrabold text-[20px] leading-7 text-(--how-to-h-title)";
var DEFAULT_DESCRIPTION_CLASS14 = "text-base leading-6 text-(--how-to-h-desc)";
var HowToUseStepCard = ({
  step,
  resolvedLabel,
  className,
  classes = {}
}) => {
  var _a, _b;
  const resolvedAssetType = step.assetType === "video" ? "video" : "image";
  const mediaUrl = resolvedAssetType === "video" ? step.videoUrl : step.image;
  const mediaAlt = (_b = (_a = step.imageAlt) != null ? _a : step.title) != null ? _b : "";
  return /* @__PURE__ */ React252.createElement("article", { className: cn(DEFAULT_ROOT_CLASS31, classes.root, className) }, mediaUrl && (resolvedAssetType === "video" ? /* @__PURE__ */ React252.createElement(
    Video,
    {
      src: mediaUrl,
      ariaLabel: mediaAlt,
      className: cn(DEFAULT_IMAGE_CLASS14, "aspect-auto rounded-none", classes.image)
    }
  ) : /* @__PURE__ */ React252.createElement(Image, { src: mediaUrl, alt: mediaAlt, className: cn(DEFAULT_IMAGE_CLASS14, classes.image) })), /* @__PURE__ */ React252.createElement("div", { className: cn(DEFAULT_BODY_CLASS5, classes.body) }, /* @__PURE__ */ React252.createElement("div", { className: DEFAULT_TITLES_CLASS }, /* @__PURE__ */ React252.createElement(Text, { as: "p", className: cn(DEFAULT_LABEL_CLASS12, classes.label) }, resolvedLabel), step.title && /* @__PURE__ */ React252.createElement(Text, { as: "p", className: cn(DEFAULT_TITLE_CLASS17, classes.title) }, step.title)), step.description && /* @__PURE__ */ React252.createElement(
    RichText,
    {
      html: step.description,
      className: cn(DEFAULT_DESCRIPTION_CLASS14, classes.description)
    }
  )));
};

// src/sections/HowToUseStepsHorizontal.tsx
var DEFAULT_SECTION_CLASS17 = "w-full [background:var(--how-to-h-bg)]";
var DEFAULT_CONTAINER_CLASS47 = "mx-auto max-w-[1100px] px-4 md:px-6 lg:px-0 flex flex-col items-center gap-6 md:gap-10";
var DEFAULT_HEADER_HEADING_CLASS3 = "text-[32px] font-extrabold leading-[40px] lg:text-[36px] lg:leading-[44px] text-(--how-to-h-title)";
var DEFAULT_HEADER_SUBHEADING_CLASS3 = "text-(--how-to-h-desc) text-center max-w-none";
var DEFAULT_HEADER_DIVIDER_CLASS5 = "bg-(--how-to-h-divider)";
var DEFAULT_STEPS_WRAPPER_CLASS = "flex flex-col gap-4 w-full";
var DEFAULT_STEPS_ROW_CLASS = "flex lg:justify-center gap-4 overflow-x-auto lg:overflow-visible w-full scroll-smooth pb-1 lg:pb-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden";
var DEFAULT_STEP_CARD_FIXED_ROOT_CLASS = "lg:flex-none lg:basis-[263px] lg:w-[263px]";
var DEFAULT_STEP_CARD_LABEL_CLASS = "font-outfit";
var DEFAULT_STEP_CARD_TITLE_CLASS = "font-outfit";
var DEFAULT_PROGRESS_CLASS2 = "flex lg:hidden items-center rounded-full overflow-hidden h-1 w-full bg-(--how-to-h-progress-track)";
var DEFAULT_CTA_WRAPPER_CLASS4 = "flex flex-col items-center gap-2 w-full md:w-[400px]";
var DEFAULT_CTA_BUTTON_CLASS4 = "w-full h-14 text-[20px] font-bold font-outfit leading-7 rounded-[10px] px-6 py-2.5 lg:py-3";
var DEFAULT_CTA_ICON_CLASS4 = "size-6 shrink-0";
var DEFAULT_CTA_FALLBACK_ICON_CLASS3 = "text-(--button-icon-color)";
function buildHowToVars2(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const stepLabelColor = (_a = colors == null ? void 0 : colors.stepLabel) != null ? _a : "#0075A7";
  return {
    "--how-to-h-bg": (_b = colors == null ? void 0 : colors.background) != null ? _b : "var(--theme-color-bg-section, #F5F5F5)",
    "--how-to-h-step-label": stepLabelColor,
    "--how-to-h-card-bg": (_c = colors == null ? void 0 : colors.cardBackground) != null ? _c : "var(--theme-color-bg-raised, #FFFFFF)",
    "--how-to-h-title": (_d = colors == null ? void 0 : colors.titleColor) != null ? _d : "var(--theme-color-text-primary, #000000)",
    "--how-to-h-desc": (_e = colors == null ? void 0 : colors.descriptionColor) != null ? _e : "var(--theme-color-text-primary, #333333)",
    "--how-to-h-divider": (_f = colors == null ? void 0 : colors.dividerColor) != null ? _f : stepLabelColor,
    "--how-to-h-progress": (_g = colors == null ? void 0 : colors.progressActive) != null ? _g : "var(--theme-color-accent, #52A4D8)",
    "--how-to-h-progress-track": (_h = colors == null ? void 0 : colors.progressTrack) != null ? _h : "var(--theme-color-border-light, #E0E0E0)"
  };
}
function isGradient2(value) {
  return value.includes("gradient");
}
var HowToUseStepsHorizontal = ({
  heading = "How to Use",
  headingHtml,
  headingAs = "h2",
  showDivider = true,
  subheading,
  subheadingPlacement = "before-divider",
  stepPrefix = "STEP",
  steps = [],
  cta = true,
  ctaLabel,
  ctaIcon,
  ctaText,
  ctaHref,
  ctaBackgroundColor,
  ctaBackgroundGradient,
  ctaBackgroundHoverColor,
  ctaBackgroundHoverGradient,
  ctaTextColor,
  ctaBorderColor,
  ctaIconColor,
  cleanVersion = false,
  showShipBy = false,
  shipByText,
  daysFromNow,
  shipByLocale,
  showStockLevel = false,
  stockLevelLabel,
  stockLevel = 30,
  stockLevelLowLabel,
  showProgressBar = true,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  var _a, _b, _c, _d, _e;
  const scrollRef = useRef17(null);
  const [scrollProgress, setScrollProgress] = useState28(0);
  const handleScroll = useCallback3(() => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollable = el.scrollWidth - el.clientWidth;
    setScrollProgress(scrollable > 0 ? el.scrollLeft / scrollable : 0);
  }, []);
  const resolvedCtaLabel = ctaLabel != null ? ctaLabel : ctaText;
  const hasCta = cta && !!resolvedCtaLabel;
  const hasShipBy = !cleanVersion && showShipBy && !!shipByText;
  const hasStockLevel = !cleanVersion && showStockLevel && !!stockLevelLabel;
  const hasSubCta = hasShipBy || hasStockLevel;
  const resolvedCtaBackground = ctaBackgroundGradient || ctaBackgroundColor || (colors == null ? void 0 : colors.ctaBackground) || "linear-gradient(to top, #ffcd5a 4.464%, #ffe65b 100%)";
  const resolvedCtaHoverBackground = ctaBackgroundHoverGradient || ctaBackgroundHoverColor || (colors == null ? void 0 : colors.ctaHoverBackground) || (isGradient2(resolvedCtaBackground) ? lightenGradient(resolvedCtaBackground, 0.1) : lightenHex(resolvedCtaBackground, 0.2));
  const ctaStyle = hasCta ? {
    "--cta-bg": resolvedCtaBackground,
    "--button-hover-color": resolvedCtaHoverBackground,
    "--button-text-color": (_a = ctaTextColor != null ? ctaTextColor : colors == null ? void 0 : colors.ctaTextColor) != null ? _a : "#000000",
    "--button-border-color": (_b = ctaBorderColor != null ? ctaBorderColor : colors == null ? void 0 : colors.ctaBorder) != null ? _b : "#d39208",
    "--button-icon-color": ctaIconColor != null ? ctaIconColor : "#9B6A00"
  } : void 0;
  const shouldFixDesktopCardWidth = steps.length > 0 && steps.length < 4;
  const stepCardClasses = {
    ...classes.stepCard,
    root: cn(
      shouldFixDesktopCardWidth && DEFAULT_STEP_CARD_FIXED_ROOT_CLASS,
      (_c = classes.stepCard) == null ? void 0 : _c.root
    ),
    label: cn(DEFAULT_STEP_CARD_LABEL_CLASS, (_d = classes.stepCard) == null ? void 0 : _d.label),
    title: cn(DEFAULT_STEP_CARD_TITLE_CLASS, (_e = classes.stepCard) == null ? void 0 : _e.title)
  };
  return /* @__PURE__ */ React253.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS17,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildHowToVars2(colors)
    },
    /* @__PURE__ */ React253.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS47, classes.container) }, (heading || headingHtml || subheading) && /* @__PURE__ */ React253.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading,
        headingAs,
        showDivider,
        subheadingPlacement,
        className: classes.header,
        classes: {
          heading: cn(DEFAULT_HEADER_HEADING_CLASS3, classes.heading),
          subheading: cn(DEFAULT_HEADER_SUBHEADING_CLASS3, classes.subheading),
          divider: cn(DEFAULT_HEADER_DIVIDER_CLASS5, classes.divider)
        }
      }
    ), steps.length > 0 && /* @__PURE__ */ React253.createElement("div", { className: DEFAULT_STEPS_WRAPPER_CLASS }, /* @__PURE__ */ React253.createElement(
      "div",
      {
        ref: scrollRef,
        onScroll: handleScroll,
        className: cn(DEFAULT_STEPS_ROW_CLASS, classes.stepsRow)
      },
      steps.map((step, i) => {
        var _a2;
        return /* @__PURE__ */ React253.createElement(
          HowToUseStepCard,
          {
            key: i,
            step,
            resolvedLabel: (_a2 = step.stepLabel) != null ? _a2 : `${stepPrefix} ${i + 1}`,
            classes: stepCardClasses
          }
        );
      })
    ), showProgressBar && /* @__PURE__ */ React253.createElement(
      "div",
      {
        "aria-hidden": "true",
        className: cn(DEFAULT_PROGRESS_CLASS2, classes.progressBar),
        style: {
          "--progress-fill": `${Math.max(4, scrollProgress * 100)}%`
        }
      },
      /* @__PURE__ */ React253.createElement("div", { className: "h-full bg-(--how-to-h-progress) rounded-full transition-[width] duration-150 min-w-1 w-[var(--progress-fill)]" })
    )), (hasCta || hasSubCta) && /* @__PURE__ */ React253.createElement("div", { className: cn(DEFAULT_CTA_WRAPPER_CLASS4, classes.ctaWrapper) }, hasCta && /* @__PURE__ */ React253.createElement(
      CTAButton,
      {
        buttonText: resolvedCtaLabel,
        icon: ctaIcon || /* @__PURE__ */ React253.createElement(
          IconArrowCircleRight,
          {
            className: cn(DEFAULT_CTA_ICON_CLASS4, DEFAULT_CTA_FALLBACK_ICON_CLASS3)
          }
        ),
        iconClassName: ctaIcon ? DEFAULT_CTA_ICON_CLASS4 : void 0,
        href: ctaHref,
        className: cn(DEFAULT_CTA_BUTTON_CLASS4, classes.ctaButton),
        style: ctaStyle
      }
    ), hasSubCta && /* @__PURE__ */ React253.createElement(
      StockAndShippingLevel,
      {
        showShipBy: hasShipBy,
        shipByText,
        daysFromNow,
        shipByLocale,
        showStockLevel: hasStockLevel,
        stockLevelLabel,
        stockLevel,
        stockLevelLowLabel,
        classes: {
          shipBy: classes.shipByWrapper,
          stockStatus: classes.stockLevelWrapper
        }
      }
    )))
  );
};

// src/sections/ContentImageSection.tsx
import React254 from "react";
var DEFAULT_SECTION_CLASS18 = "w-full flex justify-center lg:px-14 [background:var(--content-image-section-bg)]";
var DEFAULT_CONTAINER_CLASS48 = "flex w-full max-w-[1100px] flex-col items-center gap-[24px] px-4 lg:grid lg:grid-cols-[550px_550px] lg:gap-0 lg:px-0";
var DEFAULT_CONTENT_COLUMN_CLASS2 = "contents lg:flex lg:w-full lg:flex-col lg:items-start lg:gap-[24px]";
var DEFAULT_HEADER_WRAPPER_CLASS = "order-1 w-full lg:order-none";
var DEFAULT_IMAGE_WRAPPER_CLASS6 = "w-full";
var DEFAULT_IMAGE_CLASS15 = "w-full h-auto object-cover rounded-[10px] md:rounded-[20px]";
var DEFAULT_CONTENT_WRAPPER_CLASS5 = "w-full flex flex-col items-center lg:order-none lg:items-start gap-[24px]";
var DEFAULT_CONTENT_WRAPPER_IMAGE_LEFT_CLASS = "lg:pl-[40px]";
var DEFAULT_CONTENT_WRAPPER_IMAGE_RIGHT_CLASS = "lg:pr-[40px]";
var DEFAULT_HEADER_CLASS16 = "items-center text-center lg:items-start lg:text-left gap-4";
var DEFAULT_HEADING_CLASS6 = "font-extrabold text-(--content-image-heading)";
var DEFAULT_SUBHEADING_CLASS5 = "font-medium text-(--content-image-subheading)";
var DEFAULT_DIVIDER_CLASS13 = "bg-(--content-image-accent)";
var DEFAULT_TEXT_CLASS16 = "text-base md:text-[18px]/[26px] font-normal text-(--content-image-text)";
var DEFAULT_CTA_WRAPPER_CLASS5 = "mx-auto flex w-full max-w-[400px] flex-col items-center gap-2 lg:mx-0";
var DEFAULT_BUTTON_CLASS10 = "transition-colors duration-200 w-full h-14 text-[20px] font-bold font-outfit leading-7 rounded-[10px] px-6 py-2.5 lg:py-3";
var DEFAULT_CTA_ICON_CLASS5 = "size-6 shrink-0";
var DEFAULT_CTA_FALLBACK_ICON_CLASS4 = "text-(--button-icon-color)";
function buildVars8({
  sectionBgColor,
  headingTextColor,
  subheadingTextColor,
  textColor,
  accentColor
}) {
  return {
    "--content-image-section-bg": sectionBgColor != null ? sectionBgColor : "var(--theme-color-bg-page, #FFFFFF)",
    "--content-image-heading": headingTextColor != null ? headingTextColor : "var(--theme-color-heading-primary, #000000)",
    "--content-image-subheading": subheadingTextColor != null ? subheadingTextColor : "var(--theme-color-text-secondary, #333333)",
    "--content-image-text": textColor != null ? textColor : "var(--theme-color-text-primary, #333333)",
    "--content-image-accent": accentColor != null ? accentColor : "var(--theme-color-accent, #0090CD)"
  };
}
var ContentImage = ({
  assetType,
  image,
  imageAlt = "Content image",
  videoUrl,
  imagePosition = "left",
  mobileLayout = "media-first",
  heading,
  headingHtml,
  subheading,
  subheadingText,
  subheadingPlacement = "before-divider",
  text,
  sectionBgColor,
  headingTextColor,
  subheadingTextColor,
  textColor,
  accentColor,
  cta,
  ctaLabel,
  ctaIcon,
  ctaHref,
  ctaBackgroundColor,
  ctaBackgroundGradient,
  ctaBackgroundHoverColor,
  ctaBackgroundHoverGradient,
  ctaTextColor,
  ctaBorderColor,
  ctaIconColor,
  cleanVersion = false,
  showShipBy = false,
  shipByText,
  daysFromNow,
  shipByLocale,
  showStockLevel = false,
  stockLevelLabel,
  stockLevel,
  stockLevelLowLabel,
  stockAndShippingColors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const sectionCls = cn(
    DEFAULT_SECTION_CLASS18,
    getSectionSpacingClass(sectionSpacing),
    classes.section,
    className
  );
  const resolvedAssetType = assetType === "video" ? "video" : "image";
  const mediaUrl = resolvedAssetType === "video" ? videoUrl : image;
  const isMediaLast = mobileLayout === "media-last";
  const contentColumnCls = imagePosition === "right" ? "lg:col-start-1" : "lg:col-start-2";
  const mediaColumnCls = imagePosition === "right" ? "lg:col-start-2" : "lg:col-start-1";
  const contentOffsetCls = imagePosition === "right" ? DEFAULT_CONTENT_WRAPPER_IMAGE_RIGHT_CLASS : DEFAULT_CONTENT_WRAPPER_IMAGE_LEFT_CLASS;
  const containerCls = cn(DEFAULT_CONTAINER_CLASS48, classes.container);
  const contentColumnWrapperCls = cn(
    DEFAULT_CONTENT_COLUMN_CLASS2,
    mediaUrl ? contentColumnCls : "lg:col-span-2",
    mediaUrl && "lg:row-start-1",
    mediaUrl && contentOffsetCls,
    classes.contentColumnWrapper
  );
  const headerWrapperCls = cn(DEFAULT_HEADER_WRAPPER_CLASS);
  const imageWrapperCls = cn(
    DEFAULT_IMAGE_WRAPPER_CLASS6,
    isMediaLast ? "order-3" : "order-2",
    "lg:order-none",
    mediaColumnCls,
    "lg:row-start-1",
    classes.imageWrapper
  );
  const imageCls = cn(DEFAULT_IMAGE_CLASS15, classes.image);
  const headerCls = cn(DEFAULT_HEADER_CLASS16, classes.header);
  const headingCls = cn(DEFAULT_HEADING_CLASS6, classes.heading);
  const subheadingCls = cn(DEFAULT_SUBHEADING_CLASS5, classes.subheading);
  const dividerCls = cn(DEFAULT_DIVIDER_CLASS13, classes.divider);
  const textCls = cn(DEFAULT_TEXT_CLASS16, classes.text);
  const ctaWrapperCls = cn(DEFAULT_CTA_WRAPPER_CLASS5, classes.ctaWrapper);
  const buttonCls = cn(DEFAULT_BUTTON_CLASS10, classes.ctaButton);
  const contentWrapperCls = cn(
    DEFAULT_CONTENT_WRAPPER_CLASS5,
    isMediaLast ? "order-2" : "order-3",
    classes.contentWrapper
  );
  const hasCta = !!(cta && ctaLabel);
  const hasShipBy = !cleanVersion && showShipBy && !!shipByText;
  const hasStockLevel = !cleanVersion && showStockLevel && !!stockLevelLabel;
  const hasStockAndShipping = hasShipBy || hasStockLevel;
  const ctaStyle = hasCta ? {
    "--cta-bg": ctaBackgroundGradient || ctaBackgroundColor || "linear-gradient(to bottom, #FFCD5A, #FFE65B)",
    "--button-hover-color": ctaBackgroundHoverGradient || ctaBackgroundHoverColor || (ctaBackgroundGradient ? lightenGradient(ctaBackgroundGradient, 0.1) : lightenHex(ctaBackgroundColor != null ? ctaBackgroundColor : "#FFCD5A", 0.2)),
    "--button-text-color": ctaTextColor != null ? ctaTextColor : "#1a1a1a",
    "--button-border-color": ctaBorderColor != null ? ctaBorderColor : "#D39208",
    "--button-icon-color": ctaIconColor != null ? ctaIconColor : "#9B6A00"
  } : void 0;
  return /* @__PURE__ */ React254.createElement(
    "section",
    {
      className: sectionCls,
      style: buildVars8({
        sectionBgColor,
        headingTextColor,
        subheadingTextColor,
        textColor,
        accentColor
      })
    },
    /* @__PURE__ */ React254.createElement(Container, { className: containerCls }, /* @__PURE__ */ React254.createElement("div", { className: contentColumnWrapperCls }, /* @__PURE__ */ React254.createElement("div", { className: headerWrapperCls }, /* @__PURE__ */ React254.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading: subheading ? subheadingText : void 0,
        subheadingPlacement,
        className: headerCls,
        classes: { heading: headingCls, subheading: subheadingCls, divider: dividerCls }
      }
    )), /* @__PURE__ */ React254.createElement("div", { className: contentWrapperCls }, /* @__PURE__ */ React254.createElement(Text, { className: textCls }, text), (hasCta || hasStockAndShipping) && /* @__PURE__ */ React254.createElement("div", { className: ctaWrapperCls }, hasCta && /* @__PURE__ */ React254.createElement(
      CTAButton,
      {
        buttonText: ctaLabel,
        icon: ctaIcon || /* @__PURE__ */ React254.createElement(
          IconArrowCircleRight,
          {
            className: cn(DEFAULT_CTA_ICON_CLASS5, DEFAULT_CTA_FALLBACK_ICON_CLASS4)
          }
        ),
        iconClassName: ctaIcon ? DEFAULT_CTA_ICON_CLASS5 : void 0,
        href: ctaHref,
        className: buttonCls,
        style: ctaStyle
      }
    ), hasStockAndShipping && /* @__PURE__ */ React254.createElement(
      StockAndShippingLevel,
      {
        showShipBy: hasShipBy,
        shipByText,
        daysFromNow,
        shipByLocale,
        showStockLevel: hasStockLevel,
        stockLevelLabel,
        stockLevel,
        stockLevelLowLabel,
        colors: stockAndShippingColors,
        classes: {
          shipBy: classes.shipByWrapper,
          stockStatus: classes.stockLevelWrapper
        }
      }
    )))), mediaUrl && /* @__PURE__ */ React254.createElement("div", { className: imageWrapperCls }, resolvedAssetType === "video" ? /* @__PURE__ */ React254.createElement(Video, { src: mediaUrl, ariaLabel: imageAlt, className: cn(imageCls, "aspect-auto") }) : /* @__PURE__ */ React254.createElement(Image, { src: mediaUrl, alt: imageAlt, className: imageCls })))
  );
};

// src/sections/ExpertBulletPointsSection.tsx
import React255 from "react";
var DEFAULT_SECTION_CLASS19 = "w-full [background:var(--expert-bg)]";
var DEFAULT_CONTAINER_CLASS49 = "mx-auto w-full max-w-[1100px] px-4 lg:px-0 flex flex-col items-center gap-10";
var DEFAULT_HEADER_HEADING_CLASS4 = "text-[32px] leading-[40px] lg:text-[36px] lg:leading-[44px] font-extrabold text-(--expert-title)";
var DEFAULT_CARD_CLASS5 = "w-full [background:var(--expert-card-bg)] rounded-[20px] overflow-hidden flex flex-col md:flex-row gap-6 p-6 md:pl-10 md:pr-6 md:pt-6 md:pb-0";
var DEFAULT_CONTENT_CLASS16 = "flex flex-col gap-6 flex-1 min-w-0 md:pb-6";
var DEFAULT_SUBTITLE_CLASS5 = "text-[24px] md:text-[20px] lg:text-[24px] font-bold leading-[32px] md:leading-[28px] lg:leading-[32px] text-(--expert-subtitle)";
var DEFAULT_BULLET_LIST_CLASS = "flex flex-col gap-2";
var DEFAULT_BULLET_ITEM_CLASS = "flex items-center gap-2";
var DEFAULT_CHECKMARK_CLASS = "text-(--expert-checkmark)";
var DEFAULT_BULLET_TEXT_CLASS = "text-[16px] lg:text-[18px] font-bold leading-[24px] lg:leading-[26px] text-(--expert-bullet-text)";
var DEFAULT_IMAGE_WRAPPER_CLASS7 = "relative self-center md:self-end shrink-0 w-[282px] md:w-[300px] h-[370px] overflow-hidden";
var DEFAULT_IMAGE_CLASS16 = "w-full h-full object-cover object-bottom";
function buildExpertVars(colors) {
  var _a, _b, _c, _d, _e, _f;
  return {
    "--expert-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--expert-card-bg": (_b = colors == null ? void 0 : colors.cardBackground) != null ? _b : "var(--theme-color-bg-tint, #E7F4FD)",
    "--expert-title": (_c = colors == null ? void 0 : colors.titleColor) != null ? _c : "var(--theme-color-heading-primary, #000000)",
    "--expert-subtitle": (_d = colors == null ? void 0 : colors.subtitleColor) != null ? _d : "var(--theme-color-text-primary, #333333)",
    "--expert-bullet-text": (_e = colors == null ? void 0 : colors.bulletTextColor) != null ? _e : "var(--theme-color-text-primary, #333333)",
    "--expert-checkmark": (_f = colors == null ? void 0 : colors.checkmarkColor) != null ? _f : "var(--theme-color-accent, #0090CD)"
  };
}
var ExpertBulletPointsSection = ({
  heading = "Meet Our Expert",
  headingHtml,
  headingAs = "h2",
  showDivider = false,
  showSubheading = false,
  subheadingPlacement = "before-divider",
  subheading,
  subtitle,
  image,
  imageAlt = "",
  bullets = [],
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React255.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS19,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildExpertVars(colors)
    },
    /* @__PURE__ */ React255.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS49, classes.container) }, (heading || headingHtml) && /* @__PURE__ */ React255.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading: showSubheading ? subheading : void 0,
        subheadingPlacement,
        showDivider,
        className: classes.header,
        classes: {
          heading: cn(DEFAULT_HEADER_HEADING_CLASS4, classes.heading),
          divider: classes.divider,
          subheading: classes.sectionSubheading
        }
      }
    ), /* @__PURE__ */ React255.createElement("div", { className: cn(DEFAULT_CARD_CLASS5, classes.card) }, /* @__PURE__ */ React255.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS16, classes.content) }, subtitle && /* @__PURE__ */ React255.createElement(Text, { as: "p", className: cn(DEFAULT_SUBTITLE_CLASS5, classes.subtitle) }, subtitle), bullets.length > 0 && /* @__PURE__ */ React255.createElement("ul", { className: cn(DEFAULT_BULLET_LIST_CLASS, classes.bulletList) }, bullets.map((bullet, i) => /* @__PURE__ */ React255.createElement("li", { key: i, className: cn(DEFAULT_BULLET_ITEM_CLASS, classes.bulletItem) }, /* @__PURE__ */ React255.createElement(IconCheckmark, { className: cn(DEFAULT_CHECKMARK_CLASS, classes.checkmark) }), /* @__PURE__ */ React255.createElement(Text, { className: cn(DEFAULT_BULLET_TEXT_CLASS, classes.bulletText) }, bullet.text))))), /* @__PURE__ */ React255.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS7, classes.imageWrapper) }, /* @__PURE__ */ React255.createElement(Image, { src: image, alt: imageAlt, className: cn(DEFAULT_IMAGE_CLASS16, classes.image) }))))
  );
};

// src/sections/ExpertPlainTextSection.tsx
import React256 from "react";
var DEFAULT_SECTION_CLASS20 = "w-full [background:var(--expert-pt-bg)]";
var DEFAULT_CONTAINER_CLASS50 = "mx-auto max-w-[1100px] px-4 lg:px-0";
var DEFAULT_CARD_CLASS6 = "w-full [background:var(--expert-pt-card-bg)] rounded-[20px] overflow-hidden flex flex-col md:flex-row items-center gap-10 p-6 lg:pl-10 lg:pr-6 lg:py-6";
var DEFAULT_CONTENT_CLASS17 = "flex flex-col gap-6 flex-1 min-w-0 lg:py-10";
var DEFAULT_HEADING_GROUP_CLASS = "flex flex-col items-start";
var DEFAULT_HEADER_CLASS17 = "items-start text-left gap-0";
var DEFAULT_HEADING_CLASS7 = "text-[32px] leading-[40px] lg:text-[36px] lg:leading-[44px] font-extrabold text-(--expert-pt-heading)";
var DEFAULT_ROLE_SUBTITLE_CLASS = "text-[16px] md:text-[18px] leading-6 font-normal text-(--expert-pt-role)";
var DEFAULT_DESCRIPTION_CLASS15 = "text-[16px] md:text-[18px] leading-6 md:leading-[26px] font-normal text-(--expert-pt-body)";
var DEFAULT_IMAGE_COLUMN_CLASS2 = "shrink-0 flex flex-col gap-2 items-start justify-center";
var DEFAULT_IMAGE_WRAPPER_CLASS8 = "relative w-[310px] h-[388px] md:w-[200px] md:h-[250px] overflow-hidden rounded-[5px]";
var DEFAULT_IMAGE_CLASS17 = "w-full h-full object-cover object-bottom";
var DEFAULT_EXPERT_INFO_CLASS = "flex flex-col items-start";
var DEFAULT_EXPERT_NAME_CLASS = "text-[20px] leading-7 font-extrabold text-(--expert-pt-name)";
var DEFAULT_EXPERT_ROLE_CLASS = "text-[16px] leading-4 font-normal text-(--expert-pt-role)";
function buildExpertPtVars(colors) {
  var _a, _b, _c, _d, _e, _f;
  return {
    "--expert-pt-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, transparent)",
    "--expert-pt-card-bg": (_b = colors == null ? void 0 : colors.cardBackground) != null ? _b : "var(--theme-color-bg-tint, #E7F4FD)",
    "--expert-pt-heading": (_c = colors == null ? void 0 : colors.headingColor) != null ? _c : "var(--theme-color-heading-primary, #000000)",
    "--expert-pt-role": (_d = colors == null ? void 0 : colors.roleColor) != null ? _d : "var(--theme-color-text-secondary, #333333)",
    "--expert-pt-body": (_e = colors == null ? void 0 : colors.bodyColor) != null ? _e : "var(--theme-color-text-primary, #333333)",
    "--expert-pt-name": (_f = colors == null ? void 0 : colors.nameColor) != null ? _f : "var(--theme-color-text-primary, #333333)"
  };
}
var ExpertPlainTextSection = ({
  heading = "Meet Our Expert,",
  headingHtml,
  headingAs = "h2",
  expertName,
  expertRole,
  description,
  image,
  imageAlt = "",
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React256.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS20,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildExpertPtVars(colors)
    },
    /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS50, classes.container) }, /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_CARD_CLASS6, classes.card) }, /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS17, classes.content) }, /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_HEADING_GROUP_CLASS, classes.headingGroup) }, (heading || headingHtml) && /* @__PURE__ */ React256.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        showDivider: false,
        className: cn(DEFAULT_HEADER_CLASS17, classes.header),
        classes: { heading: cn(DEFAULT_HEADING_CLASS7, classes.heading) }
      }
    ), expertRole && /* @__PURE__ */ React256.createElement(Text, { as: "p", className: cn(DEFAULT_ROLE_SUBTITLE_CLASS, classes.roleSubtitle) }, expertRole)), description && /* @__PURE__ */ React256.createElement(
      RichText,
      {
        html: description,
        className: cn(DEFAULT_DESCRIPTION_CLASS15, classes.description)
      }
    )), /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_IMAGE_COLUMN_CLASS2, classes.imageColumn) }, /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS8, classes.imageWrapper) }, /* @__PURE__ */ React256.createElement(
      Image,
      {
        src: image,
        alt: imageAlt,
        className: cn(DEFAULT_IMAGE_CLASS17, classes.image)
      }
    )), /* @__PURE__ */ React256.createElement("div", { className: cn(DEFAULT_EXPERT_INFO_CLASS, classes.expertInfo) }, expertName && /* @__PURE__ */ React256.createElement(Text, { as: "p", className: cn(DEFAULT_EXPERT_NAME_CLASS, classes.expertName) }, expertName), expertRole && /* @__PURE__ */ React256.createElement(Text, { as: "p", className: cn(DEFAULT_EXPERT_ROLE_CLASS, classes.expertRole) }, expertRole)))))
  );
};

// src/hooks/useEverflowConversion.ts
import { useEffect as useEffect25, useRef as useRef18 } from "react";
var COOKIE_PREFIX = "ef_conversion_";
function getCookie2(name) {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const eqIndex = cookie.indexOf("=");
    if (eqIndex === -1) continue;
    const key = cookie.slice(0, eqIndex);
    if (key === name) return decodeURIComponent(cookie.slice(eqIndex + 1));
  }
  return null;
}
function setCookie(name, value, days = 1) {
  const date = /* @__PURE__ */ new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
}
function useEverflowConversion({
  adv_event_id,
  transaction_id,
  offer_id,
  triggerType,
  triggerValue,
  tracking_domain = "https://www.csszp8trk.com"
}) {
  const hasTriggered = useRef18(false);
  const isRunning = useRef18(false);
  useEffect25(() => {
    const cookieName = `${COOKIE_PREFIX}${adv_event_id}_${transaction_id}`;
    if (getCookie2(cookieName) || hasTriggered.current) return;
    const fireConversion = async () => {
      if (hasTriggered.current || isRunning.current) return;
      isRunning.current = true;
      try {
        const EF = window.EF;
        if (!EF || typeof EF.conversion !== "function") return;
        if (EF.customParamProvider instanceof Promise) {
          await EF.customParamProvider;
        }
        EF.customParamProvider = null;
        const result = await EF.conversion({
          offer_id,
          tracking_domain,
          adv_event_id,
          transaction_id
        });
        if ((result == null ? void 0 : result.transaction_id) && (result == null ? void 0 : result.conversion_id)) {
          hasTriggered.current = true;
          setCookie(cookieName, "true");
        } else {
          console.warn("[Everflow] Conversion response missing IDs", result);
        }
      } catch (err) {
        console.error("[Everflow] Conversion error:", err);
      } finally {
        isRunning.current = false;
      }
    };
    if (triggerType === "visit") {
      if (window.location.href.includes(triggerValue)) {
        fireConversion();
      }
      return;
    }
    const el = document.getElementById(triggerValue);
    if (!el) {
      console.warn(`[Everflow] Element #${triggerValue} not found`);
      return;
    }
    el.addEventListener("focus", fireConversion);
    return () => el.removeEventListener("focus", fireConversion);
  }, [adv_event_id, transaction_id, offer_id, triggerType, triggerValue, tracking_domain]);
}

// src/sections/InfoBannerProvenResults.tsx
import React257 from "react";
var DEFAULT_SECTION_CLASS21 = "w-full";
var DEFAULT_CONTAINER_CLASS51 = "mx-auto w-full max-w-[1100px] px-4";
var DEFAULT_BANNER_CLASS2 = "flex flex-col md:flex-row rounded-[10px] overflow-hidden border border-(--info-proven-border)";
var DEFAULT_BADGE_BLOCK_CLASS = "flex flex-row items-center justify-center gap-4 px-4 py-2 [background:var(--info-proven-badge-bg)] md:flex-col md:items-center md:w-[200px] md:shrink-0 md:p-6";
var DEFAULT_BADGE_ICON_WRAPPER_CLASS = "shrink-0 size-12 md:size-[70px]";
var DEFAULT_BADGE_LABEL_CLASS = "whitespace-nowrap font-bold text-[20px] leading-7 text-(--info-proven-badge-label) text-center";
var DEFAULT_TEXT_BLOCK_CLASS = "flex w-full min-w-0 flex-col gap-4 p-6 [background:var(--info-proven-text-bg)] md:flex-1";
var DEFAULT_HEADER_GROUP_CLASS2 = "flex flex-col gap-4";
var DEFAULT_HEADER_CLASS18 = "items-start text-left gap-0";
var DEFAULT_HEADING_CLASS8 = "text-[20px] md:text-[32px] font-extrabold leading-[28px] md:leading-[40px] text-(--info-proven-heading)";
var DEFAULT_SUBHEADING_CLASS6 = "max-w-none text-left text-[16px] leading-6 text-(--info-proven-description)";
var DEFAULT_DESCRIPTION_CLASS16 = "text-[16px] leading-6 text-(--info-proven-description)";
var INFO_PROVEN_DEFAULTS = {
  "--info-proven-badge-bg": "var(--theme-color-accent, #007b7c)",
  "--info-proven-text-bg": "var(--theme-color-bg-raised, #f3f3f3)",
  "--info-proven-border": "var(--theme-color-border, #e0e0e0)",
  "--info-proven-heading": "var(--theme-color-heading-primary, #1f1f1f)",
  "--info-proven-description": "var(--theme-color-text-secondary, #333333)",
  "--info-proven-badge-label": "var(--theme-color-text-inverse, #ffffff)",
  "--info-proven-icon": "var(--theme-color-text-inverse, #ffffff)"
};
function buildInfoProvenVars(colors) {
  return {
    ...INFO_PROVEN_DEFAULTS,
    ...(colors == null ? void 0 : colors.sectionBackground) && { background: colors.sectionBackground },
    ...(colors == null ? void 0 : colors.badgeBackground) && { "--info-proven-badge-bg": colors.badgeBackground },
    ...(colors == null ? void 0 : colors.textBackground) && { "--info-proven-text-bg": colors.textBackground },
    ...(colors == null ? void 0 : colors.borderColor) && { "--info-proven-border": colors.borderColor },
    ...(colors == null ? void 0 : colors.headingColor) && { "--info-proven-heading": colors.headingColor },
    ...(colors == null ? void 0 : colors.descriptionColor) && { "--info-proven-description": colors.descriptionColor },
    ...(colors == null ? void 0 : colors.badgeLabelColor) && { "--info-proven-badge-label": colors.badgeLabelColor },
    ...(colors == null ? void 0 : colors.badgeIconColor) && { "--info-proven-icon": colors.badgeIconColor }
  };
}
var InfoBannerProvenResults = ({
  badgeLabel = "Proven Results*",
  badgeIcon,
  heading,
  headingHtml,
  headingAs = "h3",
  subheading,
  showDivider = false,
  subheadingPlacement = "before-divider",
  paragraph,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const hasParagraph = Boolean(sanitizeHtml(paragraph));
  const hasSubheading = Boolean(sanitizeHtml(subheading));
  const hasHeader = Boolean(heading || headingHtml || hasSubheading || showDivider);
  if (!hasHeader && !hasParagraph) return null;
  return /* @__PURE__ */ React257.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS21,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildInfoProvenVars(colors)
    },
    /* @__PURE__ */ React257.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS51, classes.container) }, /* @__PURE__ */ React257.createElement("div", { className: cn(DEFAULT_BANNER_CLASS2, classes.banner) }, /* @__PURE__ */ React257.createElement("div", { className: cn(DEFAULT_BADGE_BLOCK_CLASS, classes.badgeBlock) }, /* @__PURE__ */ React257.createElement(
      "div",
      {
        className: cn(
          DEFAULT_BADGE_ICON_WRAPPER_CLASS,
          "text-(--info-proven-icon)",
          classes.badgeIconWrapper
        )
      },
      badgeIcon ? /* @__PURE__ */ React257.createElement(Icon, { src: badgeIcon, alt: "", className: "w-full h-full object-contain" }) : /* @__PURE__ */ React257.createElement(IconVerifiedBadge, { className: "w-full h-full" })
    ), badgeLabel && /* @__PURE__ */ React257.createElement(Text, { className: cn(DEFAULT_BADGE_LABEL_CLASS, classes.badgeLabel) }, badgeLabel)), /* @__PURE__ */ React257.createElement("div", { className: cn(DEFAULT_TEXT_BLOCK_CLASS, classes.textBlock) }, /* @__PURE__ */ React257.createElement("div", { className: cn(DEFAULT_HEADER_GROUP_CLASS2, classes.headerGroup) }, hasHeader && /* @__PURE__ */ React257.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        subheading,
        headingAs,
        subheadingPlacement,
        showDivider,
        className: cn(DEFAULT_HEADER_CLASS18, classes.header),
        classes: {
          heading: cn(DEFAULT_HEADING_CLASS8, classes.heading),
          subheading: cn(DEFAULT_SUBHEADING_CLASS6, classes.subheading),
          divider: classes.divider
        }
      }
    ), hasParagraph && /* @__PURE__ */ React257.createElement(
      RichText,
      {
        html: paragraph,
        className: cn(DEFAULT_DESCRIPTION_CLASS16, classes.paragraph)
      }
    )))))
  );
};

// src/molecules/ImageDescriptionCard.tsx
import React258 from "react";
var DEFAULT_ROOT_CLASS32 = "flex flex-col";
var DEFAULT_IMAGE_WRAPPER_CLASS9 = "h-[250px] overflow-hidden rounded-t-[10px] bg-[#f5f5f5] relative shrink-0";
var DEFAULT_IMAGE_CLASS18 = "w-full h-full object-cover";
var DEFAULT_BODY_CLASS6 = "bg-white p-4 rounded-b-[10px] flex flex-col gap-2 flex-1";
var DEFAULT_TITLE_CLASS18 = "text-[24px] leading-8 font-bold text-[#0075A7]";
var DEFAULT_DESCRIPTION_CLASS17 = "text-[16px] leading-6 font-normal text-[#333333]";
var ImageDescriptionCard = ({
  image,
  imageAlt,
  title,
  titleAs = "h3",
  description,
  className,
  classes = {}
}) => {
  const hasBody = !!(title || description);
  const descriptionNode = typeof description === "string" ? /* @__PURE__ */ React258.createElement(Text, { as: "p", className: cn(DEFAULT_DESCRIPTION_CLASS17, classes.description) }, description) : /* @__PURE__ */ React258.createElement("div", { className: cn(DEFAULT_DESCRIPTION_CLASS17, classes.description) }, description);
  return /* @__PURE__ */ React258.createElement("article", { className: cn(DEFAULT_ROOT_CLASS32, classes.root, className) }, /* @__PURE__ */ React258.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS9, classes.imageWrapper) }, /* @__PURE__ */ React258.createElement(Image, { src: image, alt: imageAlt, className: cn(DEFAULT_IMAGE_CLASS18, classes.image) })), hasBody && /* @__PURE__ */ React258.createElement("div", { className: cn(DEFAULT_BODY_CLASS6, classes.body) }, title && /* @__PURE__ */ React258.createElement(Text, { as: titleAs, className: cn(DEFAULT_TITLE_CLASS18, classes.title) }, title), description && descriptionNode));
};

// src/molecules/IconDescriptionCard.tsx
import React259 from "react";
var DEFAULT_ROOT_CLASS33 = "flex flex-col items-center gap-4 p-4 rounded-[20px] border bg-[#E7F4FD]";
var DEFAULT_ICON_CLASS29 = "h-[85px] w-[85px] max-w-full object-contain shrink-0 p-[15px] rounded-full";
var DEFAULT_BODY_CLASS7 = "flex flex-col gap-2 items-center w-full";
var DEFAULT_TITLE_CLASS19 = "text-[18px] font-semibold leading-6 text-[#333333] text-center";
var DEFAULT_DESCRIPTION_CLASS18 = "text-[16px] leading-6 font-normal text-[#333333]";
var IconDescriptionCard = ({
  icon,
  iconAlt = "",
  title,
  titleAs = "h3",
  description,
  className,
  classes = {}
}) => /* @__PURE__ */ React259.createElement("article", { className: cn(DEFAULT_ROOT_CLASS33, classes.root, className) }, /* @__PURE__ */ React259.createElement(Icon, { src: icon, alt: iconAlt, className: cn(DEFAULT_ICON_CLASS29, classes.icon) }), /* @__PURE__ */ React259.createElement("div", { className: cn(DEFAULT_BODY_CLASS7, classes.body) }, /* @__PURE__ */ React259.createElement(Text, { as: titleAs, className: cn(DEFAULT_TITLE_CLASS19, classes.title) }, title), description && (typeof description === "string" ? /* @__PURE__ */ React259.createElement(Text, { as: "p", className: cn(DEFAULT_DESCRIPTION_CLASS18, classes.description) }, description) : /* @__PURE__ */ React259.createElement("div", { className: cn(DEFAULT_DESCRIPTION_CLASS18, classes.description) }, description))));

// src/molecules/ToggleBoxLayout.tsx
import React260 from "react";
var DEFAULT_ROOT_CLASS34 = "flex w-full items-start gap-[14px] rounded-[6px] border border-dashed px-[16px] py-[17px] text-left transition-colors";
var ToggleBoxLayout = ({
  isActive,
  onClick,
  icon,
  children,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React260.createElement(
    "button",
    {
      type: "button",
      className: cn(
        DEFAULT_ROOT_CLASS34,
        classes.root,
        isActive ? classes.active : classes.inactive,
        className
      ),
      onClick,
      "aria-pressed": isActive
    },
    icon,
    children
  );
};

// src/molecules/TwoOptionSelector.tsx
import React261 from "react";
var DEFAULT_ROOT_CLASS35 = "w-full";
var DEFAULT_SEGMENTED_CONTROL_CLASS = "grid min-h-[72px] grid-cols-2 overflow-hidden rounded border p-[2px]";
var DEFAULT_DESCRIPTION_CLASS19 = "px-2 pt-2 text-center text-sm leading-5";
var TwoOptionSelector = ({
  firstOption,
  secondOption,
  description,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React261.createElement("div", { className: cn(DEFAULT_ROOT_CLASS35, classes.root, className) }, /* @__PURE__ */ React261.createElement("div", { className: cn(DEFAULT_SEGMENTED_CONTROL_CLASS, classes.segmentedControl), role: "group" }, /* @__PURE__ */ React261.createElement(SegmentedOption, { ...firstOption, classes: classes.option }), /* @__PURE__ */ React261.createElement(SegmentedOption, { ...secondOption, classes: classes.option })), description ? /* @__PURE__ */ React261.createElement("div", { className: cn(DEFAULT_DESCRIPTION_CLASS19, classes.description) }, description) : null);
};

// src/sections/AboutProductLargeImageDescription.tsx
import React262, { useState as useState29 } from "react";
var DEFAULT_SECTION_CLASS22 = "w-full [background:var(--about-lid-bg)]";
var DEFAULT_CONTAINER_CLASS52 = "mx-auto max-w-[1100px] px-4 lg:px-0 flex flex-col gap-10 items-center";
var DEFAULT_SUBHEADING_CLASS7 = "text-(--about-lid-subheading)";
var DEFAULT_GRID_CLASS3 = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full";
var DEFAULT_SHOW_MORE_CLASS = "font-outfit text-[18px] font-bold leading-6 text-(--about-lid-show-more) underline";
var DEFAULT_HEADER_DIVIDER_CLASS6 = "bg-(--about-lid-primary-color)";
function buildVars9(colors) {
  var _a, _b, _c, _d, _e, _f, _g;
  return {
    "--about-lid-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-tint, #E7F4FD)",
    "--about-lid-primary-color": (_b = colors == null ? void 0 : colors.primaryColor) != null ? _b : "var(--theme-color-accent, #0075A7)",
    "--about-lid-subheading": (_c = colors == null ? void 0 : colors.subheadingColor) != null ? _c : "var(--theme-color-text-primary, #333333)",
    "--about-lid-card-title": (_d = colors == null ? void 0 : colors.cardTitleColor) != null ? _d : "var(--theme-color-accent, #0075A7)",
    "--about-lid-card-desc": (_e = colors == null ? void 0 : colors.cardDescriptionColor) != null ? _e : "var(--theme-color-text-primary, #333333)",
    "--about-lid-card-body-bg": (_f = colors == null ? void 0 : colors.cardBodyBackground) != null ? _f : "var(--theme-color-bg-raised, #FFFFFF)",
    "--about-lid-show-more": (_g = colors == null ? void 0 : colors.showMoreColor) != null ? _g : "var(--theme-color-bg-dark, #002A42)"
  };
}
function getCardVisibilityClass(index, mobileLimit, desktopLimit) {
  const hiddenOnMobile = mobileLimit !== void 0 && index >= mobileLimit;
  const hiddenOnDesktop = desktopLimit !== void 0 && index >= desktopLimit;
  if (hiddenOnMobile && hiddenOnDesktop) return "hidden";
  if (hiddenOnMobile) return "hidden md:flex md:flex-col";
  if (hiddenOnDesktop) return "flex flex-col md:hidden";
  return "";
}
var AboutProductLargeImageDescription = ({
  heading,
  headingHtml,
  headingAs = "h2",
  subheading,
  subheadingPlacement = "before-divider",
  showDivider = true,
  showHeader = true,
  items = [],
  initialVisibleCount,
  mobileVisibleCount,
  showMore = false,
  showMoreText,
  onShowMore,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const [expanded, setExpanded] = useState29(false);
  if (!items.length) return null;
  const hasHeader = showHeader && !!(heading || headingHtml || subheading);
  const hasDesktopHiddenItems = !expanded && initialVisibleCount !== void 0 && items.length > initialVisibleCount;
  const hasMobileHiddenItems = !expanded && mobileVisibleCount !== void 0 && items.length > mobileVisibleCount;
  const hasAnyHiddenItems = hasDesktopHiddenItems || hasMobileHiddenItems;
  const showMoreButtonVisibility = hasMobileHiddenItems && !hasDesktopHiddenItems ? "md:hidden" : !hasMobileHiddenItems && hasDesktopHiddenItems ? "hidden md:block" : "";
  function handleShowMore() {
    setExpanded(true);
    onShowMore == null ? void 0 : onShowMore();
  }
  return /* @__PURE__ */ React262.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS22,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars9(colors)
    },
    /* @__PURE__ */ React262.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS52, classes.container) }, hasHeader && /* @__PURE__ */ React262.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading,
        subheadingPlacement,
        showDivider,
        className: classes.header,
        classes: {
          heading: classes.heading,
          subheading: cn(DEFAULT_SUBHEADING_CLASS7, classes.subheading),
          divider: cn(DEFAULT_HEADER_DIVIDER_CLASS6, classes.divider)
        }
      }
    ), items.length > 0 && /* @__PURE__ */ React262.createElement("div", { className: cn(DEFAULT_GRID_CLASS3, classes.grid) }, items.map((item, i) => {
      const visibilityClass = expanded ? "" : getCardVisibilityClass(i, mobileVisibleCount, initialVisibleCount);
      return /* @__PURE__ */ React262.createElement(
        ImageDescriptionCard,
        {
          key: `${item.title}-${i}`,
          image: item.image,
          imageAlt: item.imageAlt,
          title: item.title,
          description: /* @__PURE__ */ React262.createElement(RichText, { html: item.description }),
          className: visibilityClass,
          classes: {
            root: classes.card,
            imageWrapper: classes.cardImageWrapper,
            image: classes.cardImage,
            body: cn("[background:var(--about-lid-card-body-bg)]", classes.cardBody),
            title: cn("font-outfit text-(--about-lid-card-title)", classes.cardTitle),
            description: cn("text-(--about-lid-card-desc)", classes.cardDescription)
          }
        }
      );
    })), showMore && showMoreText && hasAnyHiddenItems && /* @__PURE__ */ React262.createElement(
      TextButton,
      {
        onClick: handleShowMore,
        className: cn(DEFAULT_SHOW_MORE_CLASS, showMoreButtonVisibility, classes.showMore)
      },
      showMoreText
    ))
  );
};

// src/sections/AboutProductLargeImageDropdown.tsx
import React263, { useState as useState30 } from "react";
var DEFAULT_SECTION_CLASS23 = "w-full px-4 [background:var(--about-plid-bg)]";
var DEFAULT_CONTAINER_BASE_CLASS = "mx-auto max-w-[1100px] grid grid-cols-1 gap-8 lg:gap-x-10 lg:gap-y-8";
var DEFAULT_TEXT_BLOCK_CLASS2 = "flex flex-col gap-4";
var DEFAULT_HEADER_CLASS19 = "items-center text-center lg:items-start lg:text-left gap-3";
var DEFAULT_HEADING_CLASS9 = "text-[32px] leading-10 md:text-[60px] md:leading-[68px] font-extrabold text-(--about-plid-heading) font-outfit text-center lg:text-left";
var DEFAULT_SUBHEADING_CLASS8 = "text-(--about-plid-description)";
var DEFAULT_DIVIDER_CLASS14 = "bg-(--about-plid-accent) mx-auto lg:mx-0";
var DEFAULT_DESCRIPTION_CLASS20 = "text-[16px] leading-6 md:text-[18px] md:leading-[26px] text-(--about-plid-description)";
var DEFAULT_IMAGE_WRAPPER_CLASS10 = "overflow-hidden rounded-[32px] w-full aspect-[5/7] md:max-w-[400px] md:mx-auto lg:aspect-auto lg:h-[800px] lg:max-w-none lg:mx-0";
var DEFAULT_IMAGE_CLASS19 = "w-full h-full object-cover block";
var DEFAULT_ACCORDION_LIST_CLASS2 = "flex flex-col gap-2 w-full";
function buildVars10(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const background = (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-dark, #121212)";
  const backgroundGradientTo = colors == null ? void 0 : colors.backgroundGradientTo;
  return {
    "--about-plid-bg": backgroundGradientTo ? `linear-gradient(to bottom, ${background}, ${backgroundGradientTo})` : background,
    "--about-plid-heading": (_b = colors == null ? void 0 : colors.headingColor) != null ? _b : "var(--theme-color-text-inverse, #ffffff)",
    "--about-plid-accent": (_c = colors == null ? void 0 : colors.accentColor) != null ? _c : "var(--theme-color-accent-secondary, #0090CD)",
    "--about-plid-description": (_d = colors == null ? void 0 : colors.descriptionColor) != null ? _d : "var(--theme-color-text-inverse, #ffffff)",
    "--about-plid-border": (_e = colors == null ? void 0 : colors.accordionBorderColor) != null ? _e : "var(--theme-color-accent-secondary, #0090CD)",
    "--about-plid-closed-bg": (_f = colors == null ? void 0 : colors.accordionClosedBackground) != null ? _f : "transparent",
    "--about-plid-open-bg": (_g = colors == null ? void 0 : colors.accordionOpenBackground) != null ? _g : "var(--theme-color-bg-raised, #ffffff)",
    "--about-plid-open-title": (_h = colors == null ? void 0 : colors.accordionOpenTitleColor) != null ? _h : "var(--theme-color-accent-secondary, #0090CD)",
    "--about-plid-closed-title": (_i = colors == null ? void 0 : colors.accordionClosedTitleColor) != null ? _i : "var(--theme-color-text-inverse, #ffffff)",
    "--about-plid-content-text": (_j = colors == null ? void 0 : colors.accordionContentTextColor) != null ? _j : "var(--theme-color-text-primary, #333333)"
  };
}
function accordionItemClasses(isOpen, classes) {
  return {
    button: cn(
      isOpen ? "[background:var(--about-plid-open-bg)]" : "[background:var(--about-plid-closed-bg)]",
      classes.accordionButton
    ),
    label: cn(
      "text-[18px] font-outfit",
      isOpen ? "text-(--about-plid-open-title)" : "text-(--about-plid-closed-title)",
      classes.accordionTitle
    ),
    iconWrapper: cn(
      isOpen ? "text-(--about-plid-open-title)" : "text-(--about-plid-closed-title)",
      classes.accordionIcon
    ),
    panel: cn(isOpen && "[background:var(--about-plid-open-bg)]", classes.accordionPanel),
    content: cn("text-[16px] text-(--about-plid-content-text)", classes.accordionContent)
  };
}
function richContent(content, className) {
  if (!content) {
    return null;
  }
  if (typeof content === "string") {
    return /* @__PURE__ */ React263.createElement(RichText, { html: content, className });
  }
  return /* @__PURE__ */ React263.createElement("div", { className }, content);
}
var AboutProductLargeImageDropdown = ({
  image,
  imageAlt,
  heading,
  headingHtml,
  headingAs = "h2",
  subheading,
  subheadingPlacement = "before-divider",
  showSubheading = false,
  description,
  items = [],
  imagePosition = "left",
  showDivider = true,
  initialOpenIndex = 0,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const [openIndex, setOpenIndex] = useState30(initialOpenIndex);
  if (!items.length) return null;
  function handleToggle(index) {
    setOpenIndex((prev) => prev === index ? -1 : index);
  }
  const hasSubheading = showSubheading && !!subheading;
  const hasTextContent = !!(heading || headingHtml || hasSubheading || description);
  return /* @__PURE__ */ React263.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS23,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars10(colors)
    },
    /* @__PURE__ */ React263.createElement(
      "div",
      {
        className: cn(
          DEFAULT_CONTAINER_BASE_CLASS,
          imagePosition === "left" ? "lg:grid-cols-[570px_1fr]" : "lg:grid-cols-[1fr_570px]",
          classes.container
        )
      },
      hasTextContent && /* @__PURE__ */ React263.createElement(
        "div",
        {
          className: cn(
            DEFAULT_TEXT_BLOCK_CLASS2,
            imagePosition === "left" ? "lg:col-start-2" : "lg:col-start-1",
            "lg:row-start-1",
            classes.textBlock
          )
        },
        (heading || headingHtml || hasSubheading || showDivider) && /* @__PURE__ */ React263.createElement(
          SectionHeader,
          {
            heading,
            headingHtml,
            headingAs,
            subheading: hasSubheading ? subheading : void 0,
            subheadingPlacement,
            showDivider,
            className: cn(DEFAULT_HEADER_CLASS19, classes.header),
            classes: {
              heading: cn(DEFAULT_HEADING_CLASS9, classes.heading),
              subheading: cn(DEFAULT_SUBHEADING_CLASS8, classes.subheading),
              divider: cn(DEFAULT_DIVIDER_CLASS14, classes.divider)
            }
          }
        ),
        richContent(description, cn(DEFAULT_DESCRIPTION_CLASS20, classes.description))
      ),
      /* @__PURE__ */ React263.createElement(
        "div",
        {
          className: cn(
            DEFAULT_IMAGE_WRAPPER_CLASS10,
            imagePosition === "left" ? "lg:col-start-1" : "lg:col-start-2",
            "lg:row-start-1 lg:row-span-2",
            classes.imageWrapper
          )
        },
        /* @__PURE__ */ React263.createElement(Image, { src: image, alt: imageAlt, className: cn(DEFAULT_IMAGE_CLASS19, classes.image) })
      ),
      /* @__PURE__ */ React263.createElement(
        "ul",
        {
          className: cn(
            DEFAULT_ACCORDION_LIST_CLASS2,
            imagePosition === "left" ? "lg:col-start-2" : "lg:col-start-1",
            hasTextContent ? "lg:row-start-2" : "lg:row-start-1",
            classes.accordionList
          )
        },
        items.map((item, index) => {
          const isOpen = openIndex === index;
          return /* @__PURE__ */ React263.createElement("li", { key: item.id }, /* @__PURE__ */ React263.createElement(
            AccordionItem,
            {
              id: item.id,
              label: item.label,
              content: richContent(item.description),
              isOpen,
              onToggle: () => handleToggle(index),
              className: cn(
                "overflow-hidden rounded-[6px] border border-(--about-plid-border)",
                classes.accordionItem
              ),
              classes: accordionItemClasses(isOpen, classes)
            }
          ));
        })
      )
    )
  );
};

// src/sections/AboutProductImageWithList.tsx
import React264 from "react";
var DEFAULT_SECTION_CLASS24 = "w-full [background:var(--apil-bg)]";
var DEFAULT_CONTAINER_CLASS53 = "mx-auto max-w-[1100px] px-4 lg:px-0 flex flex-col gap-8 md:gap-10 items-center";
var DEFAULT_IMAGE_WRAPPER_CLASS11 = "w-full flex justify-center";
var DEFAULT_IMAGE_MOBILE_CLASS2 = "w-full h-auto md:hidden";
var DEFAULT_IMAGE_DESKTOP_CLASS2 = "hidden md:block w-full !max-w-[711px] h-auto";
var DEFAULT_CARD_CLASS7 = "w-full max-w-[550px] flex gap-4 items-center rounded-[10px] p-4 border [background:var(--apil-card-bg)] border-(--apil-card-border)";
var DEFAULT_CARD_IMAGE_WRAPPER_CLASS = "size-[100px] flex-shrink-0 overflow-hidden rounded-lg";
var DEFAULT_CARD_IMAGE_CLASS = "w-full h-full object-cover";
var DEFAULT_CARD_CONTENT_CLASS = "flex flex-col gap-2 min-w-0 flex-1";
var DEFAULT_CARD_TITLE_CLASS2 = "text-[20px] font-bold leading-7 text-(--apil-card-title)";
var DEFAULT_CARD_DESC_CLASS = "text-[16px] font-normal leading-6 text-(--apil-card-desc)";
function buildVars11(colors) {
  var _a, _b, _c, _d, _e;
  return {
    "--apil-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--apil-card-bg": (_b = colors == null ? void 0 : colors.cardBackground) != null ? _b : "var(--theme-color-bg-section, #F5F5F5)",
    "--apil-card-border": (_c = colors == null ? void 0 : colors.cardBorderColor) != null ? _c : "var(--theme-color-accent-secondary, #0090CD)",
    "--apil-card-title": (_d = colors == null ? void 0 : colors.cardTitleColor) != null ? _d : "var(--theme-color-accent, #0075A7)",
    "--apil-card-desc": (_e = colors == null ? void 0 : colors.cardDescriptionColor) != null ? _e : "var(--theme-color-text-primary, #333333)"
  };
}
var AboutProductImageWithList = ({
  image,
  imageAlt,
  imageMobile,
  imageMobileAlt,
  cardImage,
  cardImageAlt,
  cardTitle,
  cardDescription,
  heading,
  headingHtml,
  headingAs = "h2",
  subheading,
  subheadingPlacement = "before-divider",
  showDivider = true,
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const hasHeader = !!(heading || headingHtml || subheading);
  const cardThumbnail = cardImage != null ? cardImage : image;
  const cardThumbnailAlt = cardImageAlt != null ? cardImageAlt : imageAlt;
  return /* @__PURE__ */ React264.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS24,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars11(colors)
    },
    /* @__PURE__ */ React264.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS53, classes.container) }, hasHeader && /* @__PURE__ */ React264.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading,
        subheadingPlacement,
        showDivider,
        className: classes.header,
        classes: {
          heading: classes.heading,
          subheading: classes.subheading,
          divider: classes.divider
        }
      }
    ), /* @__PURE__ */ React264.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS11, classes.imageWrapper) }, /* @__PURE__ */ React264.createElement(
      Image,
      {
        src: imageMobile,
        alt: imageMobileAlt,
        className: cn(DEFAULT_IMAGE_MOBILE_CLASS2, classes.imageMobile)
      }
    ), /* @__PURE__ */ React264.createElement(
      Image,
      {
        src: image,
        alt: imageAlt,
        className: cn(DEFAULT_IMAGE_DESKTOP_CLASS2, classes.image)
      }
    )), /* @__PURE__ */ React264.createElement("div", { className: cn(DEFAULT_CARD_CLASS7, classes.card) }, /* @__PURE__ */ React264.createElement("div", { className: cn(DEFAULT_CARD_IMAGE_WRAPPER_CLASS, classes.cardImageWrapper) }, /* @__PURE__ */ React264.createElement(
      Image,
      {
        src: cardThumbnail,
        alt: cardThumbnailAlt,
        className: cn(DEFAULT_CARD_IMAGE_CLASS, classes.cardImage)
      }
    )), /* @__PURE__ */ React264.createElement("div", { className: cn(DEFAULT_CARD_CONTENT_CLASS, classes.cardContent) }, /* @__PURE__ */ React264.createElement(Text, { as: "p", className: cn(DEFAULT_CARD_TITLE_CLASS2, classes.cardTitle) }, cardTitle), /* @__PURE__ */ React264.createElement(
      RichText,
      {
        html: cardDescription,
        className: cn(DEFAULT_CARD_DESC_CLASS, classes.cardDescription)
      }
    ))))
  );
};

// src/sections/AboutProductIconDescriptionStatic.tsx
import React265 from "react";
var DEFAULT_SECTION_CLASS25 = "w-full [background:var(--about-pid-bg)]";
var DEFAULT_CONTAINER_CLASS54 = "mx-auto max-w-[1100px] px-4 lg:px-0 flex flex-col gap-10 items-center";
var DEFAULT_TEXT_BLOCK_CLASS3 = "flex flex-col gap-4 items-center w-full";
var DEFAULT_SUBHEADING_CLASS9 = "font-medium text-(--about-pid-subheading)";
var DEFAULT_BODY_TEXT_CLASS = "text-[16px] leading-6 md:text-[18px] md:leading-[26px] font-normal text-(--about-pid-body-text) text-center";
var DEFAULT_GRID_CLASS4 = "flex flex-wrap justify-center gap-6 w-full";
var DEFAULT_GRID_ITEM_CLASS = "w-full lg:w-[calc(25%-18px)] lg:flex-none";
function buildVars12(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    "--about-pid-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--about-pid-subheading": (_b = colors == null ? void 0 : colors.subheadingColor) != null ? _b : "var(--theme-color-text-primary, #333333)",
    "--about-pid-body-text": (_c = colors == null ? void 0 : colors.bodyTextColor) != null ? _c : "var(--theme-color-text-primary, #333333)",
    "--about-pid-card-bg": (_d = colors == null ? void 0 : colors.cardBackground) != null ? _d : "var(--theme-color-bg-tint, #E7F4FD)",
    "--about-pid-card-border": (_e = colors == null ? void 0 : colors.cardBorderColor) != null ? _e : "var(--theme-color-border-light, #F0F0F0)",
    "--about-pid-card-icon-bg": (_f = colors == null ? void 0 : colors.iconBackground) != null ? _f : "var(--theme-color-accent-secondary, #0090CD)",
    "--about-pid-title": (_g = colors == null ? void 0 : colors.titleColor) != null ? _g : "var(--theme-color-text-primary, #333333)",
    "--about-pid-desc": (_h = colors == null ? void 0 : colors.descriptionColor) != null ? _h : "var(--theme-color-text-primary, #333333)"
  };
}
var AboutProductIconDescriptionStatic = ({
  heading,
  headingHtml,
  headingAs = "h2",
  subheading,
  subheadingPlacement = "before-divider",
  showDivider = true,
  showHeader = true,
  bodyText,
  items = [],
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  if (!items.length) return null;
  const hasHeader = showHeader && !!(heading || headingHtml || subheading);
  const showTextBlock = hasHeader || !!bodyText;
  return /* @__PURE__ */ React265.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS25,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars12(colors)
    },
    /* @__PURE__ */ React265.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS54, classes.container) }, showTextBlock && /* @__PURE__ */ React265.createElement("div", { className: cn(DEFAULT_TEXT_BLOCK_CLASS3, classes.textBlock) }, hasHeader && /* @__PURE__ */ React265.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading,
        subheadingPlacement,
        showDivider,
        className: classes.header,
        classes: {
          heading: classes.heading,
          subheading: cn(DEFAULT_SUBHEADING_CLASS9, classes.subheading),
          divider: classes.divider
        }
      }
    ), bodyText && /* @__PURE__ */ React265.createElement(RichText, { html: bodyText, className: cn(DEFAULT_BODY_TEXT_CLASS, classes.bodyText) })), /* @__PURE__ */ React265.createElement("div", { className: cn(DEFAULT_GRID_CLASS4, classes.grid) }, items.map((item, i) => /* @__PURE__ */ React265.createElement(
      "div",
      {
        key: `${item.title}-${i}`,
        className: cn(DEFAULT_GRID_ITEM_CLASS, classes.gridItem)
      },
      /* @__PURE__ */ React265.createElement(
        IconDescriptionCard,
        {
          icon: item.icon,
          iconAlt: item.iconAlt,
          title: item.title,
          description: /* @__PURE__ */ React265.createElement(RichText, { html: item.description }),
          className: "h-full",
          classes: {
            root: cn(
              "[background:var(--about-pid-card-bg)] [border-color:var(--about-pid-card-border)]",
              classes.card
            ),
            icon: cn("[background:var(--about-pid-card-icon-bg)]", classes.cardIcon),
            body: classes.cardBody,
            title: cn("text-(--about-pid-title) whitespace-pre-line", classes.cardTitle),
            description: cn("text-(--about-pid-desc)", classes.cardDescription)
          }
        }
      )
    ))))
  );
};

// src/sections/AboutProductIconDescriptionMotion.tsx
import React266, { useEffect as useEffect26, useRef as useRef19, useState as useState31 } from "react";
var DEFAULT_SECTION_CLASS26 = "w-full [background:var(--about-pidm-bg)]";
var DEFAULT_VIEWPORT_CLASS3 = "w-full overflow-hidden cursor-grab select-none";
var DEFAULT_TRACK_CLASS5 = "flex w-max will-change-transform";
var DEFAULT_GROUP_CLASS5 = "flex flex-none gap-6 pl-6";
var DEFAULT_CARD_ICON_CLASS = "h-20 w-20";
function buildVars13(colors) {
  var _a, _b, _c, _d, _e, _f;
  return {
    "--about-pidm-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-section, #F5F5F5)",
    "--about-pidm-card-bg": (_b = colors == null ? void 0 : colors.cardBackground) != null ? _b : "var(--theme-color-bg-raised, #FFFFFF)",
    "--about-pidm-title": (_c = colors == null ? void 0 : colors.titleColor) != null ? _c : "var(--theme-color-accent, #0075A7)",
    "--about-pidm-desc": (_d = colors == null ? void 0 : colors.descriptionColor) != null ? _d : "var(--theme-color-text-primary, #333333)",
    "--about-pidm-icon-border": (_e = colors == null ? void 0 : colors.iconBorderColor) != null ? _e : "var(--theme-color-accent, #0075A7)",
    "--about-pidm-icon-bg": (_f = colors == null ? void 0 : colors.iconBackground) != null ? _f : "var(--theme-color-bg-tint, #E7F4FD)"
  };
}
var COPIES2 = 3;
var AboutProductIconDescriptionMotion = ({ items = [], scrollSpeed = 0.5, colors, sectionSpacing, className, classes = {} }) => {
  const viewportRef = useRef19(null);
  const trackRef = useRef19(null);
  const firstGroupRef = useRef19(null);
  const [cycleWidth, setCycleWidth] = useState31(0);
  const [viewportWidth, setViewportWidth] = useState31(0);
  useEffect26(() => {
    const group = firstGroupRef.current;
    const viewport = viewportRef.current;
    if (!group || !viewport) return;
    const updateSizes = () => {
      setCycleWidth(group.offsetWidth);
      setViewportWidth(viewport.offsetWidth);
    };
    updateSizes();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateSizes);
      return () => {
        window.removeEventListener("resize", updateSizes);
      };
    }
    const observer = new ResizeObserver(updateSizes);
    observer.observe(group);
    observer.observe(viewport);
    return () => {
      observer.disconnect();
    };
  }, [items.length]);
  const copyCount = cycleWidth > 0 ? Math.max(COPIES2, Math.ceil(viewportWidth / cycleWidth) + 2) : COPIES2;
  const copies = Array.from({ length: copyCount }, (_, index) => index);
  useInfiniteTrackScroll({
    containerRef: viewportRef,
    trackRef,
    speed: scrollSpeed,
    cycleSize: cycleWidth,
    initialOffset: -cycleWidth
  });
  if (!items.length) return null;
  return /* @__PURE__ */ React266.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS26,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars13(colors)
    },
    /* @__PURE__ */ React266.createElement("div", { ref: viewportRef, className: cn(DEFAULT_VIEWPORT_CLASS3, classes.viewport) }, /* @__PURE__ */ React266.createElement("div", { ref: trackRef, className: cn(DEFAULT_TRACK_CLASS5, classes.track) }, copies.map((copyIndex) => /* @__PURE__ */ React266.createElement(
      "div",
      {
        key: copyIndex,
        ref: copyIndex === 0 ? firstGroupRef : void 0,
        className: cn(DEFAULT_GROUP_CLASS5, classes.group),
        "aria-hidden": copyIndex > 0 || void 0
      },
      items.map((item, itemIndex) => /* @__PURE__ */ React266.createElement(
        IconDescriptionCard,
        {
          key: `${copyIndex}-${item.title}-${itemIndex}`,
          icon: item.icon,
          iconAlt: item.iconAlt,
          title: item.title,
          description: /* @__PURE__ */ React266.createElement(RichText, { html: item.description }),
          classes: {
            root: cn(
              "items-start [background:var(--about-pidm-card-bg)] rounded-[10px] border-0 w-[355px] shrink-0",
              classes.card
            ),
            icon: cn(
              DEFAULT_CARD_ICON_CLASS,
              "border [border-color:var(--about-pidm-icon-border)] [background:var(--about-pidm-icon-bg)]",
              classes.cardIcon
            ),
            body: cn("items-start", classes.cardBody),
            title: cn(
              "text-[24px] leading-8 font-bold text-left text-(--about-pidm-title)",
              classes.cardTitle
            ),
            description: cn("text-left text-(--about-pidm-desc)", classes.cardDescription)
          }
        }
      ))
    ))))
  );
};

// src/sections/AboutProductIconTitle.tsx
import React267 from "react";
var DEFAULT_SECTION_CLASS27 = "w-full overflow-hidden [background:var(--about-pit-bg)]";
var DEFAULT_CONTAINER_CLASS55 = "mx-auto flex w-full flex-col items-center gap-6";
var DEFAULT_HEADER_CLASS20 = "w-full px-2.5 md:px-6";
var DEFAULT_HEADING_CLASS10 = "text-center text-[24px] leading-8 font-extrabold text-(--about-pit-heading) md:text-[28px] md:leading-9 lg:text-[28px] lg:leading-9";
var DEFAULT_VIEWPORT_CLASS4 = "w-full overflow-x-auto px-2.5 outline-none [scrollbar-width:none] focus-visible:ring-2 focus-visible:ring-(--about-pit-heading) focus-visible:ring-offset-2 [&::-webkit-scrollbar]:hidden";
var DEFAULT_LIST_CLASS8 = "mx-auto flex w-max list-none items-start gap-4 p-0";
var DEFAULT_ITEM_CLASS12 = "flex w-[150px] shrink-0 flex-col items-center gap-4 text-center";
var DEFAULT_IMAGE_CLASS20 = "size-[100px] rounded-full object-cover";
var DEFAULT_SUBHEADING_CLASS10 = "text-(--about-pit-subheading)";
var DEFAULT_DIVIDER_CLASS15 = "[background:var(--about-pit-divider)]";
var DEFAULT_TITLE_CLASS20 = "text-center text-xl leading-7 font-medium text-(--about-pit-title)";
function buildVars14(colors) {
  var _a, _b, _c, _d, _e;
  return {
    "--about-pit-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--about-pit-heading": (_b = colors == null ? void 0 : colors.headingColor) != null ? _b : "var(--theme-color-heading-primary, #000000)",
    "--about-pit-subheading": (_c = colors == null ? void 0 : colors.subheadingColor) != null ? _c : "var(--theme-color-text-primary, #333333)",
    "--about-pit-title": (_d = colors == null ? void 0 : colors.titleColor) != null ? _d : "var(--theme-color-heading-primary, #000000)",
    "--about-pit-divider": (_e = colors == null ? void 0 : colors.dividerColor) != null ? _e : "var(--theme-color-accent-secondary, #0090CD)"
  };
}
var AboutProductIconTitle = ({
  heading,
  headingHtml,
  headingAs = "h2",
  showDivider = false,
  showSubheading = false,
  subheading,
  subheadingPlacement,
  items = [],
  itemsAriaLabel = "Product icon list",
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  if (!items.length) return null;
  const resolvedSubheading = showSubheading ? subheading : void 0;
  const hasHeader = !!(heading || headingHtml || resolvedSubheading || showDivider);
  return /* @__PURE__ */ React267.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS27,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars14(colors)
    },
    /* @__PURE__ */ React267.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS55, classes.container) }, hasHeader && /* @__PURE__ */ React267.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading: resolvedSubheading,
        subheadingPlacement,
        showDivider,
        className: cn(DEFAULT_HEADER_CLASS20, classes.header),
        classes: {
          heading: cn(DEFAULT_HEADING_CLASS10, classes.heading),
          subheading: cn(DEFAULT_SUBHEADING_CLASS10, classes.subheading),
          divider: cn(DEFAULT_DIVIDER_CLASS15, classes.divider)
        }
      }
    ), /* @__PURE__ */ React267.createElement(
      "div",
      {
        className: cn(DEFAULT_VIEWPORT_CLASS4, classes.viewport),
        role: "region",
        "aria-label": itemsAriaLabel,
        tabIndex: 0
      },
      /* @__PURE__ */ React267.createElement("ul", { className: cn(DEFAULT_LIST_CLASS8, classes.list) }, items.map((item, index) => {
        var _a;
        return /* @__PURE__ */ React267.createElement("li", { key: `${item.title}-${index}`, className: cn(DEFAULT_ITEM_CLASS12, classes.item) }, /* @__PURE__ */ React267.createElement(
          Image,
          {
            src: item.image,
            alt: (_a = item.imageAlt) != null ? _a : item.title,
            className: cn(DEFAULT_IMAGE_CLASS20, classes.image)
          }
        ), /* @__PURE__ */ React267.createElement(Text, { as: "span", className: cn(DEFAULT_TITLE_CLASS20, classes.title) }, item.title));
      }))
    ))
  );
};

// src/sections/AboutProductLargeImageList.tsx
import React268 from "react";
var DEFAULT_SECTION_CLASS28 = "w-full [background:var(--apil-bg)]";
var DEFAULT_CONTAINER_CLASS56 = "mx-auto max-w-[1100px] px-4 lg:px-8 flex flex-col gap-8 md:gap-10 items-center";
var DEFAULT_HEADING_CLASS11 = "font-extrabold text-[32px] leading-[40px] md:text-[60px] md:leading-[68px] text-center text-(--apil-heading-color)";
var DEFAULT_CONTENT_ROW_CLASS = "flex flex-col lg:flex-row gap-8 lg:gap-10 items-center w-full";
var DEFAULT_IMAGE_CARD_CLASS2 = "w-full max-w-[280px] md:max-w-[400px] lg:w-[570px] lg:max-w-[570px] shrink-0 rounded-[32px] overflow-hidden mx-auto lg:mx-0";
var DEFAULT_IMAGE_CARD_INNER_CLASS2 = "h-auto bg-transparent";
var DEFAULT_IMAGE_CLASS21 = "block w-full h-auto object-contain";
var DEFAULT_LIST_CLASS9 = "flex flex-col w-full flex-1 min-w-0";
var DEFAULT_ITEM_CLASS13 = "flex items-center gap-4 py-4";
var DEFAULT_ICON_WRAPPER_CLASS2 = "shrink-0 rounded-full bg-(--apil-icon-bg) size-[48px] md:size-[60px] flex items-center justify-center";
var DEFAULT_ICON_CLASS30 = "size-[34px] md:size-[41px] object-contain";
var DEFAULT_LABEL_CLASS13 = "font-bold text-[20px] leading-[28px] md:text-[24px] md:leading-[32px] text-(--apil-label-color)";
var DEFAULT_DIVIDER_CLASS16 = "w-full h-px bg-(--apil-divider-color)";
var DEFAULT_CONTENT_ROW_REVERSED_CLASS = "lg:flex-row-reverse";
function buildVars15(colors) {
  var _a, _b, _c, _d, _e;
  return {
    "--apil-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "linear-gradient(to bottom, var(--theme-color-bg-tint, #e7f4fd), #cfebff)",
    "--apil-heading-color": (_b = colors == null ? void 0 : colors.headingColor) != null ? _b : "var(--theme-color-heading-primary, #000000)",
    "--apil-label-color": (_c = colors == null ? void 0 : colors.itemLabelColor) != null ? _c : "var(--theme-color-text-primary, #333333)",
    "--apil-icon-bg": (_d = colors == null ? void 0 : colors.iconBackground) != null ? _d : "rgba(255, 255, 255, 0.7)",
    "--apil-divider-color": (_e = colors == null ? void 0 : colors.dividerColor) != null ? _e : "var(--theme-color-border-light, #d1e9f7)"
  };
}
var ListItemIcon = ({ icon, iconAlt, fallbackIcon, className }) => {
  const [imgError, setImgError] = React268.useState(false);
  if (icon && !imgError) {
    return /* @__PURE__ */ React268.createElement(
      Image,
      {
        src: icon,
        alt: iconAlt != null ? iconAlt : "",
        className,
        onError: () => setImgError(true)
      }
    );
  }
  return /* @__PURE__ */ React268.createElement("span", { className }, fallbackIcon);
};
var AboutProductLargeImageList = ({
  heading,
  headingHtml,
  headingAs = "h2",
  image,
  imageAlt,
  imageTitle,
  imageDescription,
  reverseLayout = false,
  items = [],
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  if (!items.length) return null;
  const hasHeading = Boolean(heading || headingHtml);
  return /* @__PURE__ */ React268.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS28,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars15(colors)
    },
    /* @__PURE__ */ React268.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS56, classes.container) }, hasHeading && /* @__PURE__ */ React268.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        showDivider: false,
        classes: { heading: cn(DEFAULT_HEADING_CLASS11, classes.heading) }
      }
    ), /* @__PURE__ */ React268.createElement(
      "div",
      {
        className: cn(
          DEFAULT_CONTENT_ROW_CLASS,
          reverseLayout && DEFAULT_CONTENT_ROW_REVERSED_CLASS,
          classes.contentRow
        )
      },
      /* @__PURE__ */ React268.createElement(
        ImageDescriptionCard,
        {
          image,
          imageAlt,
          title: imageTitle,
          description: imageDescription,
          className: cn(DEFAULT_IMAGE_CARD_CLASS2, classes.imageCard),
          classes: {
            imageWrapper: cn(DEFAULT_IMAGE_CARD_INNER_CLASS2, classes.imageCardInner),
            image: cn(DEFAULT_IMAGE_CLASS21, classes.image),
            body: classes.imageCardBody,
            title: classes.imageCardTitle,
            description: classes.imageCardDescription
          }
        }
      ),
      /* @__PURE__ */ React268.createElement("ul", { className: cn(DEFAULT_LIST_CLASS9, classes.list) }, items.map((item, i) => {
        return /* @__PURE__ */ React268.createElement("li", { key: `${item.label}-${i}` }, i > 0 && /* @__PURE__ */ React268.createElement(
          "div",
          {
            "aria-hidden": "true",
            className: cn(DEFAULT_DIVIDER_CLASS16, classes.divider)
          }
        ), /* @__PURE__ */ React268.createElement("div", { className: cn(DEFAULT_ITEM_CLASS13, classes.item) }, (item.icon || item.iconNode) && /* @__PURE__ */ React268.createElement("div", { className: cn(DEFAULT_ICON_WRAPPER_CLASS2, classes.iconWrapper) }, /* @__PURE__ */ React268.createElement(
          ListItemIcon,
          {
            icon: item.icon,
            iconAlt: item.iconAlt,
            fallbackIcon: item.iconNode,
            className: cn(DEFAULT_ICON_CLASS30, classes.icon)
          }
        )), /* @__PURE__ */ React268.createElement(Text, { as: "span", className: cn(DEFAULT_LABEL_CLASS13, classes.label) }, item.label)));
      }))
    ))
  );
};

// src/sections/AboutProductCarouselSection.tsx
import React269, { useEffect as useEffect27, useLayoutEffect, useMemo as useMemo4, useRef as useRef20, useState as useState32 } from "react";
var DEFAULT_SECTION_CLASS29 = "w-full [background:var(--about-pc-bg)]";
var DEFAULT_HEADER_CLASS21 = "px-4";
var DEFAULT_CAROUSEL_WRAPPER_CLASS2 = "mt-10";
var DEFAULT_VIEWPORT_CLASS5 = "w-full overflow-x-hidden overflow-y-visible [&::-webkit-scrollbar]:hidden";
var DEFAULT_TRACK_CLASS6 = "flex items-start pt-px pb-px";
var DEFAULT_ITEM_CLASS14 = "shrink-0";
var DEFAULT_CARD_CLASS8 = "flex flex-col gap-4 p-4 border [background:var(--about-pc-card-bg)] [border-color:var(--about-pc-card-border)] rounded-[10px] shadow-[0px_0px_7.5px_rgba(0,0,0,0.15)]";
var DEFAULT_CARD_HEADER_CLASS2 = "flex gap-4 items-center";
var DEFAULT_CARD_IMAGE_WRAPPER_CLASS2 = "relative shrink-0 size-[65px] overflow-hidden rounded bg-[#F0F0F0]";
var DEFAULT_CARD_IMAGE_CLASS2 = "absolute inset-0 w-full h-full object-cover";
var DEFAULT_CARD_NAME_CLASS = "font-bold text-[20px] leading-7 text-(--about-pc-name)";
var DEFAULT_CARD_DIVIDER_CLASS = "[border-color:var(--about-pc-card-divider)]";
var DEFAULT_CARD_DESCRIPTION_CLASS2 = "text-base leading-6 text-(--about-pc-description)";
var DEFAULT_CARD_READ_MORE_CLASS = "text-sm leading-[14px] underline decoration-solid text-(--about-pc-read-more) self-start";
var DEFAULT_DESCRIPTION_RICH_TEXT_CLASS = "contents [&_p]:m-0 [&_p]:inline";
var DEFAULT_CONTROLS_CLASS = "mt-6 flex items-center justify-center gap-4";
var DEFAULT_CONTROL_BUTTON_CLASS = "inline-flex h-10 w-10 items-center justify-center cursor-pointer";
var DEFAULT_CHEVRON_WRAPPER_CLASS = "inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-[8.67px] bg-(--about-pc-btn-bg) text-(--about-pc-btn-chevron)";
function buildVars16(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  return {
    "--about-pc-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-tint, #E7F4FD)",
    "--about-pc-card-bg": (_b = colors == null ? void 0 : colors.cardBackground) != null ? _b : "var(--theme-color-bg-raised, #FFFFFF)",
    "--about-pc-name": (_c = colors == null ? void 0 : colors.nameColor) != null ? _c : "var(--theme-color-accent, #0075A7)",
    "--about-pc-description": (_d = colors == null ? void 0 : colors.descriptionColor) != null ? _d : "var(--theme-color-text-primary, #333333)",
    "--about-pc-read-more": (_e = colors == null ? void 0 : colors.readMoreColor) != null ? _e : "var(--theme-color-text-secondary, #6E6E6E)",
    "--about-pc-btn-bg": (_f = colors == null ? void 0 : colors.buttonBackground) != null ? _f : "var(--theme-color-bg-raised, #FFFFFF)",
    "--about-pc-btn-chevron": (_g = colors == null ? void 0 : colors.buttonChevronColor) != null ? _g : "var(--theme-color-text-secondary, #666666)",
    "--about-pc-heading": (_h = colors == null ? void 0 : colors.headingColor) != null ? _h : "var(--theme-color-heading-primary, #000000)",
    "--about-pc-subheading": (_i = colors == null ? void 0 : colors.subheadingColor) != null ? _i : "var(--theme-color-text-primary, #333333)",
    "--about-pc-divider": (_j = colors == null ? void 0 : colors.dividerColor) != null ? _j : "var(--theme-color-accent-secondary, #0090CD)",
    "--about-pc-card-border": (_k = colors == null ? void 0 : colors.cardBorderColor) != null ? _k : "transparent",
    "--about-pc-card-divider": (_l = colors == null ? void 0 : colors.cardDividerColor) != null ? _l : "var(--theme-color-border-light, #E5E7EB)"
  };
}
function CardDescription({
  description,
  readMoreLabel,
  readLessLabel,
  collapseKey,
  descriptionClassName,
  readMoreClassName
}) {
  const textRef = useRef20(null);
  const [isExpanded, setIsExpanded] = useState32(false);
  const [isOverflowing, setIsOverflowing] = useState32(false);
  useEffect27(() => {
    setIsExpanded(false);
  }, [collapseKey]);
  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setIsOverflowing(el.scrollHeight > el.clientHeight);
  }, [description]);
  if (isExpanded) {
    return /* @__PURE__ */ React269.createElement(React269.Fragment, null, /* @__PURE__ */ React269.createElement(
      RichText,
      {
        html: description,
        className: cn(DEFAULT_CARD_DESCRIPTION_CLASS2, descriptionClassName)
      }
    ), /* @__PURE__ */ React269.createElement(
      "button",
      {
        type: "button",
        className: cn(DEFAULT_CARD_READ_MORE_CLASS, readMoreClassName),
        onClick: () => setIsExpanded(false)
      },
      readLessLabel
    ));
  }
  return /* @__PURE__ */ React269.createElement("div", { className: "flex flex-col h-24" }, /* @__PURE__ */ React269.createElement(
    "div",
    {
      ref: textRef,
      className: cn(
        DEFAULT_CARD_DESCRIPTION_CLASS2,
        isOverflowing ? "line-clamp-3" : "line-clamp-4",
        descriptionClassName
      )
    },
    /* @__PURE__ */ React269.createElement(RichText, { html: description, className: DEFAULT_DESCRIPTION_RICH_TEXT_CLASS })
  ), isOverflowing && /* @__PURE__ */ React269.createElement(
    "button",
    {
      type: "button",
      className: cn("mt-auto", DEFAULT_CARD_READ_MORE_CLASS, readMoreClassName),
      onClick: () => setIsExpanded(true)
    },
    readMoreLabel
  ));
}
var AboutProductCarouselSection = ({
  heading,
  headingHtml,
  headingAs = "h2",
  subheading,
  subheadingPlacement = "before-divider",
  showDivider = true,
  items = [],
  gapPx = 24,
  peekPx = 80,
  minCardWidth = 260,
  maxCardWidth = 300,
  readMoreLabel = "Read more",
  readLessLabel = "Read less",
  carouselLabel = "Product carousel",
  prevLabel = "Previous item",
  nextLabel = "Next item",
  colors,
  sectionSpacing,
  className,
  classes = {}
}) => {
  const scrollerRef = useRef20(null);
  const firstCardRef = useRef20(null);
  const looped = useMemo4(() => {
    if (!items || items.length === 0) return [];
    return [...items, ...items, ...items];
  }, [items]);
  const [step, setStep] = useState32(maxCardWidth + gapPx);
  const [cardW, setCardW] = useState32(maxCardWidth);
  const [vw, setVw] = useState32(typeof window !== "undefined" ? window.innerWidth : 1024);
  const [ready, setReady] = useState32(false);
  const indexRef = useRef20(0);
  const animatingRef = useRef20(false);
  const queuedRef = useRef20(0);
  const [collapseKey, setCollapseKey] = useState32(0);
  const cardWidthCss = `clamp(${minCardWidth}px, calc(100vw - ${peekPx * 2}px), ${maxCardWidth}px)`;
  const canPeek = vw >= cardW + peekPx * 2;
  const sidePad = canPeek ? `max(${peekPx}px, calc(50vw - ${cardW / 2}px))` : `max(0px, calc(50vw - ${cardW / 2}px))`;
  useEffect27(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  useEffect27(() => {
    const el = firstCardRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      const w = Math.round(el.getBoundingClientRect().width);
      setCardW(w);
      setStep(w + gapPx);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [gapPx]);
  const jumpToIndex = (idx) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollLeft = idx * step;
  };
  const smoothToIndex = (idx) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollTo({ left: idx * step, behavior: "smooth" });
  };
  useEffect27(() => {
    const scroller = scrollerRef.current;
    if (!scroller || items.length === 0) return;
    requestAnimationFrame(() => {
      const start = items.length;
      indexRef.current = start;
      jumpToIndex(start);
      setReady(true);
    });
  }, [items.length, step]);
  useEffect27(() => {
    if (!ready) return;
    jumpToIndex(indexRef.current);
  }, [step, ready]);
  const normalizeIfNeeded = () => {
    const n = items.length;
    if (n === 0) return;
    const oneCopy = n;
    const min = oneCopy * 0.5;
    const max = oneCopy * 2.5;
    if (indexRef.current < min) {
      indexRef.current += oneCopy;
      jumpToIndex(indexRef.current);
    } else if (indexRef.current > max) {
      indexRef.current -= oneCopy;
      jumpToIndex(indexRef.current);
    }
  };
  const runMove = (dir) => {
    if (!ready || items.length === 0) return;
    if (animatingRef.current) {
      queuedRef.current += dir;
      return;
    }
    animatingRef.current = true;
    indexRef.current += dir;
    smoothToIndex(indexRef.current);
    window.setTimeout(() => {
      normalizeIfNeeded();
      animatingRef.current = false;
      const q = queuedRef.current;
      if (q !== 0) {
        queuedRef.current = q > 0 ? q - 1 : q + 1;
        runMove(q > 0 ? 1 : -1);
      }
    }, 520);
  };
  const onPrev = () => {
    setCollapseKey((k) => k + 1);
    runMove(-1);
  };
  const onNext = () => {
    setCollapseKey((k) => k + 1);
    runMove(1);
  };
  if (!items.length) return null;
  const hasHeader = !!(heading || headingHtml || subheading || showDivider);
  return /* @__PURE__ */ React269.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS29,
        getSectionSpacingClass(sectionSpacing),
        classes.section,
        className
      ),
      style: buildVars16(colors)
    },
    hasHeader && /* @__PURE__ */ React269.createElement(
      SectionHeader,
      {
        heading,
        headingHtml,
        headingAs,
        subheading,
        subheadingPlacement,
        showDivider,
        className: cn(DEFAULT_HEADER_CLASS21, classes.header),
        classes: {
          heading: cn("text-(--about-pc-heading)", classes.heading),
          subheading: cn("text-(--about-pc-subheading)", classes.subheading),
          divider: cn("bg-(--about-pc-divider)", classes.divider)
        }
      }
    ),
    /* @__PURE__ */ React269.createElement("div", { className: cn(DEFAULT_CAROUSEL_WRAPPER_CLASS2, classes.carouselWrapper) }, /* @__PURE__ */ React269.createElement(
      "div",
      {
        ref: scrollerRef,
        className: cn(DEFAULT_VIEWPORT_CLASS5, classes.viewport),
        style: {
          paddingLeft: sidePad,
          paddingRight: sidePad,
          touchAction: "pan-y",
          overscrollBehaviorX: "none",
          scrollbarWidth: "none"
        },
        "aria-roledescription": "carousel",
        "aria-label": carouselLabel
      },
      /* @__PURE__ */ React269.createElement(
        "ul",
        {
          className: cn(DEFAULT_TRACK_CLASS6, classes.track),
          style: { gap: `${gapPx}px`, width: "max-content" }
        },
        looped.map((item, i) => {
          var _a;
          const isDuplicate = i < items.length || i >= items.length * 2;
          return /* @__PURE__ */ React269.createElement(
            "li",
            {
              ref: i === 0 ? firstCardRef : null,
              key: `${item.name}__${i}`,
              className: cn(DEFAULT_ITEM_CLASS14, classes.item),
              style: { width: cardWidthCss },
              "aria-hidden": isDuplicate
            },
            /* @__PURE__ */ React269.createElement("div", { className: cn(DEFAULT_CARD_CLASS8, classes.card) }, /* @__PURE__ */ React269.createElement("div", { className: cn(DEFAULT_CARD_HEADER_CLASS2, classes.cardHeader) }, /* @__PURE__ */ React269.createElement(
              "div",
              {
                className: cn(DEFAULT_CARD_IMAGE_WRAPPER_CLASS2, classes.cardImageWrapper)
              },
              /* @__PURE__ */ React269.createElement(
                Image,
                {
                  src: item.image,
                  alt: (_a = item.imageAlt) != null ? _a : item.name,
                  className: cn(DEFAULT_CARD_IMAGE_CLASS2, classes.cardImage)
                }
              )
            ), /* @__PURE__ */ React269.createElement("span", { className: cn(DEFAULT_CARD_NAME_CLASS, classes.cardName) }, item.name)), /* @__PURE__ */ React269.createElement(
              Divider,
              {
                variant: "horizontal",
                className: cn(DEFAULT_CARD_DIVIDER_CLASS, classes.cardDivider)
              }
            ), /* @__PURE__ */ React269.createElement(
              CardDescription,
              {
                description: item.description,
                readMoreLabel,
                readLessLabel,
                collapseKey,
                descriptionClassName: classes.cardDescription,
                readMoreClassName: classes.cardReadMore
              }
            ))
          );
        })
      )
    ), /* @__PURE__ */ React269.createElement("div", { className: cn(DEFAULT_CONTROLS_CLASS, classes.controls) }, /* @__PURE__ */ React269.createElement(
      "button",
      {
        type: "button",
        onClick: onPrev,
        "aria-label": prevLabel,
        className: cn(DEFAULT_CONTROL_BUTTON_CLASS, classes.controlButton, classes.prevButton)
      },
      /* @__PURE__ */ React269.createElement("span", { className: DEFAULT_CHEVRON_WRAPPER_CLASS }, /* @__PURE__ */ React269.createElement(IconChevronRight, { className: "rotate-180" }))
    ), /* @__PURE__ */ React269.createElement(
      "button",
      {
        type: "button",
        onClick: onNext,
        "aria-label": nextLabel,
        className: cn(DEFAULT_CONTROL_BUTTON_CLASS, classes.controlButton, classes.nextButton)
      },
      /* @__PURE__ */ React269.createElement("span", { className: DEFAULT_CHEVRON_WRAPPER_CLASS }, /* @__PURE__ */ React269.createElement(IconChevronRight, null))
    )))
  );
};

// src/sections/superfast/SuperfastCardRepeaterSection.tsx
import React270 from "react";
var DEFAULT_SECTION_CLASS30 = "w-full [background:var(--sf-crs-bg,#fafafa)] flex justify-center py-6 md:py-10 px-4";
var DEFAULT_CONTAINER_CLASS57 = "flex flex-col gap-6 md:gap-10 items-center max-w-[1100px] w-full";
var DEFAULT_HEADER_CLASS22 = "flex flex-col gap-2 items-center w-full";
var DEFAULT_HEADING_CLASS12 = "text-[24px] md:text-[32px] lg:text-[48px] font-bold leading-tight [color:var(--sf-crs-heading,#000)] text-center uppercase";
var DEFAULT_DESCRIPTION_CLASS21 = "text-[18px] font-normal leading-[24px] [color:var(--sf-crs-desc,#333)] text-center";
var DEFAULT_GRID_CLASS5 = "grid grid-cols-2 md:grid-cols-3 gap-4 w-full";
var DEFAULT_ORDER_CLASS = "order-[var(--sf-crs-m-order)] md:order-none";
var DEFAULT_CARD_CLASS9 = "[background:var(--sf-crs-card-bg,#fff)] border-2 [border-color:var(--sf-crs-card-border,#f5f5f5)] hover:[border-color:var(--sf-crs-hover-border,#206136)] transition-colors flex flex-col gap-3 items-start overflow-hidden p-2 md:p-4 rounded-lg";
var DEFAULT_IMAGE_FRAME_CLASS = "w-full aspect-square border [border-color:var(--sf-crs-img-border,#e8e8e8)] overflow-hidden rounded-lg";
var DEFAULT_CARD_IMAGE_CLASS3 = "w-full h-full object-cover";
var DEFAULT_CARD_DETAILS_CLASS = "flex-1 flex flex-col items-start w-full";
var DEFAULT_CARD_NAME_CLASS2 = "text-[18px] font-bold leading-[24px] [color:var(--sf-crs-name,#333)]";
var DEFAULT_PRICE_ROW_CLASS = "mt-auto flex flex-wrap gap-2 items-center pt-2";
var DEFAULT_PRICE_CLASS = "text-[16px] font-bold leading-[24px] [color:var(--sf-crs-price,#333)] whitespace-nowrap";
var DEFAULT_SALE_BADGE_CLASS = "[background:var(--sf-crs-badge-bg,#ea5700)] px-2 py-1 text-[12px] font-bold leading-[16px] [color:var(--sf-crs-badge-text,#fff)] whitespace-nowrap";
var DEFAULT_CARD_BUTTON_CLASS = "cursor-pointer w-full font-poppins text-[16px] font-bold leading-[24px] text-center uppercase [text-shadow:0_1px_1px_rgba(0,0,0,0.25)] rounded-[10px] p-2 md:p-4 transition-colors duration-200";
var DEFAULT_BANNER_BASE_CLASS = "col-span-2 md:col-span-1 overflow-hidden rounded-lg relative min-h-[224px]";
var DEFAULT_BANNER_IMAGE_CLASS = "absolute inset-0 w-full h-full object-cover";
function orderStyle(order) {
  return { "--sf-crs-m-order": order };
}
function computeMobileOrder(items) {
  const productIdx = [];
  const bannerIdx = [];
  items.forEach((item, index) => (item.type === "banner" ? bannerIdx : productIdx).push(index));
  const sequence = [];
  let pi = 0;
  let bi = 0;
  while (pi < productIdx.length) {
    const pair = productIdx.slice(pi, pi + 2);
    sequence.push(...pair);
    pi += pair.length;
    if (pair.length === 2 && bi < bannerIdx.length) {
      sequence.push(bannerIdx[bi]);
      bi += 1;
    }
  }
  while (bi < bannerIdx.length) {
    sequence.push(bannerIdx[bi]);
    bi += 1;
  }
  const order = [];
  sequence.forEach((authoredIndex, position) => {
    order[authoredIndex] = position;
  });
  return order;
}
var ProductCard2 = ({
  image,
  imageAlt = "",
  name,
  price,
  saleLabel,
  ctaUrl,
  ctaLabel,
  order,
  classes = {}
}) => /* @__PURE__ */ React270.createElement(
  "div",
  {
    className: cn(DEFAULT_CARD_CLASS9, "relative", DEFAULT_ORDER_CLASS, classes.card),
    style: orderStyle(order)
  },
  ctaUrl && /* @__PURE__ */ React270.createElement("a", { href: ctaUrl, "aria-label": name || void 0, className: "absolute inset-0 z-10" }),
  /* @__PURE__ */ React270.createElement("div", { className: cn(DEFAULT_IMAGE_FRAME_CLASS, classes.cardImageFrame) }, /* @__PURE__ */ React270.createElement(
    Image,
    {
      src: image,
      alt: imageAlt,
      className: cn(DEFAULT_CARD_IMAGE_CLASS3, classes.cardImage)
    }
  )),
  /* @__PURE__ */ React270.createElement("div", { className: DEFAULT_CARD_DETAILS_CLASS }, name && /* @__PURE__ */ React270.createElement(Text, { as: "p", className: cn(DEFAULT_CARD_NAME_CLASS2, classes.cardName) }, name), /* @__PURE__ */ React270.createElement("div", { className: cn(DEFAULT_PRICE_ROW_CLASS, classes.cardPriceRow) }, price && /* @__PURE__ */ React270.createElement(Text, { as: "span", className: cn(DEFAULT_PRICE_CLASS, classes.cardPrice) }, price), saleLabel && /* @__PURE__ */ React270.createElement("span", { className: cn(DEFAULT_SALE_BADGE_CLASS, classes.cardSaleBadge) }, saleLabel))),
  ctaUrl && ctaLabel && /* @__PURE__ */ React270.createElement(
    CTAButton,
    {
      buttonText: ctaLabel,
      href: ctaUrl,
      classes: { button: cn(DEFAULT_CARD_BUTTON_CLASS, "relative z-20", classes.cardButton) }
    }
  )
);
var BannerCard = ({
  image,
  imageMobile,
  imageAlt = "",
  href,
  order,
  classes = {}
}) => /* @__PURE__ */ React270.createElement(
  "a",
  {
    href: href || void 0,
    className: cn(
      DEFAULT_BANNER_BASE_CLASS,
      DEFAULT_ORDER_CLASS,
      href && "cursor-pointer",
      classes.banner
    ),
    style: orderStyle(order)
  },
  imageMobile && /* @__PURE__ */ React270.createElement(
    Image,
    {
      src: imageMobile,
      alt: imageAlt,
      className: cn(DEFAULT_BANNER_IMAGE_CLASS, "md:hidden", classes.bannerImage)
    }
  ),
  /* @__PURE__ */ React270.createElement(
    Image,
    {
      src: image,
      alt: imageAlt,
      className: cn(
        DEFAULT_BANNER_IMAGE_CLASS,
        imageMobile && "hidden md:block",
        classes.bannerImage
      )
    }
  )
);
var SuperfastCardRepeaterSection = ({
  heading,
  showDescription = true,
  description,
  items,
  ctaLabel,
  ctaBackgroundColor,
  ctaBackgroundGradient,
  ctaBackgroundHoverColor,
  ctaBackgroundHoverGradient,
  ctaTextColor,
  ctaBorderColor,
  colors,
  className,
  classes = {}
}) => {
  if (!(items == null ? void 0 : items.length)) return null;
  const mobileOrder = computeMobileOrder(items);
  const colorVars = {
    // CTA button styling shared with the CTAButton molecule (same vars as ContentImage).
    "--cta-bg": ctaBackgroundGradient || ctaBackgroundColor || "#000000",
    "--button-hover-color": ctaBackgroundHoverGradient || ctaBackgroundHoverColor || (ctaBackgroundGradient ? lightenGradient(ctaBackgroundGradient, 0.1) : lightenHex(ctaBackgroundColor != null ? ctaBackgroundColor : "#000000", 0.2)),
    "--button-text-color": ctaTextColor != null ? ctaTextColor : "#ffffff",
    "--button-border-color": ctaBorderColor != null ? ctaBorderColor : "transparent",
    // Card/section styling (defaults provided inline in the class strings).
    ...(colors == null ? void 0 : colors.background) && { "--sf-crs-bg": colors.background },
    ...(colors == null ? void 0 : colors.headingColor) && { "--sf-crs-heading": colors.headingColor },
    ...(colors == null ? void 0 : colors.descriptionColor) && { "--sf-crs-desc": colors.descriptionColor },
    ...(colors == null ? void 0 : colors.cardBackground) && { "--sf-crs-card-bg": colors.cardBackground },
    ...(colors == null ? void 0 : colors.cardBorder) && { "--sf-crs-card-border": colors.cardBorder },
    ...(colors == null ? void 0 : colors.cardImageBorder) && { "--sf-crs-img-border": colors.cardImageBorder },
    ...(colors == null ? void 0 : colors.cardNameColor) && { "--sf-crs-name": colors.cardNameColor },
    ...(colors == null ? void 0 : colors.cardPriceColor) && { "--sf-crs-price": colors.cardPriceColor },
    ...(colors == null ? void 0 : colors.saleBadgeBackground) && { "--sf-crs-badge-bg": colors.saleBadgeBackground },
    ...(colors == null ? void 0 : colors.saleBadgeText) && { "--sf-crs-badge-text": colors.saleBadgeText },
    ...(colors == null ? void 0 : colors.cardHoverBorder) && { "--sf-crs-hover-border": colors.cardHoverBorder }
  };
  const cardClasses = {
    card: classes.card,
    cardImageFrame: classes.cardImageFrame,
    cardImage: classes.cardImage,
    cardName: classes.cardName,
    cardPriceRow: classes.cardPriceRow,
    cardPrice: classes.cardPrice,
    cardSaleBadge: classes.cardSaleBadge,
    cardButton: classes.cardButton
  };
  return /* @__PURE__ */ React270.createElement("section", { className: cn(DEFAULT_SECTION_CLASS30, classes.section, className), style: colorVars }, /* @__PURE__ */ React270.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS57, classes.container) }, /* @__PURE__ */ React270.createElement("div", { className: cn(DEFAULT_HEADER_CLASS22, classes.header) }, /* @__PURE__ */ React270.createElement(Text, { as: "h2", className: cn(DEFAULT_HEADING_CLASS12, classes.heading) }, heading), showDescription && description && /* @__PURE__ */ React270.createElement(Text, { as: "p", className: cn(DEFAULT_DESCRIPTION_CLASS21, classes.description) }, description)), /* @__PURE__ */ React270.createElement("div", { className: cn(DEFAULT_GRID_CLASS5, classes.grid) }, items.map(
    (item, index) => item.type === "banner" ? /* @__PURE__ */ React270.createElement(
      BannerCard,
      {
        key: index,
        ...item,
        order: mobileOrder[index],
        classes: { banner: classes.banner, bannerImage: classes.bannerImage }
      }
    ) : /* @__PURE__ */ React270.createElement(
      ProductCard2,
      {
        key: index,
        ...item,
        ctaLabel,
        order: mobileOrder[index],
        classes: cardClasses
      }
    )
  ))));
};

// src/sections/superfast/SuperfastBenefitsSection.tsx
import React271 from "react";
var DEFAULT_SECTION_CLASS31 = "w-full [background:var(--sf-ben-bg,#fafafa)] flex justify-center py-6 md:py-10 px-4";
var DEFAULT_CONTAINER_CLASS58 = "flex flex-col gap-6 md:gap-10 items-center max-w-[1100px] w-full";
var DEFAULT_BENEFITS_CLASS = "grid grid-cols-2 md:flex md:flex-row gap-4 w-full";
var DEFAULT_BENEFIT_ITEM_CLASS2 = "[background:var(--sf-ben-card-bg,#fff)] border [border-color:var(--sf-ben-card-border,#f5f5f5)] flex flex-1 flex-col gap-2 items-center text-center px-2 py-4 md:px-10 md:py-6 rounded-[10px]";
var DEFAULT_BENEFIT_ICON_WRAPPER_CLASS = "[background:var(--sf-ben-icon-bg,#fafafa)] rounded-full w-16 h-16 flex items-center justify-center overflow-hidden shrink-0";
var DEFAULT_BENEFIT_ICON_CLASS2 = "w-8 h-8 object-contain";
var DEFAULT_BENEFIT_LABEL_CLASS = "text-[16px] font-medium leading-[24px] [color:var(--sf-ben-label,#333)] text-center";
function buildVars17(colors) {
  return {
    ...(colors == null ? void 0 : colors.background) && { "--sf-ben-bg": colors.background },
    ...(colors == null ? void 0 : colors.cardBackground) && { "--sf-ben-card-bg": colors.cardBackground },
    ...(colors == null ? void 0 : colors.cardBorder) && { "--sf-ben-card-border": colors.cardBorder },
    ...(colors == null ? void 0 : colors.iconBackground) && { "--sf-ben-icon-bg": colors.iconBackground },
    ...(colors == null ? void 0 : colors.labelColor) && { "--sf-ben-label": colors.labelColor }
  };
}
var BenefitItemCard = ({
  icon,
  iconAlt = "",
  label,
  classes = {}
}) => /* @__PURE__ */ React271.createElement("div", { className: cn(DEFAULT_BENEFIT_ITEM_CLASS2, classes.benefitItem) }, /* @__PURE__ */ React271.createElement("div", { className: cn(DEFAULT_BENEFIT_ICON_WRAPPER_CLASS, classes.benefitIconWrapper) }, /* @__PURE__ */ React271.createElement(
  Image,
  {
    src: icon,
    alt: iconAlt,
    className: cn(DEFAULT_BENEFIT_ICON_CLASS2, classes.benefitIcon)
  }
)), label && /* @__PURE__ */ React271.createElement(Text, { as: "p", className: cn(DEFAULT_BENEFIT_LABEL_CLASS, classes.benefitLabel) }, label));
var SuperfastBenefitsSection = ({
  benefits,
  removeTopPadding = false,
  colors,
  className,
  classes = {}
}) => {
  if (!(benefits == null ? void 0 : benefits.length)) return null;
  return /* @__PURE__ */ React271.createElement(
    "section",
    {
      className: cn(
        DEFAULT_SECTION_CLASS31,
        removeTopPadding && "pt-0 md:pt-0",
        classes.section,
        className
      ),
      style: buildVars17(colors)
    },
    /* @__PURE__ */ React271.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS58, classes.container) }, /* @__PURE__ */ React271.createElement("div", { className: cn(DEFAULT_BENEFITS_CLASS, classes.benefits) }, benefits.map((benefit, index) => /* @__PURE__ */ React271.createElement(
      BenefitItemCard,
      {
        key: benefit.label + index,
        ...benefit,
        classes: {
          benefitItem: classes.benefitItem,
          benefitIconWrapper: classes.benefitIconWrapper,
          benefitIcon: classes.benefitIcon,
          benefitLabel: classes.benefitLabel
        }
      }
    ))))
  );
};

// src/sections/superfast/SuperfastStaticBanner.tsx
import React272 from "react";
var DEFAULT_SECTION_CLASS32 = "w-full";
var DEFAULT_RIBBON_ROOT_CLASS = "font-bold text-[14px] leading-[20px]";
var SuperfastStaticBanner = ({
  text,
  className,
  classes = {}
}) => {
  if (!text) return null;
  return /* @__PURE__ */ React272.createElement("section", { className: cn(DEFAULT_SECTION_CLASS32, classes.section, className) }, /* @__PURE__ */ React272.createElement(
    Ribbon,
    {
      message: text,
      classes: {
        root: cn(DEFAULT_RIBBON_ROOT_CLASS, classes.text)
      }
    }
  ));
};

// src/sections/top5/Top5ProductCard.tsx
import React273 from "react";
var DEFAULT_CARD_CLASS10 = "relative flex flex-col gap-6 rounded-2xl border px-4 py-8 md:gap-8 md:p-8 bg-(--top5-card-bg) border-(--top5-card-border) [box-shadow:0_2px_12px_rgba(0,0,0,0.04)]";
var DEFAULT_FEATURED_BORDER_CLASS = "border-8";
var DEFAULT_BADGE_CLASS = "pointer-events-none absolute -top-5 right-3 z-10 h-auto w-[88px] md:-top-8 md:right-6 md:w-[150px] lg:w-[180px]";
var DEFAULT_DIVIDER_CLASS17 = "block h-px w-full shrink-0 bg-(--top5-divider)";
var DEFAULT_HEADER_CLASS23 = "flex flex-col gap-1";
var DEFAULT_TITLE_CLASS21 = "text-[24px] leading-[32px] font-bold text-(--top5-title) md:text-[32px] md:leading-[40px]";
var DEFAULT_BRAND_CLASS2 = "w-fit text-[18px] leading-[24px] font-bold underline text-(--top5-brand) md:text-[20px]";
var DEFAULT_RATING_ROW_CLASS2 = "flex flex-col items-start gap-2 pt-2";
var DEFAULT_REVIEWS_CLASS = "flex items-center gap-1 text-[14px] leading-[16px] text-(--top5-text)";
var DEFAULT_REVIEWS_RATING_CLASS = "font-bold";
var DEFAULT_PRODUCT_ROW_CLASS = "flex flex-col gap-4 md:flex-row md:items-center md:gap-6";
var DEFAULT_IMAGE_WRAPPER_CLASS12 = "flex flex-1 items-center justify-center";
var DEFAULT_IMAGE_CLASS22 = "w-[200px] md:w-[264px] aspect-square object-contain";
var DEFAULT_ROW_DIVIDER_CLASS2 = "block h-px w-full shrink-0 self-stretch bg-(--top5-divider) md:h-auto md:w-px";
var DEFAULT_RATING_COLUMN_CLASS = "flex flex-1 flex-col items-center justify-center gap-3 text-center";
var DEFAULT_GRADE_CLASS = "text-[48px] leading-[32px] font-bold text-(--top5-title) md:text-[100px] md:leading-[80px]";
var DEFAULT_GRADE_LABEL_CLASS = "text-[18px] leading-[24px] font-semibold text-(--top5-text) md:text-[40px] md:leading-none";
var DEFAULT_RATING_CTA_WRAPPER_CLASS = "flex w-full flex-col items-center gap-3 pt-1";
var DEFAULT_HIGHLIGHT_CLASS = "text-[16px] leading-[23px] font-semibold italic text-(--top5-highlight)";
var DEFAULT_PROSCONS_CLASS = "flex flex-col gap-6 md:flex-row";
var DEFAULT_PROSCONS_COLUMN_CLASS = "flex flex-1 flex-col gap-6";
var DEFAULT_PROSCONS_TITLE_CLASS = "text-[24px] leading-[32px] font-bold md:text-[32px] md:leading-[40px]";
var DEFAULT_PROSCONS_LIST_CLASS = "flex flex-col gap-2";
var DEFAULT_LIST_ITEM_CLASS2 = "flex items-center gap-2";
var DEFAULT_LIST_ITEM_TEXT_CLASS = "text-[18px] leading-[28px] text-(--top5-text)";
var DEFAULT_LIST_ICON_CLASS2 = "shrink-0";
var DEFAULT_BOTTOM_LINE_CLASS = "flex flex-col gap-6 md:flex-row";
var DEFAULT_BOTTOM_IMAGES_CLASS = "flex flex-col gap-4 md:w-[300px] md:shrink-0";
var DEFAULT_BOTTOM_IMAGE_CLASS = "w-full aspect-square object-cover";
var DEFAULT_BOTTOM_CONTENT_CLASS = "flex flex-1 flex-col gap-6";
var DEFAULT_BOTTOM_TITLE_CLASS = "text-[24px] leading-[32px] font-bold text-(--top5-title) md:text-[32px] md:leading-[40px]";
var DEFAULT_BOTTOM_TEXT_CLASS = "text-[18px] leading-[28px] text-(--top5-text) [&_p]:mb-4 [&_p:last-child]:mb-0 [&_b]:font-bold [&_strong]:font-bold [&_a]:font-bold [&_a]:underline [&_a]:[text-underline-position:from-font] [&_a]:text-(--top5-link)";
var DEFAULT_CTA_WRAPPER_CLASS6 = "flex w-full justify-center";
var DEFAULT_CTA_CLASS2 = "w-full rounded-[100px] border-2 text-[20px] leading-[24px] [box-shadow:0_4px_2px_rgba(0,0,0,0.1)]";
var DEFAULT_TOP5_PRO_ICON = /* @__PURE__ */ React273.createElement(
  IconCircleCheckmark,
  {
    className: "size-6 text-(--top5-pros) md:size-7",
    classes: { check: "text-(--top5-card-bg)" }
  }
);
var DEFAULT_TOP5_CON_ICON = /* @__PURE__ */ React273.createElement(
  IconCircleXmark,
  {
    className: "size-6 text-(--top5-cons) md:size-7",
    classes: { x: "text-(--top5-card-bg)" }
  }
);
var DEFAULT_REVIEWS_ICON = /* @__PURE__ */ React273.createElement(IconStarFull, { className: "size-4 shrink-0" });
function buildColorVars(colors, cta, featured) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const ctaBackground = cta.backgroundGradient || cta.background;
  const ctaHover = cta.hoverGradient || cta.hoverColor || (cta.backgroundGradient ? lightenGradient(cta.backgroundGradient, 0.1) : cta.background ? lightenHex(cta.background, 0.2) : void 0);
  return {
    "--top5-card-bg": (_a = colors == null ? void 0 : colors.cardBackground) != null ? _a : "var(--theme-color-bg-raised, #FFFFFF)",
    "--top5-card-border": (_b = colors == null ? void 0 : colors.cardBorder) != null ? _b : featured ? "var(--theme-color-accent, #3486CA)" : "var(--theme-color-border-light, #E5E7EB)",
    "--top5-title": (_c = colors == null ? void 0 : colors.titleColor) != null ? _c : "var(--theme-color-heading-primary, #111827)",
    "--top5-brand": (_d = colors == null ? void 0 : colors.brandColor) != null ? _d : "var(--theme-color-accent, #0029F8)",
    "--top5-text": (_e = colors == null ? void 0 : colors.textColor) != null ? _e : "var(--theme-color-text-primary, #1A1A1A)",
    "--top5-pros": (_f = colors == null ? void 0 : colors.prosColor) != null ? _f : "var(--theme-color-success, #1BC7B1)",
    "--top5-cons": (_g = colors == null ? void 0 : colors.consColor) != null ? _g : "var(--theme-color-error, #FF4A4A)",
    "--top5-link": (_h = colors == null ? void 0 : colors.linkColor) != null ? _h : "var(--theme-color-accent, #5F8BF3)",
    "--top5-divider": (_i = colors == null ? void 0 : colors.dividerColor) != null ? _i : "var(--theme-color-border-light, #D6E3E6)",
    "--top5-highlight": (_j = colors == null ? void 0 : colors.highlightColor) != null ? _j : "var(--theme-color-text-primary, #171D0C)",
    // CTA vars consumed by the shared CTAButton molecule (gradient-capable).
    "--cta-bg": ctaBackground != null ? ctaBackground : "var(--theme-color-button-primary, #FF9900)",
    "--button-hover-color": ctaHover != null ? ctaHover : "var(--theme-color-button-hover, #E68A00)",
    "--button-text-color": (_k = cta.text) != null ? _k : "var(--theme-color-button-text, #FFFFFF)",
    "--button-border-color": (_l = cta.border) != null ? _l : "var(--theme-color-bg-raised, #FFFFFF)"
  };
}
var ProsConsColumn = ({
  title,
  titleColorClass,
  items,
  icon,
  className,
  classes = {},
  variant
}) => /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_PROSCONS_COLUMN_CLASS, className) }, title && /* @__PURE__ */ React273.createElement(
  Text,
  {
    as: "h4",
    className: cn(
      DEFAULT_PROSCONS_TITLE_CLASS,
      titleColorClass,
      variant === "pros" ? classes.prosTitle : classes.consTitle
    )
  },
  title
), /* @__PURE__ */ React273.createElement("ul", { className: DEFAULT_PROSCONS_LIST_CLASS }, items.map((item, index) => /* @__PURE__ */ React273.createElement("li", { key: `${item}-${index}`, className: cn(DEFAULT_LIST_ITEM_CLASS2, classes.listItem) }, /* @__PURE__ */ React273.createElement("span", { className: DEFAULT_LIST_ICON_CLASS2, "aria-hidden": "true" }, icon), /* @__PURE__ */ React273.createElement(Text, { as: "span", className: DEFAULT_LIST_ITEM_TEXT_CLASS }, item)))));
var BottomImage = ({
  image,
  imageAlt = "",
  className
}) => image ? /* @__PURE__ */ React273.createElement(Image, { src: image, alt: imageAlt, className }) : null;
var Top5ProductCard = ({
  rank,
  name,
  brand,
  brandHref,
  rating,
  reviewsRating,
  reviewsLabel,
  reviewsIcon = DEFAULT_REVIEWS_ICON,
  badgeImage,
  badgeImageAlt = "",
  image,
  imageAlt = "",
  grade,
  gradeLabel = "RATING",
  pros = [],
  prosTitle = "PROS",
  cons = [],
  consTitle = "CONS",
  proIcon = DEFAULT_TOP5_PRO_ICON,
  conIcon = DEFAULT_TOP5_CON_ICON,
  bottomTitle = "THE BOTTOM LINE",
  bottomHtml,
  bottomImages = [],
  cta = true,
  ctaLabel,
  ctaHref,
  showRatingCta = false,
  highlightLabel,
  ctaBackgroundColor,
  ctaBackgroundGradient,
  ctaBackgroundHoverColor,
  ctaBackgroundHoverGradient,
  ctaTextColor,
  ctaBorderColor,
  showCtaDivider = true,
  featured = false,
  colors,
  className,
  classes = {}
}) => {
  const colorVars = buildColorVars(
    colors,
    {
      background: ctaBackgroundColor,
      backgroundGradient: ctaBackgroundGradient,
      hoverColor: ctaBackgroundHoverColor,
      hoverGradient: ctaBackgroundHoverGradient,
      text: ctaTextColor,
      border: ctaBorderColor
    },
    featured
  );
  const hasReviews = typeof rating === "number" || Boolean(reviewsRating) || Boolean(reviewsLabel);
  const hasRatingColumn = Boolean(grade) || showRatingCta && cta && Boolean(ctaLabel);
  const hasProductRow = Boolean(image) || hasRatingColumn;
  const hasProsCons = pros.length > 0 || cons.length > 0;
  const hasBottomLine = Boolean(bottomHtml) || bottomImages.length > 0;
  const hasFooterCta = cta && Boolean(ctaLabel);
  const blocks = [];
  blocks.push(
    /* @__PURE__ */ React273.createElement(
      "header",
      {
        key: "header",
        className: cn(DEFAULT_HEADER_CLASS23, badgeImage && "pr-20 md:pr-44", classes.header)
      },
      /* @__PURE__ */ React273.createElement(Text, { as: "h3", className: cn(DEFAULT_TITLE_CLASS21, classes.title) }, typeof rank === "number" ? `${rank}: ${name}` : name),
      brand && (brandHref ? /* @__PURE__ */ React273.createElement("a", { href: brandHref, className: cn(DEFAULT_BRAND_CLASS2, classes.brand) }, brand) : /* @__PURE__ */ React273.createElement(Text, { as: "span", className: cn(DEFAULT_BRAND_CLASS2, classes.brand) }, brand)),
      hasReviews && /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_RATING_ROW_CLASS2, classes.rating) }, typeof rating === "number" && /* @__PURE__ */ React273.createElement(StarRating2, { rating: rating * 2 }), (reviewsRating || reviewsLabel) && /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_REVIEWS_CLASS, classes.reviews) }, reviewsIcon, reviewsRating && /* @__PURE__ */ React273.createElement(Text, { as: "span", className: cn(DEFAULT_REVIEWS_RATING_CLASS, classes.reviewsRating) }, reviewsRating), reviewsLabel && /* @__PURE__ */ React273.createElement(Text, { as: "span" }, reviewsLabel)))
    )
  );
  if (hasProductRow) {
    blocks.push(
      /* @__PURE__ */ React273.createElement("div", { key: "product-row", className: cn(DEFAULT_PRODUCT_ROW_CLASS, classes.productRow) }, image && /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS12, classes.imageWrapper) }, /* @__PURE__ */ React273.createElement(Image, { src: image, alt: imageAlt, className: cn(DEFAULT_IMAGE_CLASS22, classes.image) })), image && hasRatingColumn && /* @__PURE__ */ React273.createElement("span", { className: DEFAULT_ROW_DIVIDER_CLASS2, "aria-hidden": "true" }), hasRatingColumn && /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_RATING_COLUMN_CLASS, classes.ratingColumn) }, grade && /* @__PURE__ */ React273.createElement(Text, { as: "span", className: cn(DEFAULT_GRADE_CLASS, classes.grade) }, grade), grade && gradeLabel && /* @__PURE__ */ React273.createElement(Text, { as: "span", className: cn(DEFAULT_GRADE_LABEL_CLASS, classes.gradeLabel) }, gradeLabel), showRatingCta && cta && ctaLabel && /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_RATING_CTA_WRAPPER_CLASS, classes.ratingCtaWrapper) }, /* @__PURE__ */ React273.createElement(
        CTAButton,
        {
          buttonText: ctaLabel,
          href: ctaHref,
          classes: { button: cn(DEFAULT_CTA_CLASS2, "max-w-[300px]", classes.ctaButton) }
        }
      ), highlightLabel && /* @__PURE__ */ React273.createElement(Text, { as: "span", className: cn(DEFAULT_HIGHLIGHT_CLASS, classes.highlight) }, highlightLabel))))
    );
  }
  if (hasProsCons) {
    blocks.push(
      /* @__PURE__ */ React273.createElement("div", { key: "pros-cons", className: cn(DEFAULT_PROSCONS_CLASS, classes.prosCons) }, pros.length > 0 && /* @__PURE__ */ React273.createElement(
        ProsConsColumn,
        {
          variant: "pros",
          title: prosTitle,
          titleColorClass: "text-(--top5-pros)",
          items: pros,
          icon: proIcon,
          className: classes.pros,
          classes
        }
      ), pros.length > 0 && cons.length > 0 && /* @__PURE__ */ React273.createElement(
        "span",
        {
          className: cn(DEFAULT_DIVIDER_CLASS17, "md:hidden", classes.divider),
          "aria-hidden": "true"
        }
      ), cons.length > 0 && /* @__PURE__ */ React273.createElement(
        ProsConsColumn,
        {
          variant: "cons",
          title: consTitle,
          titleColorClass: "text-(--top5-cons)",
          items: cons,
          icon: conIcon,
          className: classes.cons,
          classes
        }
      ))
    );
  }
  if (hasBottomLine) {
    blocks.push(
      /* @__PURE__ */ React273.createElement("div", { key: "bottom-line", className: cn(DEFAULT_BOTTOM_LINE_CLASS, classes.bottomLine) }, bottomImages.length > 0 && /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_BOTTOM_IMAGES_CLASS, classes.bottomImages) }, bottomImages.map((img, index) => /* @__PURE__ */ React273.createElement(
        BottomImage,
        {
          key: index,
          ...img,
          className: cn(DEFAULT_BOTTOM_IMAGE_CLASS, classes.bottomImage)
        }
      ))), /* @__PURE__ */ React273.createElement("div", { className: DEFAULT_BOTTOM_CONTENT_CLASS }, bottomTitle && /* @__PURE__ */ React273.createElement(Text, { as: "h4", className: cn(DEFAULT_BOTTOM_TITLE_CLASS, classes.bottomTitle) }, bottomTitle), bottomHtml && /* @__PURE__ */ React273.createElement(
        RichText,
        {
          html: bottomHtml,
          className: cn(DEFAULT_BOTTOM_TEXT_CLASS, classes.bottomText)
        }
      )))
    );
  }
  return /* @__PURE__ */ React273.createElement(
    "article",
    {
      className: cn(
        DEFAULT_CARD_CLASS10,
        featured && DEFAULT_FEATURED_BORDER_CLASS,
        classes.card,
        className
      ),
      style: colorVars
    },
    badgeImage && /* @__PURE__ */ React273.createElement(
      Image,
      {
        src: badgeImage,
        alt: badgeImageAlt,
        className: cn(DEFAULT_BADGE_CLASS, classes.badge)
      }
    ),
    blocks.map((block, index) => /* @__PURE__ */ React273.createElement(React273.Fragment, { key: index }, index > 0 && /* @__PURE__ */ React273.createElement("span", { className: cn(DEFAULT_DIVIDER_CLASS17, classes.divider), "aria-hidden": "true" }), block)),
    hasFooterCta && /* @__PURE__ */ React273.createElement(React273.Fragment, null, showCtaDivider && blocks.length > 0 && /* @__PURE__ */ React273.createElement(
      "span",
      {
        className: cn(DEFAULT_DIVIDER_CLASS17, classes.divider, classes.ctaDivider),
        "aria-hidden": "true"
      }
    ), /* @__PURE__ */ React273.createElement("div", { className: cn(DEFAULT_CTA_WRAPPER_CLASS6, classes.ctaWrapper) }, /* @__PURE__ */ React273.createElement(
      CTAButton,
      {
        buttonText: ctaLabel,
        href: ctaHref,
        classes: { button: cn(DEFAULT_CTA_CLASS2, "max-w-[440px]", classes.ctaButton) }
      }
    )))
  );
};

// src/sections/top5/Top5ListSection.tsx
import React274, { useId, useState as useState33 } from "react";
var DEFAULT_SECTION_CLASS33 = "w-full px-4 py-8 md:py-12 bg-(--top5-section-bg)";
var DEFAULT_CONTAINER_CLASS59 = "mx-auto flex w-full max-w-[1000px] flex-col gap-10 md:gap-14";
var DEFAULT_HEADER_CLASS24 = "flex flex-col items-center gap-2 text-center";
var DEFAULT_HEADING_CLASS13 = "text-[28px] leading-tight font-bold text-(--top5-heading) md:text-[40px]";
var DEFAULT_DESCRIPTION_CLASS22 = "text-[16px] leading-[24px] text-(--top5-description) md:text-[18px]";
var DEFAULT_LIST_CLASS10 = "flex list-none flex-col gap-12 md:gap-16";
var DEFAULT_TOGGLE_CLASS = "relative flex flex-col items-center";
var DEFAULT_TOGGLE_LINE_CLASS = "pointer-events-none absolute inset-x-0 top-6 h-px bg-(--top5-divider)";
var DEFAULT_TOGGLE_BUTTON_CLASS = "relative flex cursor-pointer flex-col items-center gap-2";
var DEFAULT_TOGGLE_ICON_CLASS = "flex size-12 items-center justify-center rounded-full border bg-(--top5-section-bg) border-(--top5-divider) text-(--top5-heading)";
var DEFAULT_TOGGLE_LABEL_CLASS = "text-[14px] font-semibold text-(--top5-heading)";
function buildSectionVars(colors) {
  var _a, _b, _c, _d;
  return {
    "--top5-section-bg": (_a = colors == null ? void 0 : colors.sectionBackground) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--top5-heading": (_b = colors == null ? void 0 : colors.titleColor) != null ? _b : "var(--theme-color-heading-primary, #111827)",
    "--top5-description": (_c = colors == null ? void 0 : colors.textColor) != null ? _c : "var(--theme-color-text-secondary, #6B7280)",
    "--top5-divider": (_d = colors == null ? void 0 : colors.dividerColor) != null ? _d : "var(--theme-color-border-light, #D6E3E6)"
  };
}
var Top5ListSection = ({
  heading,
  description,
  products,
  visibleCount = 3,
  showMoreLabel = "See more of the list",
  showLessLabel = "See less of the list",
  proIcon = DEFAULT_TOP5_PRO_ICON,
  conIcon = DEFAULT_TOP5_CON_ICON,
  colors,
  className,
  classes = {}
}) => {
  const [expanded, setExpanded] = useState33(false);
  const listId = useId();
  if (!(products == null ? void 0 : products.length)) return null;
  const { sectionBackground: _sectionBackground, ...cardColors } = colors != null ? colors : {};
  const hasMore = visibleCount > 0 && products.length > visibleCount;
  const visibleProducts = hasMore && !expanded ? products.slice(0, visibleCount) : products;
  return /* @__PURE__ */ React274.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS33, classes.section, className),
      style: buildSectionVars(colors)
    },
    /* @__PURE__ */ React274.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS59, classes.container) }, (heading || description) && /* @__PURE__ */ React274.createElement("div", { className: cn(DEFAULT_HEADER_CLASS24, classes.header) }, heading && /* @__PURE__ */ React274.createElement(Text, { as: "h2", className: cn(DEFAULT_HEADING_CLASS13, classes.heading) }, heading), description && /* @__PURE__ */ React274.createElement(Text, { as: "p", className: cn(DEFAULT_DESCRIPTION_CLASS22, classes.description) }, description)), /* @__PURE__ */ React274.createElement("ol", { id: listId, className: cn(DEFAULT_LIST_CLASS10, classes.list) }, visibleProducts.map((product, index) => {
      var _a;
      return /* @__PURE__ */ React274.createElement("li", { key: index }, /* @__PURE__ */ React274.createElement(
        Top5ProductCard,
        {
          ...product,
          rank: (_a = product.rank) != null ? _a : index + 1,
          proIcon,
          conIcon,
          colors: { ...cardColors, ...product.colors },
          className: cn(classes.card, product.className)
        }
      ));
    })), hasMore && /* @__PURE__ */ React274.createElement("div", { className: cn(DEFAULT_TOGGLE_CLASS, classes.toggle) }, /* @__PURE__ */ React274.createElement(
      "span",
      {
        "aria-hidden": "true",
        className: cn(DEFAULT_TOGGLE_LINE_CLASS, classes.toggleLine)
      }
    ), /* @__PURE__ */ React274.createElement(
      "button",
      {
        type: "button",
        onClick: () => setExpanded((value) => !value),
        "aria-expanded": expanded,
        "aria-controls": listId,
        className: cn(DEFAULT_TOGGLE_BUTTON_CLASS, classes.toggleButton)
      },
      /* @__PURE__ */ React274.createElement("span", { className: cn(DEFAULT_TOGGLE_ICON_CLASS, classes.toggleIcon) }, /* @__PURE__ */ React274.createElement(IconChevron, { isOpen: expanded, className: "size-5" })),
      /* @__PURE__ */ React274.createElement(Text, { as: "span", className: cn(DEFAULT_TOGGLE_LABEL_CLASS, classes.toggleLabel) }, expanded ? showLessLabel : showMoreLabel)
    )))
  );
};

// src/sections/top5/Top5HeaderSection.tsx
import React275 from "react";
var DEFAULT_SECTION_CLASS34 = "w-full [background:var(--top5-header-bg)]";
var DEFAULT_CONTAINER_CLASS60 = "mx-auto flex w-full max-w-[1000px] items-center justify-between gap-6 px-4 py-4";
var DEFAULT_LOGO_LINK_CLASS = "flex shrink-0 items-center";
var DEFAULT_LOGO_CLASS7 = "block h-5 w-auto object-contain md:h-6";
var DEFAULT_DISCLOSURE_CLASS = "flex shrink-0 items-center gap-2 text-(--top5-header-disclosure) no-underline";
var DEFAULT_DISCLOSURE_ICON_CLASS = "size-3 shrink-0 md:size-4";
var DEFAULT_DISCLOSURE_TEXT_CLASS = "text-[12px] leading-4 whitespace-nowrap md:text-[14px] md:leading-5";
function buildVars18(colors) {
  var _a, _b;
  return {
    "--top5-header-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-raised, #FFFFFF)",
    "--top5-header-disclosure": (_b = colors == null ? void 0 : colors.disclosureColor) != null ? _b : "var(--theme-color-text-light, #AFC2C6)"
  };
}
var Top5HeaderSection = ({
  logo,
  logoImage,
  logoImageAlt = "",
  logoHref,
  logoAriaLabel,
  showDisclosure = true,
  disclosureText = "Advertising Disclosure",
  disclosureHref,
  onDisclosureClick,
  disclosureIcon,
  showDisclosureIcon = true,
  colors,
  className,
  classes = {}
}) => {
  const logoNode = logo != null ? logo : logoImage ? /* @__PURE__ */ React275.createElement(Image, { src: logoImage, alt: logoImageAlt, className: cn(DEFAULT_LOGO_CLASS7, classes.logo) }) : null;
  const hasDisclosure = showDisclosure && Boolean(disclosureText);
  const disclosureIconNode = disclosureIcon != null ? disclosureIcon : /* @__PURE__ */ React275.createElement(IconInfo, { className: cn(DEFAULT_DISCLOSURE_ICON_CLASS, classes.disclosureIcon) });
  const disclosureBody = /* @__PURE__ */ React275.createElement(React275.Fragment, null, showDisclosureIcon && disclosureIconNode, /* @__PURE__ */ React275.createElement(Text, { as: "span", className: cn(DEFAULT_DISCLOSURE_TEXT_CLASS, classes.disclosureText) }, disclosureText));
  const disclosureClass = cn(DEFAULT_DISCLOSURE_CLASS, classes.disclosure);
  let disclosure = null;
  if (hasDisclosure) {
    if (disclosureHref) {
      disclosure = /* @__PURE__ */ React275.createElement("a", { href: disclosureHref, className: disclosureClass }, disclosureBody);
    } else if (onDisclosureClick) {
      disclosure = /* @__PURE__ */ React275.createElement(
        "button",
        {
          type: "button",
          onClick: onDisclosureClick,
          className: cn(disclosureClass, "cursor-pointer")
        },
        disclosureBody
      );
    } else {
      disclosure = /* @__PURE__ */ React275.createElement("div", { className: disclosureClass }, disclosureBody);
    }
  }
  return /* @__PURE__ */ React275.createElement(
    "header",
    {
      className: cn(DEFAULT_SECTION_CLASS34, classes.section, className),
      style: buildVars18(colors)
    },
    /* @__PURE__ */ React275.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS60, classes.container) }, logoNode && (logoHref ? /* @__PURE__ */ React275.createElement(
      "a",
      {
        href: logoHref,
        "aria-label": logoAriaLabel || logoImageAlt || void 0,
        className: cn(DEFAULT_LOGO_LINK_CLASS, classes.logoLink)
      },
      logoNode
    ) : /* @__PURE__ */ React275.createElement("div", { className: cn(DEFAULT_LOGO_LINK_CLASS, classes.logoLink) }, logoNode)), disclosure)
  );
};

// src/sections/top5/Top5HeroSection.tsx
import React276 from "react";
var DEFAULT_SECTION_CLASS35 = "relative flex w-full flex-col items-center justify-center overflow-hidden px-4 py-10";
var DEFAULT_BACKGROUND_CLASS = "pointer-events-none absolute inset-0";
var DEFAULT_BACKGROUND_IMAGE_CLASS = "absolute inset-0 size-full max-w-none object-cover";
var DEFAULT_OVERLAY_CLASS2 = "absolute inset-0 bg-(--top5-hero-overlay)";
var DEFAULT_CONTAINER_CLASS61 = "relative flex w-full max-w-[1000px] flex-col items-center gap-6 text-center md:gap-10";
var DEFAULT_DATE_CLASS2 = "w-full text-[15px] leading-normal italic text-(--top5-hero-date)";
var DEFAULT_TITLE_CONTAINER_CLASS = "flex w-full flex-col gap-6";
var DEFAULT_HEADING_CLASS14 = "w-full whitespace-pre-line text-[32px] leading-10 font-bold text-(--top5-hero-heading) md:text-[56px] md:leading-[64px]";
var DEFAULT_SUBTITLE_CLASS6 = "w-full text-[20px] leading-8 font-bold text-(--top5-hero-subtitle) md:text-[24px]";
var DEFAULT_NAV_CLASS4 = "w-full";
var DEFAULT_NAV_LIST_CLASS = "flex list-none flex-wrap items-center justify-center gap-x-[6px] gap-y-[6px] md:gap-6";
var DEFAULT_NAV_BUTTON_CLASS = "inline-flex items-center justify-center border px-2 py-4 text-(--top5-hero-button-text) border-(--top5-hero-button-border) transition-colors duration-200 hover:bg-(--top5-hero-button-hover-bg) hover:text-(--top5-hero-button-hover-text) hover:border-(--top5-hero-button-hover-bg) md:px-4 md:py-6";
var DEFAULT_NAV_BUTTON_LABEL_CLASS = "text-[16px] leading-6 font-bold whitespace-nowrap uppercase";
function buildVars19(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    "--top5-hero-overlay": (_a = colors == null ? void 0 : colors.overlayColor) != null ? _a : "rgba(0, 0, 0, 0.8)",
    "--top5-hero-date": (_b = colors == null ? void 0 : colors.dateColor) != null ? _b : "#FFFFFF",
    "--top5-hero-heading": (_c = colors == null ? void 0 : colors.headingColor) != null ? _c : "#FFFFFF",
    "--top5-hero-subtitle": (_d = colors == null ? void 0 : colors.subtitleColor) != null ? _d : "var(--theme-color-accent, #FFDA00)",
    "--top5-hero-button-border": (_e = colors == null ? void 0 : colors.buttonBorderColor) != null ? _e : "#FFFFFF",
    "--top5-hero-button-text": (_f = colors == null ? void 0 : colors.buttonTextColor) != null ? _f : "#FFFFFF",
    "--top5-hero-button-hover-bg": (_g = colors == null ? void 0 : colors.buttonHoverBackground) != null ? _g : "#FFFFFF",
    "--top5-hero-button-hover-text": (_h = colors == null ? void 0 : colors.buttonHoverTextColor) != null ? _h : "#1C2B54"
  };
}
var Top5HeroSection = ({
  backgroundImage,
  backgroundImageAlt = "",
  backgroundSources,
  background,
  showOverlay = true,
  dateText,
  heading,
  headingAs = "h2",
  subtitleHtml,
  navButtons = [],
  navAriaLabel = "In-page navigation",
  colors,
  className,
  classes = {}
}) => {
  const hasMedia = Boolean(background || backgroundImage);
  const hasTitle = Boolean(heading || subtitleHtml);
  return /* @__PURE__ */ React276.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS35, classes.section, className),
      style: buildVars19(colors)
    },
    hasMedia && /* @__PURE__ */ React276.createElement("div", { "aria-hidden": "true", className: cn(DEFAULT_BACKGROUND_CLASS, classes.background) }, background != null ? background : backgroundImage ? /* @__PURE__ */ React276.createElement(
      Image,
      {
        src: backgroundImage,
        alt: backgroundImageAlt,
        sources: backgroundSources,
        className: cn(DEFAULT_BACKGROUND_IMAGE_CLASS, classes.backgroundImage)
      }
    ) : null, showOverlay && /* @__PURE__ */ React276.createElement("div", { className: cn(DEFAULT_OVERLAY_CLASS2, classes.overlay) })),
    /* @__PURE__ */ React276.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS61, classes.container) }, dateText && /* @__PURE__ */ React276.createElement(Text, { as: "p", className: cn(DEFAULT_DATE_CLASS2, classes.date) }, dateText), hasTitle && /* @__PURE__ */ React276.createElement("div", { className: cn(DEFAULT_TITLE_CONTAINER_CLASS, classes.titleContainer) }, heading && /* @__PURE__ */ React276.createElement(Text, { as: headingAs, className: cn(DEFAULT_HEADING_CLASS14, classes.heading) }, heading), subtitleHtml && /* @__PURE__ */ React276.createElement(
      RichText,
      {
        html: subtitleHtml,
        className: cn(DEFAULT_SUBTITLE_CLASS6, classes.subtitle)
      }
    )), navButtons.length > 0 && /* @__PURE__ */ React276.createElement("nav", { "aria-label": navAriaLabel, className: cn(DEFAULT_NAV_CLASS4, classes.nav) }, /* @__PURE__ */ React276.createElement("ul", { className: cn(DEFAULT_NAV_LIST_CLASS, classes.navList) }, navButtons.map((button, index) => /* @__PURE__ */ React276.createElement(
      "li",
      {
        key: `${button.href}-${index}`,
        className: cn(button.hideOnMobile && "hidden md:block", classes.navItem)
      },
      /* @__PURE__ */ React276.createElement("a", { href: button.href, className: cn(DEFAULT_NAV_BUTTON_CLASS, classes.navButton) }, /* @__PURE__ */ React276.createElement(
        Text,
        {
          as: "span",
          className: cn(DEFAULT_NAV_BUTTON_LABEL_CLASS, classes.navButtonLabel)
        },
        button.label
      ))
    )))))
  );
};

// src/sections/top5/Top5ProductComparisonCardSection.tsx
import React277, { useEffect as useEffect28, useRef as useRef21, useState as useState34 } from "react";
var DEFAULT_SECTION_CLASS36 = "w-full px-4 py-8 md:py-12 [background:var(--tpc-section-bg)]";
var DEFAULT_CONTAINER_CLASS62 = "mx-auto flex w-full max-w-[1000px] flex-col items-center gap-8 md:gap-16";
var DEFAULT_HEADING_CLASS15 = "text-center text-[24px] leading-tight font-bold text-(--tpc-heading) md:text-[32px] md:leading-[40px]";
var DEFAULT_TABLE_WRAPPER_CLASS = "flex w-full flex-col gap-3";
var DEFAULT_SCROLL_AREA_CLASS = "w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden";
var DEFAULT_TABLE_CLASS = "flex w-max flex-col md:w-full";
var DEFAULT_LABEL_COL_CLASS = "w-40 md:w-auto md:min-w-[180px] md:max-w-[380px] md:flex-1";
var DEFAULT_LABEL_STICKY_CLASS = "sticky left-0 z-20 [background:var(--tpc-section-bg)] md:static";
var DEFAULT_LABEL_CELL_CLASS = "flex items-center py-2 pr-2 md:px-3 md:py-3";
var DEFAULT_LABEL_CLASS14 = "text-[12px] leading-[16px] font-bold text-(--tpc-label) [word-break:break-word] md:text-[16px] md:leading-[24px]";
var DEFAULT_PRODUCT_COL_CLASS = "w-20 shrink-0 md:w-[120px]";
var DEFAULT_PRODUCT_STICKY_CLASS = "sticky left-40 z-10 md:static";
var DEFAULT_HEADER_CELL_CLASS = "flex flex-col items-center justify-center py-2 md:py-3.5";
var DEFAULT_BODY_CELL_CLASS = "flex items-center justify-center";
var DEFAULT_PRODUCT_IMAGE_CLASS3 = "size-20 object-contain md:size-[120px]";
var DEFAULT_ICON_CLASS31 = "size-4 shrink-0 md:size-5";
var DEFAULT_CAP_CLASS = "h-4";
var DEFAULT_SCROLL_TRACK_CLASS = "relative h-1 w-full overflow-hidden rounded-full bg-(--tpc-scroll-track)";
var DEFAULT_SCROLL_THUMB_CLASS = "absolute inset-y-0 rounded-full bg-(--tpc-scroll-thumb)";
function buildVars20(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return {
    "--tpc-section-bg": (_a = colors == null ? void 0 : colors.sectionBackground) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--tpc-heading": (_b = colors == null ? void 0 : colors.headingColor) != null ? _b : "var(--theme-color-heading-primary, #222222)",
    "--tpc-label": (_c = colors == null ? void 0 : colors.labelColor) != null ? _c : "var(--theme-color-text-primary, #222222)",
    "--tpc-col-bg": (_d = colors == null ? void 0 : colors.columnBackground) != null ? _d : "transparent",
    "--tpc-check": (_e = colors == null ? void 0 : colors.checkColor) != null ? _e : "var(--theme-color-success, #0EC49A)",
    "--tpc-cross": (_f = colors == null ? void 0 : colors.crossColor) != null ? _f : "var(--theme-color-error, #DD4B4B)",
    "--tpc-row-divider": (_g = colors == null ? void 0 : colors.rowDividerColor) != null ? _g : "transparent",
    "--tpc-scroll-track": (_h = colors == null ? void 0 : colors.scrollTrackColor) != null ? _h : "var(--theme-color-border-light, #E5E7EB)",
    "--tpc-scroll-thumb": (_i = colors == null ? void 0 : colors.scrollThumbColor) != null ? _i : "var(--theme-color-accent, #0EC49A)"
  };
}
function featuredCellStyle(product, position, defaults) {
  var _a, _b, _c, _d, _e;
  const style = (_a = product.featuredStyle) != null ? _a : {};
  const side = `${(_b = style.borderWidth) != null ? _b : defaults.borderWidth} ${(_c = style.borderStyle) != null ? _c : defaults.borderStyle} ${(_d = style.borderColor) != null ? _d : defaults.borderColor}`;
  return {
    background: (_e = style.background) != null ? _e : defaults.background,
    borderLeft: side,
    borderRight: side,
    ...position === "header" ? { borderTop: side } : {},
    ...position === "cap" ? { borderBottom: side } : {}
  };
}
var ScrollIndicator = ({ scrollRef, className, thumbClassName }) => {
  const [metrics, setMetrics] = useState34({ visible: false, widthPct: 0, leftPct: 0 });
  useEffect28(() => {
    const el = scrollRef.current;
    if (!el) return;
    const update = () => {
      const { scrollWidth, clientWidth, scrollLeft } = el;
      const overflow = scrollWidth - clientWidth;
      if (overflow <= 1) {
        setMetrics(
          (current) => current.visible ? { visible: false, widthPct: 0, leftPct: 0 } : current
        );
        return;
      }
      const widthPct = clientWidth / scrollWidth * 100;
      const leftPct = scrollLeft / overflow * (100 - widthPct);
      setMetrics({ visible: true, widthPct, leftPct });
    };
    update();
    el.addEventListener("scroll", update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      el.removeEventListener("scroll", update);
      observer.disconnect();
    };
  }, [scrollRef]);
  if (!metrics.visible) return null;
  return /* @__PURE__ */ React277.createElement("div", { className: cn(DEFAULT_SCROLL_TRACK_CLASS, className), "aria-hidden": "true" }, /* @__PURE__ */ React277.createElement(
    "span",
    {
      className: cn(DEFAULT_SCROLL_THUMB_CLASS, thumbClassName),
      style: { width: `${metrics.widthPct}%`, left: `${metrics.leftPct}%` }
    }
  ));
};
var Top5ProductComparisonCardSection = ({
  heading,
  headingAs = "h2",
  benefits = [],
  products = [],
  positiveIcon,
  negativeIcon,
  featuredColumnBorderWidth = "1px",
  featuredColumnBorderStyle = "solid",
  showScrollIndicator = true,
  colors,
  className,
  classes = {}
}) => {
  var _a, _b;
  const scrollRef = useRef21(null);
  const enabledProducts = products.filter((product) => product.enabled !== false);
  const orderedProducts = [
    ...enabledProducts.filter((product) => product.featured),
    ...enabledProducts.filter((product) => !product.featured)
  ];
  if (!benefits.length || !orderedProducts.length) return null;
  const featuredDefaults = {
    background: (_a = colors == null ? void 0 : colors.featuredColumnBackground) != null ? _a : "var(--theme-color-bg-tint, #E6F9EC)",
    borderColor: (_b = colors == null ? void 0 : colors.featuredColumnBorderColor) != null ? _b : "var(--theme-color-accent, #0EC49A)",
    borderWidth: featuredColumnBorderWidth,
    borderStyle: featuredColumnBorderStyle
  };
  const hasRowDivider = Boolean(
    (colors == null ? void 0 : colors.rowDividerColor) && colors.rowDividerColor !== "transparent"
  );
  const positiveNode = positiveIcon != null ? positiveIcon : /* @__PURE__ */ React277.createElement(IconCheckmark, { className: cn(DEFAULT_ICON_CLASS31, "text-(--tpc-check)", classes.icon) });
  const negativeNode = negativeIcon != null ? negativeIcon : /* @__PURE__ */ React277.createElement(IconXMark, { className: cn(DEFAULT_ICON_CLASS31, "text-(--tpc-cross)", classes.icon) });
  const isStickyColumn = (index, product) => index === 0 && Boolean(product.featured);
  return /* @__PURE__ */ React277.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS36, classes.section, className),
      style: buildVars20(colors)
    },
    /* @__PURE__ */ React277.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS62, classes.container) }, heading && /* @__PURE__ */ React277.createElement(Text, { as: headingAs, className: cn(DEFAULT_HEADING_CLASS15, classes.heading) }, heading), /* @__PURE__ */ React277.createElement("div", { className: cn(DEFAULT_TABLE_WRAPPER_CLASS, classes.header) }, /* @__PURE__ */ React277.createElement(
      "div",
      {
        ref: scrollRef,
        role: "region",
        "aria-label": heading ? `${heading} comparison table` : "Product comparison table",
        tabIndex: 0,
        className: cn(DEFAULT_SCROLL_AREA_CLASS, classes.scrollArea)
      },
      /* @__PURE__ */ React277.createElement(
        "div",
        {
          role: "table",
          "aria-label": "Product comparison",
          className: cn(DEFAULT_TABLE_CLASS, classes.table)
        },
        /* @__PURE__ */ React277.createElement("div", { role: "rowgroup" }, /* @__PURE__ */ React277.createElement("div", { role: "row", className: cn("flex items-stretch", classes.headerRow) }, /* @__PURE__ */ React277.createElement(
          "div",
          {
            role: "columnheader",
            className: cn(
              DEFAULT_LABEL_COL_CLASS,
              DEFAULT_LABEL_STICKY_CLASS,
              classes.labelCell
            )
          },
          /* @__PURE__ */ React277.createElement("span", { className: "sr-only" }, "Feature")
        ), orderedProducts.map((product, index) => {
          var _a2, _b2;
          const featured = Boolean(product.featured);
          return /* @__PURE__ */ React277.createElement(
            "div",
            {
              key: index,
              role: "columnheader",
              className: cn(
                DEFAULT_PRODUCT_COL_CLASS,
                DEFAULT_HEADER_CELL_CLASS,
                featured ? "rounded-t-[10px]" : "[background:var(--tpc-col-bg)]",
                isStickyColumn(index, product) && DEFAULT_PRODUCT_STICKY_CLASS,
                classes.productHeaderCell,
                product.className
              ),
              style: featured ? featuredCellStyle(product, "header", featuredDefaults) : void 0
            },
            product.image && /* @__PURE__ */ React277.createElement(
              Image,
              {
                src: product.image,
                alt: (_b2 = (_a2 = product.imageAlt) != null ? _a2 : product.name) != null ? _b2 : "",
                className: cn(DEFAULT_PRODUCT_IMAGE_CLASS3, classes.productImage)
              }
            ),
            product.name && /* @__PURE__ */ React277.createElement("span", { className: "sr-only" }, product.name)
          );
        }))),
        /* @__PURE__ */ React277.createElement("div", { role: "rowgroup" }, benefits.map((benefit, rowIndex) => /* @__PURE__ */ React277.createElement(
          "div",
          {
            role: "row",
            key: rowIndex,
            className: cn(
              "flex items-stretch",
              hasRowDivider && rowIndex < benefits.length - 1 && "border-b border-(--tpc-row-divider)",
              classes.row
            )
          },
          /* @__PURE__ */ React277.createElement(
            "div",
            {
              role: "rowheader",
              className: cn(
                DEFAULT_LABEL_COL_CLASS,
                DEFAULT_LABEL_STICKY_CLASS,
                DEFAULT_LABEL_CELL_CLASS,
                classes.labelCell
              )
            },
            /* @__PURE__ */ React277.createElement(Text, { as: "span", className: cn(DEFAULT_LABEL_CLASS14, classes.label) }, benefit.label)
          ),
          orderedProducts.map((product, index) => {
            const featured = Boolean(product.featured);
            const positive = product.values[rowIndex] === true;
            return /* @__PURE__ */ React277.createElement(
              "div",
              {
                role: "cell",
                key: index,
                className: cn(
                  DEFAULT_PRODUCT_COL_CLASS,
                  DEFAULT_BODY_CELL_CLASS,
                  !featured && "[background:var(--tpc-col-bg)]",
                  isStickyColumn(index, product) && DEFAULT_PRODUCT_STICKY_CLASS,
                  classes.productCell,
                  product.className
                ),
                style: featured ? featuredCellStyle(product, "body", featuredDefaults) : void 0
              },
              positive ? positiveNode : negativeNode,
              /* @__PURE__ */ React277.createElement("span", { className: "sr-only" }, positive ? "Yes" : "No")
            );
          })
        ))),
        /* @__PURE__ */ React277.createElement("div", { "aria-hidden": "true", className: "flex" }, /* @__PURE__ */ React277.createElement(
          "div",
          {
            className: cn(
              DEFAULT_LABEL_COL_CLASS,
              DEFAULT_LABEL_STICKY_CLASS,
              DEFAULT_CAP_CLASS
            )
          }
        ), orderedProducts.map((product, index) => {
          const featured = Boolean(product.featured);
          return /* @__PURE__ */ React277.createElement(
            "div",
            {
              key: index,
              className: cn(
                DEFAULT_PRODUCT_COL_CLASS,
                DEFAULT_CAP_CLASS,
                featured ? "rounded-b-[10px]" : "[background:var(--tpc-col-bg)]",
                isStickyColumn(index, product) && DEFAULT_PRODUCT_STICKY_CLASS,
                product.className
              ),
              style: featured ? featuredCellStyle(product, "cap", featuredDefaults) : void 0
            }
          );
        }))
      )
    ), showScrollIndicator && /* @__PURE__ */ React277.createElement(
      ScrollIndicator,
      {
        scrollRef,
        className: classes.scrollIndicator,
        thumbClassName: classes.scrollThumb
      }
    )))
  );
};

// src/sections/top5/Top5FooterSection.tsx
import React278 from "react";
var DEFAULT_SECTION_CLASS37 = "w-full px-4 py-4 md:py-6";
var DEFAULT_CONTAINER_CLASS63 = "mx-auto flex w-full max-w-[1000px] flex-col gap-4";
var DEFAULT_DISCLAIMER_BOX_CLASS = "flex w-full items-center justify-center border border-solid px-[13px] py-3";
var DEFAULT_DISCLAIMER_CLASS3 = "w-full text-xs leading-4";
var DEFAULT_DIVIDER_CLASS18 = "w-full";
var DEFAULT_NAV_ROW_CLASS = "flex w-full flex-col items-center justify-center gap-6 md:flex-row";
var DEFAULT_LOGO_CLASS8 = "h-6 w-auto shrink-0";
var DEFAULT_NAV_CLASS5 = "w-full md:flex-1";
var DEFAULT_NAV_LIST_CLASS2 = "flex list-none flex-wrap items-center justify-center gap-4";
var DEFAULT_NAV_LINK_CLASS = "whitespace-nowrap text-sm leading-5 transition-colors";
var DEFAULT_BACK_TO_TOP_CLASS = "inline-flex shrink-0 items-center gap-2 rounded-full px-4 py-2 transition-colors";
var DEFAULT_BACK_TO_TOP_LABEL_CLASS = "whitespace-nowrap text-center text-xs font-bold leading-4";
var DEFAULT_BACK_TO_TOP_ICON_CLASS = "size-4 shrink-0";
var DEFAULT_COPYRIGHT_CLASS = "w-full text-sm leading-5 text-center md:text-left";
var THEMED_SECTION_CLASS = "[background:var(--top5-footer-bg)]";
var THEMED_DISCLAIMER_BOX_CLASS = "border-(--top5-footer-divider)";
var THEMED_DISCLAIMER_CLASS = "text-(--top5-footer-disclaimer)";
var THEMED_DIVIDER_CLASS = "border-(--top5-footer-divider)";
var THEMED_NAV_LINK_CLASS = "text-(--top5-footer-text)";
var THEMED_BACK_TO_TOP_CLASS = "[background:var(--top5-footer-accent)] text-(--top5-footer-accent-text) hover:[background:var(--top5-footer-accent-hover)]";
var THEMED_COPYRIGHT_CLASS = "text-(--top5-footer-text)";
function buildVars21(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const vars = {
    "--top5-footer-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-section, #F9F9F9)",
    "--top5-footer-text": (_b = colors == null ? void 0 : colors.textColor) != null ? _b : "var(--theme-color-text-primary, #4F4F4F)",
    "--top5-footer-disclaimer": (_c = colors == null ? void 0 : colors.disclaimerColor) != null ? _c : "var(--theme-color-text-light, #828282)",
    "--top5-footer-divider": (_d = colors == null ? void 0 : colors.dividerColor) != null ? _d : "var(--theme-color-border, #F2F2F2)",
    "--top5-footer-accent": (_e = colors == null ? void 0 : colors.backToTopBackground) != null ? _e : "var(--theme-color-bg-dark, #232F3E)",
    "--top5-footer-accent-hover": (_g = (_f = colors == null ? void 0 : colors.backToTopHoverBackground) != null ? _f : colors == null ? void 0 : colors.backToTopBackground) != null ? _g : "var(--theme-color-bg-dark, #232F3E)",
    "--top5-footer-accent-text": (_h = colors == null ? void 0 : colors.backToTopTextColor) != null ? _h : "#FFFFFF"
  };
  if (colors == null ? void 0 : colors.linkHoverColor) {
    vars["--footer-text-hover"] = colors.linkHoverColor;
    vars["--footer-link-hover-decoration"] = "none";
  }
  return vars;
}
var Top5FooterSection = ({
  logo,
  logoAlt = "",
  logoNode,
  disclaimer,
  navLinks = [],
  navAriaLabel = "Footer navigation",
  copyrightText,
  backToTopLabel = "Back to Top",
  backToTopHref = "#top",
  backToTopIcon,
  showDisclaimer = true,
  showLogo = true,
  showNav = true,
  showBackToTop = true,
  showCopyright = true,
  colors,
  className,
  classes = {},
  styles = {}
}) => {
  const logoEl = showLogo ? logoNode != null ? logoNode : logo ? /* @__PURE__ */ React278.createElement(Image, { src: logo, alt: logoAlt, className: cn(DEFAULT_LOGO_CLASS8, classes.logo) }) : null : null;
  const hasDisclaimer = showDisclaimer && Boolean(disclaimer);
  const hasNav = showNav && navLinks.length > 0;
  const hasCopyright = showCopyright && Boolean(copyrightText);
  const hasBackToTop = showBackToTop && Boolean(backToTopLabel);
  const hasNavRow = Boolean(logoEl) || hasNav || hasBackToTop;
  return /* @__PURE__ */ React278.createElement(
    "footer",
    {
      className: cn(DEFAULT_SECTION_CLASS37, THEMED_SECTION_CLASS, classes.section, className),
      style: { ...buildVars21(colors), ...styles.section }
    },
    /* @__PURE__ */ React278.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS63, classes.container), style: styles.container }, hasDisclaimer && /* @__PURE__ */ React278.createElement(React278.Fragment, null, /* @__PURE__ */ React278.createElement(
      "div",
      {
        className: cn(
          DEFAULT_DISCLAIMER_BOX_CLASS,
          THEMED_DISCLAIMER_BOX_CLASS,
          classes.disclaimerBox
        )
      },
      /* @__PURE__ */ React278.createElement(
        RichText,
        {
          html: disclaimer,
          className: cn(
            DEFAULT_DISCLAIMER_CLASS3,
            THEMED_DISCLAIMER_CLASS,
            classes.disclaimer
          )
        }
      )
    ), /* @__PURE__ */ React278.createElement(
      Divider,
      {
        variant: "horizontal",
        className: cn(DEFAULT_DIVIDER_CLASS18, THEMED_DIVIDER_CLASS, classes.divider)
      }
    )), hasNavRow && /* @__PURE__ */ React278.createElement("div", { className: cn(DEFAULT_NAV_ROW_CLASS, classes.navRow) }, logoEl, hasNav && /* @__PURE__ */ React278.createElement("nav", { "aria-label": navAriaLabel, className: cn(DEFAULT_NAV_CLASS5, classes.nav) }, /* @__PURE__ */ React278.createElement("ul", { className: cn(DEFAULT_NAV_LIST_CLASS2, classes.navList) }, navLinks.map((link, index) => /* @__PURE__ */ React278.createElement("li", { key: `${link.label}-${index}`, className: classes.navItem }, /* @__PURE__ */ React278.createElement(
      FooterLink2,
      {
        href: link.href,
        className: cn(
          DEFAULT_NAV_LINK_CLASS,
          THEMED_NAV_LINK_CLASS,
          classes.navLink
        )
      },
      link.label
    ))))), hasBackToTop && /* @__PURE__ */ React278.createElement(
      "a",
      {
        href: backToTopHref,
        className: cn(
          DEFAULT_BACK_TO_TOP_CLASS,
          THEMED_BACK_TO_TOP_CLASS,
          classes.backToTop
        )
      },
      /* @__PURE__ */ React278.createElement(
        Text,
        {
          as: "span",
          className: cn(DEFAULT_BACK_TO_TOP_LABEL_CLASS, classes.backToTopLabel)
        },
        backToTopLabel
      ),
      /* @__PURE__ */ React278.createElement("span", { className: cn(DEFAULT_BACK_TO_TOP_ICON_CLASS, classes.backToTopIcon) }, backToTopIcon != null ? backToTopIcon : /* @__PURE__ */ React278.createElement(IconArrowUp, null))
    )), hasCopyright && /* @__PURE__ */ React278.createElement(React278.Fragment, null, /* @__PURE__ */ React278.createElement(
      Divider,
      {
        variant: "horizontal",
        className: cn(DEFAULT_DIVIDER_CLASS18, THEMED_DIVIDER_CLASS, classes.divider)
      }
    ), /* @__PURE__ */ React278.createElement(
      Text,
      {
        as: "p",
        className: cn(DEFAULT_COPYRIGHT_CLASS, THEMED_COPYRIGHT_CLASS, classes.copyright)
      },
      copyrightText
    )))
  );
};

// src/sections/top5/Top5RichMediaSection.tsx
import React279 from "react";
var DEFAULT_SECTION_CLASS38 = "w-full px-4 py-8 md:py-12";
var DEFAULT_CONTAINER_CLASS64 = "mx-auto flex w-full max-w-[1000px] flex-col items-center gap-6 [word-break:break-word]";
var DEFAULT_HEADING_CLASS16 = "w-full text-[24px] font-bold leading-8 md:text-[32px] md:leading-10";
var DEFAULT_BLOCK_CLASS = "w-full";
var DEFAULT_TEXT_CLASS17 = "w-full text-[18px] leading-[28px] [&_strong]:font-bold [&_a]:underline [&_p:not(:last-child)]:mb-4 [&_:is(ul,ol)]:my-4 [&_:is(ul,ol)]:pl-5 [&_ul]:list-disc [&_ol]:list-decimal";
var DEFAULT_IMAGE_CLASS23 = "h-auto w-full rounded-[10px]";
var DEFAULT_VIDEO_CLASS2 = "aspect-auto h-auto w-full rounded-[10px]";
var THEMED_SECTION_CLASS2 = "[background:var(--top5-rich-media-bg)]";
var THEMED_HEADING_CLASS = "text-(--top5-rich-media-heading)";
var THEMED_TEXT_CLASS = "text-(--top5-rich-media-text)";
function buildVars22(colors) {
  var _a, _b, _c;
  return {
    "--top5-rich-media-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-page, #FFFFFF)",
    "--top5-rich-media-heading": (_b = colors == null ? void 0 : colors.headingColor) != null ? _b : "var(--theme-color-heading-primary, #111827)",
    "--top5-rich-media-text": (_c = colors == null ? void 0 : colors.textColor) != null ? _c : "var(--theme-color-text-primary, #374151)"
  };
}
function isRenderableBlock(block) {
  var _a;
  if (block.type === "text") return Boolean(sanitizeHtml(block.html));
  return Boolean((_a = block.src) == null ? void 0 : _a.trim());
}
function renderBlock(block, classes) {
  switch (block.type) {
    case "text":
      return /* @__PURE__ */ React279.createElement(
        RichText,
        {
          html: block.html,
          className: cn(DEFAULT_TEXT_CLASS17, THEMED_TEXT_CLASS, classes.text)
        }
      );
    case "image":
      return /* @__PURE__ */ React279.createElement(
        Image,
        {
          src: block.src,
          alt: block.alt,
          className: cn(DEFAULT_IMAGE_CLASS23, classes.image),
          ...block.imageProps
        }
      );
    case "video":
      return /* @__PURE__ */ React279.createElement(
        Video,
        {
          src: block.src,
          poster: block.poster,
          ariaLabel: block.ariaLabel,
          className: cn(DEFAULT_VIDEO_CLASS2, classes.video),
          autoPlay: false,
          loop: false,
          controls: true,
          ...block.videoProps
        }
      );
    default:
      return null;
  }
}
var Top5RichMediaSection = ({
  heading,
  headingAs = "h2",
  blocks = [],
  colors,
  classes = {},
  styles = {},
  className
}) => {
  const renderableBlocks = blocks.filter(isRenderableBlock);
  if (!heading && renderableBlocks.length === 0) return null;
  return /* @__PURE__ */ React279.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS38, THEMED_SECTION_CLASS2, classes.section, className),
      style: { ...buildVars22(colors), ...styles.section }
    },
    /* @__PURE__ */ React279.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS64, classes.container), style: styles.container }, heading && /* @__PURE__ */ React279.createElement(
      Text,
      {
        as: headingAs,
        className: cn(DEFAULT_HEADING_CLASS16, THEMED_HEADING_CLASS, classes.heading)
      },
      heading
    ), renderableBlocks.map((block, index) => {
      var _a;
      return /* @__PURE__ */ React279.createElement(
        "div",
        {
          key: (_a = block.id) != null ? _a : index,
          className: cn(DEFAULT_BLOCK_CLASS, classes.block, block.className)
        },
        renderBlock(block, classes)
      );
    }))
  );
};

// src/sections/top5/Top5CalloutBoxSection.tsx
import React280 from "react";
var DEFAULT_SECTION_CLASS39 = "w-full px-4 py-4 md:py-6";
var DEFAULT_CONTAINER_CLASS65 = "mx-auto w-full max-w-[1000px]";
var DEFAULT_BOX_CLASS = "w-full p-4 border-(--top5-callout-box-border) [border-width:var(--top5-callout-box-border-width)] [border-style:var(--top5-callout-box-border-style)] [background:var(--top5-callout-box-bg)]";
var DEFAULT_ICON_ROW_CLASS = "flex items-start gap-3";
var DEFAULT_ICON_WRAPPER_CLASS3 = "flex shrink-0 items-center";
var DEFAULT_CONTENT_CLASS18 = "text-[18px] leading-[28px] text-(--top5-callout-box-text) [&_p]:mb-4 [&_p:last-child]:mb-0 [&_b]:font-bold [&_strong]:font-bold [&_a]:underline [&_a]:[text-underline-position:from-font]";
function normalizeBorderWidth(width) {
  if (width == null) return "1px";
  if (typeof width === "number") return `${width}px`;
  return /^\d+$/.test(width.trim()) ? `${width.trim()}px` : width;
}
function buildVars23(colors, borderWidth, borderStyle) {
  var _a, _b, _c;
  return {
    "--top5-callout-box-border": (_a = colors == null ? void 0 : colors.borderColor) != null ? _a : "var(--theme-color-text-primary, #000000)",
    "--top5-callout-box-border-width": normalizeBorderWidth(borderWidth),
    "--top5-callout-box-border-style": borderStyle != null ? borderStyle : "solid",
    "--top5-callout-box-bg": (_b = colors == null ? void 0 : colors.background) != null ? _b : "transparent",
    "--top5-callout-box-text": (_c = colors == null ? void 0 : colors.textColor) != null ? _c : "var(--theme-color-text-primary, #000000)"
  };
}
var Top5CalloutBoxSection = ({
  html,
  icon,
  borderWidth,
  borderStyle,
  colors,
  className,
  classes = {}
}) => {
  const safeHtml = sanitizeHtml(html);
  if (!safeHtml) return null;
  const content = /* @__PURE__ */ React280.createElement(
    RichText,
    {
      html: safeHtml,
      className: cn(DEFAULT_CONTENT_CLASS18, icon != null && "min-w-0 flex-1", classes.content)
    }
  );
  return /* @__PURE__ */ React280.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS39, classes.section, className),
      style: buildVars23(colors, borderWidth, borderStyle)
    },
    /* @__PURE__ */ React280.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS65, classes.container) }, /* @__PURE__ */ React280.createElement("div", { className: cn(DEFAULT_BOX_CLASS, classes.box) }, icon != null ? /* @__PURE__ */ React280.createElement("div", { className: DEFAULT_ICON_ROW_CLASS }, /* @__PURE__ */ React280.createElement("span", { className: cn(DEFAULT_ICON_WRAPPER_CLASS3, classes.iconWrapper) }, icon), content) : content))
  );
};

// src/sections/top5/Top5CalloutTableSection.tsx
import React281 from "react";
var DEFAULT_SECTION_CLASS40 = "w-full px-4 py-4 md:py-6";
var DEFAULT_CONTAINER_CLASS66 = "mx-auto w-full max-w-[1000px]";
var DEFAULT_TABLE_CLASS2 = "flex w-full flex-col border-(--top5-callout-border) [border-width:var(--top5-callout-border-width)] [border-style:var(--top5-callout-border-style)]";
var DEFAULT_LABEL_BAR_CLASS = "flex w-full items-center justify-center p-4 [background:var(--top5-callout-label-bg)]";
var DEFAULT_LABEL_CLASS15 = "w-full text-center text-[24px] leading-[32px] font-bold text-(--top5-callout-label-text)";
var DEFAULT_CONTENT_CLASS19 = "flex w-full flex-col gap-2 p-6 [background:var(--top5-callout-content-bg)]";
var DEFAULT_ITEM_CLASS15 = "flex w-full items-center gap-2";
var DEFAULT_ITEM_ICON_CLASS = "flex shrink-0 items-center";
var DEFAULT_ITEM_TEXT_CLASS3 = "min-w-0 flex-1 text-[18px] leading-[28px] text-(--top5-callout-item-text) [&_p]:m-0 [&_b]:font-bold [&_strong]:font-bold [&_a]:underline [&_a]:[text-underline-position:from-font]";
var DEFAULT_TOP5_CALLOUT_ICON = /* @__PURE__ */ React281.createElement(
  IconCircleXmark,
  {
    className: "size-6 text-(--top5-callout-icon)",
    classes: { x: "text-(--top5-callout-content-bg)" }
  }
);
function normalizeBorderWidth2(width) {
  if (width == null) return "2px";
  if (typeof width === "number") return `${width}px`;
  return /^\d+$/.test(width.trim()) ? `${width.trim()}px` : width;
}
function buildVars24(colors, borderWidth, borderStyle) {
  var _a, _b, _c, _d, _e, _f;
  const accent = (_a = colors == null ? void 0 : colors.borderColor) != null ? _a : "var(--theme-color-error, #FF4A4A)";
  return {
    "--top5-callout-border": accent,
    "--top5-callout-border-width": normalizeBorderWidth2(borderWidth),
    "--top5-callout-border-style": borderStyle != null ? borderStyle : "solid",
    "--top5-callout-label-bg": (_b = colors == null ? void 0 : colors.labelBackground) != null ? _b : accent,
    "--top5-callout-label-text": (_c = colors == null ? void 0 : colors.labelTextColor) != null ? _c : "#FFFFFF",
    "--top5-callout-content-bg": (_d = colors == null ? void 0 : colors.contentBackground) != null ? _d : "var(--theme-color-bg-raised, #FFFFFF)",
    "--top5-callout-item-text": (_e = colors == null ? void 0 : colors.itemTextColor) != null ? _e : "var(--theme-color-text-primary, #000000)",
    "--top5-callout-icon": (_f = colors == null ? void 0 : colors.iconColor) != null ? _f : accent
  };
}
var Top5CalloutTableSection = ({
  label,
  labelAs = "h3",
  items,
  icon = DEFAULT_TOP5_CALLOUT_ICON,
  borderWidth,
  borderStyle,
  colors,
  className,
  classes = {}
}) => {
  const usableItems = (items != null ? items : []).map((item) => ({ ...item, safeText: sanitizeHtml(item.text) })).filter((item) => Boolean(item.safeText));
  if (!usableItems.length) return null;
  return /* @__PURE__ */ React281.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS40, classes.section, className),
      style: buildVars24(colors, borderWidth, borderStyle)
    },
    /* @__PURE__ */ React281.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS66, classes.container) }, /* @__PURE__ */ React281.createElement("div", { className: cn(DEFAULT_TABLE_CLASS2, classes.table) }, label && /* @__PURE__ */ React281.createElement("div", { className: cn(DEFAULT_LABEL_BAR_CLASS, classes.labelBar) }, /* @__PURE__ */ React281.createElement(Text, { as: labelAs, className: cn(DEFAULT_LABEL_CLASS15, classes.label) }, label)), /* @__PURE__ */ React281.createElement("ul", { className: cn(DEFAULT_CONTENT_CLASS19, classes.content) }, usableItems.map((item, index) => {
      var _a;
      const rowIcon = (_a = item.icon) != null ? _a : icon;
      return /* @__PURE__ */ React281.createElement("li", { key: index, className: cn(DEFAULT_ITEM_CLASS15, classes.item) }, rowIcon != null && /* @__PURE__ */ React281.createElement(
        "span",
        {
          className: cn(DEFAULT_ITEM_ICON_CLASS, classes.itemIcon),
          "aria-hidden": "true"
        },
        rowIcon
      ), /* @__PURE__ */ React281.createElement(
        RichText,
        {
          html: item.safeText,
          className: cn(DEFAULT_ITEM_TEXT_CLASS3, classes.itemText)
        }
      ));
    }))))
  );
};

// src/sections/ProductNavbarSection.tsx
import React282 from "react";
var DEFAULT_SECTION_CLASS41 = "w-full [background:var(--product-navbar-bg)]";
var DEFAULT_HEADER_CLASS25 = "[background:var(--product-navbar-bg)]";
var DEFAULT_LINK_CLASS3 = "text-(--product-navbar-link-color)";
var DEFAULT_CTA_CLASS3 = "[background:var(--product-navbar-cta-bg)] border-(--product-navbar-cta-border-color) text-(--product-navbar-cta-text-color) hover:[background:var(--product-navbar-cta-hover-bg)] hover:text-(--product-navbar-cta-hover-text-color)";
var DEFAULT_MOBILE_MENU_CLASS2 = "[background:var(--product-navbar-bg)]";
function buildVars25(colors) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return {
    "--product-navbar-bg": (_a = colors == null ? void 0 : colors.background) != null ? _a : "var(--theme-color-bg-raised, #FFFFFF)",
    "--product-navbar-cta-bg": (_b = colors == null ? void 0 : colors.ctaBackground) != null ? _b : "var(--theme-color-button-primary, linear-gradient(90deg, #FFCD5A 0%, #FFE65B 100%))",
    "--product-navbar-cta-border-color": (_c = colors == null ? void 0 : colors.ctaBorderColor) != null ? _c : "var(--theme-color-button-border, #D39208)",
    "--product-navbar-cta-text-color": (_d = colors == null ? void 0 : colors.ctaTextColor) != null ? _d : "var(--theme-color-button-text, #000000)",
    "--product-navbar-cta-hover-bg": (_f = (_e = colors == null ? void 0 : colors.ctaHoverBackground) != null ? _e : colors == null ? void 0 : colors.ctaBackground) != null ? _f : "var(--theme-color-button-hover, linear-gradient(90deg, #FFCD5A 0%, #FFE65B 100%))",
    "--product-navbar-cta-hover-text-color": (_h = (_g = colors == null ? void 0 : colors.ctaHoverTextColor) != null ? _g : colors == null ? void 0 : colors.ctaTextColor) != null ? _h : "var(--theme-color-button-text, #000000)",
    "--product-navbar-link-color": (_i = colors == null ? void 0 : colors.linkColor) != null ? _i : "var(--theme-color-text-primary, #000000)"
  };
}
var ProductNavbarSection = ({
  logo,
  logoImage,
  logoImageAlt,
  links,
  cta,
  ctaText,
  ctaHref,
  flagImage,
  flagImageAlt,
  showFlag,
  showMobileMenuButton,
  mobileMenuOpen,
  defaultMobileMenuOpen,
  onMobileMenuClick,
  onMobileMenuOpenChange,
  colors,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React282.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS41, classes.section, className),
      style: buildVars25(colors)
    },
    /* @__PURE__ */ React282.createElement(
      Header,
      {
        logo,
        logoImage,
        logoImageAlt,
        links,
        cta,
        ctaText,
        ctaHref,
        flagImage,
        flagImageAlt,
        showFlag,
        showMobileMenuButton,
        mobileMenuOpen,
        defaultMobileMenuOpen,
        onMobileMenuClick,
        onMobileMenuOpenChange,
        className: cn(DEFAULT_HEADER_CLASS25, classes.header),
        classes: {
          container: classes.container,
          logo: classes.logo,
          nav: classes.nav,
          link: cn(DEFAULT_LINK_CLASS3, classes.link),
          actions: classes.actions,
          cta: cn(DEFAULT_CTA_CLASS3, classes.cta),
          flag: classes.flag,
          menuButton: classes.menuButton,
          menuIcon: classes.menuIcon,
          mobileMenu: cn(DEFAULT_MOBILE_MENU_CLASS2, classes.mobileMenu),
          mobileMenuContent: classes.mobileMenuContent,
          mobileMenuLink: cn(DEFAULT_LINK_CLASS3, classes.mobileMenuLink),
          mobileMenuCta: cn(DEFAULT_CTA_CLASS3, classes.mobileMenuCta)
        }
      }
    )
  );
};

// src/atoms/StockProgressBar.tsx
import React283 from "react";
var DEFAULT_TRACK_CLASS7 = "flex h-3 w-full overflow-hidden rounded-full border border-neutral-300 bg-neutral-100";
var DEFAULT_FILL_CLASS2 = "block h-full rounded-l-full bg-[linear-gradient(90deg,#cbfe00_0%,#fee500_48.44%,#ff2b2b_100%)]";
var clamp = (value) => Math.min(Math.max(value, 0), 100);
var StockProgressBar = ({
  fillPercent,
  "aria-labelledby": ariaLabelledBy,
  className,
  classes = {}
}) => {
  const clamped = clamp(fillPercent);
  return /* @__PURE__ */ React283.createElement(
    "div",
    {
      role: "progressbar",
      "aria-valuenow": clamped,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-labelledby": ariaLabelledBy,
      className: cn(DEFAULT_TRACK_CLASS7, classes.track, className)
    },
    /* @__PURE__ */ React283.createElement("span", { className: cn(DEFAULT_FILL_CLASS2, classes.fill), style: { width: `${clamped}%` } })
  );
};

// src/atoms/ReviewsImage.tsx
import React284 from "react";

// src/assets/socials.png
var socials_default = "data:image/png;base64,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";

// src/atoms/ReviewsImage.tsx
var ReviewsImage = ({ className }) => /* @__PURE__ */ React284.createElement("img", { src: socials_default, className, alt: "", "aria-hidden": "true" });

// src/molecules/SocialProofPill.tsx
import React285 from "react";
var DEFAULT_ROOT_CLASS36 = "flex flex-wrap items-center gap-2 rounded-xl border px-3 py-2 bg-transparent";
var DEFAULT_DIVIDER_REVIEWS_CLASS = "flex items-center gap-2";
var DEFAULT_RATING_VALUE_CLASS = "text-sm font-semibold";
var DEFAULT_REVIEWS_CLASS2 = "text-sm";
var DEFAULT_DIVIDER_CLASS19 = "h-[13px] w-px shrink-0";
var THEMED_ROOT_CLASS4 = "border-[var(--theme-color-border-light,#e5e7eb)]";
var THEMED_RATING_VALUE_CLASS = "text-[var(--theme-color-warning,#111827)]";
var THEMED_REVIEWS_CLASS = "text-[var(--theme-color-text-secondary,#6b7280)]";
var THEMED_DIVIDER_CLASS2 = "bg-[var(--theme-color-text-secondary,#6b7280)]";
var SocialProofPill = ({
  rating,
  ratingText,
  reviewsText,
  showDivider = false,
  isTrustpilot = false,
  className,
  classes
}) => /* @__PURE__ */ React285.createElement("div", { className: cn(DEFAULT_ROOT_CLASS36, THEMED_ROOT_CLASS4, className, classes == null ? void 0 : classes.root) }, /* @__PURE__ */ React285.createElement(ReviewsImage, { className: "h-7 w-auto" }), isTrustpilot ? /* @__PURE__ */ React285.createElement(TrustpilotStars2, { rating }) : /* @__PURE__ */ React285.createElement(StarRating2, { rating }), ratingText && /* @__PURE__ */ React285.createElement(
  "span",
  {
    className: cn(DEFAULT_RATING_VALUE_CLASS, THEMED_RATING_VALUE_CLASS, classes == null ? void 0 : classes.ratingText)
  },
  ratingText
), (showDivider || reviewsText) && /* @__PURE__ */ React285.createElement("span", { className: DEFAULT_DIVIDER_REVIEWS_CLASS }, showDivider && /* @__PURE__ */ React285.createElement("span", { className: cn(DEFAULT_DIVIDER_CLASS19, THEMED_DIVIDER_CLASS2) }), reviewsText && /* @__PURE__ */ React285.createElement("span", { className: cn(DEFAULT_REVIEWS_CLASS2, THEMED_REVIEWS_CLASS, classes == null ? void 0 : classes.reviewsText) }, reviewsText)));

// src/molecules/SectionTitle.tsx
import React286 from "react";
var DEFAULT_ROOT_CLASS37 = "flex flex-col";
var DEFAULT_TITLE_CLASS22 = "text-2xl font-bold leading-tight";
var DEFAULT_UNDERLINE_CLASS = "mt-[12px] h-[7px] w-[70px] md:w-[100px] rounded-[10px]";
var ALIGN_CLASS = {
  left: "mr-auto",
  center: "mx-auto",
  right: "ml-auto"
};
var THEMED_TITLE_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_UNDERLINE_CLASS = "bg-[var(--theme-color-accent,#d1d5db)]";
var SectionTitle = ({
  title,
  underlineAlign = "center",
  showUnderline = true,
  className,
  classes = {}
}) => /* @__PURE__ */ React286.createElement("div", { className: cn(DEFAULT_ROOT_CLASS37, classes.root, className) }, /* @__PURE__ */ React286.createElement("h2", { className: cn(DEFAULT_TITLE_CLASS22, THEMED_TITLE_CLASS, classes.title) }, title), showUnderline && /* @__PURE__ */ React286.createElement(
  "div",
  {
    className: cn(
      DEFAULT_UNDERLINE_CLASS,
      THEMED_UNDERLINE_CLASS,
      ALIGN_CLASS[underlineAlign],
      classes.underline
    )
  }
));

// src/molecules/ActionButton.tsx
import React287 from "react";
var DEFAULT_ROOT_CLASS38 = "flex flex-col items-center gap-2";
var DEFAULT_BUTTON_CLASS11 = "flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg px-6 py-4 text-base font-bold uppercase leading-none transition-opacity hover:opacity-80";
var DEFAULT_SUB_ACTION_CLASS = "cursor-pointer text-xs underline opacity-60 hover:opacity-100 bg-transparent border-0 p-0";
var THEMED_BUTTON_CLASS = "bg-[var(--theme-color-button-primary,#1e40af)] text-[var(--theme-color-text-inverse,#ffffff)]";
var ActionButton = ({
  text,
  icon,
  isIconAppended = false,
  subActionText,
  onAction,
  onSubAction,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React287.createElement("div", { className: cn(DEFAULT_ROOT_CLASS38, classes.root, className) }, /* @__PURE__ */ React287.createElement(
    "button",
    {
      type: "button",
      onClick: onAction,
      className: cn(DEFAULT_BUTTON_CLASS11, THEMED_BUTTON_CLASS, classes.button)
    },
    /* @__PURE__ */ React287.createElement("span", null, text),
    isIconAppended && (icon != null ? icon : /* @__PURE__ */ React287.createElement(IconDoubleChevron, null))
  ), subActionText && /* @__PURE__ */ React287.createElement(
    "button",
    {
      type: "button",
      onClick: onSubAction,
      className: cn(DEFAULT_SUB_ACTION_CLASS, classes.subAction)
    },
    subActionText
  ));
};

// src/sections/AddMoreImageSection.tsx
import React288 from "react";
var DEFAULT_ROOT_CLASS39 = "justify-items-center my-[56px] overflow-hidden";
var DEFAULT_OUTER_CLASS2 = "w-full px-4 md:px-6";
var DEFAULT_INNER_CLASS11 = "overflow-hidden flex flex-col md:flex-row rounded-[16px]";
var DEFAULT_IMAGE_WRAPPER_CLASS13 = "shrink-0 p-[8px] md:p-0 md:w-2/5 md:max-w-[300px] lg:max-w-[340px]";
var DEFAULT_IMAGE_CLASS24 = "h-full w-full object-cover rounded-t-[12px] md:rounded-none";
var DEFAULT_CONTENT_CLASS20 = "flex flex-1 flex-col items-center px-[8px] py-[8px] text-center md:px-[16px] md:py-[24px] lg:px-[40px]";
var DEFAULT_DESCRIPTION_CLASS23 = "text-[14px] leading-[20px] lg:text-[16px] lg:leading-[24px]";
var TITLE_CLASS = "text-[24px] leading-[32px] font-bold lg:text-[32px] lg:leading-[40px]";
var PILL_INLINE_CLASS = "border-0 px-0";
var THEMED_OUTER_CLASS = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var THEMED_INNER_CLASS2 = "border border-[var(--theme-color-border-light,#e5e7eb)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_DESCRIPTION_CLASS = "text-[var(--theme-color-text-secondary,#4b5563)]";
var THEMED_UNDERLINE_CLASS2 = "[background:linear-gradient(90deg,var(--theme-color-accent,#edd7cf),var(--theme-color-accent-secondary,var(--theme-color-accent,#edd7cf)))]";
var AddMoreImageSection = ({
  title,
  description,
  showUnderline = true,
  underlineAlign = "center",
  productImage,
  rating,
  ratingText,
  reviewsText,
  isTrustpilot = false,
  ctaText,
  ctaIcon,
  onCtaClick,
  subActionText,
  onSubActionClick,
  classes,
  className
}) => {
  return /* @__PURE__ */ React288.createElement("div", { className: cn(DEFAULT_ROOT_CLASS39, classes == null ? void 0 : classes.root, className) }, /* @__PURE__ */ React288.createElement("div", { className: cn(DEFAULT_OUTER_CLASS2, THEMED_OUTER_CLASS) }, /* @__PURE__ */ React288.createElement("div", { className: cn(DEFAULT_INNER_CLASS11, THEMED_INNER_CLASS2) }, /* @__PURE__ */ React288.createElement("div", { className: DEFAULT_IMAGE_WRAPPER_CLASS13 }, /* @__PURE__ */ React288.createElement("img", { src: productImage, alt: title, className: DEFAULT_IMAGE_CLASS24 })), /* @__PURE__ */ React288.createElement("div", { className: DEFAULT_CONTENT_CLASS20 }, /* @__PURE__ */ React288.createElement(
    SectionTitle,
    {
      title,
      underlineAlign,
      showUnderline,
      classes: {
        root: classes == null ? void 0 : classes.titleRoot,
        title: cn(TITLE_CLASS, classes == null ? void 0 : classes.title),
        underline: cn(THEMED_UNDERLINE_CLASS2, classes == null ? void 0 : classes.separator)
      },
      className: "mb-[16px]"
    }
  ), description && /* @__PURE__ */ React288.createElement(
    "p",
    {
      className: cn(
        DEFAULT_DESCRIPTION_CLASS23,
        THEMED_DESCRIPTION_CLASS,
        classes == null ? void 0 : classes.description,
        "mb-[8px]"
      )
    },
    description
  ), /* @__PURE__ */ React288.createElement(
    SocialProofPill,
    {
      rating,
      ratingText,
      reviewsText,
      isTrustpilot,
      classes: {
        root: cn(PILL_INLINE_CLASS, classes == null ? void 0 : classes.pillRoot),
        ratingText: classes == null ? void 0 : classes.pillRatingText,
        reviewsText: classes == null ? void 0 : classes.reviewsText
      },
      className: "mb-[8px]",
      showDivider: true
    }
  ), /* @__PURE__ */ React288.createElement(
    ActionButton,
    {
      text: ctaText,
      icon: ctaIcon,
      onAction: onCtaClick,
      subActionText,
      onSubAction: onSubActionClick,
      isIconAppended: true,
      classes: {
        root: cn("w-full", classes == null ? void 0 : classes.ctaRoot),
        button: cn("min-h-[58px]", classes == null ? void 0 : classes.ctaButton),
        subAction: classes == null ? void 0 : classes.ctaSubAction
      }
    }
  )))));
};

// src/molecules/TemplatePriceLine.tsx
import React289 from "react";

// src/checkout/utils/templateVariables.ts
var TEMPLATE_VARIABLES = {
  variable1: "variable1",
  variable2: "variable2",
  variable3: "variable3"
};
var TEMPLATE_VARIABLE_PATTERN = new RegExp(`(${Object.keys(TEMPLATE_VARIABLES).join("|")})`, "g");
var parseTemplateVariables = (template) => {
  const parts = [];
  let lastIndex = 0;
  template.replace(TEMPLATE_VARIABLE_PATTERN, (match, _group, offset) => {
    if (offset > lastIndex) {
      parts.push({
        type: "text",
        value: template.slice(lastIndex, offset)
      });
    }
    parts.push({
      type: "variable",
      value: match
    });
    lastIndex = offset + match.length;
    return match;
  });
  if (lastIndex < template.length) {
    parts.push({
      type: "text",
      value: template.slice(lastIndex)
    });
  }
  return parts;
};

// src/molecules/TemplatePriceLine.tsx
var DEFAULT_ROOT_CLASS40 = " font-medium text-[18px] leading-[24px] md:text-[20px] md:leading-[28px]";
var DEFAULT_HIGHLIGHT_CLASS2 = "font-bold";
var THEMED_ROOT_CLASS5 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_HIGHLIGHT_CLASS = "text-[var(--theme-color-success,#16a34a)]";
var TemplatePriceLine = ({
  template,
  formattedPrice,
  classes,
  className
}) => /* @__PURE__ */ React289.createElement("p", { className: cn(DEFAULT_ROOT_CLASS40, THEMED_ROOT_CLASS5, classes == null ? void 0 : classes.root, className) }, parseTemplateVariables(template).map(
  (part, i) => part.type === "variable" ? /* @__PURE__ */ React289.createElement(
    "span",
    {
      key: i,
      className: cn(DEFAULT_HIGHLIGHT_CLASS2, THEMED_HIGHLIGHT_CLASS, classes == null ? void 0 : classes.highlight)
    },
    formattedPrice != null ? formattedPrice : part.value
  ) : /* @__PURE__ */ React289.createElement(React289.Fragment, { key: i }, part.value)
));

// src/molecules/AddMoreFeatureList.tsx
import React290 from "react";
var DEFAULT_LIST_CLASS11 = "flex flex-col gap-[8px]";
var DEFAULT_ITEM_CLASS16 = "flex items-center gap-[10px]";
var DEFAULT_ICON_CLASS32 = "size-[18px] shrink-0";
var DEFAULT_TEXT_CLASS18 = "text-[16px] leading-[24px]";
var THEMED_ICON_CLASS2 = "text-[var(--theme-color-success,#16a34a)]";
var THEMED_TEXT_CLASS2 = "text-[var(--theme-color-text-primary,#111827)]";
var AddMoreFeatureList = ({
  features,
  classes,
  className
}) => /* @__PURE__ */ React290.createElement("ul", { className: cn(DEFAULT_LIST_CLASS11, classes == null ? void 0 : classes.list, className) }, features.map((feature, i) => /* @__PURE__ */ React290.createElement("li", { key: i, className: cn(DEFAULT_ITEM_CLASS16, classes == null ? void 0 : classes.item) }, /* @__PURE__ */ React290.createElement(IconCheckmark, { className: cn(DEFAULT_ICON_CLASS32, THEMED_ICON_CLASS2, classes == null ? void 0 : classes.icon) }), /* @__PURE__ */ React290.createElement("span", { className: cn(DEFAULT_TEXT_CLASS18, THEMED_TEXT_CLASS2, classes == null ? void 0 : classes.text) }, feature.label))));

// src/sections/AddMoreImageSectionV2.tsx
import React291 from "react";
var DEFAULT_ROOT_CLASS41 = "w-full bg-cover bg-center bg-no-repeat py-[16px] md:py-[32px] lg:py-[93px]";
var DEFAULT_INNER_CLASS12 = "mx-auto flex max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))] flex-col items-center gap-[16px] px-[16px] lg:flex-row lg:items-center lg:gap-[80px] lg:px-[24px]";
var DEFAULT_CONTENT_CLASS21 = "w-full max-w-[600px] flex flex-col gap-[0px] lg:max-w-none lg:flex-1 lg:order-first";
var DEFAULT_IMAGE_WRAPPER_CLASS14 = "w-full max-w-[600px] shrink-0 lg:order-last lg:max-w-[420px] lg:w-[420px]";
var DEFAULT_IMAGE_CLASS25 = "w-full rounded-[12px] object-cover lg:hidden";
var DEFAULT_IMAGE_SQUARE_CLASS = "hidden w-full rounded-[12px] object-cover lg:block lg:aspect-square";
var DEFAULT_TITLE_CLASS23 = "text-[24px] font-extrabold leading-[30px] md:text-[30px] md:leading-[38px]";
var DEFAULT_DESCRIPTION_CLASS24 = "mt-[12px] text-[18px] font-medium leading-[24px] md:text-[20px] md:leading-[26px] lg:mt-[20px]";
var DEFAULT_FEATURE_LIST_CLASS = "mt-[16px]";
var DEFAULT_PRICE_LINE_CLASS = "mt-[16px]";
var THEMED_ROOT_CLASS6 = "bg-[var(--theme-color-bg-raised,#f9fafb)]";
var THEMED_DESCRIPTION_CLASS2 = "text-[var(--theme-color-heading-primary,#111827)]";
var AddMoreImageSectionV2 = ({
  title,
  description,
  showUnderline = false,
  features,
  priceLine,
  formattedPrice,
  productImage,
  productImageWide,
  productImageAlt,
  ctaText,
  ctaIcon,
  onCtaClick,
  subActionText,
  onSubActionClick,
  backgroundImage,
  classes,
  className
}) => {
  const wideImage = productImageWide != null ? productImageWide : productImage;
  return /* @__PURE__ */ React291.createElement(
    "div",
    {
      className: cn(DEFAULT_ROOT_CLASS41, THEMED_ROOT_CLASS6, classes == null ? void 0 : classes.root, className),
      style: backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : void 0
    },
    /* @__PURE__ */ React291.createElement("div", { className: cn(DEFAULT_INNER_CLASS12, classes == null ? void 0 : classes.inner) }, /* @__PURE__ */ React291.createElement(
      SectionTitle,
      {
        title,
        showUnderline,
        classes: {
          title: cn(DEFAULT_TITLE_CLASS23, "text-center", classes == null ? void 0 : classes.title),
          underline: classes == null ? void 0 : classes.separator
        },
        className: "w-full max-w-[600px] lg:hidden"
      }
    ), /* @__PURE__ */ React291.createElement("div", { className: cn(DEFAULT_IMAGE_WRAPPER_CLASS14, classes == null ? void 0 : classes.imageWrapper) }, /* @__PURE__ */ React291.createElement(
      "img",
      {
        src: wideImage,
        alt: productImageAlt != null ? productImageAlt : title,
        className: cn(DEFAULT_IMAGE_CLASS25, classes == null ? void 0 : classes.image)
      }
    ), /* @__PURE__ */ React291.createElement(
      "img",
      {
        src: productImage,
        alt: productImageAlt != null ? productImageAlt : title,
        className: cn(DEFAULT_IMAGE_SQUARE_CLASS, classes == null ? void 0 : classes.image)
      }
    )), /* @__PURE__ */ React291.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS21, classes == null ? void 0 : classes.content) }, /* @__PURE__ */ React291.createElement(
      SectionTitle,
      {
        title,
        showUnderline,
        classes: {
          title: cn(DEFAULT_TITLE_CLASS23, classes == null ? void 0 : classes.title),
          underline: classes == null ? void 0 : classes.separator
        },
        className: "hidden lg:block"
      }
    ), description && /* @__PURE__ */ React291.createElement(
      "p",
      {
        className: cn(
          DEFAULT_DESCRIPTION_CLASS24,
          THEMED_DESCRIPTION_CLASS2,
          classes == null ? void 0 : classes.description
        )
      },
      description
    ), features && features.length > 0 && /* @__PURE__ */ React291.createElement(
      AddMoreFeatureList,
      {
        features,
        classes: classes == null ? void 0 : classes.featureList,
        className: DEFAULT_FEATURE_LIST_CLASS
      }
    ), priceLine && /* @__PURE__ */ React291.createElement(
      TemplatePriceLine,
      {
        template: priceLine,
        formattedPrice,
        classes: classes == null ? void 0 : classes.priceLine,
        className: DEFAULT_PRICE_LINE_CLASS
      }
    ), /* @__PURE__ */ React291.createElement(
      ActionButton,
      {
        text: ctaText,
        icon: ctaIcon,
        onAction: onCtaClick,
        subActionText,
        onSubAction: onSubActionClick,
        isIconAppended: true,
        classes: {
          root: cn("mt-[20px] w-full", classes == null ? void 0 : classes.ctaRoot),
          button: cn("min-h-[56px]", classes == null ? void 0 : classes.ctaButton),
          subAction: classes == null ? void 0 : classes.ctaSubAction
        }
      }
    )))
  );
};

// src/sections/AddMoreTimerSection.tsx
import React292 from "react";
var DEFAULT_ROOT_CLASS42 = "flex flex-col items-center gap-4 p-4 text-center md:gap-6 md:p-8";
var DEFAULT_CONTENT_CLASS22 = "flex w-full flex-col gap-3 md:gap-4";
var DEFAULT_SOCIAL_ROW_CLASS = "flex flex-col gap-3 md:flex-row md:items-stretch md:gap-4";
var DEFAULT_BADGE_CLASS2 = "flex md:flex-1 items-center justify-center gap-2 rounded-xl border px-3 py-2 text-sm font-medium";
var DEFAULT_TIMER_VALUE_CLASS = "rounded-lg px-2 py-0.5 font-bold tabular-nums";
var DEFAULT_DESCRIPTION_CLASS25 = "text-sm opacity-80";
var THEMED_ROOT_CLASS7 = "bg-[var(--theme-color-button-primary,#666666)] text-[var(--theme-color-text-inverse,#ffffff)]";
var THEMED_CTA_BUTTON_INVERT_CLASS = "[--theme-color-button-primary:var(--theme-color-text-inverse,#ffffff)] [--theme-color-button-hover:color-mix(in_srgb,var(--theme-color-text-inverse,#ffffff)_90%,transparent)]";
var THEMED_CTA_BUTTON_TEXT_CLASS = "text-[var(--theme-color-button-border,#333333)]";
var THEMED_CONTENT_CLASS = "max-w-[var(--theme-timer-content-width,576px)]";
var THEMED_BADGE_CLASS = "border-[var(--theme-color-timer-item-border,rgba(255,255,255,0.2))] bg-[var(--theme-color-button-hover,transparent)]";
var THEMED_BADGE_TEXT_CLASS = "text-[var(--theme-color-accent-secondary,#ffffff)]";
var THEMED_TIMER_VALUE_CLASS = "bg-[var(--theme-color-accent,#000000)] text-[var(--theme-color-text-inverse,#ffffff)]";
var THEMED_TITLE_CLASS2 = "text-[var(--theme-color-text-inverse,#ffffff)]";
var AddMoreTimerSection = ({
  title,
  description,
  showUnderline = false,
  underlineAlign = "center",
  rating,
  ratingText,
  isTrustpilot = false,
  timerLabel,
  formattedTime,
  ctaText,
  ctaIcon,
  onCtaClick,
  subActionText,
  onSubActionClick,
  classes,
  className
}) => {
  return /* @__PURE__ */ React292.createElement("div", { className: cn(DEFAULT_ROOT_CLASS42, THEMED_ROOT_CLASS7, classes == null ? void 0 : classes.root, className) }, /* @__PURE__ */ React292.createElement(
    SectionTitle,
    {
      title,
      underlineAlign,
      showUnderline,
      classes: { title: cn(THEMED_TITLE_CLASS2, classes == null ? void 0 : classes.title), underline: classes == null ? void 0 : classes.separator }
    }
  ), description && /* @__PURE__ */ React292.createElement("p", { className: cn(DEFAULT_DESCRIPTION_CLASS25, classes == null ? void 0 : classes.description) }, description), /* @__PURE__ */ React292.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS22, THEMED_CONTENT_CLASS) }, /* @__PURE__ */ React292.createElement("div", { className: DEFAULT_SOCIAL_ROW_CLASS }, /* @__PURE__ */ React292.createElement(
    SocialProofPill,
    {
      rating,
      ratingText,
      isTrustpilot,
      className: "md:flex-1 justify-center",
      classes: {
        root: classes == null ? void 0 : classes.pillRoot,
        ratingText: classes == null ? void 0 : classes.pillRatingText
      }
    }
  ), /* @__PURE__ */ React292.createElement("div", { className: cn(DEFAULT_BADGE_CLASS2, THEMED_BADGE_CLASS, classes == null ? void 0 : classes.badgeRoot) }, /* @__PURE__ */ React292.createElement("span", { className: cn(THEMED_BADGE_TEXT_CLASS, classes == null ? void 0 : classes.badgeText) }, timerLabel), formattedTime && /* @__PURE__ */ React292.createElement(
    "span",
    {
      className: cn(
        DEFAULT_TIMER_VALUE_CLASS,
        THEMED_TIMER_VALUE_CLASS,
        classes == null ? void 0 : classes.timerValue
      )
    },
    formattedTime
  ))), /* @__PURE__ */ React292.createElement(
    ActionButton,
    {
      text: ctaText,
      icon: ctaIcon,
      onAction: onCtaClick,
      subActionText,
      onSubAction: onSubActionClick,
      isIconAppended: true,
      classes: {
        root: cn(THEMED_CTA_BUTTON_INVERT_CLASS, classes == null ? void 0 : classes.ctaRoot),
        button: cn(THEMED_CTA_BUTTON_TEXT_CLASS, classes == null ? void 0 : classes.ctaButton),
        subAction: classes == null ? void 0 : classes.ctaSubAction
      }
    }
  )));
};

// src/sections/AddMoreInlineSection.tsx
import React293 from "react";
var DEFAULT_ROOT_CLASS43 = "w-full";
var DEFAULT_INNER_CLASS13 = "mx-auto flex flex-col gap-4 py-4 md:flex-row md:items-center md:gap-6 px-4 md:px-6";
var DEFAULT_LEFT_CLASS2 = "flex flex-col gap-3 md:flex-1 md:min-w-0 lg:flex-row lg:items-center lg:gap-6";
var DEFAULT_STOCK_CLASS = "flex flex-col gap-1.5 lg:flex-1 lg:min-w-0";
var DEFAULT_STOCK_LABEL_CLASS2 = "text-sm font-medium";
var THEMED_ROOT_CLASS8 = "bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_INNER_CLASS3 = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var AddMoreInlineSection = ({
  rating,
  ratingText,
  reviewsText,
  isTrustpilot = false,
  ctaText,
  ctaIcon,
  onCtaClick,
  subActionText,
  onSubActionClick,
  stockLabel,
  fillPercent,
  classes,
  className
}) => {
  return /* @__PURE__ */ React293.createElement("div", { className: cn(DEFAULT_ROOT_CLASS43, THEMED_ROOT_CLASS8, classes == null ? void 0 : classes.root, className) }, /* @__PURE__ */ React293.createElement("div", { className: cn(DEFAULT_INNER_CLASS13, THEMED_INNER_CLASS3) }, /* @__PURE__ */ React293.createElement("div", { className: DEFAULT_LEFT_CLASS2 }, /* @__PURE__ */ React293.createElement(
    SocialProofPill,
    {
      rating,
      ratingText,
      reviewsText,
      isTrustpilot,
      classes: {
        root: classes == null ? void 0 : classes.pillRoot,
        ratingText: classes == null ? void 0 : classes.pillRatingText,
        reviewsText: classes == null ? void 0 : classes.pillReviewsText
      },
      className: "shrink-0"
    }
  ), /* @__PURE__ */ React293.createElement("div", { className: DEFAULT_STOCK_CLASS }, /* @__PURE__ */ React293.createElement("span", { className: cn(DEFAULT_STOCK_LABEL_CLASS2, classes == null ? void 0 : classes.stockLabel) }, stockLabel), /* @__PURE__ */ React293.createElement(StockProgressBar, { fillPercent }))), /* @__PURE__ */ React293.createElement(
    ActionButton,
    {
      text: ctaText,
      icon: ctaIcon,
      onAction: onCtaClick,
      subActionText,
      onSubAction: onSubActionClick,
      classes: {
        root: cn("shrink-0 md:w-auto md:min-w-60", classes == null ? void 0 : classes.ctaRoot),
        button: classes == null ? void 0 : classes.ctaButton,
        subAction: classes == null ? void 0 : classes.ctaSubAction
      },
      isIconAppended: true
    }
  )));
};

// src/sections/FeatureListSection.tsx
import React296 from "react";

// src/molecules/FeatureList.tsx
import React295 from "react";

// src/molecules/FeatureListItem.tsx
import React294 from "react";
var DEFAULT_ITEM_CLASS17 = "flex items-start gap-[12px]";
var DEFAULT_TEXT_CLASS19 = "text-[16px] leading-[24px]";
var THEMED_ICON_CLASS3 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_LABEL_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_TEXT_CLASS3 = "text-[var(--theme-color-text-secondary,#4b5563)]";
var FeatureListItem = ({
  label,
  description,
  classes
}) => /* @__PURE__ */ React294.createElement("li", { className: cn(DEFAULT_ITEM_CLASS17, classes == null ? void 0 : classes.item) }, /* @__PURE__ */ React294.createElement(IconCheckCircle, { className: cn(THEMED_ICON_CLASS3, classes == null ? void 0 : classes.icon) }), /* @__PURE__ */ React294.createElement("span", { className: cn(DEFAULT_TEXT_CLASS19, THEMED_TEXT_CLASS3, classes == null ? void 0 : classes.text) }, label && /* @__PURE__ */ React294.createElement("strong", { className: cn(THEMED_LABEL_CLASS, classes == null ? void 0 : classes.label) }, label, description ? ": " : ""), description));

// src/molecules/FeatureList.tsx
var DEFAULT_LIST_CLASS12 = "flex flex-1 flex-col gap-[24px]";
var FeatureList = ({ features, classes, className }) => /* @__PURE__ */ React295.createElement("ul", { className: cn(DEFAULT_LIST_CLASS12, classes == null ? void 0 : classes.list, className) }, features.map((feature, index) => /* @__PURE__ */ React295.createElement(
  FeatureListItem,
  {
    key: index,
    label: feature.label,
    description: feature.description,
    classes
  }
)));

// src/sections/FeatureListSection.tsx
var DEFAULT_ROOT_CLASS44 = "w-full pt-[24px] pb-[24px] md:py-[56px]";
var DEFAULT_INNER_CLASS14 = "mx-auto px-[16px] md:px-[24px]";
var DEFAULT_BODY_CLASS8 = "flex flex-col md:flex-row md:items-center lg:items-start gap-[24px]";
var DEFAULT_IMAGE_CLASS26 = "w-full md:w-2/5 md:max-w-[330px] shrink-0 rounded-[12px] object-cover";
var TITLE_CLASS2 = "text-[24px] leading-[32px] font-bold lg:text-[32px] lg:leading-[40px] text-center";
var THEMED_ROOT_CLASS9 = "bg-[var(--theme-color-bg-section,transparent)]";
var THEMED_INNER_CLASS4 = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var THEMED_UNDERLINE_CLASS3 = "bg-[var(--theme-color-border-light,#edd7cf)]";
var FeatureListSection = ({
  title,
  showUnderline = true,
  underlineAlign = "center",
  productImage,
  features,
  ctaText,
  ctaIcon,
  onCtaClick,
  subActionText,
  onSubActionClick,
  classes,
  className
}) => /* @__PURE__ */ React296.createElement("div", { className: cn(DEFAULT_ROOT_CLASS44, THEMED_ROOT_CLASS9, classes == null ? void 0 : classes.root, className) }, /* @__PURE__ */ React296.createElement("div", { className: cn(DEFAULT_INNER_CLASS14, THEMED_INNER_CLASS4, classes == null ? void 0 : classes.inner) }, /* @__PURE__ */ React296.createElement(
  SectionTitle,
  {
    title,
    underlineAlign,
    showUnderline,
    classes: {
      root: classes == null ? void 0 : classes.titleRoot,
      title: cn(TITLE_CLASS2, classes == null ? void 0 : classes.title),
      underline: cn(THEMED_UNDERLINE_CLASS3, classes == null ? void 0 : classes.separator)
    },
    className: "mb-[40px] md:mb-[56px]"
  }
), /* @__PURE__ */ React296.createElement("div", { className: DEFAULT_BODY_CLASS8 }, /* @__PURE__ */ React296.createElement("img", { src: productImage, alt: title, className: DEFAULT_IMAGE_CLASS26 }), /* @__PURE__ */ React296.createElement(FeatureList, { features, classes: classes == null ? void 0 : classes.featureList })), /* @__PURE__ */ React296.createElement(
  ActionButton,
  {
    text: ctaText,
    icon: ctaIcon,
    onAction: onCtaClick,
    subActionText,
    onSubAction: onSubActionClick,
    isIconAppended: true,
    classes: {
      root: cn("w-full max-w-[420px] mx-auto mt-[24px] md:mt-[32px]", classes == null ? void 0 : classes.ctaRoot),
      button: cn("min-h-[58px]", classes == null ? void 0 : classes.ctaButton),
      subAction: classes == null ? void 0 : classes.ctaSubAction
    }
  }
)));

// src/molecules/FeatureImageCard.tsx
import React297 from "react";
var DEFAULT_CARD_CLASS11 = "flex flex-col";
var DEFAULT_IMAGE_CLASS27 = "w-full rounded-[12px] object-cover mb-[24px] aspect-square";
var DEFAULT_TITLE_CLASS24 = "text-[20px] leading-[24px] font-semibold md:text-[18px] md:font-bold text-center mb-[8px]";
var DEFAULT_DESCRIPTION_CLASS26 = "text-[16px] leading-[24px] md:text-[14px] md:leading-[20px] text-center lg:text-[16px] lg:leading-[24px]";
var THEMED_TITLE_CLASS3 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DESCRIPTION_CLASS3 = "text-[var(--theme-color-text-secondary,#4b5563)]";
var FeatureImageCard = ({
  image,
  title,
  description,
  classes
}) => /* @__PURE__ */ React297.createElement("div", { className: cn(DEFAULT_CARD_CLASS11, classes == null ? void 0 : classes.card) }, /* @__PURE__ */ React297.createElement("img", { src: image, alt: title, className: cn(DEFAULT_IMAGE_CLASS27, classes == null ? void 0 : classes.image) }), /* @__PURE__ */ React297.createElement("p", { className: cn(DEFAULT_TITLE_CLASS24, THEMED_TITLE_CLASS3, classes == null ? void 0 : classes.title) }, title), description && /* @__PURE__ */ React297.createElement("p", { className: cn(DEFAULT_DESCRIPTION_CLASS26, THEMED_DESCRIPTION_CLASS3, classes == null ? void 0 : classes.description) }, description));

// src/molecules/FeatureImageCardList.tsx
import React298 from "react";
var DEFAULT_GRID_CLASS6 = "grid grid-cols-1 gap-[24px] md:grid-cols-3";
var FeatureImageCardList = ({
  items,
  classes,
  className
}) => /* @__PURE__ */ React298.createElement("div", { className: cn(DEFAULT_GRID_CLASS6, classes == null ? void 0 : classes.grid, className) }, items.map((item, index) => /* @__PURE__ */ React298.createElement(
  FeatureImageCard,
  {
    key: index,
    image: item.image,
    title: item.title,
    description: item.description,
    classes: classes == null ? void 0 : classes.card
  }
)));

// src/sections/FeatureImageCards.tsx
import React299 from "react";
var DEFAULT_ROOT_CLASS45 = "w-full pt-[24px] pb-[24px] md:py-[56px]";
var DEFAULT_INNER_CLASS15 = "mx-auto px-[16px] md:px-[24px]";
var TITLE_CLASS3 = "text-[24px] leading-[32px] font-bold lg:text-[32px] lg:leading-[40px] text-center";
var THEMED_ROOT_CLASS10 = "bg-[var(--theme-color-bg-section,transparent)]";
var THEMED_INNER_CLASS5 = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var THEMED_UNDERLINE_CLASS4 = "bg-[var(--theme-color-border-light,#edd7cf)]";
var FeatureImageCards = ({
  title,
  showUnderline = true,
  underlineAlign = "center",
  items,
  classes,
  className
}) => /* @__PURE__ */ React299.createElement("div", { className: cn(DEFAULT_ROOT_CLASS45, THEMED_ROOT_CLASS10, classes == null ? void 0 : classes.root, className) }, /* @__PURE__ */ React299.createElement("div", { className: cn(DEFAULT_INNER_CLASS15, THEMED_INNER_CLASS5, classes == null ? void 0 : classes.inner) }, /* @__PURE__ */ React299.createElement(
  SectionTitle,
  {
    title,
    underlineAlign,
    showUnderline,
    classes: {
      root: classes == null ? void 0 : classes.titleRoot,
      title: cn(TITLE_CLASS3, classes == null ? void 0 : classes.title),
      underline: cn(THEMED_UNDERLINE_CLASS4, classes == null ? void 0 : classes.separator)
    },
    className: "mb-[40px] md:mb-[56px]"
  }
), /* @__PURE__ */ React299.createElement(FeatureImageCardList, { items, classes: classes == null ? void 0 : classes.cardList })));

// src/molecules/BenefitsCard.tsx
import React300 from "react";
var DEFAULT_CARD_CLASS12 = "flex flex-col rounded-[12px] border p-[24px]";
var DEFAULT_TITLE_CLASS25 = "text-[18px] leading-[24px] font-bold mb-[16px]";
var DEFAULT_ITEM_CLASS18 = "flex items-center gap-[12px] py-[12px]";
var DEFAULT_ITEM_TEXT_CLASS4 = "text-[14px] leading-[20px] lg:text-[16px] lg:leading-[24px]";
var THEMED_CARD_CLASS = "border-[var(--theme-color-border-light,#e5e7eb)] bg-[var(--theme-color-bg-page,#ffffff)]";
var DEFAULT_CONTRAST_BORDER_CLASS = "border-4";
var THEMED_CONTRAST_BORDER_CLASS = "border-[var(--theme-color-heading-primary,#059669)]";
var THEMED_TITLE_CLASS4 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_ITEM_TEXT_CLASS = "text-[var(--theme-color-text-secondary,#374151)]";
var THEMED_CHECK_ICON_CLASS = "text-[var(--theme-color-success,#059669)]";
var THEMED_CROSS_ICON_CLASS = "text-[var(--theme-color-error,#ef4444)]";
var BenefitsCard = ({
  title,
  items,
  contrastBorder,
  classes
}) => /* @__PURE__ */ React300.createElement(
  "div",
  {
    className: cn(
      DEFAULT_CARD_CLASS12,
      THEMED_CARD_CLASS,
      classes == null ? void 0 : classes.card,
      contrastBorder && cn(DEFAULT_CONTRAST_BORDER_CLASS, THEMED_CONTRAST_BORDER_CLASS, classes == null ? void 0 : classes.contrastCard)
    )
  },
  /* @__PURE__ */ React300.createElement("p", { className: cn(DEFAULT_TITLE_CLASS25, THEMED_TITLE_CLASS4, classes == null ? void 0 : classes.title) }, title),
  items.map((item, index) => /* @__PURE__ */ React300.createElement("div", { key: index, className: cn(DEFAULT_ITEM_CLASS18, classes == null ? void 0 : classes.item) }, item.positive ? /* @__PURE__ */ React300.createElement(IconCheckmark, { className: cn(THEMED_CHECK_ICON_CLASS, classes == null ? void 0 : classes.checkIcon) }) : /* @__PURE__ */ React300.createElement(IconXMark, { className: cn(THEMED_CROSS_ICON_CLASS, classes == null ? void 0 : classes.crossIcon) }), /* @__PURE__ */ React300.createElement("span", { className: cn(DEFAULT_ITEM_TEXT_CLASS4, THEMED_ITEM_TEXT_CLASS, classes == null ? void 0 : classes.itemText) }, item.text)))
);

// src/molecules/BenefitsCardList.tsx
import React301 from "react";
var DEFAULT_GRID_CLASS7 = "grid grid-cols-1 gap-[16px] md:grid-cols-2 md:gap-[24px]";
var BenefitsCardList = ({
  columns,
  classes,
  className
}) => /* @__PURE__ */ React301.createElement("div", { className: cn(DEFAULT_GRID_CLASS7, classes == null ? void 0 : classes.grid, className) }, columns.map((col, index) => {
  var _a, _b;
  return /* @__PURE__ */ React301.createElement(
    BenefitsCard,
    {
      key: index,
      title: (_a = col.title) != null ? _a : "",
      items: col.items,
      contrastBorder: col.contrastBorder,
      classes: {
        ...classes == null ? void 0 : classes.card,
        card: cn((_b = classes == null ? void 0 : classes.card) == null ? void 0 : _b.card, col.featured ? classes == null ? void 0 : classes.featuredCard : void 0)
      }
    }
  );
}));

// src/sections/BenefitsCards.tsx
import React302 from "react";
var DEFAULT_ROOT_CLASS46 = "w-full pt-[24px] pb-[24px] md:py-[56px]";
var DEFAULT_INNER_CLASS16 = "mx-auto px-[16px] md:px-[24px]";
var TITLE_CLASS4 = "text-[24px] leading-[32px] font-bold lg:text-[32px] lg:leading-[40px] text-center";
var THEMED_ROOT_CLASS11 = "bg-[var(--theme-color-bg-section,transparent)]";
var THEMED_INNER_CLASS6 = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var THEMED_UNDERLINE_CLASS5 = "bg-[var(--theme-color-border-light,#edd7cf)]";
var BenefitsCards = ({
  title,
  showUnderline = true,
  underlineAlign = "center",
  columns,
  ctaText,
  ctaIcon,
  onCtaClick,
  subActionText,
  onSubActionClick,
  classes,
  className
}) => /* @__PURE__ */ React302.createElement("div", { className: cn(DEFAULT_ROOT_CLASS46, THEMED_ROOT_CLASS11, classes == null ? void 0 : classes.root, className) }, /* @__PURE__ */ React302.createElement("div", { className: cn(DEFAULT_INNER_CLASS16, THEMED_INNER_CLASS6, classes == null ? void 0 : classes.inner) }, title && /* @__PURE__ */ React302.createElement(
  SectionTitle,
  {
    title,
    underlineAlign,
    showUnderline,
    classes: {
      root: classes == null ? void 0 : classes.titleRoot,
      title: cn(TITLE_CLASS4, classes == null ? void 0 : classes.title),
      underline: cn(THEMED_UNDERLINE_CLASS5, classes == null ? void 0 : classes.separator)
    },
    className: "mb-[40px] md:mb-[56px]"
  }
), /* @__PURE__ */ React302.createElement(
  BenefitsCardList,
  {
    columns,
    classes: classes == null ? void 0 : classes.cardList,
    className: ctaText ? "mb-[32px] md:mb-[40px]" : void 0
  }
), ctaText && /* @__PURE__ */ React302.createElement(
  ActionButton,
  {
    text: ctaText,
    icon: ctaIcon,
    onAction: onCtaClick,
    subActionText,
    onSubAction: onSubActionClick,
    isIconAppended: true,
    classes: {
      root: cn("w-full max-w-[420px] mx-auto", classes == null ? void 0 : classes.ctaRoot),
      button: cn("min-h-[58px]", classes == null ? void 0 : classes.ctaButton),
      subAction: classes == null ? void 0 : classes.ctaSubAction
    }
  }
)));

// src/molecules/SpecialOfferCard.tsx
import React310 from "react";

// src/checkout/components/molecules/ProductItemVariant1Option.tsx
import React304 from "react";

// src/checkout/components/atoms/ProductItemVariant1Radio.tsx
import React303 from "react";
var DEFAULT_WRAPPER_CLASS9 = "hidden items-center pl-[16px] sm:flex lg:pl-[18px]";
var DEFAULT_RADIO_CLASS = "flex size-[18px] items-center justify-center rounded-full border";
var DEFAULT_RADIO_ACTIVE_CLASS = "border-2 before:block before:size-[8px] before:rounded-full";
var THEMED_RADIO_CLASS = "border-[var(--theme-color-border,#9CA3AF)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_RADIO_ACTIVE_CLASS = "border-[var(--theme-color-accent,#3B82F6)] before:bg-[var(--theme-color-accent,#3B82F6)]";
var ProductItemVariant1Radio = ({
  isActive = false,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React303.createElement("div", { className: cn(DEFAULT_WRAPPER_CLASS9, classes.wrapper) }, /* @__PURE__ */ React303.createElement(
    "span",
    {
      className: cn(
        DEFAULT_RADIO_CLASS,
        THEMED_RADIO_CLASS,
        isActive && DEFAULT_RADIO_ACTIVE_CLASS,
        isActive && THEMED_RADIO_ACTIVE_CLASS,
        classes.radio,
        isActive && classes.active,
        className
      )
    }
  ));
};

// src/checkout/components/molecules/ProductItemVariant1Option.tsx
var DEFAULT_ROOT_CLASS47 = "flex min-h-[112px] w-full items-stretch overflow-hidden rounded-[6px] border text-left transition-colors";
var DEFAULT_ROOT_RESPONSIVE_CLASS = "lg:min-h-[122px]";
var DEFAULT_WITH_VARIANTS_CLASS = "border-0";
var THEMED_ROOT_CLASS12 = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)]";
var DEFAULT_ACTIVE_CLASS = "ring-1 ring-inset";
var THEMED_ACTIVE_CLASS = "border-[var(--theme-color-accent,#3B82F6)] bg-[var(--theme-color-bg-tint,#EFF6FF)] ring-[var(--theme-color-accent,#3B82F6)]";
var THEMED_WITH_VARIANTS_ACTIVE_CLASS = "bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var ProductItemVariant1Option = ({
  productId,
  isActive = false,
  info,
  price,
  hasDropdown,
  onSelect,
  compact = false,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React304.createElement(
    "button",
    {
      type: "button",
      "data-product-id": productId != null ? productId : void 0,
      className: cn(
        DEFAULT_ROOT_CLASS47,
        THEMED_ROOT_CLASS12,
        !compact && DEFAULT_ROOT_RESPONSIVE_CLASS,
        hasDropdown && DEFAULT_WITH_VARIANTS_CLASS,
        isActive && !hasDropdown && DEFAULT_ACTIVE_CLASS,
        isActive && (hasDropdown ? THEMED_WITH_VARIANTS_ACTIVE_CLASS : THEMED_ACTIVE_CLASS),
        isActive && classes.active,
        classes.root,
        className
      ),
      onClick: onSelect,
      "aria-pressed": isActive
    },
    /* @__PURE__ */ React304.createElement(ProductItemVariant1Radio, { isActive, classes: classes.radio }),
    info,
    price
  );
};

// src/checkout/components/molecules/ProductItemVariant1Price.tsx
import React309 from "react";

// src/checkout/components/molecules/ProductItemVariant1Badges.tsx
import React306 from "react";

// src/checkout/components/atoms/ProductItemVariant1Badge.tsx
import React305 from "react";
var DEFAULT_BADGE_CLASS3 = "inline-flex h-[24px] items-center justify-center whitespace-nowrap rounded-[5px] px-[8px] text-[12px] font-black uppercase leading-[14px]";
var THEMED_VARIANT_CLASS_MAP = {
  bestSeller: "bg-[var(--theme-color-error,#DC2626)] text-white",
  bestValue: "bg-[var(--theme-color-warning,#D97706)] text-[var(--theme-color-text-primary,#000000)]"
};
var ProductItemVariant1Badge = ({
  label,
  variant,
  className
}) => {
  return /* @__PURE__ */ React305.createElement("span", { className: cn(DEFAULT_BADGE_CLASS3, THEMED_VARIANT_CLASS_MAP[variant], className) }, label);
};

// src/checkout/components/molecules/ProductItemVariant1Badges.tsx
var DEFAULT_BADGES_CLASS = "pointer-events-none absolute bottom-[8px] left-1/2 flex -translate-x-1/2 flex-col items-center gap-[6px]";
var ProductItemVariant1Badges = ({
  bestSellerLabel,
  bestValueLabel,
  className,
  badgeClassName
}) => {
  if (!bestSellerLabel && !bestValueLabel) return null;
  return /* @__PURE__ */ React306.createElement("div", { className: cn(DEFAULT_BADGES_CLASS, className) }, bestSellerLabel && /* @__PURE__ */ React306.createElement(
    ProductItemVariant1Badge,
    {
      label: bestSellerLabel,
      variant: "bestSeller",
      className: badgeClassName
    }
  ), bestValueLabel && /* @__PURE__ */ React306.createElement(
    ProductItemVariant1Badge,
    {
      label: bestValueLabel,
      variant: "bestValue",
      className: badgeClassName
    }
  ));
};

// src/checkout/components/molecules/ProductItemVariant1MainPrice.tsx
import React307 from "react";
var DEFAULT_ROOT_CLASS48 = "mt-[2px] flex items-start justify-center";
var DEFAULT_CENTS_STACK_CLASS = "ml-[2px] flex flex-col items-start pt-[1px]";
var DEFAULT_SYMBOL_CLASS = "pt-[5px] text-[14px] font-medium leading-[16px]";
var DEFAULT_SYMBOL_RESPONSIVE_CLASS = "lg:pt-[6px] lg:text-[16px] lg:leading-[18px]";
var DEFAULT_WHOLE_CLASS = "text-[24px] font-black leading-[22px]";
var DEFAULT_WHOLE_RESPONSIVE_CLASS = "lg:text-[28px] lg:leading-[26px]";
var DEFAULT_CENTS_CLASS = "text-[14px] font-black leading-[13px]";
var DEFAULT_CENTS_RESPONSIVE_CLASS = "lg:text-[16px] lg:leading-[15px]";
var DEFAULT_EACH_CLASS = "mt-[-1px] text-[10px] leading-[11px]";
var DEFAULT_EACH_RESPONSIVE_CLASS = "lg:text-[11px] lg:leading-[12px]";
var THEMED_ROOT_CLASS13 = "text-[var(--theme-color-text-primary,#000000)]";
var THEMED_EACH_CLASS = "text-[var(--theme-color-text-primary,#000000)]";
var ProductItemVariant1MainPrice = ({
  symbol,
  symbolLeft = true,
  wholeText,
  centsText,
  eachLabel,
  compact = false,
  className,
  classes = {}
}) => {
  const symbolClass = cn(
    DEFAULT_SYMBOL_CLASS,
    !compact && DEFAULT_SYMBOL_RESPONSIVE_CLASS,
    classes.symbol
  );
  const wholeClass = cn(
    DEFAULT_WHOLE_CLASS,
    !compact && DEFAULT_WHOLE_RESPONSIVE_CLASS,
    classes.whole
  );
  const centsClass = cn(
    DEFAULT_CENTS_CLASS,
    !compact && DEFAULT_CENTS_RESPONSIVE_CLASS,
    classes.cents
  );
  const eachClass = cn(
    DEFAULT_EACH_CLASS,
    THEMED_EACH_CLASS,
    !compact && DEFAULT_EACH_RESPONSIVE_CLASS,
    classes.each
  );
  return /* @__PURE__ */ React307.createElement("div", { className: cn(DEFAULT_ROOT_CLASS48, THEMED_ROOT_CLASS13, classes.root, className) }, symbolLeft && symbol && /* @__PURE__ */ React307.createElement("span", { className: symbolClass }, symbol), /* @__PURE__ */ React307.createElement("span", { className: wholeClass }, wholeText), /* @__PURE__ */ React307.createElement("span", { className: cn(DEFAULT_CENTS_STACK_CLASS, classes.centsStack) }, centsText && /* @__PURE__ */ React307.createElement("span", { className: centsClass }, centsText), /* @__PURE__ */ React307.createElement("span", { className: eachClass }, eachLabel)), !symbolLeft && symbol && /* @__PURE__ */ React307.createElement("span", { className: symbolClass }, symbol));
};

// src/checkout/components/atoms/ProductItemVariant1OldPrice.tsx
import React308 from "react";
var DEFAULT_OLD_PRICE_CLASS = "block text-[14px] leading-[17px] line-through decoration-[1px]";
var THEMED_TEXT_CLASS4 = "text-[var(--theme-color-text-light,#9CA3AF)]";
var ProductItemVariant1OldPrice = ({
  text,
  className
}) => {
  return /* @__PURE__ */ React308.createElement("span", { className: cn(DEFAULT_OLD_PRICE_CLASS, THEMED_TEXT_CLASS4, className) }, text);
};

// src/checkout/components/molecules/ProductItemVariant1Price.tsx
var DEFAULT_PRICE_CLASS2 = "relative my-[10px] flex min-w-[110px] shrink-0 flex-col items-center justify-center border-l px-[16px] text-center sm:min-w-[130px] sm:px-[18px] lg:my-[12px] lg:px-[26px]";
var DISCOUNT_COLUMN_PRICE_CLASS = "lg:border-l-0";
var BADGE_PRICE_CLASS = "pb-[30px] pt-[8px]";
var THEMED_PRICE_BORDER_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)]";
var ProductItemVariant1Price = ({
  oldPriceText,
  symbol,
  symbolLeft = true,
  wholeText,
  centsText,
  eachLabel,
  bestSellerLabel,
  bestValueLabel,
  hasDiscountColumn = false,
  compact = false,
  className,
  classes = {}
}) => {
  const hasBadge = Boolean(bestSellerLabel || bestValueLabel);
  return /* @__PURE__ */ React309.createElement(
    "div",
    {
      className: cn(
        DEFAULT_PRICE_CLASS2,
        THEMED_PRICE_BORDER_CLASS,
        hasDiscountColumn && DISCOUNT_COLUMN_PRICE_CLASS,
        hasBadge && BADGE_PRICE_CLASS,
        classes.root,
        className
      )
    },
    oldPriceText && /* @__PURE__ */ React309.createElement(ProductItemVariant1OldPrice, { text: oldPriceText, className: classes.oldPrice }),
    /* @__PURE__ */ React309.createElement(
      ProductItemVariant1MainPrice,
      {
        symbol,
        symbolLeft,
        wholeText,
        centsText,
        eachLabel,
        compact,
        classes: classes.mainPrice
      }
    ),
    /* @__PURE__ */ React309.createElement(
      ProductItemVariant1Badges,
      {
        bestSellerLabel,
        bestValueLabel,
        className: classes.badges,
        badgeClassName: classes.badge
      }
    )
  );
};

// src/molecules/SpecialOfferCard.tsx
var DEFAULT_INFO_CLASS = "flex flex-1 h-full items-center gap-[4px] p-[10px] pr-0";
var DEFAULT_IMAGE_CLASS28 = "h-full aspect-square shrink-0 object-cover rounded-md max-h-[92px]";
var DEFAULT_QUANTITY_CLASS = "flex-1 text-center text-[18px] font-extrabold leading-tight text-(--theme-color-text-primary)";
var SpecialOfferCard = ({
  image,
  imageAlt,
  quantity,
  oldPriceText,
  symbol,
  symbolLeft,
  wholePriceText,
  centsPriceText,
  eachLabel = "",
  badge,
  isSelected = false,
  onClick,
  classes,
  className
}) => {
  const info = /* @__PURE__ */ React310.createElement("div", { className: DEFAULT_INFO_CLASS }, image && /* @__PURE__ */ React310.createElement("img", { src: image, alt: imageAlt != null ? imageAlt : quantity, className: DEFAULT_IMAGE_CLASS28 }), /* @__PURE__ */ React310.createElement("span", { className: cn(DEFAULT_QUANTITY_CLASS, classes == null ? void 0 : classes.quantity) }, quantity));
  const price = /* @__PURE__ */ React310.createElement(
    ProductItemVariant1Price,
    {
      oldPriceText,
      symbol,
      symbolLeft,
      wholeText: wholePriceText,
      centsText: centsPriceText,
      eachLabel,
      bestValueLabel: badge,
      classes: classes == null ? void 0 : classes.price,
      compact: true
    }
  );
  return /* @__PURE__ */ React310.createElement(
    ProductItemVariant1Option,
    {
      isActive: isSelected,
      hasDropdown: false,
      onSelect: onClick != null ? onClick : (() => {
      }),
      info,
      price,
      compact: true,
      className,
      classes: {
        root: cn("rounded-[12px]", classes == null ? void 0 : classes.card),
        active: classes == null ? void 0 : classes.cardSelected,
        radio: { wrapper: "hidden sm:hidden" }
      }
    }
  );
};

// src/molecules/SpecialOfferCardList.tsx
import React311 from "react";
var DEFAULT_LIST_CLASS13 = "grid grid-cols-[repeat(auto-fill,minmax(min(275px,100%),1fr))] gap-[8px]";
var SpecialOfferCardList = ({
  options,
  selectedIndex = 0,
  onSelectOption,
  classes,
  className
}) => /* @__PURE__ */ React311.createElement("div", { role: "radiogroup", className: cn(DEFAULT_LIST_CLASS13, classes == null ? void 0 : classes.list, className) }, options.map((option, i) => {
  if (!option) return null;
  return /* @__PURE__ */ React311.createElement(
    SpecialOfferCard,
    {
      key: option.id,
      ...option,
      isSelected: i === selectedIndex,
      onClick: () => onSelectOption == null ? void 0 : onSelectOption(i),
      classes: classes == null ? void 0 : classes.card
    }
  );
}));

// src/organisms/SpecialOfferModal.tsx
import React323 from "react";

// src/checkout/components/organisms/FullscreenModal.tsx
import React312 from "react";
import { createPortal } from "react-dom";
var ANIMATION_DURATION_MS = 260;
var DEFAULT_OVERLAY_CLASS3 = "fixed inset-0 z-50 bg-black/45 transition-opacity duration-300 ease-out";
var DEFAULT_LAYOUT_CLASS3 = "fixed inset-0 z-50 overflow-y-auto";
var DEFAULT_PANEL_CLASS2 = "min-h-screen w-full transition-opacity duration-300 ease-out";
function useModalVisibility(isOpen, animationDurationMs) {
  const [isMounted, setIsMounted] = React312.useState(isOpen);
  const [isVisible, setIsVisible] = React312.useState(isOpen);
  React312.useEffect(() => {
    let frameId;
    let timeoutId;
    if (isOpen) {
      setIsMounted(true);
      frameId = window.requestAnimationFrame(() => setIsVisible(true));
    } else {
      setIsVisible(false);
      timeoutId = window.setTimeout(() => setIsMounted(false), animationDurationMs);
    }
    return () => {
      if (frameId !== void 0) window.cancelAnimationFrame(frameId);
      if (timeoutId !== void 0) window.clearTimeout(timeoutId);
    };
  }, [isOpen, animationDurationMs]);
  return { isMounted, isVisible };
}
function useScrollLock(active, onEscape) {
  React312.useEffect(() => {
    if (!active) return;
    const { body, documentElement } = document;
    const prevOverflow = body.style.overflow;
    const prevPaddingRight = body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
    body.style.overflow = "hidden";
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onEscape();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      body.style.overflow = prevOverflow;
      body.style.paddingRight = prevPaddingRight;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [active, onEscape]);
}
var FullscreenModal = ({
  isOpen,
  onClose,
  children,
  labelledBy,
  animationDurationMs = ANIMATION_DURATION_MS,
  className,
  classes = {}
}) => {
  const { isMounted, isVisible } = useModalVisibility(isOpen, animationDurationMs);
  useScrollLock(isMounted, onClose);
  if (!isMounted) return null;
  return createPortal(
    /* @__PURE__ */ React312.createElement(React312.Fragment, null, /* @__PURE__ */ React312.createElement(
      "button",
      {
        type: "button",
        "aria-label": "Close modal",
        onClick: onClose,
        className: cn(
          DEFAULT_OVERLAY_CLASS3,
          isVisible ? "opacity-100" : "opacity-0",
          classes.overlay
        )
      }
    ), /* @__PURE__ */ React312.createElement(
      "div",
      {
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": labelledBy,
        className: cn(DEFAULT_LAYOUT_CLASS3, classes.layout)
      },
      /* @__PURE__ */ React312.createElement(
        "div",
        {
          className: cn(
            DEFAULT_PANEL_CLASS2,
            isVisible ? "opacity-100" : "opacity-0",
            classes.panel,
            className
          ),
          onClick: onClose
        },
        children
      )
    )),
    document.body
  );
};

// src/checkout/components/elements/ElementBar.tsx
import React322 from "react";

// src/checkout/components/elements/bar/ElementBarCheckoutTimer.tsx
import React315 from "react";

// src/checkout/constants/storageKeys.ts
var STORAGE_KEYS = {
  CHECKOUT_TIMER: "checkout_timer",
  SHIPPING_TIMER: "shipping_timer"
};

// src/checkout/components/elements/bar/ElementBarTimer.tsx
import React314 from "react";

// src/checkout/components/molecules/TimerNotice.tsx
import React313 from "react";
var DEFAULT_VALUE_CLASS = "font-bold text-current";
var TimerNotice = ({
  endAt,
  icon,
  labelTemplate,
  onEnd,
  centered,
  className,
  classes = {}
}) => {
  const labelParts = parseTemplateVariables(labelTemplate);
  return /* @__PURE__ */ React313.createElement(
    BarNotice,
    {
      icon,
      centered,
      className,
      classes: { root: classes.root, content: classes.content }
    },
    /* @__PURE__ */ React313.createElement(React313.Fragment, null, labelParts.map(
      (part, index) => part.type === "text" ? /* @__PURE__ */ React313.createElement(React313.Fragment, { key: `text-${index}` }, part.value) : /* @__PURE__ */ React313.createElement(
        CountdownText,
        {
          key: `variable-${part.value}-${index}`,
          endAt,
          onEnd,
          className: cn(DEFAULT_VALUE_CLASS, classes.value)
        }
      )
    ))
  );
};

// src/checkout/hooks/usePersistentTimer.ts
import { useCallback as useCallback4, useEffect as useEffect29, useState as useState35 } from "react";
var TIMER_COOLDOWN_HOURS = 24;
var readStoredTimer = (key) => {
  try {
    const storedTimer = window.localStorage.getItem(key);
    if (!storedTimer) {
      return null;
    }
    return JSON.parse(storedTimer);
  } catch (e) {
    try {
      window.localStorage.removeItem(key);
    } catch (e2) {
    }
    return null;
  }
};
var writeStoredTimer = (key, timer) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(timer));
  } catch (e) {
  }
};
var usePersistentTimer = ({
  enabled,
  storageKey,
  durationMinutes
}) => {
  const [timer, setTimer] = useState35(null);
  const [shouldShowTimer, setShouldShowTimer] = useState35(enabled);
  useEffect29(() => {
    if (!enabled) {
      setTimer(null);
      setShouldShowTimer(false);
      return;
    }
    const now = Date.now();
    const duration = durationMinutes * 60 * 1e3;
    const cooldown = TIMER_COOLDOWN_HOURS * 60 * 60 * 1e3;
    let persistedTimer = readStoredTimer(storageKey);
    if (!persistedTimer || now > persistedTimer.cooldownExpires) {
      persistedTimer = {
        endAt: now + duration,
        cooldownExpires: now + duration + cooldown
      };
      writeStoredTimer(storageKey, persistedTimer);
      setShouldShowTimer(true);
    } else if (now > persistedTimer.endAt) {
      setShouldShowTimer(false);
    } else {
      setShouldShowTimer(true);
    }
    setTimer(persistedTimer);
  }, [durationMinutes, enabled, storageKey]);
  const hideTimer = useCallback4(() => {
    setShouldShowTimer(false);
  }, []);
  return {
    timer,
    shouldShowTimer,
    hideTimer
  };
};

// src/checkout/components/elements/bar/ElementBarTimer.tsx
var ElementBarTimer = ({
  duration,
  storageKey,
  labelTemplate,
  icon,
  centered,
  className,
  classes = {}
}) => {
  if (duration == null) {
    return null;
  }
  const timer = usePersistentTimer({
    enabled: true,
    storageKey,
    durationMinutes: duration
  });
  if (!timer.shouldShowTimer || !timer.timer) return null;
  return /* @__PURE__ */ React314.createElement(
    TimerNotice,
    {
      labelTemplate,
      endAt: timer.timer.endAt,
      icon,
      onEnd: timer.hideTimer,
      centered,
      className,
      classes
    }
  );
};

// src/checkout/components/elements/bar/ElementBarCheckoutTimer.tsx
var THEMED_BG_CLASS = "bg-[var(--theme-color-bars-timer-background,#fffbeb)]";
var THEMED_TEXT_CLASS5 = "text-[var(--theme-color-text-secondary,#333333)]";
var THEMED_BORDER_CLASS = "border-[var(--theme-color-border-light,#e0e0e0)]";
var ElementBarCheckoutTimer = ({ elementConfig, classes = {} }) => {
  var _a, _b;
  const { styles } = elementConfig;
  return /* @__PURE__ */ React315.createElement(
    "div",
    {
      style: {
        "--theme-color-bars-timer-background": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.borderColor
      }
    },
    /* @__PURE__ */ React315.createElement(
      ElementBarTimer,
      {
        duration: elementConfig.config.duration,
        centered: elementConfig.config.centered,
        storageKey: (_a = elementConfig.config.storageKey) != null ? _a : STORAGE_KEYS.CHECKOUT_TIMER,
        labelTemplate: (_b = elementConfig.content.text) != null ? _b : "",
        icon: /* @__PURE__ */ React315.createElement(ClockIcon, null),
        className: THEMED_BG_CLASS,
        classes: {
          root: cn(THEMED_BORDER_CLASS, THEMED_TEXT_CLASS5, classes.root),
          content: cn(THEMED_TEXT_CLASS5, classes.discountNotice),
          value: THEMED_TEXT_CLASS5
        }
      }
    )
  );
};

// src/checkout/components/elements/bar/ElementBarDiscount.tsx
import React317 from "react";

// src/helpers/parseBoldText.ts
import React316 from "react";
var parseBoldText = (text) => {
  const result = [];
  let remaining = text;
  let key = 0;
  while (remaining.length > 0) {
    const openIdx = remaining.indexOf("<b>");
    if (openIdx === -1) {
      result.push(remaining);
      break;
    }
    if (openIdx > 0) {
      result.push(remaining.slice(0, openIdx));
    }
    const closeIdx = remaining.indexOf("</b>", openIdx + 3);
    if (closeIdx === -1) {
      result.push(remaining.slice(openIdx));
      break;
    }
    result.push(
      React316.createElement(
        "b",
        { key: key++, className: "font-bold" },
        remaining.slice(openIdx + 3, closeIdx)
      )
    );
    remaining = remaining.slice(closeIdx + 4);
  }
  return result.length === 1 ? result[0] : React316.createElement(React316.Fragment, null, ...result);
};

// src/checkout/components/elements/bar/ElementBarDiscount.tsx
var THEMED_BG_CLASS2 = "bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var THEMED_TEXT_CLASS6 = "text-[var(--theme-color-text-secondary,#333333)]";
var THEMED_BORDER_CLASS2 = "border-[var(--theme-color-border-light,#e0e0e0)]";
var ElementBarDiscount = ({ elementConfig, classes = {} }) => {
  var _a, _b, _c;
  const { styles } = elementConfig;
  const { compact } = elementConfig.config;
  const icon = elementConfig.config.icon ? /* @__PURE__ */ React317.createElement("img", { src: elementConfig.config.icon, alt: (_a = elementConfig.config.iconAlt) != null ? _a : "" }) : /* @__PURE__ */ React317.createElement(DoubleTagIcon, null);
  return /* @__PURE__ */ React317.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-tint": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.borderColor
      }
    },
    /* @__PURE__ */ React317.createElement(
      BarNotice,
      {
        icon,
        centered: elementConfig.config.centered,
        compact,
        className: THEMED_BG_CLASS2,
        classes: {
          root: cn(THEMED_BORDER_CLASS2, THEMED_TEXT_CLASS6, classes.discountNotice)
        }
      },
      parseBoldText((_c = (_b = elementConfig.content) == null ? void 0 : _b.text) != null ? _c : "")
    )
  );
};

// src/checkout/components/elements/bar/ElementBarFreeShippingTimer.tsx
import React318 from "react";
var THEMED_BG_CLASS3 = "bg-[var(--theme-color-bars-free-shipping-background,#f0fdf4)]";
var THEMED_TEXT_CLASS7 = "text-[var(--theme-color-text-secondary,#333333)]";
var THEMED_BORDER_CLASS3 = "border-[var(--theme-color-border-light,#e0e0e0)]";
var ElementBarFreeShippingTimer = ({ elementConfig, classes = {} }) => {
  var _a, _b, _c;
  const { styles } = elementConfig;
  const icon = elementConfig.config.icon ? /* @__PURE__ */ React318.createElement("img", { src: elementConfig.config.icon, alt: (_a = elementConfig.config.iconAlt) != null ? _a : "" }) : /* @__PURE__ */ React318.createElement(TruckIcon, null);
  return /* @__PURE__ */ React318.createElement(
    "div",
    {
      style: {
        "--theme-color-bars-free-shipping-background": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.borderColor
      }
    },
    /* @__PURE__ */ React318.createElement(
      ElementBarTimer,
      {
        duration: elementConfig.config.duration,
        centered: elementConfig.config.centered,
        storageKey: (_b = elementConfig.config.storageKey) != null ? _b : STORAGE_KEYS.SHIPPING_TIMER,
        labelTemplate: (_c = elementConfig.content.text) != null ? _c : "",
        icon,
        className: THEMED_BG_CLASS3,
        classes: {
          root: cn(THEMED_BORDER_CLASS3, THEMED_TEXT_CLASS7, classes.root),
          content: cn(THEMED_TEXT_CLASS7, classes.discountNotice),
          value: THEMED_TEXT_CLASS7
        }
      }
    )
  );
};

// src/checkout/components/elements/bar/ElementBarStock.tsx
import React321 from "react";

// src/checkout/hooks/useStockSimulation.ts
import { useEffect as useEffect30, useMemo as useMemo5, useState as useState36 } from "react";
var TOTAL_SUPPLY_RANGE = { min: 400, max: 499 };
var INITIAL_STOCK_RANGE = { min: 95, max: 106 };
var STOCK_FLOOR = 5;
var DECREMENT_RANGE = { min: 7, max: 8 };
var DECREMENT_INTERVAL_SECONDS_RANGE = { min: 20, max: 29 };
var getRandomInt = (min, max) => {
  const normalizedMin = Math.ceil(min);
  const normalizedMax = Math.floor(max);
  return Math.floor(Math.random() * (normalizedMax - normalizedMin + 1)) + normalizedMin;
};
var getInitialTotalSupply = () => getRandomInt(TOTAL_SUPPLY_RANGE.min, TOTAL_SUPPLY_RANGE.max);
var getInitialStockCount = () => getRandomInt(INITIAL_STOCK_RANGE.min, INITIAL_STOCK_RANGE.max);
var calculateFillPercent = (stockCount, totalSupply) => {
  if (!totalSupply) {
    return 0;
  }
  return 100 - stockCount * 100 / totalSupply;
};
var useStockSimulation = ({ enabled }) => {
  const [totalSupply, setTotalSupply] = useState36(getInitialTotalSupply);
  const [stockCount, setStockCount] = useState36(getInitialStockCount);
  useEffect30(() => {
    if (!enabled) {
      return;
    }
    setTotalSupply(getInitialTotalSupply());
    setStockCount(getInitialStockCount());
  }, [enabled]);
  useEffect30(() => {
    if (!enabled) {
      return;
    }
    const intervalSeconds = getRandomInt(
      DECREMENT_INTERVAL_SECONDS_RANGE.min,
      DECREMENT_INTERVAL_SECONDS_RANGE.max
    );
    const interval = window.setInterval(() => {
      const decrement = getRandomInt(DECREMENT_RANGE.min, DECREMENT_RANGE.max);
      setStockCount((currentStockCount) => {
        if (currentStockCount <= STOCK_FLOOR || currentStockCount - decrement <= STOCK_FLOOR) {
          window.clearInterval(interval);
          return STOCK_FLOOR;
        }
        return currentStockCount - decrement;
      });
    }, intervalSeconds * 1e3);
    return () => window.clearInterval(interval);
  }, [enabled]);
  const fillPercent = useMemo5(
    () => calculateFillPercent(stockCount, totalSupply),
    [stockCount, totalSupply]
  );
  return {
    fillPercent,
    stockCount
  };
};

// src/checkout/components/molecules/StockBar.tsx
import React320 from "react";

// src/checkout/components/molecules/StockMeter.tsx
import React319 from "react";
var DEFAULT_ROOT_CLASS49 = "grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-4 text-center text-sm font-bold leading-5";
var StockMeter = ({
  label,
  trailingText,
  fillPercent,
  className,
  classes = {}
}) => {
  const labelId = React319.useId();
  const trailingTextId = React319.useId();
  return /* @__PURE__ */ React319.createElement(BarSurface, { className: cn(DEFAULT_ROOT_CLASS49, classes.root, className) }, /* @__PURE__ */ React319.createElement("span", { id: labelId, className: classes.label }, label), /* @__PURE__ */ React319.createElement(
    StockProgressBar,
    {
      fillPercent,
      "aria-labelledby": `${labelId} ${trailingTextId}`,
      classes: { track: classes.bar, fill: classes.fill }
    }
  ), /* @__PURE__ */ React319.createElement("span", { id: trailingTextId, className: classes.trailingText }, trailingText));
};

// src/checkout/components/molecules/StockBar.tsx
var StockBar = ({
  config,
  fillPercent,
  stockCount,
  className,
  classes = {}
}) => {
  const labelParts = parseTemplateVariables(config.labelTemplate);
  return /* @__PURE__ */ React320.createElement(
    StockMeter,
    {
      label: /* @__PURE__ */ React320.createElement(React320.Fragment, null, labelParts.map(
        (part, index) => part.type === "text" ? /* @__PURE__ */ React320.createElement(React320.Fragment, { key: `text-${index}` }, part.value) : /* @__PURE__ */ React320.createElement("strong", { key: `variable-${part.value}-${index}`, className: classes.stockCount }, stockCount)
      )),
      trailingText: config.leftInStockLabel,
      fillPercent,
      className,
      classes: { root: classes.root, bar: classes.bar, fill: classes.fill }
    }
  );
};

// src/checkout/components/elements/bar/ElementBarStock.tsx
var THEMED_BG_CLASS4 = "bg-[var(--theme-color-bars-stock-background,#fff5f0)]";
var THEMED_TEXT_CLASS8 = "text-[var(--theme-color-text-secondary,#333333)]";
var THEMED_BORDER_CLASS4 = "border-[var(--theme-color-border-light,#e0e0e0)]";
var THEMED_METER_CLASS = "bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_COUNT_CLASS = "text-[var(--theme-color-error,#ff2d2b)]";
var ElementBarStock = ({ elementConfig, classes = {} }) => {
  var _a, _b, _c, _d;
  const { styles } = elementConfig;
  const stock = useStockSimulation({ enabled: true });
  return /* @__PURE__ */ React321.createElement(
    "div",
    {
      style: {
        "--theme-color-bars-stock-background": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.borderColor,
        "--theme-color-bg-page": styles == null ? void 0 : styles.meterColor,
        "--theme-color-error": styles == null ? void 0 : styles.stockCountColor
      }
    },
    /* @__PURE__ */ React321.createElement(
      StockBar,
      {
        config: {
          labelTemplate: (_b = (_a = elementConfig.content) == null ? void 0 : _a.textLeft) != null ? _b : "",
          leftInStockLabel: (_d = (_c = elementConfig.content) == null ? void 0 : _c.textRight) != null ? _d : ""
        },
        fillPercent: stock.fillPercent,
        stockCount: stock.stockCount,
        classes: {
          root: cn(THEMED_BORDER_CLASS4, THEMED_BG_CLASS4, THEMED_TEXT_CLASS8, classes.stockMeter),
          bar: cn(THEMED_BORDER_CLASS4, THEMED_METER_CLASS),
          stockCount: cn(THEMED_COUNT_CLASS, classes.stockCount)
        }
      }
    )
  );
};

// src/checkout/components/elements/ElementBar.tsx
var BAR_COMPONENT_BY_TYPE = {
  progress: ElementBarStock,
  text: ElementBarDiscount,
  timer: ElementBarCheckoutTimer,
  freeShipping: ElementBarFreeShippingTimer
};
var DEFAULT_ROOT_CLASS50 = "my-2";
var ElementBar = (props) => {
  var _a;
  const Component = BAR_COMPONENT_BY_TYPE[props.elementConfig.config.type];
  return /* @__PURE__ */ React322.createElement("div", { className: cn(DEFAULT_ROOT_CLASS50, (_a = props.classes) == null ? void 0 : _a.root) }, /* @__PURE__ */ React322.createElement(Component, { ...props }));
};

// src/organisms/SpecialOfferModal.tsx
var DEFAULT_PANEL_CLASS3 = "flex min-h-screen items-center justify-center p-[16px]";
var DEFAULT_CARD_CLASS13 = "relative w-full max-w-[640px] overflow-hidden rounded-[16px] shadow-2xl";
var DEFAULT_BARS_CLASS = "";
var DEFAULT_CONTENT_CLASS23 = "m-[32px]";
var DEFAULT_TITLE_CLASS26 = "my-[24px] text-center text-[18px] font-extrabold leading-[24px] md:text-[22px] md:leading-[28px]";
var DEFAULT_CTA_CLASS4 = "mt-[16px]";
var THEMED_CARD_CLASS2 = "bg-[var(--theme-color-bg-page,#ffffff)] text-[var(--theme-color-text-secondary,#111827)]";
var THEMED_BARS_CLASS = "bg-[var(--theme-color-bg-section,#f8fafc)]";
var THEMED_TITLE_CLASS5 = "text-[var(--theme-color-heading-primary,#111827)]";
var SpecialOfferModal = ({
  isOpen,
  onClose,
  title,
  options,
  selectedIndex = 0,
  onSelectOption,
  bars,
  ctaText,
  onCtaClick,
  subActionText,
  onSubActionClick,
  classes,
  className,
  style
}) => {
  var _a;
  const hasBars = bars != null && bars.length > 0;
  return /* @__PURE__ */ React323.createElement(
    FullscreenModal,
    {
      isOpen,
      onClose,
      classes: {
        ...classes == null ? void 0 : classes.modal,
        panel: cn(DEFAULT_PANEL_CLASS3, (_a = classes == null ? void 0 : classes.modal) == null ? void 0 : _a.panel)
      }
    },
    /* @__PURE__ */ React323.createElement(
      "div",
      {
        className: cn(DEFAULT_CARD_CLASS13, THEMED_CARD_CLASS2, classes == null ? void 0 : classes.card, className),
        style,
        onClick: (e) => e.stopPropagation()
      },
      /* @__PURE__ */ React323.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS23, classes == null ? void 0 : classes.content) }, hasBars && /* @__PURE__ */ React323.createElement("div", { className: cn(DEFAULT_BARS_CLASS, THEMED_BARS_CLASS, classes == null ? void 0 : classes.bars) }, bars.map((bar, i) => {
        var _a2;
        return /* @__PURE__ */ React323.createElement(
          ElementBar,
          {
            key: i,
            elementConfig: bar,
            classes: (_a2 = classes == null ? void 0 : classes.barItem) == null ? void 0 : _a2[bar.config.type]
          }
        );
      })), /* @__PURE__ */ React323.createElement("h2", { className: cn(DEFAULT_TITLE_CLASS26, THEMED_TITLE_CLASS5, classes == null ? void 0 : classes.title) }, title), /* @__PURE__ */ React323.createElement(
        SpecialOfferCardList,
        {
          options,
          selectedIndex,
          onSelectOption,
          classes: classes == null ? void 0 : classes.cardList
        }
      ), /* @__PURE__ */ React323.createElement(
        ActionButton,
        {
          text: ctaText,
          onAction: onCtaClick ? () => {
            var _a2, _b;
            return onCtaClick((_b = (_a2 = options[selectedIndex]) == null ? void 0 : _a2.id) != null ? _b : "");
          } : void 0,
          subActionText,
          onSubAction: onSubActionClick,
          isIconAppended: true,
          classes: {
            root: cn(DEFAULT_CTA_CLASS4, classes == null ? void 0 : classes.cta),
            button: cn("min-h-[52px]", classes == null ? void 0 : classes.ctaButton),
            subAction: classes == null ? void 0 : classes.ctaSubAction
          }
        }
      ))
    )
  );
};

// src/sections/superfast/SuperfastMainBanner.tsx
import React324 from "react";
import classNames95 from "classnames";
var DEFAULT_SECTION_CLASS42 = "w-full overflow-hidden";
var DEFAULT_IMAGE_CLASS29 = "w-full h-auto";
var DEFAULT_DESKTOP_IMAGE_CLASS = "hidden md:block w-full h-auto";
var DEFAULT_MOBILE_IMAGE_CLASS = "block md:hidden w-full h-auto";
var SuperfastMainBanner = ({
  block,
  className,
  classes = {}
}) => {
  var _a, _b;
  const { desktopImage, desktopImageAlt, mobileImage, mobileImageAlt, href } = block;
  if (!desktopImage && !mobileImage) return null;
  const resolvedDesktopAlt = (_a = desktopImageAlt != null ? desktopImageAlt : mobileImageAlt) != null ? _a : "";
  const resolvedMobileAlt = (_b = mobileImageAlt != null ? mobileImageAlt : desktopImageAlt) != null ? _b : "";
  const hasBoth = !!(desktopImage && mobileImage);
  const content = /* @__PURE__ */ React324.createElement(React324.Fragment, null, desktopImage && /* @__PURE__ */ React324.createElement(
    Image,
    {
      src: desktopImage,
      alt: resolvedDesktopAlt,
      className: classNames95(
        hasBoth ? DEFAULT_DESKTOP_IMAGE_CLASS : DEFAULT_IMAGE_CLASS29,
        classes.desktopImage
      )
    }
  ), mobileImage && /* @__PURE__ */ React324.createElement(
    Image,
    {
      src: mobileImage,
      alt: resolvedMobileAlt,
      className: classNames95(
        hasBoth ? DEFAULT_MOBILE_IMAGE_CLASS : DEFAULT_IMAGE_CLASS29,
        classes.mobileImage
      )
    }
  ));
  return /* @__PURE__ */ React324.createElement(
    "section",
    {
      "aria-label": "Main banner",
      className: classNames95(DEFAULT_SECTION_CLASS42, classes.section, className)
    },
    href ? /* @__PURE__ */ React324.createElement("a", { href, className: "block w-full" }, content) : content
  );
};

// src/sections/superfast/SuperfastSmallBanner.tsx
import React325 from "react";
import classNames96 from "classnames";
var DEFAULT_SECTION_CLASS43 = "w-full px-4 py-6 md:px-6";
var DEFAULT_CONTAINER_CLASS67 = "max-w-[1100px] mx-auto w-full";
var DEFAULT_IMAGE_CLASS30 = "w-full h-auto rounded-[8px]";
var DEFAULT_DESKTOP_IMAGE_CLASS2 = "hidden md:block w-full h-auto rounded-[8px]";
var DEFAULT_MOBILE_IMAGE_CLASS2 = "block md:hidden w-full h-auto rounded-[8px]";
var SuperfastSmallBanner = ({
  block,
  removeTopPadding = false,
  className,
  classes = {}
}) => {
  var _a, _b;
  const { desktopImage, desktopImageAlt, mobileImage, mobileImageAlt, href } = block;
  if (!desktopImage && !mobileImage) return null;
  const resolvedDesktopAlt = (_a = desktopImageAlt != null ? desktopImageAlt : mobileImageAlt) != null ? _a : "";
  const resolvedMobileAlt = (_b = mobileImageAlt != null ? mobileImageAlt : desktopImageAlt) != null ? _b : "";
  const hasBoth = !!(desktopImage && mobileImage);
  const images = /* @__PURE__ */ React325.createElement(React325.Fragment, null, desktopImage && /* @__PURE__ */ React325.createElement(
    Image,
    {
      src: desktopImage,
      alt: resolvedDesktopAlt,
      className: classNames96(
        hasBoth ? DEFAULT_DESKTOP_IMAGE_CLASS2 : DEFAULT_IMAGE_CLASS30,
        classes.desktopImage
      )
    }
  ), mobileImage && /* @__PURE__ */ React325.createElement(
    Image,
    {
      src: mobileImage,
      alt: resolvedMobileAlt,
      className: classNames96(
        hasBoth ? DEFAULT_MOBILE_IMAGE_CLASS2 : DEFAULT_IMAGE_CLASS30,
        classes.mobileImage
      )
    }
  ));
  return /* @__PURE__ */ React325.createElement(
    "section",
    {
      "aria-label": "Small banner",
      className: classNames96(
        DEFAULT_SECTION_CLASS43,
        removeTopPadding && "pt-0",
        classes.section,
        className
      )
    },
    /* @__PURE__ */ React325.createElement("div", { className: classNames96(DEFAULT_CONTAINER_CLASS67, classes.container) }, href ? /* @__PURE__ */ React325.createElement("a", { href, className: "block w-full" }, images) : images)
  );
};

// src/sections/superfast/SuperfastHeaderSection.tsx
import React326 from "react";
var DEFAULT_SECTION_CLASS44 = "w-full flex flex-col";
var DEFAULT_PROMO_BAR_CLASS = "w-full flex items-center justify-center px-4 py-1 [background:var(--sf-header-promo-bg,#000)]";
var DEFAULT_PROMO_TEXT_CLASS = "text-[12px] md:text-[14px] font-bold leading-5 text-center uppercase [color:var(--sf-header-promo-text,#fff)]";
var DEFAULT_BENEFITS_BAR_CLASS2 = "w-full flex flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2 md:gap-x-10 [background:var(--sf-header-benefits-bg,#f5f5f5)]";
var DEFAULT_BENEFIT_ITEM_CLASS3 = "text-[14px] font-medium leading-5 [color:var(--sf-header-benefits-text,#000)]";
var DEFAULT_BENEFIT_ICON_CLASS3 = "w-4 h-4 object-contain";
var DEFAULT_LOGO_CLASS9 = "flex w-[100px] h-[24px] md:w-[150px] md:h-[24px] lg:w-[200px] lg:h-[32px] shrink-0 items-center";
var DEFAULT_HEADER_CLASS26 = "[background:var(--sf-header-navbar-bg,#fff)]";
var DEFAULT_LINK_CLASS4 = "text-(--sf-header-link-color)";
var DEFAULT_MOBILE_MENU_CLASS3 = "[background:var(--sf-header-navbar-bg,#fff)]";
var DEFAULT_MOBILE_MENU_CONTENT_CLASS2 = "flex min-h-0 flex-col overflow-hidden px-4 py-0";
var DEFAULT_MOBILE_MENU_LINK_CLASS2 = "text-[14px] font-medium leading-6";
function buildVars26(colors) {
  var _a, _b, _c, _d, _e, _f;
  return {
    "--sf-header-promo-bg": (_a = colors == null ? void 0 : colors.promoBarBackground) != null ? _a : "#000000",
    "--sf-header-promo-text": (_b = colors == null ? void 0 : colors.promoBarText) != null ? _b : "#ffffff",
    "--sf-header-benefits-bg": (_c = colors == null ? void 0 : colors.benefitsBarBackground) != null ? _c : "#f5f5f5",
    "--sf-header-benefits-text": (_d = colors == null ? void 0 : colors.benefitsBarText) != null ? _d : "#000000",
    "--sf-header-navbar-bg": (_e = colors == null ? void 0 : colors.navbarBackground) != null ? _e : "#ffffff",
    "--sf-header-link-color": (_f = colors == null ? void 0 : colors.navbarLinkColor) != null ? _f : "#000000"
  };
}
var SuperfastHeaderSection = ({
  promoText,
  showPromoBar = true,
  benefits,
  showBenefitsBar = true,
  logo,
  logoImage,
  logoImageAlt,
  links,
  showMobileMenuButton = true,
  menuIcon,
  menuOpenIcon,
  mobileMenuOpen,
  defaultMobileMenuOpen,
  onMobileMenuClick,
  onMobileMenuOpenChange,
  colors,
  className,
  classes = {}
}) => {
  const hasPromoBar = showPromoBar && !!promoText;
  const hasBenefitsBar = showBenefitsBar && !!(benefits == null ? void 0 : benefits.length);
  return /* @__PURE__ */ React326.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS44, classes.section, className),
      style: buildVars26(colors)
    },
    hasPromoBar && /* @__PURE__ */ React326.createElement("div", { className: cn(DEFAULT_PROMO_BAR_CLASS, classes.promoBar) }, /* @__PURE__ */ React326.createElement(Text, { as: "p", className: cn(DEFAULT_PROMO_TEXT_CLASS, classes.promoText) }, promoText)),
    hasBenefitsBar && /* @__PURE__ */ React326.createElement("div", { className: cn(DEFAULT_BENEFITS_BAR_CLASS2, classes.benefitsBar) }, benefits.map((benefit, index) => {
      var _a;
      return /* @__PURE__ */ React326.createElement(
        IconLabelRow,
        {
          key: benefit.label + index,
          label: benefit.label,
          icon: /* @__PURE__ */ React326.createElement(
            Image,
            {
              src: benefit.icon,
              alt: (_a = benefit.iconAlt) != null ? _a : "",
              className: cn(DEFAULT_BENEFIT_ICON_CLASS3, classes.benefitIcon)
            }
          ),
          className: cn(DEFAULT_BENEFIT_ITEM_CLASS3, classes.benefitItem),
          classes: { label: classes.benefitLabel }
        }
      );
    })),
    /* @__PURE__ */ React326.createElement(
      Header,
      {
        logo,
        logoImage,
        logoImageAlt,
        links,
        showMobileMenuButton,
        menuIcon,
        menuOpenIcon: menuOpenIcon != null ? menuOpenIcon : /* @__PURE__ */ React326.createElement(IconXMark, null),
        mobileMenuOpen,
        defaultMobileMenuOpen,
        onMobileMenuClick,
        onMobileMenuOpenChange,
        className: cn(DEFAULT_HEADER_CLASS26, classes.header),
        classes: {
          container: classes.headerContainer,
          logo: cn(DEFAULT_LOGO_CLASS9, classes.logo),
          nav: classes.nav,
          link: cn(DEFAULT_LINK_CLASS4, classes.link),
          actions: classes.actions,
          menuButton: classes.menuButton,
          menuIcon: classes.menuIcon,
          mobileMenu: cn(DEFAULT_MOBILE_MENU_CLASS3, classes.mobileMenu),
          mobileMenuContent: cn(DEFAULT_MOBILE_MENU_CONTENT_CLASS2, classes.mobileMenuContent),
          mobileMenuLink: cn(
            DEFAULT_LINK_CLASS4,
            DEFAULT_MOBILE_MENU_LINK_CLASS2,
            classes.mobileMenuLink
          )
        }
      }
    )
  );
};

// src/sections/superfast/SuperfastShopByCategoriesSection.tsx
import React327 from "react";
var DEFAULT_SECTION_CLASS45 = "w-full [background:var(--sf-sbc-bg,#fff)] flex justify-center py-6 md:py-10 px-4";
var DEFAULT_CONTAINER_CLASS68 = "flex flex-col gap-6 md:gap-10 items-center max-w-[1100px] w-full";
var DEFAULT_HEADING_CLASS17 = "text-[24px] md:text-[32px] lg:text-[48px] font-bold leading-tight [color:var(--sf-sbc-heading,#000)] text-center uppercase";
var DEFAULT_GRID_CLASS8 = "flex flex-wrap gap-4 justify-center w-full";
var DEFAULT_CARD_CLASS14 = "[background:var(--sf-sbc-card-bg,#fafafa)] border-2 [border-color:var(--sf-sbc-card-border,#f5f5f5)] hover:[border-color:var(--sf-sbc-hover-border,#206136)] transition-colors flex flex-col gap-4 items-center justify-start overflow-hidden p-4 rounded-[8px] cursor-pointer w-[171px] md:w-[207px] no-underline";
var DEFAULT_CARD_IMAGE_WRAPPER_CLASS3 = "w-full aspect-square overflow-hidden";
var DEFAULT_CARD_IMAGE_CLASS4 = "w-full h-full object-contain";
var DEFAULT_CARD_LABEL_CLASS = "text-[18px] font-bold leading-[24px] [color:var(--sf-sbc-label,#333)] text-center";
function buildVars27(colors) {
  return {
    ...(colors == null ? void 0 : colors.background) && { "--sf-sbc-bg": colors.background },
    ...(colors == null ? void 0 : colors.headingColor) && { "--sf-sbc-heading": colors.headingColor },
    ...(colors == null ? void 0 : colors.cardBackground) && { "--sf-sbc-card-bg": colors.cardBackground },
    ...(colors == null ? void 0 : colors.cardBorder) && { "--sf-sbc-card-border": colors.cardBorder },
    ...(colors == null ? void 0 : colors.cardHoverBorder) && { "--sf-sbc-hover-border": colors.cardHoverBorder },
    ...(colors == null ? void 0 : colors.labelColor) && { "--sf-sbc-label": colors.labelColor }
  };
}
var CategoryCard = ({
  image,
  imageAlt = "",
  label,
  url,
  classes = {}
}) => /* @__PURE__ */ React327.createElement("a", { href: url, className: cn(DEFAULT_CARD_CLASS14, classes.card) }, /* @__PURE__ */ React327.createElement("div", { className: cn(DEFAULT_CARD_IMAGE_WRAPPER_CLASS3, classes.cardImageWrapper) }, /* @__PURE__ */ React327.createElement(
  Image,
  {
    src: image,
    alt: imageAlt,
    className: cn(DEFAULT_CARD_IMAGE_CLASS4, classes.cardImage)
  }
)), label && /* @__PURE__ */ React327.createElement(Text, { as: "p", className: cn(DEFAULT_CARD_LABEL_CLASS, classes.cardLabel) }, label));
var SuperfastShopByCategoriesSection = ({
  heading = "Shop by category",
  headingAs = "h2",
  categories,
  colors,
  className,
  classes = {}
}) => {
  if (!(categories == null ? void 0 : categories.length)) return null;
  return /* @__PURE__ */ React327.createElement(
    "section",
    {
      className: cn(DEFAULT_SECTION_CLASS45, classes.section, className),
      style: buildVars27(colors)
    },
    /* @__PURE__ */ React327.createElement("div", { className: cn(DEFAULT_CONTAINER_CLASS68, classes.container) }, heading && /* @__PURE__ */ React327.createElement(Text, { as: headingAs, className: cn(DEFAULT_HEADING_CLASS17, classes.heading) }, heading), /* @__PURE__ */ React327.createElement("div", { className: cn(DEFAULT_GRID_CLASS8, classes.grid) }, categories.map((category, index) => /* @__PURE__ */ React327.createElement(
      CategoryCard,
      {
        key: category.label + index,
        ...category,
        classes: {
          card: classes.card,
          cardImageWrapper: classes.cardImageWrapper,
          cardImage: classes.cardImage,
          cardLabel: classes.cardLabel
        }
      }
    ))))
  );
};

// src/checkout/Checkout.tsx
import React435, { useEffect as useEffect33 } from "react";

// src/checkout/components/sections/RenderingEngine.tsx
import React434 from "react";

// src/checkout/components/sections/RibbonSection.tsx
import React328 from "react";
var RibbonSection = ({ sectionConfig, classes }) => {
  const { content, styles } = sectionConfig;
  return /* @__PURE__ */ React328.createElement(
    "div",
    {
      style: {
        "--theme-color-button-primary": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-inverse": styles == null ? void 0 : styles.textColor
      }
    },
    /* @__PURE__ */ React328.createElement(
      Ribbon,
      {
        message: parseBoldText(content.message),
        iconImage: content.iconImage,
        iconAlt: content.iconAlt,
        classes
      }
    )
  );
};

// src/checkout/components/sections/TimerRibbonSection.tsx
import React329 from "react";
var TimerRibbonSection = ({
  sectionConfig,
  classes,
  onTimerEnd = () => {
  }
}) => {
  var _a, _b;
  const { config, content, styles } = sectionConfig;
  const { timer } = usePersistentTimer({
    enabled: true,
    storageKey: (_a = config.storageKey) != null ? _a : STORAGE_KEYS.CHECKOUT_TIMER,
    durationMinutes: config.durationMinutes
  });
  const { formattedTime } = useCountdown({ endAt: (_b = timer == null ? void 0 : timer.endAt) != null ? _b : Infinity, onEnd: onTimerEnd });
  const timerText = content.labelTemplate ? parseBoldText(
    parseTemplateVariables(content.labelTemplate).map((part) => part.type === "variable" ? formattedTime : part.value).join("")
  ) : formattedTime;
  return /* @__PURE__ */ React329.createElement(
    "div",
    {
      style: {
        "--theme-color-button-primary": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-inverse": styles == null ? void 0 : styles.textColor,
        "--theme-color-warning": styles == null ? void 0 : styles.timerTextColor
      }
    },
    /* @__PURE__ */ React329.createElement(
      Ribbon,
      {
        message: parseBoldText(content.message),
        iconImage: content.iconImage,
        iconAlt: content.iconAlt,
        timerIcon: /* @__PURE__ */ React329.createElement(IconClock, null),
        timerText,
        classes
      }
    )
  );
};

// src/checkout/components/sections/HeaderSection.tsx
import React332 from "react";

// src/checkout/components/organisms/CheckoutHeader.tsx
import React330 from "react";
var DEFAULT_ACTION_CLASS2 = "grid size-10 cursor-pointer place-items-center rounded-full border-0 bg-transparent p-0 transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-2";
var THEMED_ACTION_TEXT_CLASS = "text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_ACTION_FOCUS_CLASS = "focus-visible:outline-[var(--theme-color-accent,#3B82F6)]";
var CheckoutHeader = ({
  logoImage,
  logoAlt,
  shoppingBagLabel,
  onShoppingBagClick,
  className,
  classes = {}
}) => {
  const action = /* @__PURE__ */ React330.createElement(
    "button",
    {
      type: "button",
      "aria-label": shoppingBagLabel,
      onClick: onShoppingBagClick,
      className: cn(
        DEFAULT_ACTION_CLASS2,
        THEMED_ACTION_TEXT_CLASS,
        THEMED_ACTION_FOCUS_CLASS,
        classes.action
      )
    },
    /* @__PURE__ */ React330.createElement(ShoppingBagIcon, { classes: { root: classes.icon } })
  );
  return /* @__PURE__ */ React330.createElement(
    PageHeader,
    {
      logoImage,
      logoAlt,
      right: action,
      className,
      classes: {
        root: classes.root,
        inner: classes.inner,
        logo: classes.logo
      }
    }
  );
};

// src/checkout/context/CheckoutSectionNavigationContext.tsx
import React331 from "react";
var CheckoutSectionNavigationContext = React331.createContext({
  registerScrollTarget: () => {
  },
  scrollToTarget: () => {
  }
});
var CheckoutSectionNavigationProvider = ({
  children
}) => {
  const scrollTargetRef = React331.useRef(null);
  const registerScrollTarget = (element) => {
    scrollTargetRef.current = element;
  };
  const scrollToTarget = () => {
    var _a;
    (_a = scrollTargetRef.current) == null ? void 0 : _a.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return /* @__PURE__ */ React331.createElement(CheckoutSectionNavigationContext.Provider, { value: { registerScrollTarget, scrollToTarget } }, children);
};
var useCheckoutSectionNavigation = () => React331.useContext(CheckoutSectionNavigationContext);

// src/checkout/components/sections/HeaderSection.tsx
var HeaderSection = ({ logo, sectionConfig, classes = {} }) => {
  const { scrollToTarget } = useCheckoutSectionNavigation();
  return /* @__PURE__ */ React332.createElement(
    CheckoutHeader,
    {
      logoImage: logo == null ? void 0 : logo.src,
      logoAlt: logo == null ? void 0 : logo.alt,
      shoppingBagLabel: sectionConfig.content.shoppingBagLabel,
      onShoppingBagClick: scrollToTarget,
      classes: { root: classes.header }
    }
  );
};

// src/checkout/components/sections/InlineBreadcrumbHeaderSection.tsx
import React333 from "react";
var InlineBreadcrumbHeaderSection = ({
  logo,
  sectionConfig,
  classes = {}
}) => /* @__PURE__ */ React333.createElement(
  InlineBreadcrumbPageHeader,
  {
    logoImage: logo == null ? void 0 : logo.src,
    logoAlt: logo == null ? void 0 : logo.alt,
    steps: sectionConfig.content.steps,
    activeIndex: sectionConfig.config.activeIndex,
    classes: { root: classes.header }
  }
);

// src/checkout/components/sections/PillBreadcrumbHeaderSection.tsx
import React334 from "react";
var PillBreadcrumbHeaderSection = ({
  logo,
  sectionConfig,
  classes = {}
}) => /* @__PURE__ */ React334.createElement(
  PillBreadcrumbPageHeader,
  {
    logoImage: logo == null ? void 0 : logo.src,
    logoAlt: logo == null ? void 0 : logo.alt,
    steps: sectionConfig.content.steps,
    activeIndex: sectionConfig.config.activeIndex,
    classes: { root: classes.header }
  }
);

// src/checkout/components/sections/ProductHeroSection.tsx
import React356 from "react";

// src/checkout/components/organisms/ProductHeroGallery.tsx
import React341 from "react";

// src/checkout/hooks/useProductHeroGallery.ts
import { useEffect as useEffect31, useRef as useRef22, useState as useState37 } from "react";
var THUMBNAIL_DRAG_THRESHOLD_PX = 4;
var DEFAULT_DRAG_STATE = {
  isDragging: false,
  hasMoved: false,
  startX: 0,
  startY: 0,
  scrollLeft: 0,
  scrollTop: 0
};
var useProductHeroGallery = (media) => {
  var _a;
  const [selectedMediaIndex, setSelectedMediaIndex] = useState37(0);
  const [slideDirection, setSlideDirection] = useState37("next");
  const thumbnailListRef = useRef22(null);
  const thumbnailButtonRefs = useRef22([]);
  const dragStateRef = useRef22(DEFAULT_DRAG_STATE);
  const selectedMedia = (_a = media[selectedMediaIndex]) != null ? _a : media[0];
  const mediaAnimationClass = slideDirection === "next" ? "product-hero-media-slide-next" : "product-hero-media-slide-previous";
  const handleSelectMedia = (nextIndex) => {
    if (nextIndex === selectedMediaIndex || nextIndex < 0 || nextIndex >= media.length) {
      return;
    }
    setSlideDirection(nextIndex > selectedMediaIndex ? "next" : "previous");
    setSelectedMediaIndex(nextIndex);
  };
  const handlePreviousMedia = () => {
    handleSelectMedia(selectedMediaIndex - 1);
  };
  const handleNextMedia = () => {
    handleSelectMedia(selectedMediaIndex + 1);
  };
  const handleThumbnailPointerDown = (event) => {
    const thumbnailList = thumbnailListRef.current;
    if (!thumbnailList) {
      return;
    }
    dragStateRef.current = {
      isDragging: true,
      hasMoved: false,
      startX: event.clientX,
      startY: event.clientY,
      scrollLeft: thumbnailList.scrollLeft,
      scrollTop: thumbnailList.scrollTop
    };
  };
  const handleThumbnailPointerMove = (event) => {
    const thumbnailList = thumbnailListRef.current;
    if (!thumbnailList || !dragStateRef.current.isDragging) {
      return;
    }
    const dragDeltaX = event.clientX - dragStateRef.current.startX;
    const dragDeltaY = event.clientY - dragStateRef.current.startY;
    if (!dragStateRef.current.hasMoved && Math.abs(dragDeltaX) < THUMBNAIL_DRAG_THRESHOLD_PX && Math.abs(dragDeltaY) < THUMBNAIL_DRAG_THRESHOLD_PX) {
      return;
    }
    if (!dragStateRef.current.hasMoved) {
      dragStateRef.current.hasMoved = true;
      try {
        thumbnailList.setPointerCapture(event.pointerId);
      } catch (e) {
      }
    }
    event.preventDefault();
    thumbnailList.scrollLeft = dragStateRef.current.scrollLeft - dragDeltaX;
    thumbnailList.scrollTop = dragStateRef.current.scrollTop - dragDeltaY;
  };
  const handleThumbnailPointerEnd = (event) => {
    const thumbnailList = thumbnailListRef.current;
    dragStateRef.current.isDragging = false;
    if (thumbnailList == null ? void 0 : thumbnailList.hasPointerCapture(event.pointerId)) {
      thumbnailList.releasePointerCapture(event.pointerId);
    }
  };
  const handleThumbnailClickCapture = (event) => {
    if (!dragStateRef.current.hasMoved) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    dragStateRef.current.hasMoved = false;
  };
  useEffect31(() => {
    var _a2;
    (_a2 = thumbnailButtonRefs.current[selectedMediaIndex]) == null ? void 0 : _a2.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth"
    });
  }, [selectedMediaIndex]);
  return {
    selectedMedia,
    selectedMediaIndex,
    mediaAnimationClass,
    thumbnailListRef,
    thumbnailButtonRefs,
    handleSelectMedia,
    handlePreviousMedia,
    handleNextMedia,
    handleThumbnailPointerDown,
    handleThumbnailPointerMove,
    handleThumbnailPointerEnd,
    handleThumbnailClickCapture
  };
};

// src/checkout/components/organisms/ProductHeroMediaFrame.tsx
import React338 from "react";

// src/checkout/components/molecules/ProductHeroMedia.tsx
import React336 from "react";
var DEFAULT_MEDIA_CLASS = "h-full w-full object-cover";
var DEFAULT_IFRAME_CLASS = "h-full w-full border-0";
var ProductHeroImageMedia = ({ mediaItem, animationClass }) => {
  return /* @__PURE__ */ React336.createElement(
    "img",
    {
      src: mediaItem.src,
      alt: mediaItem.alt,
      className: cn(DEFAULT_MEDIA_CLASS, animationClass)
    }
  );
};
var ProductHeroVideoMedia = ({ mediaItem, animationClass }) => {
  var _a;
  return /* @__PURE__ */ React336.createElement(
    "video",
    {
      className: cn(DEFAULT_MEDIA_CLASS, animationClass),
      src: mediaItem.src,
      poster: mediaItem.posterSrc,
      autoPlay: mediaItem.autoplay,
      muted: (_a = mediaItem.autoplay) != null ? _a : true,
      loop: mediaItem.loop,
      controls: !mediaItem.autoplay,
      playsInline: true,
      preload: mediaItem.autoplay ? "auto" : "metadata"
    }
  );
};
var ProductHeroIframeMedia = ({ mediaItem, animationClass }) => {
  return /* @__PURE__ */ React336.createElement(
    "iframe",
    {
      src: mediaItem.src,
      title: mediaItem.alt,
      className: cn(DEFAULT_IFRAME_CLASS, animationClass),
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    }
  );
};
var PRODUCT_HERO_MEDIA_RENDERERS = {
  [PRODUCT_HERO_MEDIA_KIND.image]: ProductHeroImageMedia,
  [PRODUCT_HERO_MEDIA_KIND.video]: ProductHeroVideoMedia,
  [PRODUCT_HERO_MEDIA_KIND.iframe]: ProductHeroIframeMedia
};
var ProductHeroMedia = ({ mediaItem, animationClass }) => {
  const MediaRenderer = PRODUCT_HERO_MEDIA_RENDERERS[mediaItem.kind];
  return /* @__PURE__ */ React336.createElement(MediaRenderer, { mediaItem, animationClass });
};

// src/checkout/components/atoms/ProductHeroNavigationButton.tsx
import React337 from "react";
var DEFAULT_NAVIGATION_BUTTON_CLASS = "absolute top-1/2 z-10 grid size-8 -translate-y-1/2 place-items-center rounded-[4px] bg-white/85 shadow-sm transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-40 md:size-9";
var THEMED_TEXT_CLASS9 = "text-[var(--theme-color-text-secondary,#666666)]";
var ProductHeroNavigationButton = ({
  children,
  disabled,
  onClick,
  ariaLabel,
  className,
  classes = {}
}) => /* @__PURE__ */ React337.createElement(
  "button",
  {
    type: "button",
    onClick,
    disabled,
    className: cn(DEFAULT_NAVIGATION_BUTTON_CLASS, THEMED_TEXT_CLASS9, classes.root, className),
    "aria-label": ariaLabel
  },
  children
);

// src/checkout/components/organisms/ProductHeroMediaFrame.tsx
var DEFAULT_MEDIA_FRAME_CLASS = "order-1 relative aspect-square w-full overflow-hidden rounded-[10px] md:max-w-[440px] lg:order-2 lg:size-[440px] lg:shrink-0";
var THEMED_BG_CLASS5 = "bg-[var(--theme-color-bg-section,#F3F4F6)]";
var ProductHeroMediaFrame = ({
  mediaItem,
  mediaAnimationClass,
  selectedMediaIndex,
  mediaCount,
  onPreviousMedia,
  onNextMedia,
  className,
  classes = {}
}) => /* @__PURE__ */ React338.createElement("div", { className: cn(DEFAULT_MEDIA_FRAME_CLASS, THEMED_BG_CLASS5, classes.root, className) }, mediaItem ? /* @__PURE__ */ React338.createElement(React338.Fragment, null, /* @__PURE__ */ React338.createElement(
  ProductHeroNavigationButton,
  {
    onClick: onPreviousMedia,
    disabled: selectedMediaIndex === 0,
    className: "left-5 md:left-3"
  },
  /* @__PURE__ */ React338.createElement(ChevronIcon, { direction: "previous" })
), /* @__PURE__ */ React338.createElement("div", { className: "h-full w-full" }, /* @__PURE__ */ React338.createElement(
  ProductHeroMedia,
  {
    key: mediaItem.id,
    mediaItem,
    animationClass: mediaAnimationClass
  }
)), /* @__PURE__ */ React338.createElement(
  ProductHeroNavigationButton,
  {
    onClick: onNextMedia,
    disabled: selectedMediaIndex === mediaCount - 1,
    className: "right-5 md:right-3"
  },
  /* @__PURE__ */ React338.createElement(ChevronIcon, { direction: "next" })
)) : null);

// src/checkout/components/molecules/ProductHeroThumbnailRail.tsx
import React340 from "react";

// src/checkout/components/molecules/ProductHeroThumbnailButton.tsx
import React339 from "react";
var DEFAULT_THUMBNAIL_BUTTON_CLASS = "size-16 shrink-0 overflow-hidden rounded-[4px] border border-[#ebebeb] transition focus-visible:outline-2 focus-visible:outline-offset-2 lg:size-20";
var DEFAULT_THUMBNAIL_IMAGE_CLASS = "h-full w-full select-none object-cover";
var THEMED_THUMBNAIL_BUTTON_CLASS = "bg-[var(--theme-color-bg-page,#ffffff)] focus-visible:outline-[var(--theme-color-accent,#3B82F6)]";
var DEFAULT_ACTIVE_THUMBNAIL_BUTTON_CLASS = "ring-1";
var THEMED_ACTIVE_THUMBNAIL_BUTTON_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] ring-[var(--theme-color-border-light,#E5E7EB)]";
var ProductHeroThumbnailButton = React339.forwardRef(({ mediaItem, index, isActive, onSelect, className, classes = {} }, ref) => /* @__PURE__ */ React339.createElement(
  "button",
  {
    ref,
    type: "button",
    onClick: () => onSelect(index),
    className: cn(
      DEFAULT_THUMBNAIL_BUTTON_CLASS,
      THEMED_THUMBNAIL_BUTTON_CLASS,
      isActive && DEFAULT_ACTIVE_THUMBNAIL_BUTTON_CLASS,
      isActive && THEMED_ACTIVE_THUMBNAIL_BUTTON_CLASS,
      classes.root,
      className
    ),
    "aria-current": isActive
  },
  /* @__PURE__ */ React339.createElement(
    "img",
    {
      src: mediaItem.thumbnailSrc,
      alt: mediaItem.alt,
      className: cn(DEFAULT_THUMBNAIL_IMAGE_CLASS, classes.image),
      draggable: false
    }
  )
));
ProductHeroThumbnailButton.displayName = "ProductHeroThumbnailButton";

// src/checkout/components/molecules/ProductHeroThumbnailRail.tsx
var DEFAULT_THUMBNAIL_LIST_CLASS = "product-hero-scrollbar-none order-2 flex min-w-0 max-w-full touch-pan-x cursor-grab gap-2 overflow-x-auto scroll-smooth active:cursor-grabbing lg:order-1 lg:max-h-[440px] lg:w-20 lg:flex-col lg:overflow-y-auto lg:overflow-x-hidden lg:pb-0 lg:touch-pan-y";
var DEFAULT_THUMBNAIL_LIST_STACKED_CLASS = "product-hero-scrollbar-none order-2 flex min-w-0 max-w-full touch-pan-x cursor-grab gap-2 overflow-x-auto scroll-smooth active:cursor-grabbing";
var ProductHeroThumbnailRail = ({
  media,
  selectedMediaIndex,
  thumbnailButtonRefs,
  thumbnailListRef,
  onSelectMedia,
  onPointerDown,
  onPointerMove,
  onPointerEnd,
  onClickCapture,
  thumbnailsBelow = false,
  className,
  classes = {}
}) => /* @__PURE__ */ React340.createElement(
  "div",
  {
    ref: thumbnailListRef,
    className: cn(
      thumbnailsBelow ? DEFAULT_THUMBNAIL_LIST_STACKED_CLASS : DEFAULT_THUMBNAIL_LIST_CLASS,
      classes.root,
      className
    ),
    onPointerDown,
    onPointerMove,
    onPointerUp: onPointerEnd,
    onPointerCancel: onPointerEnd,
    onPointerLeave: onPointerEnd,
    onClickCapture
  },
  media.map((mediaItem, index) => /* @__PURE__ */ React340.createElement(
    ProductHeroThumbnailButton,
    {
      key: mediaItem.id,
      ref: (node) => {
        thumbnailButtonRefs.current[index] = node;
      },
      mediaItem,
      index,
      isActive: index === selectedMediaIndex,
      onSelect: onSelectMedia,
      className: classes.thumbnail
    }
  ))
);

// src/checkout/components/organisms/ProductHeroGallery.tsx
var DEFAULT_GALLERY_CLASS = "flex min-w-0 flex-col gap-2";
var DEFAULT_MEDIA_LAYOUT_CLASS = "flex min-w-0 flex-col gap-2 lg:flex-row";
var DEFAULT_MEDIA_LAYOUT_STACKED_CLASS = "flex min-w-0 flex-col gap-2";
var ProductHeroGallery = ({
  media,
  thumbnailsBelow = false,
  className,
  classes = {}
}) => {
  const {
    selectedMedia,
    selectedMediaIndex,
    mediaAnimationClass,
    thumbnailListRef,
    thumbnailButtonRefs,
    handleSelectMedia,
    handlePreviousMedia,
    handleNextMedia,
    handleThumbnailPointerDown,
    handleThumbnailPointerMove,
    handleThumbnailPointerEnd,
    handleThumbnailClickCapture
  } = useProductHeroGallery(media);
  return /* @__PURE__ */ React341.createElement("div", { className: cn(DEFAULT_GALLERY_CLASS, classes.root, className) }, /* @__PURE__ */ React341.createElement(
    "div",
    {
      className: thumbnailsBelow ? DEFAULT_MEDIA_LAYOUT_STACKED_CLASS : DEFAULT_MEDIA_LAYOUT_CLASS
    },
    thumbnailsBelow && /* @__PURE__ */ React341.createElement(
      ProductHeroMediaFrame,
      {
        mediaItem: selectedMedia,
        mediaAnimationClass,
        selectedMediaIndex,
        mediaCount: media.length,
        onPreviousMedia: handlePreviousMedia,
        onNextMedia: handleNextMedia
      }
    ),
    /* @__PURE__ */ React341.createElement(
      ProductHeroThumbnailRail,
      {
        media,
        selectedMediaIndex,
        thumbnailButtonRefs,
        thumbnailListRef,
        onSelectMedia: handleSelectMedia,
        onPointerDown: handleThumbnailPointerDown,
        onPointerMove: handleThumbnailPointerMove,
        onPointerEnd: handleThumbnailPointerEnd,
        onClickCapture: handleThumbnailClickCapture,
        thumbnailsBelow
      }
    ),
    !thumbnailsBelow && /* @__PURE__ */ React341.createElement(
      ProductHeroMediaFrame,
      {
        mediaItem: selectedMedia,
        mediaAnimationClass,
        selectedMediaIndex,
        mediaCount: media.length,
        onPreviousMedia: handlePreviousMedia,
        onNextMedia: handleNextMedia
      }
    )
  ));
};

// src/checkout/components/organisms/HeroElementRenderer.tsx
import React355 from "react";

// src/checkout/utils/positionClass.ts
var getPositionClass = (index, total) => cn(index === 0 && "mt-0", index === total - 1 && "mb-0");

// src/checkout/components/elements/ElementHeroBenefit.tsx
import React342 from "react";
var THEMED_TEXT_CLASS10 = "text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_ICON_CLASS4 = "text-[var(--theme-color-text-secondary,#666666)]";
var ElementHeroBenefit = ({
  elementConfig,
  className,
  classes = {}
}) => /* @__PURE__ */ React342.createElement(
  IconTextRow,
  {
    text: elementConfig.content.label,
    icon: /* @__PURE__ */ React342.createElement(CircleCheckIcon, null),
    className,
    classes: {
      root: cn("my-3", THEMED_TEXT_CLASS10, classes.root),
      icon: cn(THEMED_ICON_CLASS4, classes.icon),
      text: classes.label
    }
  }
);

// src/checkout/components/elements/ElementHeroCTA.tsx
import React343 from "react";
var DEFAULT_ROOT_CLASS51 = "my-3";
var ElementHeroCTA = ({
  elementConfig,
  ctaAdapters,
  className,
  classes = {}
}) => /* @__PURE__ */ React343.createElement(
  ActionButton,
  {
    text: elementConfig.content.text,
    subActionText: elementConfig.content.subActionText,
    onAction: ctaAdapters == null ? void 0 : ctaAdapters.heroCTAPrimary,
    onSubAction: ctaAdapters == null ? void 0 : ctaAdapters.heroCTASecondary,
    className: cn(DEFAULT_ROOT_CLASS51, classes.root, className)
  }
);

// src/checkout/components/elements/ElementHeroFlagRow.tsx
import React344 from "react";
var DEFAULT_ROOT_CLASS52 = "my-3";
var DEFAULT_ICON_CLASS33 = "[&_img]:h-4 [&_img]:w-4 [&_img]:object-contain [&_svg]:h-4 [&_svg]:w-4";
var THEMED_TEXT_CLASS11 = "text-[var(--theme-color-text-secondary,#666666)]";
var ElementHeroFlagRow = ({
  elementConfig,
  className,
  classes = {}
}) => {
  var _a;
  const icon = elementConfig.content.icon ? /* @__PURE__ */ React344.createElement("img", { src: elementConfig.content.icon, alt: (_a = elementConfig.content.iconAlt) != null ? _a : "" }) : /* @__PURE__ */ React344.createElement(FlagIcon, null);
  return /* @__PURE__ */ React344.createElement(
    IconLabelRow,
    {
      label: elementConfig.content.label,
      icon,
      className,
      classes: {
        root: cn(DEFAULT_ROOT_CLASS52, THEMED_TEXT_CLASS11, classes.root),
        icon: cn(DEFAULT_ICON_CLASS33, classes.icon),
        label: classes.label
      }
    }
  );
};

// src/checkout/components/elements/ElementHeroHeadingDescription.tsx
import React345 from "react";
var DEFAULT_ROOT_CLASS53 = "my-3";
var THEMED_HEADING_CLASS2 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DESCRIPTION_CLASS4 = "text-[var(--theme-color-text-secondary,#666666)]";
var ElementHeroHeadingDescription = ({
  elementConfig,
  className,
  classes = {}
}) => {
  const { heading, description } = elementConfig.content;
  return /* @__PURE__ */ React345.createElement(
    HeadingDescriptionBlock,
    {
      heading: heading != null ? heading : "",
      description: description != null ? description : "",
      className,
      classes: {
        root: cn(DEFAULT_ROOT_CLASS53, classes.root),
        heading: cn(THEMED_HEADING_CLASS2, classes.heading),
        description: cn(THEMED_DESCRIPTION_CLASS4, classes.description)
      }
    }
  );
};

// src/checkout/components/elements/ElementHeroProductCardList.tsx
import React346, { useMemo as useMemo6 } from "react";
import { useShallow } from "zustand/react/shallow";

// src/checkout/stores/orderStore.ts
import { create as create2 } from "zustand";

// src/checkout/utils/productVariants.ts
var getVisibleSelectedIndex = (options, products, preferredIndex) => {
  if (options[preferredIndex] != null) return preferredIndex;
  return options.reduce(
    (best, opt, idx) => opt !== null && (best === -1 || products[idx].amount > products[best].amount) ? idx : best,
    -1
  );
};
var syncProductToProductList = (products, selectedProductIndex, selectProduct) => {
  const selected = products[selectedProductIndex];
  if (!selected || isProductVisible(selected, "productLists" /* PRODUCT_LISTS */)) return;
  const firstVisible = products.findIndex(
    (p) => isProductVisible(p, "productLists" /* PRODUCT_LISTS */)
  );
  if (firstVisible !== -1) selectProduct(firstVisible);
};
var isProductVisible = (product, context) => {
  var _a;
  return !((_a = product.visibility) == null ? void 0 : _a.length) || product.visibility.includes(context);
};
var getDefaultProductVariantValue = (variants) => {
  var _a, _b, _c, _d;
  return (_d = (_c = (_a = variants.find((variant) => variant.isDefaultVariant)) == null ? void 0 : _a.value) != null ? _c : (_b = variants[0]) == null ? void 0 : _b.value) != null ? _d : "";
};
var getProductVariantGroups = (productVariants) => {
  if (!productVariants) return [];
  return Object.entries(productVariants).map(([key, variantGroup]) => ({
    key,
    customVariantsSelectionTitle: variantGroup.customVariantsSelectionTitle,
    customVariantsItemLabel: variantGroup.customVariantsItemLabel,
    customVariantLink: variantGroup.customVariantLink,
    variants: variantGroup.variants
  }));
};
var getDefaultProductVariantValues = (variantGroups) => variantGroups.reduce(
  (defaultValues, variantGroup) => ({
    ...defaultValues,
    [variantGroup.key]: getDefaultProductVariantValue(variantGroup.variants)
  }),
  {}
);
var getItemSelections = (variantKeys, selectedProductVariants, index) => Object.fromEntries(
  variantKeys.flatMap((key) => {
    var _a;
    const val = (_a = selectedProductVariants[key]) == null ? void 0 : _a[index];
    return val !== void 0 ? [[key, val]] : [];
  })
);
var matchesCombinedVariant = (variant, selections) => Object.entries(selections).every(([key, value]) => variant.attributes[key] === value);
var getCombinedVariantGroups = (combinedVariants, selectedProductVariants) => {
  var _a, _b;
  const variantKeys = Object.keys(selectedProductVariants);
  const itemCount = (_b = (_a = selectedProductVariants[variantKeys[0]]) == null ? void 0 : _a.length) != null ? _b : 0;
  if (variantKeys.length === 0 || itemCount === 0) return [];
  const countMap = /* @__PURE__ */ new Map();
  Array.from({ length: itemCount }, (_, i) => {
    const selections = getItemSelections(variantKeys, selectedProductVariants, i);
    const matched = combinedVariants.find((v) => matchesCombinedVariant(v, selections));
    if (!matched) return;
    const existing = countMap.get(matched.konnVariantId);
    if (existing) {
      existing.count++;
    } else {
      countMap.set(matched.konnVariantId, { ...matched, count: 1 });
    }
  });
  return Array.from(countMap.values());
};
var getCombinedVariantLabel = (attributes, productVariants) => Object.entries(attributes).map(([key, value]) => {
  var _a, _b;
  const option = (_a = productVariants[key]) == null ? void 0 : _a.variants.find((v) => v.value === value);
  return (_b = option == null ? void 0 : option.label) != null ? _b : value;
}).join(" / ");
var getSelectedProductVariantValues = (amount, variantGroups, selectedProductVariantMemory, defaultProductVariantValues) => variantGroups.reduce((selectedValues, variantGroup) => {
  var _a;
  const defaultVariantValue = (_a = defaultProductVariantValues[variantGroup.key]) != null ? _a : "";
  return {
    ...selectedValues,
    [variantGroup.key]: Array.from({ length: amount }, (_, itemIndex) => {
      var _a2;
      const rememberedVariantValue = (_a2 = selectedProductVariantMemory[variantGroup.key]) == null ? void 0 : _a2[itemIndex];
      const isRememberedVariantAvailable = variantGroup.variants.some(
        (variant) => variant.value === rememberedVariantValue
      );
      return isRememberedVariantAvailable ? rememberedVariantValue : defaultVariantValue;
    })
  };
}, {});

// src/checkout/utils/productCardHelpers.ts
function removeCurrencySymbol(currencyString) {
  var _a, _b;
  const currencyRegex = /(?:^\D+)|(?:\D+$)/;
  const currencySymbol = (_b = (_a = currencyString == null ? void 0 : currencyString.match(currencyRegex)) == null ? void 0 : _a[0]) != null ? _b : "";
  const value = currencyString == null ? void 0 : currencyString.replace(currencyRegex, "");
  return { currencySymbol, value };
}
var currencyParser = (currencyCode, country, formattedString) => {
  var _a, _b, _c, _d, _e;
  const formattedPrice = formattedString ? formattedString.replace(/(0\.00|0,00|0)/, String(currencyCode)) : "";
  let priceObject = {
    symbolLeft: true,
    number: 0,
    cents: "00",
    symbol: "",
    hasCents: true
  };
  let splitedValue;
  if (formattedPrice.includes("R ")) {
    const parts = formattedPrice.split(".");
    if (parts[0].length >= 3) {
      parts[0] = Number(parts[0]).toLocaleString();
    }
    splitedValue = ["R" + parts[0], parts[1]];
  } else {
    if (formattedPrice.includes(",")) {
      splitedValue = formattedPrice.split(",");
    } else {
      splitedValue = formattedPrice.split(".");
    }
  }
  const currencyRegex = /(?:^\D+)|(?:\D+$)/;
  const firstItemHasSymbol = currencyRegex.test((_a = splitedValue[0]) == null ? void 0 : _a.trim());
  if (firstItemHasSymbol) {
    const splitedFirstNumber = removeCurrencySymbol((_b = splitedValue[0]) == null ? void 0 : _b.trim());
    priceObject = {
      ...priceObject,
      symbolLeft: true,
      number: Number(splitedFirstNumber.value),
      cents: splitedValue[1] ? splitedValue[1] : "00",
      symbol: splitedFirstNumber.currencySymbol
    };
  } else {
    const splitedSecondNumber = removeCurrencySymbol((_c = splitedValue[1]) == null ? void 0 : _c.trim());
    priceObject = {
      ...priceObject,
      symbolLeft: false,
      number: splitedValue[0],
      cents: (_d = splitedSecondNumber.value) != null ? _d : "00",
      symbol: (_e = splitedSecondNumber.currencySymbol) == null ? void 0 : _e.trim()
    };
  }
  if (country === "JPY") {
    priceObject = {
      ...priceObject,
      hasCents: false
    };
  }
  return priceObject;
};

// src/checkout/utils/orderPricing.ts
var PRICE_TEMPLATE_PATTERN = /(0\.00|0,00|0)/;
var formatCurrency = (value, formattedString) => {
  const normalizedValue = Number.isFinite(value) ? value.toFixed(2) : "0.00";
  return formattedString.replace(PRICE_TEMPLATE_PATTERN, normalizedValue);
};
var getParsedPriceDisplay = (priceValue, currencyCode, formattedString) => {
  const currentPriceText = formatCurrency(priceValue, formattedString);
  const currentPriceObject = currencyParser(priceValue == null ? void 0 : priceValue.toFixed(2), currencyCode, formattedString);
  if (currentPriceObject) {
    return {
      currentPriceObject,
      currentPriceWholeText: String(currentPriceObject.number),
      currentPriceCentsText: currentPriceObject.hasCents ? currentPriceObject.cents : "",
      currentPriceAmountText: `${currentPriceObject.number}${currentPriceObject.hasCents ? `.${currentPriceObject.cents}` : ""}`
    };
  }
  const normalizedPriceText = currentPriceText.replace(/[^\d.,]/g, "");
  const [wholeText = "", centsText = ""] = normalizedPriceText.split(/[.,]/);
  return {
    currentPriceObject: null,
    currentPriceWholeText: wholeText,
    currentPriceCentsText: centsText,
    currentPriceAmountText: normalizedPriceText
  };
};
var getProductQuantity = (product) => {
  var _a;
  const billedAmount = (_a = product.billedAmount) != null ? _a : 0;
  return billedAmount > 0 ? billedAmount : product.amount;
};
var getProductDisplayPricing = (product, pricingConfig, hasAppliedDiscountCode, isWarrantySelected) => {
  var _a, _b, _c, _d;
  const {
    formattedString,
    currencyCode,
    isDiscountCodeFeatureEnabled,
    shouldMultiplyWarrantyByQuantity = false
  } = pricingConfig;
  const quantity = getProductQuantity(product);
  const baseCardPriceValue = product.price;
  const promoCardPriceValue = (_a = product.promoDiscountedPrice) != null ? _a : 0;
  const baseSummaryPriceValue = baseCardPriceValue * quantity;
  const promoSummaryPriceValue = promoCardPriceValue * quantity;
  const hasPromoPrice = product.promoDiscountedPrice !== null && product.promoDiscountedPrice !== void 0;
  const shouldUsePromoPrice = isDiscountCodeFeatureEnabled && hasAppliedDiscountCode && hasPromoPrice;
  const currentPriceValue = shouldUsePromoPrice ? promoCardPriceValue : baseCardPriceValue;
  const currentPriceText = formatCurrency(currentPriceValue, formattedString);
  const parsedCurrentPrice = getParsedPriceDisplay(
    currentPriceValue,
    currencyCode,
    formattedString
  );
  const shippingValue = shouldUsePromoPrice && product.promoShippingPrice !== null && product.promoShippingPrice !== void 0 ? product.promoShippingPrice : product.shippingPrice;
  const shippingDifference = shouldUsePromoPrice && product.promoShippingPrice !== null && product.promoShippingPrice !== void 0 ? Math.max(product.shippingPrice - product.promoShippingPrice, 0) : 0;
  const baseWarrantyPrice = (_b = product.warrantyPrice) != null ? _b : 0;
  const warrantyMultiplier = shouldMultiplyWarrantyByQuantity ? product.amount : 1;
  const warrantyValue = isWarrantySelected ? baseWarrantyPrice * warrantyMultiplier : 0;
  const subtotalValue = (shouldUsePromoPrice ? promoSummaryPriceValue : baseSummaryPriceValue) + warrantyValue;
  const totalValue = subtotalValue + shippingValue;
  const oldPriceValue = (_c = product.oldPrice) != null ? _c : 0;
  const discountValue = shouldUsePromoPrice ? Math.max(baseSummaryPriceValue - promoSummaryPriceValue, 0) : 0;
  const savingsValue = Math.max(oldPriceValue - subtotalValue + shippingDifference, 0);
  const discountPercent = isDiscountCodeFeatureEnabled && hasAppliedDiscountCode ? (_d = product.promoDiscountAmountPercent) != null ? _d : product.youSavePercentage : product.youSavePercentage;
  return {
    currentPriceObject: parsedCurrentPrice.currentPriceObject,
    currentPriceValue,
    currentPriceText,
    currentPriceWholeText: parsedCurrentPrice.currentPriceWholeText,
    currentPriceCentsText: parsedCurrentPrice.currentPriceCentsText,
    currentPriceAmountText: parsedCurrentPrice.currentPriceAmountText,
    oldPriceValue,
    oldPriceText: oldPriceValue > 0 ? formatCurrency(oldPriceValue, formattedString) : "",
    shippingValue,
    shippingText: formatCurrency(shippingValue, formattedString),
    subtotalValue,
    subtotalText: formatCurrency(subtotalValue, formattedString),
    totalValue,
    totalText: formatCurrency(totalValue, formattedString),
    warrantyValue,
    warrantyText: formatCurrency(warrantyValue, formattedString),
    savingsValue,
    savingsText: formatCurrency(savingsValue, formattedString),
    discountValue,
    discountText: formatCurrency(discountValue, formattedString),
    discountPercent,
    formattedString
  };
};
var getProductsDisplayPricing = (products, pricingConfig, hasAppliedDiscountCode, isWarrantySelected) => products.map(
  (product) => getProductDisplayPricing(product, pricingConfig, hasAppliedDiscountCode, isWarrantySelected)
);
var getVariantGroupPricing = (group, product, pricing) => {
  const { subtotalValue, oldPriceValue, formattedString, ...rest } = pricing;
  const unitRatio = group.count / product.amount;
  const ceilCents = (v) => Math.ceil(v * 100) / 100;
  const variantSubtotal = ceilCents(subtotalValue * unitRatio);
  const variantOldPrice = ceilCents(oldPriceValue * unitRatio);
  return {
    ...rest,
    subtotalValue: variantSubtotal,
    subtotalText: formatCurrency(variantSubtotal, formattedString),
    oldPriceValue: variantOldPrice,
    oldPriceText: variantOldPrice > 0 ? formatCurrency(variantOldPrice, formattedString) : "",
    formattedString
  };
};

// src/checkout/stores/orderStore.ts
var getActiveProducts = (baseProducts, subscriptionProducts, isSubscribe) => isSubscribe ? subscriptionProducts : baseProducts;
var getOrderSubmitValue = (state, additionalData = null) => ({
  selectedProduct: state.selectedProduct,
  appliedDiscountCode: state.appliedDiscountCode,
  selectedProductVariants: state.selectedProductVariants,
  selectedCombinedProductVariants: state.selectedCombinedProductVariants,
  isWarrantySelected: state.isWarrantySelected,
  enabledVariantType: state.enabledVariantType,
  selectedProductPricing: state.selectedProductPricing,
  isSubscribe: state.isSubscribe,
  additionalData
});
var useOrderStore = create2((set, get) => ({
  isOrderInitialized: false,
  isSubscribe: false,
  isWarrantySelected: false,
  appliedDiscountCode: null,
  pricingConfig: {
    currencyCode: void 0,
    formattedString: "$0.00",
    isDiscountCodeFeatureEnabled: false
  },
  baseProducts: [],
  subscriptionProducts: [],
  products: [],
  productPricingByIndex: [],
  selectedProduct: null,
  selectedProductPricing: null,
  enabledVariantType: void 0,
  productVariants: {},
  defaultProductVariantValues: {},
  selectedProductIndex: 0,
  selectedProductVariantMemory: {},
  selectedProductVariants: {},
  combinedVariants: [],
  selectedCombinedProductVariants: [],
  setIsSubscribe: (isSubscribe) => {
    const {
      baseProducts,
      subscriptionProducts,
      pricingConfig,
      appliedDiscountCode,
      isWarrantySelected,
      selectedProductIndex
    } = get();
    const nextProducts = getActiveProducts(baseProducts, subscriptionProducts, isSubscribe);
    const productPricingByIndex = getProductsDisplayPricing(
      nextProducts,
      pricingConfig,
      !!appliedDiscountCode,
      isWarrantySelected
    );
    set({
      isSubscribe,
      products: nextProducts,
      productPricingByIndex
    });
    get().selectProduct(selectedProductIndex);
  },
  setIsWarrantySelected: (isWarrantySelected) => {
    const { products, pricingConfig, appliedDiscountCode, selectedProductIndex } = get();
    const productPricingByIndex = getProductsDisplayPricing(
      products,
      pricingConfig,
      !!appliedDiscountCode,
      isWarrantySelected
    );
    set({
      isWarrantySelected,
      productPricingByIndex
    });
    get().selectProduct(selectedProductIndex);
  },
  applyDiscountCode: (appliedDiscountCode) => {
    const { products, pricingConfig, isWarrantySelected, selectedProductIndex } = get();
    const productPricingByIndex = getProductsDisplayPricing(
      products,
      pricingConfig,
      true,
      isWarrantySelected
    );
    set({
      appliedDiscountCode,
      productPricingByIndex
    });
    get().selectProduct(selectedProductIndex);
  },
  removeDiscountCode: () => {
    const { products, pricingConfig, isWarrantySelected, selectedProductIndex } = get();
    const productPricingByIndex = getProductsDisplayPricing(
      products,
      pricingConfig,
      false,
      isWarrantySelected
    );
    set({
      appliedDiscountCode: null,
      productPricingByIndex
    });
    get().selectProduct(selectedProductIndex);
  },
  selectProduct: (selectedProductIndex) => {
    const {
      products,
      productPricingByIndex,
      enabledVariantType,
      productVariants,
      selectedProduct: currentSelectedProduct
    } = get();
    const selectedProduct = products[selectedProductIndex];
    const selectedProductPricing = productPricingByIndex[selectedProductIndex];
    set({
      selectedProductIndex,
      selectedProduct,
      selectedProductPricing
    });
    const hasSelectedProductAmountChanged = (currentSelectedProduct == null ? void 0 : currentSelectedProduct.amount) !== selectedProduct.amount;
    if (enabledVariantType === "perProduct" /* PER_PRODUCT */ && hasSelectedProductAmountChanged) {
      get().initializeProductVariants(selectedProduct.amount, productVariants);
    }
  },
  initializeProductVariants: (amount, productVariants) => {
    set((state) => {
      const variantGroups = getProductVariantGroups(productVariants);
      const selectedProductVariants = getSelectedProductVariantValues(
        amount,
        variantGroups,
        state.selectedProductVariantMemory,
        state.defaultProductVariantValues
      );
      return {
        selectedProductVariants,
        selectedCombinedProductVariants: getCombinedVariantGroups(
          state.combinedVariants,
          selectedProductVariants
        )
      };
    });
  },
  selectProductVariant: (variantGroupKey, itemIndex, variantValue) => {
    set((state) => {
      var _a, _b;
      const currentVariantValues = (_a = state.selectedProductVariants[variantGroupKey]) != null ? _a : [];
      if (currentVariantValues[itemIndex] === variantValue) return state;
      const nextVariantValues = [...currentVariantValues];
      nextVariantValues[itemIndex] = variantValue;
      const nextVariantMemory = [...(_b = state.selectedProductVariantMemory[variantGroupKey]) != null ? _b : []];
      nextVariantMemory[itemIndex] = variantValue;
      const selectedProductVariants = {
        ...state.selectedProductVariants,
        [variantGroupKey]: nextVariantValues
      };
      return {
        selectedProductVariantMemory: {
          ...state.selectedProductVariantMemory,
          [variantGroupKey]: nextVariantMemory
        },
        selectedProductVariants,
        selectedCombinedProductVariants: getCombinedVariantGroups(
          state.combinedVariants,
          selectedProductVariants
        )
      };
    });
  },
  initializeOrder: (products, subscriptionProducts, pricingConfig, isSubscriptionEnabled, isWarrantyPreselected = false, enabledVariantType, variants, preferredProductIndex, combinedVariants = []) => {
    const initialProducts = getActiveProducts(
      products,
      subscriptionProducts,
      isSubscriptionEnabled
    );
    const selectedProductIndex = preferredProductIndex != null ? preferredProductIndex : 0;
    const productPricingByIndex = getProductsDisplayPricing(
      initialProducts,
      pricingConfig,
      false,
      isWarrantyPreselected
    );
    const isVariantSelectionEnabled = Object.keys(variants != null ? variants : {}).length > 0 ? true : false;
    const enabledVariantTypeOverride = isVariantSelectionEnabled ? "perProduct" /* PER_PRODUCT */ : void 0;
    const isPerCheckoutVariantsEnabled = enabledVariantType === "perCheckout" /* PER_CHECKOUT */;
    const productVariants = variants != null ? variants : {};
    const defaultProductVariantValues = isVariantSelectionEnabled ? getDefaultProductVariantValues(getProductVariantGroups(productVariants)) : {};
    set({
      isSubscribe: isSubscriptionEnabled,
      isWarrantySelected: isWarrantyPreselected,
      pricingConfig,
      baseProducts: products,
      subscriptionProducts,
      products: initialProducts,
      productPricingByIndex,
      enabledVariantType: enabledVariantTypeOverride,
      combinedVariants,
      ...isVariantSelectionEnabled && {
        productVariants,
        defaultProductVariantValues
      }
    });
    get().selectProduct(selectedProductIndex);
    if (isPerCheckoutVariantsEnabled) {
      get().initializeProductVariants(1, productVariants);
    }
    set({ isOrderInitialized: true });
  }
}));

// src/checkout/components/elements/ElementHeroProductCardList.tsx
var DEFAULT_ROOT_CLASS54 = "my-3";
var ElementHeroProductCardList = ({
  elementConfig,
  className,
  classes = {}
}) => {
  const { eachLabel, bestValueLabel, bestSellerLabel } = elementConfig.content;
  const products = useOrderStore(useShallow((state) => state.products));
  const productPricingByIndex = useOrderStore(useShallow((state) => state.productPricingByIndex));
  const selectedProductIndex = useOrderStore((state) => state.selectedProductIndex);
  const selectProduct = useOrderStore((state) => state.selectProduct);
  const isOrderInitialized = useOrderStore((state) => state.isOrderInitialized);
  const options = useMemo6(
    () => products.map((product, storeIndex) => {
      var _a, _b, _c;
      if (!isProductVisible(product, "productLists" /* PRODUCT_LISTS */)) return null;
      const pricing = productPricingByIndex[storeIndex];
      if (!pricing) return null;
      const badge = product.isBestValue ? bestValueLabel : product.isBestSeller ? bestSellerLabel : void 0;
      return {
        id: String(product.id),
        image: product.imageUrl,
        quantity: `${product.amount}x`,
        oldPriceText: pricing.oldPriceText,
        symbol: (_a = pricing.currentPriceObject) == null ? void 0 : _a.symbol,
        symbolLeft: (_c = (_b = pricing.currentPriceObject) == null ? void 0 : _b.symbolLeft) != null ? _c : true,
        wholePriceText: pricing.currentPriceWholeText,
        centsPriceText: pricing.currentPriceCentsText,
        eachLabel,
        badge
      };
    }),
    [products, productPricingByIndex, eachLabel, bestValueLabel, bestSellerLabel]
  );
  if (!isOrderInitialized) return null;
  return /* @__PURE__ */ React346.createElement("div", { className: cn(DEFAULT_ROOT_CLASS54, classes.root, className) }, /* @__PURE__ */ React346.createElement(
    SpecialOfferCardList,
    {
      options,
      selectedIndex: selectedProductIndex,
      onSelectOption: selectProduct,
      classes: classes.cardList
    }
  ));
};

// src/checkout/components/elements/ElementHeroRatingRow.tsx
import React347 from "react";
var DEFAULT_ROOT_CLASS55 = "my-3";
var THEMED_RATING_LINE_CLASS = "text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_RATING_VALUE_CLASS2 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_RATING_DIVIDER_CLASS = "text-[var(--theme-color-border-light,#E5E7EB)]";
var ElementHeroRatingRow = ({
  elementConfig,
  isCleanVersion,
  className,
  classes = {}
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */ React347.createElement(
    RatingSummaryRow,
    {
      ratingValue: (_a = elementConfig.content.ratingText) != null ? _a : "",
      starRating: elementConfig.content.rating,
      reviewsLabel: (_b = elementConfig.content.reviewsLabel) != null ? _b : "",
      isTrustpilot: isCleanVersion ? false : (_c = elementConfig.content.isTrustpilot) != null ? _c : true,
      className,
      classes: {
        root: cn(DEFAULT_ROOT_CLASS55, THEMED_RATING_LINE_CLASS, classes.root, classes.ratingLine),
        rating: THEMED_RATING_VALUE_CLASS2,
        divider: THEMED_RATING_DIVIDER_CLASS
      }
    }
  );
};

// src/checkout/components/elements/ElementHeroSellingPoints.tsx
import React350 from "react";

// src/checkout/components/molecules/ProductHeroSellingPoints.tsx
import React349 from "react";

// src/checkout/components/molecules/ProductHeroSellingPointItem.tsx
import React348 from "react";
var DEFAULT_SELLING_POINT_ICON_CLASS = "[&_img]:h-7 [&_img]:w-7 [&_img]:object-contain";
var THEMED_SELLING_POINT_ITEM_CLASS = "text-[var(--theme-color-text-secondary,#666666)]";
var ProductHeroSellingPointItem = ({
  sellingPoint,
  className,
  classes = {}
}) => /* @__PURE__ */ React348.createElement(
  IconLabelStack,
  {
    icon: /* @__PURE__ */ React348.createElement("img", { src: sellingPoint.iconSrc, alt: sellingPoint.iconAlt }),
    label: sellingPoint.label,
    className,
    classes: {
      root: cn(THEMED_SELLING_POINT_ITEM_CLASS, classes.root),
      icon: cn(DEFAULT_SELLING_POINT_ICON_CLASS, classes.icon),
      label: classes.label
    }
  }
);

// src/checkout/components/molecules/ProductHeroSellingPoints.tsx
var DEFAULT_SELLING_POINTS_CLASS = "grid grid-cols-2 gap-x-6 gap-y-4 pt-2 text-center md:grid-cols-4 md:gap-x-5 md:pt-1";
var ProductHeroSellingPoints = ({
  sellingPoints,
  className,
  classes = {}
}) => /* @__PURE__ */ React349.createElement("div", { className: cn(DEFAULT_SELLING_POINTS_CLASS, classes.root, className) }, sellingPoints.map((sellingPoint) => {
  var _a, _b;
  return /* @__PURE__ */ React349.createElement(
    ProductHeroSellingPointItem,
    {
      key: sellingPoint.id,
      sellingPoint,
      className: classes.item,
      classes: {
        ...classes.sellingPoint,
        icon: cn((_a = classes.sellingPoint) == null ? void 0 : _a.icon, classes.icon),
        label: cn((_b = classes.sellingPoint) == null ? void 0 : _b.label, classes.label)
      }
    }
  );
}));

// src/checkout/components/elements/ElementHeroSellingPoints.tsx
var DEFAULT_ROOT_CLASS56 = "my-3";
var ElementHeroSellingPoints = ({
  elementConfig,
  className,
  classes = {}
}) => /* @__PURE__ */ React350.createElement(
  ProductHeroSellingPoints,
  {
    sellingPoints: elementConfig.content.sellingPoints,
    className: cn(DEFAULT_ROOT_CLASS56, classes.root, classes.sellingPoints, className)
  }
);

// src/checkout/components/elements/ElementHeroSocialProof.tsx
import React354 from "react";

// src/checkout/components/molecules/ProductHeroSocialProofAvatars.tsx
import React351 from "react";
var DEFAULT_AVATARS_WRAPPER_CLASS = "relative shrink-0";
var DEFAULT_AVATARS_CLASS = "h-8 w-auto shrink-0";
var DEFAULT_VERIFIED_CLASS4 = "absolute -bottom-0.5 right-0 grid size-3.5 place-items-center rounded-full text-white ring-1 ring-white";
var THEMED_VERIFIED_BG_CLASS = "bg-[var(--theme-color-success,#059669)]";
var ProductHeroSocialProofAvatars = ({
  className,
  classes = {}
}) => /* @__PURE__ */ React351.createElement("div", { className: cn(DEFAULT_AVATARS_WRAPPER_CLASS, classes.root, className) }, /* @__PURE__ */ React351.createElement(ReviewsImage, { className: cn(DEFAULT_AVATARS_CLASS, classes.image) }), /* @__PURE__ */ React351.createElement(
  "span",
  {
    className: cn(DEFAULT_VERIFIED_CLASS4, THEMED_VERIFIED_BG_CLASS, classes.verified),
    "aria-hidden": "true"
  },
  /* @__PURE__ */ React351.createElement(BadgeCheckIcon, null)
));

// src/checkout/components/molecules/ProductHeroSocialProofText.tsx
import React352 from "react";
var DEFAULT_TEXT_CLASS20 = "flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px] leading-5";
var DEFAULT_VALUE_CLASS2 = "font-bold";
var THEMED_TEXT_CLASS12 = "text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_VALUE_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var ProductHeroSocialProofText = ({
  customersValue,
  customersLabel,
  ratingValue,
  ratingLabel,
  className,
  classes = {}
}) => /* @__PURE__ */ React352.createElement("div", { className: cn(DEFAULT_TEXT_CLASS20, THEMED_TEXT_CLASS12, classes.root, className) }, /* @__PURE__ */ React352.createElement("span", null, customersValue ? /* @__PURE__ */ React352.createElement("span", { className: cn(DEFAULT_VALUE_CLASS2, THEMED_VALUE_CLASS, classes.value) }, customersValue, " ") : null, customersLabel), /* @__PURE__ */ React352.createElement("span", null, ratingValue ? /* @__PURE__ */ React352.createElement("span", { className: cn(DEFAULT_VALUE_CLASS2, THEMED_VALUE_CLASS, classes.value) }, ratingValue, " ") : null, ratingLabel));

// src/checkout/components/molecules/SocialProofLayout.tsx
import React353 from "react";
var DEFAULT_ROOT_CLASS57 = "flex items-center gap-3 rounded-[6px] border px-4 py-2";
var SocialProofLayout = ({
  avatars,
  text,
  className,
  classes = {}
}) => /* @__PURE__ */ React353.createElement("div", { className: cn(DEFAULT_ROOT_CLASS57, classes.root, className) }, /* @__PURE__ */ React353.createElement("div", { className: classes.avatars }, avatars), /* @__PURE__ */ React353.createElement("div", { className: classes.text }, text));

// src/checkout/components/elements/ElementHeroSocialProof.tsx
var DEFAULT_ROOT_CLASS58 = "my-3";
var THEMED_SOCIAL_PROOF_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-raised,#F9FAFB)]";
var ElementHeroSocialProof = ({
  elementConfig,
  className,
  classes = {}
}) => {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ React354.createElement(
    SocialProofLayout,
    {
      className: cn(DEFAULT_ROOT_CLASS58, classes.root, className),
      classes: { root: THEMED_SOCIAL_PROOF_CLASS },
      avatars: /* @__PURE__ */ React354.createElement(
        ProductHeroSocialProofAvatars,
        {
          classes: {
            root: classes.avatarsWrapper,
            image: classes.avatars,
            verified: classes.verified
          }
        }
      ),
      text: /* @__PURE__ */ React354.createElement(
        ProductHeroSocialProofText,
        {
          customersValue: (_a = elementConfig.content.customersValue) != null ? _a : "",
          customersLabel: (_b = elementConfig.content.customersLabel) != null ? _b : "",
          ratingValue: (_c = elementConfig.content.ratingValue) != null ? _c : "",
          ratingLabel: (_d = elementConfig.content.ratingLabel) != null ? _d : "",
          classes: { root: classes.text, value: classes.value }
        }
      )
    }
  );
};

// src/checkout/components/organisms/HeroElementRenderer.tsx
var HeroElementRenderer = React355.memo(function HeroElementRenderer2({
  elements,
  ctaAdapters,
  isCleanVersion,
  classes = {}
}) {
  return /* @__PURE__ */ React355.createElement(React355.Fragment, null, elements.map((element, index) => {
    const rootClass = getPositionClass(index, elements.length);
    switch (element.type) {
      case "flag-row":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroFlagRow,
          {
            key: `hero-flag-row-${index}`,
            elementConfig: element,
            classes: { root: rootClass }
          }
        );
      case "heading-description":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroHeadingDescription,
          {
            key: `hero-heading-description-${index}`,
            elementConfig: element,
            classes: { root: rootClass }
          }
        );
      case "rating-row":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroRatingRow,
          {
            key: `hero-rating-row-${index}`,
            elementConfig: element,
            isCleanVersion,
            classes: { root: rootClass }
          }
        );
      case "benefit":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroBenefit,
          {
            key: `hero-benefit-${index}`,
            elementConfig: element,
            classes: { root: rootClass }
          }
        );
      case "social-proof":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroSocialProof,
          {
            key: `hero-social-proof-${index}`,
            elementConfig: element,
            classes: { root: rootClass }
          }
        );
      case "selling-points":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroSellingPoints,
          {
            key: `hero-selling-points-${index}`,
            elementConfig: element,
            classes: { root: rootClass, sellingPoints: classes.sellingPoints }
          }
        );
      case "product-card-list":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroProductCardList,
          {
            key: `hero-product-card-list-${index}`,
            elementConfig: element,
            classes: { root: rootClass }
          }
        );
      case "cta":
        return /* @__PURE__ */ React355.createElement(
          ElementHeroCTA,
          {
            key: `hero-cta-${index}`,
            elementConfig: element,
            ctaAdapters,
            classes: { root: rootClass }
          }
        );
      case "bar":
        return /* @__PURE__ */ React355.createElement(
          ElementBar,
          {
            key: `hero-bar-${index}`,
            elementConfig: element,
            classes: { root: rootClass }
          }
        );
      default:
        return null;
    }
  }));
});

// src/checkout/components/sections/ProductHeroSection.tsx
var DEFAULT_PRODUCT_HERO_SECTION_CLASS = "";
var DEFAULT_PRODUCT_HERO_INNER_CLASS = "mx-auto grid max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))] gap-4 px-2 py-4 md:grid-cols-[minmax(0,400px)_minmax(0,1fr)] md:items-start md:gap-4 md:px-4 md:py-6 lg:grid-cols-[minmax(0,530px)_minmax(0,1fr)] lg:gap-8 lg:py-8";
var DEFAULT_THUMBNAILS_BELOW_PRODUCT_HERO_INNER_CLASS = "mx-auto grid max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))] gap-4 px-2 py-4 md:grid-cols-[auto_minmax(0,1fr)] md:items-start md:gap-4 md:px-4 md:py-6 lg:gap-8 lg:py-8";
var THEMED_PRODUCT_HERO_SECTION_CLASS = "bg-[var(--theme-color-bg-raised,#F9FAFB)]";
var ProductHeroSection = ({
  sectionConfig,
  ctaAdapters,
  isCleanVersion,
  className,
  classes = {}
}) => {
  var _a;
  const contentSlot = sectionConfig.slots.find(
    (slot) => slot.name === "content"
  );
  const heroElements = (_a = contentSlot == null ? void 0 : contentSlot.elements) != null ? _a : [];
  return /* @__PURE__ */ React356.createElement(
    "section",
    {
      className: cn(
        DEFAULT_PRODUCT_HERO_SECTION_CLASS,
        THEMED_PRODUCT_HERO_SECTION_CLASS,
        classes.root,
        className
      )
    },
    /* @__PURE__ */ React356.createElement(
      "div",
      {
        className: cn(
          sectionConfig.config.thumbnailsBelow ? DEFAULT_THUMBNAILS_BELOW_PRODUCT_HERO_INNER_CLASS : DEFAULT_PRODUCT_HERO_INNER_CLASS,
          classes.inner
        )
      },
      /* @__PURE__ */ React356.createElement(
        ProductHeroGallery,
        {
          media: sectionConfig.content.media,
          thumbnailsBelow: sectionConfig.config.thumbnailsBelow,
          className: classes.gallery
        }
      ),
      /* @__PURE__ */ React356.createElement("div", { className: classes.content }, /* @__PURE__ */ React356.createElement(
        HeroElementRenderer,
        {
          elements: heroElements,
          ctaAdapters,
          isCleanVersion,
          classes: { sellingPoints: classes.sellingPoints }
        }
      ))
    )
  );
};

// src/checkout/components/sections/SeparatorSection.tsx
import React357 from "react";
var DEFAULT_SEPARATOR_SECTION_CLASS = "hidden md:block";
var DEFAULT_SEPARATOR_HEIGHT = 16;
var DEFAULT_SEPARATOR_BORDER_CLASS = "border-y";
var DEFAULT_BOTTOM_ONLY_BORDER_CLASS = "border-b";
var THEMED_BG_CLASS6 = "bg-[var(--theme-color-bg-section,#F3F4F6)]";
var THEMED_BORDER_CLASS5 = "border-[var(--theme-color-border-light,#E5E7EB)]";
var SeparatorSection = ({
  height = DEFAULT_SEPARATOR_HEIGHT,
  borderless = false,
  className
}) => {
  const resolvedHeight = height >= 0 ? height : DEFAULT_SEPARATOR_HEIGHT;
  const defaultBorderClass = resolvedHeight === 0 ? DEFAULT_BOTTOM_ONLY_BORDER_CLASS : DEFAULT_SEPARATOR_BORDER_CLASS;
  return /* @__PURE__ */ React357.createElement(
    "div",
    {
      className: cn(
        THEMED_BG_CLASS6,
        DEFAULT_SEPARATOR_SECTION_CLASS,
        !borderless && defaultBorderClass,
        !borderless && THEMED_BORDER_CLASS5,
        className
      ),
      style: { height: `${resolvedHeight}px` },
      "aria-hidden": true
    }
  );
};

// src/checkout/components/sections/Layout2ColV1Section.tsx
import React423 from "react";

// src/checkout/components/organisms/LayoutElementRenderer.tsx
import React421 from "react";

// src/checkout/components/elements/ElementBadgeCard.tsx
import React358 from "react";
var DEFAULT_ROOT_CLASS59 = "my-4";
var DEFAULT_IMAGE_CLASS31 = "size-16 flex-none object-contain";
var THEMED_BORDER_CLASS6 = "border-[var(--theme-color-border-light,#E5E7EB)]";
var THEMED_TITLE_CLASS6 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DESCRIPTION_CLASS5 = "text-[var(--theme-color-text-secondary,#666666)]";
var ElementBadgeCard = ({ elementConfig, classes = {} }) => {
  const { content } = elementConfig;
  const image = content.icon ? /* @__PURE__ */ React358.createElement("img", { className: DEFAULT_IMAGE_CLASS31, src: content.icon, alt: content.title }) : /* @__PURE__ */ React358.createElement(MoneyBackBadgeIcon, null);
  return /* @__PURE__ */ React358.createElement(
    ImageCard,
    {
      image,
      title: content.title,
      description: content.description,
      classes: {
        root: cn(THEMED_BORDER_CLASS6, DEFAULT_ROOT_CLASS59, classes.root),
        title: THEMED_TITLE_CLASS6,
        description: THEMED_DESCRIPTION_CLASS5
      }
    }
  );
};

// src/checkout/components/elements/ElementFeatureCard.tsx
import React359 from "react";
var DEFAULT_ROOT_CLASS60 = "my-4";
var THEMED_TITLE_CLASS7 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DESCRIPTION_CLASS6 = "text-[var(--theme-color-text-secondary,#666666)]";
var ElementFeatureCard = ({ elementConfig, classes = {} }) => {
  var _a, _b, _c;
  const content = (_a = elementConfig.content) != null ? _a : {};
  return /* @__PURE__ */ React359.createElement(
    FeatureCard,
    {
      icon: content.icon,
      iconAlt: content.iconAlt,
      title: (_b = content.title) != null ? _b : "",
      description: (_c = content.description) != null ? _c : "",
      classes: {
        root: cn(DEFAULT_ROOT_CLASS60, classes.root),
        title: THEMED_TITLE_CLASS7,
        description: THEMED_DESCRIPTION_CLASS6
      }
    }
  );
};

// src/checkout/components/elements/ElementFooter.tsx
import React362 from "react";

// src/checkout/components/organisms/FooterNav.tsx
import React361 from "react";

// src/checkout/components/atoms/FooterLinkItem.tsx
import React360 from "react";
var DEFAULT_FOOTER_LINK_CLASS = "text-xs leading-4 text-[#525252] no-underline";
var THEMED_HOVER_CLASS = "hover:text-[var(--theme-color-accent,#3B82F6)]";
var FooterLinkItem = ({ link, className }) => {
  return /* @__PURE__ */ React360.createElement("a", { className: cn(DEFAULT_FOOTER_LINK_CLASS, THEMED_HOVER_CLASS, className), href: link.href }, link.label);
};

// src/checkout/components/organisms/FooterNav.tsx
var DEFAULT_FOOTER_NAV_CLASS = "flex flex-wrap justify-center gap-x-5 gap-y-3 border-t pt-5";
var THEMED_BORDER_CLASS7 = "border-[var(--theme-color-border-light,#E5E7EB)]";
var FooterNav = ({ links, label, className, classes = {} }) => {
  return /* @__PURE__ */ React361.createElement(
    "nav",
    {
      className: cn(DEFAULT_FOOTER_NAV_CLASS, THEMED_BORDER_CLASS7, classes.root, className),
      "aria-label": label
    },
    links.map((link) => /* @__PURE__ */ React361.createElement(FooterLinkItem, { link, className: classes.item, key: link.label }))
  );
};

// src/checkout/components/elements/ElementFooter.tsx
var DEFAULT_ROOT_CLASS61 = "my-4";
var ElementFooter = ({ elementConfig, classes = {} }) => {
  const visibilityClass = elementConfig.config.showOnDesktop ? "hidden md:flex" : "md:hidden";
  return /* @__PURE__ */ React362.createElement(
    FooterNav,
    {
      links: elementConfig.content.links,
      className: visibilityClass,
      classes: { root: cn(DEFAULT_ROOT_CLASS61, classes.root) }
    }
  );
};

// src/checkout/components/elements/ElementOrderForm.tsx
import React364 from "react";

// src/checkout/legacyForm/LegacyForm.tsx
import React363 from "react";

// src/checkout/legacyForm/buildLegacyWindowConfig.ts
var getLegacyFormLabels = (productsConfig) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P;
  return {
    tr_checkout_v4_form_nameLabel: (_c = (_b = (_a = productsConfig.checkoutForm) == null ? void 0 : _a.labels) == null ? void 0 : _b.firstName) != null ? _c : "First Name",
    tr_checkout_v4_form_lastNameLabel: (_f = (_e = (_d = productsConfig.checkoutForm) == null ? void 0 : _d.labels) == null ? void 0 : _e.lastName) != null ? _f : "Last Name",
    tr_checkout_v4_form_emailLabel: (_i = (_h = (_g = productsConfig.checkoutForm) == null ? void 0 : _g.labels) == null ? void 0 : _h.email) != null ? _i : "Email Address",
    tr_checkout_v4_form_phoneLabel: (_l = (_k = (_j = productsConfig.checkoutForm) == null ? void 0 : _j.labels) == null ? void 0 : _k.phone) != null ? _l : "Phone Number",
    tr_checkout_v4_form_countryLabel: (_o = (_n = (_m = productsConfig.checkoutForm) == null ? void 0 : _m.labels) == null ? void 0 : _n.country) != null ? _o : "Country",
    tr_checkout_v4_form_addressLabel: (_r = (_q = (_p = productsConfig.checkoutForm) == null ? void 0 : _p.labels) == null ? void 0 : _q.address) != null ? _r : "Address",
    tr_checkout_v4_form_cityLabel: (_u = (_t = (_s = productsConfig.checkoutForm) == null ? void 0 : _s.labels) == null ? void 0 : _t.city) != null ? _u : "City",
    tr_checkout_v4_form_stateLabel: (_x = (_w = (_v = productsConfig.checkoutForm) == null ? void 0 : _v.labels) == null ? void 0 : _w.state) != null ? _x : "State",
    tr_checkout_v4_form_postLabel: (_A = (_z = (_y = productsConfig.checkoutForm) == null ? void 0 : _y.labels) == null ? void 0 : _z.zip) != null ? _A : "Zip/Postcode",
    tr_checkout_v4_form_cardNumberLabel: (_D = (_C = (_B = productsConfig.checkoutForm) == null ? void 0 : _B.labels) == null ? void 0 : _C.cardNumber) != null ? _D : "Card Number",
    tr_checkout_v4_form_expirationLabel: (_G = (_F = (_E = productsConfig.checkoutForm) == null ? void 0 : _E.labels) == null ? void 0 : _F.expiration) != null ? _G : "Expiration (MM/YY)",
    tr_checkout_v4_form_securityLabel: (_J = (_I = (_H = productsConfig.checkoutForm) == null ? void 0 : _H.labels) == null ? void 0 : _I.securityCode) != null ? _J : "Security Code",
    tr_checkout_v4_form_securityComment: (_M = (_L = (_K = productsConfig.checkoutForm) == null ? void 0 : _K.labels) == null ? void 0 : _L.securityComment) != null ? _M : "3-digit security code usually found on the back of your card.",
    tr_checkout_v4_form_searchLabel: (_P = (_O = (_N = productsConfig.checkoutForm) == null ? void 0 : _N.labels) == null ? void 0 : _O.search) != null ? _P : "Search",
    checkout_v4_form_securityCom: true,
    tr_checkout_v4_form_securityIcon: false
  };
};
var getLegacyFormHeadings = (productsConfig) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  return {
    tr_checkout_v4_form_informationHeading: (_c = (_b = (_a = productsConfig.checkoutForm) == null ? void 0 : _a.headings) == null ? void 0 : _b.customerInformation) != null ? _c : "Customer Information",
    tr_checkout_v4_form_shippingHeading: (_f = (_e = (_d = productsConfig.checkoutForm) == null ? void 0 : _d.headings) == null ? void 0 : _e.deliveryAddress) != null ? _f : "Delivery Address",
    tr_checkout_v4_form_methodsHeading: (_i = (_h = (_g = productsConfig.checkoutForm) == null ? void 0 : _g.headings) == null ? void 0 : _h.paymentMethods) != null ? _i : "Payment Methods",
    tr_checkout_v4_form_cardCollapseHeading: (_l = (_k = (_j = productsConfig.checkoutForm) == null ? void 0 : _j.headings) == null ? void 0 : _k.creditCard) != null ? _l : "Credit Card",
    tr_checkout_v4_form_paypalInner: (_o = (_n = (_m = productsConfig.checkoutForm) == null ? void 0 : _m.headings) == null ? void 0 : _n.paypalInner) != null ? _o : "After clicking the payment button, you will be redirected to a secure payment window to complete your transaction",
    checkout_v4_form_paypalInnerIcon: false,
    checkout_v4_form_paypalCollapseIcon: false,
    checkout_v4_form_cardCollapseIcon: false
  };
};
var getLegacyFormErrors = (productsConfig) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
  return {
    tr_checkout_v4_form_requiredError: (_c = (_b = (_a = productsConfig.checkoutForm) == null ? void 0 : _a.errors) == null ? void 0 : _b.required) != null ? _c : "This field is required",
    tr_checkout_v4_form_cardError: (_f = (_e = (_d = productsConfig.checkoutForm) == null ? void 0 : _d.errors) == null ? void 0 : _e.card) != null ? _f : "Please enter a valid card number",
    tr_checkout_v4_form_expirationError: (_i = (_h = (_g = productsConfig.checkoutForm) == null ? void 0 : _g.errors) == null ? void 0 : _h.expiration) != null ? _i : "Please enter a valid expiration date",
    tr_checkout_v4_form_emailError: (_l = (_k = (_j = productsConfig.checkoutForm) == null ? void 0 : _j.errors) == null ? void 0 : _k.email) != null ? _l : "Please enter a valid email address",
    tr_checkout_v4_form_phoneError: (_o = (_n = (_m = productsConfig.checkoutForm) == null ? void 0 : _m.errors) == null ? void 0 : _n.phone) != null ? _o : "Please enter a valid phone number",
    tr_checkout_v4_form_cvvError: (_r = (_q = (_p = productsConfig.checkoutForm) == null ? void 0 : _p.errors) == null ? void 0 : _q.cvv) != null ? _r : "Please enter a valid security code",
    tr_checkout_v4_form_termsError: (_u = (_t = (_s = productsConfig.checkoutForm) == null ? void 0 : _s.errors) == null ? void 0 : _t.policy) != null ? _u : "Please agree with the terms before continuing",
    tr_checkout_v4_form_symbolError: (_x = (_w = (_v = productsConfig.checkoutForm) == null ? void 0 : _v.errors) == null ? void 0 : _w.symbol) != null ? _x : "Please remove unsupported symbols",
    tr_checkout_v4_form_invalidCountry: (_A = (_z = (_y = productsConfig.checkoutForm) == null ? void 0 : _y.errors) == null ? void 0 : _z.invalidCountry) != null ? _A : "Please select a valid country"
  };
};
var buildLegacyRuntimeConfig = (productsConfig, summaryConfig, theme) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M;
  const themeVariables = getThemeVariables(theme);
  const formLabels = getLegacyFormLabels(productsConfig);
  const formHeadings = getLegacyFormHeadings(productsConfig);
  const formErrors = getLegacyFormErrors(productsConfig);
  return {
    form: {
      checkout_v4_formLabels: formLabels,
      checkout_v4_formHeadings: formHeadings,
      checkout_v4_errors: formErrors,
      checkout_v4_payment_method_position: (_b = (_a = productsConfig.checkoutForm) == null ? void 0 : _a.paymentMethodPosition) != null ? _b : "top",
      hide_paypal_express_button_block: (_d = (_c = productsConfig.checkoutForm) == null ? void 0 : _c.hidePaypalExpressButton) != null ? _d : false,
      tr_checkout_v4_disclaimer_text: (_f = (_e = productsConfig.checkoutForm) == null ? void 0 : _e.disclaimerText) != null ? _f : "",
      tr_checkout_v4_formEncrypted: (_i = (_h = (_g = productsConfig.checkoutForm) == null ? void 0 : _g.headings) == null ? void 0 : _h.sslText) != null ? _i : "All transactions are SSL secure and encrypted",
      tr_checkout_v4_formEncrypted_top: (_l = (_k = (_j = productsConfig.checkoutForm) == null ? void 0 : _j.headings) == null ? void 0 : _k.paymentSubtext) != null ? _l : "All transactions are secure and encrypted.",
      tr_checkout_v4_form_cta: (_o = (_n = (_m = productsConfig.checkoutForm) == null ? void 0 : _m.headings) == null ? void 0 : _n.submit) != null ? _o : "Complete Order",
      tr_checkout_v4_form_processing: (_r = (_q = (_p = productsConfig.checkoutForm) == null ? void 0 : _p.headings) == null ? void 0 : _q.processing) != null ? _r : "Processing",
      tr_checkout_v4_form_paypalText: (_u = (_t = (_s = productsConfig.checkoutForm) == null ? void 0 : _s.headings) == null ? void 0 : _t.paypalSubmit) != null ? _u : "Checkout With PayPal",
      tr_checkout_v4_paypal_upper: (_x = (_w = (_v = productsConfig.checkoutForm) == null ? void 0 : _v.headings) == null ? void 0 : _w.expressTop) != null ? _x : "Express checkout",
      tr_checkout_v4_paypal_bottom: (_A = (_z = (_y = productsConfig.checkoutForm) == null ? void 0 : _y.headings) == null ? void 0 : _z.expressBottom) != null ? _A : "Or continue to pay with credit card"
    },
    summary: {
      tr_checkout_v4_summary_orderLabel: summaryConfig.subtotalLabel,
      tr_checkout_v4_summary_shippingLabel: summaryConfig.shippingLabel,
      tr_checkout_v4_summary_warrantyLabel: "Warranty",
      tr_checkout_v4_summary_shippingProtectionLabel: "Shipping Warranty"
    },
    products: {
      checkout_v4_products_show: false,
      checkout_v4_upsell_popup_toggle: false,
      checkout_v4_products_borderCC: false,
      checkout_v4_products_checkButtonCcColor: (_C = (_B = productsConfig.legacyProductsCheckButtonCcColor) != null ? _B : themeVariables.themeColorButtonPrimary) != null ? _C : "#1F2937",
      checkout_v4_products_paymentHeadingBgColor: (_D = productsConfig.legacyProductsPaymentHeadingBgColor) != null ? _D : "#eef4ff"
    },
    globalComponents: {
      checkout_v4_components_paypalBackground: "#ffc438",
      checkout_v4_components_paypalBackgroundHover: "#ffd87a",
      checkout_v4_components_paypalShadowColor: "#dba72d",
      checkout_v4_components_paypalShadowColorHover: "#e1b64f",
      checkout_v4_components_paypalTextColor: "#333333",
      checkout_v4_components_btnTheme: (_E = themeVariables.themeColorButtonPrimary) != null ? _E : "#1F2937"
    },
    checkboxText: (_H = (_G = (_F = productsConfig.checkoutForm) == null ? void 0 : _F.labels) == null ? void 0 : _G.policy) != null ? _H : "I have read the Terms and Conditions and Privacy Policy and agree with them.",
    affiliate: (_J = (_I = productsConfig.additionalData) == null ? void 0 : _I.aff) != null ? _J : "",
    postId: (_L = (_K = productsConfig.additionalData) == null ? void 0 : _K.postId) != null ? _L : "",
    cleanDesktop: productsConfig.isCleanVersion,
    cleanMobile: productsConfig.isCleanVersion,
    complianceDesktop: false,
    complianceMobile: false,
    directCheck: false,
    enhancedContrast: false,
    isAdyenEnabled: (_M = productsConfig.isAdyenEnabled) != null ? _M : false
  };
};

// src/checkout/legacyForm/critical.css?raw
var critical_default = {};

// src/checkout/legacyForm/style.css?raw
var style_default = {};

// src/checkout/legacyForm/LegacyForm.tsx
var LEGACY_FORM_SCOPE_CLASS = "legacyForm";
var addLegacyIntlTelInputCompatibilityCss = (scopeClass) => `
.${scopeClass} .country-list>li>.country-name,
.${scopeClass} .country-list>li>.dial-code,
.${scopeClass} .iti__country-name,
.${scopeClass} .iti__dial-code {
  font-family: "Roboto", sans-serif;
  color: #333;
}

.${scopeClass} .iti__country {
  display: flex;
  align-items: center;
  padding: 8px 8px;
  outline: none;
}

.${scopeClass} .iti__flag-box,
.${scopeClass} .iti__country-name {
  margin-right: 8px;
}

.${scopeClass} .iti__search-input {
  padding: 9px 12px;
  border-width: 0;
  border-radius: 3px;
}
`;
var toLegacyProduct = (product) => {
  var _a, _b;
  return {
    ...product,
    generic_name: product.name,
    display_name: product.name,
    shipping_price: product.shippingPrice,
    warranty_price: (_a = product.warrantyPrice) != null ? _a : 0,
    old_price: (_b = product.oldPrice) != null ? _b : 0,
    promo_discounted_price: product.promoDiscountedPrice,
    promo_discount_amount_percent: product.promoDiscountAmountPercent,
    you_save_percentage: product.youSavePercentage,
    image: product.imageUrl ? { url: product.imageUrl } : void 0
  };
};
var buildLegacyProductsConfig = (schemaConfig, orderFormElement) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const crmPaymentsConfig = schemaConfig.paymentsConfig;
  return {
    showProducts: false,
    isCleanVersion: schemaConfig.isCleanVersion || false,
    productsHeading: "",
    pickerAdditionalMessage: "",
    productEachLabel: "Each",
    discountSaveLabel: "Save",
    discountOffLabel: "Off",
    isDiscountCodeFeatureEnabled: schemaConfig.isDiscountCodeFeatureEnabled || false,
    productBestSellerLabel: "Best Seller",
    productBestValueLabel: "Best Value",
    additionalData: {
      aff: schemaConfig.aff,
      country: schemaConfig.country,
      postId: schemaConfig.postId,
      nextPageOnSuccess: schemaConfig.nextPageOnSuccess,
      konnektiveCampaignId: schemaConfig.konnektiveCampaignId,
      subscriptionNextPage: schemaConfig.subscriptionNextPage,
      subscriptionCampaignId: schemaConfig.subscriptionCampaignId
    },
    isSubscriptionEnabled: schemaConfig.isSubscriptionEnabled,
    isWarrantyEnabled: schemaConfig.isWarrantyEnabled,
    isWarrantyPreselected: schemaConfig.isWarrantyPreselected,
    shouldMultiplyWarrantyByQuantity: schemaConfig.shouldMultiplyWarrantyByQuantity,
    currencyCode: schemaConfig.currencyCode,
    formattedString: schemaConfig.products.formattedString,
    selectedProductIndex: schemaConfig.selectedProductIndex,
    showProductPickerV2: schemaConfig.products.showProductPickerV2 || false,
    productDropdownContent: schemaConfig.products.productDropdownContent,
    enabledVariantType: schemaConfig.enabledVariantType,
    subscriptionTitle: "",
    subscriptionDescription: "",
    oneTimeDescription: "",
    subscribeAndSave: "",
    oneTimePurchase: "",
    productVariants: schemaConfig.products.productVariants,
    products: (_a = schemaConfig.products.baseProducts) != null ? _a : [],
    subscriptionProducts: (_b = schemaConfig.products.subscriptionProducts) != null ? _b : [],
    formPrefillData: schemaConfig.formPrefillData,
    paymentsConfig: schemaConfig.paymentsConfig,
    isAdyenEnabled: (_c = schemaConfig.paymentsConfig) == null ? void 0 : _c.isAdyenEnabled,
    checkoutForm: {
      defaultPaymentMethod: orderFormElement.content.defaultPaymentMethod,
      paymentMethodPosition: orderFormElement.content.paymentMethodPosition,
      defaultCountry: orderFormElement.content.defaultCountry,
      requirePolicy: schemaConfig.isCleanVersion ? true : (_e = crmPaymentsConfig == null ? void 0 : crmPaymentsConfig.requirePolicy) != null ? _e : (_d = orderFormElement.config) == null ? void 0 : _d.requirePolicy,
      hidePaypalExpressButton: (_g = crmPaymentsConfig == null ? void 0 : crmPaymentsConfig.hidePaypalExpressButton) != null ? _g : (_f = orderFormElement.config) == null ? void 0 : _f.hidePaypalExpressButton,
      disclaimerText: orderFormElement.content.disclaimerText,
      paymentMethods: (_i = crmPaymentsConfig == null ? void 0 : crmPaymentsConfig.paymentMethods) != null ? _i : (_h = orderFormElement.config) == null ? void 0 : _h.paymentMethods,
      labels: orderFormElement.content.labels,
      headings: orderFormElement.content.headings,
      errors: orderFormElement.content.errors
    }
  };
};
var buildLegacySummaryConfig = (orderFormElement) => {
  var _a, _b, _c, _d;
  return {
    title: "Order Summary",
    subtotalLabel: (_b = (_a = orderFormElement.content.summary) == null ? void 0 : _a.subtotalLabel) != null ? _b : "Order",
    shippingLabel: (_d = (_c = orderFormElement.content.summary) == null ? void 0 : _c.shippingLabel) != null ? _d : "Shipping",
    totalLabel: "Total",
    totalSavingsLabel: "Total Savings",
    discountPlaceholder: "",
    discountApplyLabel: "",
    discountErrorLabel: "",
    discountCode: "",
    showOnlyTitleWhenClosed: false,
    defaultExpanded: false
  };
};
var buildLegacyProductData = (productsConfig, selectedProduct, isSubscribe) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  return {
    ...productsConfig,
    currency_code: productsConfig.currencyCode,
    country_code: (_c = (_a = productsConfig.checkoutForm) == null ? void 0 : _a.defaultCountry) != null ? _c : (_b = productsConfig.additionalData) == null ? void 0 : _b.country,
    paypal_merchant: (_e = (_d = productsConfig.paymentsConfig) == null ? void 0 : _d.paypalMerchant) != null ? _e : "",
    konnektive_campaign_id: (_g = (_f = productsConfig.additionalData) == null ? void 0 : _f.konnektiveCampaignId) != null ? _g : "",
    next_page_on_success: (_j = (_i = selectedProduct == null ? void 0 : selectedProduct.nextPageOnSuccess) != null ? _i : (_h = productsConfig.additionalData) == null ? void 0 : _h.nextPageOnSuccess) != null ? _j : "",
    multiply_price_by_amount: productsConfig.shouldMultiplyWarrantyByQuantity,
    add_warranty_for_product: productsConfig.isWarrantyEnabled,
    select_warranty_type_cc: (_k = productsConfig.selectWarrantyTypeCc) != null ? _k : { label: "Extended Warranty" },
    enable_discount_codes: productsConfig.isDiscountCodeFeatureEnabled,
    enable_color_variants: Boolean((_l = productsConfig.productVariants) == null ? void 0 : _l.color),
    enable_size_variants: Boolean((_m = productsConfig.productVariants) == null ? void 0 : _m.size),
    show_bundle_design: false,
    allowed_payment_methods: {
      enable_klarna: (_p = (_o = (_n = productsConfig.checkoutForm) == null ? void 0 : _n.paymentMethods) == null ? void 0 : _o.klarna) != null ? _p : false,
      remove_warranty_with_klarna: (_r = (_q = productsConfig.paymentsConfig) == null ? void 0 : _q.removeWarrantyWithKlarna) != null ? _r : false
    },
    subscription: {
      subscription_enable: productsConfig.isSubscriptionEnabled,
      subscription_next_page: (_t = (_s = productsConfig.additionalData) == null ? void 0 : _s.subscriptionNextPage) != null ? _t : "",
      konnektive_campaign_id: (_v = (_u = productsConfig.additionalData) == null ? void 0 : _u.subscriptionCampaignId) != null ? _v : "",
      subscription_active: isSubscribe
    },
    paymentsConfig: {
      ...productsConfig.paymentsConfig,
      stripeApplePayAllowed: ((_x = (_w = productsConfig.checkoutForm) == null ? void 0 : _w.paymentMethods) == null ? void 0 : _x.applePay) && ((_y = productsConfig.paymentsConfig) == null ? void 0 : _y.stripeApplePayAllowed),
      googlePayConfigured: ((_A = (_z = productsConfig.checkoutForm) == null ? void 0 : _z.paymentMethods) == null ? void 0 : _A.googlePay) && ((_B = productsConfig.paymentsConfig) == null ? void 0 : _B.googlePayConfigured),
      klarnaAllowed: ((_D = (_C = productsConfig.checkoutForm) == null ? void 0 : _C.paymentMethods) == null ? void 0 : _D.klarna) && ((_E = productsConfig.paymentsConfig) == null ? void 0 : _E.klarnaAllowed)
    },
    prefillData: (_F = productsConfig.formPrefillData) != null ? _F : null
  };
};
var hydrateLegacyStores = async (productsConfig, summaryConfig, selectedProduct, selectedProductPricing, appliedDiscountCode, isWarrantySelected, isSubscribe, isPreview, theme) => {
  const runtimeConfig = buildLegacyRuntimeConfig(productsConfig, summaryConfig, theme);
  setLegacyRuntimeConfig({ ...runtimeConfig, isPreview });
  const [{ useTemplateStore }, { useProductData }, { useCartData }] = await Promise.all([
    // @ts-expect-error raw legacy JS module
    import("./templateStore-6HO5DI3J.mjs"),
    // @ts-expect-error raw legacy JS module
    import("./productStore-AJJVZTN5.mjs"),
    // @ts-expect-error raw legacy JS module
    import("./cartStore-5SKBRWMK.mjs")
  ]);
  const legacySelectedProduct = selectedProduct ? toLegacyProduct(selectedProduct) : null;
  useTemplateStore.setState((state) => {
    var _a, _b;
    return {
      ...state,
      isLoading: false,
      isMobile: window.innerWidth < 1071,
      mobileGallery: window.innerWidth <= 767,
      paymentMethod: (_b = (_a = productsConfig.checkoutForm) == null ? void 0 : _a.defaultPaymentMethod) != null ? _b : "card",
      direct: runtimeConfig.affiliate.includes("-direct"),
      complianceDesktop: runtimeConfig.complianceDesktop,
      complianceMobile: runtimeConfig.complianceMobile,
      cleanDesktop: runtimeConfig.cleanDesktop,
      cleanMobile: runtimeConfig.cleanMobile,
      withProductPicker: Boolean(runtimeConfig.products.checkout_v4_products_show),
      totalSavingsStyle: runtimeConfig.summary.checkout_v4_summary_savingsStyl,
      showBulletPoints: Boolean(runtimeConfig.summary.checkout_v4_summary_bullet_points),
      enhancedContrast: runtimeConfig.enhancedContrast,
      isGooglePayAvailable: false,
      isApplePayAvailable: false,
      upsellPopup: {
        ...state.upsellPopup,
        popupEnabled: Boolean(runtimeConfig.products.checkout_v4_upsell_popup_toggle)
      }
    };
  });
  useProductData.setState((state) => ({
    ...state,
    ...buildLegacyProductData(productsConfig, legacySelectedProduct, isSubscribe)
  }));
  useCartData.setState((state) => {
    var _a, _b;
    return {
      ...state,
      selectedProduct: legacySelectedProduct,
      warrantyState: isWarrantySelected,
      discountCode: appliedDiscountCode != null ? appliedDiscountCode : void 0,
      isDiscountApplied: !!appliedDiscountCode,
      isSubscribe,
      cartTotal: ((_a = selectedProductPricing == null ? void 0 : selectedProductPricing.totalValue) == null ? void 0 : _a.toFixed) ? selectedProductPricing.totalValue.toFixed(2) : (_b = selectedProductPricing == null ? void 0 : selectedProductPricing.totalText) != null ? _b : "0.00",
      variants: []
    };
  });
};
var LegacyForm = ({
  schemaConfig,
  orderFormElement,
  adapters
}) => {
  const productsConfig = React363.useMemo(
    () => buildLegacyProductsConfig(schemaConfig, orderFormElement),
    [orderFormElement, schemaConfig]
  );
  const summaryConfig = React363.useMemo(
    () => buildLegacySummaryConfig(orderFormElement),
    [orderFormElement]
  );
  const selectedProduct = useOrderStore((state) => state.selectedProduct);
  const selectedProductPricing = useOrderStore((state) => state.selectedProductPricing);
  const appliedDiscountCode = useOrderStore((state) => state.appliedDiscountCode);
  const isWarrantySelected = useOrderStore((state) => state.isWarrantySelected);
  const isSubscribe = useOrderStore((state) => state.isSubscribe);
  const scopedLegacyCss = React363.useMemo(
    () => [critical_default, style_default].join("\n") + addLegacyIntlTelInputCompatibilityCss(LEGACY_FORM_SCOPE_CLASS),
    []
  );
  const [FormComponent, setFormComponent] = React363.useState(null);
  React363.useEffect(() => {
    let isCancelled = false;
    if (!selectedProduct || !selectedProductPricing) return void 0;
    const loadLegacyForm = async () => {
      var _a;
      await hydrateLegacyStores(
        productsConfig,
        summaryConfig,
        selectedProduct,
        selectedProductPricing,
        appliedDiscountCode,
        isWarrantySelected,
        isSubscribe,
        (_a = schemaConfig.isPreview) != null ? _a : false,
        schemaConfig.theme
      );
      const legacyFormModule = (
        // @ts-expect-error raw legacy JSX module
        await import("./form-GREEW6Q7.mjs")
      );
      if (!isCancelled) {
        setFormComponent(() => legacyFormModule.Form);
      }
    };
    void loadLegacyForm();
    return () => {
      isCancelled = true;
    };
  }, [
    schemaConfig.isPreview,
    productsConfig,
    summaryConfig,
    selectedProduct,
    selectedProductPricing,
    appliedDiscountCode,
    isWarrantySelected,
    isSubscribe
  ]);
  if (!FormComponent) return null;
  return /* @__PURE__ */ React363.createElement("div", { className: LEGACY_FORM_SCOPE_CLASS }, /* @__PURE__ */ React363.createElement("style", null, scopedLegacyCss), /* @__PURE__ */ React363.createElement(FormComponent, { submitAdapters: adapters }));
};

// src/checkout/components/elements/ElementOrderForm.tsx
var DEFAULT_ROOT_CLASS62 = "my-6";
var ElementOrderForm = ({
  schemaConfig,
  elementConfig,
  formAdapters,
  classes = {}
}) => {
  return /* @__PURE__ */ React364.createElement("div", { className: cn(DEFAULT_ROOT_CLASS62, classes.root) }, /* @__PURE__ */ React364.createElement(
    LegacyForm,
    {
      schemaConfig,
      orderFormElement: elementConfig,
      adapters: formAdapters
    }
  ));
};

// src/checkout/components/elements/ElementOrderSummary.tsx
import React375 from "react";

// src/checkout/components/organisms/SummaryCard.tsx
import React374 from "react";

// src/checkout/hooks/useSummaryCard.ts
import React365 from "react";
var useSummaryCard = ({
  content,
  isDiscountCodeFeatureEnabled,
  isWarrantyEnabled,
  isExpanded,
  isSavingsDisplayedWhenClosed
}) => {
  var _a, _b, _c;
  const showOnlyTitleWhenClosed = !(isSavingsDisplayedWhenClosed != null ? isSavingsDisplayedWhenClosed : true);
  const [isExpandedState, setIsExpandedState] = React365.useState(isExpanded != null ? isExpanded : false);
  const [isShippingModalOpen, setIsShippingModalOpen] = React365.useState(false);
  const selectedProduct = useOrderStore((state) => state.selectedProduct);
  const selectedProductPricing = useOrderStore((state) => state.selectedProductPricing);
  const appliedDiscountCode = useOrderStore((state) => state.appliedDiscountCode);
  const isWarrantySelected = useOrderStore((state) => state.isWarrantySelected);
  const setIsWarrantySelected = useOrderStore((state) => state.setIsWarrantySelected);
  const showTopSavings = !showOnlyTitleWhenClosed && !isExpandedState && ((_a = selectedProductPricing == null ? void 0 : selectedProductPricing.savingsValue) != null ? _a : 0) > 0;
  const discountLabel = isDiscountCodeFeatureEnabled && appliedDiscountCode && ((_b = selectedProductPricing == null ? void 0 : selectedProductPricing.discountValue) != null ? _b : 0) > 0 ? `${appliedDiscountCode} (-${selectedProductPricing == null ? void 0 : selectedProductPricing.discountText})` : null;
  const warrantyCheckboxLabel = content.warrantyCheckboxLabelTemplate;
  const showWarrantyToggle = isWarrantyEnabled && ((_c = selectedProduct == null ? void 0 : selectedProduct.warrantyPrice) != null ? _c : 0) > 0 && !!warrantyCheckboxLabel;
  const productTitleSuffix = isWarrantySelected && content.warrantySelectedLabel ? content.warrantySelectedLabel : null;
  return {
    selectedProduct,
    selectedProductPricing,
    isExpandedState,
    showOnlyTitleWhenClosed,
    showTopSavings,
    isShippingModalOpen,
    discountLabel,
    warrantyCheckboxLabel,
    showWarrantyToggle,
    isWarrantySelected,
    productTitleSuffix,
    onToggleExpanded: () => setIsExpandedState((current) => !current),
    onExpand: () => setIsExpandedState(true),
    onOpenShippingModal: () => setIsShippingModalOpen(true),
    onCloseShippingModal: () => setIsShippingModalOpen(false),
    onToggleWarranty: () => setIsWarrantySelected(!isWarrantySelected)
  };
};

// src/checkout/components/organisms/ShippingDeliveryModal.tsx
import React366 from "react";
var DEFAULT_DIALOG_CLASS = "min-h-screen w-full overflow-hidden bg-white";
var DEFAULT_HEADER_CLASS27 = "flex items-center justify-between bg-white px-[20px] py-[14px] md:px-[32px]";
var DEFAULT_LOGO_CLASS10 = "h-[24px] w-auto object-contain md:h-[28px]";
var DEFAULT_CLOSE_BUTTON_CLASS2 = "cursor-pointer flex h-[40px] w-[40px] items-center justify-center rounded-full bg-[#333333] text-white transition-colors hover:bg-[#1f1f1f]";
var DEFAULT_TITLE_BAR_CLASS = "bg-[#333333] px-[20px] py-[14px] text-center text-[28px] font-bold leading-[36px] text-white md:px-[32px] md:py-[12px] md:text-[30px] md:leading-[40px]";
var DEFAULT_CONTENT_SHELL_CLASS = "min-h-[calc(100vh-124px)] bg-[#f5f5f5] px-[16px] py-[24px] md:min-h-[calc(100vh-132px)] md:px-[32px] md:py-[24px]";
var DEFAULT_CONTENT_CARD_CLASS = "mx-auto max-w-[872px] bg-white px-[24px] py-[28px] text-[14px] leading-[1.65] text-[#4f4f4f] shadow-[0_10px_30px_rgba(0,0,0,0.08)] md:px-[40px] md:py-[36px]";
var DEFAULT_SECTION_TITLE_CLASS2 = "mb-[12px] text-[16px] font-bold leading-[24px] text-[#333333]";
var DEFAULT_LIST_CLASS14 = "grid gap-[10px]";
var DEFAULT_LINK_CLASS5 = "text-[#2f59ff] underline";
var DEFAULT_TEXT_BLOCK_CLASS4 = "mt-[24px]";
var ShippingDeliveryModal = ({
  isOpen,
  onClose,
  headerLogoSrc,
  headerLogoAlt = "",
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React366.createElement(
    FullscreenModal,
    {
      isOpen,
      onClose,
      labelledBy: "shipping-delivery-title",
      className: cn(DEFAULT_DIALOG_CLASS, classes.dialog, className)
    },
    /* @__PURE__ */ React366.createElement("div", { className: DEFAULT_HEADER_CLASS27 }, headerLogoSrc ? /* @__PURE__ */ React366.createElement("img", { src: headerLogoSrc, alt: headerLogoAlt, className: DEFAULT_LOGO_CLASS10 }) : /* @__PURE__ */ React366.createElement("div", null), /* @__PURE__ */ React366.createElement(
      "button",
      {
        type: "button",
        onClick: onClose,
        className: DEFAULT_CLOSE_BUTTON_CLASS2,
        "aria-label": "Close shipping and delivery modal"
      },
      /* @__PURE__ */ React366.createElement(CloseIcon, { className: "h-[18px] w-[18px]" })
    )),
    /* @__PURE__ */ React366.createElement("div", { id: "shipping-delivery-title", className: DEFAULT_TITLE_BAR_CLASS }, "Shipping & Delivery"),
    /* @__PURE__ */ React366.createElement("div", { className: DEFAULT_CONTENT_SHELL_CLASS }, /* @__PURE__ */ React366.createElement("div", { className: cn(DEFAULT_CONTENT_CARD_CLASS, classes.content) }, /* @__PURE__ */ React366.createElement("section", null, /* @__PURE__ */ React366.createElement("h2", { className: DEFAULT_SECTION_TITLE_CLASS2 }, "1. Shipping"), /* @__PURE__ */ React366.createElement("ol", { className: DEFAULT_LIST_CLASS14 }, /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "1.1 "), "Shipping costs will be calculated at the checkout."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "1.2 "), "We ship Worldwide. In the event that we are unable to deliver an item to you, we will contact you directly and immediately refund you. If you're unsure, please enquire prior to placing your order."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "1.3 "), "You will receive a confirmation email, containing a tracking ID and a link to follow the journey of your package. To track your package you can visit our", " ", /* @__PURE__ */ React366.createElement(
      "a",
      {
        href: "https://t.trackingmore.com/aefb2e3c",
        target: "_blank",
        rel: "noreferrer noopener",
        className: DEFAULT_LINK_CLASS5
      },
      "Tracking Page here"
    ), ". Please allow 1 to 3 business days for the tracking information to show. If you find any issues with your tracking codes please contact us", " ", /* @__PURE__ */ React366.createElement("a", { href: "/legal/contact-us/", className: DEFAULT_LINK_CLASS5 }, "here"), "."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "1.4 "), "Most items are dispatched within 12 hours. It will take up to 5-12 business days for the delivery of your order. Please consider any holidays or other force majeure situations that might impact delivery times and extend our average delivery times by additional 14 business days."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "1.5 "), "We are not responsible for any shipping deliveries that may be affected by customs, natural occurrences, transfers between our carrier to the local carrier in your country or air and ground transportation strikes or delays, nor any extra fees, customs or back end charges."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "1.6 "), "You will need your order number from your confirmation email when making an inquiry."))), /* @__PURE__ */ React366.createElement("section", { className: DEFAULT_TEXT_BLOCK_CLASS4 }, /* @__PURE__ */ React366.createElement("h2", { className: DEFAULT_SECTION_TITLE_CLASS2 }, "2. Delivery"), /* @__PURE__ */ React366.createElement("ol", { className: DEFAULT_LIST_CLASS14 }, /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "2.1 "), "It is the responsibility of the buyer to make sure that the shipping address entered is correct. We do our best to speed up processing and shipping time, so there is always a small window to correct an incorrect shipping address (usually around 12 hours). Please contact us immediately if you believe you have provided an incorrect shipping address."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "2.2 "), "We are not responsible for lost or stolen packages. If your tracking information states that your package was delivered to your address and you have not received it, please report it to your respective shipping carrier at the information provided to you on our", " ", /* @__PURE__ */ React366.createElement(
      "a",
      {
        href: "https://t.trackingmore.com/aefb2e3c",
        target: "_blank",
        rel: "noreferrer noopener",
        className: DEFAULT_LINK_CLASS5
      },
      "Tracking Page"
    ), "."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "2.3 "), "Not accepting the purchase is a violation of the agreement and the purchase will not be refunded."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "2.4 "), "If you are experiencing problems with the delivery, please reach out to us via contacts provided", " ", /* @__PURE__ */ React366.createElement("a", { href: "mailto:support@therawolf.com", className: DEFAULT_LINK_CLASS5 }, "here"), "."), /* @__PURE__ */ React366.createElement("li", null, /* @__PURE__ */ React366.createElement("strong", null, "2.5 "), "If you are interested in returning the purchase, please check our", " ", /* @__PURE__ */ React366.createElement("a", { href: "/legal/returns-cancellation/", className: DEFAULT_LINK_CLASS5 }, "Returns & Cancellation Policy"), ".")))))
  );
};

// src/checkout/components/organisms/SummaryCardDiscountCode.tsx
import React367 from "react";
var DEFAULT_DISCOUNT_FORM_CLASS = "py-[16px]";
var DEFAULT_DISCOUNT_FORM_ROW_CLASS = "flex items-stretch gap-[12px]";
var DEFAULT_DISCOUNT_INPUT_CLASS = "min-h-[52px] flex-1 rounded-[6px] border px-[16px] py-[15px] text-[14px] leading-[20px] font-normal not-italic outline-none";
var DEFAULT_DISCOUNT_BUTTON_CLASS = "min-h-[52px] rounded-[6px] border px-[20px] py-[15px] text-[14px] leading-[20px] font-bold";
var DEFAULT_DISCOUNT_ERROR_CLASS = "mt-[8px] text-[14px] leading-[20px] font-normal not-italic";
var DEFAULT_APPLIED_CODES_CLASS = "mt-[12px] flex flex-wrap gap-[8px]";
var DEFAULT_APPLIED_CODE_CLASS = "inline-flex items-center gap-[6px] rounded-[6px] border px-[8px] py-[4px]";
var DEFAULT_APPLIED_CODE_TEXT_CLASS = "text-[14px] leading-[20px] font-bold";
var DEFAULT_APPLIED_CODE_ICON_CLASS = "h-[16px] w-[16px]";
var THEMED_DISCOUNT_INPUT_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)] text-[var(--theme-color-heading-primary,#111827)] placeholder:text-[var(--theme-color-text-light,#9CA3AF)] focus:border-[var(--theme-color-accent,#3B82F6)]";
var THEMED_DISCOUNT_BUTTON_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-raised,#F9FAFB)] text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_DISCOUNT_ERROR_CLASS = "text-[var(--theme-color-error,#DC2626)]";
var THEMED_APPLIED_CODE_CLASS = "border-[var(--theme-color-summary-badge-border,#BBF7D0)] bg-[var(--theme-color-summary-badge-background,#f0fdf4)]";
var THEMED_APPLIED_CODE_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_APPLIED_CODE_REMOVE_CLASS = "text-[var(--theme-color-text-light,#9CA3AF)]";
var THEMED_APPLIED_CODE_ICON_CLASS = "text-[var(--theme-color-text-light,#9CA3AF)]";
var SummaryCardDiscountCode = ({
  isEnabled,
  discountCode,
  placeholder,
  applyLabel,
  errorLabel
}) => {
  const [discountInputValue, setDiscountInputValue] = React367.useState("");
  const [discountError, setDiscountError] = React367.useState("");
  const appliedDiscountCode = useOrderStore((state) => state.appliedDiscountCode);
  const applyDiscountCode = useOrderStore((state) => state.applyDiscountCode);
  const removeDiscountCode = useOrderStore((state) => state.removeDiscountCode);
  if (!isEnabled) return null;
  const normalizedDiscountCode = discountCode.trim().toUpperCase();
  const normalizedInputValue = discountInputValue.trim().toUpperCase();
  const handleDiscountSubmit = (event) => {
    event.preventDefault();
    if (!normalizedInputValue || normalizedInputValue !== normalizedDiscountCode) {
      setDiscountError(errorLabel);
      return;
    }
    applyDiscountCode(normalizedDiscountCode);
    setDiscountInputValue("");
    setDiscountError("");
  };
  const handleRemoveDiscount = () => {
    removeDiscountCode();
    setDiscountError("");
  };
  return /* @__PURE__ */ React367.createElement("form", { className: DEFAULT_DISCOUNT_FORM_CLASS, onSubmit: handleDiscountSubmit }, /* @__PURE__ */ React367.createElement("div", { className: DEFAULT_DISCOUNT_FORM_ROW_CLASS }, /* @__PURE__ */ React367.createElement(
    "input",
    {
      type: "text",
      value: discountInputValue,
      onChange: (event) => {
        setDiscountInputValue(event.target.value);
        if (discountError) setDiscountError("");
      },
      placeholder,
      className: cn(DEFAULT_DISCOUNT_INPUT_CLASS, THEMED_DISCOUNT_INPUT_CLASS)
    }
  ), /* @__PURE__ */ React367.createElement(
    "button",
    {
      type: "submit",
      className: cn(DEFAULT_DISCOUNT_BUTTON_CLASS, THEMED_DISCOUNT_BUTTON_CLASS)
    },
    applyLabel
  )), discountError && /* @__PURE__ */ React367.createElement("div", { className: cn(DEFAULT_DISCOUNT_ERROR_CLASS, THEMED_DISCOUNT_ERROR_CLASS) }, discountError), !!appliedDiscountCode && /* @__PURE__ */ React367.createElement("div", { className: DEFAULT_APPLIED_CODES_CLASS }, /* @__PURE__ */ React367.createElement("div", { className: cn(DEFAULT_APPLIED_CODE_CLASS, THEMED_APPLIED_CODE_CLASS) }, /* @__PURE__ */ React367.createElement(
    DoubleTagIcon,
    {
      className: cn(DEFAULT_APPLIED_CODE_ICON_CLASS, THEMED_APPLIED_CODE_ICON_CLASS)
    }
  ), /* @__PURE__ */ React367.createElement("span", { className: cn(DEFAULT_APPLIED_CODE_TEXT_CLASS, THEMED_APPLIED_CODE_TEXT_CLASS) }, appliedDiscountCode), /* @__PURE__ */ React367.createElement(
    "button",
    {
      type: "button",
      className: cn(THEMED_APPLIED_CODE_REMOVE_CLASS),
      onClick: handleRemoveDiscount,
      "aria-label": `Remove ${appliedDiscountCode}`
    },
    /* @__PURE__ */ React367.createElement(CloseIcon, null)
  ))));
};

// src/checkout/components/molecules/SummaryCardProductRow.tsx
import React368 from "react";
var DEFAULT_PRODUCT_ROW_CLASS2 = "grid grid-cols-[auto_1fr_auto] items-start gap-[12px] py-[16px]";
var DEFAULT_PRODUCT_IMAGE_WRAPPER_CLASS = "relative w-[64px] shrink-0";
var DEFAULT_PRODUCT_IMAGE_CLASS4 = "block aspect-square w-full rounded-[4px] border object-cover";
var DEFAULT_PRODUCT_AMOUNT_CLASS = "absolute right-[-8px] top-[-12px] flex h-[22px] min-w-[22px] items-center justify-center rounded-full px-[6px] text-[12px] leading-[16px] font-bold";
var DEFAULT_PRODUCT_INFO_CLASS = "min-w-0 self-start pt-[2px]";
var DEFAULT_PRODUCT_TITLE_CLASS = "text-[14px] leading-[20px] font-bold";
var DEFAULT_PRODUCT_DISCOUNT_CLASS = "mt-[4px] flex items-center gap-[4px] text-[12px] leading-[16px] font-normal not-italic";
var DEFAULT_PRODUCT_PRICE_CLASS = "self-start pt-[2px] text-right";
var DEFAULT_OLD_PRICE_CLASS2 = "mb-[4px] block whitespace-nowrap text-[12px] leading-[16px] font-normal not-italic line-through";
var DEFAULT_CURRENT_PRICE_CLASS = "block whitespace-nowrap text-[14px] leading-[20px] font-medium not-italic";
var THEMED_IMAGE_BORDER_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)]";
var THEMED_AMOUNT_BG_CLASS = "bg-[var(--theme-color-success,#059669)]";
var THEMED_AMOUNT_TEXT_CLASS = "text-[var(--theme-color-text-inverse,#ffffff)]";
var THEMED_TITLE_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_MUTED_TEXT_CLASS = "text-[var(--theme-color-text-light,#9CA3AF)]";
var SummaryCardProductRow = ({
  product,
  pricing,
  discountLabel,
  titleSuffix,
  combinedVariantGroup,
  variantLabel,
  className
}) => {
  var _a, _b;
  const imageUrl = (_a = combinedVariantGroup == null ? void 0 : combinedVariantGroup.imageUrl) != null ? _a : product.imageUrl;
  const imageAlt = variantLabel != null ? variantLabel : product.name;
  const amountBadge = (_b = combinedVariantGroup == null ? void 0 : combinedVariantGroup.count) != null ? _b : product.amount;
  return /* @__PURE__ */ React368.createElement("div", { className: cn(DEFAULT_PRODUCT_ROW_CLASS2, className) }, /* @__PURE__ */ React368.createElement("div", { className: DEFAULT_PRODUCT_IMAGE_WRAPPER_CLASS }, /* @__PURE__ */ React368.createElement(
    "img",
    {
      src: imageUrl,
      alt: imageAlt,
      className: cn(DEFAULT_PRODUCT_IMAGE_CLASS4, THEMED_IMAGE_BORDER_CLASS)
    }
  ), /* @__PURE__ */ React368.createElement(
    "span",
    {
      className: cn(
        DEFAULT_PRODUCT_AMOUNT_CLASS,
        THEMED_AMOUNT_BG_CLASS,
        THEMED_AMOUNT_TEXT_CLASS
      )
    },
    amountBadge
  )), /* @__PURE__ */ React368.createElement("div", { className: DEFAULT_PRODUCT_INFO_CLASS }, /* @__PURE__ */ React368.createElement("div", { className: cn(DEFAULT_PRODUCT_TITLE_CLASS, THEMED_TITLE_TEXT_CLASS) }, product.name, titleSuffix ? ` ${titleSuffix}` : ""), variantLabel && /* @__PURE__ */ React368.createElement("div", { className: cn(DEFAULT_PRODUCT_DISCOUNT_CLASS, THEMED_MUTED_TEXT_CLASS) }, /* @__PURE__ */ React368.createElement("span", null, variantLabel)), discountLabel && /* @__PURE__ */ React368.createElement("div", { className: cn(DEFAULT_PRODUCT_DISCOUNT_CLASS, THEMED_MUTED_TEXT_CLASS) }, /* @__PURE__ */ React368.createElement(DoubleTagIcon, { className: cn("h-[16px] w-[16px]", THEMED_MUTED_TEXT_CLASS) }), /* @__PURE__ */ React368.createElement("span", null, discountLabel))), /* @__PURE__ */ React368.createElement("div", { className: DEFAULT_PRODUCT_PRICE_CLASS }, pricing.oldPriceText && /* @__PURE__ */ React368.createElement("span", { className: cn(DEFAULT_OLD_PRICE_CLASS2, THEMED_MUTED_TEXT_CLASS) }, pricing.oldPriceText), /* @__PURE__ */ React368.createElement("span", { className: cn(DEFAULT_CURRENT_PRICE_CLASS, THEMED_TITLE_TEXT_CLASS) }, pricing.subtotalText)));
};

// src/checkout/components/molecules/SummaryCardTopSavings.tsx
import React369 from "react";
var DEFAULT_TOP_SAVINGS_CLASS = "grid cursor-pointer overflow-hidden transition-[max-height,opacity,margin-bottom,padding-bottom] duration-300 ease-in-out";
var TOP_SAVINGS_VISIBLE_CLASS = "mb-[16px] max-h-[56px] border-b pb-[16px] opacity-100";
var TOP_SAVINGS_HIDDEN_CLASS = "mb-0 max-h-0 border-b-0 pb-0 opacity-0";
var DEFAULT_TOP_SAVINGS_INNER_CLASS = "flex items-center justify-between";
var DEFAULT_TOP_SAVINGS_LABEL_CLASS = "text-[14px] leading-[20px] font-normal not-italic";
var DEFAULT_TOP_SAVINGS_VALUE_CLASS = "text-[14px] leading-[20px] font-normal not-italic";
var THEMED_VISIBLE_BORDER_CLASS = "border-[var(--theme-color-bg-section,#F3F4F6)]";
var THEMED_LABEL_TEXT_CLASS = "text-[var(--theme-color-success,#059669)]";
var THEMED_VALUE_TEXT_CLASS = "text-[var(--theme-color-success,#059669)]";
var SummaryCardTopSavings = ({
  isVisible,
  label,
  value,
  onExpand,
  className
}) => {
  return /* @__PURE__ */ React369.createElement(
    "div",
    {
      className: cn(
        DEFAULT_TOP_SAVINGS_CLASS,
        isVisible ? cn(TOP_SAVINGS_VISIBLE_CLASS, THEMED_VISIBLE_BORDER_CLASS) : TOP_SAVINGS_HIDDEN_CLASS,
        className
      ),
      "aria-hidden": !isVisible,
      onClick: onExpand
    },
    /* @__PURE__ */ React369.createElement("div", { className: DEFAULT_TOP_SAVINGS_INNER_CLASS }, /* @__PURE__ */ React369.createElement("div", { className: cn(DEFAULT_TOP_SAVINGS_LABEL_CLASS, THEMED_LABEL_TEXT_CLASS) }, label), /* @__PURE__ */ React369.createElement("div", { className: cn(DEFAULT_TOP_SAVINGS_VALUE_CLASS, THEMED_VALUE_TEXT_CLASS) }, value))
  );
};

// src/checkout/components/molecules/SummaryCardTotals.tsx
import React370 from "react";
var DEFAULT_TOTALS_CLASS = "pt-[16px]";
var DEFAULT_TOTAL_ROW_CLASS = "flex items-center justify-between gap-[16px] text-[14px] leading-[20px] font-normal not-italic";
var DEFAULT_TOTAL_ROW_STACK_CLASS = "grid gap-[10px]";
var DEFAULT_SHIPPING_LABEL_CLASS = "inline-flex items-center gap-[4px]";
var DEFAULT_HELP_BUTTON_CLASS = "cursor-pointer";
var DEFAULT_DIVIDER_SPACER_CLASS = "mt-[16px]";
var DEFAULT_DIVIDER_CLASS20 = "h-px";
var DEFAULT_SAVINGS_ROW_CLASS = "mt-[16px] flex items-center justify-between text-[14px] leading-[20px] font-normal not-italic";
var DEFAULT_TOTAL_ROW_FINAL_CLASS = "mt-[16px] flex items-center justify-between text-[18px] leading-[24px] font-bold not-italic";
var THEMED_TOTAL_ROW_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_HELP_BUTTON_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DIVIDER_BG_CLASS = "bg-[var(--theme-color-bg-section,#F3F4F6)]";
var THEMED_SAVINGS_ROW_TEXT_CLASS = "text-[var(--theme-color-success,#059669)]";
var THEMED_TOTAL_ROW_FINAL_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var SummaryCardTotals = ({
  pricing,
  subtotalLabel,
  shippingLabel,
  totalSavingsLabel,
  totalLabel,
  onOpenShippingModal,
  className,
  dividerClassName
}) => {
  return /* @__PURE__ */ React370.createElement("div", { className: cn(DEFAULT_TOTALS_CLASS, className) }, /* @__PURE__ */ React370.createElement("div", { className: DEFAULT_TOTAL_ROW_STACK_CLASS }, /* @__PURE__ */ React370.createElement("div", { className: cn(DEFAULT_TOTAL_ROW_CLASS, THEMED_TOTAL_ROW_TEXT_CLASS) }, /* @__PURE__ */ React370.createElement("span", null, subtotalLabel), /* @__PURE__ */ React370.createElement("span", null, pricing.subtotalText)), /* @__PURE__ */ React370.createElement("div", { className: cn(DEFAULT_TOTAL_ROW_CLASS, THEMED_TOTAL_ROW_TEXT_CLASS) }, /* @__PURE__ */ React370.createElement("span", { className: DEFAULT_SHIPPING_LABEL_CLASS }, /* @__PURE__ */ React370.createElement("span", null, shippingLabel), /* @__PURE__ */ React370.createElement(
    "button",
    {
      type: "button",
      className: cn(DEFAULT_HELP_BUTTON_CLASS, THEMED_HELP_BUTTON_TEXT_CLASS),
      "aria-label": "Shipping information",
      onClick: onOpenShippingModal
    },
    /* @__PURE__ */ React370.createElement(QuestionMarkCircleIcon, null)
  )), /* @__PURE__ */ React370.createElement("span", null, pricing.shippingText))), /* @__PURE__ */ React370.createElement("div", { className: DEFAULT_DIVIDER_SPACER_CLASS }, /* @__PURE__ */ React370.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS20, THEMED_DIVIDER_BG_CLASS, dividerClassName) })), /* @__PURE__ */ React370.createElement("div", { className: cn(DEFAULT_SAVINGS_ROW_CLASS, THEMED_SAVINGS_ROW_TEXT_CLASS) }, /* @__PURE__ */ React370.createElement("span", null, totalSavingsLabel), /* @__PURE__ */ React370.createElement("span", null, "-", pricing.savingsText)), /* @__PURE__ */ React370.createElement("div", { className: cn(DEFAULT_TOTAL_ROW_FINAL_CLASS, THEMED_TOTAL_ROW_FINAL_TEXT_CLASS) }, /* @__PURE__ */ React370.createElement("span", null, totalLabel), /* @__PURE__ */ React370.createElement("span", null, pricing.totalText)));
};

// src/checkout/components/molecules/SummaryCardTrigger.tsx
import React372 from "react";

// src/checkout/components/atoms/ProductVariantChevronIcon.tsx
import React371 from "react";
var DEFAULT_ICON_CLASS34 = "h-[6px] w-[10px] shrink-0 transition-transform duration-200";
var EXPANDED_ICON_CLASS = "rotate-180";
var ProductVariantChevronIcon = ({
  isExpanded = false,
  className
}) => {
  return /* @__PURE__ */ React371.createElement(
    "svg",
    {
      className: cn(DEFAULT_ICON_CLASS34, isExpanded && EXPANDED_ICON_CLASS, className),
      width: "10",
      height: "6",
      viewBox: "0 0 10 6",
      fill: "none",
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React371.createElement(
      "path",
      {
        d: "M4.99999 5.5C4.84317 5.5 4.68637 5.43998 4.56681 5.32018L0.804499 1.5486C0.565167 1.30868 0.565167 0.919689 0.804499 0.679867C1.04373 0.440044 1.43169 0.440044 1.67104 0.679867L4.99999 4.01717L8.32895 0.679983C8.56828 0.440161 8.9562 0.440161 9.19541 0.679983C9.43486 0.919806 9.43486 1.30879 9.19541 1.54871L5.43316 5.3203C5.31354 5.44011 5.15675 5.5 4.99999 5.5Z",
        fill: "currentColor"
      }
    )
  );
};

// src/checkout/components/molecules/SummaryCardTrigger.tsx
var DEFAULT_TRIGGER_CLASS = "flex w-full cursor-pointer items-center justify-between gap-[16px] text-left";
var DEFAULT_TRIGGER_TITLE_CLASS = "flex items-center gap-[8px] text-[14px] leading-[20px] font-normal not-italic";
var DEFAULT_TRIGGER_RIGHT_CLASS = "ml-auto";
var DEFAULT_TRIGGER_TOTAL_CLASS = "text-[14px] leading-[20px] font-normal not-italic";
var DEFAULT_CHEVRON_CLASS2 = "h-[8px] w-[12px]";
var THEMED_TRIGGER_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_TRIGGER_TOTAL_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_CHEVRON_TEXT_CLASS = "text-[var(--theme-color-text-light,#9CA3AF)]";
var SummaryCardTrigger = ({
  title,
  totalText,
  isExpanded,
  showOnlyTitleWhenClosed,
  onToggle,
  className
}) => {
  const isTitleOnlyClosed = showOnlyTitleWhenClosed && !isExpanded;
  const showHeaderPrice = !showOnlyTitleWhenClosed;
  const chevron = /* @__PURE__ */ React372.createElement(
    ProductVariantChevronIcon,
    {
      isExpanded,
      className: cn(DEFAULT_CHEVRON_CLASS2, THEMED_CHEVRON_TEXT_CLASS)
    }
  );
  return /* @__PURE__ */ React372.createElement(
    "button",
    {
      type: "button",
      className: cn(DEFAULT_TRIGGER_CLASS, THEMED_TRIGGER_TEXT_CLASS, className),
      onClick: onToggle,
      "aria-expanded": isExpanded
    },
    /* @__PURE__ */ React372.createElement("span", { className: DEFAULT_TRIGGER_TITLE_CLASS }, /* @__PURE__ */ React372.createElement("span", null, title), !isTitleOnlyClosed && chevron),
    /* @__PURE__ */ React372.createElement("span", { className: DEFAULT_TRIGGER_RIGHT_CLASS }, showHeaderPrice && /* @__PURE__ */ React372.createElement("span", { className: cn(DEFAULT_TRIGGER_TOTAL_CLASS, THEMED_TRIGGER_TOTAL_TEXT_CLASS) }, totalText), isTitleOnlyClosed && chevron)
  );
};

// src/checkout/components/molecules/SummaryCardWarrantyToggle.tsx
import React373 from "react";
var DEFAULT_ROOT_CLASS63 = "py-[16px]";
var DEFAULT_BUTTON_CLASS12 = "flex w-full items-start gap-[10px] text-left text-[14px] leading-[24px] font-normal cursor-pointer";
var DEFAULT_CHECKBOX_CLASS2 = "mt-[3px] flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[4px] border bg-white";
var DEFAULT_CHECKBOX_ACTIVE_CLASS = "text-white";
var DEFAULT_CHECKBOX_ICON_CLASS = "text-[12px] leading-none";
var THEMED_BUTTON_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_CHECKBOX_BORDER_CLASS = "border-[var(--theme-color-bg-section,#F3F4F6)]";
var THEMED_CHECKBOX_ACTIVE_BORDER_CLASS = "border-[var(--theme-color-heading-primary,#111827)]";
var THEMED_CHECKBOX_ACTIVE_BG_CLASS = "bg-[var(--theme-color-heading-primary,#111827)]";
var SummaryCardWarrantyToggle = ({
  label,
  isSelected,
  onToggle,
  className
}) => {
  return /* @__PURE__ */ React373.createElement("div", { className: cn(DEFAULT_ROOT_CLASS63, className) }, /* @__PURE__ */ React373.createElement(
    "button",
    {
      type: "button",
      className: cn(DEFAULT_BUTTON_CLASS12, THEMED_BUTTON_TEXT_CLASS),
      onClick: onToggle
    },
    /* @__PURE__ */ React373.createElement(
      "span",
      {
        className: cn(
          DEFAULT_CHECKBOX_CLASS2,
          THEMED_CHECKBOX_BORDER_CLASS,
          isSelected && cn(
            DEFAULT_CHECKBOX_ACTIVE_CLASS,
            THEMED_CHECKBOX_ACTIVE_BORDER_CLASS,
            THEMED_CHECKBOX_ACTIVE_BG_CLASS
          )
        ),
        "aria-hidden": "true"
      },
      isSelected ? /* @__PURE__ */ React373.createElement("span", { className: DEFAULT_CHECKBOX_ICON_CLASS }, "\u2713") : null
    ),
    /* @__PURE__ */ React373.createElement("span", null, label)
  ));
};

// src/checkout/components/organisms/SummaryCard.tsx
var DEFAULT_CARD_CLASS15 = "rounded-[8px] border px-[18px] py-[16px]";
var DEFAULT_CONTENT_CLASS24 = "grid transition-[grid-template-rows,opacity] duration-300 ease-out";
var CONTENT_OPEN_CLASS = "grid-rows-[1fr] opacity-100";
var CONTENT_CLOSED_CLASS = "grid-rows-[0fr] opacity-0";
var DEFAULT_CONTENT_INNER_CLASS = "min-h-0 overflow-hidden";
var DEFAULT_CONTENT_BODY_CLASS = "pt-[16px]";
var DEFAULT_DIVIDER_CLASS21 = "h-px";
var THEMED_CARD_CLASS3 = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_DIVIDER_CLASS3 = "bg-[var(--theme-color-bg-section,#F3F4F6)]";
var SummaryCard = ({
  content,
  isDiscountCodeFeatureEnabled,
  isWarrantyEnabled,
  isExpanded,
  isSavingsDisplayedWhenClosed,
  discountCode = "",
  headerLogoSrc,
  headerLogoAlt,
  rootRef,
  className,
  classes = {}
}) => {
  var _a, _b, _c;
  const combinedVariantGroups = useOrderStore((state) => state.selectedCombinedProductVariants);
  const productVariants = useOrderStore((state) => state.productVariants);
  const {
    selectedProduct,
    selectedProductPricing,
    isExpandedState,
    showOnlyTitleWhenClosed,
    showTopSavings,
    isShippingModalOpen,
    discountLabel,
    warrantyCheckboxLabel,
    showWarrantyToggle,
    isWarrantySelected,
    productTitleSuffix,
    onToggleExpanded,
    onExpand,
    onOpenShippingModal,
    onCloseShippingModal,
    onToggleWarranty
  } = useSummaryCard({
    content,
    isDiscountCodeFeatureEnabled,
    isWarrantyEnabled,
    isExpanded,
    isSavingsDisplayedWhenClosed
  });
  if (!selectedProduct || !selectedProductPricing) return null;
  return /* @__PURE__ */ React374.createElement(
    "section",
    {
      ref: rootRef,
      className: cn(DEFAULT_CARD_CLASS15, THEMED_CARD_CLASS3, classes.root, className)
    },
    selectedProductPricing.savingsValue > 0 && /* @__PURE__ */ React374.createElement(
      SummaryCardTopSavings,
      {
        isVisible: showTopSavings,
        label: content.totalSavingsLabel,
        value: selectedProductPricing.savingsText,
        onExpand,
        className: classes.topSavings
      }
    ),
    /* @__PURE__ */ React374.createElement(
      SummaryCardTrigger,
      {
        title: content.title,
        totalText: selectedProductPricing.totalText,
        isExpanded: isExpandedState,
        showOnlyTitleWhenClosed,
        onToggle: onToggleExpanded,
        className: classes.trigger
      }
    ),
    /* @__PURE__ */ React374.createElement(
      "div",
      {
        className: cn(
          DEFAULT_CONTENT_CLASS24,
          isExpandedState ? CONTENT_OPEN_CLASS : CONTENT_CLOSED_CLASS,
          classes.content
        ),
        "aria-hidden": !isExpandedState
      },
      /* @__PURE__ */ React374.createElement("div", { className: DEFAULT_CONTENT_INNER_CLASS }, /* @__PURE__ */ React374.createElement("div", { className: DEFAULT_CONTENT_BODY_CLASS }, /* @__PURE__ */ React374.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS21, THEMED_DIVIDER_CLASS3, classes.divider) }), combinedVariantGroups.length > 0 ? combinedVariantGroups.map((group) => /* @__PURE__ */ React374.createElement(
        SummaryCardProductRow,
        {
          key: group.konnVariantId,
          product: selectedProduct,
          pricing: getVariantGroupPricing(group, selectedProduct, selectedProductPricing),
          discountLabel,
          titleSuffix: productTitleSuffix,
          combinedVariantGroup: group,
          variantLabel: productVariants ? getCombinedVariantLabel(group.attributes, productVariants) : void 0,
          className: classes.productRow
        }
      )) : /* @__PURE__ */ React374.createElement(
        SummaryCardProductRow,
        {
          product: selectedProduct,
          pricing: selectedProductPricing,
          discountLabel,
          titleSuffix: productTitleSuffix,
          className: classes.productRow
        }
      ), /* @__PURE__ */ React374.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS21, THEMED_DIVIDER_CLASS3, classes.divider) }), showWarrantyToggle && /* @__PURE__ */ React374.createElement(React374.Fragment, null, /* @__PURE__ */ React374.createElement(
        SummaryCardWarrantyToggle,
        {
          label: warrantyCheckboxLabel,
          isSelected: isWarrantySelected,
          onToggle: onToggleWarranty,
          className: classes.warranty
        }
      ), /* @__PURE__ */ React374.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS21, THEMED_DIVIDER_CLASS3, classes.divider) })), isDiscountCodeFeatureEnabled && /* @__PURE__ */ React374.createElement(React374.Fragment, null, /* @__PURE__ */ React374.createElement(
        SummaryCardDiscountCode,
        {
          isEnabled: isDiscountCodeFeatureEnabled,
          discountCode,
          placeholder: (_a = content.discountPlaceholder) != null ? _a : "",
          applyLabel: (_b = content.discountApplyLabel) != null ? _b : "",
          errorLabel: (_c = content.discountErrorLabel) != null ? _c : ""
        }
      ), /* @__PURE__ */ React374.createElement("div", { className: cn(DEFAULT_DIVIDER_CLASS21, THEMED_DIVIDER_CLASS3, classes.divider) })), /* @__PURE__ */ React374.createElement(
        SummaryCardTotals,
        {
          pricing: selectedProductPricing,
          subtotalLabel: content.subtotalLabel,
          shippingLabel: content.shippingLabel,
          totalSavingsLabel: content.totalSavingsLabel,
          totalLabel: content.totalLabel,
          onOpenShippingModal,
          className: classes.totals,
          dividerClassName: classes.divider
        }
      )))
    ),
    /* @__PURE__ */ React374.createElement(
      ShippingDeliveryModal,
      {
        isOpen: isShippingModalOpen,
        onClose: onCloseShippingModal,
        headerLogoSrc,
        headerLogoAlt
      }
    )
  );
};

// src/checkout/components/elements/ElementOrderSummary.tsx
var DEFAULT_ROOT_CLASS64 = "my-4";
var ElementOrderSummary = ({
  elementConfig,
  schemaConfig,
  classes = {}
}) => {
  var _a, _b, _c, _d;
  const { registerScrollTarget } = useCheckoutSectionNavigation();
  const { content, config } = elementConfig;
  return /* @__PURE__ */ React375.createElement(
    SummaryCard,
    {
      rootRef: registerScrollTarget,
      content,
      isDiscountCodeFeatureEnabled: !!schemaConfig.isDiscountCodeFeatureEnabled && ((_a = config.isDiscountInputEnabled) != null ? _a : true),
      isWarrantyEnabled: schemaConfig.isWarrantyEnabled && ((_b = config.isWarrantyToggleEnabled) != null ? _b : true),
      discountCode: schemaConfig.discountCode,
      isExpanded: config.isExpanded,
      isSavingsDisplayedWhenClosed: config.isSavingsDisplayedWhenClosed,
      headerLogoSrc: (_c = schemaConfig.logo) == null ? void 0 : _c.src,
      headerLogoAlt: (_d = schemaConfig.logo) == null ? void 0 : _d.alt,
      classes: { root: cn(DEFAULT_ROOT_CLASS64, classes.root) }
    }
  );
};

// src/checkout/components/elements/ElementProductList.tsx
import React414 from "react";

// src/checkout/components/molecules/CheckoutSectionHeading.tsx
import React376 from "react";
var DEFAULT_ROOT_CLASS65 = "flex items-center justify-between gap-[14px]";
var DEFAULT_HEADING_CLASS18 = "text-[24px] font-black leading-[29px] text-current";
var CheckoutSectionHeading = ({
  title,
  action,
  as = "h2",
  className,
  classes = {}
}) => {
  const HeadingTag = as;
  return /* @__PURE__ */ React376.createElement("div", { className: cn(DEFAULT_ROOT_CLASS65, classes.root, className) }, /* @__PURE__ */ React376.createElement(HeadingTag, { className: cn(DEFAULT_HEADING_CLASS18, classes.heading) }, title), action);
};

// src/checkout/components/organisms/ProductList.tsx
import React413 from "react";

// src/checkout/components/organisms/ProductItemVariant1.tsx
import React399 from "react";
import { useShallow as useShallow2 } from "zustand/react/shallow";

// src/checkout/components/molecules/ProductItemVariant1Info.tsx
import React382 from "react";

// src/checkout/components/atoms/ProductItemVariant1Image.tsx
import React377 from "react";
var DEFAULT_WRAPPER_CLASS10 = "flex size-[64px] shrink-0 self-center items-center justify-center lg:size-[85px]";
var DEFAULT_IMAGE_CLASS32 = "size-[64px] object-contain lg:size-[85px]";
var ProductItemVariant1Image = ({
  src,
  alt,
  className,
  classes = {}
}) => {
  if (!src) return null;
  return /* @__PURE__ */ React377.createElement("div", { className: cn(DEFAULT_WRAPPER_CLASS10, classes.wrapper) }, /* @__PURE__ */ React377.createElement("img", { src, alt, className: cn(DEFAULT_IMAGE_CLASS32, classes.image, className) }));
};

// src/checkout/components/molecules/ProductItemVariant1Summary.tsx
import React381 from "react";

// src/checkout/components/atoms/ProductItemVariant1Amount.tsx
import React378 from "react";
var DEFAULT_AMOUNT_CLASS = "block text-[28px] font-black leading-[28px] lg:text-[32px] lg:leading-[32px]";
var THEMED_TEXT_CLASS13 = "text-[var(--theme-color-text-primary,#000000)]";
var ProductItemVariant1Amount = ({
  amount,
  className
}) => {
  return /* @__PURE__ */ React378.createElement("span", { className: cn(DEFAULT_AMOUNT_CLASS, THEMED_TEXT_CLASS13, className) }, amount, "x");
};

// src/checkout/components/atoms/ProductItemVariant1Name.tsx
import React379 from "react";
var DEFAULT_NAME_CLASS5 = "block pt-[4px] text-[12px] font-bold leading-[16px] lg:text-[16px] lg:leading-[20px]";
var THEMED_TEXT_CLASS14 = "text-[var(--theme-color-text-primary,#000000)]";
var ProductItemVariant1Name = ({ text, className }) => {
  return /* @__PURE__ */ React379.createElement("span", { className: cn(DEFAULT_NAME_CLASS5, THEMED_TEXT_CLASS14, className) }, text);
};

// src/checkout/components/molecules/ProductItemVariant1DiscountPill.tsx
import React380 from "react";
var DEFAULT_PILL_CLASS = "inline-flex h-[28px] w-[66px] flex-nowrap items-center gap-[5px] rounded-[6px] border px-[8px] text-[12px] leading-[14px] lg:w-[82px]";
var DESKTOP_PILL_CLASS = "h-[38px] justify-center gap-[6px] px-[14px] text-[14px]";
var DEFAULT_TEXT_CLASS21 = "whitespace-nowrap font-medium";
var DEFAULT_ICON_CLASS35 = "h-[14px] w-[14px] shrink-0";
var DESKTOP_ICON_CLASS = "h-[16px] w-[16px]";
var THEMED_PILL_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)] text-[var(--theme-color-text-primary,#000000)]";
var ProductItemVariant1DiscountPill = ({
  discountPercent,
  variant = "compact",
  className,
  classes = {}
}) => {
  const isDesktop = variant === "desktop";
  return /* @__PURE__ */ React380.createElement(
    "div",
    {
      className: cn(
        DEFAULT_PILL_CLASS,
        THEMED_PILL_CLASS,
        isDesktop && DESKTOP_PILL_CLASS,
        classes.root,
        className
      )
    },
    /* @__PURE__ */ React380.createElement(
      DoubleTagIcon,
      {
        className: cn(DEFAULT_ICON_CLASS35, isDesktop && DESKTOP_ICON_CLASS, classes.icon)
      }
    ),
    /* @__PURE__ */ React380.createElement("span", { className: cn(DEFAULT_TEXT_CLASS21, classes.text) }, discountPercent, " %")
  );
};

// src/checkout/components/molecules/ProductItemVariant1Summary.tsx
var DEFAULT_SUMMARY_CLASS2 = "flex min-w-0 flex-1 items-center justify-center px-[8px] py-[10px] lg:px-[18px]";
var DEFAULT_TEXT_STACK_CLASS = "min-w-0 text-center";
var DEFAULT_PILL_MOBILE_CLASS = "mt-[8px] lg:hidden";
var DEFAULT_PILL_DESKTOP_CLASS = "my-[10px] hidden shrink-0 items-center justify-center border-x px-[18px] lg:my-[12px] lg:flex lg:px-[28px]";
var THEMED_PILL_DESKTOP_BORDER_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)]";
var ProductItemVariant1Summary = ({
  amount,
  name,
  discountPercent,
  className,
  classes = {}
}) => {
  var _a;
  return /* @__PURE__ */ React381.createElement(React381.Fragment, null, /* @__PURE__ */ React381.createElement("div", { className: cn(DEFAULT_SUMMARY_CLASS2, classes.root, className) }, /* @__PURE__ */ React381.createElement("div", { className: cn(DEFAULT_TEXT_STACK_CLASS, classes.textStack) }, /* @__PURE__ */ React381.createElement(ProductItemVariant1Amount, { amount, className: classes.amount }), /* @__PURE__ */ React381.createElement(ProductItemVariant1Name, { text: name, className: classes.name }), !!discountPercent && /* @__PURE__ */ React381.createElement(
    ProductItemVariant1DiscountPill,
    {
      discountPercent,
      className: classes.pillMobile,
      classes: { ...classes.pill, root: cn(DEFAULT_PILL_MOBILE_CLASS, (_a = classes.pill) == null ? void 0 : _a.root) }
    }
  ))), !!discountPercent && /* @__PURE__ */ React381.createElement(
    "div",
    {
      className: cn(
        DEFAULT_PILL_DESKTOP_CLASS,
        THEMED_PILL_DESKTOP_BORDER_CLASS,
        classes.pillDesktop
      )
    },
    /* @__PURE__ */ React381.createElement(
      ProductItemVariant1DiscountPill,
      {
        discountPercent,
        variant: "desktop",
        classes: classes.pill
      }
    )
  ));
};

// src/checkout/components/molecules/ProductItemVariant1Info.tsx
var DEFAULT_INFO_CLASS2 = "flex min-w-0 flex-1 items-stretch pl-[10px] pr-0 lg:pl-[18px]";
var ProductItemVariant1Info = ({
  image,
  summary,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React382.createElement("div", { className: cn(DEFAULT_INFO_CLASS2, classes.root, className) }, /* @__PURE__ */ React382.createElement(ProductItemVariant1Image, { src: image.src, alt: image.alt, classes: classes.image }), /* @__PURE__ */ React382.createElement(ProductItemVariant1Summary, { ...summary, classes: classes.summary }));
};

// src/checkout/components/molecules/ProductItemVariant1DropdownContent.tsx
import React383 from "react";
var DEFAULT_ROOT_CLASS66 = "grid transition-[grid-template-rows,opacity] duration-300 ease-out rounded-[6px]";
var ROOT_OPEN_CLASS = "grid-rows-[1fr] overflow-visible opacity-100";
var ROOT_CLOSED_CLASS = "pointer-events-none grid-rows-[0fr] overflow-hidden opacity-0";
var DEFAULT_INNER_CLASS17 = "min-h-0";
var DEFAULT_SECTION_CLASS46 = "px-[12px] py-[16px]";
var DEFAULT_SEPARATOR_CLASS2 = "mb-[16px] h-[1px]";
var DEFAULT_TITLE_CLASS27 = "mb-[8px] text-[14px] leading-[20px] font-medium";
var DEFAULT_MESSAGE_CLASS2 = "text-[12px] leading-[16px] font-normal";
var THEMED_ROOT_BG_CLASS = "bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var THEMED_SEPARATOR_CLASS2 = "bg-[var(--theme-color-border-light,#E5E7EB)]";
var THEMED_TITLE_CLASS8 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_MESSAGE_CLASS2 = "text-[var(--theme-color-text-light,#9CA3AF)]";
var ProductItemVariant1DropdownContent = ({
  isOpen,
  title,
  message,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React383.createElement(
    "div",
    {
      className: cn(
        DEFAULT_ROOT_CLASS66,
        THEMED_ROOT_BG_CLASS,
        isOpen ? ROOT_OPEN_CLASS : ROOT_CLOSED_CLASS,
        classes.root,
        className
      ),
      "aria-hidden": !isOpen
    },
    /* @__PURE__ */ React383.createElement("div", { className: cn(DEFAULT_INNER_CLASS17, classes.inner) }, /* @__PURE__ */ React383.createElement("section", { className: cn(DEFAULT_SECTION_CLASS46, classes.section, classes.container) }, /* @__PURE__ */ React383.createElement("div", { className: cn(DEFAULT_SEPARATOR_CLASS2, THEMED_SEPARATOR_CLASS2, classes.separator) }), /* @__PURE__ */ React383.createElement("div", { className: cn(DEFAULT_TITLE_CLASS27, THEMED_TITLE_CLASS8, classes.title) }, title), /* @__PURE__ */ React383.createElement("div", { className: cn(DEFAULT_MESSAGE_CLASS2, THEMED_MESSAGE_CLASS2, classes.message) }, message)))
  );
};

// src/checkout/components/organisms/ProductItemVariant1VariantGroups.tsx
import React398 from "react";

// src/checkout/components/organisms/ProductItemVariant1VariantGroupItem.tsx
import React397 from "react";

// src/checkout/components/molecules/ProductItemVariant1Variants.tsx
import React396 from "react";

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariants.tsx
import React388 from "react";

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariantsHeader.tsx
import React385 from "react";

// src/checkout/components/atoms/ProductVariantLink.tsx
import React384 from "react";
var DEFAULT_LINK_CLASS6 = "inline-flex items-center gap-[6px] text-center text-[12px] font-normal leading-[20px] underline";
var DEFAULT_IMAGE_CLASS33 = "h-[14px] w-auto shrink-0";
var THEMED_LINK_CLASS = "text-[var(--theme-color-accent,#3B82F6)] visited:text-[var(--theme-color-accent,#3B82F6)]";
var ProductVariantLink = ({ link, className }) => {
  return /* @__PURE__ */ React384.createElement("a", { className: cn(DEFAULT_LINK_CLASS6, THEMED_LINK_CLASS, className), href: link.href }, link.label, link.image && /* @__PURE__ */ React384.createElement("img", { src: link.image, className: DEFAULT_IMAGE_CLASS33, alt: link.label }));
};

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariantsHeader.tsx
var THEMED_HEADING_CLASS3 = "text-[var(--theme-color-heading-primary,#111827)]";
var ProductItemVariant1CheckoutVariantsHeader = ({
  heading,
  variantLink
}) => {
  return /* @__PURE__ */ React385.createElement(
    CheckoutSectionHeading,
    {
      as: "h3",
      title: heading,
      action: variantLink ? /* @__PURE__ */ React385.createElement(ProductVariantLink, { link: variantLink }) : void 0,
      classes: { heading: THEMED_HEADING_CLASS3 }
    }
  );
};

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariantsOptions.tsx
import React387 from "react";

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariantsOption.tsx
import React386 from "react";
var THEMED_OPTION_CLASS = "border-[var(--theme-color-border,#9CA3AF)] bg-[var(--theme-color-bg-page,#ffffff)] text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_OPTION_ACTIVE_CLASS = "border-[var(--theme-color-accent,#3B82F6)] bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var THEMED_RADIO_INDICATOR_CLASS = "border-[var(--theme-color-border,#9CA3AF)] bg-[var(--theme-color-bg-page,#ffffff)] before:bg-[var(--theme-color-accent,#3B82F6)]";
var THEMED_RADIO_ACTIVE_CLASS2 = "border-[var(--theme-color-accent,#3B82F6)]";
var ProductItemVariant1CheckoutVariantsOption = ({
  variant,
  isSelected = false,
  onSelect
}) => {
  return /* @__PURE__ */ React386.createElement(
    SelectableRadioOption,
    {
      isSelected,
      label: variant.label,
      onClick: () => onSelect(variant.value),
      classes: {
        root: THEMED_OPTION_CLASS,
        active: THEMED_OPTION_ACTIVE_CLASS,
        radioIndicator: THEMED_RADIO_INDICATOR_CLASS,
        radioActive: THEMED_RADIO_ACTIVE_CLASS2
      }
    }
  );
};

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariantsOptions.tsx
var DEFAULT_FORM_CLASS = "grid gap-[14px]";
var ONE_COLUMN_FORM_CLASS = "grid-cols-1";
var TWO_COLUMN_FORM_CLASS = "grid-cols-2";
var THREE_COLUMN_FORM_CLASS = "grid-cols-1 sm:grid-cols-3";
var getFormLayoutClass = (optionCount) => {
  if (optionCount % 3 === 0) return THREE_COLUMN_FORM_CLASS;
  if (optionCount % 2 === 0) return TWO_COLUMN_FORM_CLASS;
  return ONE_COLUMN_FORM_CLASS;
};
var ProductItemVariant1CheckoutVariantsOptions = ({
  variants,
  selectedValue,
  onChange
}) => {
  return /* @__PURE__ */ React387.createElement("div", { className: cn(DEFAULT_FORM_CLASS, getFormLayoutClass(variants.length)) }, variants.map((variant) => /* @__PURE__ */ React387.createElement(
    ProductItemVariant1CheckoutVariantsOption,
    {
      key: variant.id,
      variant,
      isSelected: variant.value === selectedValue,
      onSelect: onChange
    }
  )));
};

// src/checkout/components/molecules/ProductItemVariant1CheckoutVariants.tsx
var DEFAULT_ROOT_CLASS67 = "grid grid-rows-[1fr] overflow-visible bg-transparent";
var DEFAULT_INNER_CLASS18 = "min-h-0";
var DEFAULT_SECTION_CLASS47 = "p-0";
var DEFAULT_CONTENT_CLASS25 = "grid gap-[16px]";
var ProductItemVariant1CheckoutVariants = ({
  isOpen,
  variants,
  selectedVariants,
  heading,
  variantLink,
  onChange,
  className
}) => {
  return /* @__PURE__ */ React388.createElement("div", { className: cn(DEFAULT_ROOT_CLASS67, className), "aria-hidden": !isOpen }, /* @__PURE__ */ React388.createElement("div", { className: DEFAULT_INNER_CLASS18 }, /* @__PURE__ */ React388.createElement("section", { className: DEFAULT_SECTION_CLASS47 }, /* @__PURE__ */ React388.createElement("div", { className: DEFAULT_CONTENT_CLASS25 }, /* @__PURE__ */ React388.createElement(
    ProductItemVariant1CheckoutVariantsHeader,
    {
      heading,
      variantLink
    }
  ), /* @__PURE__ */ React388.createElement(
    ProductItemVariant1CheckoutVariantsOptions,
    {
      variants,
      selectedValue: selectedVariants[0],
      onChange: (variantValue) => onChange(0, variantValue)
    }
  )))));
};

// src/checkout/components/molecules/ProductItemVariant1ProductVariants.tsx
import React395 from "react";

// src/checkout/components/molecules/ProductItemVariant1VariantSelect.tsx
import React394 from "react";

// src/checkout/components/molecules/ProductItemVariant1VariantSelectMenu.tsx
import React392 from "react";

// src/checkout/components/molecules/ProductItemVariant1VariantSelectOption.tsx
import React391 from "react";

// src/checkout/components/atoms/ColorSwatch.tsx
import React389 from "react";
var DEFAULT_SWATCH_CLASS = "size-[14px] shrink-0 rounded-full border";
var THEMED_BORDER_CLASS8 = "border-[var(--theme-color-border-light,#E5E7EB)]";
var ColorSwatch = ({ color, className }) => {
  if (!color) return null;
  return /* @__PURE__ */ React389.createElement(
    "span",
    {
      className: cn(DEFAULT_SWATCH_CLASS, THEMED_BORDER_CLASS8, className),
      style: { backgroundColor: color },
      "aria-hidden": "true"
    }
  );
};

// src/checkout/components/atoms/ProductVariantSelectText.tsx
import React390 from "react";
var DEFAULT_TEXT_CLASS22 = "truncate text-[12px] font-medium leading-[16px]";
var ProductVariantSelectText = ({
  children,
  className
}) => {
  return /* @__PURE__ */ React390.createElement("span", { className: cn(DEFAULT_TEXT_CLASS22, className) }, children);
};

// src/checkout/components/molecules/ProductItemVariant1VariantSelectOption.tsx
var DEFAULT_OPTION_CLASS2 = "flex w-full items-center gap-[8px] px-[10px] py-[11px] text-left text-[12px] font-normal leading-[16px] transition-colors";
var THEMED_OPTION_CLASS2 = "text-[var(--theme-color-text-primary,#000000)] hover:bg-[var(--theme-color-bg-section,#F3F4F6)]";
var THEMED_OPTION_ACTIVE_CLASS2 = "bg-[var(--theme-color-bg-section,#F3F4F6)]";
var ProductItemVariant1VariantSelectOption = ({
  variant,
  isSelected,
  onSelect,
  className
}) => {
  return /* @__PURE__ */ React391.createElement(
    "button",
    {
      type: "button",
      className: cn(
        DEFAULT_OPTION_CLASS2,
        THEMED_OPTION_CLASS2,
        isSelected && THEMED_OPTION_ACTIVE_CLASS2,
        className
      ),
      onClick: () => onSelect(variant.value)
    },
    /* @__PURE__ */ React391.createElement(ColorSwatch, { color: variant.color }),
    /* @__PURE__ */ React391.createElement(ProductVariantSelectText, null, variant.label)
  );
};

// src/checkout/components/molecules/ProductItemVariant1VariantSelectMenu.tsx
var DEFAULT_MENU_CLASS = "absolute left-0 right-0 top-[calc(100%+4px)] z-30 overflow-hidden rounded-[6px] border shadow-[0_8px_18px_rgba(0,0,0,0.12)]";
var THEMED_MENU_BORDER_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)]";
var THEMED_MENU_BG_CLASS = "bg-[var(--theme-color-bg-page,#ffffff)]";
var ProductItemVariant1VariantSelectMenu = ({
  variants,
  selectedValue,
  onSelect,
  className
}) => {
  return /* @__PURE__ */ React392.createElement(
    "div",
    {
      className: cn(DEFAULT_MENU_CLASS, THEMED_MENU_BORDER_CLASS, THEMED_MENU_BG_CLASS, className)
    },
    variants.map((variant) => /* @__PURE__ */ React392.createElement(
      ProductItemVariant1VariantSelectOption,
      {
        key: variant.id,
        variant,
        isSelected: variant.value === selectedValue,
        onSelect
      }
    ))
  );
};

// src/checkout/components/molecules/ProductItemVariant1VariantSelectTrigger.tsx
import React393 from "react";
var DEFAULT_TRIGGER_CLASS2 = "flex w-full flex-col overflow-hidden rounded-[6px] border text-left";
var DEFAULT_TRIGGER_ACTIVE_CLASS = "ring-1 ring-inset";
var DEFAULT_LABEL_CLASS16 = "flex items-center justify-between gap-[8px] px-[10px] pt-[6px] text-[12px] font-normal leading-[16px]";
var DEFAULT_SELECTED_CLASS = "flex min-w-0 items-center gap-[6px] px-[10px] py-[7px]";
var THEMED_TRIGGER_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)] text-[var(--theme-color-text-primary,#000000)]";
var THEMED_TRIGGER_ACTIVE_CLASS = "border-[var(--theme-color-accent,#3B82F6)] ring-[var(--theme-color-accent,#3B82F6)]";
var THEMED_LABEL_CLASS2 = "text-[var(--theme-color-text-light,#9CA3AF)]";
var THEMED_CHEVRON_CLASS = "text-[var(--theme-color-text-light,#9CA3AF)]";
var ProductItemVariant1VariantSelectTrigger = ({
  itemLabel,
  selectedVariant,
  isOpen,
  onClick,
  className
}) => {
  return /* @__PURE__ */ React393.createElement(
    "button",
    {
      type: "button",
      className: cn(
        DEFAULT_TRIGGER_CLASS2,
        THEMED_TRIGGER_CLASS,
        isOpen && DEFAULT_TRIGGER_ACTIVE_CLASS,
        isOpen && THEMED_TRIGGER_ACTIVE_CLASS,
        className
      ),
      onClick,
      "aria-expanded": isOpen
    },
    /* @__PURE__ */ React393.createElement("span", { className: cn(DEFAULT_LABEL_CLASS16, THEMED_LABEL_CLASS2) }, itemLabel, /* @__PURE__ */ React393.createElement(ProductVariantChevronIcon, { isExpanded: isOpen, className: THEMED_CHEVRON_CLASS })),
    /* @__PURE__ */ React393.createElement("span", { className: DEFAULT_SELECTED_CLASS }, /* @__PURE__ */ React393.createElement(ColorSwatch, { color: selectedVariant.color }), /* @__PURE__ */ React393.createElement(ProductVariantSelectText, null, selectedVariant.label))
  );
};

// src/checkout/components/molecules/ProductItemVariant1VariantSelect.tsx
var DEFAULT_ROOT_CLASS68 = "relative min-w-0";
var ProductItemVariant1VariantSelect = ({
  itemIndex,
  itemLabel,
  variants,
  selectedValue,
  onChange,
  className
}) => {
  var _a;
  const [isMenuOpen, setIsMenuOpen] = React394.useState(false);
  const rootRef = React394.useRef(null);
  const selectedVariant = (_a = variants.find((variant) => variant.value === selectedValue)) != null ? _a : variants[0];
  const closeMenuOnBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsMenuOpen(false);
    }
  };
  const selectVariant = (variantValue) => {
    onChange(itemIndex, variantValue);
    setIsMenuOpen(false);
  };
  return /* @__PURE__ */ React394.createElement("div", { ref: rootRef, className: cn(DEFAULT_ROOT_CLASS68, className), onBlur: closeMenuOnBlur }, /* @__PURE__ */ React394.createElement(
    ProductItemVariant1VariantSelectTrigger,
    {
      itemLabel,
      selectedVariant,
      isOpen: isMenuOpen,
      onClick: () => setIsMenuOpen((currentValue) => !currentValue)
    }
  ), isMenuOpen && /* @__PURE__ */ React394.createElement(
    ProductItemVariant1VariantSelectMenu,
    {
      variants,
      selectedValue: selectedVariant.value,
      onSelect: selectVariant
    }
  ));
};

// src/checkout/components/molecules/ProductItemVariant1ProductVariants.tsx
var DEFAULT_ROOT_CLASS69 = "grid transition-[grid-template-rows,opacity] duration-300 ease-out rounded-[6px]";
var ROOT_OPEN_CLASS2 = "grid-rows-[1fr] overflow-visible opacity-100";
var ROOT_CLOSED_CLASS2 = "pointer-events-none grid-rows-[0fr] overflow-hidden opacity-0";
var DEFAULT_INNER_CLASS19 = "min-h-0";
var DEFAULT_SECTION_CLASS48 = "px-[14px] pb-[14px] pt-[20px] md:pt-[16px]";
var DEFAULT_SEPARATOR_CLASS3 = "mb-[14px] h-[1px]";
var DEFAULT_CONTENT_CLASS26 = "grid gap-[8px]";
var DEFAULT_HEADER_CLASS28 = "flex flex-wrap items-center gap-x-[14px] gap-y-[2px]";
var DEFAULT_HEADING_CLASS19 = "text-[14px] font-medium leading-[20px]";
var DEFAULT_FORM_CLASS2 = "grid gap-[8px] sm:grid-flow-col sm:auto-cols-fr";
var THEMED_ROOT_BG_CLASS2 = "bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var THEMED_SEPARATOR_BG_CLASS = "bg-[var(--theme-color-border-light,#E5E7EB)]";
var THEMED_HEADING_TEXT_CLASS = "text-[var(--theme-color-heading-primary,#111827)]";
var getItemLabel = (itemIndex, itemLabel) => `${itemIndex + 1} ${itemLabel}`;
var ProductItemVariant1ProductVariants = ({
  isOpen,
  amount,
  variants,
  selectedVariants,
  heading,
  itemLabel,
  variantLink,
  onChange,
  className
}) => {
  return /* @__PURE__ */ React395.createElement(
    "div",
    {
      className: cn(
        DEFAULT_ROOT_CLASS69,
        THEMED_ROOT_BG_CLASS2,
        isOpen ? ROOT_OPEN_CLASS2 : ROOT_CLOSED_CLASS2,
        className
      ),
      "aria-hidden": !isOpen
    },
    /* @__PURE__ */ React395.createElement("div", { className: DEFAULT_INNER_CLASS19 }, /* @__PURE__ */ React395.createElement("section", { className: DEFAULT_SECTION_CLASS48 }, /* @__PURE__ */ React395.createElement("div", { className: cn(DEFAULT_SEPARATOR_CLASS3, THEMED_SEPARATOR_BG_CLASS) }), /* @__PURE__ */ React395.createElement("div", { className: DEFAULT_CONTENT_CLASS26 }, /* @__PURE__ */ React395.createElement("div", { className: DEFAULT_HEADER_CLASS28 }, /* @__PURE__ */ React395.createElement("h3", { className: cn(DEFAULT_HEADING_CLASS19, THEMED_HEADING_TEXT_CLASS) }, heading), variantLink && /* @__PURE__ */ React395.createElement(ProductVariantLink, { link: variantLink })), /* @__PURE__ */ React395.createElement("div", { className: DEFAULT_FORM_CLASS2 }, Array.from({ length: amount }, (_, itemIndex) => /* @__PURE__ */ React395.createElement(
      ProductItemVariant1VariantSelect,
      {
        key: itemIndex,
        itemIndex,
        itemLabel: getItemLabel(itemIndex, itemLabel),
        variants,
        selectedValue: selectedVariants[itemIndex],
        onChange
      }
    ))))))
  );
};

// src/checkout/components/molecules/ProductItemVariant1Variants.tsx
var ProductItemVariant1Variants = ({
  isOpen,
  amount,
  variants,
  selectedVariants,
  enabledVariantType,
  onChange,
  heading,
  itemLabel,
  variantLink,
  className
}) => {
  if (!enabledVariantType) return null;
  const VariantLayout = enabledVariantType === "perCheckout" /* PER_CHECKOUT */ ? ProductItemVariant1CheckoutVariants : ProductItemVariant1ProductVariants;
  return /* @__PURE__ */ React396.createElement(
    VariantLayout,
    {
      isOpen,
      amount,
      variants,
      selectedVariants,
      heading,
      itemLabel,
      variantLink,
      onChange,
      className
    }
  );
};

// src/checkout/components/organisms/ProductItemVariant1VariantGroupItem.tsx
var EMPTY_VARIANT_VALUES = [];
var getSelectedVariantsForProduct = (amount, defaultVariantValue, selectedVariants, isActive) => {
  if (isActive) return selectedVariants;
  return Array.from({ length: amount }, () => defaultVariantValue);
};
var ProductItemVariant1VariantGroupItem = React397.memo(
  function ProductItemVariant1VariantGroupItem2({
    variantGroup,
    isOpen,
    amount,
    enabledVariantType
  }) {
    const defaultProductVariantValue = useOrderStore(
      (state) => {
        var _a;
        return (_a = state.defaultProductVariantValues[variantGroup.key]) != null ? _a : "";
      }
    );
    const selectedProductVariantValues = useOrderStore(
      (state) => {
        var _a;
        return (_a = state.selectedProductVariants[variantGroup.key]) != null ? _a : EMPTY_VARIANT_VALUES;
      }
    );
    const selectProductVariant = useOrderStore((state) => state.selectProductVariant);
    const selectedVariants = React397.useMemo(
      () => getSelectedVariantsForProduct(
        amount,
        defaultProductVariantValue,
        selectedProductVariantValues,
        isOpen
      ),
      [amount, defaultProductVariantValue, isOpen, selectedProductVariantValues]
    );
    const handleChange = React397.useCallback(
      (itemIndex, variantValue) => selectProductVariant(variantGroup.key, itemIndex, variantValue),
      [selectProductVariant, variantGroup.key]
    );
    return /* @__PURE__ */ React397.createElement(
      ProductItemVariant1Variants,
      {
        isOpen,
        amount,
        variants: variantGroup.variants,
        selectedVariants,
        enabledVariantType,
        onChange: handleChange,
        heading: variantGroup.customVariantsSelectionTitle,
        itemLabel: variantGroup.customVariantsItemLabel,
        variantLink: variantGroup.customVariantLink
      }
    );
  }
);

// src/checkout/components/organisms/ProductItemVariant1VariantGroups.tsx
var DEFAULT_ROOT_CLASS70 = "grid";
var CHECKOUT_ROOT_CLASS = "gap-[16px]";
var ProductItemVariant1VariantGroups = ({
  isOpen,
  amount,
  enabledVariantType,
  productVariants,
  classes = {}
}) => {
  const variantGroups = React398.useMemo(
    () => getProductVariantGroups(productVariants),
    [productVariants]
  );
  const isPerCheckoutVariant = enabledVariantType === "perCheckout" /* PER_CHECKOUT */;
  return /* @__PURE__ */ React398.createElement(
    "div",
    {
      className: cn(DEFAULT_ROOT_CLASS70, isPerCheckoutVariant && CHECKOUT_ROOT_CLASS, classes.root)
    },
    variantGroups.map((variantGroup) => /* @__PURE__ */ React398.createElement(
      ProductItemVariant1VariantGroupItem,
      {
        key: variantGroup.key,
        variantGroup,
        isOpen,
        amount,
        enabledVariantType
      }
    ))
  );
};

// src/checkout/components/organisms/ProductItemVariant1.tsx
var DEFAULT_PRODUCT_WITH_VARIANTS_CLASS = "overflow-visible rounded-[6px] border";
var THEMED_PRODUCT_WITH_VARIANTS_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_PRODUCT_WITH_VARIANTS_ACTIVE_CLASS = "border-[var(--theme-color-accent,#3B82F6)] bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var ProductItemVariant1 = ({
  product,
  productIndex,
  productsConfig,
  content,
  hasDropdown,
  hasVariantsPerProduct,
  productDropdownContent
}) => {
  var _a, _b, _c, _d;
  const productId = product.id;
  const selectedProductIndex = useOrderStore((state) => state.selectedProductIndex);
  const productPricing = useOrderStore(
    useShallow2((state) => state.productPricingByIndex[productIndex])
  );
  const selectProduct = useOrderStore((state) => state.selectProduct);
  const isOrderInitialized = useOrderStore((state) => state.isOrderInitialized);
  const isActive = productIndex === selectedProductIndex;
  const { productBestValueLabel, productBestSellerLabel, productEachLabel } = content;
  const { productVariants } = productsConfig;
  const { isBestSeller, isBestValue, amount, name } = product;
  const discountPercent = productPricing == null ? void 0 : productPricing.discountPercent;
  if (!isOrderInitialized || !productPricing) return null;
  const productItemOption = /* @__PURE__ */ React399.createElement(
    ProductItemVariant1Option,
    {
      productId,
      isActive,
      hasDropdown,
      onSelect: () => selectProduct(productIndex),
      info: /* @__PURE__ */ React399.createElement(
        ProductItemVariant1Info,
        {
          image: { src: (_a = product.imageUrl) != null ? _a : "", alt: name },
          summary: {
            amount,
            name,
            discountPercent
          }
        }
      ),
      price: /* @__PURE__ */ React399.createElement(
        ProductItemVariant1Price,
        {
          oldPriceText: productPricing.oldPriceText,
          symbol: (_b = productPricing.currentPriceObject) == null ? void 0 : _b.symbol,
          symbolLeft: (_d = (_c = productPricing.currentPriceObject) == null ? void 0 : _c.symbolLeft) != null ? _d : true,
          wholeText: productPricing.currentPriceWholeText,
          centsText: productPricing.currentPriceCentsText,
          eachLabel: productEachLabel || "",
          bestSellerLabel: isBestSeller ? productBestSellerLabel : void 0,
          bestValueLabel: isBestValue ? productBestValueLabel : void 0,
          hasDiscountColumn: !!discountPercent
        }
      )
    }
  );
  let dropdownContent = null;
  if (hasVariantsPerProduct) {
    dropdownContent = /* @__PURE__ */ React399.createElement(
      ProductItemVariant1VariantGroups,
      {
        isOpen: isActive,
        amount,
        enabledVariantType: "perProduct" /* PER_PRODUCT */,
        productVariants
      }
    );
  }
  if (productDropdownContent) {
    dropdownContent = /* @__PURE__ */ React399.createElement(
      ProductItemVariant1DropdownContent,
      {
        isOpen: isActive,
        title: productDropdownContent.title,
        message: productDropdownContent.message
      }
    );
  }
  if (!hasDropdown) return productItemOption;
  return /* @__PURE__ */ React399.createElement(
    "div",
    {
      className: cn(
        DEFAULT_PRODUCT_WITH_VARIANTS_CLASS,
        THEMED_PRODUCT_WITH_VARIANTS_CLASS,
        isActive && THEMED_PRODUCT_WITH_VARIANTS_ACTIVE_CLASS
      )
    },
    productItemOption,
    dropdownContent
  );
};

// src/checkout/components/organisms/ProductItemVariant2.tsx
import React412 from "react";
import { useShallow as useShallow3 } from "zustand/react/shallow";

// src/checkout/components/molecules/ProductItemVariant2Info.tsx
import React406 from "react";

// src/checkout/components/atoms/ProductItemVariant2Image.tsx
import React400 from "react";
var DEFAULT_WRAPPER_CLASS11 = "flex w-[80px] shrink-0 justify-center lg:w-[96px]";
var DEFAULT_IMAGE_CLASS34 = "size-[80px] object-contain lg:h-[88px] lg:w-[96px]";
var ProductItemVariant2Image = ({
  src,
  alt,
  className,
  classes = {}
}) => {
  if (!src) return null;
  return /* @__PURE__ */ React400.createElement("div", { className: cn(DEFAULT_WRAPPER_CLASS11, classes.wrapper) }, /* @__PURE__ */ React400.createElement("img", { src, alt, className: cn(DEFAULT_IMAGE_CLASS34, classes.image, className) }));
};

// src/checkout/components/molecules/ProductItemVariant2Content.tsx
import React405 from "react";

// src/checkout/components/atoms/ProductItemVariant2Message.tsx
import React401 from "react";
var DEFAULT_MESSAGE_CLASS3 = "mt-[4px] block text-[12px] leading-[16px] lg:text-[14px] lg:leading-[20px]";
var THEMED_TEXT_CLASS15 = "text-[var(--theme-color-text-secondary,#666666)]";
var ProductItemVariant2Message = ({
  text,
  className
}) => {
  return /* @__PURE__ */ React401.createElement("span", { className: cn(DEFAULT_MESSAGE_CLASS3, THEMED_TEXT_CLASS15, className) }, text);
};

// src/checkout/components/atoms/ProductItemVariant2Title.tsx
import React402 from "react";
var DEFAULT_TITLE_CLASS28 = "block text-[16px] font-black leading-[19px] lg:text-[20px] lg:leading-[24px]";
var THEMED_TEXT_CLASS16 = "text-[var(--theme-color-text-primary,#000000)]";
var ProductItemVariant2Title = ({ text, className }) => {
  return /* @__PURE__ */ React402.createElement("span", { className: cn(DEFAULT_TITLE_CLASS28, THEMED_TEXT_CLASS16, className) }, text);
};

// src/checkout/components/molecules/ProductItemVariant2Badges.tsx
import React404 from "react";

// src/checkout/components/atoms/ProductItemVariant2Badge.tsx
import React403 from "react";
var DEFAULT_BADGE_CLASS4 = "inline-flex h-[20px] shrink-0 items-center whitespace-nowrap rounded-[3px] px-[7px] text-[11px] font-black uppercase leading-[12px] lg:h-[24px] lg:px-[8px] lg:text-[14px] lg:leading-[16px]";
var THEMED_BADGE_CLASS2 = "text-[var(--theme-color-text-inverse,#ffffff)]";
var THEMED_VARIANT_CLASS_MAP2 = {
  bestSeller: "bg-[var(--theme-color-error,#DC2626)]",
  bestValue: "bg-[var(--theme-color-warning,#D97706)] text-[var(--theme-color-text-primary,#000000)]"
};
var ProductItemVariant2Badge = ({
  label,
  variant,
  className
}) => {
  return /* @__PURE__ */ React403.createElement(
    "span",
    {
      className: cn(
        DEFAULT_BADGE_CLASS4,
        THEMED_BADGE_CLASS2,
        THEMED_VARIANT_CLASS_MAP2[variant],
        className
      )
    },
    label
  );
};

// src/checkout/components/molecules/ProductItemVariant2Badges.tsx
var DEFAULT_BADGES_CLASS2 = "mb-[4px] flex flex-col items-start gap-[4px] lg:mb-[6px] lg:flex-row lg:items-center lg:gap-[6px]";
var ProductItemVariant2Badges = ({
  bestSellerLabel,
  bestValueLabel,
  className,
  badgeClassName
}) => {
  if (!bestSellerLabel && !bestValueLabel) return null;
  return /* @__PURE__ */ React404.createElement("div", { className: cn(DEFAULT_BADGES_CLASS2, className) }, bestSellerLabel && /* @__PURE__ */ React404.createElement(
    ProductItemVariant2Badge,
    {
      label: bestSellerLabel,
      variant: "bestSeller",
      className: badgeClassName
    }
  ), bestValueLabel && /* @__PURE__ */ React404.createElement(
    ProductItemVariant2Badge,
    {
      label: bestValueLabel,
      variant: "bestValue",
      className: badgeClassName
    }
  ));
};

// src/checkout/components/molecules/ProductItemVariant2Content.tsx
var DEFAULT_CONTENT_CLASS27 = "min-w-0 self-center";
var ProductItemVariant2Content = ({
  title,
  message,
  bestSellerLabel,
  bestValueLabel,
  classes = {}
}) => {
  return /* @__PURE__ */ React405.createElement("div", { className: cn(DEFAULT_CONTENT_CLASS27, classes.content) }, /* @__PURE__ */ React405.createElement(
    ProductItemVariant2Badges,
    {
      bestSellerLabel,
      bestValueLabel,
      className: classes.badges,
      badgeClassName: classes.badge
    }
  ), /* @__PURE__ */ React405.createElement(ProductItemVariant2Title, { text: title, className: classes.title }), message && /* @__PURE__ */ React405.createElement(ProductItemVariant2Message, { text: message, className: classes.message }));
};

// src/checkout/components/molecules/ProductItemVariant2Info.tsx
var DEFAULT_INFO_CLASS3 = "flex min-w-0 flex-1 items-center gap-[10px]";
var THEMED_RADIO_INDICATOR_CLASS2 = "border-[var(--theme-color-border,#9CA3AF)] bg-[var(--theme-color-bg-page,#ffffff)] before:bg-[var(--theme-color-accent,#3B82F6)]";
var THEMED_RADIO_ACTIVE_CLASS3 = "border-[var(--theme-color-accent,#3B82F6)]";
var ProductItemVariant2Info = ({
  isActive = false,
  image,
  content,
  className,
  classes = {}
}) => {
  var _a, _b;
  const radioClasses = {
    ...classes.radio,
    indicator: cn(THEMED_RADIO_INDICATOR_CLASS2, (_a = classes.radio) == null ? void 0 : _a.indicator),
    active: cn(THEMED_RADIO_ACTIVE_CLASS3, (_b = classes.radio) == null ? void 0 : _b.active)
  };
  return /* @__PURE__ */ React406.createElement("div", { className: cn(DEFAULT_INFO_CLASS3, classes.root, className) }, /* @__PURE__ */ React406.createElement(SelectableRadio, { isActive, classes: radioClasses }), /* @__PURE__ */ React406.createElement(ProductItemVariant2Image, { src: image.src, alt: image.alt, classes: classes.image }), /* @__PURE__ */ React406.createElement(ProductItemVariant2Content, { ...content, classes: classes.content }));
};

// src/checkout/components/molecules/ProductItemVariant2Option.tsx
import React407 from "react";
var DEFAULT_ROOT_CLASS71 = "flex h-full min-h-[106px] w-full items-center gap-[10px] rounded-[6px] border px-[8px] py-[10px] text-left transition-colors lg:min-h-[134px] lg:px-[16px] lg:py-[14px]";
var DEFAULT_ROOT_ACTIVE_CLASS = "ring-1 ring-inset";
var THEMED_ROOT_CLASS14 = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_ROOT_ACTIVE_CLASS = "border-[var(--theme-color-accent,#3B82F6)] bg-[var(--theme-color-bg-tint,#EFF6FF)] ring-[var(--theme-color-accent,#3B82F6)]";
var ProductItemVariant2Option = ({
  isActive = false,
  productId,
  left,
  right,
  onSelect,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React407.createElement(
    "button",
    {
      type: "button",
      "data-product-id": productId != null ? productId : void 0,
      className: cn(
        DEFAULT_ROOT_CLASS71,
        THEMED_ROOT_CLASS14,
        isActive && DEFAULT_ROOT_ACTIVE_CLASS,
        isActive && THEMED_ROOT_ACTIVE_CLASS,
        isActive && classes.active,
        classes.root,
        className
      ),
      onClick: onSelect,
      "aria-pressed": isActive
    },
    left,
    right
  );
};

// src/checkout/components/molecules/ProductItemVariant2Price.tsx
import React411 from "react";

// src/checkout/components/atoms/ProductItemVariant2DiscountText.tsx
import React408 from "react";
var DEFAULT_DISCOUNT_CLASS = "mt-[4px] block break-words text-[14px] font-black uppercase leading-[17px]";
var THEMED_TEXT_CLASS17 = "text-[var(--theme-color-error,#DC2626)]";
var ProductItemVariant2DiscountText = ({
  text,
  className
}) => {
  return /* @__PURE__ */ React408.createElement("span", { className: cn(DEFAULT_DISCOUNT_CLASS, THEMED_TEXT_CLASS17, className) }, text);
};

// src/checkout/components/atoms/ProductItemVariant2MainPrice.tsx
import React409 from "react";
var DEFAULT_PRICE_CLASS3 = "mt-[2px] flex flex-wrap items-baseline justify-end lg:mt-[4px]";
var DEFAULT_PRICE_SYMBOL_CLASS = "text-[14px] font-black leading-[17px] lg:text-[18px] lg:leading-[22px]";
var DEFAULT_PRICE_NUMBER_CLASS = "text-[16px] font-black leading-[19px] lg:text-[20px] lg:leading-[24px]";
var DEFAULT_EACH_CLASS2 = "ml-[4px] text-[13px] font-normal leading-[16px] lg:text-[14px] lg:leading-[17px]";
var THEMED_TEXT_CLASS18 = "text-[var(--theme-color-text-primary,#000000)]";
var ProductItemVariant2MainPrice = ({
  amountText,
  eachLabel,
  symbol,
  symbolLeft = false,
  classes = {}
}) => {
  return /* @__PURE__ */ React409.createElement("div", { className: cn(DEFAULT_PRICE_CLASS3, THEMED_TEXT_CLASS18, classes.root) }, symbolLeft && symbol && /* @__PURE__ */ React409.createElement("span", { className: cn(DEFAULT_PRICE_SYMBOL_CLASS, classes.symbol) }, symbol), /* @__PURE__ */ React409.createElement("span", { className: cn(DEFAULT_PRICE_NUMBER_CLASS, classes.number) }, amountText), !symbolLeft && symbol && /* @__PURE__ */ React409.createElement("span", { className: cn(DEFAULT_PRICE_SYMBOL_CLASS, classes.symbol) }, symbol), /* @__PURE__ */ React409.createElement("span", { className: cn(DEFAULT_EACH_CLASS2, THEMED_TEXT_CLASS18, classes.each) }, "/", eachLabel));
};

// src/checkout/components/atoms/ProductItemVariant2OldPrice.tsx
import React410 from "react";
var DEFAULT_OLD_PRICE_CLASS3 = "relative inline-block text-[12px] leading-[15px] before:absolute before:left-[-2px] before:top-[50%] before:h-[1px] before:w-[calc(100%+4px)] before:-rotate-[18deg] lg:text-[14px] lg:leading-[17px]";
var THEMED_TEXT_CLASS19 = "text-[var(--theme-color-text-light,#9CA3AF)]";
var THEMED_STRIKETHROUGH_CLASS = "before:bg-[var(--theme-color-error,#DC2626)]";
var ProductItemVariant2OldPrice = ({
  text,
  className
}) => {
  return /* @__PURE__ */ React410.createElement(
    "span",
    {
      className: cn(
        DEFAULT_OLD_PRICE_CLASS3,
        THEMED_TEXT_CLASS19,
        THEMED_STRIKETHROUGH_CLASS,
        className
      )
    },
    text
  );
};

// src/checkout/components/molecules/ProductItemVariant2Price.tsx
var DEFAULT_PRICE_COLUMN_CLASS = "min-w-0 text-right";
var ProductItemVariant2Price = ({
  oldPriceText,
  amountText,
  symbol,
  symbolLeft = false,
  eachLabel,
  discountText,
  className,
  classes = {}
}) => {
  return /* @__PURE__ */ React411.createElement("div", { className: cn(DEFAULT_PRICE_COLUMN_CLASS, classes.root, className) }, oldPriceText && /* @__PURE__ */ React411.createElement(ProductItemVariant2OldPrice, { text: oldPriceText, className: classes.oldPrice }), /* @__PURE__ */ React411.createElement(
    ProductItemVariant2MainPrice,
    {
      amountText,
      eachLabel,
      symbol,
      symbolLeft,
      classes: {
        root: classes.price,
        symbol: classes.symbol,
        number: classes.number,
        each: classes.each
      }
    }
  ), discountText && /* @__PURE__ */ React411.createElement(ProductItemVariant2DiscountText, { text: discountText, className: classes.save }));
};

// src/checkout/components/organisms/ProductItemVariant2.tsx
var ProductItemVariant2 = ({
  product,
  productIndex,
  content
}) => {
  var _a, _b, _c, _d;
  const productId = product.id;
  const selectedProductIndex = useOrderStore((state) => state.selectedProductIndex);
  const productPricing = useOrderStore(
    useShallow3((state) => state.productPricingByIndex[productIndex])
  );
  const selectProduct = useOrderStore((state) => state.selectProduct);
  const isActive = productIndex === selectedProductIndex;
  const {
    productBestValueLabel,
    productBestSellerLabel,
    pickerAdditionalMessage,
    discountOffLabel,
    productEachLabel,
    discountSaveLabel
  } = content;
  const { isBestSeller, isBestValue, amount, name, description } = product;
  const pickerTitle = amount ? `${amount}x ${name}` : name;
  const productMessage = description || pickerAdditionalMessage;
  if (!productPricing) return null;
  return /* @__PURE__ */ React412.createElement(
    ProductItemVariant2Option,
    {
      productId,
      isActive,
      onSelect: () => selectProduct(productIndex),
      left: /* @__PURE__ */ React412.createElement(
        ProductItemVariant2Info,
        {
          isActive,
          image: { src: (_a = product.imageUrl) != null ? _a : "", alt: name },
          content: {
            title: pickerTitle,
            message: productMessage,
            bestSellerLabel: isBestSeller ? productBestSellerLabel : void 0,
            bestValueLabel: isBestValue ? productBestValueLabel : void 0
          }
        }
      ),
      right: /* @__PURE__ */ React412.createElement(
        ProductItemVariant2Price,
        {
          oldPriceText: productPricing.oldPriceText,
          amountText: productPricing.currentPriceAmountText,
          symbol: (_b = productPricing.currentPriceObject) == null ? void 0 : _b.symbol,
          symbolLeft: (_d = (_c = productPricing.currentPriceObject) == null ? void 0 : _c.symbolLeft) != null ? _d : false,
          eachLabel: productEachLabel || "",
          discountText: !!(productPricing == null ? void 0 : productPricing.discountPercent) ? `${discountSaveLabel} ${productPricing.discountPercent}% ${discountOffLabel}` : void 0
        }
      )
    }
  );
};

// src/checkout/components/organisms/ProductList.tsx
var LIST_CLASS = "grid auto-rows-fr gap-[12px]";
var LIST_WITH_VARIANTS_CLASS = "auto-rows-auto";
var ProductsList = ({
  productsConfig,
  content,
  productType,
  classes = {}
}) => {
  const { productDropdownContent } = productsConfig;
  const products = useOrderStore((state) => state.products);
  const enabledVariantType = useOrderStore((state) => state.enabledVariantType);
  const isOrderInitialized = useOrderStore((state) => state.isOrderInitialized);
  if (!isOrderInitialized) return null;
  const hasVariantsPerProduct = enabledVariantType === "perProduct" /* PER_PRODUCT */;
  const hasDropdown = hasVariantsPerProduct || !!productDropdownContent;
  return /* @__PURE__ */ React413.createElement("div", { className: cn(LIST_CLASS, hasDropdown && LIST_WITH_VARIANTS_CLASS, classes.root) }, products.map((product, productIndex) => {
    if (!isProductVisible(product, "productLists" /* PRODUCT_LISTS */)) return null;
    const productId = product.id;
    if (productType === "variant2" /* VARIANT_2 */) {
      return /* @__PURE__ */ React413.createElement(
        ProductItemVariant2,
        {
          key: productId,
          product,
          productIndex,
          content
        }
      );
    }
    return /* @__PURE__ */ React413.createElement(
      ProductItemVariant1,
      {
        key: productId,
        product,
        productIndex,
        productsConfig,
        content,
        hasDropdown,
        hasVariantsPerProduct,
        productDropdownContent
      }
    );
  }));
};

// src/checkout/components/elements/ElementProductList.tsx
var DEFAULT_ROOT_CLASS72 = "my-4";
var THEMED_HEADING_CLASS4 = "text-[var(--theme-color-heading-primary,#111827)]";
var ElementProductList = ({
  elementConfig,
  schemaConfig,
  classes = {}
}) => {
  const { showProductPickerV2 } = schemaConfig.products;
  return /* @__PURE__ */ React414.createElement("div", { className: cn(DEFAULT_ROOT_CLASS72, classes.root) }, /* @__PURE__ */ React414.createElement(
    CheckoutSectionHeading,
    {
      title: elementConfig.content.productsHeading,
      className: "mb-[16px]",
      classes: { heading: THEMED_HEADING_CLASS4 }
    }
  ), /* @__PURE__ */ React414.createElement(
    ProductsList,
    {
      productsConfig: schemaConfig.products,
      content: elementConfig.content,
      productType: showProductPickerV2 ? "variant2" /* VARIANT_2 */ : "variant1" /* VARIANT_1 */
    }
  ));
};

// src/checkout/components/elements/ElementRatingCard.tsx
import React415 from "react";
var DEFAULT_ROOT_CLASS73 = "my-4";
var THEMED_ROOT_CLASS15 = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_STARS_CLASS = "text-[var(--theme-color-warning,#D97706)]";
var THEMED_NAME_CLASS = "text-[var(--theme-color-text-primary,#000000)]";
var THEMED_LABEL_CLASS3 = "text-[var(--theme-color-success,#059669)]";
var THEMED_TITLE_CLASS9 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DESCRIPTION_CLASS7 = "text-[var(--theme-color-text-secondary,#666666)]";
var ElementRatingCard = ({
  elementConfig,
  isCleanVersion,
  classes = {}
}) => {
  const { content, config } = elementConfig;
  return /* @__PURE__ */ React415.createElement(
    RatingCard,
    {
      title: content.title,
      description: content.description,
      name: content.name,
      label: isCleanVersion ? void 0 : content.label,
      isTrustpilot: isCleanVersion ? false : content.isTrustpilot,
      rating: config == null ? void 0 : config.rating,
      classes: {
        root: cn(THEMED_ROOT_CLASS15, DEFAULT_ROOT_CLASS73, classes.root),
        stars: THEMED_STARS_CLASS,
        name: THEMED_NAME_CLASS,
        label: THEMED_LABEL_CLASS3,
        title: THEMED_TITLE_CLASS9,
        description: THEMED_DESCRIPTION_CLASS7
      }
    }
  );
};

// src/checkout/components/elements/ElementSubscriptionGlobalSelect.tsx
import React416 from "react";
var DEFAULT_ROOT_CLASS74 = "my-4";
var DEFAULT_SEGMENTED_CONTROL_CLASS2 = "grid min-h-[72px] grid-cols-2 overflow-hidden rounded border p-[2px]";
var DEFAULT_DESCRIPTION_CLASS27 = "px-2 pt-2 text-center text-sm leading-5";
var DEFAULT_OPTION_CLASS3 = "focus-visible:outline-2 focus-visible:outline-offset-2";
var THEMED_SEGMENTED_CONTROL_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_DESCRIPTION_CLASS8 = "text-[var(--theme-color-text-secondary,#666666)]";
var THEMED_OPTION_CLASS3 = "text-[var(--theme-color-text-secondary,#666666)] focus-visible:outline-[var(--theme-color-accent,#3B82F6)]";
var THEMED_OPTION_ACTIVE_CLASS3 = "border-[var(--theme-color-accent,#3B82F6)] bg-[var(--theme-color-bg-tint,#EFF6FF)] text-[var(--theme-color-text-primary,#000000)]";
var ElementSubscriptionGlobalSelect = ({
  elementConfig,
  classes = {}
}) => {
  const isOrderInitialized = useOrderStore((state) => state.isOrderInitialized);
  const isSubscribe = useOrderStore((state) => state.isSubscribe);
  const setIsSubscribe = useOrderStore((state) => state.setIsSubscribe);
  if (!isOrderInitialized) return null;
  return /* @__PURE__ */ React416.createElement(
    TwoOptionSelector,
    {
      firstOption: {
        isActive: isSubscribe,
        label: elementConfig.content.buttonSubscription,
        onSelect: () => setIsSubscribe(true)
      },
      secondOption: {
        isActive: !isSubscribe,
        label: elementConfig.content.buttonBase,
        onSelect: () => setIsSubscribe(false)
      },
      description: isSubscribe ? elementConfig.content.footerTextSubscriptionEnabled : elementConfig.content.footerTextSubscriptionDisabled,
      classes: {
        root: cn(DEFAULT_ROOT_CLASS74, classes.root),
        segmentedControl: cn(DEFAULT_SEGMENTED_CONTROL_CLASS2, THEMED_SEGMENTED_CONTROL_CLASS),
        description: cn(DEFAULT_DESCRIPTION_CLASS27, THEMED_DESCRIPTION_CLASS8),
        option: {
          root: cn(DEFAULT_OPTION_CLASS3, THEMED_OPTION_CLASS3),
          active: THEMED_OPTION_ACTIVE_CLASS3
        }
      }
    }
  );
};

// src/checkout/components/elements/ElementSubscriptionToggleBox.tsx
import React418 from "react";

// src/checkout/components/molecules/SubscriptionBoxContent.tsx
import React417 from "react";
var DEFAULT_CONTENT_CLASS28 = "flex flex-col gap-[4px]";
var DEFAULT_TITLE_CLASS29 = "text-[16px] font-black leading-[19px]";
var DEFAULT_DESCRIPTION_CLASS28 = "text-[12px] leading-[15px]";
var THEMED_TITLE_TEXT_CLASS2 = "text-[var(--theme-color-heading-primary,#111827)]";
var THEMED_DESCRIPTION_TEXT_CLASS = "text-[var(--theme-color-text-secondary,#666666)]";
var SubscriptionBoxContent = ({
  title,
  description,
  classes = {}
}) => {
  return /* @__PURE__ */ React417.createElement("span", { className: cn(DEFAULT_CONTENT_CLASS28, classes.content) }, title && /* @__PURE__ */ React417.createElement("span", { className: cn(DEFAULT_TITLE_CLASS29, THEMED_TITLE_TEXT_CLASS2, classes.title) }, title), description && /* @__PURE__ */ React417.createElement(
    "span",
    {
      className: cn(
        DEFAULT_DESCRIPTION_CLASS28,
        THEMED_DESCRIPTION_TEXT_CLASS,
        classes.description
      )
    },
    description
  ));
};

// src/checkout/components/elements/ElementSubscriptionToggleBox.tsx
var DEFAULT_ROOT_CLASS75 = "my-4";
var DEFAULT_CHECKBOX_CLASS3 = "mt-[2px]";
var THEMED_ROOT_ACTIVE_CLASS2 = "border-[var(--theme-color-accent,#3B82F6)] bg-[var(--theme-color-bg-tint,#EFF6FF)]";
var THEMED_ROOT_INACTIVE_CLASS = "border-[var(--theme-color-border-light,#E5E7EB)] bg-[var(--theme-color-bg-raised,#F9FAFB)]";
var ElementSubscriptionToggleBox = ({
  elementConfig,
  classes = {}
}) => {
  const isSubscribe = useOrderStore((state) => state.isSubscribe);
  const setIsSubscribe = useOrderStore((state) => state.setIsSubscribe);
  const checkboxIcon = isSubscribe ? /* @__PURE__ */ React418.createElement(CheckboxCheckedIcon, { className: DEFAULT_CHECKBOX_CLASS3 }) : /* @__PURE__ */ React418.createElement(CheckboxUncheckedIcon, { className: DEFAULT_CHECKBOX_CLASS3 });
  return /* @__PURE__ */ React418.createElement(
    ToggleBoxLayout,
    {
      isActive: isSubscribe,
      onClick: () => setIsSubscribe(!isSubscribe),
      icon: checkboxIcon,
      classes: {
        root: cn(DEFAULT_ROOT_CLASS75, classes.root),
        active: THEMED_ROOT_ACTIVE_CLASS2,
        inactive: THEMED_ROOT_INACTIVE_CLASS
      }
    },
    /* @__PURE__ */ React418.createElement(
      SubscriptionBoxContent,
      {
        title: elementConfig.content.title,
        description: isSubscribe ? elementConfig.content.subtitleSubscriptionEnabled : elementConfig.content.subtitleSubscriptionDisabled
      }
    )
  );
};

// src/checkout/components/elements/ElementTextSeparator.tsx
import React420 from "react";

// src/checkout/components/molecules/SectionDivider.tsx
import React419 from "react";
var DEFAULT_SECTION_DIVIDER_CLASS = "flex items-center";
var DEFAULT_SECTION_DIVIDER_LINE_CLASS = "h-px flex-1";
var DEFAULT_SECTION_DIVIDER_TEXT_CLASS = "px-4 text-center text-sm font-normal not-italic leading-5";
var THEMED_LINE_BG_CLASS = "bg-[var(--theme-color-border-light,#E5E7EB)]";
var THEMED_TEXT_COLOR_CLASS = "text-[var(--theme-color-text-light,#9CA3AF)]";
var SectionDivider = ({ children, className, classes = {} }) => /* @__PURE__ */ React419.createElement("div", { className: cn(DEFAULT_SECTION_DIVIDER_CLASS, classes.root, className) }, /* @__PURE__ */ React419.createElement(
  "span",
  {
    className: cn(DEFAULT_SECTION_DIVIDER_LINE_CLASS, THEMED_LINE_BG_CLASS, classes.line),
    "aria-hidden": "true"
  }
), /* @__PURE__ */ React419.createElement("span", { className: cn(DEFAULT_SECTION_DIVIDER_TEXT_CLASS, THEMED_TEXT_COLOR_CLASS, classes.text) }, children), /* @__PURE__ */ React419.createElement(
  "span",
  {
    className: cn(DEFAULT_SECTION_DIVIDER_LINE_CLASS, THEMED_LINE_BG_CLASS, classes.line),
    "aria-hidden": "true"
  }
));

// src/checkout/components/elements/ElementTextSeparator.tsx
var DEFAULT_ROOT_CLASS76 = "my-4";
var ElementTextSeparator = ({
  elementConfig,
  classes = {}
}) => /* @__PURE__ */ React420.createElement(SectionDivider, { classes: { root: cn(DEFAULT_ROOT_CLASS76, classes.root) } }, elementConfig.content.text);

// src/checkout/components/organisms/LayoutElementRenderer.tsx
var LayoutElementRenderer = React421.memo(
  ({ elements, schemaConfig, formAdapters, classes = {} }) => {
    return /* @__PURE__ */ React421.createElement(React421.Fragment, null, elements.map((element, index) => {
      const rootClass = getPositionClass(index, elements.length);
      switch (element.type) {
        case "bar":
          return /* @__PURE__ */ React421.createElement(
            ElementBar,
            {
              key: `bar-${index}`,
              elementConfig: element,
              classes: {
                root: rootClass,
                discountNotice: classes.discountNotice,
                stockCount: classes.stockCount,
                stockMeter: classes.stockMeter
              }
            }
          );
        case "subscription-select":
          return /* @__PURE__ */ React421.createElement(
            ElementSubscriptionGlobalSelect,
            {
              key: `subscription-select-${index}`,
              elementConfig: element,
              classes: { root: rootClass }
            }
          );
        case "product-list":
          return /* @__PURE__ */ React421.createElement(
            ElementProductList,
            {
              key: `product-list-${index}`,
              elementConfig: element,
              schemaConfig,
              classes: { root: rootClass }
            }
          );
        case "subscription-toggle-box":
          return /* @__PURE__ */ React421.createElement(
            ElementSubscriptionToggleBox,
            {
              key: `subscription-toggle-box-${index}`,
              elementConfig: element,
              classes: { root: rootClass }
            }
          );
        case "order-form":
          return /* @__PURE__ */ React421.createElement(
            ElementOrderForm,
            {
              key: `order-form-${index}`,
              schemaConfig,
              elementConfig: element,
              formAdapters,
              classes: { root: rootClass }
            }
          );
        case "order-summary":
          return /* @__PURE__ */ React421.createElement(
            ElementOrderSummary,
            {
              key: `order-summary-${index}`,
              elementConfig: element,
              schemaConfig,
              classes: { root: rootClass }
            }
          );
        case "badge-card":
          return /* @__PURE__ */ React421.createElement(
            ElementBadgeCard,
            {
              key: `badge-card-${index}`,
              elementConfig: element,
              classes: { root: rootClass }
            }
          );
        case "text-separator":
          return /* @__PURE__ */ React421.createElement(
            ElementTextSeparator,
            {
              key: `text-separator-${index}`,
              elementConfig: element,
              classes: { root: rootClass }
            }
          );
        case "feature-card":
          return /* @__PURE__ */ React421.createElement(
            ElementFeatureCard,
            {
              key: `feature-card-${index}`,
              elementConfig: element,
              classes: { root: rootClass }
            }
          );
        case "rating-card":
          return /* @__PURE__ */ React421.createElement(
            ElementRatingCard,
            {
              key: `rating-card-${index}`,
              elementConfig: element,
              isCleanVersion: schemaConfig.isCleanVersion,
              classes: { root: rootClass }
            }
          );
        case "footer":
          return /* @__PURE__ */ React421.createElement(
            ElementFooter,
            {
              key: `footer-${index}`,
              elementConfig: element,
              classes: { root: rootClass }
            }
          );
        default:
          return null;
      }
    }));
  }
);

// src/checkout/components/templates/Layout2ColV1Layout.tsx
import React422 from "react";
var DEFAULT_LAYOUT_CLASS4 = "grid w-full flex-1 grid-cols-1 md:grid-cols-2";
var DEFAULT_COLUMN_CLASS = "w-full px-4 lg:px-0";
var DEFAULT_LEFT_CLASS3 = "py-4";
var DEFAULT_RIGHT_CLASS3 = "py-4";
var DEFAULT_GUTTER_CLASS = "hidden lg:row-start-1 lg:block";
var NORMAL_LAYOUT_CLASS = "lg:grid-cols-[minmax(0,1fr)_598px_443px_minmax(0,1fr)]";
var REVERSED_LAYOUT_CLASS = "lg:grid-cols-[minmax(0,1fr)_443px_598px_minmax(0,1fr)]";
var INNER_PADDING_RIGHT_CLASS = "md:pr-6 lg:pr-[38px]";
var INNER_PADDING_LEFT_CLASS = "md:pl-6 lg:pl-[38px]";
var LEFT_WIDE_COLUMN_CLASS = "lg:col-start-2";
var RIGHT_WIDE_COLUMN_CLASS = "lg:col-start-3";
var LEFT_REVERSED_ORDER_CLASS = "md:order-2";
var RIGHT_REVERSED_ORDER_CLASS = "md:order-1";
var START_GUTTER_CLASS = "lg:col-start-1";
var END_GUTTER_CLASS = "lg:col-start-4";
var DEFAULT_LEFT_BORDER_CLASS = "border-r";
var DEFAULT_RIGHT_BORDER_CLASS = "border-l";
var THEMED_LEFT_BG_CLASS = "bg-[var(--theme-color-bg-page,#ffffff)]";
var THEMED_RIGHT_BG_CLASS = "bg-[var(--theme-color-bg-raised,#F9FAFB)]";
var THEMED_DIVIDER_CLASS4 = "border-[var(--theme-color-border-light,#E5E7EB)]";
var Layout2ColV1Layout = ({
  left,
  right,
  isReversed = false,
  className,
  classes = {}
}) => {
  const layoutClass = isReversed ? REVERSED_LAYOUT_CLASS : NORMAL_LAYOUT_CLASS;
  const leftClass = isReversed ? cn(
    LEFT_REVERSED_ORDER_CLASS,
    DEFAULT_RIGHT_BORDER_CLASS,
    THEMED_DIVIDER_CLASS4,
    INNER_PADDING_LEFT_CLASS,
    RIGHT_WIDE_COLUMN_CLASS
  ) : cn(
    DEFAULT_LEFT_BORDER_CLASS,
    THEMED_DIVIDER_CLASS4,
    INNER_PADDING_RIGHT_CLASS,
    LEFT_WIDE_COLUMN_CLASS
  );
  const rightClass = isReversed ? cn(RIGHT_REVERSED_ORDER_CLASS, INNER_PADDING_RIGHT_CLASS, LEFT_WIDE_COLUMN_CLASS) : cn(INNER_PADDING_LEFT_CLASS, RIGHT_WIDE_COLUMN_CLASS);
  const gutterClass = isReversed ? START_GUTTER_CLASS : END_GUTTER_CLASS;
  const gutter = /* @__PURE__ */ React422.createElement(
    "div",
    {
      className: cn(THEMED_RIGHT_BG_CLASS, DEFAULT_GUTTER_CLASS, gutterClass, classes.gutter),
      "aria-hidden": "true"
    }
  );
  return /* @__PURE__ */ React422.createElement("main", { className: cn(DEFAULT_LAYOUT_CLASS4, layoutClass, classes.root, className) }, isReversed && gutter, /* @__PURE__ */ React422.createElement(
    "div",
    {
      className: cn(
        THEMED_LEFT_BG_CLASS,
        DEFAULT_COLUMN_CLASS,
        DEFAULT_LEFT_CLASS3,
        leftClass,
        classes.left
      )
    },
    left
  ), /* @__PURE__ */ React422.createElement(
    "div",
    {
      className: cn(
        THEMED_RIGHT_BG_CLASS,
        DEFAULT_COLUMN_CLASS,
        DEFAULT_RIGHT_CLASS3,
        rightClass,
        classes.right
      )
    },
    /* @__PURE__ */ React422.createElement("div", { className: cn(classes.rightContent) }, right)
  ), !isReversed && gutter);
};

// src/checkout/components/sections/Layout2ColV1Section.tsx
var Layout2ColV1Section = ({
  schemaConfig,
  sectionConfig,
  formAdapters,
  classes = {}
}) => {
  var _a, _b;
  const col1 = sectionConfig.slots.find((slot) => slot.name === "col-1");
  const col2 = sectionConfig.slots.find((slot) => slot.name === "col-2");
  const checkoutClasses = React423.useMemo(
    () => ({
      bars: classes.bars,
      discountNotice: classes.discountNotice,
      stockCount: classes.stockCount,
      stockMeter: classes.stockMeter
    }),
    [classes.bars, classes.discountNotice, classes.stockCount, classes.stockMeter]
  );
  return /* @__PURE__ */ React423.createElement("section", null, /* @__PURE__ */ React423.createElement(
    Layout2ColV1Layout,
    {
      isReversed: sectionConfig.config.isReversed,
      className: classes.content,
      classes: { left: classes.checkout },
      left: /* @__PURE__ */ React423.createElement(
        LayoutElementRenderer,
        {
          schemaConfig,
          elements: (_a = col1 == null ? void 0 : col1.elements) != null ? _a : [],
          formAdapters,
          classes: checkoutClasses
        }
      ),
      right: /* @__PURE__ */ React423.createElement("aside", { className: cn(classes.orderSummaryColumn) }, /* @__PURE__ */ React423.createElement(LayoutElementRenderer, { schemaConfig, elements: (_b = col2 == null ? void 0 : col2.elements) != null ? _b : [] }))
    }
  ));
};

// src/checkout/components/sections/BenefitsSection.tsx
import React424 from "react";
var BenefitsSection = ({ sectionConfig, ctaAdapters, classes }) => {
  const { content, config, styles } = sectionConfig;
  return /* @__PURE__ */ React424.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-section": styles == null ? void 0 : styles.bgColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.separatorColor,
        "--theme-color-bg-page": styles == null ? void 0 : styles.cardBgColor,
        "--theme-color-heading-primary": styles == null ? void 0 : styles.cardTitleColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.itemTextColor,
        "--theme-color-success": styles == null ? void 0 : styles.checkIconColor,
        "--theme-color-error": styles == null ? void 0 : styles.crossIconColor
      }
    },
    /* @__PURE__ */ React424.createElement(
      BenefitsCards,
      {
        title: content.title,
        showUnderline: config == null ? void 0 : config.showUnderline,
        underlineAlign: config == null ? void 0 : config.underlineAlign,
        columns: content.columns,
        ctaText: content.ctaText,
        subActionText: content.subActionText,
        onCtaClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary,
        onSubActionClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTASecondary,
        classes
      }
    )
  );
};

// src/checkout/components/sections/FeatureCardsSection.tsx
import React425 from "react";
var FeatureCardsSection = ({ sectionConfig, classes }) => {
  const { config, content, styles } = sectionConfig;
  return /* @__PURE__ */ React425.createElement(
    "div",
    {
      className: classes == null ? void 0 : classes.root,
      style: {
        "--theme-color-bg-section": styles == null ? void 0 : styles.bgColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.separatorColor,
        "--theme-color-heading-primary": styles == null ? void 0 : styles.titleColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor
      }
    },
    /* @__PURE__ */ React425.createElement(
      FeatureImageCards,
      {
        title: content.title,
        items: content.items,
        showUnderline: config == null ? void 0 : config.showUnderline,
        underlineAlign: config == null ? void 0 : config.underlineAlign
      }
    )
  );
};

// src/checkout/components/sections/CTAInlineSection.tsx
import React426 from "react";
var CTAInlineSection = ({
  sectionConfig,
  ctaAdapters,
  isCleanVersion
}) => {
  var _a;
  const { content, styles } = sectionConfig;
  const { fillPercent, stockCount } = useStockSimulation({ enabled: true });
  const stockLabel = parseTemplateVariables((_a = content.stockText) != null ? _a : "").map(
    (part, i) => part.type === "variable" ? /* @__PURE__ */ React426.createElement("b", { key: i }, stockCount) : /* @__PURE__ */ React426.createElement("span", { key: i }, part.value)
  );
  return /* @__PURE__ */ React426.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-page": styles == null ? void 0 : styles.bgColor,
        "--theme-color-warning": styles == null ? void 0 : styles.pillRatingColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.pillReviewsColor,
        "--theme-color-button-primary": styles == null ? void 0 : styles.ctaBgColor,
        "--theme-color-text-inverse": styles == null ? void 0 : styles.ctaTextColor
      }
    },
    /* @__PURE__ */ React426.createElement(
      AddMoreInlineSection,
      {
        rating: content.rating,
        ratingText: content.ratingText,
        reviewsText: content.reviewsText,
        isTrustpilot: isCleanVersion ? false : content.isTrustpilot,
        ctaText: content.ctaText,
        subActionText: content.subActionText,
        onCtaClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary,
        onSubActionClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTASecondary,
        stockLabel,
        fillPercent
      }
    )
  );
};

// src/checkout/components/sections/CTAImageSection.tsx
import React427 from "react";
var CTAImageSection = ({
  sectionConfig,
  ctaAdapters,
  isCleanVersion
}) => {
  const { content, config, styles } = sectionConfig;
  return /* @__PURE__ */ React427.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-page": styles == null ? void 0 : styles.bgColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.borderColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor,
        "--theme-color-accent": styles == null ? void 0 : styles.separatorColor,
        "--theme-color-accent-secondary": styles == null ? void 0 : styles.separatorEndColor
      }
    },
    /* @__PURE__ */ React427.createElement(
      AddMoreImageSection,
      {
        title: content.title,
        description: content.description,
        showUnderline: config == null ? void 0 : config.showUnderline,
        underlineAlign: config == null ? void 0 : config.underlineAlign,
        productImage: content.productImage,
        rating: content.rating,
        ratingText: content.ratingText,
        reviewsText: content.reviewsText,
        isTrustpilot: isCleanVersion ? false : content.isTrustpilot,
        ctaText: content.ctaText,
        subActionText: content.subActionText,
        onCtaClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary,
        onSubActionClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTASecondary
      }
    )
  );
};

// src/checkout/components/sections/CTAImageSectionV2.tsx
import React428 from "react";
var CTAImageSectionV2 = ({ sectionConfig, ctaAdapters }) => {
  const { content, config, styles } = sectionConfig;
  return /* @__PURE__ */ React428.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-raised": styles == null ? void 0 : styles.bgColor,
        "--theme-color-heading-primary": styles == null ? void 0 : styles.titleColor,
        "--theme-color-success": styles == null ? void 0 : styles.featureIconColor,
        "--theme-color-text-primary": styles == null ? void 0 : styles.featureTextColor,
        "--theme-color-button-primary": styles == null ? void 0 : styles.ctaBgColor,
        "--theme-color-text-inverse": styles == null ? void 0 : styles.ctaTextColor,
        "--theme-color-accent": styles == null ? void 0 : styles.separatorColor,
        "--theme-color-accent-secondary": styles == null ? void 0 : styles.separatorEndColor
      }
    },
    /* @__PURE__ */ React428.createElement(
      AddMoreImageSectionV2,
      {
        title: content.title,
        description: content.description,
        showUnderline: config == null ? void 0 : config.showUnderline,
        features: content.features,
        priceLine: content.priceLine,
        formattedPrice: content.formattedPrice,
        productImage: content.productImage,
        productImageWide: content.productImageWide,
        productImageAlt: content.productImageAlt,
        ctaText: content.ctaText,
        subActionText: content.subActionText,
        onCtaClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary,
        onSubActionClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTASecondary,
        backgroundImage: content.backgroundImage
      }
    )
  );
};

// src/checkout/components/sections/CTATimerSection.tsx
import React429 from "react";
var CTATimerSection = ({
  sectionConfig,
  ctaAdapters,
  isCleanVersion
}) => {
  var _a, _b;
  const { content, config, styles } = sectionConfig;
  const { timer } = usePersistentTimer({
    enabled: true,
    storageKey: (_a = config.storageKey) != null ? _a : STORAGE_KEYS.CHECKOUT_TIMER,
    durationMinutes: config.durationMinutes
  });
  const { formattedTime } = useCountdown({
    endAt: (_b = timer == null ? void 0 : timer.endAt) != null ? _b : Infinity,
    onEnd: () => {
    },
    showHours: true
  });
  return /* @__PURE__ */ React429.createElement(
    "div",
    {
      style: {
        "--theme-color-button-primary": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-inverse": styles == null ? void 0 : styles.textColor,
        "--theme-color-timer-item-border": styles == null ? void 0 : styles.itemBorderColor,
        "--theme-color-button-hover": styles == null ? void 0 : styles.itemBgColor,
        "--theme-color-accent-secondary": styles == null ? void 0 : styles.itemTextColor,
        "--theme-color-accent": styles == null ? void 0 : styles.timeBgColor
      }
    },
    /* @__PURE__ */ React429.createElement(
      AddMoreTimerSection,
      {
        title: content.title,
        description: content.description,
        showUnderline: config == null ? void 0 : config.showUnderline,
        underlineAlign: config == null ? void 0 : config.underlineAlign,
        rating: content.rating,
        ratingText: content.ratingText,
        isTrustpilot: isCleanVersion ? false : content.isTrustpilot,
        timerLabel: content.timerLabel,
        formattedTime,
        ctaText: content.ctaText,
        subActionText: content.subActionText,
        onCtaClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary,
        onSubActionClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTASecondary
      }
    )
  );
};

// src/checkout/components/sections/ReviewsSection.tsx
import React430 from "react";
var ReviewsSection = ({
  sectionConfig,
  onWriteReview,
  isCleanVersion
}) => {
  const { block } = sectionConfig;
  const resolvedBlock = isCleanVersion ? { ...block, verifiedLabel: void 0 } : block;
  return /* @__PURE__ */ React430.createElement(
    ReviewsSmallImagesVertical,
    {
      block: resolvedBlock,
      showScoreSummary: false,
      onWriteReview,
      classes: {
        section: "px-0",
        inner: "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))] px-4 md:px-6"
      }
    }
  );
};

// src/checkout/components/sections/FeaturesSection.tsx
import React431 from "react";
var FeaturesSection = ({ sectionConfig, ctaAdapters }) => {
  var _a;
  const { content, config, styles } = sectionConfig;
  return /* @__PURE__ */ React431.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-section": styles == null ? void 0 : styles.bgColor,
        "--theme-color-heading-primary": styles == null ? void 0 : styles.titleColor,
        "--theme-color-border-light": styles == null ? void 0 : styles.separatorColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor
      }
    },
    /* @__PURE__ */ React431.createElement(
      FeatureListSection,
      {
        title: content.title,
        productImage: content.productImage,
        features: content.features,
        showUnderline: config == null ? void 0 : config.showUnderline,
        underlineAlign: config == null ? void 0 : config.underlineAlign,
        ctaText: (_a = content.ctaText) != null ? _a : "",
        subActionText: content.subActionText,
        onCtaClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary,
        onSubActionClick: ctaAdapters == null ? void 0 : ctaAdapters.defaultCTASecondary
      }
    )
  );
};

// src/checkout/components/sections/DetailedFooterSection.tsx
import React432 from "react";
var CONTACT_ICONS = {
  email: /* @__PURE__ */ React432.createElement(IconEmail, null),
  chat: /* @__PURE__ */ React432.createElement(IconChat, null),
  phone: /* @__PURE__ */ React432.createElement(IconPhone, null)
};
var PAYMENT_ICONS = {
  paypal: { icon: /* @__PURE__ */ React432.createElement(IconPayPalCard, null), label: "PayPal" },
  visa: { icon: /* @__PURE__ */ React432.createElement(IconVisaCard, null), label: "Visa" },
  mastercard: { icon: /* @__PURE__ */ React432.createElement(IconMasterCard, null), label: "Mastercard" },
  amex: { icon: /* @__PURE__ */ React432.createElement(IconAmexCard, null), label: "Amex" },
  diners: { icon: /* @__PURE__ */ React432.createElement(IconDinersCard, null), label: "Diners" },
  discover: { icon: /* @__PURE__ */ React432.createElement(IconDiscoverCard, null), label: "Discover" }
};
var THEMED_INNER_CLASS7 = "max-w-[var(--theme-layout-page-width,var(--breakpoint-lg,1072px))]";
var DEFAULT_PAYMENT_ICON_TYPES = [
  "paypal",
  "visa",
  "mastercard",
  "amex",
  "diners",
  "discover"
];
var DetailedFooterSection = ({ sectionConfig }) => {
  var _a, _b, _c;
  const { content, config, styles } = sectionConfig;
  const contactItems = ((_a = content.contactItems) != null ? _a : []).map((item) => ({
    icon: CONTACT_ICONS[item.type],
    label: item.label,
    href: item.href
  }));
  const paymentIcons = ((_b = content.paymentIconTypes) != null ? _b : DEFAULT_PAYMENT_ICON_TYPES).map((type) => PAYMENT_ICONS[type]);
  const columns = [
    ...(_c = content.columns) != null ? _c : [],
    ...(config == null ? void 0 : config.showContactColumn) !== false && content.contactTitle && contactItems.length ? [{ type: "contact", title: content.contactTitle, items: contactItems }] : []
  ];
  return /* @__PURE__ */ React432.createElement(
    FooterSection2,
    {
      logo: content.logo,
      logoAlt: content.logoAlt,
      description: content.description,
      disclaimer: content.disclaimer,
      copyrightText: content.copyrightText,
      columns,
      colors: styles,
      paymentIcons: (config == null ? void 0 : config.showPaymentIcons) !== false ? paymentIcons : void 0,
      showBenefits: config == null ? void 0 : config.showBenefits,
      showLogo: config == null ? void 0 : config.showLogo,
      showDescription: config == null ? void 0 : config.showDescription,
      showColumns: config == null ? void 0 : config.showColumns,
      showDisclaimer: config == null ? void 0 : config.showDisclaimer,
      showCopyrightBar: config == null ? void 0 : config.showCopyrightBar,
      classes: { innerContainer: THEMED_INNER_CLASS7 }
    }
  );
};

// src/checkout/components/sections/SpecialOfferModalSection.tsx
import React433, { useCallback as useCallback5, useMemo as useMemo7, useState as useState39 } from "react";
import { useShallow as useShallow4 } from "zustand/react/shallow";

// src/checkout/hooks/useModalProductSelection.ts
import { useEffect as useEffect32, useState as useState38 } from "react";
var useModalProductSelection = (isOpen, selectedProductIndex) => {
  const [localSelectedIndex, setLocalSelectedIndex] = useState38(selectedProductIndex);
  useEffect32(() => {
    if (!isOpen) return;
    setLocalSelectedIndex(selectedProductIndex);
  }, [isOpen]);
  return { localSelectedIndex, setLocalSelectedIndex };
};

// src/checkout/components/sections/SpecialOfferModalSection.tsx
var SpecialOfferModalSection = ({
  sectionConfig,
  ctaAdapters,
  isOpen: isOpenProp,
  onClose: onCloseProp
}) => {
  var _a;
  const { content, config, styles } = sectionConfig;
  const [isOpenInternal, setIsOpenInternal] = useState39((_a = config == null ? void 0 : config.initiallyOpen) != null ? _a : true);
  const isOpen = isOpenProp != null ? isOpenProp : isOpenInternal;
  const onClose = onCloseProp != null ? onCloseProp : (() => setIsOpenInternal(false));
  const products = useOrderStore(useShallow4((state) => state.products));
  const productPricingByIndex = useOrderStore(useShallow4((state) => state.productPricingByIndex));
  const selectedProductIndex = useOrderStore((state) => state.selectedProductIndex);
  const selectProduct = useOrderStore((state) => state.selectProduct);
  const isOrderInitialized = useOrderStore((state) => state.isOrderInitialized);
  const options = useMemo7(
    () => products.map((product, storeIndex) => {
      var _a2, _b, _c;
      if (!isProductVisible(product, "specialOfferModal" /* SPECIAL_OFFER_MODAL */)) return null;
      const pricing = productPricingByIndex[storeIndex];
      if (!pricing) return null;
      const badge = product.isBestValue ? content.bestValueLabel : product.isBestSeller ? content.bestSellerLabel : void 0;
      return {
        id: String(product.id),
        image: product.imageUrl,
        quantity: `${product.amount}x`,
        oldPriceText: pricing.oldPriceText,
        symbol: (_a2 = pricing.currentPriceObject) == null ? void 0 : _a2.symbol,
        symbolLeft: (_c = (_b = pricing.currentPriceObject) == null ? void 0 : _b.symbolLeft) != null ? _c : true,
        wholePriceText: pricing.currentPriceWholeText,
        centsPriceText: pricing.currentPriceCentsText,
        eachLabel: content.eachLabel,
        badge
      };
    }),
    [products, productPricingByIndex, content]
  );
  const { localSelectedIndex, setLocalSelectedIndex } = useModalProductSelection(
    isOpen,
    selectedProductIndex
  );
  const effectiveLocalSelectedIndex = getVisibleSelectedIndex(
    options,
    products,
    localSelectedIndex
  );
  const handleClose = useCallback5(() => {
    syncProductToProductList(products, selectedProductIndex, selectProduct);
    onClose();
  }, [products, selectedProductIndex, selectProduct, onClose]);
  const handleCta = useCallback5(() => {
    selectProduct(effectiveLocalSelectedIndex);
    ctaAdapters == null ? void 0 : ctaAdapters.defaultCTAPrimary();
  }, [selectProduct, effectiveLocalSelectedIndex, ctaAdapters]);
  if (!isOrderInitialized) return null;
  return /* @__PURE__ */ React433.createElement(
    "div",
    {
      style: {
        "--theme-color-bg-page": styles == null ? void 0 : styles.bgColor,
        "--theme-color-text-secondary": styles == null ? void 0 : styles.textColor,
        "--theme-color-heading-primary": styles == null ? void 0 : styles.titleColor,
        "--theme-color-bg-section": styles == null ? void 0 : styles.barsBgColor
      }
    },
    /* @__PURE__ */ React433.createElement(
      SpecialOfferModal,
      {
        isOpen,
        onClose: handleClose,
        title: content.title,
        options,
        selectedIndex: effectiveLocalSelectedIndex,
        onSelectOption: setLocalSelectedIndex,
        bars: content.bars,
        ctaText: content.ctaText,
        onCtaClick: handleCta,
        subActionText: content.subActionText,
        onSubActionClick: handleClose
      }
    )
  );
};

// src/checkout/components/sections/RenderingEngine.tsx
var SectionErrorBoundary = class extends React434.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error(`[RenderingEngine] Section "${this.props.sectionType}" threw an error:`, error);
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
};
var renderSection = (section, index, { config, formAdapters, isUpsell }) => {
  var _a, _b;
  const isCleanVersion = "isCleanVersion" in config ? config.isCleanVersion : false;
  switch (section.type) {
    case "ribbon":
      return /* @__PURE__ */ React434.createElement(RibbonSection, { key: `section-${index}-ribbon`, sectionConfig: section });
    case "ribbon-timer":
      return /* @__PURE__ */ React434.createElement(TimerRibbonSection, { key: `section-${index}-ribbon-timer`, sectionConfig: section });
    case "header":
      return /* @__PURE__ */ React434.createElement(
        HeaderSection,
        {
          key: `section-${index}-header`,
          logo: config.logo,
          sectionConfig: section
        }
      );
    case "header-inline-breadcrumb":
      return /* @__PURE__ */ React434.createElement(
        InlineBreadcrumbHeaderSection,
        {
          key: `section-${index}-header-inline-breadcrumb`,
          logo: config.logo,
          sectionConfig: section
        }
      );
    case "header-pill-breadcrumb":
      return /* @__PURE__ */ React434.createElement(
        PillBreadcrumbHeaderSection,
        {
          key: `section-${index}-header-pill-breadcrumb`,
          logo: config.logo,
          sectionConfig: section
        }
      );
    case "hero-section":
      return /* @__PURE__ */ React434.createElement(
        ProductHeroSection,
        {
          key: `section-${index}-hero`,
          sectionConfig: section,
          ctaAdapters: formAdapters,
          isCleanVersion
        }
      );
    case "separator-v1":
      return /* @__PURE__ */ React434.createElement(
        SeparatorSection,
        {
          key: `section-${index}-separator-v1`,
          height: (_a = section.config) == null ? void 0 : _a.height,
          borderless: (_b = section.config) == null ? void 0 : _b.borderless
        }
      );
    case "layout-2col-v1":
      if (isUpsell) return null;
      return /* @__PURE__ */ React434.createElement(
        Layout2ColV1Section,
        {
          key: `section-${index}-layout-2col-v1`,
          schemaConfig: config,
          sectionConfig: section,
          formAdapters
        }
      );
    case "benefits":
      return /* @__PURE__ */ React434.createElement(
        BenefitsSection,
        {
          key: `section-${index}-benefits`,
          sectionConfig: section,
          ctaAdapters: formAdapters
        }
      );
    case "feature-cards-section":
      return /* @__PURE__ */ React434.createElement(
        FeatureCardsSection,
        {
          key: `section-${index}-feature-cards-section`,
          sectionConfig: section
        }
      );
    case "cta-inline":
      return /* @__PURE__ */ React434.createElement(
        CTAInlineSection,
        {
          key: `section-${index}-cta-inline`,
          sectionConfig: section,
          ctaAdapters: formAdapters,
          isCleanVersion
        }
      );
    case "cta-image":
      return /* @__PURE__ */ React434.createElement(
        CTAImageSection,
        {
          key: `section-${index}-cta-image`,
          sectionConfig: section,
          ctaAdapters: formAdapters,
          isCleanVersion
        }
      );
    case "cta-image-v2":
      return /* @__PURE__ */ React434.createElement(
        CTAImageSectionV2,
        {
          key: `section-${index}-cta-image-v2`,
          sectionConfig: section,
          ctaAdapters: formAdapters
        }
      );
    case "cta-timer":
      return /* @__PURE__ */ React434.createElement(
        CTATimerSection,
        {
          key: `section-${index}-cta-timer`,
          sectionConfig: section,
          ctaAdapters: formAdapters,
          isCleanVersion
        }
      );
    case "reviews":
      return /* @__PURE__ */ React434.createElement(
        ReviewsSection,
        {
          key: `section-${index}-reviews`,
          sectionConfig: section,
          isCleanVersion
        }
      );
    case "features":
      return /* @__PURE__ */ React434.createElement(
        FeaturesSection,
        {
          key: `section-${index}-features`,
          sectionConfig: section,
          ctaAdapters: formAdapters
        }
      );
    case "footer":
      return /* @__PURE__ */ React434.createElement(DetailedFooterSection, { key: `section-${index}-footer`, sectionConfig: section });
    case "special-offer-modal":
      return /* @__PURE__ */ React434.createElement(
        SpecialOfferModalSection,
        {
          key: `section-${index}-special-offer-modal`,
          sectionConfig: section,
          ctaAdapters: formAdapters
        }
      );
    default:
      return null;
  }
};
var RenderingEngine = React434.memo(function RenderingEngine2({
  config,
  formAdapters,
  isUpsell
}) {
  const sections = config.sections;
  const renderedSections = React434.useMemo(
    () => sections.map((section, index) => /* @__PURE__ */ React434.createElement(SectionErrorBoundary, { key: `section-${index}-${section.type}`, sectionType: section.type }, renderSection(section, index, { config, formAdapters, isUpsell }))),
    [config, formAdapters, isUpsell, sections]
  );
  return /* @__PURE__ */ React434.createElement(React434.Fragment, null, renderedSections);
});

// src/checkout/hooks/useCheckoutFormAdapters.ts
import { useMemo as useMemo8, useRef as useRef23 } from "react";
var useCheckoutFormAdapters = (additionalData = null, {
  onSubmitCard = () => {
  },
  onSubmitPaypal = () => {
  },
  onSubmitKlarna = () => {
  },
  onSubmitApplePay = () => {
  },
  onSubmitGooglePay = () => {
  },
  onHeroCTAPrimary = () => {
  },
  onHeroCTASecondary = () => {
  },
  onDefaultCTAPrimary = () => {
  },
  onDefaultCTASecondary = () => {
  },
  onEmailBlur = () => {
  }
} = {}) => {
  const getSubmitValue2 = () => getOrderSubmitValue(useOrderStore.getState(), additionalData);
  const lastEmailRef = useRef23(null);
  return useMemo8(
    () => ({
      onSubmitCard: (providerData) => {
        return onSubmitCard(providerData, getSubmitValue2());
      },
      onSubmitPaypal: (providerData) => {
        return onSubmitPaypal(providerData, getSubmitValue2());
      },
      onSubmitKlarna: (providerData) => {
        return onSubmitKlarna(providerData, getSubmitValue2());
      },
      onSubmitApplePay: (providerData) => {
        return onSubmitApplePay(providerData, getSubmitValue2());
      },
      onSubmitGooglePay: (providerData) => {
        return onSubmitGooglePay(providerData, getSubmitValue2());
      },
      heroCTAPrimary: () => onHeroCTAPrimary(getSubmitValue2()),
      heroCTASecondary: () => onHeroCTASecondary(getSubmitValue2()),
      defaultCTAPrimary: () => onDefaultCTAPrimary(getSubmitValue2()),
      defaultCTASecondary: () => onDefaultCTASecondary(getSubmitValue2()),
      onEmailBlur: (email, firstName, lastName) => {
        if (email && email !== lastEmailRef.current) {
          lastEmailRef.current = email;
          onEmailBlur(email, firstName, lastName, getSubmitValue2());
        }
      }
    }),
    [
      additionalData,
      onSubmitCard,
      onSubmitPaypal,
      onSubmitKlarna,
      onSubmitApplePay,
      onSubmitGooglePay,
      onHeroCTAPrimary,
      onHeroCTASecondary,
      onDefaultCTAPrimary,
      onDefaultCTASecondary,
      onEmailBlur
    ]
  );
};

// src/checkout/utils/additionalData.ts
var getCheckoutAdditionalData = (config) => ({
  aff: config.aff,
  country: config.country,
  postId: config.postId,
  nextPageOnSuccess: config.nextPageOnSuccess,
  konnektiveCampaignId: config.konnektiveCampaignId,
  subscriptionNextPage: config.subscriptionNextPage,
  subscriptionCampaignId: config.subscriptionCampaignId
});

// src/checkout/Checkout.tsx
var DEFAULT_CHECKOUT_CLASS = "flex min-h-screen flex-col bg-(--theme-color-bg-page) [font-family:var(--theme-font-checkout,Roboto,sans-serif)] text-(--theme-color-text-primary)";
var Checkout = ({ config, submitAdapters, className, classes = {} }) => {
  const initializeOrder = useOrderStore((state) => state.initializeOrder);
  const additionalData = React435.useMemo(() => getCheckoutAdditionalData(config), [config]);
  const resolvedThemeVariables = React435.useMemo(
    () => getCheckoutThemeVariables(config.theme),
    [config.theme]
  );
  const formAdapters = useCheckoutFormAdapters(additionalData, submitAdapters);
  useEffect33(() => {
    var _a, _b, _c, _d;
    initializeOrder(
      (_a = config.products.baseProducts) != null ? _a : [],
      (_b = config.products.subscriptionProducts) != null ? _b : [],
      {
        currencyCode: config.currencyCode,
        formattedString: config.products.formattedString,
        isDiscountCodeFeatureEnabled: config.isDiscountCodeFeatureEnabled || false,
        shouldMultiplyWarrantyByQuantity: config.shouldMultiplyWarrantyByQuantity
      },
      config.isSubscriptionEnabled,
      config.isCleanVersion ? false : config.isWarrantyPreselected,
      config.enabledVariantType,
      config.products.productVariants,
      (_c = config.selectedProductIndex) != null ? _c : 0,
      (_d = config.products.combinedVariants) != null ? _d : []
    );
  }, [config, initializeOrder]);
  return /* @__PURE__ */ React435.createElement(ThemeProvider, { variables: resolvedThemeVariables }, /* @__PURE__ */ React435.createElement(CheckoutSectionNavigationProvider, null, /* @__PURE__ */ React435.createElement("div", { className: cn(DEFAULT_CHECKOUT_CLASS, classes.root, className) }, /* @__PURE__ */ React435.createElement(RenderingEngine, { config, formAdapters }))));
};

// src/checkout/Upsells.tsx
import React436, { useEffect as useEffect34 } from "react";

// src/checkout/hooks/useUpsellsFormAdapters.ts
import { useMemo as useMemo9 } from "react";
var getSubmitValue = () => getOrderSubmitValue(useOrderStore.getState());
var useUpsellsFormAdapters = ({
  onHeroCTAPrimary = () => {
  },
  onHeroCTASecondary = () => {
  },
  onDefaultCTAPrimary = () => {
  },
  onDefaultCTASecondary = () => {
  }
} = {}) => {
  return useMemo9(
    () => ({
      heroCTAPrimary: () => onHeroCTAPrimary(getSubmitValue()),
      heroCTASecondary: () => onHeroCTASecondary(getSubmitValue()),
      defaultCTAPrimary: () => onDefaultCTAPrimary(getSubmitValue()),
      defaultCTASecondary: () => onDefaultCTASecondary(getSubmitValue())
    }),
    [onDefaultCTAPrimary, onDefaultCTASecondary, onHeroCTASecondary, onHeroCTAPrimary]
  );
};

// src/checkout/Upsells.tsx
var DEFAULT_UPSELLS_CLASS = "flex min-h-screen flex-col bg-(--theme-color-bg-page) [font-family:var(--theme-font-checkout,Roboto,sans-serif)] text-(--theme-color-text-primary)";
var Upsells = ({ config, submitAdapters, className, classes = {} }) => {
  const initializeOrder = useOrderStore((state) => state.initializeOrder);
  const resolvedThemeVariables = React436.useMemo(
    () => getCheckoutThemeVariables(config.theme),
    [config.theme]
  );
  const formAdapters = useUpsellsFormAdapters(submitAdapters);
  useEffect34(() => {
    var _a, _b, _c, _d, _e, _f;
    initializeOrder(
      (_a = config.products.baseProducts) != null ? _a : [],
      (_b = config.products.subscriptionProducts) != null ? _b : [],
      {
        currencyCode: config.currencyCode,
        formattedString: config.products.formattedString,
        isDiscountCodeFeatureEnabled: false,
        shouldMultiplyWarrantyByQuantity: false
      },
      (_c = config.isSubscriptionEnabled) != null ? _c : false,
      config.isCleanVersion ? false : (_d = config.isWarrantyPreselected) != null ? _d : false,
      config.enabledVariantType,
      config.products.productVariants,
      (_e = config.selectedProductIndex) != null ? _e : 0,
      (_f = config.products.combinedVariants) != null ? _f : []
    );
  }, [config, initializeOrder]);
  return /* @__PURE__ */ React436.createElement(ThemeProvider, { variables: resolvedThemeVariables }, /* @__PURE__ */ React436.createElement("div", { className: cn(DEFAULT_UPSELLS_CLASS, classes.root, className) }, /* @__PURE__ */ React436.createElement(RenderingEngine, { config, formAdapters, isUpsell: true })));
};

// src/checkout/services/loggerService.ts
var checkoutLogger = {
  error(error) {
    console.error(error);
  }
};

// src/checkout/configs/combineCheckoutConfigs.ts
var mergeProductsById = (crmProducts, cmsProducts) => {
  const crmProductsById = new Map(crmProducts.map((product) => [String(product.id), product]));
  return cmsProducts.map((cmsProduct) => {
    const crmProduct = crmProductsById.get(String(cmsProduct.id));
    return {
      ...crmProduct,
      ...cmsProduct
    };
  });
};
var mergeVariantOptionsById = (crmVariants, cmsVariants) => {
  const crmVariantsById = new Map(crmVariants.map((variant) => [variant.id, variant]));
  return cmsVariants.map((cmsVariant) => ({
    ...crmVariantsById.get(cmsVariant.id),
    ...cmsVariant
  }));
};
var mergeProductVariants = (crmProductVariants, cmsProductVariants) => {
  const variantGroupKeys = /* @__PURE__ */ new Set([
    ...Object.keys(crmProductVariants != null ? crmProductVariants : {}),
    ...Object.keys(cmsProductVariants != null ? cmsProductVariants : {})
  ]);
  return Array.from(variantGroupKeys).reduce((mergedVariants, key) => {
    const crmVariantGroup = crmProductVariants == null ? void 0 : crmProductVariants[key];
    const cmsVariantGroup = cmsProductVariants == null ? void 0 : cmsProductVariants[key];
    if (!crmVariantGroup || !cmsVariantGroup) {
      return mergedVariants;
    }
    return {
      ...mergedVariants,
      [key]: {
        ...cmsVariantGroup,
        variants: mergeVariantOptionsById(crmVariantGroup.variants, cmsVariantGroup.variants)
      }
    };
  }, {});
};
var combineCheckoutConfigs = (cmsConfig, crmConfig, skipValidation = false) => {
  var _a, _b, _c, _d;
  if (!skipValidation) {
    const validation = validateCheckoutConfigs(cmsConfig, crmConfig);
    if (!validation.valid) {
      validation.errors.forEach((error) => checkoutLogger.error(new Error(error.technical)));
    }
  }
  return {
    ...crmConfig,
    ...cmsConfig,
    products: {
      ...crmConfig.products,
      ...cmsConfig.products,
      productVariants: mergeProductVariants(
        crmConfig.products.productVariants,
        cmsConfig.products.productVariants
      ),
      baseProducts: mergeProductsById(
        (_a = crmConfig.products.baseProducts) != null ? _a : [],
        (_b = cmsConfig.products.baseProducts) != null ? _b : []
      ),
      subscriptionProducts: mergeProductsById(
        (_c = crmConfig.products.subscriptionProducts) != null ? _c : [],
        (_d = cmsConfig.products.subscriptionProducts) != null ? _d : []
      )
    }
  };
};
export {
  AboutProductCarouselSection,
  AboutProductIconDescriptionMotion,
  AboutProductIconDescriptionStatic,
  AboutProductIconTitle,
  AboutProductImageWithList,
  AboutProductLargeImageDescription,
  AboutProductLargeImageDropdown,
  AboutProductLargeImageList,
  AccordionItem,
  ActionButton,
  AddMoreFeatureList,
  AddMoreImageSection,
  AddMoreImageSectionV2,
  AddMoreInlineSection,
  AddMoreTimerSection,
  ArticleBanner,
  ArticleFooter,
  ArticleHeader,
  ArticleProductCard,
  ArticleReview,
  ArticleStatistics,
  Badge,
  BadgeCheckIcon,
  BannerLogos,
  BannerTextMotion,
  BannerTimerAndText,
  BannerTimerBadge,
  BarNotice,
  BarSurface,
  BenefitsCard,
  BenefitsCardList,
  BenefitsCards,
  BrandLogo,
  Button,
  CTAButton,
  Card,
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  CheckmarkList,
  Checkout,
  ChevronIcon,
  CircleCheckIcon,
  ClockIcon,
  CloseIcon,
  CommentsThread,
  CompareTableSection,
  ComparisonCard,
  Container,
  ContentImage,
  ContentImageBulletListSection,
  Copyright,
  CountdownText,
  DEFAULT_TOP5_CALLOUT_ICON,
  DEFAULT_TOP5_CON_ICON,
  DEFAULT_TOP5_PRO_ICON,
  DateText,
  Divider,
  DoubleTagIcon,
  ExpertBulletPointsSection,
  ExpertCard,
  ExpertPlainTextSection,
  FORM_TYPES,
  FORM_UNITS,
  FaqAccordion,
  FaqItem,
  FaqSection,
  FeatureCard,
  FeatureImageCard,
  FeatureImageCardList,
  FeatureImageCards,
  FeatureList,
  FeatureListItem,
  FeatureListSection,
  FeaturesImageSection,
  FlagIcon,
  Floater,
  Footer,
  FooterSection2 as FooterPageSection,
  FooterSection,
  GalleryCarousel,
  HalfStarIcon,
  Header,
  Heading,
  HeadingDescriptionBlock,
  Hero,
  HeroGalleryReview,
  HeroReviewCard,
  HowToUseStepsHorizontal,
  HowToUseStepsVerticalSection,
  Icon,
  IconBonus,
  IconBox,
  IconBurgerMenu,
  IconCart,
  IconCheckCircle,
  IconCircleXmark,
  IconClock,
  IconDescriptionCard,
  IconDoubleChevron,
  IconInfo,
  IconLabelRow,
  IconLabelStack,
  IconStarEmpty,
  IconStarFull,
  IconStarHalf,
  IconSummary,
  IconTextRow,
  IconThumbsUp,
  IconTrustpilotStar,
  IconVerifiedBadge,
  IconXMark,
  Image,
  ImageCard,
  ImageDescriptionCard,
  InfoBannerAward,
  InfoBannerProvenResults,
  InlineBreadcrumbPageHeader,
  InlineStepBreadcrumb,
  LikeButton,
  LikeCount,
  Link,
  LinkEnhancer,
  Logo,
  LogoItem,
  Marquee,
  MarqueeImages,
  MarqueeText,
  MoneyBack,
  MoneyBackBadgeIcon,
  PageHeader,
  PercentageProgress,
  PillBreadcrumbPageHeader,
  PillStepBreadcrumb,
  ProductBenefitsSection,
  ProductCard,
  ProductNavbarSection,
  PromoBar,
  ProvenResultsBanner,
  QuestionMarkCircleIcon,
  Quiz,
  RatingBanner,
  RatingCard,
  RatingSummaryRow,
  RecommendedCard,
  ReviewCarouselMotion,
  ReviewCarouselSection,
  ReviewStatistics,
  ReviewsFooter,
  ReviewsImage,
  ReviewsList,
  ReviewsSmallImagesVertical,
  Ribbon,
  RichText,
  SSLText,
  STEP_TYPES,
  ScoreBar,
  SectionHeader,
  SectionTitle,
  SegmentedOption,
  SelectableRadio,
  SelectableRadioOption,
  ShoppingBagIcon,
  SocialProofImagesMotion,
  SocialProofPill,
  SpecialOfferCard,
  SpecialOfferCardList,
  SpecialOfferModal,
  StarIcon,
  StarRating2 as StarRating,
  Statistics,
  StatsCard,
  StatsImageResultsCTASection,
  StatsImageResultsSection,
  StatsThreeResultsWithoutImageSection,
  StepCard,
  Steps,
  StickyCtaFloater,
  StickyCtaFloaterSection,
  StockLevel,
  StockProgressBar,
  SuperfastBenefitsSection,
  SuperfastCardRepeaterSection,
  SuperfastHeaderSection,
  SuperfastMainBanner,
  SuperfastShopByCategoriesSection,
  SuperfastSmallBanner,
  SuperfastStaticBanner,
  TemplatePriceLine,
  Text,
  ThemeContext,
  ThemeProvider,
  TimerBadge,
  ToggleBoxLayout,
  Top5CalloutBoxSection,
  Top5CalloutTableSection,
  Top5FooterSection,
  Top5HeaderSection,
  Top5HeroSection,
  Top5LinkEnhancer,
  Top5ListSection,
  Top5ProductCard,
  Top5ProductComparisonCardSection,
  Top5RichMediaSection,
  TruckIcon,
  TrustpilotStars2 as TrustpilotStars,
  TwoOptionSelector,
  Upsells,
  VerifiedIcon,
  Video,
  ZigzagCard,
  combineCheckoutConfigs,
  defaultStickyCtaFloaterSectionBlock,
  getCheckoutThemeVariables,
  getSectionSpacingClass,
  useEverflowConversion,
  validateCheckoutConfigs,
  validateCmsConfig
};
//# sourceMappingURL=index.mjs.map